export const wayfinderData = {
  36530072: {
    id: "item_33077",
    "Last Name": "Hong",
    "First Name": "Minh Le",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530093: {
    id: "item_7645",
    "Last Name": "Shaw",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530121: {
    id: "item_20412",
    "Last Name": "Huang",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530122: {
    id: "item_20491",
    "Last Name": "Manwaring",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530148: {
    id: "item_7623",
    "Last Name": "Hillis",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530157: {
    id: "item_20365",
    "Last Name": "Adams",
    "First Name": "Ella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530163: {
    id: "item_31466",
    "Last Name": "Soon",
    "First Name": "Lydia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530164: {
    id: "item_7679",
    "Last Name": "Quinn",
    "First Name": "Bronagh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530172: {
    id: "item_33042",
    "Last Name": "O'Toole",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530185: {
    id: "item_31378",
    "Last Name": "Garrido",
    "First Name": "Meg",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530193: {
    id: "item_31393",
    "Last Name": "Crouche",
    "First Name": "Genevieve",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530204: {
    id: "item_7800",
    "Last Name": "Zheng",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530216: {
    id: "item_20652",
    "Last Name": "Ayong",
    "First Name": "Louie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530219: {
    id: "item_20654",
    "Last Name": "Hughes",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530232: {
    id: "item_7863",
    "Last Name": "Moad",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530242: {
    id: "item_7714",
    "Last Name": "Patel",
    "First Name": "Dharmesh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530261: {
    id: "item_20660",
    "Last Name": "Lunasco",
    "First Name": "Emil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530267: {
    id: "item_20525",
    "Last Name": "Builder",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530282: {
    id: "item_20680",
    "Last Name": "Ridley",
    "First Name": "Eloise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530296: {
    id: "item_31303",
    "Last Name": "Thai",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530316: {
    id: "item_20368",
    "Last Name": "Mac Sweeney",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530321: {
    id: "item_20389",
    "Last Name": "Kopbayev",
    "First Name": "Askar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530324: {
    id: "item_7802",
    "Last Name": "Strachan",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530341: {
    id: "item_20714",
    "Last Name": "Counsell",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530347: {
    id: "item_7761",
    "Last Name": "Campbell",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530348: {
    id: "item_20471",
    "Last Name": "McGregor",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530366: {
    id: "item_7675",
    "Last Name": "Blake",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530393: {
    id: "item_20729",
    "Last Name": "Wing",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530400: {
    id: "item_7719",
    "Last Name": "Harrow",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530408: {
    id: "item_31345",
    "Last Name": "Wang",
    "First Name": "Yilong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530419: {
    id: "item_7735",
    "Last Name": "Lai",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530425: {
    id: "item_7710",
    "Last Name": "Delgado",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530428: {
    id: "item_20722",
    "Last Name": "Dionela",
    "First Name": "Welan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530447: {
    id: "item_7963",
    "Last Name": "Williams",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530460: {
    id: "item_7895",
    "Last Name": "Clark",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530466: {
    id: "item_31424",
    "Last Name": "Greaves",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530468: {
    id: "item_31422",
    "Last Name": "Satyaprakash",
    "First Name": "Sathwick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530478: {
    id: "item_20659",
    "Last Name": "Aziz",
    "First Name": "Wali",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530480: {
    id: "item_7891",
    "Last Name": "So",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530486: {
    id: "item_7892",
    "Last Name": "Hawkins",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530489: {
    id: "item_7906",
    "Last Name": "Willard",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530492: {
    id: "item_7883",
    "Last Name": "Evans",
    "First Name": "Teri",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530493: {
    id: "item_7884",
    "Last Name": "Desmarais",
    "First Name": "Marie-Gabrielle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530495: {
    id: "item_7909",
    "Last Name": "Mihnea",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530507: {
    id: "item_7908",
    "Last Name": "Dizon",
    "First Name": "Dino",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530514: {
    id: "item_7889",
    "Last Name": "Sloman",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530518: {
    id: "item_31433",
    "Last Name": "Irvine",
    "First Name": "Laurie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530520: {
    id: "item_5765",
    "Last Name": "Cardona",
    "First Name": "Cristian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530523: {
    id: "item_7907",
    "Last Name": "Collaga",
    "First Name": "Neville",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530542: {
    id: "item_7887",
    "Last Name": "Nelsen",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530546: {
    id: "item_33069",
    "Last Name": "Noh",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530548: {
    id: "item_31462",
    "Last Name": "Hewitt",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530555: {
    id: "item_7881",
    "Last Name": "Flor",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530559: {
    id: "item_20669",
    "Last Name": "Talwar",
    "First Name": "Baljit Singh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530562: {
    id: "item_20728",
    "Last Name": "Djenidi",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530599: {
    id: "item_7878",
    "Last Name": "Browne",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530601: {
    id: "item_33068",
    "Last Name": "Sands",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530605: {
    id: "item_7877",
    "Last Name": "McAllister",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530610: {
    id: "item_7859",
    "Last Name": "Phillips",
    "First Name": "Jaydn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530615: {
    id: "item_20658",
    "Last Name": "Shaw",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530623: {
    id: "item_7608",
    "Last Name": "zhou",
    "First Name": "ling",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530640: {
    id: "item_20649",
    "Last Name": "Speranza",
    "First Name": "Tara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530643: {
    id: "item_7876",
    "Last Name": "Sweeny",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530657: {
    id: "item_7866",
    "Last Name": "COMERCIANTE",
    "First Name": "MARK",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530659: {
    id: "item_31412",
    "Last Name": "Lowe",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530662: {
    id: "item_7869",
    "Last Name": "Cheraghi",
    "First Name": "Amir",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530663: {
    id: "item_7870",
    "Last Name": "Byrne",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530667: {
    id: "item_7872",
    "Last Name": "Goettler`",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530690: {
    id: "item_7607",
    "Last Name": "Tiongson",
    "First Name": "Arbe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530704: {
    id: "item_20651",
    "Last Name": "Stormonth",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530706: {
    id: "item_31415",
    "Last Name": "Turley",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530717: {
    id: "item_31461",
    "Last Name": "Wheeler",
    "First Name": "Adina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530721: {
    id: "item_7867",
    "Last Name": "Mooney",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530722: {
    id: "item_33067",
    "Last Name": "Raj",
    "First Name": "Harish",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530735: {
    id: "item_20443",
    "Last Name": "Ghadafy",
    "First Name": "Muhammed",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530754: {
    id: "item_7864",
    "Last Name": "Seibane",
    "First Name": "Pilar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530785: {
    id: "item_31407",
    "Last Name": "Buol",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530786: {
    id: "item_20733",
    "Last Name": "Helm",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530787: {
    id: "item_20645",
    "Last Name": "Dines",
    "First Name": "Martine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530794: {
    id: "item_31406",
    "Last Name": "Jedrzejczyk",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530803: {
    id: "item_20662",
    "Last Name": "Hayes",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530824: {
    id: "item_20663",
    "Last Name": "Crockford",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530832: {
    id: "item_7852",
    "Last Name": "Kong",
    "First Name": "Vanny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530840: {
    id: "item_7856",
    "Last Name": "Quartullo",
    "First Name": "Petra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530852: {
    id: "item_20641",
    "Last Name": "Webb",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530862: {
    id: "item_7901",
    "Last Name": "de Groot",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530868: {
    id: "item_20633",
    "Last Name": "Burns",
    "First Name": "Chad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530881: {
    id: "item_7898",
    "Last Name": "Cao",
    "First Name": "Huiying",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530884: {
    id: "item_31405",
    "Last Name": "Surti",
    "First Name": "Hormuz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530908: {
    id: "item_33066",
    "Last Name": "Bellamy",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530910: {
    id: "item_20639",
    "Last Name": "Dao",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530916: {
    id: "item_20637",
    "Last Name": "Escamilla Ortega",
    "First Name": "Ivonne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530917: {
    id: "item_33065",
    "Last Name": "David",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530932: {
    id: "item_31425",
    "Last Name": "Prideaux",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530940: {
    id: "item_7853",
    "Last Name": "Han",
    "First Name": "Dongli",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530960: {
    id: "item_31314",
    "Last Name": "Fish",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530962: {
    id: "item_33002",
    "Last Name": "Aitken",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530967: {
    id: "item_20636",
    "Last Name": "Ky",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530972: {
    id: "item_31400",
    "Last Name": "Grant",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36530977: {
    id: "item_20635",
    "Last Name": "KRIEZIS",
    "First Name": "BILL",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531028: {
    id: "item_7894",
    "Last Name": "Burns",
    "First Name": "Stewart",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531039: {
    id: "item_20631",
    "Last Name": "Inoue",
    "First Name": "Fumi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531050: {
    id: "item_20661",
    "Last Name": "Curtis",
    "First Name": "Krystal",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531067: {
    id: "item_7893",
    "Last Name": "Watkins",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531075: {
    id: "item_33062",
    "Last Name": "Symonds",
    "First Name": "Terri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531081: {
    id: "item_7845",
    "Last Name": "Bennett",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531094: {
    id: "item_7843",
    "Last Name": "Park",
    "First Name": "Yejun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531098: {
    id: "item_7888",
    "Last Name": "Hoblos",
    "First Name": "Rayan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531103: {
    id: "item_7836",
    "Last Name": "Aryal",
    "First Name": "Mohan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531110: {
    id: "item_7832",
    "Last Name": "Hutchens",
    "First Name": "Callam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531122: {
    id: "item_7837",
    "Last Name": "Salmon",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531128: {
    id: "item_20627",
    "Last Name": "Gomez",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531133: {
    id: "item_7839",
    "Last Name": "Rahimi",
    "First Name": "Arash",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531140: {
    id: "item_20628",
    "Last Name": "Gibbs",
    "First Name": "Kerrie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531148: {
    id: "item_33058",
    "Last Name": "Crowe",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531151: {
    id: "item_20626",
    "Last Name": "Lau",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531153: {
    id: "item_31423",
    "Last Name": "Stupka",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531158: {
    id: "item_7890",
    "Last Name": "Chaff",
    "First Name": "Tina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531166: {
    id: "item_33092",
    "Last Name": "Murphy",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531170: {
    id: "item_20727",
    "Last Name": "Ashen",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531172: {
    id: "item_7834",
    "Last Name": "Cozens",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531184: {
    id: "item_33059",
    "Last Name": "Lazarus",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531230: {
    id: "item_7964",
    "Last Name": "Wild",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531236: {
    id: "item_31392",
    "Last Name": "Wang",
    "First Name": "Malannie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531248: {
    id: "item_33057",
    "Last Name": "Tan",
    "First Name": "Cindy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531250: {
    id: "item_31391",
    "Last Name": "Turaga",
    "First Name": "Kalyan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531282: {
    id: "item_7826",
    "Last Name": "Hopper",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531319: {
    id: "item_7823",
    "Last Name": "Kulchar",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531321: {
    id: "item_33001",
    "Last Name": "Nasey",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531327: {
    id: "item_20726",
    "Last Name": "Hashek",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531343: {
    id: "item_20615",
    "Last Name": "Jackson",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531344: {
    id: "item_7822",
    "Last Name": "Carlick",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531345: {
    id: "item_20617",
    "Last Name": "Guo",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531358: {
    id: "item_20616",
    "Last Name": "Kinder",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531364: {
    id: "item_7817",
    "Last Name": "Candan",
    "First Name": "Erol",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531442: {
    id: "item_33054",
    "Last Name": "Liu",
    "First Name": "Mia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531483: {
    id: "item_20611",
    "Last Name": "Howley",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531493: {
    id: "item_33052",
    "Last Name": "GAO",
    "First Name": "Yijun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531503: {
    id: "item_31420",
    "Last Name": "McCormick",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531505: {
    id: "item_7880",
    "Last Name": "Kirwan",
    "First Name": "Tina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531514: {
    id: "item_20657",
    "Last Name": "Caro",
    "First Name": "Jim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531541: {
    id: "item_33050",
    "Last Name": "Frahill",
    "First Name": "Eithne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531552: {
    id: "item_33045",
    "Last Name": "Li",
    "First Name": "Ken",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531560: {
    id: "item_7808",
    "Last Name": "Dodd",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531594: {
    id: "item_7804",
    "Last Name": "Closey",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531598: {
    id: "item_33046",
    "Last Name": "Trumper",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531603: {
    id: "item_7803",
    "Last Name": "Lawson",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531617: {
    id: "item_31419",
    "Last Name": "Jedrzejczyk",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531628: {
    id: "item_33044",
    "Last Name": "trang",
    "First Name": "darren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531652: {
    id: "item_7801",
    "Last Name": "Eldridge",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531671: {
    id: "item_20601",
    "Last Name": "Jacobs",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531677: {
    id: "item_33105",
    "Last Name": "Peddakotla",
    "First Name": "Ravi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531684: {
    id: "item_31418",
    "Last Name": "Martin",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531694: {
    id: "item_7796",
    "Last Name": "Topham",
    "First Name": "Kathy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531697: {
    id: "item_7798",
    "Last Name": "Bilic",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531704: {
    id: "item_7786",
    "Last Name": "O'Brien",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531707: {
    id: "item_7795",
    "Last Name": "Richardson",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531724: {
    id: "item_7793",
    "Last Name": "Bonalume",
    "First Name": "Arian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531747: {
    id: "item_7791",
    "Last Name": "Asrress",
    "First Name": "Luca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531776: {
    id: "item_7792",
    "Last Name": "McCaugherty",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531782: {
    id: "item_33043",
    "Last Name": "Miles",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531791: {
    id: "item_5774",
    "Last Name": "Golding",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531849: {
    id: "item_7604",
    "Last Name": "Chu",
    "First Name": "Tsz Yin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531850: {
    id: "item_20592",
    "Last Name": "Lai",
    "First Name": "Livia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531858: {
    id: "item_7603",
    "Last Name": "Tang",
    "First Name": "Thomas Zhi Xiong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531885: {
    id: "item_20589",
    "Last Name": "Fitzmaurice",
    "First Name": "Roisin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531915: {
    id: "item_7780",
    "Last Name": "Guilfoyle",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531946: {
    id: "item_7779",
    "Last Name": "De Gratie",
    "First Name": "Morgane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531951: {
    id: "item_7874",
    "Last Name": "ROY",
    "First Name": "BELINDA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531953: {
    id: "item_33000",
    "Last Name": "Walden",
    "First Name": "Anne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36531963: {
    id: "item_31377",
    "Last Name": "Todkar",
    "First Name": "Anurag",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532034: {
    id: "item_7962",
    "Last Name": "correa",
    "First Name": "victor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532037: {
    id: "item_5773",
    "Last Name": "Yang",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532064: {
    id: "item_7961",
    "Last Name": "Stoker",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532068: {
    id: "item_20581",
    "Last Name": "Vincent",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532077: {
    id: "item_31416",
    "Last Name": "Laya",
    "First Name": "Rizka",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532120: {
    id: "item_20578",
    "Last Name": "Kowal",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532126: {
    id: "item_7775",
    "Last Name": "Stutchbury",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532129: {
    id: "item_20577",
    "Last Name": "Kavanagh",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532158: {
    id: "item_7773",
    "Last Name": "Jimenez",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532194: {
    id: "item_7770",
    "Last Name": "Hort",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532234: {
    id: "item_7868",
    "Last Name": "Zhang",
    "First Name": "Zhuowei",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532245: {
    id: "item_7767",
    "Last Name": "McCabe",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532253: {
    id: "item_31310",
    "Last Name": "Bowler",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532268: {
    id: "item_31465",
    "Last Name": "Bianchi",
    "First Name": "Luisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532280: {
    id: "item_20732",
    "Last Name": "Suarez",
    "First Name": "Diana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532328: {
    id: "item_20648",
    "Last Name": "Rositano",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532329: {
    id: "item_20569",
    "Last Name": "Zhang",
    "First Name": "Jingjing",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532332: {
    id: "item_7764",
    "Last Name": "Guan",
    "First Name": "Jane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532333: {
    id: "item_20566",
    "Last Name": "moffett",
    "First Name": "jeremy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532352: {
    id: "item_20647",
    "Last Name": "Roux",
    "First Name": "Sandy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532373: {
    id: "item_20725",
    "Last Name": "Shawyer",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532377: {
    id: "item_31460",
    "Last Name": "Allan",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532389: {
    id: "item_31413",
    "Last Name": "Di Donato",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532397: {
    id: "item_31414",
    "Last Name": "Prevost",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532435: {
    id: "item_20565",
    "Last Name": "Singh",
    "First Name": "Jan Nayak",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532444: {
    id: "item_7865",
    "Last Name": "Bautista",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532447: {
    id: "item_20646",
    "Last Name": "Edwards",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532485: {
    id: "item_31367",
    "Last Name": "Lewis",
    "First Name": "Marilyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532501: {
    id: "item_7757",
    "Last Name": "Neille",
    "First Name": "Merryl",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532502: {
    id: "item_7862",
    "Last Name": "Dawson",
    "First Name": "Shona",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532510: {
    id: "item_7756",
    "Last Name": "Pilbin",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532526: {
    id: "item_7861",
    "Last Name": "Holloway",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532542: {
    id: "item_18581",
    "Last Name": "Chen",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532545: {
    id: "item_7752",
    "Last Name": "Bissaker",
    "First Name": "Rebel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532563: {
    id: "item_33039",
    "Last Name": "Ma",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532587: {
    id: "item_7860",
    "Last Name": "Wilkins",
    "First Name": "Alasdair",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532589: {
    id: "item_31410",
    "Last Name": "Crothers",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532590: {
    id: "item_31408",
    "Last Name": "Dang",
    "First Name": "Lam Dien",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532616: {
    id: "item_20561",
    "Last Name": "Janse van Vuuren",
    "First Name": "Jeanneli",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532624: {
    id: "item_20560",
    "Last Name": "Weinstein",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532637: {
    id: "item_7960",
    "Last Name": "Wilson",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532682: {
    id: "item_7598",
    "Last Name": "Alvarado",
    "First Name": "Juan Cruz",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532687: {
    id: "item_33037",
    "Last Name": "Giron",
    "First Name": "Charina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532689: {
    id: "item_33038",
    "Last Name": "Duffy",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532691: {
    id: "item_20644",
    "Last Name": "Stuart",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532705: {
    id: "item_18583",
    "Last Name": "Mathiessen",
    "First Name": "Ralph",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532706: {
    id: "item_7741",
    "Last Name": "Bong",
    "First Name": "Jia Hung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532709: {
    id: "item_7744",
    "Last Name": "Williams",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532711: {
    id: "item_7743",
    "Last Name": "Meura",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532712: {
    id: "item_20724",
    "Last Name": "Arnold",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532751: {
    id: "item_20643",
    "Last Name": "Davis",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532767: {
    id: "item_7742",
    "Last Name": "O'Shea",
    "First Name": "Jude",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532770: {
    id: "item_31365",
    "Last Name": "Jones",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532775: {
    id: "item_20723",
    "Last Name": "Eggleston",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532776: {
    id: "item_7959",
    "Last Name": "Estavillo",
    "First Name": "EJ",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532785: {
    id: "item_7858",
    "Last Name": "Cullen",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532795: {
    id: "item_7958",
    "Last Name": "Spurdle",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532835: {
    id: "item_20557",
    "Last Name": "Huang",
    "First Name": "Liying",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532877: {
    id: "item_7596",
    "Last Name": "Abe",
    "First Name": "Takaaki",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532893: {
    id: "item_31363",
    "Last Name": "Ku",
    "First Name": "Chiu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532919: {
    id: "item_31361",
    "Last Name": "Joson",
    "First Name": "Kristina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532942: {
    id: "item_31362",
    "Last Name": "Cameron",
    "First Name": "Eireann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532945: {
    id: "item_20552",
    "Last Name": "Sheehan",
    "First Name": "Mary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532953: {
    id: "item_7857",
    "Last Name": "Hurley",
    "First Name": "Meaghan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532956: {
    id: "item_7957",
    "Last Name": "RIDDLE",
    "First Name": "DIANE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532975: {
    id: "item_31360",
    "Last Name": "TAYLOR",
    "First Name": "natalie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36532997: {
    id: "item_7734",
    "Last Name": "Shin",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36533046: {
    id: "item_7733",
    "Last Name": "Walton",
    "First Name": "Heath",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36533069: {
    id: "item_7956",
    "Last Name": "Sheriff",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36533130: {
    id: "item_33033",
    "Last Name": "Gascoyne",
    "First Name": "Larissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36533413: {
    id: "item_7731",
    "Last Name": "Chong",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36533585: {
    id: "item_7855",
    "Last Name": "Stewart",
    "First Name": "Holly",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36533760: {
    id: "item_20548",
    "Last Name": "Yeates",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36533952: {
    id: "item_33104",
    "Last Name": "Gillies",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36534410: {
    id: "item_33091",
    "Last Name": "Woodbury",
    "First Name": "Vickie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36534674: {
    id: "item_20546",
    "Last Name": "Graham",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36534709: {
    id: "item_20547",
    "Last Name": "Connelly",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36535273: {
    id: "item_20435",
    "Last Name": "Thornburg",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36535558: {
    id: "item_7854",
    "Last Name": "Ryan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36535614: {
    id: "item_31477",
    "Last Name": "Putra",
    "First Name": "Angga F",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36536156: {
    id: "item_7727",
    "Last Name": "Hamilton",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36536547: {
    id: "item_20544",
    "Last Name": "Kelly",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36536917: {
    id: "item_20542",
    "Last Name": "Carey",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36537450: {
    id: "item_7718",
    "Last Name": "Crocombe",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538092: {
    id: "item_33031",
    "Last Name": "Wickham",
    "First Name": "Ailen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538234: {
    id: "item_31356",
    "Last Name": "Fairbourn",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538239: {
    id: "item_7722",
    "Last Name": "Belobrajdic",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538242: {
    id: "item_7721",
    "Last Name": "Grey",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538272: {
    id: "item_7712",
    "Last Name": "dong",
    "First Name": "xingqi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538273: {
    id: "item_33090",
    "Last Name": "Dresser",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538282: {
    id: "item_7713",
    "Last Name": "Thomas",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538285: {
    id: "item_5782",
    "Last Name": "Dawes",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538306: {
    id: "item_20530",
    "Last Name": "Brennan",
    "First Name": "Holly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538330: {
    id: "item_20540",
    "Last Name": "Ziegler",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538339: {
    id: "item_20539",
    "Last Name": "Chan",
    "First Name": "Cindy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538341: {
    id: "item_33103",
    "Last Name": "Leung",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538362: {
    id: "item_33064",
    "Last Name": "Duque Eusse",
    "First Name": "Paula Andrea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538425: {
    id: "item_31354",
    "Last Name": "Palamara",
    "First Name": "Claudio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538470: {
    id: "item_31353",
    "Last Name": "COHEN",
    "First Name": "ARNOLD",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538949: {
    id: "item_7705",
    "Last Name": "Whealing",
    "First Name": "Claudine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36538978: {
    id: "item_33030",
    "Last Name": "Lopez",
    "First Name": "Maureen Louise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36539137: {
    id: "item_33063",
    "Last Name": "Tessmann",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36539789: {
    id: "item_20531",
    "Last Name": "Diomampo",
    "First Name": "Sherryl",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36539807: {
    id: "item_7592",
    "Last Name": "Zamri",
    "First Name": "Muhammad Saiful",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36540030: {
    id: "item_20529",
    "Last Name": "Low",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36540049: {
    id: "item_20731",
    "Last Name": "Schropp",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36540075: {
    id: "item_31459",
    "Last Name": "Paterson",
    "First Name": "Tanza",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36540080: {
    id: "item_33102",
    "Last Name": "Leung",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36540095: {
    id: "item_7702",
    "Last Name": "Wolffe",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36540106: {
    id: "item_5764",
    "Last Name": "Ibo",
    "First Name": "Matias",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36540124: {
    id: "item_20433",
    "Last Name": "Mete",
    "First Name": "Moana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36540200: {
    id: "item_20523",
    "Last Name": "Yee",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36541219: {
    id: "item_31348",
    "Last Name": "Biro",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36541675: {
    id: "item_31458",
    "Last Name": "Curby",
    "First Name": "Amber",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36542247: {
    id: "item_20721",
    "Last Name": "NEEDS",
    "First Name": "TRUDI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36542249: {
    id: "item_20720",
    "Last Name": "Needs",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36542780: {
    id: "item_20634",
    "Last Name": "Lythgo",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36542970: {
    id: "item_7589",
    "Last Name": "Cula",
    "First Name": "Darwin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36543633: {
    id: "item_7591",
    "Last Name": "Zhu",
    "First Name": "Lifang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36545115: {
    id: "item_7847",
    "Last Name": "Liu",
    "First Name": "Kuang-Tao",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36545117: {
    id: "item_20521",
    "Last Name": "Mc Crory",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36545877: {
    id: "item_20719",
    "Last Name": "Penny",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36547052: {
    id: "item_31399",
    "Last Name": "Goodley",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36547173: {
    id: "item_20430",
    "Last Name": "Istiawan",
    "First Name": "Nikolas Hubert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36547191: {
    id: "item_20632",
    "Last Name": "Youels",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36547237: {
    id: "item_20515",
    "Last Name": "Low",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36547247: {
    id: "item_7694",
    "Last Name": "Van Wyngaard",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36547421: {
    id: "item_20630",
    "Last Name": "Simsek",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36547522: {
    id: "item_20514",
    "Last Name": "Bougher",
    "First Name": "Harriett",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36547778: {
    id: "item_20512",
    "Last Name": "Hisoler",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36547959: {
    id: "item_20513",
    "Last Name": "Tiffen",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36548303: {
    id: "item_20510",
    "Last Name": "Lim",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36548954: {
    id: "item_31397",
    "Last Name": "Carlton",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36548986: {
    id: "item_7691",
    "Last Name": "Wilkey",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36549086: {
    id: "item_7689",
    "Last Name": "Kruger",
    "First Name": "Francois",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36549095: {
    id: "item_20508",
    "Last Name": "Boehm",
    "First Name": "Topher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36549108: {
    id: "item_7688",
    "Last Name": "Cregan",
    "First Name": "Marisa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36549142: {
    id: "item_33061",
    "Last Name": "Gardner",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36549162: {
    id: "item_7686",
    "Last Name": "morrissey",
    "First Name": "mike",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36549609: {
    id: "item_33022",
    "Last Name": "Harker",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36549829: {
    id: "item_20505",
    "Last Name": "Bui",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36550529: {
    id: "item_7844",
    "Last Name": "Pike",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36551657: {
    id: "item_7682",
    "Last Name": "Prell",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36552127: {
    id: "item_20504",
    "Last Name": "Langdon",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36552841: {
    id: "item_20730",
    "Last Name": "Forsythe",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36553355: {
    id: "item_7681",
    "Last Name": "Centrone",
    "First Name": "Dion",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36554097: {
    id: "item_20502",
    "Last Name": "Corcoran",
    "First Name": "Mary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36554392: {
    id: "item_31457",
    "Last Name": "Vine",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36554444: {
    id: "item_7676",
    "Last Name": "Sisson",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36554509: {
    id: "item_7955",
    "Last Name": "Jones",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36554709: {
    id: "item_7842",
    "Last Name": "Trinks",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36554870: {
    id: "item_33020",
    "Last Name": "Wang",
    "First Name": "Charley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36555176: {
    id: "item_31339",
    "Last Name": "Pes",
    "First Name": "Rasa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36555839: {
    id: "item_7954",
    "Last Name": "Foster",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36555841: {
    id: "item_31395",
    "Last Name": "Spencer",
    "First Name": "Fleur",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36555903: {
    id: "item_20426",
    "Last Name": "Mohamed Mas'oud",
    "First Name": "Mohammad Aidil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36555986: {
    id: "item_31306",
    "Last Name": "Jensen",
    "First Name": "Cheryl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36556506: {
    id: "item_33017",
    "Last Name": "Hao",
    "First Name": "Yichen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36556583: {
    id: "item_20425",
    "Last Name": "WANG",
    "First Name": "BINWU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36556658: {
    id: "item_20629",
    "Last Name": "Ferris",
    "First Name": "Darryl",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36556919: {
    id: "item_7670",
    "Last Name": "Amaral",
    "First Name": "Fernanda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36560658: {
    id: "item_33089",
    "Last Name": "Dawson",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36560659: {
    id: "item_7665",
    "Last Name": "Cao",
    "First Name": "Celine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36560665: {
    id: "item_7667",
    "Last Name": "Du",
    "First Name": "Jian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36560930: {
    id: "item_7664",
    "Last Name": "Outterside",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36561030: {
    id: "item_31335",
    "Last Name": "Manlulo",
    "First Name": "Randolf",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36561228: {
    id: "item_7666",
    "Last Name": "Anderson",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36561287: {
    id: "item_7663",
    "Last Name": "VILLAREAL",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562452: {
    id: "item_7584",
    "Last Name": "Hua",
    "First Name": "Liping",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562607: {
    id: "item_31456",
    "Last Name": "Cox",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562635: {
    id: "item_20718",
    "Last Name": "Cremasco",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562658: {
    id: "item_7833",
    "Last Name": "Sanchez",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562709: {
    id: "item_7582",
    "Last Name": "Lazaroff",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562711: {
    id: "item_20717",
    "Last Name": "Cheang",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562717: {
    id: "item_7660",
    "Last Name": "Mitchell",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562720: {
    id: "item_33015",
    "Last Name": "Ganbold",
    "First Name": "Purevjargal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562740: {
    id: "item_20624",
    "Last Name": "Nation",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36562776: {
    id: "item_7657",
    "Last Name": "Kim",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36563036: {
    id: "item_20623",
    "Last Name": "Geraghty",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36563393: {
    id: "item_7655",
    "Last Name": "KIM",
    "First Name": "SUNGHOON",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36564620: {
    id: "item_20622",
    "Last Name": "Geraghty",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36564888: {
    id: "item_20488",
    "Last Name": "McLearie",
    "First Name": "Janet",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36564898: {
    id: "item_31332",
    "Last Name": "lee",
    "First Name": "sze man, mandy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36566808: {
    id: "item_31305",
    "Last Name": "Edgecombe",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36566996: {
    id: "item_5768",
    "Last Name": "Hasher",
    "First Name": "Abdullah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36568016: {
    id: "item_31331",
    "Last Name": "Saul",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36568025: {
    id: "item_31304",
    "Last Name": "Li",
    "First Name": "xinji",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36568569: {
    id: "item_33014",
    "Last Name": "Handley",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36568667: {
    id: "item_20621",
    "Last Name": "Wright",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36568961: {
    id: "item_20484",
    "Last Name": "Gao",
    "First Name": "Min",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36569017: {
    id: "item_20483",
    "Last Name": "Le Miere",
    "First Name": "Diana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36569080: {
    id: "item_7831",
    "Last Name": "Hampton",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36569321: {
    id: "item_7830",
    "Last Name": "Power",
    "First Name": "Suzy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36569343: {
    id: "item_20481",
    "Last Name": "Lau",
    "First Name": "Phil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36569351: {
    id: "item_7953",
    "Last Name": "Gregory",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36569389: {
    id: "item_7647",
    "Last Name": "Ryall",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36569418: {
    id: "item_20620",
    "Last Name": "Burn",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36569726: {
    id: "item_20421",
    "Last Name": "Zing Ling Tracy",
    "First Name": "Lo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36570096: {
    id: "item_31302",
    "Last Name": "Dulay",
    "First Name": "Mary Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36571043: {
    id: "item_7644",
    "Last Name": "Yan",
    "First Name": "xiaoqin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36573410: {
    id: "item_7642",
    "Last Name": "Houssenloge",
    "First Name": "Haydn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36573707: {
    id: "item_33011",
    "Last Name": "Woisin",
    "First Name": "Kathie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36574775: {
    id: "item_7581",
    "Last Name": "Sak",
    "First Name": "Kai yau",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36575615: {
    id: "item_20475",
    "Last Name": "Wu",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36575647: {
    id: "item_32993",
    "Last Name": "Kongara",
    "First Name": "Ravindra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36575971: {
    id: "item_20474",
    "Last Name": "Geng",
    "First Name": "Shu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576054: {
    id: "item_7951",
    "Last Name": "Miller",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576067: {
    id: "item_33101",
    "Last Name": "Valero",
    "First Name": "Miriam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576086: {
    id: "item_7952",
    "Last Name": "Ryan",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576121: {
    id: "item_33100",
    "Last Name": "Ventura",
    "First Name": "Kishia Mae",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576220: {
    id: "item_20470",
    "Last Name": "Haynes",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576226: {
    id: "item_31325",
    "Last Name": "Tran",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576240: {
    id: "item_31301",
    "Last Name": "Ca–ada",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576244: {
    id: "item_20468",
    "Last Name": "Hanson",
    "First Name": "Glenda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576275: {
    id: "item_7632",
    "Last Name": "Stevens",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576334: {
    id: "item_7629",
    "Last Name": "Bowen",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576339: {
    id: "item_20467",
    "Last Name": "Louis",
    "First Name": "Rohit",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576342: {
    id: "item_20465",
    "Last Name": "Luo",
    "First Name": "Zhuolin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576350: {
    id: "item_31464",
    "Last Name": "Tan",
    "First Name": "Mei Nguyen Joy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576382: {
    id: "item_7579",
    "Last Name": "Leong",
    "First Name": "Teo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576429: {
    id: "item_32992",
    "Last Name": "ALAM",
    "First Name": "MD ZAHIRUL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576438: {
    id: "item_7626",
    "Last Name": "Vasquez",
    "First Name": "Jean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576508: {
    id: "item_7625",
    "Last Name": "Cheng",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576548: {
    id: "item_20417",
    "Last Name": "Nguyen",
    "First Name": "Tuan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576549: {
    id: "item_7624",
    "Last Name": "Connolly",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576591: {
    id: "item_33099",
    "Last Name": "Owen",
    "First Name": "Ann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576607: {
    id: "item_7820",
    "Last Name": "Madgwick",
    "First Name": "Ash",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576616: {
    id: "item_33008",
    "Last Name": "Banco",
    "First Name": "Lucia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576625: {
    id: "item_33007",
    "Last Name": "Barrett",
    "First Name": "Raelene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576681: {
    id: "item_31390",
    "Last Name": "Jarvis",
    "First Name": "Anita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576687: {
    id: "item_7818",
    "Last Name": "Muthi",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576712: {
    id: "item_7819",
    "Last Name": "Shaaban",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576889: {
    id: "item_20716",
    "Last Name": "Frost",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36576969: {
    id: "item_7578",
    "Last Name": "Tsai",
    "First Name": "Yu-Ming",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577109: {
    id: "item_7815",
    "Last Name": "Pastoor",
    "First Name": "Xanthe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577158: {
    id: "item_32991",
    "Last Name": "Wibowo",
    "First Name": "Lukas Dharmawan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577215: {
    id: "item_31318",
    "Last Name": "CURRAN",
    "First Name": "PETER",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577259: {
    id: "item_20614",
    "Last Name": "Hill",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577266: {
    id: "item_7814",
    "Last Name": "Pope",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577273: {
    id: "item_7618",
    "Last Name": "Feitosa",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577314: {
    id: "item_7950",
    "Last Name": "Philcox",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577317: {
    id: "item_20413",
    "Last Name": "WU",
    "First Name": "QING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577358: {
    id: "item_20416",
    "Last Name": "CHUA",
    "First Name": "KIM WAH",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577382: {
    id: "item_32990",
    "Last Name": "Velasco",
    "First Name": "Marie Corazon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577402: {
    id: "item_7576",
    "Last Name": "Kharitonov",
    "First Name": "Ilya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577413: {
    id: "item_33055",
    "Last Name": "Patrick",
    "First Name": "Richelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577462: {
    id: "item_31317",
    "Last Name": "Gould",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577486: {
    id: "item_32989",
    "Last Name": "Maniam",
    "First Name": "Andre",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577487: {
    id: "item_33004",
    "Last Name": "Hind",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577505: {
    id: "item_31387",
    "Last Name": "Halim",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577564: {
    id: "item_7949",
    "Last Name": "Scollary",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577650: {
    id: "item_7614",
    "Last Name": "Smith",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577673: {
    id: "item_7811",
    "Last Name": "Galbraith",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577762: {
    id: "item_33053",
    "Last Name": "Hampton",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577781: {
    id: "item_7612",
    "Last Name": "Wooldridge",
    "First Name": "Margriet",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577791: {
    id: "item_20608",
    "Last Name": "Stewart",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577807: {
    id: "item_33098",
    "Last Name": "Caraballo",
    "First Name": "Arlene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577825: {
    id: "item_20451",
    "Last Name": "D'Haeseleer",
    "First Name": "Sabine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577892: {
    id: "item_7573",
    "Last Name": "Joergensen",
    "First Name": "Torben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577972: {
    id: "item_33003",
    "Last Name": "Seah",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577979: {
    id: "item_20445",
    "Last Name": "Stephenson",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36577994: {
    id: "item_7609",
    "Last Name": "Kong",
    "First Name": "Qingsheng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578003: {
    id: "item_7810",
    "Last Name": "Jones",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578004: {
    id: "item_5778",
    "Last Name": "Silva",
    "First Name": "Anderson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578015: {
    id: "item_20715",
    "Last Name": "Southan",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578020: {
    id: "item_33051",
    "Last Name": "Gattin",
    "First Name": "Jaidan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578021: {
    id: "item_5777",
    "Last Name": "Cheng",
    "First Name": "Yuanchao",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578091: {
    id: "item_20444",
    "Last Name": "Cowan",
    "First Name": "Corie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578104: {
    id: "item_31455",
    "Last Name": "Ness-Wilson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578106: {
    id: "item_31300",
    "Last Name": "Costa",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578188: {
    id: "item_20411",
    "Last Name": "LIANG",
    "First Name": "JIANHUA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578202: {
    id: "item_32988",
    "Last Name": "Nguyen Thi Thu",
    "First Name": "Trang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578269: {
    id: "item_7570",
    "Last Name": "Li",
    "First Name": "Xiaobai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578358: {
    id: "item_33049",
    "Last Name": "Craine",
    "First Name": "Earl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578376: {
    id: "item_20409",
    "Last Name": "Chen",
    "First Name": "Guoxiang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578377: {
    id: "item_20442",
    "Last Name": "Gao",
    "First Name": "Xueli",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578429: {
    id: "item_31313",
    "Last Name": "Allen",
    "First Name": "Brett",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578446: {
    id: "item_20441",
    "Last Name": "Noble",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578518: {
    id: "item_7806",
    "Last Name": "Ndlovu",
    "First Name": "Bongani",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578524: {
    id: "item_20439",
    "Last Name": "Mullen",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578553: {
    id: "item_7568",
    "Last Name": "Low",
    "First Name": "Darrell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578556: {
    id: "item_7605",
    "Last Name": "Manoharan",
    "First Name": "Navin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578584: {
    id: "item_20605",
    "Last Name": "Butler",
    "First Name": "Mike",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578593: {
    id: "item_33048",
    "Last Name": "Rahman",
    "First Name": "Md Mahbubur",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578696: {
    id: "item_32999",
    "Last Name": "Graham",
    "First Name": "Bronwyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578748: {
    id: "item_7602",
    "Last Name": "Hughes",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578812: {
    id: "item_31386",
    "Last Name": "Lai",
    "First Name": "Wing",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578818: {
    id: "item_7601",
    "Last Name": "Portilla",
    "First Name": "Jerome",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578827: {
    id: "item_7805",
    "Last Name": "Su",
    "First Name": "Jiang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578845: {
    id: "item_20713",
    "Last Name": "Deetlefs",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578882: {
    id: "item_20603",
    "Last Name": "Tiet",
    "First Name": "Jen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578898: {
    id: "item_20438",
    "Last Name": "Caru",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578974: {
    id: "item_20436",
    "Last Name": "Whelan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36578997: {
    id: "item_7597",
    "Last Name": "Yunzal",
    "First Name": "Elijah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579067: {
    id: "item_7594",
    "Last Name": "McGuire",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579087: {
    id: "item_32998",
    "Last Name": "Raw",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579229: {
    id: "item_31297",
    "Last Name": "Manahan",
    "First Name": "Cecile",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579257: {
    id: "item_20434",
    "Last Name": "Schweser",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579324: {
    id: "item_7593",
    "Last Name": "Bui",
    "First Name": "Nhu Hai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579356: {
    id: "item_20406",
    "Last Name": "Holzschuher",
    "First Name": "Karin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579438: {
    id: "item_20432",
    "Last Name": "Clarke",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579444: {
    id: "item_20405",
    "Last Name": "Hanks",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579494: {
    id: "item_7590",
    "Last Name": "Nguyen",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579521: {
    id: "item_7588",
    "Last Name": "Jeffreys",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579613: {
    id: "item_7948",
    "Last Name": "Curran",
    "First Name": "Peta",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579659: {
    id: "item_7565",
    "Last Name": "Silva",
    "First Name": "Ruben Jr",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579692: {
    id: "item_20429",
    "Last Name": "Hamilton",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579706: {
    id: "item_33097",
    "Last Name": "Burns",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579779: {
    id: "item_31385",
    "Last Name": "Yeo",
    "First Name": "Kee Hong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579804: {
    id: "item_20427",
    "Last Name": "Tan",
    "First Name": "Bosco",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579814: {
    id: "item_5775",
    "Last Name": "Patterson",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579818: {
    id: "item_32995",
    "Last Name": "Liu",
    "First Name": "Yuen Tai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579830: {
    id: "item_32987",
    "Last Name": "SYU",
    "First Name": "FEIKAI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579874: {
    id: "item_7585",
    "Last Name": "Woodhouse",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579876: {
    id: "item_7583",
    "Last Name": "Ibarra",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579907: {
    id: "item_20424",
    "Last Name": "Shelly",
    "First Name": "Linda-Anne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36579932: {
    id: "item_7799",
    "Last Name": "Roche",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580054: {
    id: "item_20422",
    "Last Name": "Brunner",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580133: {
    id: "item_20419",
    "Last Name": "Hughson",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580146: {
    id: "item_20418",
    "Last Name": "Shanahan",
    "First Name": "Jim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580150: {
    id: "item_20712",
    "Last Name": "Nies",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580212: {
    id: "item_7797",
    "Last Name": "Anand Kumar",
    "First Name": "Ashok",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580219: {
    id: "item_20600",
    "Last Name": "Torres",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580350: {
    id: "item_20599",
    "Last Name": "Leyes",
    "First Name": "Leyman",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580352: {
    id: "item_31383",
    "Last Name": "Komoto",
    "First Name": "Shunya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580377: {
    id: "item_20598",
    "Last Name": "Macdonald",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580410: {
    id: "item_20415",
    "Last Name": "Tan",
    "First Name": "Fang Yee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580415: {
    id: "item_20403",
    "Last Name": "S¿rensen",
    "First Name": "Benny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580632: {
    id: "item_7571",
    "Last Name": "Yik",
    "First Name": "Hamm",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580647: {
    id: "item_20597",
    "Last Name": "Kavanagh",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580809: {
    id: "item_31299",
    "Last Name": "Lee",
    "First Name": "Riley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580837: {
    id: "item_20711",
    "Last Name": "Ainbinder",
    "First Name": "Bernardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580900: {
    id: "item_20408",
    "Last Name": "Hinchey",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580903: {
    id: "item_20596",
    "Last Name": "Mitsikas",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580910: {
    id: "item_20407",
    "Last Name": "Quinn",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36580961: {
    id: "item_7566",
    "Last Name": "Arnold",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581003: {
    id: "item_31296",
    "Last Name": "Kulkattimas",
    "First Name": "Chanop",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581038: {
    id: "item_7563",
    "Last Name": "Tse",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581047: {
    id: "item_20595",
    "Last Name": "Goodley",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581092: {
    id: "item_20710",
    "Last Name": "Simpson",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581112: {
    id: "item_31463",
    "Last Name": "Villena",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581113: {
    id: "item_7790",
    "Last Name": "MEI",
    "First Name": "May",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581135: {
    id: "item_20401",
    "Last Name": "Mai",
    "First Name": "Qinghua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581185: {
    id: "item_7561",
    "Last Name": "Radhakrishnan",
    "First Name": "Sandeep",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581195: {
    id: "item_7560",
    "Last Name": "Pickford",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581232: {
    id: "item_31294",
    "Last Name": "Lee",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581258: {
    id: "item_7559",
    "Last Name": "Galvis Gonzalez",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581387: {
    id: "item_20398",
    "Last Name": "Knapton",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581392: {
    id: "item_32986",
    "Last Name": "Purniyati",
    "First Name": "Asti Sri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581394: {
    id: "item_32982",
    "Last Name": "Binskin",
    "First Name": "Narelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581425: {
    id: "item_31290",
    "Last Name": "Taran",
    "First Name": "Nataliya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581429: {
    id: "item_7788",
    "Last Name": "Rea",
    "First Name": "Uale",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581442: {
    id: "item_20593",
    "Last Name": "Milnes",
    "First Name": "Di",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581553: {
    id: "item_7557",
    "Last Name": "Sagaa",
    "First Name": "Saeed",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581603: {
    id: "item_20393",
    "Last Name": "Trock",
    "First Name": "Anastasia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581658: {
    id: "item_31454",
    "Last Name": "Palmer",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581667: {
    id: "item_20591",
    "Last Name": "LI",
    "First Name": "HAIYAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581679: {
    id: "item_31379",
    "Last Name": "Cumming",
    "First Name": "Carmel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581692: {
    id: "item_20391",
    "Last Name": "Griffiths",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581698: {
    id: "item_31292",
    "Last Name": "Koizumi",
    "First Name": "Naoya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581737: {
    id: "item_7784",
    "Last Name": "Zhang",
    "First Name": "Ning",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581750: {
    id: "item_7947",
    "Last Name": "Taylor",
    "First Name": "Nathanial",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581773: {
    id: "item_32985",
    "Last Name": "Nesti",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581784: {
    id: "item_20399",
    "Last Name": "Cheong",
    "First Name": "April",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581785: {
    id: "item_32984",
    "Last Name": "Wilson",
    "First Name": "Laurie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581818: {
    id: "item_7547",
    "Last Name": "Shipway",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581819: {
    id: "item_31291",
    "Last Name": "zhang",
    "First Name": "yong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581835: {
    id: "item_7546",
    "Last Name": "Gordon",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581876: {
    id: "item_31453",
    "Last Name": "Scott",
    "First Name": "Stacy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581878: {
    id: "item_20387",
    "Last Name": "Yu",
    "First Name": "Quanquan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581892: {
    id: "item_7544",
    "Last Name": "Le Jambre",
    "First Name": "Renee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581934: {
    id: "item_7783",
    "Last Name": "Barker",
    "First Name": "Dawn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581945: {
    id: "item_20397",
    "Last Name": "Kirchberger",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36581964: {
    id: "item_7782",
    "Last Name": "Kaur",
    "First Name": "Arashdeep",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582005: {
    id: "item_20396",
    "Last Name": "Suwardaniyasa",
    "First Name": "Ecep",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582022: {
    id: "item_31452",
    "Last Name": "Thambar",
    "First Name": "Sukumaran",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582053: {
    id: "item_20383",
    "Last Name": "Hoy",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582083: {
    id: "item_7537",
    "Last Name": "Gurung",
    "First Name": "Chandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582087: {
    id: "item_7556",
    "Last Name": "Seow",
    "First Name": "Kim Song",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582128: {
    id: "item_20394",
    "Last Name": "Manzano",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582158: {
    id: "item_7555",
    "Last Name": "Khoo",
    "First Name": "Lay Mui",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582160: {
    id: "item_20379",
    "Last Name": "Stevens",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582217: {
    id: "item_7946",
    "Last Name": "Birt",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582241: {
    id: "item_7945",
    "Last Name": "Stoker",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582244: {
    id: "item_31288",
    "Last Name": "Gibbons",
    "First Name": "Carleen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582273: {
    id: "item_31287",
    "Last Name": "Lacbay",
    "First Name": "Wilbert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582297: {
    id: "item_7532",
    "Last Name": "scott",
    "First Name": "duncan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582298: {
    id: "item_5783",
    "Last Name": "Carreno",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582304: {
    id: "item_7530",
    "Last Name": "Clarkson",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582329: {
    id: "item_32978",
    "Last Name": "Cook",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582332: {
    id: "item_20586",
    "Last Name": "Lear",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582358: {
    id: "item_7527",
    "Last Name": "Birnie",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582367: {
    id: "item_20585",
    "Last Name": "Lien",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582377: {
    id: "item_7526",
    "Last Name": "Roche",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582415: {
    id: "item_7525",
    "Last Name": "Close",
    "First Name": "Alison",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582417: {
    id: "item_31376",
    "Last Name": "Cartwright",
    "First Name": "Stefani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582470: {
    id: "item_20375",
    "Last Name": "Donohoe",
    "First Name": "Liz",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582484: {
    id: "item_31272",
    "Last Name": "Nesbitt",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582552: {
    id: "item_20709",
    "Last Name": "Budai",
    "First Name": "Ferenc",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582568: {
    id: "item_20371",
    "Last Name": "Januszek",
    "First Name": "Mirek",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582603: {
    id: "item_32972",
    "Last Name": "Page",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582609: {
    id: "item_32970",
    "Last Name": "Marshan",
    "First Name": "Mel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582645: {
    id: "item_31270",
    "Last Name": "Clark",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582650: {
    id: "item_7778",
    "Last Name": "Sword",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582663: {
    id: "item_33096",
    "Last Name": "Fong",
    "First Name": "Yun Han",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582665: {
    id: "item_32981",
    "Last Name": "Durnin",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582693: {
    id: "item_33088",
    "Last Name": "Cooper",
    "First Name": "Carol",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582716: {
    id: "item_7522",
    "Last Name": "Grealy",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582765: {
    id: "item_31375",
    "Last Name": "Hanson",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582788: {
    id: "item_31266",
    "Last Name": "Foley",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582796: {
    id: "item_7521",
    "Last Name": "Santos",
    "First Name": "Reginald",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582807: {
    id: "item_33041",
    "Last Name": "HE",
    "First Name": "Jingxuan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582814: {
    id: "item_20392",
    "Last Name": "Abu Hassan",
    "First Name": "Hairulirwan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582870: {
    id: "item_20580",
    "Last Name": "Selfe",
    "First Name": "Philip",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582918: {
    id: "item_7516",
    "Last Name": "Elias",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582931: {
    id: "item_32969",
    "Last Name": "Sembiring",
    "First Name": "Mujiono",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582947: {
    id: "item_7776",
    "Last Name": "Goldsworthy",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582960: {
    id: "item_20362",
    "Last Name": "Barutha",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36582980: {
    id: "item_31286",
    "Last Name": "Subakti",
    "First Name": "Edy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583044: {
    id: "item_7514",
    "Last Name": "Clark",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583049: {
    id: "item_7774",
    "Last Name": "Valvo",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583067: {
    id: "item_7513",
    "Last Name": "McCaughan",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583116: {
    id: "item_20358",
    "Last Name": "Estepa",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583127: {
    id: "item_20573",
    "Last Name": "HEELIS",
    "First Name": "TINA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583145: {
    id: "item_7772",
    "Last Name": "Nicholls",
    "First Name": "Dominie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583146: {
    id: "item_7511",
    "Last Name": "Fonzi",
    "First Name": "Yumiko",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583152: {
    id: "item_20357",
    "Last Name": "Herschel",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583164: {
    id: "item_20355",
    "Last Name": "Bennett",
    "First Name": "Laurence",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583172: {
    id: "item_7769",
    "Last Name": "Chiu",
    "First Name": "Hung Mui",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583174: {
    id: "item_20572",
    "Last Name": "Gimbert",
    "First Name": "Renee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583199: {
    id: "item_20571",
    "Last Name": "Scarlett-Arundell",
    "First Name": "Tracie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583203: {
    id: "item_20354",
    "Last Name": "Vergara",
    "First Name": "John Joel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583210: {
    id: "item_20353",
    "Last Name": "Hocking",
    "First Name": "Jarrod",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583215: {
    id: "item_31285",
    "Last Name": "Leelayoova",
    "First Name": "Tanunt",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583245: {
    id: "item_7549",
    "Last Name": "SUZUKI",
    "First Name": "HIROKI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583249: {
    id: "item_20349",
    "Last Name": "Caprin",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583272: {
    id: "item_7510",
    "Last Name": "Dai",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583276: {
    id: "item_31260",
    "Last Name": "Baldwin",
    "First Name": "Rick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583339: {
    id: "item_31258",
    "Last Name": "Silber",
    "First Name": "Darren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583405: {
    id: "item_20390",
    "Last Name": "GHAZALI",
    "First Name": "MOHD SHUKRI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583415: {
    id: "item_7766",
    "Last Name": "Wilkens",
    "First Name": "Jaimee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583421: {
    id: "item_7765",
    "Last Name": "WILLMOTT",
    "First Name": "JOSHUA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583433: {
    id: "item_5772",
    "Last Name": "Wheeler",
    "First Name": "Kendall",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583457: {
    id: "item_7762",
    "Last Name": "Beattie",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583472: {
    id: "item_31254",
    "Last Name": "Musarra",
    "First Name": "Suzy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583479: {
    id: "item_20344",
    "Last Name": "Harvey",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583485: {
    id: "item_20708",
    "Last Name": "Plush",
    "First Name": "Katarina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583491: {
    id: "item_20342",
    "Last Name": "Potapenko",
    "First Name": "Anastasiya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583495: {
    id: "item_20341",
    "Last Name": "Troy",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583507: {
    id: "item_31373",
    "Last Name": "Then",
    "First Name": "Italia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583510: {
    id: "item_20567",
    "Last Name": "Nathanson",
    "First Name": "Evan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583518: {
    id: "item_20340",
    "Last Name": "Sherlock",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583556: {
    id: "item_32966",
    "Last Name": "Bullard",
    "First Name": "Cherrie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583557: {
    id: "item_20707",
    "Last Name": "Deetlefs",
    "First Name": "Wesley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583560: {
    id: "item_31371",
    "Last Name": "Susilawati",
    "First Name": "Connie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583563: {
    id: "item_20336",
    "Last Name": "Langas",
    "First Name": "Eleni",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583578: {
    id: "item_20706",
    "Last Name": "Carlin",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583582: {
    id: "item_31253",
    "Last Name": "Yu",
    "First Name": "Qinglian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583594: {
    id: "item_31370",
    "Last Name": "Diesta",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583618: {
    id: "item_31252",
    "Last Name": "Sano",
    "First Name": "Ruru",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583624: {
    id: "item_31251",
    "Last Name": "Yang",
    "First Name": "Vicki",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583639: {
    id: "item_31451",
    "Last Name": "McDermid",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583642: {
    id: "item_7759",
    "Last Name": "Hurdley",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583656: {
    id: "item_7545",
    "Last Name": "Song",
    "First Name": "Jie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583659: {
    id: "item_31369",
    "Last Name": "Garcia",
    "First Name": "Keith",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583717: {
    id: "item_20332",
    "Last Name": "Gimbert",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583743: {
    id: "item_20564",
    "Last Name": "Giannasca",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583767: {
    id: "item_20331",
    "Last Name": "Crawshay",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583810: {
    id: "item_20329",
    "Last Name": "Oxborough",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583885: {
    id: "item_20388",
    "Last Name": "Sitthimayteekul",
    "First Name": "Sawat",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583918: {
    id: "item_20562",
    "Last Name": "Hillier",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583928: {
    id: "item_20324",
    "Last Name": "Hashemi",
    "First Name": "Naeem",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583948: {
    id: "item_20323",
    "Last Name": "Carmody",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36583959: {
    id: "item_20386",
    "Last Name": "Jantaramanee",
    "First Name": "Sansanee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584012: {
    id: "item_7494",
    "Last Name": "Dundon",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584036: {
    id: "item_20322",
    "Last Name": "Walker",
    "First Name": "Amie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584098: {
    id: "item_7543",
    "Last Name": "Ide",
    "First Name": "Yoko",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584153: {
    id: "item_7755",
    "Last Name": "Page",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584185: {
    id: "item_31366",
    "Last Name": "Wong",
    "First Name": "Tsz Hin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584219: {
    id: "item_20320",
    "Last Name": "Lau",
    "First Name": "Kwan Wai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584425: {
    id: "item_7491",
    "Last Name": "Kelly",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584439: {
    id: "item_20384",
    "Last Name": "LI",
    "First Name": "JIANAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584466: {
    id: "item_20319",
    "Last Name": "Johnson",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584583: {
    id: "item_7488",
    "Last Name": "Dishi",
    "First Name": "Elor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584605: {
    id: "item_5757",
    "Last Name": "Wiratmaja",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8402778, 151.2072222],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.834825, 151.207728],
    "Ped Crossing 2": [-33.836832, 151.20732],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584617: {
    id: "item_32980",
    "Last Name": "WANG",
    "First Name": "Yiran",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584619: {
    id: "item_20316",
    "Last Name": "Sullivan",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584644: {
    id: "item_20315",
    "Last Name": "CHEUNG",
    "First Name": "WAI MING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584814: {
    id: "item_20313",
    "Last Name": "Ou",
    "First Name": "Galen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36584905: {
    id: "item_31280",
    "Last Name": "Agatep",
    "First Name": "Pia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36585166: {
    id: "item_20382",
    "Last Name": "Burnham",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36585176: {
    id: "item_31279",
    "Last Name": "Rounds",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36585331: {
    id: "item_5762",
    "Last Name": "AGUILLON",
    "First Name": "JOVIE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36585383: {
    id: "item_20381",
    "Last Name": "CHENG",
    "First Name": "YU CHIEH",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36585587: {
    id: "item_20380",
    "Last Name": "Leung",
    "First Name": "Chung Wai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36586355: {
    id: "item_32979",
    "Last Name": "Su",
    "First Name": "Daphne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36586634: {
    id: "item_20312",
    "Last Name": "Le Tourneau",
    "First Name": "Luc",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36586730: {
    id: "item_7535",
    "Last Name": "MA",
    "First Name": "YIWEI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36587847: {
    id: "item_20378",
    "Last Name": "Larsen",
    "First Name": "Katja Villalobos",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36588366: {
    id: "item_31276",
    "Last Name": "Forest",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36588820: {
    id: "item_7533",
    "Last Name": "Cherkady",
    "First Name": "Girish",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36590538: {
    id: "item_20311",
    "Last Name": "Pieterse",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36591672: {
    id: "item_7483",
    "Last Name": "Rigelsford",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36592596: {
    id: "item_20310",
    "Last Name": "Ronquillo",
    "First Name": "Dale",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36592633: {
    id: "item_31241",
    "Last Name": "Qiu",
    "First Name": "Zhixin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36592811: {
    id: "item_31274",
    "Last Name": "Streib",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36592918: {
    id: "item_20308",
    "Last Name": "Timeus",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36592931: {
    id: "item_7749",
    "Last Name": "Ryan",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36593133: {
    id: "item_7748",
    "Last Name": "Howlett",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36593373: {
    id: "item_7747",
    "Last Name": "Borchard",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36593416: {
    id: "item_7746",
    "Last Name": "Kershaw",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36593649: {
    id: "item_20559",
    "Last Name": "Griffiths",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36594099: {
    id: "item_7482",
    "Last Name": "McCarthy",
    "First Name": "Colin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36594112: {
    id: "item_20306",
    "Last Name": "Soucy",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36594373: {
    id: "item_7481",
    "Last Name": "Connor",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36594533: {
    id: "item_20305",
    "Last Name": "Cimino",
    "First Name": "Marco",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36594668: {
    id: "item_31235",
    "Last Name": "Cuento",
    "First Name": "Leandro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36595018: {
    id: "item_7479",
    "Last Name": "Arnott",
    "First Name": "Stewart",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36595353: {
    id: "item_32952",
    "Last Name": "McPake",
    "First Name": "Elyse",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36595682: {
    id: "item_32977",
    "Last Name": "Richard",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36595713: {
    id: "item_31232",
    "Last Name": "Taylor-Brain",
    "First Name": "Paige",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36595903: {
    id: "item_20300",
    "Last Name": "Muller",
    "First Name": "Cobus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36595943: {
    id: "item_7473",
    "Last Name": "Montet",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36596191: {
    id: "item_31231",
    "Last Name": "Hain",
    "First Name": "Trina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36596222: {
    id: "item_7740",
    "Last Name": "Panagiotopoulos",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36596368: {
    id: "item_32950",
    "Last Name": "Donovan",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36596391: {
    id: "item_32976",
    "Last Name": "Holsaeter",
    "First Name": "Svein",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36596594: {
    id: "item_33086",
    "Last Name": "Donovan",
    "First Name": "Warren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36596631: {
    id: "item_31273",
    "Last Name": "Holsaeter",
    "First Name": "Janet",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36596848: {
    id: "item_7931",
    "Last Name": "Tandean",
    "First Name": "Bjorn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36596930: {
    id: "item_20556",
    "Last Name": "Wang",
    "First Name": "Yao",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36597218: {
    id: "item_5780",
    "Last Name": "Carritt",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36597375: {
    id: "item_20554",
    "Last Name": "Gorrion",
    "First Name": "Ollie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36597459: {
    id: "item_7929",
    "Last Name": "Goldstone",
    "First Name": "Philip",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36597672: {
    id: "item_33085",
    "Last Name": "Lockwood",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36597827: {
    id: "item_31446",
    "Last Name": "Finegan",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36597965: {
    id: "item_7927",
    "Last Name": "Le Clech",
    "First Name": "Pierre",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36598080: {
    id: "item_7736",
    "Last Name": "Torquido",
    "First Name": "Sef",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36598241: {
    id: "item_20377",
    "Last Name": "Lu",
    "First Name": "Jun Liang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36598447: {
    id: "item_33084",
    "Last Name": "Simone",
    "First Name": "Coach",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36598459: {
    id: "item_20694",
    "Last Name": "Hargreaves",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36598737: {
    id: "item_7923",
    "Last Name": "Knight",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36598891: {
    id: "item_7944",
    "Last Name": "Schumacher",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36598893: {
    id: "item_20551",
    "Last Name": "Montefalcon",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36599138: {
    id: "item_33083",
    "Last Name": "Kasemrungchaikit",
    "First Name": "Sittath",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36599486: {
    id: "item_33081",
    "Last Name": "McCool",
    "First Name": "SinŽad",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36599543: {
    id: "item_20686",
    "Last Name": "Jung",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36599864: {
    id: "item_7943",
    "Last Name": "Moody",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36600002: {
    id: "item_20550",
    "Last Name": "Wisdom",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36600068: {
    id: "item_31450",
    "Last Name": "Song",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36600158: {
    id: "item_31441",
    "Last Name": "Xu",
    "First Name": "Yangshuo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36600655: {
    id: "item_31359",
    "Last Name": "Hocking",
    "First Name": "Debbie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36601478: {
    id: "item_7916",
    "Last Name": "Mullane",
    "First Name": "Shauna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36602834: {
    id: "item_31439",
    "Last Name": "Rogers",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36604316: {
    id: "item_31435",
    "Last Name": "Owen",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36604387: {
    id: "item_20374",
    "Last Name": "Ong",
    "First Name": "Jane-Jane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36604395: {
    id: "item_31434",
    "Last Name": "Simpson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36605029: {
    id: "item_20549",
    "Last Name": "Kennedy",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36605546: {
    id: "item_7905",
    "Last Name": "Fanning",
    "First Name": "Megan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36605591: {
    id: "item_31432",
    "Last Name": "Warmerdam",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36605886: {
    id: "item_7904",
    "Last Name": "Truong",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36606203: {
    id: "item_7730",
    "Last Name": "Chang",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36606352: {
    id: "item_32975",
    "Last Name": "Chen",
    "First Name": "Luoying",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36606480: {
    id: "item_20666",
    "Last Name": "Romagosa",
    "First Name": "Carles",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36606602: {
    id: "item_31358",
    "Last Name": "Tautua",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36606743: {
    id: "item_20665",
    "Last Name": "Kazzi",
    "First Name": "Rita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36606805: {
    id: "item_31428",
    "Last Name": "Barlogio",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36606919: {
    id: "item_20664",
    "Last Name": "Guan",
    "First Name": "Yu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36606948: {
    id: "item_31427",
    "Last Name": "Waisurasing",
    "First Name": "Kriangkrai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36607055: {
    id: "item_32973",
    "Last Name": "Nasrul",
    "First Name": "Hendrik",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36607062: {
    id: "item_32974",
    "Last Name": "WIDIATI",
    "First Name": "NURUL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36607316: {
    id: "item_7899",
    "Last Name": "Whelan",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36607576: {
    id: "item_33071",
    "Last Name": "Hudson",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36608013: {
    id: "item_33032",
    "Last Name": "Mauger",
    "First Name": "Marc",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36608089: {
    id: "item_20705",
    "Last Name": "Murray",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36608347: {
    id: "item_20543",
    "Last Name": "Button",
    "First Name": "Carly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36608369: {
    id: "item_7897",
    "Last Name": "Woodland",
    "First Name": "Breyer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36608373: {
    id: "item_32971",
    "Last Name": "Azizan",
    "First Name": "Norizan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36608817: {
    id: "item_7896",
    "Last Name": "Lau",
    "First Name": "Benny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36609366: {
    id: "item_7942",
    "Last Name": "Johns",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36609421: {
    id: "item_5779",
    "Last Name": "Padmanathan",
    "First Name": "Rehana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36609499: {
    id: "item_7725",
    "Last Name": "Herft",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36609618: {
    id: "item_31421",
    "Last Name": "Huang",
    "First Name": "Wilson",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36609780: {
    id: "item_7886",
    "Last Name": "Bar Gerbi",
    "First Name": "Nissim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36609785: {
    id: "item_20704",
    "Last Name": "Dawson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36609849: {
    id: "item_7885",
    "Last Name": "Leperou",
    "First Name": "Florent",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36609943: {
    id: "item_20369",
    "Last Name": "Lencse",
    "First Name": "Chaolan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36609979: {
    id: "item_7524",
    "Last Name": "Quek",
    "First Name": "Kia Fatt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610034: {
    id: "item_7882",
    "Last Name": "Tse",
    "First Name": "Chui Tung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610079: {
    id: "item_7723",
    "Last Name": "Cornick",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610174: {
    id: "item_7941",
    "Last Name": "Ritchie",
    "First Name": "Kai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610347: {
    id: "item_7879",
    "Last Name": "Tinker",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610556: {
    id: "item_20656",
    "Last Name": "Abeynayake",
    "First Name": "Nandun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610579: {
    id: "item_20655",
    "Last Name": "Rittoff",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610588: {
    id: "item_7716",
    "Last Name": "Du",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610678: {
    id: "item_7940",
    "Last Name": "Linsley",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610710: {
    id: "item_20653",
    "Last Name": "Zimerman",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610741: {
    id: "item_7875",
    "Last Name": "Ciscato",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610944: {
    id: "item_7873",
    "Last Name": "Bennett",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36610984: {
    id: "item_31417",
    "Last Name": "Adams",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611012: {
    id: "item_20367",
    "Last Name": "Lui",
    "First Name": "Ho Yin Danny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611019: {
    id: "item_7871",
    "Last Name": "Atzmon",
    "First Name": "Doron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611028: {
    id: "item_7939",
    "Last Name": "Ravelingien",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611049: {
    id: "item_20703",
    "Last Name": "Lambert",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611158: {
    id: "item_7711",
    "Last Name": "CHOI",
    "First Name": "WOOHYUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611214: {
    id: "item_7938",
    "Last Name": "Macalalad",
    "First Name": "John Mathew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611244: {
    id: "item_31268",
    "Last Name": "Rosdahl",
    "First Name": "Lars",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611305: {
    id: "item_20650",
    "Last Name": "Carlson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611410: {
    id: "item_20366",
    "Last Name": "Zetzsche",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611448: {
    id: "item_20702",
    "Last Name": "devlin",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611575: {
    id: "item_20538",
    "Last Name": "George",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611613: {
    id: "item_7520",
    "Last Name": "Chen",
    "First Name": "Yu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611670: {
    id: "item_31411",
    "Last Name": "Newman",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611681: {
    id: "item_20537",
    "Last Name": "Chester",
    "First Name": "Rod",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611753: {
    id: "item_31409",
    "Last Name": "Gomez",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611775: {
    id: "item_7519",
    "Last Name": "Lee",
    "First Name": "SeungYong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611795: {
    id: "item_31355",
    "Last Name": "Hipwell",
    "First Name": "Sarah-Jane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611912: {
    id: "item_20642",
    "Last Name": "Godfrey",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36611980: {
    id: "item_20535",
    "Last Name": "Cadzow",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612022: {
    id: "item_31265",
    "Last Name": "Kaitiwong",
    "First Name": "Saran",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612077: {
    id: "item_20640",
    "Last Name": "Ou",
    "First Name": "Karmen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612299: {
    id: "item_7937",
    "Last Name": "Ngai",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612315: {
    id: "item_20638",
    "Last Name": "Woodward",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612362: {
    id: "item_31404",
    "Last Name": "Cunninghame",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612381: {
    id: "item_31403",
    "Last Name": "Kingsford-Smith",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612406: {
    id: "item_20533",
    "Last Name": "Schmidt",
    "First Name": "Thammen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612480: {
    id: "item_20532",
    "Last Name": "Innes",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612482: {
    id: "item_31401",
    "Last Name": "Wolfe",
    "First Name": "Russell",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612486: {
    id: "item_31402",
    "Last Name": "Wolfe",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612556: {
    id: "item_7704",
    "Last Name": "Rankin",
    "First Name": "Chuck",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612580: {
    id: "item_20527",
    "Last Name": "Payne",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612602: {
    id: "item_31352",
    "Last Name": "Liu",
    "First Name": "Xiongfei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612611: {
    id: "item_7851",
    "Last Name": "Tanaka",
    "First Name": "Daichi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612655: {
    id: "item_20701",
    "Last Name": "Dawes",
    "First Name": "Owen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612701: {
    id: "item_7850",
    "Last Name": "Flood",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612722: {
    id: "item_7936",
    "Last Name": "Mesa",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612737: {
    id: "item_7849",
    "Last Name": "Bird",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612791: {
    id: "item_7848",
    "Last Name": "Teoh",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612834: {
    id: "item_31351",
    "Last Name": "Wu",
    "First Name": "Wen-Jui",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612852: {
    id: "item_20526",
    "Last Name": "Chikwakukire",
    "First Name": "Jotham",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612911: {
    id: "item_33029",
    "Last Name": "Ting",
    "First Name": "Anita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36612959: {
    id: "item_31398",
    "Last Name": "Nguyen",
    "First Name": "Thai Thanh Tung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36613957: {
    id: "item_7703",
    "Last Name": "Bowey",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36614173: {
    id: "item_7846",
    "Last Name": "Richards",
    "First Name": "Duncan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36614240: {
    id: "item_32968",
    "Last Name": "ZHONG",
    "First Name": "NAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36614894: {
    id: "item_31396",
    "Last Name": "Qi",
    "First Name": "Jiaxiong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36615072: {
    id: "item_31350",
    "Last Name": "Hsu",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36615169: {
    id: "item_20700",
    "Last Name": "McGowan",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36615275: {
    id: "item_31264",
    "Last Name": "GOH",
    "First Name": "PECK SAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36615656: {
    id: "item_7512",
    "Last Name": "Ilagan",
    "First Name": "Elroy Jon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36618464: {
    id: "item_31263",
    "Last Name": "Mitchell",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36620655: {
    id: "item_33060",
    "Last Name": "Cheng",
    "First Name": "Changhui",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36621039: {
    id: "item_7841",
    "Last Name": "delaney",
    "First Name": "robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36621675: {
    id: "item_7840",
    "Last Name": "Jones",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36622682: {
    id: "item_7838",
    "Last Name": "Steel",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36623266: {
    id: "item_31349",
    "Last Name": "Kim",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36624956: {
    id: "item_31449",
    "Last Name": "Whitehead",
    "First Name": "Jody",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36625246: {
    id: "item_31394",
    "Last Name": "Dua",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36625409: {
    id: "item_7835",
    "Last Name": "QIU",
    "First Name": "YONGCHAO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36625752: {
    id: "item_33027",
    "Last Name": "Zelesco",
    "First Name": "Karina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36625822: {
    id: "item_20524",
    "Last Name": "Choi",
    "First Name": "Yong Jin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36626258: {
    id: "item_20625",
    "Last Name": "McIlwain",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36626715: {
    id: "item_7701",
    "Last Name": "QIN",
    "First Name": "JIAJUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36627165: {
    id: "item_20743",
    "Last Name": "Langmead",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36627868: {
    id: "item_7829",
    "Last Name": "Gibson",
    "First Name": "Mac",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36628022: {
    id: "item_7935",
    "Last Name": "Smyth",
    "First Name": "Lilli",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36628027: {
    id: "item_20619",
    "Last Name": "Lamming",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36628964: {
    id: "item_7828",
    "Last Name": "Wang",
    "First Name": "Christine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36629084: {
    id: "item_7827",
    "Last Name": "Fleming",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36629407: {
    id: "item_7825",
    "Last Name": "Marks",
    "First Name": "Warren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36629440: {
    id: "item_7824",
    "Last Name": "Sloshberg",
    "First Name": "Cara",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36630265: {
    id: "item_33056",
    "Last Name": "Christie",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36630356: {
    id: "item_20618",
    "Last Name": "Curran",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36631885: {
    id: "item_7821",
    "Last Name": "Crosse",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36632183: {
    id: "item_33025",
    "Last Name": "Kent",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36632583: {
    id: "item_31261",
    "Last Name": "Clement",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36632712: {
    id: "item_5760",
    "Last Name": "Burrows",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36632720: {
    id: "item_7700",
    "Last Name": "Williamson",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36633183: {
    id: "item_7816",
    "Last Name": "Cordier",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36633269: {
    id: "item_31389",
    "Last Name": "Robbins",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36633697: {
    id: "item_31388",
    "Last Name": "McEnery",
    "First Name": "Rose",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36634016: {
    id: "item_20613",
    "Last Name": "Lee",
    "First Name": "Jo-Ann",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36634216: {
    id: "item_20297",
    "Last Name": "Banton",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36634667: {
    id: "item_20612",
    "Last Name": "McCallion",
    "First Name": "Ciaran",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36634772: {
    id: "item_7813",
    "Last Name": "Sheekey",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36634938: {
    id: "item_7812",
    "Last Name": "Lee",
    "First Name": "Nathan Kin-Mun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36635143: {
    id: "item_20610",
    "Last Name": "Najjar",
    "First Name": "Alan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36635427: {
    id: "item_7699",
    "Last Name": "Galbraith",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36635440: {
    id: "item_20609",
    "Last Name": "Sayer",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36635894: {
    id: "item_20607",
    "Last Name": "Kittos",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36636215: {
    id: "item_20606",
    "Last Name": "Ruhnau",
    "First Name": "Curtis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36636533: {
    id: "item_7809",
    "Last Name": "Yoon",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36636683: {
    id: "item_31448",
    "Last Name": "Torrington",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36636816: {
    id: "item_7934",
    "Last Name": "Byrne",
    "First Name": "Reece",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36637751: {
    id: "item_7807",
    "Last Name": "Kavanagh",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36638047: {
    id: "item_33047",
    "Last Name": "Thomas",
    "First Name": "Phil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36638287: {
    id: "item_20352",
    "Last Name": "Cheng",
    "First Name": "Savannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36638464: {
    id: "item_20604",
    "Last Name": "Novota",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36638943: {
    id: "item_20699",
    "Last Name": "Murphy",
    "First Name": "Cerys",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36639368: {
    id: "item_33087",
    "Last Name": "Gee",
    "First Name": "Heather",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36639523: {
    id: "item_20519",
    "Last Name": "Chung",
    "First Name": "Vicky",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36639564: {
    id: "item_20350",
    "Last Name": "HU",
    "First Name": "YEFANG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36639650: {
    id: "item_5776",
    "Last Name": "Cundasawmy",
    "First Name": "Karen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36639743: {
    id: "item_20348",
    "Last Name": "Gomez",
    "First Name": "Adrianne Kim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36639842: {
    id: "item_20602",
    "Last Name": "Berkery",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36639915: {
    id: "item_20516",
    "Last Name": "Clarke",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36640459: {
    id: "item_7509",
    "Last Name": "Liu",
    "First Name": "Ying",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36640488: {
    id: "item_31384",
    "Last Name": "Torrevillas",
    "First Name": "Stella",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36640518: {
    id: "item_31382",
    "Last Name": "Lai Lee",
    "First Name": "Neil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36640801: {
    id: "item_7794",
    "Last Name": "Sciacca",
    "First Name": "Kath",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36640815: {
    id: "item_7695",
    "Last Name": "Harrop",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36640975: {
    id: "item_31381",
    "Last Name": "Hurst",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36641175: {
    id: "item_31343",
    "Last Name": "Tolentino",
    "First Name": "Angelo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36641286: {
    id: "item_31380",
    "Last Name": "Woodliffe",
    "First Name": "Colette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36641462: {
    id: "item_7789",
    "Last Name": "Loveday",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36641791: {
    id: "item_20594",
    "Last Name": "Grindlay",
    "First Name": "Symon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36641842: {
    id: "item_7693",
    "Last Name": "Rudkins",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36641860: {
    id: "item_7787",
    "Last Name": "Smith",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36641862: {
    id: "item_7785",
    "Last Name": "Nguyen",
    "First Name": "Viet",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36641933: {
    id: "item_7692",
    "Last Name": "Yap",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36641964: {
    id: "item_20509",
    "Last Name": "Crawley",
    "First Name": "Brigitte",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642042: {
    id: "item_7933",
    "Last Name": "Stanley",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642151: {
    id: "item_20590",
    "Last Name": "KROON",
    "First Name": "Mike",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642233: {
    id: "item_31259",
    "Last Name": "Eleosida",
    "First Name": "Portia Hilary",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642350: {
    id: "item_5770",
    "Last Name": "Vincent",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642467: {
    id: "item_31342",
    "Last Name": "Chung",
    "First Name": "Hsin-Fang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642518: {
    id: "item_20588",
    "Last Name": "Boland",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642755: {
    id: "item_7932",
    "Last Name": "bubnich",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642807: {
    id: "item_20507",
    "Last Name": "Lodwick",
    "First Name": "Bill",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642813: {
    id: "item_33024",
    "Last Name": "Lai",
    "First Name": "Judy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36642896: {
    id: "item_31257",
    "Last Name": "Gandhanya",
    "First Name": "Paulus Lukas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36644168: {
    id: "item_20587",
    "Last Name": "Leung",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36644620: {
    id: "item_7687",
    "Last Name": "Tanriadi",
    "First Name": "Andru",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36645187: {
    id: "item_7507",
    "Last Name": "OYAMA",
    "First Name": "CHII",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36645534: {
    id: "item_20347",
    "Last Name": "Kim",
    "First Name": "HyoSeok",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36645596: {
    id: "item_33095",
    "Last Name": "Yukontong",
    "First Name": "Jariya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36648505: {
    id: "item_7781",
    "Last Name": "Maes",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36648777: {
    id: "item_20346",
    "Last Name": "Marasciulo",
    "First Name": "Lizz",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36649359: {
    id: "item_31255",
    "Last Name": "Chen",
    "First Name": "Yanan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36649937: {
    id: "item_20584",
    "Last Name": "Trimmer",
    "First Name": "Carolynn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36650073: {
    id: "item_7777",
    "Last Name": "Williamson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36650610: {
    id: "item_20698",
    "Last Name": "Brett",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36650646: {
    id: "item_7684",
    "Last Name": "Cooke",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36650900: {
    id: "item_5781",
    "Last Name": "Mudford",
    "First Name": "Sonia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36651013: {
    id: "item_20583",
    "Last Name": "Everett",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36651029: {
    id: "item_20582",
    "Last Name": "Bourke",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36651235: {
    id: "item_20506",
    "Last Name": "Wilcox",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36651425: {
    id: "item_33040",
    "Last Name": "Fishlock",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36651658: {
    id: "item_20579",
    "Last Name": "Hill",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36651778: {
    id: "item_5759",
    "Last Name": "Williamson",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36651920: {
    id: "item_20576",
    "Last Name": "Jackson",
    "First Name": "Donna-Leigh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36652015: {
    id: "item_7683",
    "Last Name": "Fogarty",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36652040: {
    id: "item_20343",
    "Last Name": "Plianpae",
    "First Name": "Krit",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36652299: {
    id: "item_20575",
    "Last Name": "Lai",
    "First Name": "Ying Yi Jovellyne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36652629: {
    id: "item_20574",
    "Last Name": "Corkin",
    "First Name": "Neil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36652639: {
    id: "item_7771",
    "Last Name": "McNally",
    "First Name": "Orlagh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36652892: {
    id: "item_20697",
    "Last Name": "Mulhearn",
    "First Name": "Glen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36652975: {
    id: "item_5769",
    "Last Name": "Dyer",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36653187: {
    id: "item_20570",
    "Last Name": "Fitzwater",
    "First Name": "Suzie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36653227: {
    id: "item_7768",
    "Last Name": "Wolff",
    "First Name": "Cas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36653324: {
    id: "item_20503",
    "Last Name": "Brown",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36654191: {
    id: "item_20568",
    "Last Name": "Mellars",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36654207: {
    id: "item_7763",
    "Last Name": "Bhandari",
    "First Name": "Rabindra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36654244: {
    id: "item_31374",
    "Last Name": "Zaragoza",
    "First Name": "Henry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36654520: {
    id: "item_31372",
    "Last Name": "Thompson",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36654841: {
    id: "item_7760",
    "Last Name": "Dumaran",
    "First Name": "Fritz",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36654987: {
    id: "item_7680",
    "Last Name": "Tan",
    "First Name": "Kuan Lee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36654989: {
    id: "item_31368",
    "Last Name": "Shields",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655006: {
    id: "item_7506",
    "Last Name": "Robson",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655011: {
    id: "item_7758",
    "Last Name": "Cheah",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655015: {
    id: "item_20563",
    "Last Name": "Farr",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655023: {
    id: "item_20501",
    "Last Name": "Kang",
    "First Name": "Jiong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655054: {
    id: "item_7753",
    "Last Name": "Tran",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655070: {
    id: "item_31341",
    "Last Name": "Hunter",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655131: {
    id: "item_7754",
    "Last Name": "Thielemans",
    "First Name": "Bek",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655192: {
    id: "item_7673",
    "Last Name": "Burbidge",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655224: {
    id: "item_7751",
    "Last Name": "Boutsikakis",
    "First Name": "Costa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655226: {
    id: "item_7750",
    "Last Name": "Fiertl",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655260: {
    id: "item_33035",
    "Last Name": "Ge",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655274: {
    id: "item_20558",
    "Last Name": "PRADOS-VALERIO",
    "First Name": "VICTOR",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655303: {
    id: "item_7745",
    "Last Name": "Ji",
    "First Name": "Jason Changyong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655313: {
    id: "item_33036",
    "Last Name": "Barillo",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655327: {
    id: "item_31340",
    "Last Name": "Setiawan",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655347: {
    id: "item_20339",
    "Last Name": "Urip",
    "First Name": "Indira Parwitasari",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655358: {
    id: "item_31364",
    "Last Name": "Hernandez",
    "First Name": "Gayda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655361: {
    id: "item_7738",
    "Last Name": "Diola",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655362: {
    id: "item_7930",
    "Last Name": "Owen",
    "First Name": "Trish",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655378: {
    id: "item_7739",
    "Last Name": "Karpes",
    "First Name": "Dorin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655384: {
    id: "item_20338",
    "Last Name": "Moy",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655395: {
    id: "item_7737",
    "Last Name": "Acosta",
    "First Name": "Pamela",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655417: {
    id: "item_20337",
    "Last Name": "Soegiriawan",
    "First Name": "Soegiriawan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655426: {
    id: "item_20555",
    "Last Name": "Hunter",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655456: {
    id: "item_20553",
    "Last Name": "Li",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655479: {
    id: "item_7504",
    "Last Name": "NISHIMOTO",
    "First Name": "JAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655510: {
    id: "item_31447",
    "Last Name": "Thornton",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655594: {
    id: "item_20498",
    "Last Name": "Jones",
    "First Name": "Mery",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655674: {
    id: "item_20696",
    "Last Name": "Thorn",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655688: {
    id: "item_20497",
    "Last Name": "Whybrow",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655689: {
    id: "item_33034",
    "Last Name": "Pothugunta",
    "First Name": "Santhosh Kumar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36655723: {
    id: "item_7732",
    "Last Name": "Beckmann",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656062: {
    id: "item_20695",
    "Last Name": "Mangkla",
    "First Name": "Bunchan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656111: {
    id: "item_7729",
    "Last Name": "Caminer",
    "First Name": "Nadya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656131: {
    id: "item_33019",
    "Last Name": "Terupo",
    "First Name": "Celine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656154: {
    id: "item_7728",
    "Last Name": "Duong Le",
    "First Name": "Hai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656182: {
    id: "item_31357",
    "Last Name": "Lee",
    "First Name": "Chengrui",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656186: {
    id: "item_20545",
    "Last Name": "Lay",
    "First Name": "Nofiana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656222: {
    id: "item_20495",
    "Last Name": "Roten",
    "First Name": "Markus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656226: {
    id: "item_7928",
    "Last Name": "Seville",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656287: {
    id: "item_7726",
    "Last Name": "Aynsley",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656308: {
    id: "item_31336",
    "Last Name": "Sankey",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656344: {
    id: "item_7724",
    "Last Name": "Gorman",
    "First Name": "Niall",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656407: {
    id: "item_7720",
    "Last Name": "Ryan-Enright",
    "First Name": "Diarmuid",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656447: {
    id: "item_7717",
    "Last Name": "Premkumar",
    "First Name": "Darshika",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656465: {
    id: "item_20541",
    "Last Name": "Supatthana",
    "First Name": "Suchanee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656474: {
    id: "item_7669",
    "Last Name": "Travill",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656513: {
    id: "item_7715",
    "Last Name": "McClelland",
    "First Name": "Ross",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656578: {
    id: "item_20494",
    "Last Name": "Travill",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656605: {
    id: "item_20492",
    "Last Name": "Fiore-Yatomi",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656679: {
    id: "item_7709",
    "Last Name": "Refalo",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656688: {
    id: "item_20334",
    "Last Name": "Whitmore",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656719: {
    id: "item_20493",
    "Last Name": "Adams",
    "First Name": "Jacqui",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36656822: {
    id: "item_20536",
    "Last Name": "Covell",
    "First Name": "Leah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36657145: {
    id: "item_20534",
    "Last Name": "Kemp",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36657215: {
    id: "item_7708",
    "Last Name": "Hitchcock",
    "First Name": "Ollie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36657322: {
    id: "item_7707",
    "Last Name": "Gee",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36657397: {
    id: "item_7706",
    "Last Name": "Devaux",
    "First Name": "Amelie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36657419: {
    id: "item_20528",
    "Last Name": "MOON",
    "First Name": "JUN SIK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36657486: {
    id: "item_31250",
    "Last Name": "BOHUI",
    "First Name": "FENG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36657605: {
    id: "item_31249",
    "Last Name": "Nabong",
    "First Name": "Ricardo Carl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36657815: {
    id: "item_33028",
    "Last Name": "Tang",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36658345: {
    id: "item_33026",
    "Last Name": "Nicolson",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36658548: {
    id: "item_7924",
    "Last Name": "Wols",
    "First Name": "Roslind",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659018: {
    id: "item_20692",
    "Last Name": "Glanzmann",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659065: {
    id: "item_31347",
    "Last Name": "Heilbron",
    "First Name": "Greg",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659077: {
    id: "item_20691",
    "Last Name": "Bailey",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659313: {
    id: "item_31248",
    "Last Name": "fernandez",
    "First Name": "gil breinard",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659323: {
    id: "item_31346",
    "Last Name": "Narkhede",
    "First Name": "Swapnil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659353: {
    id: "item_20522",
    "Last Name": "Coert",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659518: {
    id: "item_31344",
    "Last Name": "alouker",
    "First Name": "viktor",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659789: {
    id: "item_7498",
    "Last Name": "Rizki",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659796: {
    id: "item_20520",
    "Last Name": "Balido",
    "First Name": "Nathanael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36659799: {
    id: "item_7698",
    "Last Name": "Bailey",
    "First Name": "Julian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36660021: {
    id: "item_20330",
    "Last Name": "Wang",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36660113: {
    id: "item_7697",
    "Last Name": "Gelonesi",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36660226: {
    id: "item_7696",
    "Last Name": "Toole",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36660233: {
    id: "item_20518",
    "Last Name": "Skourmallas",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36660336: {
    id: "item_20517",
    "Last Name": "Jordan",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36660866: {
    id: "item_5771",
    "Last Name": "Greyling-Wells",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36660887: {
    id: "item_20689",
    "Last Name": "Breevaart",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36661139: {
    id: "item_20511",
    "Last Name": "Jareno",
    "First Name": "Victor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36661309: {
    id: "item_20328",
    "Last Name": "AKAZA",
    "First Name": "SHUNSUKE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36661379: {
    id: "item_7661",
    "Last Name": "Walker",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36661543: {
    id: "item_7690",
    "Last Name": "Nally",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36661552: {
    id: "item_20327",
    "Last Name": "Asistol",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36661601: {
    id: "item_33023",
    "Last Name": "Martens",
    "First Name": "Selina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36661671: {
    id: "item_20326",
    "Last Name": "Ugarte",
    "First Name": "Monica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36661705: {
    id: "item_7685",
    "Last Name": "Lee",
    "First Name": "Chatwin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36661811: {
    id: "item_20325",
    "Last Name": "Mulachela",
    "First Name": "Achmad Adhni",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662113: {
    id: "item_31445",
    "Last Name": "Queck",
    "First Name": "Kirsten",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662247: {
    id: "item_32963",
    "Last Name": "SIHITE",
    "First Name": "RUDIANTO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662287: {
    id: "item_33021",
    "Last Name": "Murray",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662298: {
    id: "item_31334",
    "Last Name": "Peterson",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662380: {
    id: "item_31333",
    "Last Name": "Hoggins",
    "First Name": "Rob",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662390: {
    id: "item_20489",
    "Last Name": "Vlemmix",
    "First Name": "Wilco",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662414: {
    id: "item_7678",
    "Last Name": "Lewis",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662422: {
    id: "item_7677",
    "Last Name": "Gulliver",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662600: {
    id: "item_20500",
    "Last Name": "Rusli",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662604: {
    id: "item_7674",
    "Last Name": "Walaszek",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662731: {
    id: "item_20499",
    "Last Name": "Green",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36662781: {
    id: "item_7672",
    "Last Name": "Cao",
    "First Name": "Bin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36663021: {
    id: "item_31338",
    "Last Name": "Ching Chuen",
    "First Name": "Chan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36663034: {
    id: "item_7656",
    "Last Name": "Wu",
    "First Name": "Lei",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36663058: {
    id: "item_20496",
    "Last Name": "Bergman",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36663081: {
    id: "item_7671",
    "Last Name": "Hickin",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36663158: {
    id: "item_31337",
    "Last Name": "Srivastava",
    "First Name": "Shuchi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36663330: {
    id: "item_33018",
    "Last Name": "Lagahit",
    "First Name": "Cherrielyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36663834: {
    id: "item_7668",
    "Last Name": "Liphan",
    "First Name": "Surasit",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36664674: {
    id: "item_33016",
    "Last Name": "Raju",
    "First Name": "Suresh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36666441: {
    id: "item_7495",
    "Last Name": "OH",
    "First Name": "MINJIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36669950: {
    id: "item_31246",
    "Last Name": "AI",
    "First Name": "FANG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36671624: {
    id: "item_7662",
    "Last Name": "Jabbour",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36672673: {
    id: "item_20490",
    "Last Name": "Sath",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36673734: {
    id: "item_20687",
    "Last Name": "Baines",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36674402: {
    id: "item_7659",
    "Last Name": "Maestri",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36674447: {
    id: "item_7658",
    "Last Name": "Webb",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36674477: {
    id: "item_31443",
    "Last Name": "Perry",
    "First Name": "Diane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36674611: {
    id: "item_7922",
    "Last Name": "Perry",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36674997: {
    id: "item_20685",
    "Last Name": "Matthews",
    "First Name": "karlee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36675044: {
    id: "item_7920",
    "Last Name": "Packer",
    "First Name": "Rod",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36675857: {
    id: "item_20487",
    "Last Name": "Ferreira",
    "First Name": "Zita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36676278: {
    id: "item_7654",
    "Last Name": "Arbabzadeh",
    "First Name": "Sina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36676884: {
    id: "item_7653",
    "Last Name": "Aguilar",
    "First Name": "Bob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36677136: {
    id: "item_7651",
    "Last Name": "Agelopoulos",
    "First Name": "Jim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36677186: {
    id: "item_7650",
    "Last Name": "Diaz",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36677432: {
    id: "item_7652",
    "Last Name": "Tuangthong",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36677531: {
    id: "item_20486",
    "Last Name": "Idrus",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36677807: {
    id: "item_20485",
    "Last Name": "Patch",
    "First Name": "Bethanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36677908: {
    id: "item_33013",
    "Last Name": "Saggu",
    "First Name": "Rav",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36678174: {
    id: "item_31442",
    "Last Name": "Diment",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36678207: {
    id: "item_31330",
    "Last Name": "Mcgahan",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36678300: {
    id: "item_7648",
    "Last Name": "Daehne",
    "First Name": "Julia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36678373: {
    id: "item_20480",
    "Last Name": "Niguidula Vila San Juan",
    "First Name": "Paula",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36678969: {
    id: "item_20478",
    "Last Name": "Riera",
    "First Name": "Emilie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36679149: {
    id: "item_7649",
    "Last Name": "Bourne",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36679410: {
    id: "item_7646",
    "Last Name": "Ortiz Segura",
    "First Name": "Esteban",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36680220: {
    id: "item_33012",
    "Last Name": "Kadam",
    "First Name": "Pushkar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36680293: {
    id: "item_20477",
    "Last Name": "Qiu",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36680399: {
    id: "item_20476",
    "Last Name": "Wilson",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36680530: {
    id: "item_20684",
    "Last Name": "Cox",
    "First Name": "Jim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36680591: {
    id: "item_20683",
    "Last Name": "Ortiz Segura",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36682068: {
    id: "item_7639",
    "Last Name": "ROBERTS",
    "First Name": "NIGEL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36682198: {
    id: "item_33010",
    "Last Name": "Aguilera",
    "First Name": "Elma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36682229: {
    id: "item_31328",
    "Last Name": "Nampally",
    "First Name": "Raghu Varma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36682453: {
    id: "item_31327",
    "Last Name": "VENKATASUBRAMANIAN",
    "First Name": "DIVYA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36682653: {
    id: "item_31244",
    "Last Name": "Rogozinski",
    "First Name": "Keith",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36683300: {
    id: "item_7636",
    "Last Name": "Taylor",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36683586: {
    id: "item_20482",
    "Last Name": "Erriad",
    "First Name": "Radinka",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36683695: {
    id: "item_7634",
    "Last Name": "Badenhorst",
    "First Name": "Cathryn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36683755: {
    id: "item_7633",
    "Last Name": "Faulkner",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36684847: {
    id: "item_20469",
    "Last Name": "Marjanovic",
    "First Name": "Nikola",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36686394: {
    id: "item_7630",
    "Last Name": "McDonell",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36686914: {
    id: "item_20464",
    "Last Name": "Lovarini",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36687095: {
    id: "item_20463",
    "Last Name": "Scanlon",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36687179: {
    id: "item_20462",
    "Last Name": "Hutt",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36687431: {
    id: "item_7492",
    "Last Name": "Kwok",
    "First Name": "Ho Ming",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36687601: {
    id: "item_33009",
    "Last Name": "Swaminathan",
    "First Name": "Gurusubramanian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36688181: {
    id: "item_31323",
    "Last Name": "Balagtas",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36688655: {
    id: "item_31322",
    "Last Name": "Ng",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36688806: {
    id: "item_20459",
    "Last Name": "Purcell",
    "First Name": "Jo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36688835: {
    id: "item_7622",
    "Last Name": "Stadnik",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36688978: {
    id: "item_20479",
    "Last Name": "Schaeffer",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36689098: {
    id: "item_5767",
    "Last Name": "Carter",
    "First Name": "Theresa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36689109: {
    id: "item_31320",
    "Last Name": "Christophorou",
    "First Name": "Danniella",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36689242: {
    id: "item_32960",
    "Last Name": "Escala",
    "First Name": "Marissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36689751: {
    id: "item_20675",
    "Last Name": "Craig",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36689776: {
    id: "item_7621",
    "Last Name": "Johnson",
    "First Name": "Breannan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36689809: {
    id: "item_7490",
    "Last Name": "YUZAKI",
    "First Name": "MARIKO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36690896: {
    id: "item_32959",
    "Last Name": "Japadermawan",
    "First Name": "Barry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36691040: {
    id: "item_33079",
    "Last Name": "Chiringa",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36691197: {
    id: "item_31319",
    "Last Name": "xayabouth",
    "First Name": "kevin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36691251: {
    id: "item_7619",
    "Last Name": "Koo",
    "First Name": "Jhett",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36691669: {
    id: "item_7617",
    "Last Name": "Hackett-Evans",
    "First Name": "Bryony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36691754: {
    id: "item_31329",
    "Last Name": "Cook",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36691765: {
    id: "item_7616",
    "Last Name": "Wilson",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36691794: {
    id: "item_7615",
    "Last Name": "Guevarra",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36692281: {
    id: "item_33076",
    "Last Name": "Rodriguez",
    "First Name": "Saroja",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36692329: {
    id: "item_20454",
    "Last Name": "Kang",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36694573: {
    id: "item_7918",
    "Last Name": "Clough",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36694661: {
    id: "item_31242",
    "Last Name": "Castro",
    "First Name": "Allan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36694791: {
    id: "item_7487",
    "Last Name": "Wong",
    "First Name": "Jye Yau",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36695406: {
    id: "item_7486",
    "Last Name": "Rodriguez",
    "First Name": "Klymille keilah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36698972: {
    id: "item_20453",
    "Last Name": "Le",
    "First Name": "Tu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36700288: {
    id: "item_32957",
    "Last Name": "ZHAO",
    "First Name": "YING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36705584: {
    id: "item_7485",
    "Last Name": "Park",
    "First Name": "Sangcheol",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36711197: {
    id: "item_7484",
    "Last Name": "Lin",
    "First Name": "Jin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36712079: {
    id: "item_31316",
    "Last Name": "Field",
    "First Name": "Paige",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36712971: {
    id: "item_20450",
    "Last Name": "Chamberlain",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36713253: {
    id: "item_20449",
    "Last Name": "Timmins",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36713311: {
    id: "item_20448",
    "Last Name": "DEVELIN",
    "First Name": "REBECCA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36713907: {
    id: "item_20447",
    "Last Name": "Johns",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36714694: {
    id: "item_7611",
    "Last Name": "Singh",
    "First Name": "Harkanwalpreet",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36714861: {
    id: "item_7610",
    "Last Name": "Cornwell",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36715129: {
    id: "item_18580",
    "Last Name": "Byrnes",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36715233: {
    id: "item_7643",
    "Last Name": "Gabrisch",
    "First Name": "Taylah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36715357: {
    id: "item_31315",
    "Last Name": "Hukins",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36716769: {
    id: "item_20440",
    "Last Name": "Pilleri Cheleri",
    "First Name": "Sampreeth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36716900: {
    id: "item_7606",
    "Last Name": "Torres",
    "First Name": "Richmond",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36716918: {
    id: "item_31312",
    "Last Name": "Crellin",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36717106: {
    id: "item_7913",
    "Last Name": "Devitt",
    "First Name": "Julia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36717158: {
    id: "item_20672",
    "Last Name": "Martin",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36717263: {
    id: "item_7912",
    "Last Name": "Swaby",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36717293: {
    id: "item_33075",
    "Last Name": "Wells",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36717426: {
    id: "item_31311",
    "Last Name": "chen",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36717639: {
    id: "item_20309",
    "Last Name": "Kume",
    "First Name": "Ranko",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36718054: {
    id: "item_7641",
    "Last Name": "Debenham",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36718131: {
    id: "item_31309",
    "Last Name": "Sharma",
    "First Name": "Nagesh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36718209: {
    id: "item_7600",
    "Last Name": "McNabb",
    "First Name": "Garry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36718671: {
    id: "item_20437",
    "Last Name": "Tng",
    "First Name": "Matthias",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36718797: {
    id: "item_7599",
    "Last Name": "Crocker",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36718840: {
    id: "item_31308",
    "Last Name": "Dragunow",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36718925: {
    id: "item_31240",
    "Last Name": "Kennedy",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36718961: {
    id: "item_31437",
    "Last Name": "Norgard",
    "First Name": "Anne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36719047: {
    id: "item_7595",
    "Last Name": "Shrestha",
    "First Name": "Bijaya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36719334: {
    id: "item_31436",
    "Last Name": "Norgard",
    "First Name": "Garry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36719551: {
    id: "item_31307",
    "Last Name": "Wood",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36719720: {
    id: "item_7640",
    "Last Name": "OConnor",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36721138: {
    id: "item_20307",
    "Last Name": "DAVIDSON",
    "First Name": "HANNA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36721146: {
    id: "item_7638",
    "Last Name": "Chew",
    "First Name": "Leon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36721261: {
    id: "item_20431",
    "Last Name": "Lucas",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36721939: {
    id: "item_20428",
    "Last Name": "Fowler",
    "First Name": "Jackie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36721958: {
    id: "item_32997",
    "Last Name": "Nguyen",
    "First Name": "Duc",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36722248: {
    id: "item_7587",
    "Last Name": "van Meeteren",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36722393: {
    id: "item_32996",
    "Last Name": "LIM",
    "First Name": "GIM SHING ROLAND",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36722486: {
    id: "item_7586",
    "Last Name": "Mallinson",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36722516: {
    id: "item_32994",
    "Last Name": "Kelly",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36722820: {
    id: "item_7911",
    "Last Name": "Dobbins",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36723145: {
    id: "item_5763",
    "Last Name": "Brettell",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36723228: {
    id: "item_20423",
    "Last Name": "Flint",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36723609: {
    id: "item_20420",
    "Last Name": "Li",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36723832: {
    id: "item_7580",
    "Last Name": "Taylor",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36724202: {
    id: "item_7637",
    "Last Name": "Ochirbat",
    "First Name": "Batjargal",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36724297: {
    id: "item_31238",
    "Last Name": "Jimeno",
    "First Name": "Allain",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36724848: {
    id: "item_7577",
    "Last Name": "Byron",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36724990: {
    id: "item_7575",
    "Last Name": "Campbell",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725068: {
    id: "item_20414",
    "Last Name": "Pope",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725167: {
    id: "item_20473",
    "Last Name": "Kelly",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725207: {
    id: "item_7574",
    "Last Name": "Barrett",
    "First Name": "Salil",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725237: {
    id: "item_20472",
    "Last Name": "Jeanes",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725510: {
    id: "item_33073",
    "Last Name": "Simshauser",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725533: {
    id: "item_7572",
    "Last Name": "Jacquart",
    "First Name": "Gaetan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725670: {
    id: "item_7635",
    "Last Name": "Kona",
    "First Name": "Thembani",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725750: {
    id: "item_31326",
    "Last Name": "Rainbird",
    "First Name": "Birgit",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725778: {
    id: "item_7569",
    "Last Name": "Cleary",
    "First Name": "Mick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725796: {
    id: "item_20410",
    "Last Name": "Murray",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725882: {
    id: "item_7567",
    "Last Name": "Mikirtoumov",
    "First Name": "Sasha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36725925: {
    id: "item_31298",
    "Last Name": "Jackson",
    "First Name": "Karin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726177: {
    id: "item_31237",
    "Last Name": "Sarungu",
    "First Name": "Panca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726239: {
    id: "item_7564",
    "Last Name": "Kwong",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726317: {
    id: "item_7562",
    "Last Name": "Pyke",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726338: {
    id: "item_32955",
    "Last Name": "LI",
    "First Name": "XI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726551: {
    id: "item_20404",
    "Last Name": "Davies",
    "First Name": "Allan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726582: {
    id: "item_31295",
    "Last Name": "Arifin",
    "First Name": "Arifin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726655: {
    id: "item_20402",
    "Last Name": "Macaspac",
    "First Name": "Jenny Claire",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726701: {
    id: "item_7558",
    "Last Name": "Duncan",
    "First Name": "Clarissa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726714: {
    id: "item_7631",
    "Last Name": "Keereman",
    "First Name": "Pepijn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726793: {
    id: "item_20400",
    "Last Name": "Wyndham",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726825: {
    id: "item_31293",
    "Last Name": "Huang",
    "First Name": "Chung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726862: {
    id: "item_32983",
    "Last Name": "Fraser",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726872: {
    id: "item_20466",
    "Last Name": "Cross",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726916: {
    id: "item_20395",
    "Last Name": "Macapagal",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36726966: {
    id: "item_31289",
    "Last Name": "METTER",
    "First Name": "Sabrina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727023: {
    id: "item_7554",
    "Last Name": "Nievergelt",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727085: {
    id: "item_7628",
    "Last Name": "Buccella",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727100: {
    id: "item_20461",
    "Last Name": "Heang",
    "First Name": "Keo Kasey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727112: {
    id: "item_7553",
    "Last Name": "Peace",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727149: {
    id: "item_20670",
    "Last Name": "Jara",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727174: {
    id: "item_7552",
    "Last Name": "Curtis",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727175: {
    id: "item_7551",
    "Last Name": "Curtis",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727244: {
    id: "item_7550",
    "Last Name": "McDonald",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727309: {
    id: "item_7627",
    "Last Name": "Feely",
    "First Name": "Olwyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727314: {
    id: "item_7548",
    "Last Name": "Lantelme",
    "First Name": "Matteo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727345: {
    id: "item_31284",
    "Last Name": "Casta–eda Barboza",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727409: {
    id: "item_31431",
    "Last Name": "Wirrell",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727431: {
    id: "item_31283",
    "Last Name": "Black",
    "First Name": "Xanthe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727441: {
    id: "item_20460",
    "Last Name": "Looby",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727662: {
    id: "item_20385",
    "Last Name": "White",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727760: {
    id: "item_31324",
    "Last Name": "Yang",
    "First Name": "Jung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727887: {
    id: "item_7542",
    "Last Name": "Castres",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36727967: {
    id: "item_7541",
    "Last Name": "Wen",
    "First Name": "Philip",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36728067: {
    id: "item_31282",
    "Last Name": "Shen",
    "First Name": "Amy S.",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36728136: {
    id: "item_7540",
    "Last Name": "Liong",
    "First Name": "Shawn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36728232: {
    id: "item_31281",
    "Last Name": "Lauretti",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36728463: {
    id: "item_7539",
    "Last Name": "Walker",
    "First Name": "Linsey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36728486: {
    id: "item_7538",
    "Last Name": "Smith",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36728619: {
    id: "item_5761",
    "Last Name": "Haynes",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36728752: {
    id: "item_7536",
    "Last Name": "Haynes",
    "First Name": "Meg",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36729416: {
    id: "item_31278",
    "Last Name": "Chen",
    "First Name": "Chen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36729685: {
    id: "item_31277",
    "Last Name": "Song",
    "First Name": "Yichun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36732219: {
    id: "item_7534",
    "Last Name": "MacDougall",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36732293: {
    id: "item_20304",
    "Last Name": "Lao Emperador",
    "First Name": "Joanna Pauline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36733988: {
    id: "item_32951",
    "Last Name": "Yuan",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36734187: {
    id: "item_33006",
    "Last Name": "Li",
    "First Name": "Galee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36737473: {
    id: "item_31234",
    "Last Name": "Sembel",
    "First Name": "Roy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36739393: {
    id: "item_7531",
    "Last Name": "Perera",
    "First Name": "Galhenage Pasan Nuwinda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36740030: {
    id: "item_31275",
    "Last Name": "Warmerdam",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36742488: {
    id: "item_7477",
    "Last Name": "Haugh",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36743012: {
    id: "item_7476",
    "Last Name": "Mita",
    "First Name": "Kiyomi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36743882: {
    id: "item_7529",
    "Last Name": "Wilson",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36745804: {
    id: "item_7528",
    "Last Name": "Jenkins",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36748900: {
    id: "item_31233",
    "Last Name": "Loxas",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36750313: {
    id: "item_20668",
    "Last Name": "Cornelius",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36751834: {
    id: "item_31321",
    "Last Name": "Nakamura",
    "First Name": "Shelly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36752395: {
    id: "item_20376",
    "Last Name": "Currie",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36753277: {
    id: "item_20373",
    "Last Name": "O'Connor",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36754001: {
    id: "item_20372",
    "Last Name": "Kozak-King",
    "First Name": "Hanna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36754308: {
    id: "item_31271",
    "Last Name": "Justino",
    "First Name": "Daiane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36754549: {
    id: "item_7903",
    "Last Name": "Abdolhoseini",
    "First Name": "Mahmoud",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36754785: {
    id: "item_20370",
    "Last Name": "Shoniwa",
    "First Name": "Lionel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36755200: {
    id: "item_7902",
    "Last Name": "Gardner",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36755606: {
    id: "item_20458",
    "Last Name": "Pearson",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36755631: {
    id: "item_20667",
    "Last Name": "Henshaw",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36755862: {
    id: "item_7523",
    "Last Name": "Dolera",
    "First Name": "Michele",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36756134: {
    id: "item_31269",
    "Last Name": "Savla",
    "First Name": "Ronak",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36756351: {
    id: "item_31267",
    "Last Name": "Vongxayasy",
    "First Name": "Vanh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36756743: {
    id: "item_5766",
    "Last Name": "Ulum",
    "First Name": "Ali",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36757124: {
    id: "item_20364",
    "Last Name": "Cohen",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36757340: {
    id: "item_31430",
    "Last Name": "Lorenz",
    "First Name": "Eva",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36757393: {
    id: "item_7518",
    "Last Name": "Baird",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36757399: {
    id: "item_31429",
    "Last Name": "Rodriguez",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36757914: {
    id: "item_7517",
    "Last Name": "Nghiem",
    "First Name": "Doan Danny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36758387: {
    id: "item_20363",
    "Last Name": "Bluett",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36758747: {
    id: "item_7620",
    "Last Name": "Chellappah",
    "First Name": "Nihilesh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36758893: {
    id: "item_7474",
    "Last Name": "Li",
    "First Name": "Wai Sum",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36759183: {
    id: "item_18579",
    "Last Name": "Cooper",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36759337: {
    id: "item_7515",
    "Last Name": "Graham",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36759367: {
    id: "item_33072",
    "Last Name": "Tudjman",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36759435: {
    id: "item_20457",
    "Last Name": "Felton",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36759630: {
    id: "item_20361",
    "Last Name": "Truong",
    "First Name": "Rick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36759705: {
    id: "item_20360",
    "Last Name": "Thomas",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36760167: {
    id: "item_20359",
    "Last Name": "Bishop",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36760745: {
    id: "item_31262",
    "Last Name": "Ali",
    "First Name": "Naaz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36761400: {
    id: "item_20356",
    "Last Name": "Anos",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36762272: {
    id: "item_20351",
    "Last Name": "Xu",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36762535: {
    id: "item_32967",
    "Last Name": "Lim",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36763712: {
    id: "item_7508",
    "Last Name": "De Groote",
    "First Name": "Sander",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36764737: {
    id: "item_31256",
    "Last Name": "Tiller",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36765240: {
    id: "item_20345",
    "Last Name": "lacey",
    "First Name": "richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36765793: {
    id: "item_7505",
    "Last Name": "Goater",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36766407: {
    id: "item_31230",
    "Last Name": "Song",
    "First Name": "Ming",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36766899: {
    id: "item_20299",
    "Last Name": "_",
    "First Name": "_",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36767193: {
    id: "item_20335",
    "Last Name": "Dagan",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36767448: {
    id: "item_7503",
    "Last Name": "Hume",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36768606: {
    id: "item_32965",
    "Last Name": "Fletcher",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36768754: {
    id: "item_7502",
    "Last Name": "Steer",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36768973: {
    id: "item_7501",
    "Last Name": "jones",
    "First Name": "lesly",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36769280: {
    id: "item_7500",
    "Last Name": "Shaw",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36769436: {
    id: "item_33005",
    "Last Name": "Healy",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36769466: {
    id: "item_20333",
    "Last Name": "Garth",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36769608: {
    id: "item_20456",
    "Last Name": "Quinn",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36770053: {
    id: "item_5758",
    "Last Name": "Wellings",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36770548: {
    id: "item_7499",
    "Last Name": "Poole",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36770740: {
    id: "item_33094",
    "Last Name": "Ambagahawattage",
    "First Name": "Malsha Salini Kariyawasam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36770772: {
    id: "item_7497",
    "Last Name": "Richardson",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36770986: {
    id: "item_20298",
    "Last Name": "LIU",
    "First Name": "JIBO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36771211: {
    id: "item_32964",
    "Last Name": "Hartley",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36771411: {
    id: "item_7496",
    "Last Name": "Tyson",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36771427: {
    id: "item_31476",
    "Last Name": "Khoo",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36771979: {
    id: "item_31247",
    "Last Name": "Bullard",
    "First Name": "Colin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36772274: {
    id: "item_32962",
    "Last Name": "Sutek",
    "First Name": "Mary",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36773158: {
    id: "item_20321",
    "Last Name": "Baneres",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36774641: {
    id: "item_7493",
    "Last Name": "Bennetto",
    "First Name": "Dale",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36774706: {
    id: "item_31245",
    "Last Name": "Alvarez",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36774875: {
    id: "item_32961",
    "Last Name": "Dizon",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36778797: {
    id: "item_20455",
    "Last Name": "McConnell",
    "First Name": "Keely",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36779368: {
    id: "item_20318",
    "Last Name": "Colosimo",
    "First Name": "Julius",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36779399: {
    id: "item_7489",
    "Last Name": "Simpkins",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36779446: {
    id: "item_31243",
    "Last Name": "Torio",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36779608: {
    id: "item_20317",
    "Last Name": "Opie",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36783734: {
    id: "item_20314",
    "Last Name": "Guiam",
    "First Name": "Marivic",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36783978: {
    id: "item_32958",
    "Last Name": "Santos",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36784307: {
    id: "item_32956",
    "Last Name": "Li",
    "First Name": "Jiacheng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36784376: {
    id: "item_7900",
    "Last Name": "Koster",
    "First Name": "Grace",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785292: {
    id: "item_31229",
    "Last Name": "wongkittipat",
    "First Name": "palang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785424: {
    id: "item_31228",
    "Last Name": "NAMTHONG",
    "First Name": "WINAI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785428: {
    id: "item_31239",
    "Last Name": "Huang",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785544: {
    id: "item_32949",
    "Last Name": "NAMTHONG",
    "First Name": "SUKANYA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785587: {
    id: "item_31236",
    "Last Name": "XU",
    "First Name": "Haiyang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785682: {
    id: "item_32954",
    "Last Name": "Savla",
    "First Name": "Sonal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785720: {
    id: "item_7480",
    "Last Name": "Franklin",
    "First Name": "Michaella",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785762: {
    id: "item_7478",
    "Last Name": "Foord",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785767: {
    id: "item_32947",
    "Last Name": "ZENG",
    "First Name": "QIAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785774: {
    id: "item_32953",
    "Last Name": "Kavanagh",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785781: {
    id: "item_32948",
    "Last Name": "Cartasano",
    "First Name": "Jaclyn Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785820: {
    id: "item_20303",
    "Last Name": "Sandjojo",
    "First Name": "Yulie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785849: {
    id: "item_20302",
    "Last Name": "Gaddi",
    "First Name": "Gilbert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785870: {
    id: "item_7475",
    "Last Name": "Marshall",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36785890: {
    id: "item_20301",
    "Last Name": "Lowe",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786021: {
    id: "item_18582",
    "Last Name": "Oo",
    "First Name": "Myint Mo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786048: {
    id: "item_7926",
    "Last Name": "Ching",
    "First Name": "Cellina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786061: {
    id: "item_7925",
    "Last Name": "Ho",
    "First Name": "Hui Ping",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786105: {
    id: "item_7613",
    "Last Name": "Young",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786118: {
    id: "item_20693",
    "Last Name": "Harriman",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786203: {
    id: "item_20690",
    "Last Name": "Barker",
    "First Name": "Robbie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786248: {
    id: "item_20688",
    "Last Name": "Dudley",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786303: {
    id: "item_33082",
    "Last Name": "Stevens",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786306: {
    id: "item_20452",
    "Last Name": "Thai",
    "First Name": "Hilton",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786323: {
    id: "item_31444",
    "Last Name": "Dumanon",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786374: {
    id: "item_32946",
    "Last Name": "Padriquela",
    "First Name": "Basilisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786430: {
    id: "item_31426",
    "Last Name": "McDermid",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786446: {
    id: "item_7921",
    "Last Name": "Hong",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786496: {
    id: "item_32945",
    "Last Name": "HAGORILES",
    "First Name": "KATHRINA VANESSA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786524: {
    id: "item_33080",
    "Last Name": "Jomkamsing",
    "First Name": "Prachya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786534: {
    id: "item_32944",
    "Last Name": "Yanson",
    "First Name": "Melieve Mirasol",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786589: {
    id: "item_33070",
    "Last Name": "Dawes",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786600: {
    id: "item_20682",
    "Last Name": "Worgan",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786612: {
    id: "item_20681",
    "Last Name": "Paris",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786613: {
    id: "item_20679",
    "Last Name": "Brener",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786626: {
    id: "item_31227",
    "Last Name": "Pastor",
    "First Name": "Pauline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786643: {
    id: "item_20678",
    "Last Name": "Ham",
    "First Name": "Esther",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786725: {
    id: "item_20677",
    "Last Name": "Burgin",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786763: {
    id: "item_20676",
    "Last Name": "Potkonjak",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786780: {
    id: "item_7919",
    "Last Name": "TRUONG",
    "First Name": "Tu Do",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786826: {
    id: "item_32943",
    "Last Name": "BAUTISTA",
    "First Name": "GLECIALIE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786840: {
    id: "item_20446",
    "Last Name": "Diep",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786845: {
    id: "item_31440",
    "Last Name": "Liang",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786865: {
    id: "item_33078",
    "Last Name": "Joshi",
    "First Name": "Anand",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786886: {
    id: "item_33093",
    "Last Name": "Amaratunga",
    "First Name": "Hashan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786896: {
    id: "item_20673",
    "Last Name": "Bawden",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36786898: {
    id: "item_20674",
    "Last Name": "Siso",
    "First Name": "Grant keithley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36787021: {
    id: "item_7917",
    "Last Name": "Nguyen",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36787117: {
    id: "item_7915",
    "Last Name": "Cheung",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36787174: {
    id: "item_7914",
    "Last Name": "Thomson",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36787292: {
    id: "item_31438",
    "Last Name": "Agustian",
    "First Name": "Andree",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36787456: {
    id: "item_7910",
    "Last Name": "Nathanael",
    "First Name": "Mercy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36787457: {
    id: "item_33074",
    "Last Name": "Shrestha",
    "First Name": "Pratik",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36787644: {
    id: "item_20671",
    "Last Name": "Lu",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928298: {
    id: "item_33106",
    "Last Name": "Okazaki",
    "First Name": "Leo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928340: {
    id: "item_20734",
    "Last Name": "Chainani",
    "First Name": "Sunil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928362: {
    id: "item_7965",
    "Last Name": "Chapman",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928417: {
    id: "item_33107",
    "Last Name": "Chang",
    "First Name": "Lecquia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928496: {
    id: "item_7966",
    "Last Name": "Shaw",
    "First Name": "Jayden",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928511: {
    id: "item_31467",
    "Last Name": "Murfet",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928555: {
    id: "item_31468",
    "Last Name": "Dean",
    "First Name": "Erica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928557: {
    id: "item_7968",
    "Last Name": "Molloy",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928562: {
    id: "item_7967",
    "Last Name": "Regan",
    "First Name": "Remy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928718: {
    id: "item_20735",
    "Last Name": "Feng",
    "First Name": "Weiwei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928759: {
    id: "item_20736",
    "Last Name": "Daly",
    "First Name": "Lorraine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928830: {
    id: "item_20737",
    "Last Name": "Realph",
    "First Name": "Tegan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928845: {
    id: "item_7969",
    "Last Name": "Smith",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928950: {
    id: "item_20738",
    "Last Name": "Parfenova",
    "First Name": "Janna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36928968: {
    id: "item_20739",
    "Last Name": "Rethamel",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36929175: {
    id: "item_5784",
    "Last Name": "Marquez",
    "First Name": "Louie Francis Glodoviza",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36929197: {
    id: "item_7970",
    "Last Name": "Houvardas",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36929232: {
    id: "item_31469",
    "Last Name": "Hutapea",
    "First Name": "Fabio Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36929278: {
    id: "item_20740",
    "Last Name": "Citra",
    "First Name": "Devina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36929621: {
    id: "item_7971",
    "Last Name": "Tan",
    "First Name": "Wei Ling",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36929662: {
    id: "item_7972",
    "Last Name": "OÕDonnell",
    "First Name": "Ronan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36929753: {
    id: "item_7973",
    "Last Name": "Limanto",
    "First Name": "Felisia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36929846: {
    id: "item_33108",
    "Last Name": "YUNITA",
    "First Name": "EKA PUTRI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36930188: {
    id: "item_20741",
    "Last Name": "Ford",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36930262: {
    id: "item_31470",
    "Last Name": "Valmonte",
    "First Name": "Joseph Alden",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36930278: {
    id: "item_33109",
    "Last Name": "Febriyanti",
    "First Name": "Yani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36930364: {
    id: "item_33110",
    "Last Name": "Wong",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36930975: {
    id: "item_7974",
    "Last Name": "Laister",
    "First Name": "Jakob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36931048: {
    id: "item_7975",
    "Last Name": "Wong",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36931599: {
    id: "item_33111",
    "Last Name": "Zhou",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36931962: {
    id: "item_20742",
    "Last Name": "Gil Alcala",
    "First Name": "Arianna Rebeca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36939977: {
    id: "item_20744",
    "Last Name": "TIAN",
    "First Name": "HONGQIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36940707: {
    id: "item_31471",
    "Last Name": "CHARTPISARN",
    "First Name": "MATEE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36940992: {
    id: "item_20745",
    "Last Name": "Yapinus",
    "First Name": "Elbern",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36941065: {
    id: "item_31472",
    "Last Name": "Zhang",
    "First Name": "Lydia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36941166: {
    id: "item_31473",
    "Last Name": "Lim",
    "First Name": "Sze Yin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36941256: {
    id: "item_7976",
    "Last Name": "Dix",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36941482: {
    id: "item_31474",
    "Last Name": "Dourado",
    "First Name": "Steffi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36941617: {
    id: "item_31475",
    "Last Name": "WANG",
    "First Name": "XIAOROU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36941967: {
    id: "item_33112",
    "Last Name": "Cantrell",
    "First Name": "Annemarie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36942027: {
    id: "item_7977",
    "Last Name": "SHIMIZU",
    "First Name": "YASUO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  36943307: {
    id: "item_5785",
    "Last Name": "Sarajan",
    "First Name": "Mohammad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37092855: {
    id: "item_20746",
    "Last Name": "Openshaw",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37099130: {
    id: "item_7978",
    "Last Name": "Taylor",
    "First Name": "Yael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37101174: {
    id: "item_33113",
    "Last Name": "Phan",
    "First Name": "Ngoc Cam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37115208: {
    id: "item_7979",
    "Last Name": "Gehrels",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37115460: {
    id: "item_7980",
    "Last Name": "ARIFFIN",
    "First Name": "MOHD ASRIE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37115461: {
    id: "item_20747",
    "Last Name": "Uyeda",
    "First Name": "Ayumi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37115696: {
    id: "item_7981",
    "Last Name": "Pelaez Botero",
    "First Name": "Marcelo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37116402: {
    id: "item_7982",
    "Last Name": "Karonga",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144655: {
    id: "item_19390",
    "Last Name": "Jukic",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144697: {
    id: "item_18900",
    "Last Name": "Zhong",
    "First Name": "Xiao",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144761: {
    id: "item_8722",
    "Last Name": "Roy",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144766: {
    id: "item_8723",
    "Last Name": "Myers",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144790: {
    id: "item_6275",
    "Last Name": "Ahn",
    "First Name": "Do Hyun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144806: {
    id: "item_18899",
    "Last Name": "Wedesweiler",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144808: {
    id: "item_19389",
    "Last Name": "McAulay",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144814: {
    id: "item_32102",
    "Last Name": "Ochi",
    "First Name": "Kanami",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144819: {
    id: "item_6274",
    "Last Name": "Jacks",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144835: {
    id: "item_18896",
    "Last Name": "Dickens",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144865: {
    id: "item_21372",
    "Last Name": "Lopez",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144872: {
    id: "item_6273",
    "Last Name": "Garratt",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144880: {
    id: "item_21324",
    "Last Name": "Burford",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144885: {
    id: "item_6269",
    "Last Name": "James-Wallace",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144887: {
    id: "item_6272",
    "Last Name": "Tortorella",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144902: {
    id: "item_18898",
    "Last Name": "Croser",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144908: {
    id: "item_18891",
    "Last Name": "Do",
    "First Name": "Hue Chi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144909: {
    id: "item_6268",
    "Last Name": "van den Eijnden",
    "First Name": "Wout",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144911: {
    id: "item_6271",
    "Last Name": "Elford",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144915: {
    id: "item_8720",
    "Last Name": "Apablaza",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144919: {
    id: "item_6267",
    "Last Name": "McLaren",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144920: {
    id: "item_18897",
    "Last Name": "Vasudivan",
    "First Name": "Vanisha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144926: {
    id: "item_6270",
    "Last Name": "Goodhew",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144931: {
    id: "item_8721",
    "Last Name": "Bist",
    "First Name": "Veneet",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144935: {
    id: "item_21323",
    "Last Name": "Castaneda",
    "First Name": "Francis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144937: {
    id: "item_18893",
    "Last Name": "McKay-Lowndes",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144939: {
    id: "item_18894",
    "Last Name": "Duffell",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144944: {
    id: "item_18881",
    "Last Name": "Hannan",
    "First Name": "Sharn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144946: {
    id: "item_18895",
    "Last Name": "Montoya",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144964: {
    id: "item_33753",
    "Last Name": "Ballance",
    "First Name": "Randal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144970: {
    id: "item_6266",
    "Last Name": "Lynch",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37144983: {
    id: "item_18892",
    "Last Name": "Langford",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145001: {
    id: "item_21322",
    "Last Name": "Tirivanhu",
    "First Name": "Tendai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145003: {
    id: "item_6265",
    "Last Name": "Hutchinson",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145006: {
    id: "item_8719",
    "Last Name": "Bisko",
    "First Name": "Mateo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145007: {
    id: "item_18890",
    "Last Name": "Creelman",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145016: {
    id: "item_18887",
    "Last Name": "Pitcairn",
    "First Name": "Zygan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145022: {
    id: "item_18889",
    "Last Name": "O'Shea",
    "First Name": "Benedick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145030: {
    id: "item_6259",
    "Last Name": "Sahyoune",
    "First Name": "Marcel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145055: {
    id: "item_18868",
    "Last Name": "Moseley",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145061: {
    id: "item_6220",
    "Last Name": "Meadows",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145063: {
    id: "item_18888",
    "Last Name": "Jones",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145064: {
    id: "item_6263",
    "Last Name": "Bramwell",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145067: {
    id: "item_6262",
    "Last Name": "Kerr",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145069: {
    id: "item_18886",
    "Last Name": "Lam",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145073: {
    id: "item_33752",
    "Last Name": "Arumugam",
    "First Name": "Sunilkumar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145078: {
    id: "item_6239",
    "Last Name": "Stobbs",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145079: {
    id: "item_18882",
    "Last Name": "Sheridan",
    "First Name": "Alfie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145085: {
    id: "item_6264",
    "Last Name": "MOOHIN",
    "First Name": "DARREN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145104: {
    id: "item_18879",
    "Last Name": "Olivers",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145108: {
    id: "item_32101",
    "Last Name": "Holmes",
    "First Name": "Sheryl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145109: {
    id: "item_18885",
    "Last Name": "Nguyen",
    "First Name": "Cuong Manh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145112: {
    id: "item_6260",
    "Last Name": "antoon",
    "First Name": "mikhaela",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145115: {
    id: "item_8715",
    "Last Name": "Preston",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145123: {
    id: "item_18877",
    "Last Name": "Gatus",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145131: {
    id: "item_32092",
    "Last Name": "Howden",
    "First Name": "Ava",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145132: {
    id: "item_18869",
    "Last Name": "Andres Roig",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145135: {
    id: "item_18870",
    "Last Name": "Pablo-Torres Jimenez",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145140: {
    id: "item_18874",
    "Last Name": "Chi",
    "First Name": "Carina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145142: {
    id: "item_18839",
    "Last Name": "Morrison",
    "First Name": "Corbie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145155: {
    id: "item_21321",
    "Last Name": "Curry",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145167: {
    id: "item_33748",
    "Last Name": "Kakarla",
    "First Name": "Arun Kumar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145173: {
    id: "item_6253",
    "Last Name": "Vlahandreas",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145174: {
    id: "item_18872",
    "Last Name": "LE",
    "First Name": "DIANA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145175: {
    id: "item_6243",
    "Last Name": "Altmann",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145176: {
    id: "item_6247",
    "Last Name": "Fernandez",
    "First Name": "Duwian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145192: {
    id: "item_21320",
    "Last Name": "Rounds",
    "First Name": "Ashlee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145208: {
    id: "item_6258",
    "Last Name": "Sukke",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145224: {
    id: "item_6575",
    "Last Name": "Gill",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145226: {
    id: "item_6255",
    "Last Name": "Felauer",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145232: {
    id: "item_6234",
    "Last Name": "Fajardo",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145234: {
    id: "item_6252",
    "Last Name": "Saunders",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145235: {
    id: "item_6257",
    "Last Name": "Condipodero",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145236: {
    id: "item_18871",
    "Last Name": "Prasad",
    "First Name": "Aman",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145238: {
    id: "item_18867",
    "Last Name": "Scherbeijn",
    "First Name": "Lieke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145248: {
    id: "item_18861",
    "Last Name": "Sazali",
    "First Name": "Sufian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145263: {
    id: "item_21318",
    "Last Name": "Wong",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145269: {
    id: "item_18860",
    "Last Name": "Dimitropoulos",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145279: {
    id: "item_6254",
    "Last Name": "Edwards",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145285: {
    id: "item_8709",
    "Last Name": "Silvester",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145287: {
    id: "item_18858",
    "Last Name": "Fedoruk",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145288: {
    id: "item_6248",
    "Last Name": "Garganis",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145290: {
    id: "item_8714",
    "Last Name": "Ciftcioglu",
    "First Name": "Nev",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145296: {
    id: "item_6246",
    "Last Name": "McCarthy",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145310: {
    id: "item_18863",
    "Last Name": "Easton",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145317: {
    id: "item_33729",
    "Last Name": "kim",
    "First Name": "Dong Wook",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145320: {
    id: "item_18848",
    "Last Name": "Ku",
    "First Name": "Jajun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145323: {
    id: "item_6231",
    "Last Name": "Dinneen",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145324: {
    id: "item_21313",
    "Last Name": "Walsh",
    "First Name": "Frances",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145325: {
    id: "item_18846",
    "Last Name": "Felizardo",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145330: {
    id: "item_6228",
    "Last Name": "Wilson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145341: {
    id: "item_18853",
    "Last Name": "Peters",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145349: {
    id: "item_18830",
    "Last Name": "Leistra",
    "First Name": "Tino",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145361: {
    id: "item_32083",
    "Last Name": "Waddell",
    "First Name": "April",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145362: {
    id: "item_32241",
    "Last Name": "Chimedregzen",
    "First Name": "Oyunbold",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145369: {
    id: "item_32098",
    "Last Name": "David",
    "First Name": "Mary Leidan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145379: {
    id: "item_18847",
    "Last Name": "Prema",
    "First Name": "Shive",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145380: {
    id: "item_6237",
    "Last Name": "Colli",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145384: {
    id: "item_21315",
    "Last Name": "Dudhatra",
    "First Name": "Margesh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145388: {
    id: "item_18829",
    "Last Name": "Garrett",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145390: {
    id: "item_6244",
    "Last Name": "Turner",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145391: {
    id: "item_8712",
    "Last Name": "Carstens",
    "First Name": "Dannie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145394: {
    id: "item_6236",
    "Last Name": "Meachem",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145401: {
    id: "item_6233",
    "Last Name": "Hofart",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145403: {
    id: "item_18810",
    "Last Name": "Hornachos",
    "First Name": "Jio Benson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145406: {
    id: "item_33740",
    "Last Name": "Li",
    "First Name": "Dan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145407: {
    id: "item_8708",
    "Last Name": "Goodwin",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145420: {
    id: "item_8704",
    "Last Name": "Prizeman",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145428: {
    id: "item_8711",
    "Last Name": "Sack",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145442: {
    id: "item_18843",
    "Last Name": "Griggs",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145446: {
    id: "item_21311",
    "Last Name": "Chan",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145457: {
    id: "item_32095",
    "Last Name": "McKechnie",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145465: {
    id: "item_18840",
    "Last Name": "Watson",
    "First Name": "Angus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145487: {
    id: "item_18824",
    "Last Name": "Jervis",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145493: {
    id: "item_6227",
    "Last Name": "klimas",
    "First Name": "saul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145497: {
    id: "item_33735",
    "Last Name": "Ma",
    "First Name": "Jiayi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145503: {
    id: "item_18834",
    "Last Name": "brumby",
    "First Name": "hayley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145506: {
    id: "item_8705",
    "Last Name": "Burford",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145512: {
    id: "item_8701",
    "Last Name": "Cooper",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145534: {
    id: "item_21302",
    "Last Name": "Gilich",
    "First Name": "Rainer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145536: {
    id: "item_8699",
    "Last Name": "Tsiligiannis",
    "First Name": "Jana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145545: {
    id: "item_18821",
    "Last Name": "Duong Vo",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145557: {
    id: "item_18825",
    "Last Name": "Molloy",
    "First Name": "Mathieu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145577: {
    id: "item_6221",
    "Last Name": "Slavotinek",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145595: {
    id: "item_8702",
    "Last Name": "Watson-Smith",
    "First Name": "Kerrin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145605: {
    id: "item_18804",
    "Last Name": "argent-dawson",
    "First Name": "lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145607: {
    id: "item_21306",
    "Last Name": "Acosta",
    "First Name": "Laarni Day",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145615: {
    id: "item_6218",
    "Last Name": "Geiseler",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145620: {
    id: "item_6222",
    "Last Name": "McGavin",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145645: {
    id: "item_6195",
    "Last Name": "O'Brien",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145652: {
    id: "item_21303",
    "Last Name": "Tran",
    "First Name": "Quynh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145655: {
    id: "item_8689",
    "Last Name": "Smith",
    "First Name": "Davin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145662: {
    id: "item_18808",
    "Last Name": "Theodorus",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145674: {
    id: "item_8695",
    "Last Name": "Fontana",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145678: {
    id: "item_8696",
    "Last Name": "Cresp",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145682: {
    id: "item_33704",
    "Last Name": "Brandt",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145684: {
    id: "item_6217",
    "Last Name": "Byrne",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145687: {
    id: "item_18806",
    "Last Name": "Herbert",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145704: {
    id: "item_32080",
    "Last Name": "Radocchia",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145708: {
    id: "item_6211",
    "Last Name": "Murray",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145710: {
    id: "item_8690",
    "Last Name": "Walles",
    "First Name": "Elysha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145721: {
    id: "item_6214",
    "Last Name": "Burke",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145722: {
    id: "item_8688",
    "Last Name": "Buenrostro",
    "First Name": "Lorrie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145724: {
    id: "item_6208",
    "Last Name": "CARNOVALE",
    "First Name": "Giacomo Jake Mathew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145735: {
    id: "item_33726",
    "Last Name": "Davies",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145741: {
    id: "item_18791",
    "Last Name": "Chua",
    "First Name": "Gary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145744: {
    id: "item_6205",
    "Last Name": "Stafford",
    "First Name": "Campbell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145745: {
    id: "item_18798",
    "Last Name": "Lees",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145757: {
    id: "item_6212",
    "Last Name": "Mineeff",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145760: {
    id: "item_18774",
    "Last Name": "Wragg",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145765: {
    id: "item_18802",
    "Last Name": "Kei",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145780: {
    id: "item_18794",
    "Last Name": "Martinez",
    "First Name": "Bruno",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145784: {
    id: "item_18782",
    "Last Name": "Peachey",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145789: {
    id: "item_18796",
    "Last Name": "jackson",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145797: {
    id: "item_19388",
    "Last Name": "Phillips",
    "First Name": "Anya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145798: {
    id: "item_6207",
    "Last Name": "McLaughlin",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145802: {
    id: "item_6136",
    "Last Name": "Cooper Mihelyi",
    "First Name": "Tones",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145814: {
    id: "item_6201",
    "Last Name": "Wong",
    "First Name": "Pik Yong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145829: {
    id: "item_18776",
    "Last Name": "Putra",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145847: {
    id: "item_6198",
    "Last Name": "Pabst",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145866: {
    id: "item_33718",
    "Last Name": "Vareloglou",
    "First Name": "Eric",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145868: {
    id: "item_32078",
    "Last Name": "Bigland",
    "First Name": "Deb",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145883: {
    id: "item_8679",
    "Last Name": "Lennon-Hamill",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145884: {
    id: "item_6148",
    "Last Name": "Spence",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145885: {
    id: "item_32074",
    "Last Name": "Oplado",
    "First Name": "Debbyshire",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145890: {
    id: "item_8685",
    "Last Name": "Tanji",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145897: {
    id: "item_21299",
    "Last Name": "LI",
    "First Name": "MINGXUAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145904: {
    id: "item_21300",
    "Last Name": "Cooper",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145905: {
    id: "item_18761",
    "Last Name": "xian",
    "First Name": "siting",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145913: {
    id: "item_33723",
    "Last Name": "Nicosen",
    "First Name": "Williams",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145935: {
    id: "item_6185",
    "Last Name": "Carlin",
    "First Name": "Eunan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145943: {
    id: "item_18777",
    "Last Name": "Qu",
    "First Name": "Huanyu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145963: {
    id: "item_6190",
    "Last Name": "Hatzer",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145964: {
    id: "item_18779",
    "Last Name": "YANG",
    "First Name": "YUCHAO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145966: {
    id: "item_33724",
    "Last Name": "Markham",
    "First Name": "Alisha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145969: {
    id: "item_6175",
    "Last Name": "McIntyre",
    "First Name": "Sally",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145993: {
    id: "item_6186",
    "Last Name": "Olesen",
    "First Name": "Esper",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37145994: {
    id: "item_6180",
    "Last Name": "Wang",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146002: {
    id: "item_6183",
    "Last Name": "Leavy",
    "First Name": "Ainsley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146003: {
    id: "item_6176",
    "Last Name": "Mudaliar",
    "First Name": "Praven",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146007: {
    id: "item_21292",
    "Last Name": "Dowd",
    "First Name": "Khiara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146008: {
    id: "item_6192",
    "Last Name": "Ireland",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146023: {
    id: "item_33715",
    "Last Name": "Singh",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146029: {
    id: "item_6167",
    "Last Name": "Ramadas",
    "First Name": "Shankar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146034: {
    id: "item_18754",
    "Last Name": "Madurai",
    "First Name": "Radigan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146037: {
    id: "item_33716",
    "Last Name": "Sutanto",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146041: {
    id: "item_6177",
    "Last Name": "Reardon",
    "First Name": "Elyse",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146049: {
    id: "item_33714",
    "Last Name": "Smith",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146051: {
    id: "item_32056",
    "Last Name": "Bernardo",
    "First Name": "Christine Denise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146055: {
    id: "item_32065",
    "Last Name": "Lueke",
    "First Name": "Christian Juergen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146058: {
    id: "item_6178",
    "Last Name": "Jain",
    "First Name": "Ankur",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146064: {
    id: "item_18759",
    "Last Name": "Rose",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146068: {
    id: "item_19387",
    "Last Name": "Whiting",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146077: {
    id: "item_8678",
    "Last Name": "McMaster",
    "First Name": "P D",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146084: {
    id: "item_18764",
    "Last Name": "Webb",
    "First Name": "Louisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146097: {
    id: "item_33710",
    "Last Name": "Tilbury",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146102: {
    id: "item_18736",
    "Last Name": "Lawson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146105: {
    id: "item_8673",
    "Last Name": "Hunter",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146134: {
    id: "item_33713",
    "Last Name": "Brown",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146140: {
    id: "item_8672",
    "Last Name": "La Torre",
    "First Name": "John Kennedy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146145: {
    id: "item_18756",
    "Last Name": "Glanville",
    "First Name": "Jon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146147: {
    id: "item_33711",
    "Last Name": "Relingado",
    "First Name": "Jay-R",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146149: {
    id: "item_6163",
    "Last Name": "Chong-Halliday",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146156: {
    id: "item_6158",
    "Last Name": "Longman",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146163: {
    id: "item_6168",
    "Last Name": "Young",
    "First Name": "Paris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146171: {
    id: "item_18750",
    "Last Name": "Lee",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146173: {
    id: "item_18738",
    "Last Name": "Wu",
    "First Name": "Elaine Hua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146181: {
    id: "item_18734",
    "Last Name": "Wojtun",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146188: {
    id: "item_33708",
    "Last Name": "Houghton",
    "First Name": "Josh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146198: {
    id: "item_18742",
    "Last Name": "McGarian",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146201: {
    id: "item_32060",
    "Last Name": "lauren",
    "First Name": "chris",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146205: {
    id: "item_18731",
    "Last Name": "Butler",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146213: {
    id: "item_18741",
    "Last Name": "Owens",
    "First Name": "Dale",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146215: {
    id: "item_6153",
    "Last Name": "Adams",
    "First Name": "Samson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146219: {
    id: "item_18715",
    "Last Name": "Faustino",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146227: {
    id: "item_32061",
    "Last Name": "Kounadis",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146236: {
    id: "item_6161",
    "Last Name": "Carmody",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146243: {
    id: "item_32063",
    "Last Name": "Barden",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146252: {
    id: "item_6112",
    "Last Name": "Ried",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146260: {
    id: "item_6151",
    "Last Name": "Cowan",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146267: {
    id: "item_18718",
    "Last Name": "Freeman",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146281: {
    id: "item_33700",
    "Last Name": "Malligan",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146296: {
    id: "item_21288",
    "Last Name": "Salander",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146312: {
    id: "item_18721",
    "Last Name": "Saunders",
    "First Name": "Dave",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146314: {
    id: "item_18719",
    "Last Name": "PARADA",
    "First Name": "CATHERINE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146320: {
    id: "item_18688",
    "Last Name": "McArthur",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146324: {
    id: "item_6149",
    "Last Name": "Mckevett",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146326: {
    id: "item_18720",
    "Last Name": "Wigmore",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146338: {
    id: "item_6116",
    "Last Name": "Potter",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146339: {
    id: "item_21285",
    "Last Name": "Garcia",
    "First Name": "Drew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146348: {
    id: "item_18710",
    "Last Name": "Batik",
    "First Name": "Ladislav",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146354: {
    id: "item_6135",
    "Last Name": "Fenaroli",
    "First Name": "Louis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146371: {
    id: "item_21280",
    "Last Name": "Ashby",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146372: {
    id: "item_33705",
    "Last Name": "Pionan",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146373: {
    id: "item_32054",
    "Last Name": "Chen",
    "First Name": "Maria Camille Louise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146383: {
    id: "item_18712",
    "Last Name": "TOXOPEUS",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146385: {
    id: "item_6146",
    "Last Name": "Emery",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146398: {
    id: "item_18711",
    "Last Name": "Lee",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146399: {
    id: "item_21284",
    "Last Name": "Howells",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146407: {
    id: "item_6125",
    "Last Name": "Barrett",
    "First Name": "Ash",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146416: {
    id: "item_21275",
    "Last Name": "Callaghan",
    "First Name": "Taylor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146422: {
    id: "item_32057",
    "Last Name": "Vu",
    "First Name": "Thao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146425: {
    id: "item_18705",
    "Last Name": "Harrowell",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146435: {
    id: "item_18709",
    "Last Name": "Barton",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146451: {
    id: "item_18707",
    "Last Name": "Wong",
    "First Name": "Xan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146452: {
    id: "item_18701",
    "Last Name": "Guerin",
    "First Name": "Aiden",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146456: {
    id: "item_6574",
    "Last Name": "Fernando",
    "First Name": "Asela",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146485: {
    id: "item_6114",
    "Last Name": "Permthongin",
    "First Name": "Chayathon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146490: {
    id: "item_6128",
    "Last Name": "Goh",
    "First Name": "Julian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146496: {
    id: "item_33701",
    "Last Name": "Sieders",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146502: {
    id: "item_18702",
    "Last Name": "Bradley",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146517: {
    id: "item_18694",
    "Last Name": "Wee",
    "First Name": "Zifang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146521: {
    id: "item_32045",
    "Last Name": "Walmsley",
    "First Name": "Kirstie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146528: {
    id: "item_33694",
    "Last Name": "Cheah",
    "First Name": "Yik-Siang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146533: {
    id: "item_32053",
    "Last Name": "Chong",
    "First Name": "Teck Onn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146540: {
    id: "item_6126",
    "Last Name": "Hanrahan",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146541: {
    id: "item_18699",
    "Last Name": "Myet",
    "First Name": "Htet",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146543: {
    id: "item_18653",
    "Last Name": "Bermudez",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146544: {
    id: "item_33688",
    "Last Name": "Seiter",
    "First Name": "Madeline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146563: {
    id: "item_8664",
    "Last Name": "Wainwright",
    "First Name": "Louis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146573: {
    id: "item_18692",
    "Last Name": "Armstrong",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146577: {
    id: "item_8661",
    "Last Name": "Potgieter",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146583: {
    id: "item_18693",
    "Last Name": "Profitt",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146593: {
    id: "item_6127",
    "Last Name": "Bemelen",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146595: {
    id: "item_21254",
    "Last Name": "Iape",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146632: {
    id: "item_6118",
    "Last Name": "Pratama",
    "First Name": "Aulia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146633: {
    id: "item_32052",
    "Last Name": "Park",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146635: {
    id: "item_8660",
    "Last Name": "Wangsomnuk",
    "First Name": "Thamwisai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146641: {
    id: "item_18687",
    "Last Name": "Swan",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146646: {
    id: "item_6103",
    "Last Name": "Damouni",
    "First Name": "Maha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146647: {
    id: "item_5990",
    "Last Name": "Wilson",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146652: {
    id: "item_6123",
    "Last Name": "Nguyen",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146658: {
    id: "item_6102",
    "Last Name": "Midgley",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146680: {
    id: "item_18666",
    "Last Name": "Pang",
    "First Name": "Zi Yang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146688: {
    id: "item_32039",
    "Last Name": "Horta",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146710: {
    id: "item_8656",
    "Last Name": "Nalbandian",
    "First Name": "Avedis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146711: {
    id: "item_6068",
    "Last Name": "Connell",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146727: {
    id: "item_18673",
    "Last Name": "Doherty",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146747: {
    id: "item_33687",
    "Last Name": "Villapando",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146754: {
    id: "item_6106",
    "Last Name": "Dickerson",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146766: {
    id: "item_6059",
    "Last Name": "Chagas Bodziak",
    "First Name": "Fernanda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146774: {
    id: "item_32038",
    "Last Name": "Jiang",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146777: {
    id: "item_6096",
    "Last Name": "Labella",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146780: {
    id: "item_8647",
    "Last Name": "Strange",
    "First Name": "Dale",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146791: {
    id: "item_18665",
    "Last Name": "Fox",
    "First Name": "Emmett",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146797: {
    id: "item_18649",
    "Last Name": "Feliciano",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146799: {
    id: "item_8648",
    "Last Name": "Hart",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146806: {
    id: "item_6099",
    "Last Name": "Joughin",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146815: {
    id: "item_32240",
    "Last Name": "Rune",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146848: {
    id: "item_8883",
    "Last Name": "Kurniasih",
    "First Name": "Wahyu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146852: {
    id: "item_33682",
    "Last Name": "Lardizabal",
    "First Name": "Joanna Mae",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146860: {
    id: "item_8651",
    "Last Name": "McCowen",
    "First Name": "Diarmuid",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146885: {
    id: "item_21270",
    "Last Name": "Wong",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146894: {
    id: "item_18659",
    "Last Name": "Skidmore",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146929: {
    id: "item_18638",
    "Last Name": "YANG",
    "First Name": "HONGSHAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146937: {
    id: "item_8644",
    "Last Name": "Wilkinson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146938: {
    id: "item_6085",
    "Last Name": "Da Silva Godinho",
    "First Name": "Fabio Jose",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146939: {
    id: "item_18645",
    "Last Name": "Rancie",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146957: {
    id: "item_6084",
    "Last Name": "Smallcalder",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146965: {
    id: "item_6079",
    "Last Name": "Cheatham",
    "First Name": "Ayla",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146969: {
    id: "item_18623",
    "Last Name": "Prynne",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146978: {
    id: "item_18644",
    "Last Name": "Watters",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146987: {
    id: "item_6086",
    "Last Name": "Liu",
    "First Name": "Jiayuan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146992: {
    id: "item_18634",
    "Last Name": "Nilsen",
    "First Name": "Kristi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37146995: {
    id: "item_18611",
    "Last Name": "Anderson",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147015: {
    id: "item_18641",
    "Last Name": "Plummer",
    "First Name": "Lauryn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147022: {
    id: "item_18622",
    "Last Name": "Beltran",
    "First Name": "Andres",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147027: {
    id: "item_32029",
    "Last Name": "Jayatilake",
    "First Name": "Regina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147029: {
    id: "item_6572",
    "Last Name": "Wilson",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147035: {
    id: "item_6080",
    "Last Name": "Hayward",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147037: {
    id: "item_18627",
    "Last Name": "Frith",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147045: {
    id: "item_6054",
    "Last Name": "Flint",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147050: {
    id: "item_18619",
    "Last Name": "Armend‡riz",
    "First Name": "Elisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147074: {
    id: "item_8882",
    "Last Name": "Tanguay",
    "First Name": "Donald",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147077: {
    id: "item_32025",
    "Last Name": "Pyper",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147079: {
    id: "item_8633",
    "Last Name": "Micallef",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147083: {
    id: "item_6078",
    "Last Name": "Whitear",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147085: {
    id: "item_18632",
    "Last Name": "Anderson",
    "First Name": "Taryn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147094: {
    id: "item_6077",
    "Last Name": "Stone",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147097: {
    id: "item_8638",
    "Last Name": "Wilkinson",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147104: {
    id: "item_18609",
    "Last Name": "Armada",
    "First Name": "Carlo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147105: {
    id: "item_6069",
    "Last Name": "Phillips",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147106: {
    id: "item_8632",
    "Last Name": "Deardo",
    "First Name": "Malvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147112: {
    id: "item_21245",
    "Last Name": "Stewart",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147124: {
    id: "item_18620",
    "Last Name": "Birmingham",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147131: {
    id: "item_6573",
    "Last Name": "Serrano Bravo",
    "First Name": "Gabriela Mariana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147136: {
    id: "item_6074",
    "Last Name": "Le",
    "First Name": "Trung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147140: {
    id: "item_18605",
    "Last Name": "Sim",
    "First Name": "Belle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147149: {
    id: "item_32028",
    "Last Name": "Vuckovic",
    "First Name": "Luka",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147155: {
    id: "item_18603",
    "Last Name": "Mateus",
    "First Name": "Thiago",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147161: {
    id: "item_18614",
    "Last Name": "Unwin",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147165: {
    id: "item_6061",
    "Last Name": "Lai",
    "First Name": "Shee Ching",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147180: {
    id: "item_18617",
    "Last Name": "Birtchnrll",
    "First Name": "Brenton",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147185: {
    id: "item_18592",
    "Last Name": "Olanio",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147187: {
    id: "item_6066",
    "Last Name": "Hewasinghage",
    "First Name": "Kawishka",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147191: {
    id: "item_21258",
    "Last Name": "Robinson",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147201: {
    id: "item_32026",
    "Last Name": "Boxter",
    "First Name": "Lori",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147230: {
    id: "item_18608",
    "Last Name": "Ngoi",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147242: {
    id: "item_8635",
    "Last Name": "Carpenter",
    "First Name": "Paige",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147246: {
    id: "item_33653",
    "Last Name": "Guajardo",
    "First Name": "Alyssa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147247: {
    id: "item_33676",
    "Last Name": "Lian",
    "First Name": "Yee Von",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147253: {
    id: "item_33670",
    "Last Name": "Jin",
    "First Name": "Yuqian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147261: {
    id: "item_21263",
    "Last Name": "Miranda",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147267: {
    id: "item_6047",
    "Last Name": "Singh",
    "First Name": "Punit",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147272: {
    id: "item_6064",
    "Last Name": "McKinley",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147275: {
    id: "item_18606",
    "Last Name": "Miller",
    "First Name": "Hylton",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147277: {
    id: "item_33674",
    "Last Name": "Rajapaksha",
    "First Name": "Sat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147281: {
    id: "item_8631",
    "Last Name": "Petsas",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147282: {
    id: "item_6058",
    "Last Name": "Quach",
    "First Name": "Derrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147305: {
    id: "item_8623",
    "Last Name": "Tan",
    "First Name": "Wily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147311: {
    id: "item_18601",
    "Last Name": "Sia",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147313: {
    id: "item_6045",
    "Last Name": "Lurido",
    "First Name": "Sherwin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147317: {
    id: "item_21256",
    "Last Name": "Zhuo",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147318: {
    id: "item_6056",
    "Last Name": "Batchelor",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147320: {
    id: "item_6053",
    "Last Name": "Riley Sandler",
    "First Name": "Kate",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147338: {
    id: "item_21257",
    "Last Name": "Simanjuntak",
    "First Name": "Michael Hariara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147344: {
    id: "item_5954",
    "Last Name": "Treacy",
    "First Name": "Caitlin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147347: {
    id: "item_18598",
    "Last Name": "McEwan",
    "First Name": "Grant",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147353: {
    id: "item_32021",
    "Last Name": "Caballero",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147354: {
    id: "item_6022",
    "Last Name": "Yoshida",
    "First Name": "Ryo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147355: {
    id: "item_18588",
    "Last Name": "Lui",
    "First Name": "Lu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147367: {
    id: "item_6048",
    "Last Name": "Dossche",
    "First Name": "Edouard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147371: {
    id: "item_8630",
    "Last Name": "Harrison",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147376: {
    id: "item_8627",
    "Last Name": "Arrosa",
    "First Name": "Ma Angela",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147379: {
    id: "item_21255",
    "Last Name": "Walker",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147404: {
    id: "item_32018",
    "Last Name": "Fung",
    "First Name": "Yuck Sam John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147414: {
    id: "item_6041",
    "Last Name": "Patel",
    "First Name": "Chirag",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147421: {
    id: "item_33662",
    "Last Name": "Vidal",
    "First Name": "Lui Randall",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147424: {
    id: "item_32020",
    "Last Name": "Raaz",
    "First Name": "Jezza",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147449: {
    id: "item_33667",
    "Last Name": "Rabadon",
    "First Name": "Marina Tatshani II",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147450: {
    id: "item_6038",
    "Last Name": "Corkill",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147465: {
    id: "item_33660",
    "Last Name": "Juinio",
    "First Name": "John Patrick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147466: {
    id: "item_8626",
    "Last Name": "Kovacs",
    "First Name": "Keith",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147473: {
    id: "item_6025",
    "Last Name": "Knott",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147475: {
    id: "item_6035",
    "Last Name": "Spiller",
    "First Name": "Jacquie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147516: {
    id: "item_32015",
    "Last Name": "BONVINO",
    "First Name": "ERIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147530: {
    id: "item_6031",
    "Last Name": "Cuigniez",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147531: {
    id: "item_33650",
    "Last Name": "Caballero",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147543: {
    id: "item_21251",
    "Last Name": "Hara",
    "First Name": "Mariana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147568: {
    id: "item_21244",
    "Last Name": "Resch",
    "First Name": "Vicki",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147574: {
    id: "item_6020",
    "Last Name": "Tarriga",
    "First Name": "Joseph Christianne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147586: {
    id: "item_8619",
    "Last Name": "Bowen",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147592: {
    id: "item_8616",
    "Last Name": "Hancock",
    "First Name": "Jinaya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147598: {
    id: "item_32005",
    "Last Name": "Lindsay",
    "First Name": "Jaclyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147609: {
    id: "item_33634",
    "Last Name": "Yusay",
    "First Name": "Anna Alyssa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147620: {
    id: "item_8828",
    "Last Name": "Ma",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147622: {
    id: "item_33655",
    "Last Name": "Guerrero",
    "First Name": "Joey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147632: {
    id: "item_33659",
    "Last Name": "Childs",
    "First Name": "Ali",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147642: {
    id: "item_32013",
    "Last Name": "Ross",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147646: {
    id: "item_6018",
    "Last Name": "Hutchinson",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147659: {
    id: "item_21240",
    "Last Name": "Burns",
    "First Name": "Dora",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147670: {
    id: "item_6014",
    "Last Name": "galligani",
    "First Name": "cyril",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147727: {
    id: "item_32003",
    "Last Name": "PERRIN",
    "First Name": "FIONA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147729: {
    id: "item_21242",
    "Last Name": "Mangulabnan",
    "First Name": "Charlemagne Benedict",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147759: {
    id: "item_33654",
    "Last Name": "Yan",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147791: {
    id: "item_21226",
    "Last Name": "Demaria",
    "First Name": "Domenico",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147802: {
    id: "item_5948",
    "Last Name": "Dickson",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147805: {
    id: "item_5976",
    "Last Name": "El Dirani",
    "First Name": "Sobhee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147853: {
    id: "item_8595",
    "Last Name": "Harris",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147857: {
    id: "item_8594",
    "Last Name": "Wadsworth",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147868: {
    id: "item_5983",
    "Last Name": "Robbins",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147877: {
    id: "item_33636",
    "Last Name": "Pura",
    "First Name": "Carina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147882: {
    id: "item_8599",
    "Last Name": "Kuwahara",
    "First Name": "Kazuki",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147883: {
    id: "item_21233",
    "Last Name": "Smith",
    "First Name": "Laurie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147886: {
    id: "item_5982",
    "Last Name": "Adams",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147901: {
    id: "item_6000",
    "Last Name": "Barnett",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147903: {
    id: "item_5999",
    "Last Name": "Buder",
    "First Name": "Sven",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147917: {
    id: "item_21217",
    "Last Name": "Campbell",
    "First Name": "Grant",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147924: {
    id: "item_33631",
    "Last Name": "Purimettla Chinna Kondaiah",
    "First Name": "Dinesh Rao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147935: {
    id: "item_8577",
    "Last Name": "Garrido",
    "First Name": "Guillermo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147956: {
    id: "item_21232",
    "Last Name": "Tran-Lam",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147978: {
    id: "item_33640",
    "Last Name": "Paz Dominguez",
    "First Name": "Paola",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147996: {
    id: "item_33643",
    "Last Name": "Barritt",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37147999: {
    id: "item_32002",
    "Last Name": "Woodson",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148001: {
    id: "item_33642",
    "Last Name": "Hutchinson",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148018: {
    id: "item_31980",
    "Last Name": "Brady",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148025: {
    id: "item_8585",
    "Last Name": "Brokas",
    "First Name": "Julien",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148052: {
    id: "item_21215",
    "Last Name": "Bateman",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148077: {
    id: "item_5977",
    "Last Name": "Castillo",
    "First Name": "Kaitlyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148079: {
    id: "item_5970",
    "Last Name": "Boyce",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148092: {
    id: "item_33630",
    "Last Name": "windle",
    "First Name": "caroline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148094: {
    id: "item_21216",
    "Last Name": "Guevara Morales",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148131: {
    id: "item_5917",
    "Last Name": "Summers",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148138: {
    id: "item_5969",
    "Last Name": "Warnes",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148139: {
    id: "item_31992",
    "Last Name": "Heald",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148147: {
    id: "item_5971",
    "Last Name": "Lewis",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148154: {
    id: "item_21209",
    "Last Name": "Crol",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148160: {
    id: "item_33624",
    "Last Name": "Zhao",
    "First Name": "Jiabin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148163: {
    id: "item_5934",
    "Last Name": "Anderson",
    "First Name": "Anca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148216: {
    id: "item_31989",
    "Last Name": "sylvander",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148226: {
    id: "item_31985",
    "Last Name": "Bloom",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148239: {
    id: "item_5963",
    "Last Name": "Adams",
    "First Name": "Karl",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148278: {
    id: "item_31988",
    "Last Name": "Jia",
    "First Name": "Qiuhong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148285: {
    id: "item_8574",
    "Last Name": "McIntyre",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148302: {
    id: "item_33614",
    "Last Name": "Syamsuar",
    "First Name": "Irlamsyah Syam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148305: {
    id: "item_31976",
    "Last Name": "Calado",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148351: {
    id: "item_21212",
    "Last Name": "Johnson",
    "First Name": "Cate",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148358: {
    id: "item_5950",
    "Last Name": "Hunt",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148368: {
    id: "item_21214",
    "Last Name": "Kunde",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148380: {
    id: "item_33573",
    "Last Name": "Panopio",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148394: {
    id: "item_5912",
    "Last Name": "Brooks",
    "First Name": "Monic",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148399: {
    id: "item_5935",
    "Last Name": "Chapman",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148474: {
    id: "item_21200",
    "Last Name": "McGuirk",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148479: {
    id: "item_5940",
    "Last Name": "Foster",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148483: {
    id: "item_33608",
    "Last Name": "Rigodon",
    "First Name": "Ceara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148496: {
    id: "item_32239",
    "Last Name": "Geng",
    "First Name": "Zidi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148515: {
    id: "item_8540",
    "Last Name": "FENG",
    "First Name": "Zhiwei",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148517: {
    id: "item_8561",
    "Last Name": "greig",
    "First Name": "kerry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148535: {
    id: "item_5925",
    "Last Name": "Bower",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148542: {
    id: "item_21207",
    "Last Name": "Malory",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148544: {
    id: "item_8566",
    "Last Name": "Joel",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148545: {
    id: "item_21202",
    "Last Name": "Siret",
    "First Name": "Christie-Anne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148547: {
    id: "item_33589",
    "Last Name": "Ford",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148566: {
    id: "item_33597",
    "Last Name": "Natividad",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148569: {
    id: "item_8562",
    "Last Name": "Tan",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148611: {
    id: "item_31963",
    "Last Name": "Calimutan",
    "First Name": "Gerald Lloyd",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148675: {
    id: "item_5924",
    "Last Name": "Scheepers",
    "First Name": "Morne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148700: {
    id: "item_8550",
    "Last Name": "KANG",
    "First Name": "DONGCHEOL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148704: {
    id: "item_8536",
    "Last Name": "Weber",
    "First Name": "Klaus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148708: {
    id: "item_33579",
    "Last Name": "Dewi",
    "First Name": "Sari",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148716: {
    id: "item_5904",
    "Last Name": "Revelo",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148753: {
    id: "item_8553",
    "Last Name": "Carroll",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148757: {
    id: "item_8543",
    "Last Name": "Mcclelland",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148766: {
    id: "item_8497",
    "Last Name": "Tansley",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148781: {
    id: "item_19386",
    "Last Name": "Campbell",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148787: {
    id: "item_8542",
    "Last Name": "Huxley",
    "First Name": "Sally",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148788: {
    id: "item_21194",
    "Last Name": "Limbaroc",
    "First Name": "Darrell Christian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148797: {
    id: "item_21197",
    "Last Name": "Palombi",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148826: {
    id: "item_5909",
    "Last Name": "Hordern",
    "First Name": "Hunter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148845: {
    id: "item_5910",
    "Last Name": "Vawser",
    "First Name": "Allie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148858: {
    id: "item_31966",
    "Last Name": "Lee",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148897: {
    id: "item_5893",
    "Last Name": "Guy",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148954: {
    id: "item_31948",
    "Last Name": "Delmo",
    "First Name": "Lorenzo Jun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148970: {
    id: "item_8531",
    "Last Name": "Peart",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148978: {
    id: "item_5896",
    "Last Name": "Walker",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148982: {
    id: "item_5827",
    "Last Name": "O'Leary",
    "First Name": "Se‡n",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148986: {
    id: "item_18586",
    "Last Name": "Hardy",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148988: {
    id: "item_21188",
    "Last Name": "Marochi Almeida",
    "First Name": "Joaquim Antonio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37148999: {
    id: "item_5888",
    "Last Name": "Copland",
    "First Name": "Neal",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149002: {
    id: "item_31959",
    "Last Name": "Lambert",
    "First Name": "Bernadine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149020: {
    id: "item_5881",
    "Last Name": "Vrsecky",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149039: {
    id: "item_5870",
    "Last Name": "Kakonyi",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149054: {
    id: "item_21182",
    "Last Name": "Joseph",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149059: {
    id: "item_19382",
    "Last Name": "Wilson",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149068: {
    id: "item_8539",
    "Last Name": "Bird",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149090: {
    id: "item_21186",
    "Last Name": "Schwartz",
    "First Name": "Kirsten",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149114: {
    id: "item_32238",
    "Last Name": "Chen",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149160: {
    id: "item_31929",
    "Last Name": "Nishioka",
    "First Name": "Kahori",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149166: {
    id: "item_5875",
    "Last Name": "Cardy",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149174: {
    id: "item_8533",
    "Last Name": "Wilkinson",
    "First Name": "Grace",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149185: {
    id: "item_6571",
    "Last Name": "Pihier",
    "First Name": "Archie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149211: {
    id: "item_21181",
    "Last Name": "Carter",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149214: {
    id: "item_5865",
    "Last Name": "Helmi",
    "First Name": "Robby",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149216: {
    id: "item_8528",
    "Last Name": "Montalvo",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149244: {
    id: "item_8523",
    "Last Name": "Sarra",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149250: {
    id: "item_5847",
    "Last Name": "Jarman",
    "First Name": "Beau",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149263: {
    id: "item_5867",
    "Last Name": "Hanlon",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149275: {
    id: "item_33568",
    "Last Name": "Pane",
    "First Name": "Antonietta",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149295: {
    id: "item_19385",
    "Last Name": "Hoskins",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149302: {
    id: "item_21174",
    "Last Name": "Segerstrom",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149324: {
    id: "item_33940",
    "Last Name": "Were",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149329: {
    id: "item_33555",
    "Last Name": "Breen",
    "First Name": "Jillian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149356: {
    id: "item_19384",
    "Last Name": "Luppino",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149385: {
    id: "item_31937",
    "Last Name": "Brown",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149425: {
    id: "item_5842",
    "Last Name": "Shah",
    "First Name": "Grant",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149452: {
    id: "item_5831",
    "Last Name": "Rowe",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149462: {
    id: "item_31935",
    "Last Name": "Hooks",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149492: {
    id: "item_5828",
    "Last Name": "Topari",
    "First Name": "Yusuf",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149501: {
    id: "item_19383",
    "Last Name": "Evans",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149515: {
    id: "item_5836",
    "Last Name": "Lawson",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149528: {
    id: "item_8453",
    "Last Name": "REIS",
    "First Name": "ADILSON",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149538: {
    id: "item_8513",
    "Last Name": "Hendrick",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149584: {
    id: "item_19381",
    "Last Name": "Needham",
    "First Name": "Jacqui",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149601: {
    id: "item_8506",
    "Last Name": "Bambrook",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149670: {
    id: "item_8504",
    "Last Name": "Arganese",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149697: {
    id: "item_33552",
    "Last Name": "Orr",
    "First Name": "Celeste",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149706: {
    id: "item_33544",
    "Last Name": "Alcantara",
    "First Name": "Ivy Klarisse",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149707: {
    id: "item_31913",
    "Last Name": "tian",
    "First Name": "xiang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149718: {
    id: "item_21162",
    "Last Name": "Vourdoumpas",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149723: {
    id: "item_21159",
    "Last Name": "Aglipa",
    "First Name": "Napoleon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149730: {
    id: "item_21157",
    "Last Name": "Davidson",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149734: {
    id: "item_21163",
    "Last Name": "Naidoo",
    "First Name": "Yogeeta",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149797: {
    id: "item_31912",
    "Last Name": "Barros",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149807: {
    id: "item_21152",
    "Last Name": "Calle Jimenez",
    "First Name": "Lila",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149823: {
    id: "item_31906",
    "Last Name": "De Scrilli",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149876: {
    id: "item_8489",
    "Last Name": "Martell",
    "First Name": "Jacquelyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149880: {
    id: "item_8488",
    "Last Name": "Pain",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149881: {
    id: "item_31915",
    "Last Name": "Guerrero",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149942: {
    id: "item_31840",
    "Last Name": "LeTellier",
    "First Name": "Carolina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149965: {
    id: "item_33526",
    "Last Name": "tan",
    "First Name": "claire sze yin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149968: {
    id: "item_31907",
    "Last Name": "Hua",
    "First Name": "Aili",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37149997: {
    id: "item_33519",
    "Last Name": "Bailey",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150000: {
    id: "item_33527",
    "Last Name": "Bibian",
    "First Name": "Arrianna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150009: {
    id: "item_21154",
    "Last Name": "Poon",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150013: {
    id: "item_33497",
    "Last Name": "Bertsos",
    "First Name": "Arna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150040: {
    id: "item_8881",
    "Last Name": "Ferguson",
    "First Name": "Louise",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150054: {
    id: "item_8486",
    "Last Name": "Panoutsos",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150121: {
    id: "item_33524",
    "Last Name": "Chang",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150122: {
    id: "item_8481",
    "Last Name": "Superina",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150130: {
    id: "item_8479",
    "Last Name": "Porter",
    "First Name": "Elisha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150158: {
    id: "item_21146",
    "Last Name": "Clifford",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150163: {
    id: "item_31891",
    "Last Name": "Kimpton",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150193: {
    id: "item_8471",
    "Last Name": "Grant",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150218: {
    id: "item_31890",
    "Last Name": "Lai",
    "First Name": "Ka Yin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150242: {
    id: "item_8454",
    "Last Name": "O'Connor",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150250: {
    id: "item_33522",
    "Last Name": "Chan",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150257: {
    id: "item_8470",
    "Last Name": "Bailey",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150305: {
    id: "item_31888",
    "Last Name": "Copeland",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150383: {
    id: "item_8461",
    "Last Name": "Stanton",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150388: {
    id: "item_21144",
    "Last Name": "simpson",
    "First Name": "samantha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150409: {
    id: "item_33513",
    "Last Name": "Sabu Jose",
    "First Name": "Josy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150422: {
    id: "item_31879",
    "Last Name": "Hoffman",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150436: {
    id: "item_8432",
    "Last Name": "Kingston",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150452: {
    id: "item_5818",
    "Last Name": "Colreavy",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150472: {
    id: "item_21143",
    "Last Name": "McKeown",
    "First Name": "Clare",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150482: {
    id: "item_8341",
    "Last Name": "ORR",
    "First Name": "JAMIE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150508: {
    id: "item_33504",
    "Last Name": "De Leon",
    "First Name": "Rogelio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150512: {
    id: "item_33505",
    "Last Name": "Guerrero Jr.",
    "First Name": "Eufemio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150513: {
    id: "item_31886",
    "Last Name": "Callen",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150564: {
    id: "item_8448",
    "Last Name": "Hill",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150573: {
    id: "item_19380",
    "Last Name": "Law",
    "First Name": "Carly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150586: {
    id: "item_31874",
    "Last Name": "Pizarro",
    "First Name": "Mauricio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150618: {
    id: "item_21128",
    "Last Name": "de Sa Bomfim",
    "First Name": "Thiago",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150620: {
    id: "item_33476",
    "Last Name": "Jones",
    "First Name": "Carl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150656: {
    id: "item_33495",
    "Last Name": "Hunt",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150677: {
    id: "item_8450",
    "Last Name": "Wang",
    "First Name": "Xiaoxi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150703: {
    id: "item_19229",
    "Last Name": "Dai",
    "First Name": "Jianhua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150729: {
    id: "item_8447",
    "Last Name": "Vedder",
    "First Name": "Timm",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150782: {
    id: "item_21124",
    "Last Name": "Kulthia",
    "First Name": "Arunjit Singh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150827: {
    id: "item_31868",
    "Last Name": "Matarese",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150853: {
    id: "item_8437",
    "Last Name": "Cummins",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150884: {
    id: "item_31863",
    "Last Name": "Moral",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150913: {
    id: "item_21125",
    "Last Name": "Fegan",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37150964: {
    id: "item_31841",
    "Last Name": "Yea",
    "First Name": "Gwangwoo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151035: {
    id: "item_21116",
    "Last Name": "Czernicziw",
    "First Name": "Natalya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151037: {
    id: "item_31859",
    "Last Name": "Cumming",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151063: {
    id: "item_8430",
    "Last Name": "Wolstin",
    "First Name": "Eyal",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151068: {
    id: "item_31846",
    "Last Name": "Zaw",
    "First Name": "Wunna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151073: {
    id: "item_8428",
    "Last Name": "Holzinger",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151095: {
    id: "item_21102",
    "Last Name": "Mendez",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151137: {
    id: "item_8424",
    "Last Name": "Fogo",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151151: {
    id: "item_21113",
    "Last Name": "GUAN",
    "First Name": "TING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151173: {
    id: "item_31850",
    "Last Name": "Mckiernan",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151189: {
    id: "item_8426",
    "Last Name": "Hodson",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151212: {
    id: "item_21089",
    "Last Name": "Mannion",
    "First Name": "Kayleigh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151217: {
    id: "item_33478",
    "Last Name": "Field",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151238: {
    id: "item_31820",
    "Last Name": "Robson",
    "First Name": "Karl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151249: {
    id: "item_21112",
    "Last Name": "Robinson",
    "First Name": "Jemma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151284: {
    id: "item_8380",
    "Last Name": "Bailie",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151290: {
    id: "item_31826",
    "Last Name": "Karmi",
    "First Name": "Hafzil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151329: {
    id: "item_21108",
    "Last Name": "Ford",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151331: {
    id: "item_31812",
    "Last Name": "Bimantara",
    "First Name": "Dony Rosmana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151338: {
    id: "item_31810",
    "Last Name": "Susanti",
    "First Name": "wahyu hadi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151346: {
    id: "item_8404",
    "Last Name": "Taylor",
    "First Name": "Ed",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151404: {
    id: "item_33465",
    "Last Name": "Jung",
    "First Name": "Yea Won",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151439: {
    id: "item_8397",
    "Last Name": "Connell",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151468: {
    id: "item_32237",
    "Last Name": "Langley",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151470: {
    id: "item_31831",
    "Last Name": "NUGRAHA",
    "First Name": "RIAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151512: {
    id: "item_8371",
    "Last Name": "Evans",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151553: {
    id: "item_21104",
    "Last Name": "Contreras Vacca",
    "First Name": "Gerardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151555: {
    id: "item_33352",
    "Last Name": "SUN",
    "First Name": "HERMAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151582: {
    id: "item_33466",
    "Last Name": "Moyle",
    "First Name": "Astrid",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151601: {
    id: "item_21097",
    "Last Name": "Calara",
    "First Name": "Paul Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151619: {
    id: "item_8387",
    "Last Name": "Woods",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151620: {
    id: "item_31824",
    "Last Name": "Nuthakki",
    "First Name": "Venkat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151691: {
    id: "item_31811",
    "Last Name": "Fourie",
    "First Name": "Clarissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151693: {
    id: "item_8376",
    "Last Name": "Brown",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151709: {
    id: "item_8391",
    "Last Name": "jones",
    "First Name": "bayden",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151713: {
    id: "item_8393",
    "Last Name": "Treloar",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151714: {
    id: "item_31816",
    "Last Name": "Kumar",
    "First Name": "Vinay",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151719: {
    id: "item_33458",
    "Last Name": "Santos",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151725: {
    id: "item_21081",
    "Last Name": "Reilly",
    "First Name": "Marieka",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151727: {
    id: "item_21096",
    "Last Name": "Boyle",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151779: {
    id: "item_8354",
    "Last Name": "Ko",
    "First Name": "Cheng Hsu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151806: {
    id: "item_31808",
    "Last Name": "CHEN",
    "First Name": "YU SIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151821: {
    id: "item_33449",
    "Last Name": "RAJANDRAN",
    "First Name": "KUNAVATHY",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151823: {
    id: "item_33448",
    "Last Name": "Doroy",
    "First Name": "Cyrus Immanuel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151825: {
    id: "item_21402",
    "Last Name": "Zidek-Zvonar",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151841: {
    id: "item_31802",
    "Last Name": "Washington",
    "First Name": "Nieshe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151903: {
    id: "item_8365",
    "Last Name": "McLaren",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151948: {
    id: "item_31805",
    "Last Name": "Best",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151949: {
    id: "item_21084",
    "Last Name": "Tranter",
    "First Name": "Beth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151971: {
    id: "item_8309",
    "Last Name": "Angee",
    "First Name": "Mauricio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37151987: {
    id: "item_8369",
    "Last Name": "Green",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152076: {
    id: "item_8305",
    "Last Name": "Baraya",
    "First Name": "Bernardo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152147: {
    id: "item_5813",
    "Last Name": "Toland",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152177: {
    id: "item_21059",
    "Last Name": "Yaxley",
    "First Name": "Zara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152219: {
    id: "item_33425",
    "Last Name": "Dy",
    "First Name": "Francis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152241: {
    id: "item_8347",
    "Last Name": "Gill",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152247: {
    id: "item_33424",
    "Last Name": "Cortez",
    "First Name": "Gerick Enrique",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152273: {
    id: "item_8350",
    "Last Name": "Maia",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152277: {
    id: "item_31791",
    "Last Name": "Wang",
    "First Name": "Mitz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152289: {
    id: "item_33427",
    "Last Name": "Albornoz",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152311: {
    id: "item_8337",
    "Last Name": "Sulisto",
    "First Name": "Imam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152321: {
    id: "item_33413",
    "Last Name": "Roy",
    "First Name": "Teetash",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152371: {
    id: "item_31773",
    "Last Name": "Maddison",
    "First Name": "Dave",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152375: {
    id: "item_31785",
    "Last Name": "Armanda",
    "First Name": "Sektya Ageng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152400: {
    id: "item_21074",
    "Last Name": "Vujcich",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152450: {
    id: "item_8342",
    "Last Name": "Black",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152452: {
    id: "item_8327",
    "Last Name": "Leal",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152459: {
    id: "item_31784",
    "Last Name": "Kirkwood",
    "First Name": "Casey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152464: {
    id: "item_33426",
    "Last Name": "Lin",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152475: {
    id: "item_33422",
    "Last Name": "Sheppard",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152536: {
    id: "item_33404",
    "Last Name": "Fong",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152578: {
    id: "item_33416",
    "Last Name": "Marasigan",
    "First Name": "Pamela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152610: {
    id: "item_31770",
    "Last Name": "Suharto",
    "First Name": "Lina Fitriani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152641: {
    id: "item_31767",
    "Last Name": "Lee",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152646: {
    id: "item_8331",
    "Last Name": "Gunn",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152664: {
    id: "item_8324",
    "Last Name": "Collard",
    "First Name": "Karen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152675: {
    id: "item_8329",
    "Last Name": "Cotton",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152683: {
    id: "item_21060",
    "Last Name": "Malik",
    "First Name": "Vivek",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152723: {
    id: "item_8326",
    "Last Name": "Barraclough",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152828: {
    id: "item_21056",
    "Last Name": "Gambold",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152852: {
    id: "item_21052",
    "Last Name": "Siddon",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152884: {
    id: "item_19379",
    "Last Name": "Emmanuel",
    "First Name": "Marian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152914: {
    id: "item_33397",
    "Last Name": "Nurcahya",
    "First Name": "Rika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152917: {
    id: "item_21050",
    "Last Name": "Parsonson",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152946: {
    id: "item_31759",
    "Last Name": "Andrian",
    "First Name": "Okky",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152961: {
    id: "item_21039",
    "Last Name": "Hynes",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152962: {
    id: "item_33396",
    "Last Name": "Somers",
    "First Name": "Genine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37152987: {
    id: "item_21057",
    "Last Name": "Cincotta",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153009: {
    id: "item_8314",
    "Last Name": "Halpert",
    "First Name": "Marcel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153021: {
    id: "item_33391",
    "Last Name": "Obih-Frank",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153031: {
    id: "item_8315",
    "Last Name": "Newson-Brown",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153116: {
    id: "item_8294",
    "Last Name": "Cosi",
    "First Name": "Cris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153129: {
    id: "item_21048",
    "Last Name": "Nguyen",
    "First Name": "Thi Quynh Nhu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153219: {
    id: "item_21049",
    "Last Name": "Wang",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153226: {
    id: "item_33386",
    "Last Name": "Mthalane",
    "First Name": "Dumisile",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153279: {
    id: "item_33387",
    "Last Name": "Bhat",
    "First Name": "Namratha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153310: {
    id: "item_8300",
    "Last Name": "burton",
    "First Name": "troy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153336: {
    id: "item_33373",
    "Last Name": "Sutton",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153348: {
    id: "item_8296",
    "Last Name": "Tamang",
    "First Name": "Kiran",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153376: {
    id: "item_21044",
    "Last Name": "Hayward",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153407: {
    id: "item_33375",
    "Last Name": "Stewart",
    "First Name": "Don",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153427: {
    id: "item_6570",
    "Last Name": "Church",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153487: {
    id: "item_21043",
    "Last Name": "Power",
    "First Name": "Orla",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153525: {
    id: "item_8283",
    "Last Name": "Shah",
    "First Name": "Hery",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153569: {
    id: "item_8222",
    "Last Name": "Sangil",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153570: {
    id: "item_31741",
    "Last Name": "Heah",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153596: {
    id: "item_8281",
    "Last Name": "Amos",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153597: {
    id: "item_8287",
    "Last Name": "GORDON",
    "First Name": "STUART",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153598: {
    id: "item_33370",
    "Last Name": "Tipping",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153632: {
    id: "item_33368",
    "Last Name": "Hong",
    "First Name": "Sylvia Sujung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153680: {
    id: "item_31727",
    "Last Name": "Perez Bustos",
    "First Name": "Ana Lucia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153694: {
    id: "item_31728",
    "Last Name": "Ajimura",
    "First Name": "Chanelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153697: {
    id: "item_31724",
    "Last Name": "Gamble",
    "First Name": "Deepa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153724: {
    id: "item_21040",
    "Last Name": "Finlay",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153733: {
    id: "item_5810",
    "Last Name": "Davis",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153766: {
    id: "item_8274",
    "Last Name": "Ammentorp",
    "First Name": "Bronte",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153772: {
    id: "item_21035",
    "Last Name": "Gunning",
    "First Name": "Alfie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153778: {
    id: "item_19228",
    "Last Name": "Merino Rodriguez",
    "First Name": "Jose Guillermo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153812: {
    id: "item_8269",
    "Last Name": "Hodcroft",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153833: {
    id: "item_31717",
    "Last Name": "Hillstead",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153835: {
    id: "item_8275",
    "Last Name": "Lombardi",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153868: {
    id: "item_31710",
    "Last Name": "Yu",
    "First Name": "Ding",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153933: {
    id: "item_19378",
    "Last Name": "Tan",
    "First Name": "Anne Kathleen Plibundo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37153958: {
    id: "item_21031",
    "Last Name": "MEDRANO",
    "First Name": "MAIA FRANCES",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154032: {
    id: "item_31699",
    "Last Name": "Mulyadi",
    "First Name": "Jonly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154044: {
    id: "item_21025",
    "Last Name": "Lam",
    "First Name": "Lok Hin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154045: {
    id: "item_33349",
    "Last Name": "Laudencia",
    "First Name": "Herminia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154047: {
    id: "item_8267",
    "Last Name": "Wallett",
    "First Name": "Troye",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154048: {
    id: "item_8264",
    "Last Name": "Sutcliffe",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154054: {
    id: "item_33938",
    "Last Name": "Upton",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154057: {
    id: "item_33939",
    "Last Name": "Ang",
    "First Name": "Peng lin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154062: {
    id: "item_31704",
    "Last Name": "ZHANG",
    "First Name": "ZUDA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154064: {
    id: "item_21026",
    "Last Name": "Sun",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154131: {
    id: "item_31697",
    "Last Name": "Guevara",
    "First Name": "Mara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154137: {
    id: "item_33348",
    "Last Name": "Murphy",
    "First Name": "Blythe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154140: {
    id: "item_33346",
    "Last Name": "Cheng",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154143: {
    id: "item_21012",
    "Last Name": "dalgliesh",
    "First Name": "Sonya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154146: {
    id: "item_31702",
    "Last Name": "de Bruyn",
    "First Name": "Josh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154168: {
    id: "item_8259",
    "Last Name": "Bowyer",
    "First Name": "Cambel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154182: {
    id: "item_21401",
    "Last Name": "Hodge",
    "First Name": "Rhonda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154207: {
    id: "item_21015",
    "Last Name": "XU",
    "First Name": "JIANGTAO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154216: {
    id: "item_33342",
    "Last Name": "Inglis",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154268: {
    id: "item_31689",
    "Last Name": "Evardone",
    "First Name": "Maria Angellica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154276: {
    id: "item_21017",
    "Last Name": "Nuttall",
    "First Name": "Betsy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154284: {
    id: "item_31692",
    "Last Name": "Danford",
    "First Name": "Kristina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154287: {
    id: "item_31685",
    "Last Name": "Lillywhite",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154346: {
    id: "item_21006",
    "Last Name": "lopez alvarez",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154364: {
    id: "item_31676",
    "Last Name": "Therond",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154439: {
    id: "item_21002",
    "Last Name": "Crawford",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154516: {
    id: "item_21008",
    "Last Name": "Gin",
    "First Name": "Julie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154525: {
    id: "item_33335",
    "Last Name": "Jarman",
    "First Name": "Yasmin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154542: {
    id: "item_33336",
    "Last Name": "Koruthu",
    "First Name": "Chandy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154562: {
    id: "item_33330",
    "Last Name": "Zou",
    "First Name": "Ran",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154571: {
    id: "item_31684",
    "Last Name": "Almario",
    "First Name": "Cirilo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154575: {
    id: "item_8239",
    "Last Name": "Swain",
    "First Name": "Edwyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154578: {
    id: "item_33324",
    "Last Name": "Betita",
    "First Name": "Jomar Alyzar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154648: {
    id: "item_31677",
    "Last Name": "Arumardi",
    "First Name": "Agustina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154756: {
    id: "item_31679",
    "Last Name": "Whitear",
    "First Name": "Ria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154814: {
    id: "item_8230",
    "Last Name": "Stukel",
    "First Name": "Mikayla",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154817: {
    id: "item_8225",
    "Last Name": "Chu",
    "First Name": "Gwangcheol",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154819: {
    id: "item_8231",
    "Last Name": "Revis",
    "First Name": "Rob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154827: {
    id: "item_8227",
    "Last Name": "Martinez",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154838: {
    id: "item_8880",
    "Last Name": "KUONG",
    "First Name": "CHI KONG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154881: {
    id: "item_8226",
    "Last Name": "Cisneros",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154910: {
    id: "item_21001",
    "Last Name": "Trent",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154917: {
    id: "item_20996",
    "Last Name": "Croton",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154918: {
    id: "item_19376",
    "Last Name": "Roush",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154919: {
    id: "item_33318",
    "Last Name": "Wang",
    "First Name": "Si",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154922: {
    id: "item_20992",
    "Last Name": "Oaksford",
    "First Name": "Jamie Marie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37154937: {
    id: "item_19377",
    "Last Name": "De Rosa",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155000: {
    id: "item_31663",
    "Last Name": "Del Rosario",
    "First Name": "Karlyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155040: {
    id: "item_31655",
    "Last Name": "Hidalgo",
    "First Name": "Rhea Nova",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155044: {
    id: "item_8211",
    "Last Name": "Tan",
    "First Name": "Ji",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155049: {
    id: "item_33309",
    "Last Name": "Lutfi",
    "First Name": "Cut Fika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155055: {
    id: "item_8213",
    "Last Name": "Lenahan",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155094: {
    id: "item_8194",
    "Last Name": "Connellan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155095: {
    id: "item_8207",
    "Last Name": "Croak",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155102: {
    id: "item_33310",
    "Last Name": "Lleno",
    "First Name": "Ronald Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155106: {
    id: "item_8204",
    "Last Name": "Goodfield",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155108: {
    id: "item_20995",
    "Last Name": "Jukes",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155115: {
    id: "item_8210",
    "Last Name": "Malaneschii",
    "First Name": "Andres",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155121: {
    id: "item_31652",
    "Last Name": "Seshadri",
    "First Name": "Uday",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155149: {
    id: "item_33300",
    "Last Name": "Feng",
    "First Name": "Flora",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155160: {
    id: "item_20993",
    "Last Name": "Kermode",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155184: {
    id: "item_19374",
    "Last Name": "venegas cordero",
    "First Name": "julio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155188: {
    id: "item_8203",
    "Last Name": "Deng",
    "First Name": "Deric",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155192: {
    id: "item_31656",
    "Last Name": "Li",
    "First Name": "Sidney",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155224: {
    id: "item_20990",
    "Last Name": "Martinez",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155248: {
    id: "item_8201",
    "Last Name": "Roshe",
    "First Name": "Unathi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155324: {
    id: "item_20975",
    "Last Name": "Leung",
    "First Name": "Elaine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155346: {
    id: "item_18584",
    "Last Name": "PERIN",
    "First Name": "Guillaume",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155347: {
    id: "item_33303",
    "Last Name": "Lafaye",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155358: {
    id: "item_19375",
    "Last Name": "Hartman",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155378: {
    id: "item_31637",
    "Last Name": "Feng",
    "First Name": "Deli",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155410: {
    id: "item_31651",
    "Last Name": "Long",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155425: {
    id: "item_21371",
    "Last Name": "Jestico",
    "First Name": "Darragh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155517: {
    id: "item_31645",
    "Last Name": "Bandy",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155526: {
    id: "item_20973",
    "Last Name": "Anderson",
    "First Name": "Jodie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155557: {
    id: "item_33261",
    "Last Name": "Neale",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155606: {
    id: "item_20966",
    "Last Name": "Ooi",
    "First Name": "Ken Chai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155636: {
    id: "item_31643",
    "Last Name": "Webb",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155640: {
    id: "item_31644",
    "Last Name": "Cattley",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155664: {
    id: "item_33291",
    "Last Name": "Hockey",
    "First Name": "Dianne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155670: {
    id: "item_32236",
    "Last Name": "Velazquez",
    "First Name": "Sheileen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155678: {
    id: "item_8180",
    "Last Name": "Cao",
    "First Name": "Cuong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155719: {
    id: "item_8184",
    "Last Name": "Skliros",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155723: {
    id: "item_31642",
    "Last Name": "Gava",
    "First Name": "Mario",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155728: {
    id: "item_8186",
    "Last Name": "dagdug",
    "First Name": "iliana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155765: {
    id: "item_8177",
    "Last Name": "Cadena Cadena",
    "First Name": "Christian Camilo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155800: {
    id: "item_33283",
    "Last Name": "Milczarek",
    "First Name": "Izabela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155801: {
    id: "item_20962",
    "Last Name": "Rusmedi",
    "First Name": "Rickyanto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155804: {
    id: "item_8182",
    "Last Name": "Amey",
    "First Name": "Guy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155846: {
    id: "item_31636",
    "Last Name": "Vivas",
    "First Name": "Beverly Jane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155848: {
    id: "item_20959",
    "Last Name": "Metzke",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155892: {
    id: "item_31635",
    "Last Name": "Sulianto",
    "First Name": "Yuyung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155901: {
    id: "item_20955",
    "Last Name": "Teague",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37155947: {
    id: "item_20951",
    "Last Name": "Zoanetti",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156067: {
    id: "item_8155",
    "Last Name": "Dang",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156080: {
    id: "item_31629",
    "Last Name": "Neale",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156089: {
    id: "item_8164",
    "Last Name": "HUSSEY",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156119: {
    id: "item_20943",
    "Last Name": "Tongkum",
    "First Name": "Tossapol",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156134: {
    id: "item_20944",
    "Last Name": "Allum",
    "First Name": "Elyse",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156152: {
    id: "item_33276",
    "Last Name": "Carmody",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156211: {
    id: "item_20937",
    "Last Name": "Roberts",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156212: {
    id: "item_31627",
    "Last Name": "Cooper",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156224: {
    id: "item_31622",
    "Last Name": "Cheah",
    "First Name": "Kum Yee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156270: {
    id: "item_33273",
    "Last Name": "Surjadi",
    "First Name": "Niko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156277: {
    id: "item_33269",
    "Last Name": "Mmaone",
    "First Name": "Rose",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156283: {
    id: "item_31618",
    "Last Name": "Li",
    "First Name": "Wing Man",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156296: {
    id: "item_8152",
    "Last Name": "Dundon",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156303: {
    id: "item_8151",
    "Last Name": "Braid",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156359: {
    id: "item_8113",
    "Last Name": "Addo",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156364: {
    id: "item_19373",
    "Last Name": "Susilo",
    "First Name": "Osmar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156392: {
    id: "item_8143",
    "Last Name": "learmonth",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156400: {
    id: "item_33259",
    "Last Name": "Carey",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156403: {
    id: "item_31621",
    "Last Name": "Ferretti",
    "First Name": "Ilenia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156405: {
    id: "item_31620",
    "Last Name": "Allport",
    "First Name": "Bek",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156406: {
    id: "item_33264",
    "Last Name": "Carty",
    "First Name": "Sarah-louise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156453: {
    id: "item_8146",
    "Last Name": "Wilding",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156467: {
    id: "item_20930",
    "Last Name": "Masters",
    "First Name": "Benn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156468: {
    id: "item_31604",
    "Last Name": "Valentine",
    "First Name": "Katy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156479: {
    id: "item_31611",
    "Last Name": "Winata",
    "First Name": "Felix",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156488: {
    id: "item_8142",
    "Last Name": "Guignard",
    "First Name": "Anouk",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156526: {
    id: "item_20922",
    "Last Name": "Alanis",
    "First Name": "Alena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156551: {
    id: "item_5801",
    "Last Name": "Gaunt",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156571: {
    id: "item_31606",
    "Last Name": "Radtke",
    "First Name": "Bianka",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156574: {
    id: "item_8135",
    "Last Name": "Carter",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156615: {
    id: "item_8132",
    "Last Name": "Samaniego",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156616: {
    id: "item_33937",
    "Last Name": "Colunga Hernandez",
    "First Name": "Juan Fernando",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156635: {
    id: "item_20916",
    "Last Name": "Raccanello",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156655: {
    id: "item_8136",
    "Last Name": "Tagore",
    "First Name": "Sharan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156675: {
    id: "item_8128",
    "Last Name": "Zea Fernandez",
    "First Name": "Melisa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156676: {
    id: "item_33251",
    "Last Name": "Russell",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156683: {
    id: "item_8130",
    "Last Name": "Zotova",
    "First Name": "Maryna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156708: {
    id: "item_31603",
    "Last Name": "Plomer",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156770: {
    id: "item_31601",
    "Last Name": "ALLEN",
    "First Name": "YVONNE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156794: {
    id: "item_5799",
    "Last Name": "Yang",
    "First Name": "Erin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156836: {
    id: "item_33245",
    "Last Name": "OÕNeal",
    "First Name": "Kasey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156858: {
    id: "item_33239",
    "Last Name": "Phalanisong",
    "First Name": "Wannapha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156888: {
    id: "item_31599",
    "Last Name": "Mizzi",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156923: {
    id: "item_31597",
    "Last Name": "Siale",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156939: {
    id: "item_21370",
    "Last Name": "JIA",
    "First Name": "SIYI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156948: {
    id: "item_20905",
    "Last Name": "caruso",
    "First Name": "ngaire",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156954: {
    id: "item_8124",
    "Last Name": "sanders",
    "First Name": "melissa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156956: {
    id: "item_31589",
    "Last Name": "Raeburn",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37156962: {
    id: "item_20899",
    "Last Name": "Aksoy Aciloglu",
    "First Name": "Ayse",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157030: {
    id: "item_20894",
    "Last Name": "Tan",
    "First Name": "Haan Chiang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157032: {
    id: "item_31596",
    "Last Name": "Jackson",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157035: {
    id: "item_20890",
    "Last Name": "Dillon",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157037: {
    id: "item_33236",
    "Last Name": "Agorilla",
    "First Name": "Zoe Anika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157046: {
    id: "item_8122",
    "Last Name": "Fisher",
    "First Name": "Keri",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157060: {
    id: "item_20896",
    "Last Name": "Taylor",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157064: {
    id: "item_31593",
    "Last Name": "Walker",
    "First Name": "Bridin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157070: {
    id: "item_31592",
    "Last Name": "Ignacio",
    "First Name": "Mailene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157145: {
    id: "item_20892",
    "Last Name": "Cranstoun",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157153: {
    id: "item_33220",
    "Last Name": "Widjanarka",
    "First Name": "Chandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157163: {
    id: "item_33235",
    "Last Name": "Eamraksa",
    "First Name": "Phailin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157204: {
    id: "item_20891",
    "Last Name": "Makina",
    "First Name": "Moyra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157214: {
    id: "item_8115",
    "Last Name": "Salazar",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157228: {
    id: "item_31577",
    "Last Name": "coutts",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157241: {
    id: "item_33217",
    "Last Name": "Glanzmann",
    "First Name": "Carole",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157269: {
    id: "item_8111",
    "Last Name": "Parletta",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157270: {
    id: "item_33230",
    "Last Name": "Tumurkhuyag",
    "First Name": "Ariunjargal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157317: {
    id: "item_20883",
    "Last Name": "Cooper",
    "First Name": "Blaine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157340: {
    id: "item_31584",
    "Last Name": "Donovan",
    "First Name": "Dean",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157347: {
    id: "item_20870",
    "Last Name": "Parekh",
    "First Name": "Rosita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157446: {
    id: "item_8102",
    "Last Name": "Rijks",
    "First Name": "Jim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157481: {
    id: "item_8099",
    "Last Name": "Winyard",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157550: {
    id: "item_20874",
    "Last Name": "Mikhail",
    "First Name": "Deena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157554: {
    id: "item_8100",
    "Last Name": "O'Neil",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157668: {
    id: "item_33218",
    "Last Name": "Suda",
    "First Name": "Mia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157676: {
    id: "item_33204",
    "Last Name": "Tang",
    "First Name": "Taomin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157687: {
    id: "item_31563",
    "Last Name": "Trirahadi",
    "First Name": "Aji",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157691: {
    id: "item_33221",
    "Last Name": "Blyth",
    "First Name": "Leila",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157694: {
    id: "item_8096",
    "Last Name": "Gerakiteys",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157706: {
    id: "item_31565",
    "Last Name": "Stockdale",
    "First Name": "Matt",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157715: {
    id: "item_5796",
    "Last Name": "Francisco",
    "First Name": "Jean-Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157748: {
    id: "item_20868",
    "Last Name": "Wu",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157782: {
    id: "item_8086",
    "Last Name": "Tinsley",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157787: {
    id: "item_8091",
    "Last Name": "Ghee",
    "First Name": "Kelsey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157821: {
    id: "item_20866",
    "Last Name": "Redaelli",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157875: {
    id: "item_8087",
    "Last Name": "Leung",
    "First Name": "Ivy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157889: {
    id: "item_20861",
    "Last Name": "Nealy",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157912: {
    id: "item_8075",
    "Last Name": "Natoli",
    "First Name": "Angela",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157919: {
    id: "item_8083",
    "Last Name": "Whittle",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157936: {
    id: "item_33207",
    "Last Name": "McGenity",
    "First Name": "Eugenia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157939: {
    id: "item_19372",
    "Last Name": "kerr",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157965: {
    id: "item_31559",
    "Last Name": "Boue",
    "First Name": "Llilian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37157998: {
    id: "item_20860",
    "Last Name": "Bowers",
    "First Name": "Sharmini",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158049: {
    id: "item_33203",
    "Last Name": "Blomqvist",
    "First Name": "Charlotta",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158114: {
    id: "item_8078",
    "Last Name": "Chau",
    "First Name": "Nixon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158151: {
    id: "item_33196",
    "Last Name": "Sabong",
    "First Name": "Viven Christian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158163: {
    id: "item_20850",
    "Last Name": "Siuhengalu",
    "First Name": "Fine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158268: {
    id: "item_8058",
    "Last Name": "Laub",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158280: {
    id: "item_8070",
    "Last Name": "Rand",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158283: {
    id: "item_8069",
    "Last Name": "Tyler-Whiteman",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158317: {
    id: "item_33187",
    "Last Name": "Kurniawan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158358: {
    id: "item_20846",
    "Last Name": "Anderson",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158397: {
    id: "item_8065",
    "Last Name": "Chan",
    "First Name": "Wai Keung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158460: {
    id: "item_20833",
    "Last Name": "Thomas",
    "First Name": "Colin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158487: {
    id: "item_20841",
    "Last Name": "Burnett",
    "First Name": "Sharni",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158500: {
    id: "item_33183",
    "Last Name": "Graham",
    "First Name": "Shana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158507: {
    id: "item_8061",
    "Last Name": "Xing",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158521: {
    id: "item_8044",
    "Last Name": "Pozzi",
    "First Name": "Tram",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158590: {
    id: "item_20834",
    "Last Name": "Gaunt",
    "First Name": "Heather",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158595: {
    id: "item_31539",
    "Last Name": "Goss",
    "First Name": "Karly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158630: {
    id: "item_8827",
    "Last Name": "Chung",
    "First Name": "Ted Onn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158681: {
    id: "item_8054",
    "Last Name": "MARTONI",
    "First Name": "FRANCESCO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158698: {
    id: "item_8052",
    "Last Name": "Chuah",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158700: {
    id: "item_20831",
    "Last Name": "Narula",
    "First Name": "Trishika",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158709: {
    id: "item_20828",
    "Last Name": "Dempsey",
    "First Name": "Di",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158716: {
    id: "item_8050",
    "Last Name": "Simmons",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158746: {
    id: "item_20824",
    "Last Name": "CAI",
    "First Name": "ADELE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158748: {
    id: "item_8043",
    "Last Name": "Tang",
    "First Name": "Huifang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158770: {
    id: "item_8042",
    "Last Name": "SHENG",
    "First Name": "LIUHAI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158778: {
    id: "item_31534",
    "Last Name": "Ignacio",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158796: {
    id: "item_20823",
    "Last Name": "Bueno Pires",
    "First Name": "Livia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158818: {
    id: "item_20822",
    "Last Name": "Ryan",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158847: {
    id: "item_31530",
    "Last Name": "KLEIN MARODIN",
    "First Name": "JOYCE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158851: {
    id: "item_20812",
    "Last Name": "Lau",
    "First Name": "Pui Yi Pamela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158883: {
    id: "item_8039",
    "Last Name": "Bowen",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158904: {
    id: "item_20815",
    "Last Name": "Raharjo",
    "First Name": "trisno",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158921: {
    id: "item_20811",
    "Last Name": "Robles Lopez",
    "First Name": "Aude",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158923: {
    id: "item_20807",
    "Last Name": "Francesconi",
    "First Name": "Mia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158995: {
    id: "item_33169",
    "Last Name": "van Zijl",
    "First Name": "Christa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37158998: {
    id: "item_20809",
    "Last Name": "Wilson",
    "First Name": "Annalise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159026: {
    id: "item_19371",
    "Last Name": "Forster",
    "First Name": "Fred",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159049: {
    id: "item_8036",
    "Last Name": "Malreddy",
    "First Name": "Raghu Veera Reddy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159052: {
    id: "item_8037",
    "Last Name": "MacLeod-Smith",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159060: {
    id: "item_8034",
    "Last Name": "McClanachan",
    "First Name": "Lisca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159073: {
    id: "item_33168",
    "Last Name": "Allen",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159107: {
    id: "item_31523",
    "Last Name": "Lim",
    "First Name": "Shyang Guey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159112: {
    id: "item_20796",
    "Last Name": "Anthes",
    "First Name": "Brady",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159122: {
    id: "item_20803",
    "Last Name": "Martinez",
    "First Name": "Julio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159124: {
    id: "item_31519",
    "Last Name": "Glasgow",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159161: {
    id: "item_33162",
    "Last Name": "Yin",
    "First Name": "jiruo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159179: {
    id: "item_33153",
    "Last Name": "Manago",
    "First Name": "Jacqueline Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159218: {
    id: "item_5789",
    "Last Name": "Gestro",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159219: {
    id: "item_8031",
    "Last Name": "Munde",
    "First Name": "Aniruddh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159222: {
    id: "item_32235",
    "Last Name": "Bord—n",
    "First Name": "Ana Cristina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159233: {
    id: "item_31521",
    "Last Name": "Cui",
    "First Name": "Yu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159250: {
    id: "item_20791",
    "Last Name": "Tran",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159260: {
    id: "item_8032",
    "Last Name": "lee",
    "First Name": "huiju",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159297: {
    id: "item_19370",
    "Last Name": "Tancred",
    "First Name": "Grayce",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159299: {
    id: "item_33157",
    "Last Name": "Cramsie",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159303: {
    id: "item_20799",
    "Last Name": "Giesser",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159311: {
    id: "item_20789",
    "Last Name": "Lau Seng Wah",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159313: {
    id: "item_20793",
    "Last Name": "Flores",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159391: {
    id: "item_20790",
    "Last Name": "Ton",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159398: {
    id: "item_8029",
    "Last Name": "Zeitoune",
    "First Name": "Marwan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159444: {
    id: "item_31510",
    "Last Name": "Jones",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159517: {
    id: "item_8025",
    "Last Name": "Ng",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159588: {
    id: "item_6569",
    "Last Name": "Engel",
    "First Name": "Leah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159590: {
    id: "item_20786",
    "Last Name": "Dao",
    "First Name": "Uyen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159602: {
    id: "item_8024",
    "Last Name": "Lynch",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159617: {
    id: "item_8018",
    "Last Name": "Knoester",
    "First Name": "Lizil",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159621: {
    id: "item_31507",
    "Last Name": "Teague",
    "First Name": "Kayleigh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159627: {
    id: "item_31504",
    "Last Name": "Firmeza",
    "First Name": "Sheryl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159678: {
    id: "item_31505",
    "Last Name": "Coffill",
    "First Name": "Nicki",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159689: {
    id: "item_32234",
    "Last Name": "Lau",
    "First Name": "Wing Yan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159703: {
    id: "item_33141",
    "Last Name": "Baulch",
    "First Name": "Annalise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159725: {
    id: "item_8012",
    "Last Name": "Khustiadi",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159735: {
    id: "item_33936",
    "Last Name": "satrioprojo",
    "First Name": "dymas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159736: {
    id: "item_8019",
    "Last Name": "conchar",
    "First Name": "melissa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159761: {
    id: "item_6487",
    "Last Name": "Penaloza Ortiz",
    "First Name": "Anthony saul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159779: {
    id: "item_8000",
    "Last Name": "Plummer",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159784: {
    id: "item_20777",
    "Last Name": "West",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159787: {
    id: "item_8015",
    "Last Name": "Lombardi",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159800: {
    id: "item_8014",
    "Last Name": "Richter",
    "First Name": "Alexandria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159809: {
    id: "item_33143",
    "Last Name": "Cardone",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159832: {
    id: "item_33145",
    "Last Name": "Myall",
    "First Name": "Shaan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159843: {
    id: "item_31498",
    "Last Name": "Chau",
    "First Name": "Lai Fong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159897: {
    id: "item_31496",
    "Last Name": "Brett",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159943: {
    id: "item_31495",
    "Last Name": "Ramirez",
    "First Name": "David Edison",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159951: {
    id: "item_33935",
    "Last Name": "Gaspard",
    "First Name": "Elizabeth Jade",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159956: {
    id: "item_8010",
    "Last Name": "Mangiapane",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37159958: {
    id: "item_5786",
    "Last Name": "ZHOU",
    "First Name": "TAO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160020: {
    id: "item_20771",
    "Last Name": "Kabastanakis",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160033: {
    id: "item_20770",
    "Last Name": "Abrahams",
    "First Name": "Barry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160054: {
    id: "item_8008",
    "Last Name": "Shepherd",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160173: {
    id: "item_31489",
    "Last Name": "Hough",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160183: {
    id: "item_8004",
    "Last Name": "Kassam",
    "First Name": "Maya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160204: {
    id: "item_8003",
    "Last Name": "Clifford",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160217: {
    id: "item_31485",
    "Last Name": "TAN",
    "First Name": "WEE BENG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160221: {
    id: "item_20762",
    "Last Name": "Boo",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160229: {
    id: "item_8001",
    "Last Name": "Palmer",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160306: {
    id: "item_8879",
    "Last Name": "Cohen",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160322: {
    id: "item_33128",
    "Last Name": "Gabiola",
    "First Name": "Marlo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160348: {
    id: "item_6568",
    "Last Name": "James",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160361: {
    id: "item_20757",
    "Last Name": "Kim",
    "First Name": "Jun Min",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160386: {
    id: "item_20759",
    "Last Name": "Sayce",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160444: {
    id: "item_33123",
    "Last Name": "Thamchoto",
    "First Name": "Teewara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160518: {
    id: "item_8878",
    "Last Name": "Loo",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160522: {
    id: "item_7990",
    "Last Name": "Power",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160542: {
    id: "item_20754",
    "Last Name": "Miller",
    "First Name": "Shay",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160581: {
    id: "item_21252",
    "Last Name": "Dawson",
    "First Name": "Kerri",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160622: {
    id: "item_8624",
    "Last Name": "Burchill",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160634: {
    id: "item_33665",
    "Last Name": "Wear",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160674: {
    id: "item_33663",
    "Last Name": "CUNCHALA",
    "First Name": "Shravan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160702: {
    id: "item_6033",
    "Last Name": "Finnie",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160721: {
    id: "item_21248",
    "Last Name": "Jimenez",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160743: {
    id: "item_8620",
    "Last Name": "Qasem",
    "First Name": "Yasmine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160778: {
    id: "item_8618",
    "Last Name": "Weir",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160814: {
    id: "item_6023",
    "Last Name": "Weir",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160829: {
    id: "item_33658",
    "Last Name": "Kuhne",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160891: {
    id: "item_8613",
    "Last Name": "Burke",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160892: {
    id: "item_8611",
    "Last Name": "Daly",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160896: {
    id: "item_33652",
    "Last Name": "Heath",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160918: {
    id: "item_8609",
    "Last Name": "Kwok",
    "First Name": "Wing Yin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160924: {
    id: "item_5996",
    "Last Name": "East",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160955: {
    id: "item_33651",
    "Last Name": "Niagara",
    "First Name": "Duta",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37160967: {
    id: "item_8608",
    "Last Name": "Sousa",
    "First Name": "Roberta",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161002: {
    id: "item_6013",
    "Last Name": "Willett",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161008: {
    id: "item_32009",
    "Last Name": "VanAmstel",
    "First Name": "Jikki",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161013: {
    id: "item_8604",
    "Last Name": "Franklin",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161025: {
    id: "item_21241",
    "Last Name": "homsub",
    "First Name": "saravadee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161051: {
    id: "item_8602",
    "Last Name": "Liu",
    "First Name": "Xiang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161064: {
    id: "item_21239",
    "Last Name": "Huang",
    "First Name": "Rocky",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161137: {
    id: "item_5998",
    "Last Name": "Go",
    "First Name": "Mar Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161158: {
    id: "item_33649",
    "Last Name": "Aseniero",
    "First Name": "Aaron Joshua",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161169: {
    id: "item_21400",
    "Last Name": "Nash Morales",
    "First Name": "Fernanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161177: {
    id: "item_8826",
    "Last Name": "Bowry",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161186: {
    id: "item_8600",
    "Last Name": "Shore",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161196: {
    id: "item_6001",
    "Last Name": "Martin",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161226: {
    id: "item_21235",
    "Last Name": "Van zyl",
    "First Name": "Candice",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161273: {
    id: "item_5986",
    "Last Name": "Hartshorn",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161276: {
    id: "item_8593",
    "Last Name": "Back",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161278: {
    id: "item_5994",
    "Last Name": "Fifield",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161286: {
    id: "item_33646",
    "Last Name": "Prajapati",
    "First Name": "Mayank",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161328: {
    id: "item_21230",
    "Last Name": "Baxter",
    "First Name": "Nisaa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161352: {
    id: "item_5991",
    "Last Name": "Cvitanovich",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161374: {
    id: "item_5988",
    "Last Name": "Corr",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161387: {
    id: "item_33638",
    "Last Name": "BADRAZAMANI",
    "First Name": "DANI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161410: {
    id: "item_21228",
    "Last Name": "Gordon",
    "First Name": "Carrie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161490: {
    id: "item_21227",
    "Last Name": "HARRIS",
    "First Name": "BRADY",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161514: {
    id: "item_5973",
    "Last Name": "Peeters",
    "First Name": "Sue",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161523: {
    id: "item_5978",
    "Last Name": "Rains",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161533: {
    id: "item_31997",
    "Last Name": "Marrone",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161535: {
    id: "item_33632",
    "Last Name": "Bin Mohmad Sah",
    "First Name": "Nuaim Nukman",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161547: {
    id: "item_33874",
    "Last Name": "Osman",
    "First Name": "Listyawati",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161563: {
    id: "item_8588",
    "Last Name": "Yoon",
    "First Name": "Hanchul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161572: {
    id: "item_18587",
    "Last Name": "LEE",
    "First Name": "___",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161621: {
    id: "item_8584",
    "Last Name": "Park",
    "First Name": "Erin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161624: {
    id: "item_33621",
    "Last Name": "Liwanag",
    "First Name": "Norman",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161669: {
    id: "item_33626",
    "Last Name": "BIN WAN SAPIAN SORI",
    "First Name": "WAN MOHD KHALIL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161673: {
    id: "item_8582",
    "Last Name": "Morrison",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161691: {
    id: "item_8578",
    "Last Name": "Cesaroni",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161700: {
    id: "item_21221",
    "Last Name": "Lee",
    "First Name": "Rue Shen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161720: {
    id: "item_8581",
    "Last Name": "Allen",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161726: {
    id: "item_5967",
    "Last Name": "Lim",
    "First Name": "Ee Kim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161753: {
    id: "item_8579",
    "Last Name": "Buckingham",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161770: {
    id: "item_5968",
    "Last Name": "Tan",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161782: {
    id: "item_21199",
    "Last Name": "Ngo",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161790: {
    id: "item_5961",
    "Last Name": "Best",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161813: {
    id: "item_33620",
    "Last Name": "James",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161818: {
    id: "item_5959",
    "Last Name": "Shine",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161827: {
    id: "item_5966",
    "Last Name": "Wong",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161830: {
    id: "item_5944",
    "Last Name": "Cha",
    "First Name": "Jeonghwan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161840: {
    id: "item_8560",
    "Last Name": "Wang",
    "First Name": "Li-Li",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161887: {
    id: "item_5956",
    "Last Name": "Wong",
    "First Name": "Tsz Wai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161897: {
    id: "item_8877",
    "Last Name": "HU",
    "First Name": "JHYFANG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161905: {
    id: "item_8572",
    "Last Name": "Utojo",
    "First Name": "Agus Salim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161922: {
    id: "item_33616",
    "Last Name": "Rian",
    "First Name": "Muhamad",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161950: {
    id: "item_8575",
    "Last Name": "Phan",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161953: {
    id: "item_19369",
    "Last Name": "Keith",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161968: {
    id: "item_33617",
    "Last Name": "Ross",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161982: {
    id: "item_31986",
    "Last Name": "Lynch",
    "First Name": "Doreen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37161988: {
    id: "item_8573",
    "Last Name": "Cowey",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162001: {
    id: "item_5951",
    "Last Name": "Karunakalage",
    "First Name": "Chinthaka",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162010: {
    id: "item_5942",
    "Last Name": "green",
    "First Name": "cooper",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162043: {
    id: "item_33606",
    "Last Name": "connolly",
    "First Name": "margaret",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162048: {
    id: "item_33615",
    "Last Name": "Perilla",
    "First Name": "Jessenia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162050: {
    id: "item_5949",
    "Last Name": "Cuasay",
    "First Name": "Jules",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162114: {
    id: "item_33612",
    "Last Name": "Kayser",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162127: {
    id: "item_33611",
    "Last Name": "MacRaild",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162222: {
    id: "item_33609",
    "Last Name": "tripathi",
    "First Name": "satyendra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162237: {
    id: "item_5930",
    "Last Name": "Healey",
    "First Name": "Kirsten",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162244: {
    id: "item_31982",
    "Last Name": "Barral",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162285: {
    id: "item_21205",
    "Last Name": "Sanders",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162294: {
    id: "item_8559",
    "Last Name": "Koury",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162331: {
    id: "item_21206",
    "Last Name": "Goodrick",
    "First Name": "Delwyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162334: {
    id: "item_33605",
    "Last Name": "Vo",
    "First Name": "Aloysius",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162348: {
    id: "item_8558",
    "Last Name": "Byers",
    "First Name": "Renee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162352: {
    id: "item_21203",
    "Last Name": "Dennis",
    "First Name": "Maxwell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162400: {
    id: "item_33600",
    "Last Name": "Prasetyo",
    "First Name": "Ngudiono",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162436: {
    id: "item_5920",
    "Last Name": "CHIU",
    "First Name": "Terry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162442: {
    id: "item_5921",
    "Last Name": "Jongeling",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162510: {
    id: "item_33591",
    "Last Name": "McMahon",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162531: {
    id: "item_8555",
    "Last Name": "Cella",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162551: {
    id: "item_5915",
    "Last Name": "Balasuriya",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162555: {
    id: "item_8552",
    "Last Name": "Colovic",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162573: {
    id: "item_31977",
    "Last Name": "Monsalud",
    "First Name": "Marko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162575: {
    id: "item_8549",
    "Last Name": "Lau",
    "First Name": "Shuk Yi Angela",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162615: {
    id: "item_33588",
    "Last Name": "John",
    "First Name": "Mades",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162638: {
    id: "item_6567",
    "Last Name": "Rose",
    "First Name": "Hunter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162663: {
    id: "item_5907",
    "Last Name": "Arrowsmith",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162678: {
    id: "item_31974",
    "Last Name": "Chikuruwo",
    "First Name": "Rufaro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162679: {
    id: "item_33585",
    "Last Name": "Conway",
    "First Name": "Krystal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162680: {
    id: "item_33571",
    "Last Name": "Duncan",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162688: {
    id: "item_19368",
    "Last Name": "Toro",
    "First Name": "Paulina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162703: {
    id: "item_33934",
    "Last Name": "Campbell",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162743: {
    id: "item_5906",
    "Last Name": "Sugars",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162747: {
    id: "item_21196",
    "Last Name": "Hopkins",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162768: {
    id: "item_5885",
    "Last Name": "Twartz",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162780: {
    id: "item_33587",
    "Last Name": "Sealey",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162782: {
    id: "item_5903",
    "Last Name": "OÕBrien",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162792: {
    id: "item_5900",
    "Last Name": "JOHNSON",
    "First Name": "CHRISTOPHER",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162796: {
    id: "item_5902",
    "Last Name": "Chalmers",
    "First Name": "Calum",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162802: {
    id: "item_33584",
    "Last Name": "Asetre",
    "First Name": "Jo Hannah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162852: {
    id: "item_5887",
    "Last Name": "Earner",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162873: {
    id: "item_33583",
    "Last Name": "Ruzlan",
    "First Name": "Muhamad Ridhwan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162891: {
    id: "item_21190",
    "Last Name": "Moore",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162898: {
    id: "item_31965",
    "Last Name": "Anglade",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162925: {
    id: "item_8527",
    "Last Name": "ZHANG",
    "First Name": "BEI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162954: {
    id: "item_5891",
    "Last Name": "Meade",
    "First Name": "Kaspar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162960: {
    id: "item_33582",
    "Last Name": "Imel",
    "First Name": "Gretchen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162965: {
    id: "item_5886",
    "Last Name": "Alonzo",
    "First Name": "Kim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37162973: {
    id: "item_33873",
    "Last Name": "Lau Ming King",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163029: {
    id: "item_8537",
    "Last Name": "Kusic",
    "First Name": "Noah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163037: {
    id: "item_31961",
    "Last Name": "Boyle",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163040: {
    id: "item_21187",
    "Last Name": "Way",
    "First Name": "Damien",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163052: {
    id: "item_33933",
    "Last Name": "Yee",
    "First Name": "Kai Sian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163106: {
    id: "item_5878",
    "Last Name": "Castle",
    "First Name": "Trent",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163124: {
    id: "item_33577",
    "Last Name": "Chan",
    "First Name": "Annie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163125: {
    id: "item_31956",
    "Last Name": "Lowe",
    "First Name": "Moi Moi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163153: {
    id: "item_8534",
    "Last Name": "Jiang",
    "First Name": "Bing",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163236: {
    id: "item_5862",
    "Last Name": "KIM",
    "First Name": "KWIYOUNG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163279: {
    id: "item_31953",
    "Last Name": "Smith",
    "First Name": "Greg",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163283: {
    id: "item_33576",
    "Last Name": "Cameron",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163328: {
    id: "item_33575",
    "Last Name": "Laro",
    "First Name": "Raquel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163330: {
    id: "item_5866",
    "Last Name": "Twartz",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163354: {
    id: "item_31951",
    "Last Name": "Yan",
    "First Name": "pengpeng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163409: {
    id: "item_21173",
    "Last Name": "Narang",
    "First Name": "Thepanant",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163418: {
    id: "item_5856",
    "Last Name": "Angeles",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163422: {
    id: "item_31943",
    "Last Name": "Corpuz",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163437: {
    id: "item_8825",
    "Last Name": "HU",
    "First Name": "LEIHONG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163472: {
    id: "item_31949",
    "Last Name": "Cunningham",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163500: {
    id: "item_31945",
    "Last Name": "Tuite",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163509: {
    id: "item_21399",
    "Last Name": "Chou",
    "First Name": "Tzu-Heng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163520: {
    id: "item_5826",
    "Last Name": "OÕBrien",
    "First Name": "Annie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163542: {
    id: "item_5845",
    "Last Name": "Waycott",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163543: {
    id: "item_31940",
    "Last Name": "BUAWANNGAM",
    "First Name": "THANTIPONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163560: {
    id: "item_8522",
    "Last Name": "CHO",
    "First Name": "YEONHO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163567: {
    id: "item_5846",
    "Last Name": "LEE",
    "First Name": "JIA GEN IVAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163572: {
    id: "item_31944",
    "Last Name": "Frogley",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163599: {
    id: "item_5850",
    "Last Name": "Hibbins",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163610: {
    id: "item_8520",
    "Last Name": "Nielsen",
    "First Name": "Cathrine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163642: {
    id: "item_31939",
    "Last Name": "Dickson",
    "First Name": "Khew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163733: {
    id: "item_8514",
    "Last Name": "Bartley",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163752: {
    id: "item_31936",
    "Last Name": "Arellano",
    "First Name": "Beatriz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163762: {
    id: "item_31934",
    "Last Name": "Tejero",
    "First Name": "Shareen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163775: {
    id: "item_5834",
    "Last Name": "Chan",
    "First Name": "Pak hung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163810: {
    id: "item_31931",
    "Last Name": "Vilchis",
    "First Name": "Carmen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163819: {
    id: "item_5825",
    "Last Name": "MACHADO HAESBAERT",
    "First Name": "CRISTIAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163831: {
    id: "item_8510",
    "Last Name": "Aspinall",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163834: {
    id: "item_31933",
    "Last Name": "Corpuz",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163877: {
    id: "item_8509",
    "Last Name": "Wheatley",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163923: {
    id: "item_21167",
    "Last Name": "Goodlet",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37163964: {
    id: "item_33557",
    "Last Name": "Hunt",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164041: {
    id: "item_33553",
    "Last Name": "VISESKOSIN",
    "First Name": "Watcharapon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164070: {
    id: "item_5822",
    "Last Name": "McAlister",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164154: {
    id: "item_5821",
    "Last Name": "Houghton",
    "First Name": "Beth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164186: {
    id: "item_33547",
    "Last Name": "Smith",
    "First Name": "Cassie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164195: {
    id: "item_31918",
    "Last Name": "MOK",
    "First Name": "CHIUN SHYONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164200: {
    id: "item_8499",
    "Last Name": "Ngan",
    "First Name": "Yat Hang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164206: {
    id: "item_31917",
    "Last Name": "Barron",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164228: {
    id: "item_33548",
    "Last Name": "Cardenas-Aviles",
    "First Name": "Gladys",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164245: {
    id: "item_33550",
    "Last Name": "Grover",
    "First Name": "Silka",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164260: {
    id: "item_21160",
    "Last Name": "Yulius",
    "First Name": "Gustav",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164284: {
    id: "item_8498",
    "Last Name": "Mohammed",
    "First Name": "Shamveel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164367: {
    id: "item_31916",
    "Last Name": "Fischer",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164380: {
    id: "item_8496",
    "Last Name": "Sayers",
    "First Name": "Isabelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164386: {
    id: "item_33545",
    "Last Name": "Salazar",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164444: {
    id: "item_8824",
    "Last Name": "park",
    "First Name": "song jun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164447: {
    id: "item_21155",
    "Last Name": "Hejeile",
    "First Name": "Andres",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164506: {
    id: "item_33542",
    "Last Name": "Spiteri",
    "First Name": "Andi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164543: {
    id: "item_31908",
    "Last Name": "Arquiza",
    "First Name": "Katlein Eisra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164562: {
    id: "item_8491",
    "Last Name": "Byrne",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164565: {
    id: "item_5820",
    "Last Name": "Quan",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164601: {
    id: "item_33538",
    "Last Name": "Bin Arshad",
    "First Name": "Mahadzer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164628: {
    id: "item_33539",
    "Last Name": "Smales",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164639: {
    id: "item_19367",
    "Last Name": "Hunter-Dickson",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164729: {
    id: "item_8484",
    "Last Name": "Yeung",
    "First Name": "Wai Shing",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164770: {
    id: "item_8472",
    "Last Name": "Phang",
    "First Name": "Riping",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164785: {
    id: "item_8487",
    "Last Name": "Johnston",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164792: {
    id: "item_31904",
    "Last Name": "Pinpin",
    "First Name": "Lem",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164803: {
    id: "item_8485",
    "Last Name": "Cancho Curioso",
    "First Name": "Diego Martin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164810: {
    id: "item_21151",
    "Last Name": "Boden",
    "First Name": "Taryn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164891: {
    id: "item_21149",
    "Last Name": "Wu",
    "First Name": "Yuting",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164927: {
    id: "item_33532",
    "Last Name": "Kaurin",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164959: {
    id: "item_8480",
    "Last Name": "Vankalken",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164980: {
    id: "item_31901",
    "Last Name": "Cunningham",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37164997: {
    id: "item_31898",
    "Last Name": "RUKMANA",
    "First Name": "YOGI ARIE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165007: {
    id: "item_31899",
    "Last Name": "Shmerling",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165077: {
    id: "item_31896",
    "Last Name": "Ford",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165080: {
    id: "item_8478",
    "Last Name": "McFarlane",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165095: {
    id: "item_8475",
    "Last Name": "Ng",
    "First Name": "Man Hin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165160: {
    id: "item_8473",
    "Last Name": "Lugo Roman",
    "First Name": "Frances",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165179: {
    id: "item_8476",
    "Last Name": "O Reilly",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165288: {
    id: "item_21147",
    "Last Name": "Lyon",
    "First Name": "Teale",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165326: {
    id: "item_33932",
    "Last Name": "Godfrey",
    "First Name": "Molly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165377: {
    id: "item_8469",
    "Last Name": "Low",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165382: {
    id: "item_6486",
    "Last Name": "Shukla",
    "First Name": "Avanish K",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165384: {
    id: "item_19366",
    "Last Name": "Duangdee",
    "First Name": "Surachet",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165485: {
    id: "item_33516",
    "Last Name": "Secuya",
    "First Name": "Arthuro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165507: {
    id: "item_19365",
    "Last Name": "Pierangeli",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165512: {
    id: "item_8467",
    "Last Name": "LaCombe",
    "First Name": "Whitney",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165556: {
    id: "item_6566",
    "Last Name": "Rodriguez",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165589: {
    id: "item_8463",
    "Last Name": "Tomlins",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165718: {
    id: "item_8458",
    "Last Name": "Atkins",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165787: {
    id: "item_8455",
    "Last Name": "Walter",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165799: {
    id: "item_33512",
    "Last Name": "Salazar",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165817: {
    id: "item_33511",
    "Last Name": "Gnanananthan",
    "First Name": "Mathavakrishna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165825: {
    id: "item_19364",
    "Last Name": "Cai",
    "First Name": "Shuhang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165846: {
    id: "item_33507",
    "Last Name": "Thomas",
    "First Name": "Meghan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165890: {
    id: "item_21138",
    "Last Name": "Wilson",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37165953: {
    id: "item_8452",
    "Last Name": "Hayes",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166008: {
    id: "item_31880",
    "Last Name": "Kaye",
    "First Name": "Candice",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166083: {
    id: "item_8451",
    "Last Name": "Ulrich",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166088: {
    id: "item_31877",
    "Last Name": "Dias",
    "First Name": "Rob",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166177: {
    id: "item_21129",
    "Last Name": "Nolasco",
    "First Name": "Dale",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166258: {
    id: "item_8876",
    "Last Name": "THATTAI RANGARAJAN",
    "First Name": "Bharatram",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166284: {
    id: "item_31870",
    "Last Name": "Denton",
    "First Name": "Laurie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166407: {
    id: "item_8446",
    "Last Name": "Catt",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166422: {
    id: "item_8445",
    "Last Name": "Cheung",
    "First Name": "Janet",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166442: {
    id: "item_6565",
    "Last Name": "CHEN",
    "First Name": "HUNGHSIEN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166447: {
    id: "item_8444",
    "Last Name": "Lane",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166512: {
    id: "item_8442",
    "Last Name": "Hon",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166515: {
    id: "item_21127",
    "Last Name": "Dagan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166526: {
    id: "item_31864",
    "Last Name": "Yan",
    "First Name": "Hong Yin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166539: {
    id: "item_8441",
    "Last Name": "Dedal",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166541: {
    id: "item_19363",
    "Last Name": "Conway",
    "First Name": "Beck",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166592: {
    id: "item_31865",
    "Last Name": "Chan",
    "First Name": "Yee Sum",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166675: {
    id: "item_8439",
    "Last Name": "Elphick",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166712: {
    id: "item_8436",
    "Last Name": "Cummins",
    "First Name": "Danah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166714: {
    id: "item_8438",
    "Last Name": "zhong",
    "First Name": "fei",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166739: {
    id: "item_33490",
    "Last Name": "Pavlovic",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166757: {
    id: "item_21122",
    "Last Name": "Hatalaibessy",
    "First Name": "Daniel ricard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166861: {
    id: "item_31860",
    "Last Name": "Wang",
    "First Name": "Cara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166867: {
    id: "item_33488",
    "Last Name": "Hicks",
    "First Name": "Chantelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166871: {
    id: "item_31856",
    "Last Name": "Quach",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166883: {
    id: "item_33487",
    "Last Name": "Elson",
    "First Name": "Terry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166887: {
    id: "item_31861",
    "Last Name": "Aviles Soto",
    "First Name": "Miriam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166975: {
    id: "item_33486",
    "Last Name": "Santos",
    "First Name": "Emil Louise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166983: {
    id: "item_31853",
    "Last Name": "Bahrom",
    "First Name": "Shariz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37166995: {
    id: "item_31852",
    "Last Name": "Boonchuang",
    "First Name": "Suchintana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167022: {
    id: "item_21119",
    "Last Name": "Harby",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167051: {
    id: "item_5817",
    "Last Name": "Ravelo",
    "First Name": "Julian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167102: {
    id: "item_19227",
    "Last Name": "Madrigal Hernandez",
    "First Name": "Luis Raul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167113: {
    id: "item_33472",
    "Last Name": "BOHOL",
    "First Name": "ROSEMARIE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167161: {
    id: "item_8429",
    "Last Name": "Larkin",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167172: {
    id: "item_32233",
    "Last Name": "Riley",
    "First Name": "Lizzie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167177: {
    id: "item_31851",
    "Last Name": "Winduss",
    "First Name": "Rebekah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167202: {
    id: "item_19226",
    "Last Name": "Shafi",
    "First Name": "Faisal",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167222: {
    id: "item_33481",
    "Last Name": "Mai",
    "First Name": "Nhi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167231: {
    id: "item_21115",
    "Last Name": "Packer",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167249: {
    id: "item_31843",
    "Last Name": "Librett",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167272: {
    id: "item_31849",
    "Last Name": "Khongwut",
    "First Name": "Salinee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167289: {
    id: "item_31847",
    "Last Name": "Wan",
    "First Name": "Tak Wing",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167306: {
    id: "item_8421",
    "Last Name": "Lidden",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167310: {
    id: "item_8422",
    "Last Name": "Bosman",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167375: {
    id: "item_31835",
    "Last Name": "Murillo Ardila",
    "First Name": "Eliana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167407: {
    id: "item_31838",
    "Last Name": "Singson",
    "First Name": "Esmeralda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167418: {
    id: "item_33473",
    "Last Name": "Lantika",
    "First Name": "Nini",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167461: {
    id: "item_21111",
    "Last Name": "Collins",
    "First Name": "Jaysen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167468: {
    id: "item_8413",
    "Last Name": "Opie",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167470: {
    id: "item_21103",
    "Last Name": "Hu",
    "First Name": "Xiaoming",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167481: {
    id: "item_8414",
    "Last Name": "Cooper",
    "First Name": "Rhylie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167495: {
    id: "item_33470",
    "Last Name": "park",
    "First Name": "sungho",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167514: {
    id: "item_33468",
    "Last Name": "McCracken",
    "First Name": "Rod",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167539: {
    id: "item_21109",
    "Last Name": "Gibson",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167540: {
    id: "item_31837",
    "Last Name": "Leow",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167641: {
    id: "item_33467",
    "Last Name": "LIN",
    "First Name": "CHAO-FENG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167648: {
    id: "item_31833",
    "Last Name": "Greaves",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167742: {
    id: "item_6485",
    "Last Name": "Wu",
    "First Name": "Robin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167771: {
    id: "item_8403",
    "Last Name": "Turner",
    "First Name": "Robin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167776: {
    id: "item_8408",
    "Last Name": "Pentland",
    "First Name": "Sharaze",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167808: {
    id: "item_31828",
    "Last Name": "Lee",
    "First Name": "Ka Lok",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167823: {
    id: "item_8406",
    "Last Name": "Slee",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167847: {
    id: "item_21101",
    "Last Name": "Pasierbek",
    "First Name": "Karolina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167924: {
    id: "item_21100",
    "Last Name": "Lee",
    "First Name": "David Sang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167937: {
    id: "item_21105",
    "Last Name": "Kim",
    "First Name": "Manjin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37167964: {
    id: "item_31825",
    "Last Name": "Rodriguez",
    "First Name": "Margarita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168023: {
    id: "item_33463",
    "Last Name": "Winterhalter",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168059: {
    id: "item_8399",
    "Last Name": "Martinez",
    "First Name": "Anel Esmeralda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168060: {
    id: "item_19362",
    "Last Name": "Hsieh",
    "First Name": "Ching Hsiang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168067: {
    id: "item_31823",
    "Last Name": "Wood",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168090: {
    id: "item_21099",
    "Last Name": "Carter",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168170: {
    id: "item_33462",
    "Last Name": "Leverett",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168193: {
    id: "item_8396",
    "Last Name": "pyeon",
    "First Name": "jaeyoung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168252: {
    id: "item_21093",
    "Last Name": "Fan",
    "First Name": "Limei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168269: {
    id: "item_33460",
    "Last Name": "Wilson",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168295: {
    id: "item_31814",
    "Last Name": "Brener",
    "First Name": "Danijel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168299: {
    id: "item_8392",
    "Last Name": "Truong",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168323: {
    id: "item_33457",
    "Last Name": "Maliyekkal Thomas",
    "First Name": "Anil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168334: {
    id: "item_8388",
    "Last Name": "Teixeira Lima",
    "First Name": "Jo‹o Lucas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168401: {
    id: "item_21087",
    "Last Name": "Valdez",
    "First Name": "Eva",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168608: {
    id: "item_33452",
    "Last Name": "Truscott",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168639: {
    id: "item_21085",
    "Last Name": "Hua",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168656: {
    id: "item_8374",
    "Last Name": "Sanborn",
    "First Name": "Madison",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168676: {
    id: "item_21083",
    "Last Name": "Scherer",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168797: {
    id: "item_33446",
    "Last Name": "Randall",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168830: {
    id: "item_21082",
    "Last Name": "Prasad",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168843: {
    id: "item_33445",
    "Last Name": "Pang",
    "First Name": "Wen Ghim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168967: {
    id: "item_33443",
    "Last Name": "Carreon",
    "First Name": "Florencio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168989: {
    id: "item_31801",
    "Last Name": "Andres",
    "First Name": "Isa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37168990: {
    id: "item_33442",
    "Last Name": "Gu",
    "First Name": "Lena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37169022: {
    id: "item_8364",
    "Last Name": "Gonzalez Rivera",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37169038: {
    id: "item_33441",
    "Last Name": "Knox",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37169083: {
    id: "item_33440",
    "Last Name": "Bautista",
    "First Name": "Karl Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37169113: {
    id: "item_8360",
    "Last Name": "Perri",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37169119: {
    id: "item_31797",
    "Last Name": "Krycerova",
    "First Name": "Veronika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37169244: {
    id: "item_8359",
    "Last Name": "WANG",
    "First Name": "TENG YUNG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37169878: {
    id: "item_21077",
    "Last Name": "Collins",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37170337: {
    id: "item_33438",
    "Last Name": "PHANN",
    "First Name": "Kealeang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37170396: {
    id: "item_8355",
    "Last Name": "Harvey",
    "First Name": "Sheldon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37171202: {
    id: "item_21076",
    "Last Name": "Peabody",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37171468: {
    id: "item_31790",
    "Last Name": "MARTINO",
    "First Name": "LUCIA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37171470: {
    id: "item_8351",
    "Last Name": "Liacos",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172137: {
    id: "item_8352",
    "Last Name": "GARLICK",
    "First Name": "CHRIS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172476: {
    id: "item_8348",
    "Last Name": "Atienza",
    "First Name": "Rina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172546: {
    id: "item_21073",
    "Last Name": "Tran",
    "First Name": "Hai Nam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172547: {
    id: "item_8345",
    "Last Name": "Paintner",
    "First Name": "Crispin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172570: {
    id: "item_21069",
    "Last Name": "Stewart",
    "First Name": "Arabella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172585: {
    id: "item_31788",
    "Last Name": "Davenport",
    "First Name": "Belle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172704: {
    id: "item_31783",
    "Last Name": "Draper",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172734: {
    id: "item_21072",
    "Last Name": "Huggett",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172846: {
    id: "item_21065",
    "Last Name": "Watts",
    "First Name": "Simone",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172923: {
    id: "item_33420",
    "Last Name": "Asegurado",
    "First Name": "Clouwee Lance",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172988: {
    id: "item_8336",
    "Last Name": "Brownlow",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37172997: {
    id: "item_33418",
    "Last Name": "Wong",
    "First Name": "Godfrey Yau Meng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37173066: {
    id: "item_8332",
    "Last Name": "Hower",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37173091: {
    id: "item_21066",
    "Last Name": "Tetzner",
    "First Name": "Clayton Cristiano",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37173154: {
    id: "item_33415",
    "Last Name": "Dacres",
    "First Name": "Shellyann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37173435: {
    id: "item_19225",
    "Last Name": "Triroj",
    "First Name": "Sarit",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37173584: {
    id: "item_8330",
    "Last Name": "Pennisi",
    "First Name": "Salvatore",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37173757: {
    id: "item_33408",
    "Last Name": "Leong",
    "First Name": "Frank",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37176110: {
    id: "item_8322",
    "Last Name": "Russell",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37176202: {
    id: "item_33403",
    "Last Name": "CHEN",
    "First Name": "FENGCHAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37176372: {
    id: "item_31768",
    "Last Name": "YEUNG",
    "First Name": "CHEUKHO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37177483: {
    id: "item_31761",
    "Last Name": "Avery",
    "First Name": "Annette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37177620: {
    id: "item_31766",
    "Last Name": "Eyog",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37178749: {
    id: "item_31757",
    "Last Name": "Yeung",
    "First Name": "Chung Ho",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37178754: {
    id: "item_33398",
    "Last Name": "Solomon",
    "First Name": "Rochelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37178765: {
    id: "item_31764",
    "Last Name": "Liu",
    "First Name": "Veronica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37178793: {
    id: "item_21055",
    "Last Name": "McAlpine",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37178876: {
    id: "item_32232",
    "Last Name": "Chiempitayanuwat",
    "First Name": "Rungtham",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37179280: {
    id: "item_21053",
    "Last Name": "Reyes",
    "First Name": "Bernardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37179522: {
    id: "item_8875",
    "Last Name": "LU",
    "First Name": "LIANGCHUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37179606: {
    id: "item_8313",
    "Last Name": "Saunders",
    "First Name": "Kym",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37180686: {
    id: "item_32231",
    "Last Name": "Joestina",
    "First Name": "Elita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37181021: {
    id: "item_31755",
    "Last Name": "Sukkasem",
    "First Name": "Rodjana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37181593: {
    id: "item_31753",
    "Last Name": "Dunn",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37181643: {
    id: "item_31751",
    "Last Name": "Megat Edrus",
    "First Name": "Megat Azman",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37181668: {
    id: "item_8303",
    "Last Name": "Speakman",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37181696: {
    id: "item_31749",
    "Last Name": "Murray",
    "First Name": "Jillian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37181745: {
    id: "item_33872",
    "Last Name": "WU",
    "First Name": "KA WING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37181852: {
    id: "item_8302",
    "Last Name": "poggi",
    "First Name": "wolfango",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37181854: {
    id: "item_8301",
    "Last Name": "Chen",
    "First Name": "Bo-Rong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37181920: {
    id: "item_21046",
    "Last Name": "Parkinson",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37182797: {
    id: "item_21045",
    "Last Name": "Gunatilake",
    "First Name": "Ashera",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37183339: {
    id: "item_8298",
    "Last Name": "Elsden",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37183414: {
    id: "item_33381",
    "Last Name": "Benson",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37184709: {
    id: "item_33378",
    "Last Name": "LI",
    "First Name": "CHENXI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37184713: {
    id: "item_31745",
    "Last Name": "Bing sheng",
    "First Name": "Chen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37184840: {
    id: "item_19361",
    "Last Name": "KIM",
    "First Name": "JAEHYUN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37184849: {
    id: "item_8290",
    "Last Name": "adam",
    "First Name": "adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37184851: {
    id: "item_21042",
    "Last Name": "Sari",
    "First Name": "Distanty Kartika",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37184859: {
    id: "item_31742",
    "Last Name": "WADDINGTON",
    "First Name": "NICKIE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37184879: {
    id: "item_8874",
    "Last Name": "Ruscoe",
    "First Name": "Jon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37184902: {
    id: "item_31740",
    "Last Name": "Bali",
    "First Name": "Reyhan Tenri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37186788: {
    id: "item_8873",
    "Last Name": "Lee",
    "First Name": "Sanggun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187347: {
    id: "item_8284",
    "Last Name": "Tangtanawat",
    "First Name": "Sudarat",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187350: {
    id: "item_8288",
    "Last Name": "DiDonato-Sroczenski",
    "First Name": "Gia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187497: {
    id: "item_8286",
    "Last Name": "Gillmer",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187530: {
    id: "item_8285",
    "Last Name": "Canty",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187548: {
    id: "item_31733",
    "Last Name": "McElroy",
    "First Name": "Joye",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187561: {
    id: "item_31732",
    "Last Name": "Goldsmith",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187580: {
    id: "item_33931",
    "Last Name": "Moffat",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187602: {
    id: "item_31731",
    "Last Name": "ABINAN",
    "First Name": "CHARISE MAE TUBERA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187613: {
    id: "item_33365",
    "Last Name": "Keroulis",
    "First Name": "Dina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37187628: {
    id: "item_33363",
    "Last Name": "Noviar",
    "First Name": "Namirah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37188671: {
    id: "item_8276",
    "Last Name": "Cotter",
    "First Name": "Enda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37189176: {
    id: "item_33362",
    "Last Name": "YACOBELLIS",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37189952: {
    id: "item_31722",
    "Last Name": "Aina",
    "First Name": "Fatimah Al",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37189964: {
    id: "item_31723",
    "Last Name": "Paliauhoetomo",
    "First Name": "Agnes",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37191361: {
    id: "item_31720",
    "Last Name": "Lim",
    "First Name": "Angela Charmagne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37191825: {
    id: "item_31718",
    "Last Name": "Carr",
    "First Name": "Tina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192075: {
    id: "item_8270",
    "Last Name": "Jackson",
    "First Name": "Kimmy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192125: {
    id: "item_21033",
    "Last Name": "Yao",
    "First Name": "Xue Bo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192269: {
    id: "item_31714",
    "Last Name": "Li",
    "First Name": "Mengyun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192291: {
    id: "item_19360",
    "Last Name": "UN",
    "First Name": "CHI PANG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192349: {
    id: "item_31711",
    "Last Name": "Tanara",
    "First Name": "Crystal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192482: {
    id: "item_33350",
    "Last Name": "xie",
    "First Name": "xiaohong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192521: {
    id: "item_8265",
    "Last Name": "Nguyen",
    "First Name": "Khang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192523: {
    id: "item_31708",
    "Last Name": "Pfeffer",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192606: {
    id: "item_8263",
    "Last Name": "Kershaw",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192714: {
    id: "item_5809",
    "Last Name": "Haugen",
    "First Name": "Brock",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192745: {
    id: "item_31703",
    "Last Name": "McPhail",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192838: {
    id: "item_33347",
    "Last Name": "Saparman",
    "First Name": "Khalis Afiq",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192866: {
    id: "item_21023",
    "Last Name": "Wickham",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192882: {
    id: "item_31701",
    "Last Name": "Xu",
    "First Name": "Meng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192939: {
    id: "item_33345",
    "Last Name": "Tilo",
    "First Name": "Elaine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192947: {
    id: "item_8256",
    "Last Name": "Li",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37192991: {
    id: "item_19359",
    "Last Name": "Canlas",
    "First Name": "Josaiah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193060: {
    id: "item_31696",
    "Last Name": "Minney-Smith",
    "First Name": "Cara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193155: {
    id: "item_8252",
    "Last Name": "Kang",
    "First Name": "Minsung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193167: {
    id: "item_33341",
    "Last Name": "Hamilton",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193213: {
    id: "item_31691",
    "Last Name": "Peazold",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193237: {
    id: "item_8250",
    "Last Name": "Fisher",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193256: {
    id: "item_31690",
    "Last Name": "Whitehead",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193306: {
    id: "item_33340",
    "Last Name": "Walmsley",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193363: {
    id: "item_21014",
    "Last Name": "Holmes",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193377: {
    id: "item_8248",
    "Last Name": "Mcgeady",
    "First Name": "Elise",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193417: {
    id: "item_33338",
    "Last Name": "McAvoy",
    "First Name": "Elena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193441: {
    id: "item_21010",
    "Last Name": "Aspridis",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193456: {
    id: "item_8872",
    "Last Name": "Nafi adhani",
    "First Name": "M rizki",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193509: {
    id: "item_32230",
    "Last Name": "Smith",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193529: {
    id: "item_31683",
    "Last Name": "Ling",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193530: {
    id: "item_31686",
    "Last Name": "Dewi",
    "First Name": "Tycia Angeline Surya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193531: {
    id: "item_8244",
    "Last Name": "Dickson",
    "First Name": "Barry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193536: {
    id: "item_8243",
    "Last Name": "Zhou",
    "First Name": "Bo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193565: {
    id: "item_31682",
    "Last Name": "Evans",
    "First Name": "Daisy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193582: {
    id: "item_8241",
    "Last Name": "Ly",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193679: {
    id: "item_33331",
    "Last Name": "Rohan",
    "First Name": "Nerissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193686: {
    id: "item_8238",
    "Last Name": "Thomas",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193717: {
    id: "item_8237",
    "Last Name": "Porter",
    "First Name": "Jill",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193816: {
    id: "item_33327",
    "Last Name": "McDonald",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193847: {
    id: "item_33930",
    "Last Name": "Grinter",
    "First Name": "Russell",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193886: {
    id: "item_8234",
    "Last Name": "Hargreaves",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193922: {
    id: "item_32229",
    "Last Name": "Chan",
    "First Name": "Zenobia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193953: {
    id: "item_33325",
    "Last Name": "Casta–eda",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37193959: {
    id: "item_33326",
    "Last Name": "Zhang",
    "First Name": "Zhiqian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37194314: {
    id: "item_21398",
    "Last Name": "Harrington",
    "First Name": "Letitia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37194343: {
    id: "item_8228",
    "Last Name": "golshevsky",
    "First Name": "corinne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37194379: {
    id: "item_5807",
    "Last Name": "Sukamto",
    "First Name": "Anjarini",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37194400: {
    id: "item_5806",
    "Last Name": "Ka tou",
    "First Name": "Che",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37194885: {
    id: "item_33320",
    "Last Name": "NOFITA",
    "First Name": "NADYA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37194939: {
    id: "item_21000",
    "Last Name": "Zeffert",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37194971: {
    id: "item_31672",
    "Last Name": "Hyam",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37194972: {
    id: "item_8216",
    "Last Name": "Boyd",
    "First Name": "Kerri-Lyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37194995: {
    id: "item_31671",
    "Last Name": "Termsedcharoen",
    "First Name": "Oranas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195041: {
    id: "item_33317",
    "Last Name": "Khayat",
    "First Name": "Nuha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195516: {
    id: "item_8209",
    "Last Name": "Ngo",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195526: {
    id: "item_8208",
    "Last Name": "Huang",
    "First Name": "Guo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195531: {
    id: "item_6564",
    "Last Name": "Nielsen",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195536: {
    id: "item_31662",
    "Last Name": "Good",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195567: {
    id: "item_31660",
    "Last Name": "O'Neill",
    "First Name": "Engela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195577: {
    id: "item_8202",
    "Last Name": "Longkumer",
    "First Name": "Lima",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195614: {
    id: "item_8205",
    "Last Name": "Underwood",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195621: {
    id: "item_20994",
    "Last Name": "Grosvenor Wedding",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195642: {
    id: "item_32228",
    "Last Name": "Huang",
    "First Name": "Chin Tsai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195658: {
    id: "item_33306",
    "Last Name": "Rezeki",
    "First Name": "Titi Wulan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195699: {
    id: "item_33307",
    "Last Name": "Johari",
    "First Name": "Fasha Liyana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195762: {
    id: "item_20985",
    "Last Name": "Jiang",
    "First Name": "Xiaomin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195822: {
    id: "item_31653",
    "Last Name": "Urquhart",
    "First Name": "Challon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195826: {
    id: "item_20987",
    "Last Name": "Mactier",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195839: {
    id: "item_7983",
    "Last Name": "Underhill",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195855: {
    id: "item_6563",
    "Last Name": "Zurawlenko",
    "First Name": "Jana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195858: {
    id: "item_20986",
    "Last Name": "Clough",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195882: {
    id: "item_8871",
    "Last Name": "Phoonsawad",
    "First Name": "Kornphon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195967: {
    id: "item_8195",
    "Last Name": "Loughnan",
    "First Name": "Kath",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37195975: {
    id: "item_20982",
    "Last Name": "Langsdorf",
    "First Name": "Griffin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196021: {
    id: "item_33302",
    "Last Name": "Sims",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196030: {
    id: "item_20977",
    "Last Name": "Yaptinchay",
    "First Name": "Oscar Robert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196037: {
    id: "item_20974",
    "Last Name": "Poole",
    "First Name": "Errol",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196040: {
    id: "item_31650",
    "Last Name": "Diment",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196101: {
    id: "item_31649",
    "Last Name": "Loo",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196112: {
    id: "item_33298",
    "Last Name": "SIRAIT",
    "First Name": "RISA TIAR STEFFANI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196165: {
    id: "item_33296",
    "Last Name": "Shapiro",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196187: {
    id: "item_31648",
    "Last Name": "Charlemagne",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196216: {
    id: "item_19358",
    "Last Name": "Lowe",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196248: {
    id: "item_32164",
    "Last Name": "Nakaroti",
    "First Name": "Greer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196304: {
    id: "item_7984",
    "Last Name": "Asegaff",
    "First Name": "Mahdi Kemal",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196366: {
    id: "item_33294",
    "Last Name": "Hendra",
    "First Name": "Hendra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196394: {
    id: "item_8188",
    "Last Name": "MacLeod",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196424: {
    id: "item_31641",
    "Last Name": "Bailey",
    "First Name": "Shane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196426: {
    id: "item_20971",
    "Last Name": "Pritchard",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196429: {
    id: "item_33293",
    "Last Name": "Gauci",
    "First Name": "Raelene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196431: {
    id: "item_33292",
    "Last Name": "Rivera",
    "First Name": "Cathrine Marie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196538: {
    id: "item_31640",
    "Last Name": "OMeley",
    "First Name": "Carlie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196541: {
    id: "item_33290",
    "Last Name": "MacFarlane",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196542: {
    id: "item_33289",
    "Last Name": "Kusunoki",
    "First Name": "Kara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196596: {
    id: "item_8185",
    "Last Name": "Kistemaker",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196612: {
    id: "item_20968",
    "Last Name": "Bray",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196683: {
    id: "item_31639",
    "Last Name": "Bailey",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196724: {
    id: "item_5805",
    "Last Name": "Kam",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196747: {
    id: "item_31638",
    "Last Name": "Castro",
    "First Name": "Marie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196864: {
    id: "item_8179",
    "Last Name": "Marchenko",
    "First Name": "Iurii",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196878: {
    id: "item_20957",
    "Last Name": "Thomson",
    "First Name": "Tanisha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196917: {
    id: "item_20956",
    "Last Name": "Thompson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37196952: {
    id: "item_8165",
    "Last Name": "Kosinar",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197001: {
    id: "item_33281",
    "Last Name": "MCDOWALL",
    "First Name": "DONNA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197081: {
    id: "item_8169",
    "Last Name": "Lin",
    "First Name": "Juu Shyun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197090: {
    id: "item_33280",
    "Last Name": "GABAGAT",
    "First Name": "JHOANNE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197094: {
    id: "item_8172",
    "Last Name": "Spagnolo",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197176: {
    id: "item_33278",
    "Last Name": "Singh",
    "First Name": "Garima",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197208: {
    id: "item_20949",
    "Last Name": "Pohl",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197253: {
    id: "item_32227",
    "Last Name": "Anastos",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197273: {
    id: "item_33929",
    "Last Name": "Li",
    "First Name": "Siying",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197282: {
    id: "item_20946",
    "Last Name": "Cashin",
    "First Name": "Indi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197332: {
    id: "item_8163",
    "Last Name": "Peters",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197340: {
    id: "item_20947",
    "Last Name": "Liboa",
    "First Name": "Ann",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197362: {
    id: "item_8157",
    "Last Name": "Delanghe",
    "First Name": "Camille",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197366: {
    id: "item_33928",
    "Last Name": "Lennon",
    "First Name": "Tania",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197406: {
    id: "item_8160",
    "Last Name": "Buttimore",
    "First Name": "Alistair",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197416: {
    id: "item_31630",
    "Last Name": "Kent",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197439: {
    id: "item_20945",
    "Last Name": "Dolton",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197463: {
    id: "item_8158",
    "Last Name": "Corazzola",
    "First Name": "Emanuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197471: {
    id: "item_20941",
    "Last Name": "Sibenius Trip",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197502: {
    id: "item_33274",
    "Last Name": "Widjojo",
    "First Name": "Cati Rahayu Wulandari",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197528: {
    id: "item_20940",
    "Last Name": "Sinpraseuth",
    "First Name": "Pwastana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197535: {
    id: "item_31624",
    "Last Name": "Dayrit",
    "First Name": "Carmelo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197546: {
    id: "item_33272",
    "Last Name": "Saktyawan",
    "First Name": "Okky Winang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197555: {
    id: "item_8153",
    "Last Name": "Sobol",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197556: {
    id: "item_33270",
    "Last Name": "Weng",
    "First Name": "Yu Cheng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197605: {
    id: "item_8150",
    "Last Name": "Banks",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197629: {
    id: "item_33268",
    "Last Name": "England",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197658: {
    id: "item_8149",
    "Last Name": "Frezza",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197679: {
    id: "item_31617",
    "Last Name": "Liu",
    "First Name": "Dan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197765: {
    id: "item_20932",
    "Last Name": "Trifonov",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197769: {
    id: "item_33262",
    "Last Name": "Anderson",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197795: {
    id: "item_33260",
    "Last Name": "Li",
    "First Name": "Yuxing",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197821: {
    id: "item_20934",
    "Last Name": "Wolkowitsch",
    "First Name": "Anne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197902: {
    id: "item_31615",
    "Last Name": "Wei",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197906: {
    id: "item_33258",
    "Last Name": "Hardy",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197939: {
    id: "item_20929",
    "Last Name": "Dalvean",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37197953: {
    id: "item_19224",
    "Last Name": "KOBAYASHI",
    "First Name": "HIROAKI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198024: {
    id: "item_8138",
    "Last Name": "Lamplough",
    "First Name": "Eranita",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198056: {
    id: "item_8141",
    "Last Name": "Overend",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198075: {
    id: "item_33256",
    "Last Name": "Lam",
    "First Name": "Kar Wah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198079: {
    id: "item_33253",
    "Last Name": "GAO",
    "First Name": "XIAOQIAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198095: {
    id: "item_33254",
    "Last Name": "Hannon",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198161: {
    id: "item_33252",
    "Last Name": "Budiman",
    "First Name": "Ridwan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198162: {
    id: "item_31608",
    "Last Name": "Luo",
    "First Name": "Yixin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198222: {
    id: "item_5802",
    "Last Name": "Ten Dam",
    "First Name": "Eli",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198230: {
    id: "item_20920",
    "Last Name": "Petrevics",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198281: {
    id: "item_33250",
    "Last Name": "Go",
    "First Name": "Mark Lester",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198348: {
    id: "item_6562",
    "Last Name": "Lee",
    "First Name": "Tsz Huen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198422: {
    id: "item_8870",
    "Last Name": "Dunoon",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198426: {
    id: "item_8131",
    "Last Name": "Lauw",
    "First Name": "Hendra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198437: {
    id: "item_20913",
    "Last Name": "Levinson",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198471: {
    id: "item_31602",
    "Last Name": "Webster",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198533: {
    id: "item_8129",
    "Last Name": "Cannell",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198543: {
    id: "item_33246",
    "Last Name": "Cadano",
    "First Name": "Luvie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198561: {
    id: "item_31600",
    "Last Name": "Petrusma",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198582: {
    id: "item_20911",
    "Last Name": "Vachon",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198601: {
    id: "item_33926",
    "Last Name": "Bin Yanan",
    "First Name": "Hafiz Aizat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198610: {
    id: "item_33927",
    "Last Name": "Bennett",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198619: {
    id: "item_20910",
    "Last Name": "Gossage",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198652: {
    id: "item_8127",
    "Last Name": "Archer",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198657: {
    id: "item_31598",
    "Last Name": "Da Silva Mariusso",
    "First Name": "Wellington",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198727: {
    id: "item_33925",
    "Last Name": "Gallo",
    "First Name": "Marco",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198739: {
    id: "item_5798",
    "Last Name": "Mathipa",
    "First Name": "Kgashane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198820: {
    id: "item_21397",
    "Last Name": "Morrison",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198842: {
    id: "item_32226",
    "Last Name": "Hsieh",
    "First Name": "Ming Chung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198973: {
    id: "item_8123",
    "Last Name": "Ho",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198996: {
    id: "item_20900",
    "Last Name": "van der Tuin",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37198998: {
    id: "item_31594",
    "Last Name": "Perkins-Weir",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199080: {
    id: "item_20897",
    "Last Name": "Geary",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199084: {
    id: "item_31590",
    "Last Name": "Wu",
    "First Name": "Bing-Sian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199102: {
    id: "item_20893",
    "Last Name": "Noyes",
    "First Name": "Montana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199104: {
    id: "item_8121",
    "Last Name": "Tisdell",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199117: {
    id: "item_20895",
    "Last Name": "MELIS",
    "First Name": "ERIC",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199136: {
    id: "item_33238",
    "Last Name": "Hendratno",
    "First Name": "Tri Pomo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199207: {
    id: "item_8118",
    "Last Name": "Bateson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199220: {
    id: "item_33234",
    "Last Name": "Opie",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199303: {
    id: "item_19357",
    "Last Name": "Leung",
    "First Name": "Hau Yi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199318: {
    id: "item_8114",
    "Last Name": "Meszaros",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199359: {
    id: "item_31587",
    "Last Name": "Dunn",
    "First Name": "Nina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199388: {
    id: "item_33233",
    "Last Name": "Park",
    "First Name": "Sang Hyok",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199443: {
    id: "item_20888",
    "Last Name": "Tattersall",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199453: {
    id: "item_31585",
    "Last Name": "Essey",
    "First Name": "Dominique",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199518: {
    id: "item_8108",
    "Last Name": "Wroble",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199520: {
    id: "item_6561",
    "Last Name": "Kiely",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199528: {
    id: "item_33231",
    "Last Name": "Hansen",
    "First Name": "Jodie Maree",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199530: {
    id: "item_19356",
    "Last Name": "BENSABBAH",
    "First Name": "MŽlina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199533: {
    id: "item_20887",
    "Last Name": "Bout",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199538: {
    id: "item_20886",
    "Last Name": "HARTANTO",
    "First Name": "JOSEPH",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199609: {
    id: "item_33229",
    "Last Name": "Henderson-Wraight",
    "First Name": "Mackenzie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199662: {
    id: "item_33227",
    "Last Name": "Arevalo",
    "First Name": "JESUS REUBEN III",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199734: {
    id: "item_31582",
    "Last Name": "Phillips",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199827: {
    id: "item_33225",
    "Last Name": "Fowler",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199841: {
    id: "item_31579",
    "Last Name": "Grimshaw",
    "First Name": "Liam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199873: {
    id: "item_31575",
    "Last Name": "CHAN",
    "First Name": "CHUNG MAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199875: {
    id: "item_33223",
    "Last Name": "De Castro",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199891: {
    id: "item_8101",
    "Last Name": "McGeoch",
    "First Name": "Tyson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199896: {
    id: "item_31576",
    "Last Name": "Anquillano",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199898: {
    id: "item_8869",
    "Last Name": "McCabe",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199914: {
    id: "item_31574",
    "Last Name": "Channon",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199930: {
    id: "item_33224",
    "Last Name": "Kim",
    "First Name": "Subin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37199999: {
    id: "item_33222",
    "Last Name": "CHANG",
    "First Name": "YU-MING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200030: {
    id: "item_20871",
    "Last Name": "Earl",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200145: {
    id: "item_21396",
    "Last Name": "Cohn",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200155: {
    id: "item_31569",
    "Last Name": "Wood",
    "First Name": "Kayleigh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200167: {
    id: "item_6560",
    "Last Name": "Nguy_n Qu_c",
    "First Name": "S_",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200248: {
    id: "item_8095",
    "Last Name": "Chan",
    "First Name": "Siu Cheung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200321: {
    id: "item_8094",
    "Last Name": "Cao",
    "First Name": "ShengZi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200340: {
    id: "item_31567",
    "Last Name": "Cruz",
    "First Name": "Julius Russell",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200363: {
    id: "item_33212",
    "Last Name": "Stiller",
    "First Name": "Lyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200376: {
    id: "item_8093",
    "Last Name": "Lee",
    "First Name": "Jim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200377: {
    id: "item_33211",
    "Last Name": "GUO",
    "First Name": "MINGZHU Sandy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200414: {
    id: "item_6559",
    "Last Name": "Hanna",
    "First Name": "Kristopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200437: {
    id: "item_5795",
    "Last Name": "Harcourt",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200484: {
    id: "item_20863",
    "Last Name": "McGeachin",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200618: {
    id: "item_31558",
    "Last Name": "Hillan",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200639: {
    id: "item_31555",
    "Last Name": "Afni",
    "First Name": "Hema apri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200646: {
    id: "item_31557",
    "Last Name": "Marin",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200664: {
    id: "item_8085",
    "Last Name": "OÕReilly",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200667: {
    id: "item_20862",
    "Last Name": "Smith",
    "First Name": "Margery",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200698: {
    id: "item_33206",
    "Last Name": "Kermond",
    "First Name": "Sue",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200707: {
    id: "item_8082",
    "Last Name": "Aksu",
    "First Name": "Serkan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200790: {
    id: "item_8080",
    "Last Name": "O'Sullivan",
    "First Name": "Sian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200808: {
    id: "item_8079",
    "Last Name": "Osmond",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200839: {
    id: "item_33202",
    "Last Name": "Geduld",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200844: {
    id: "item_19355",
    "Last Name": "HUANG",
    "First Name": "KAI YANG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200960: {
    id: "item_8076",
    "Last Name": "Ganeshan",
    "First Name": "Roshan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200964: {
    id: "item_33200",
    "Last Name": "Halim",
    "First Name": "Caitlyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200970: {
    id: "item_20852",
    "Last Name": "Symons",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37200971: {
    id: "item_6558",
    "Last Name": "Peirce",
    "First Name": "Ned",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201012: {
    id: "item_20853",
    "Last Name": "Jonsson",
    "First Name": "Bogi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201056: {
    id: "item_31553",
    "Last Name": "Prim",
    "First Name": "Fagian rifki",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201211: {
    id: "item_33192",
    "Last Name": "Joyce Sebastian",
    "First Name": "Valerie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201221: {
    id: "item_33193",
    "Last Name": "Vagg",
    "First Name": "Mikaela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201249: {
    id: "item_31546",
    "Last Name": "Kelly",
    "First Name": "Bonny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201313: {
    id: "item_20845",
    "Last Name": "Rump",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201319: {
    id: "item_8064",
    "Last Name": "Brown",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201345: {
    id: "item_33188",
    "Last Name": "Suzuki",
    "First Name": "Harumi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201385: {
    id: "item_31541",
    "Last Name": "KIN KAY",
    "First Name": "LEUNG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201407: {
    id: "item_20840",
    "Last Name": "Duddington",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201547: {
    id: "item_20838",
    "Last Name": "Farrugia",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201555: {
    id: "item_8059",
    "Last Name": "Cobban",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201667: {
    id: "item_8868",
    "Last Name": "Cartlidge",
    "First Name": "Krista",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201699: {
    id: "item_32225",
    "Last Name": "Collins",
    "First Name": "Freddie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201717: {
    id: "item_33924",
    "Last Name": "Ravinutala",
    "First Name": "Nalini",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201731: {
    id: "item_20832",
    "Last Name": "Murtha",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201763: {
    id: "item_8049",
    "Last Name": "Gao",
    "First Name": "Yindi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201830: {
    id: "item_8048",
    "Last Name": "Gurjar",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201928: {
    id: "item_31532",
    "Last Name": "CHI HO",
    "First Name": "TANG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201947: {
    id: "item_20821",
    "Last Name": "Chang",
    "First Name": "Tzu-Cheng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201973: {
    id: "item_33173",
    "Last Name": "Acreman",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201991: {
    id: "item_20819",
    "Last Name": "YIP",
    "First Name": "SAU HOI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37201993: {
    id: "item_20818",
    "Last Name": "Csuros",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202017: {
    id: "item_5790",
    "Last Name": "Anderson",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202134: {
    id: "item_8038",
    "Last Name": "Presa",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202265: {
    id: "item_8035",
    "Last Name": "Stanley",
    "First Name": "Finn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202306: {
    id: "item_33166",
    "Last Name": "harrop",
    "First Name": "claire",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202311: {
    id: "item_20805",
    "Last Name": "Wallace",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202321: {
    id: "item_33163",
    "Last Name": "Martiana sari",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202409: {
    id: "item_33923",
    "Last Name": "KIM",
    "First Name": "EUNYOUNG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202439: {
    id: "item_33160",
    "Last Name": "Plummer",
    "First Name": "Rosamund",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202475: {
    id: "item_6557",
    "Last Name": "arias",
    "First Name": "jose",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202476: {
    id: "item_8033",
    "Last Name": "Mills",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202491: {
    id: "item_33158",
    "Last Name": "MASON",
    "First Name": "Ron",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202516: {
    id: "item_20801",
    "Last Name": "Jenkinson",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202537: {
    id: "item_20798",
    "Last Name": "Smith",
    "First Name": "Warren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202615: {
    id: "item_20795",
    "Last Name": "Mander",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202683: {
    id: "item_33156",
    "Last Name": "Ho",
    "First Name": "Ming-Chan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202711: {
    id: "item_31511",
    "Last Name": "Cusack",
    "First Name": "Geraldine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202719: {
    id: "item_31512",
    "Last Name": "Peh",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202764: {
    id: "item_8027",
    "Last Name": "Yeomans",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202818: {
    id: "item_33152",
    "Last Name": "Wang",
    "First Name": "Yi-Hsuan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202832: {
    id: "item_8867",
    "Last Name": "ANG",
    "First Name": "RAYMOND",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202847: {
    id: "item_21395",
    "Last Name": "Curtin",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202857: {
    id: "item_20787",
    "Last Name": "O Connor",
    "First Name": "Fionnuala",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202911: {
    id: "item_33151",
    "Last Name": "SHIM",
    "First Name": "HYUN SOO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37202973: {
    id: "item_20785",
    "Last Name": "BIN ZAKARIA",
    "First Name": "MOHAMMAD YUSOFF",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203058: {
    id: "item_20781",
    "Last Name": "Price",
    "First Name": "Jayme-Leigh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203152: {
    id: "item_32224",
    "Last Name": "kimura",
    "First Name": "junko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203165: {
    id: "item_33148",
    "Last Name": "Lamberth",
    "First Name": "Helena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203214: {
    id: "item_5787",
    "Last Name": "Zheng",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203251: {
    id: "item_8017",
    "Last Name": "Milosevic",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203255: {
    id: "item_8016",
    "Last Name": "Lomax",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203495: {
    id: "item_8009",
    "Last Name": "Sanchez",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203558: {
    id: "item_8007",
    "Last Name": "ZHANG",
    "First Name": "XIA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203590: {
    id: "item_31492",
    "Last Name": "Mason",
    "First Name": "Rosalind",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203636: {
    id: "item_6556",
    "Last Name": "Garrard",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203702: {
    id: "item_32223",
    "Last Name": "Khantigaroon",
    "First Name": "Thanes",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203774: {
    id: "item_31490",
    "Last Name": "Broadhead",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203839: {
    id: "item_31488",
    "Last Name": "YUEN",
    "First Name": "YAT HONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203844: {
    id: "item_8866",
    "Last Name": "Philipson",
    "First Name": "Becky",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203851: {
    id: "item_33135",
    "Last Name": "Knox",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203857: {
    id: "item_20760",
    "Last Name": "Berry",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203867: {
    id: "item_20761",
    "Last Name": "Rigby",
    "First Name": "Lucinda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203886: {
    id: "item_7998",
    "Last Name": "Dunn",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203891: {
    id: "item_31487",
    "Last Name": "Meehan",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203952: {
    id: "item_19354",
    "Last Name": "Martevuo",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37203962: {
    id: "item_33129",
    "Last Name": "Iqbal",
    "First Name": "Asif",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204019: {
    id: "item_20758",
    "Last Name": "Cossar",
    "First Name": "Michaela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204051: {
    id: "item_20756",
    "Last Name": "Schembri",
    "First Name": "Salvatore",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204087: {
    id: "item_31486",
    "Last Name": "Hadkins",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204117: {
    id: "item_33125",
    "Last Name": "HWA",
    "First Name": "JER-SHYAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204146: {
    id: "item_7993",
    "Last Name": "Duffy",
    "First Name": "Rhianna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204147: {
    id: "item_31480",
    "Last Name": "NG",
    "First Name": "CHAN YI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204159: {
    id: "item_31479",
    "Last Name": "Yamamoto",
    "First Name": "Kana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204185: {
    id: "item_7991",
    "Last Name": "NAGATSU",
    "First Name": "TAKERU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204256: {
    id: "item_7987",
    "Last Name": "O'Kane",
    "First Name": "Laureen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204265: {
    id: "item_20755",
    "Last Name": "Read",
    "First Name": "Neil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204296: {
    id: "item_33120",
    "Last Name": "Osman",
    "First Name": "Kamarulzaman",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204308: {
    id: "item_18865",
    "Last Name": "wang",
    "First Name": "yingti",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204326: {
    id: "item_18862",
    "Last Name": "Gunton",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204347: {
    id: "item_6251",
    "Last Name": "Haw",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204428: {
    id: "item_18859",
    "Last Name": "Riboux",
    "First Name": "Camille",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204502: {
    id: "item_33744",
    "Last Name": "Castro",
    "First Name": "Lourdes Trinidad Virginia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204507: {
    id: "item_6250",
    "Last Name": "Valen�a",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204536: {
    id: "item_21316",
    "Last Name": "Richards",
    "First Name": "Donna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204540: {
    id: "item_18856",
    "Last Name": "Pivott",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204563: {
    id: "item_18850",
    "Last Name": "Deng",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204598: {
    id: "item_33742",
    "Last Name": "Kint",
    "First Name": "Phi nga",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204606: {
    id: "item_18852",
    "Last Name": "Zafar",
    "First Name": "Zain",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204608: {
    id: "item_32097",
    "Last Name": "parazzini",
    "First Name": "francesco giovanni",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204654: {
    id: "item_6555",
    "Last Name": "Okhueleigbe",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204678: {
    id: "item_33741",
    "Last Name": "McPherson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204698: {
    id: "item_18849",
    "Last Name": "Lee",
    "First Name": "Kaemin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204729: {
    id: "item_18845",
    "Last Name": "Alsaieri",
    "First Name": "Ashwaq",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204732: {
    id: "item_8710",
    "Last Name": "McConnell",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204796: {
    id: "item_33737",
    "Last Name": "Odo–o",
    "First Name": "Astrid Ayla",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204798: {
    id: "item_21314",
    "Last Name": "Wickham",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204807: {
    id: "item_18842",
    "Last Name": "Kumar",
    "First Name": "Rajiv",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204809: {
    id: "item_18841",
    "Last Name": "Morgan",
    "First Name": "Jed",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204818: {
    id: "item_6238",
    "Last Name": "Jensen",
    "First Name": "Tom Inge Tilley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204912: {
    id: "item_33736",
    "Last Name": "Perez",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204923: {
    id: "item_18836",
    "Last Name": "Wilson",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204942: {
    id: "item_8706",
    "Last Name": "Chung",
    "First Name": "Wen-liang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204946: {
    id: "item_18831",
    "Last Name": "Dai",
    "First Name": "Fei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204956: {
    id: "item_18832",
    "Last Name": "Wibawa",
    "First Name": "Steven Ryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204958: {
    id: "item_18833",
    "Last Name": "Jin",
    "First Name": "Johnson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37204986: {
    id: "item_6229",
    "Last Name": "Rudgley",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205016: {
    id: "item_32093",
    "Last Name": "Scaglione",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205030: {
    id: "item_18827",
    "Last Name": "Matuszek",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205049: {
    id: "item_18828",
    "Last Name": "Foster",
    "First Name": "Paddy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205088: {
    id: "item_21310",
    "Last Name": "Halstead",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205095: {
    id: "item_6226",
    "Last Name": "Craig",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205111: {
    id: "item_8700",
    "Last Name": "Stout",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205203: {
    id: "item_6223",
    "Last Name": "Sasso",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205217: {
    id: "item_32089",
    "Last Name": "Fowler",
    "First Name": "Shona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205237: {
    id: "item_18817",
    "Last Name": "MacDonald",
    "First Name": "Barry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205253: {
    id: "item_18818",
    "Last Name": "Orrock",
    "First Name": "Ed",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205254: {
    id: "item_18819",
    "Last Name": "Downes",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205303: {
    id: "item_6219",
    "Last Name": "EUNKYU",
    "First Name": "PARK",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205340: {
    id: "item_18816",
    "Last Name": "Li",
    "First Name": "Danny Wing Ho",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205372: {
    id: "item_33731",
    "Last Name": "Barned",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205377: {
    id: "item_18814",
    "Last Name": "Marin",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205384: {
    id: "item_32085",
    "Last Name": "Bowes",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205422: {
    id: "item_8694",
    "Last Name": "CHAN",
    "First Name": "KA WAI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205434: {
    id: "item_18811",
    "Last Name": "BLANCHON",
    "First Name": "CHRISTELLE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205451: {
    id: "item_6216",
    "Last Name": "Hidayad",
    "First Name": "Deddy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205455: {
    id: "item_18813",
    "Last Name": "Scott",
    "First Name": "Declan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205456: {
    id: "item_6213",
    "Last Name": "Mohsen",
    "First Name": "Waled",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205470: {
    id: "item_18809",
    "Last Name": "Cranwell",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205471: {
    id: "item_21305",
    "Last Name": "Kan",
    "First Name": "Junhai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205476: {
    id: "item_8693",
    "Last Name": "Cardoso",
    "First Name": "Helcio carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205488: {
    id: "item_8692",
    "Last Name": "noroc",
    "First Name": "marian denis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205494: {
    id: "item_18805",
    "Last Name": "Chatnarat",
    "First Name": "Phongsathon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205504: {
    id: "item_18807",
    "Last Name": "Kirkbride",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205555: {
    id: "item_33728",
    "Last Name": "Ng",
    "First Name": "Ke Li",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205572: {
    id: "item_8684",
    "Last Name": "Wang",
    "First Name": "Jun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205574: {
    id: "item_6209",
    "Last Name": "Ferrando",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205590: {
    id: "item_32084",
    "Last Name": "Tam",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205594: {
    id: "item_21304",
    "Last Name": "Stern",
    "First Name": "Marie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205606: {
    id: "item_32222",
    "Last Name": "Lopez Pablos",
    "First Name": "Marissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205621: {
    id: "item_6204",
    "Last Name": "Pojanasophanakul",
    "First Name": "Samphan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205635: {
    id: "item_18799",
    "Last Name": "Ruddock",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205658: {
    id: "item_6206",
    "Last Name": "Nolan",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205680: {
    id: "item_6203",
    "Last Name": "Betts",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205724: {
    id: "item_18793",
    "Last Name": "zheng",
    "First Name": "steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205729: {
    id: "item_18792",
    "Last Name": "Skoglund",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205734: {
    id: "item_33114",
    "Last Name": "Idrus",
    "First Name": "Alwi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205750: {
    id: "item_18785",
    "Last Name": "You",
    "First Name": "Wentao",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205761: {
    id: "item_8686",
    "Last Name": "Burgess",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205763: {
    id: "item_33727",
    "Last Name": "Cheung",
    "First Name": "Ka shing",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205772: {
    id: "item_18790",
    "Last Name": "Resenberger",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205775: {
    id: "item_18789",
    "Last Name": "Su",
    "First Name": "Francis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205825: {
    id: "item_18787",
    "Last Name": "Kralova",
    "First Name": "Lucia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205837: {
    id: "item_32077",
    "Last Name": "Fulton",
    "First Name": "Kristi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205845: {
    id: "item_33725",
    "Last Name": "Ferrolino",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205866: {
    id: "item_18784",
    "Last Name": "Pham",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205881: {
    id: "item_21298",
    "Last Name": "Harris",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205893: {
    id: "item_6200",
    "Last Name": "Le Vagueresse",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205907: {
    id: "item_8683",
    "Last Name": "Jones",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205924: {
    id: "item_6199",
    "Last Name": "Khouhli",
    "First Name": "Fatiha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205942: {
    id: "item_32075",
    "Last Name": "Sharpe",
    "First Name": "Tayla",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205951: {
    id: "item_18780",
    "Last Name": "Lei",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37205996: {
    id: "item_21297",
    "Last Name": "Niebch",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206007: {
    id: "item_18775",
    "Last Name": "Baker",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206043: {
    id: "item_32073",
    "Last Name": "Blandon",
    "First Name": "Regina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206058: {
    id: "item_6191",
    "Last Name": "Steele-Smith",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206108: {
    id: "item_18773",
    "Last Name": "Palamountain",
    "First Name": "Sally",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206134: {
    id: "item_18772",
    "Last Name": "Walsh",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206198: {
    id: "item_18769",
    "Last Name": "Perestrelo",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206211: {
    id: "item_6181",
    "Last Name": "Chadband",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206212: {
    id: "item_8682",
    "Last Name": "Sveinsson",
    "First Name": "Lara",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206245: {
    id: "item_8681",
    "Last Name": "Dewayani",
    "First Name": "Dionesia Nadya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206299: {
    id: "item_33719",
    "Last Name": "YOKOYAMA",
    "First Name": "TATSURO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206301: {
    id: "item_8680",
    "Last Name": "Mickle",
    "First Name": "Karen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206307: {
    id: "item_32221",
    "Last Name": "chen",
    "First Name": "jie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206312: {
    id: "item_18766",
    "Last Name": "Perdrix",
    "First Name": "Laureen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206318: {
    id: "item_18765",
    "Last Name": "Tizon",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206331: {
    id: "item_18762",
    "Last Name": "Cooksey",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206431: {
    id: "item_18757",
    "Last Name": "Power",
    "First Name": "Jim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206433: {
    id: "item_8676",
    "Last Name": "Wang",
    "First Name": "Martina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206449: {
    id: "item_6174",
    "Last Name": "Vincent",
    "First Name": "Micah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206458: {
    id: "item_32068",
    "Last Name": "Patalinghug",
    "First Name": "John Arthur",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206475: {
    id: "item_18753",
    "Last Name": "Page",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206482: {
    id: "item_32069",
    "Last Name": "Taylor",
    "First Name": "Dave",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206490: {
    id: "item_8675",
    "Last Name": "Carr",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206503: {
    id: "item_6173",
    "Last Name": "Agnew",
    "First Name": "Caoimhe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206545: {
    id: "item_32067",
    "Last Name": "Bin Mohd Kamal",
    "First Name": "Ahmad Taufeeq Arrahman",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206548: {
    id: "item_6172",
    "Last Name": "Couch",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206579: {
    id: "item_6170",
    "Last Name": "Chuah",
    "First Name": "Lilian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206606: {
    id: "item_18743",
    "Last Name": "Mccann",
    "First Name": "Keira",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206647: {
    id: "item_32066",
    "Last Name": "Regis",
    "First Name": "Ma. Teresa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206656: {
    id: "item_8671",
    "Last Name": "Kristianto",
    "First Name": "Cliff",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206678: {
    id: "item_32064",
    "Last Name": "Perwitasari",
    "First Name": "Witria Wahyu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206688: {
    id: "item_18740",
    "Last Name": "Whyte",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206763: {
    id: "item_18737",
    "Last Name": "Nicholls",
    "First Name": "Phil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206770: {
    id: "item_18735",
    "Last Name": "Chang",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206778: {
    id: "item_6164",
    "Last Name": "Rojas",
    "First Name": "Priscilla",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206781: {
    id: "item_33707",
    "Last Name": "Trigg",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206787: {
    id: "item_6162",
    "Last Name": "Sabatovych",
    "First Name": "Uliana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206805: {
    id: "item_32062",
    "Last Name": "HARADA",
    "First Name": "Ryoko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206807: {
    id: "item_21291",
    "Last Name": "Craddock",
    "First Name": "Jon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206814: {
    id: "item_21290",
    "Last Name": "Jian",
    "First Name": "Ming-Tse",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206876: {
    id: "item_18727",
    "Last Name": "Beare",
    "First Name": "Shawn Kim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206891: {
    id: "item_33922",
    "Last Name": "Taswin",
    "First Name": "Geranuma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206907: {
    id: "item_18729",
    "Last Name": "Cai",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206916: {
    id: "item_6160",
    "Last Name": "Jasper",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206982: {
    id: "item_18723",
    "Last Name": "Maysonet",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37206990: {
    id: "item_18724",
    "Last Name": "Chang",
    "First Name": "Leon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207005: {
    id: "item_18722",
    "Last Name": "Hennig",
    "First Name": "Maggie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207026: {
    id: "item_6157",
    "Last Name": "Memela",
    "First Name": "Velile",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207042: {
    id: "item_19223",
    "Last Name": "Lellis Streck",
    "First Name": "Patr’cia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207060: {
    id: "item_8670",
    "Last Name": "AGRANOVSKIY",
    "First Name": "ALEXEY",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207065: {
    id: "item_8669",
    "Last Name": "Guadalupe",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207095: {
    id: "item_8668",
    "Last Name": "Vicencio",
    "First Name": "Cristian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207100: {
    id: "item_6484",
    "Last Name": "Telfar",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207153: {
    id: "item_6154",
    "Last Name": "Lovera",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207167: {
    id: "item_6152",
    "Last Name": "Cunningham",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207221: {
    id: "item_8666",
    "Last Name": "LIANG",
    "First Name": "DEYU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207248: {
    id: "item_18716",
    "Last Name": "Friedman",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207291: {
    id: "item_18714",
    "Last Name": "Law",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207332: {
    id: "item_6145",
    "Last Name": "Crawford",
    "First Name": "Justine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207350: {
    id: "item_21286",
    "Last Name": "ZHANG",
    "First Name": "MIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207361: {
    id: "item_6143",
    "Last Name": "Tsang",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207383: {
    id: "item_32058",
    "Last Name": "Ginting",
    "First Name": "Agustinus Alexander",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207448: {
    id: "item_6137",
    "Last Name": "Zhang",
    "First Name": "Wenzhou",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207519: {
    id: "item_6141",
    "Last Name": "CHUANG",
    "First Name": "CHIH-CHUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207539: {
    id: "item_6140",
    "Last Name": "Huang",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207542: {
    id: "item_33702",
    "Last Name": "Carmichael",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207563: {
    id: "item_6138",
    "Last Name": "Abeygunasekara",
    "First Name": "Manil",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207564: {
    id: "item_6139",
    "Last Name": "Carron-Arthur",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207573: {
    id: "item_6134",
    "Last Name": "Issa",
    "First Name": "Convention",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207577: {
    id: "item_18708",
    "Last Name": "Warhurst",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207601: {
    id: "item_18706",
    "Last Name": "Hawker",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207622: {
    id: "item_33699",
    "Last Name": "Lau",
    "First Name": "Gloria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207668: {
    id: "item_6132",
    "Last Name": "Duckworth",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207737: {
    id: "item_18696",
    "Last Name": "rapala",
    "First Name": "Malgorzata Zofia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207765: {
    id: "item_18697",
    "Last Name": "Handaja",
    "First Name": "Diana Oktavia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207818: {
    id: "item_33698",
    "Last Name": "Tambunan",
    "First Name": "Yuliana Rotua Ulibasa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207833: {
    id: "item_33697",
    "Last Name": "GARCIA",
    "First Name": "JONATHAN GERARD",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207888: {
    id: "item_18691",
    "Last Name": "Wilson",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207900: {
    id: "item_6129",
    "Last Name": "Wan",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37207931: {
    id: "item_18690",
    "Last Name": "Artani",
    "First Name": "Kashif",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208053: {
    id: "item_33696",
    "Last Name": "Voon",
    "First Name": "May Yin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208078: {
    id: "item_8823",
    "Last Name": "Tronchon",
    "First Name": "Lo•c",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208142: {
    id: "item_18682",
    "Last Name": "DURAN",
    "First Name": "EQCELLIUS",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208157: {
    id: "item_6124",
    "Last Name": "Kwan Ho",
    "First Name": "Cheung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208176: {
    id: "item_18686",
    "Last Name": "ALANG ABD HAMID",
    "First Name": "HAZMIR BIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208189: {
    id: "item_6121",
    "Last Name": "gan",
    "First Name": "ying",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208199: {
    id: "item_6122",
    "Last Name": "DIRICQ",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208264: {
    id: "item_18683",
    "Last Name": "Noon",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208265: {
    id: "item_6120",
    "Last Name": "mulligan",
    "First Name": "matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208290: {
    id: "item_32051",
    "Last Name": "Lee",
    "First Name": "Cheryl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208335: {
    id: "item_6117",
    "Last Name": "Roche",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208344: {
    id: "item_32049",
    "Last Name": "Thienthong",
    "First Name": "Pornchai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208353: {
    id: "item_32050",
    "Last Name": "Wang",
    "First Name": "Ching-Ya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208358: {
    id: "item_32047",
    "Last Name": "Grimley",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208388: {
    id: "item_21279",
    "Last Name": "brady",
    "First Name": "abigail",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208410: {
    id: "item_32048",
    "Last Name": "Rouson",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208442: {
    id: "item_21278",
    "Last Name": "Samson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208466: {
    id: "item_18680",
    "Last Name": "Jacobsen",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208469: {
    id: "item_21276",
    "Last Name": "Cochrane",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208498: {
    id: "item_6113",
    "Last Name": "TRASLAVI„A",
    "First Name": "ANDRES",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208505: {
    id: "item_18679",
    "Last Name": "Juntamalee",
    "First Name": "Achitsing",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208616: {
    id: "item_18678",
    "Last Name": "Katich",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208635: {
    id: "item_6111",
    "Last Name": "Park",
    "First Name": "Jungsu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208659: {
    id: "item_8865",
    "Last Name": "Kloner",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208671: {
    id: "item_33692",
    "Last Name": "Trainor",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208705: {
    id: "item_8657",
    "Last Name": "Luck",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208743: {
    id: "item_33690",
    "Last Name": "Mui Chun",
    "First Name": "Li",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208747: {
    id: "item_6110",
    "Last Name": "Hembroff",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208769: {
    id: "item_32044",
    "Last Name": "Merani",
    "First Name": "Ignacio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208773: {
    id: "item_18672",
    "Last Name": "Ma",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208800: {
    id: "item_18671",
    "Last Name": "Naish",
    "First Name": "Kara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208808: {
    id: "item_33689",
    "Last Name": "Dhivarakara",
    "First Name": "Sobrutai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208895: {
    id: "item_6107",
    "Last Name": "SEUNGHWAN",
    "First Name": "KIM",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37208926: {
    id: "item_32041",
    "Last Name": "Irish",
    "First Name": "Toya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209012: {
    id: "item_6104",
    "Last Name": "Lee",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209017: {
    id: "item_18668",
    "Last Name": "Marcon",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209078: {
    id: "item_33921",
    "Last Name": "Rodriguez",
    "First Name": "Billy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209080: {
    id: "item_32040",
    "Last Name": "LaRaia",
    "First Name": "Roxanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209130: {
    id: "item_8652",
    "Last Name": "TAO",
    "First Name": "WEIFENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209142: {
    id: "item_6554",
    "Last Name": "Benoit",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209223: {
    id: "item_18663",
    "Last Name": "CHENG",
    "First Name": "TZUYANG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209258: {
    id: "item_18662",
    "Last Name": "Bieler",
    "First Name": "Henning",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209326: {
    id: "item_21274",
    "Last Name": "Mann",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209360: {
    id: "item_32037",
    "Last Name": "Zhang",
    "First Name": "Shuyang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209361: {
    id: "item_8653",
    "Last Name": "Corona",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209370: {
    id: "item_18661",
    "Last Name": "Rojas",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209437: {
    id: "item_8650",
    "Last Name": "MICHEL",
    "First Name": "Yannick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209457: {
    id: "item_6095",
    "Last Name": "Pellens",
    "First Name": "Roger",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209465: {
    id: "item_8649",
    "Last Name": "Thirapolvanichkul",
    "First Name": "Thanawat",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209475: {
    id: "item_18654",
    "Last Name": "DEMEURAN",
    "First Name": "ANNE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209500: {
    id: "item_18652",
    "Last Name": "Lupinska",
    "First Name": "Malwina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209554: {
    id: "item_6093",
    "Last Name": "Fowler",
    "First Name": "Howrd",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209571: {
    id: "item_18650",
    "Last Name": "Feerick",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209580: {
    id: "item_18648",
    "Last Name": "Zhukovskaia",
    "First Name": "Ekaterina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209593: {
    id: "item_33686",
    "Last Name": "kub-ao",
    "First Name": "Konika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209595: {
    id: "item_19353",
    "Last Name": "TONGCHAITONG",
    "First Name": "PONGSAK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209640: {
    id: "item_18646",
    "Last Name": "Chan",
    "First Name": "Whyemun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209761: {
    id: "item_6090",
    "Last Name": "Theobald",
    "First Name": "Sally",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209767: {
    id: "item_33684",
    "Last Name": "Sylvester",
    "First Name": "Gillian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209795: {
    id: "item_8646",
    "Last Name": "Kang",
    "First Name": "Susan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209879: {
    id: "item_32035",
    "Last Name": "Lin",
    "First Name": "Chun-Po",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209935: {
    id: "item_6088",
    "Last Name": "Kowalczyk",
    "First Name": "Rafa_",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209954: {
    id: "item_33683",
    "Last Name": "Shari",
    "First Name": "Abdul Hadi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37209988: {
    id: "item_6087",
    "Last Name": "Zhu",
    "First Name": "Yunni",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210014: {
    id: "item_21266",
    "Last Name": "Pozo",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210015: {
    id: "item_18643",
    "Last Name": "Kwon",
    "First Name": "Nahyun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210063: {
    id: "item_32033",
    "Last Name": "Budimulia",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210075: {
    id: "item_21394",
    "Last Name": "LO",
    "First Name": "WAI HUNG MATTHEW",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210121: {
    id: "item_6083",
    "Last Name": "Mak",
    "First Name": "Ping Nang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210139: {
    id: "item_32032",
    "Last Name": "Silvestri",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210167: {
    id: "item_18639",
    "Last Name": "Haskell",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210198: {
    id: "item_32031",
    "Last Name": "SCHUBERT",
    "First Name": "JULIE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210200: {
    id: "item_21267",
    "Last Name": "Chandhupatla",
    "First Name": "Satyanarayan Reddy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210250: {
    id: "item_18636",
    "Last Name": "Hughes",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210267: {
    id: "item_8640",
    "Last Name": "Alberione",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210356: {
    id: "item_18633",
    "Last Name": "Reynolds",
    "First Name": "Miranda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210405: {
    id: "item_19352",
    "Last Name": "Kolankowski",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210413: {
    id: "item_18631",
    "Last Name": "Yang",
    "First Name": "Qingsong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210443: {
    id: "item_33680",
    "Last Name": "Sloan",
    "First Name": "Lichu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210510: {
    id: "item_6076",
    "Last Name": "Guruprasad",
    "First Name": "Vishwas Bharadwaj",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210565: {
    id: "item_18629",
    "Last Name": "Doherty",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210586: {
    id: "item_18628",
    "Last Name": "Del rio fernandez",
    "First Name": "Francine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210649: {
    id: "item_33679",
    "Last Name": "Garrett",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210706: {
    id: "item_8864",
    "Last Name": "Kirkowski",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210738: {
    id: "item_18626",
    "Last Name": "Vella",
    "First Name": "Angelo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210773: {
    id: "item_6073",
    "Last Name": "WONG",
    "First Name": "CHUN YIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210819: {
    id: "item_6072",
    "Last Name": "Ramli",
    "First Name": "Abdul Rhakhman",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210979: {
    id: "item_32220",
    "Last Name": "Fontenot",
    "First Name": "Shay",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37210987: {
    id: "item_6071",
    "Last Name": "Aguilar",
    "First Name": "Justo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211062: {
    id: "item_6070",
    "Last Name": "Radune",
    "First Name": "C.J.",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211206: {
    id: "item_33678",
    "Last Name": "Paliu",
    "First Name": "Mariana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211245: {
    id: "item_18613",
    "Last Name": "SHEN",
    "First Name": "SZUWEI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211314: {
    id: "item_8636",
    "Last Name": "Green",
    "First Name": "Gwendolyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211342: {
    id: "item_21262",
    "Last Name": "Liandy",
    "First Name": "Liandy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211364: {
    id: "item_33871",
    "Last Name": "Jeludin",
    "First Name": "Zeffrey Ali Musa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211397: {
    id: "item_6063",
    "Last Name": "Fan",
    "First Name": "Wai Lon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211441: {
    id: "item_21393",
    "Last Name": "Melati",
    "First Name": "Melati",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211445: {
    id: "item_21261",
    "Last Name": "Susanto",
    "First Name": "Edi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211540: {
    id: "item_33870",
    "Last Name": "LIEW",
    "First Name": "WEE LONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211603: {
    id: "item_6062",
    "Last Name": "Yap",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211677: {
    id: "item_6060",
    "Last Name": "Gerken",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211679: {
    id: "item_8634",
    "Last Name": "Demko",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211704: {
    id: "item_18602",
    "Last Name": "Anteby",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211914: {
    id: "item_18600",
    "Last Name": "Evans",
    "First Name": "Edd",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211916: {
    id: "item_19222",
    "Last Name": "Lombardi",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211927: {
    id: "item_6057",
    "Last Name": "Perry",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37211981: {
    id: "item_19221",
    "Last Name": "Vasamsetti",
    "First Name": "Sri",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212041: {
    id: "item_32219",
    "Last Name": "Suzukawa-Tseng",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212081: {
    id: "item_6055",
    "Last Name": "Martinez Perez",
    "First Name": "Karina Maria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212084: {
    id: "item_6553",
    "Last Name": "Sowerby",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212092: {
    id: "item_21259",
    "Last Name": "SU",
    "First Name": "CHENG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212104: {
    id: "item_18597",
    "Last Name": "TSENG",
    "First Name": "HAN-TING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212132: {
    id: "item_33673",
    "Last Name": "Yiu",
    "First Name": "Chik yim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212175: {
    id: "item_18594",
    "Last Name": "Cheng",
    "First Name": "Hoi Yuen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212183: {
    id: "item_32163",
    "Last Name": "Rocha-Cadman",
    "First Name": "Xiomara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212198: {
    id: "item_8822",
    "Last Name": "Zheng",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212210: {
    id: "item_19351",
    "Last Name": "Sheffield",
    "First Name": "Mason",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212320: {
    id: "item_18591",
    "Last Name": "Pattison",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212412: {
    id: "item_8821",
    "Last Name": "Knowles",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212428: {
    id: "item_6051",
    "Last Name": "Haigh",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212485: {
    id: "item_19350",
    "Last Name": "Hampton",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212488: {
    id: "item_6049",
    "Last Name": "Kapuangan",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212626: {
    id: "item_8863",
    "Last Name": "Alevyzakis",
    "First Name": "Georgios",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212931: {
    id: "item_33869",
    "Last Name": "Srinivasan",
    "First Name": "Rajeswari",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37212987: {
    id: "item_21392",
    "Last Name": "Estrada",
    "First Name": "Silvia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37213188: {
    id: "item_19349",
    "Last Name": "Brennan",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37213229: {
    id: "item_6046",
    "Last Name": "Raveloson",
    "First Name": "Tantely",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37213378: {
    id: "item_33669",
    "Last Name": "Khoo",
    "First Name": "Kah Wai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37213545: {
    id: "item_8629",
    "Last Name": "ALVES DOMINGUES",
    "First Name": "MICHELE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37213557: {
    id: "item_32218",
    "Last Name": "Andayani",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37213606: {
    id: "item_8628",
    "Last Name": "de Vegt",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37213746: {
    id: "item_6042",
    "Last Name": "Harris",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37213787: {
    id: "item_6040",
    "Last Name": "Rivera Rivera",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214084: {
    id: "item_6036",
    "Last Name": "Manese",
    "First Name": "jay jhoseph",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214199: {
    id: "item_6483",
    "Last Name": "Susanto",
    "First Name": "Budiman",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214329: {
    id: "item_6552",
    "Last Name": "Thiery",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214390: {
    id: "item_6034",
    "Last Name": "Miller",
    "First Name": "Rodolfo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214448: {
    id: "item_6551",
    "Last Name": "Chen",
    "First Name": "Brian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214481: {
    id: "item_6032",
    "Last Name": "Kwok",
    "First Name": "Kar Cheong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214591: {
    id: "item_32016",
    "Last Name": "Hoare",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214609: {
    id: "item_6482",
    "Last Name": "Jennison",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214739: {
    id: "item_6550",
    "Last Name": "Martirez",
    "First Name": "Rhaymart",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214742: {
    id: "item_8621",
    "Last Name": "Kallenbach",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214778: {
    id: "item_19220",
    "Last Name": "Chladek",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214930: {
    id: "item_8617",
    "Last Name": "DONEGAN",
    "First Name": "JOSEPH",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37214982: {
    id: "item_6029",
    "Last Name": "Coley",
    "First Name": "Chase",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215058: {
    id: "item_6027",
    "Last Name": "Harrison",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215278: {
    id: "item_6024",
    "Last Name": "Jones",
    "First Name": "Brea",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215358: {
    id: "item_8614",
    "Last Name": "Knuth",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215390: {
    id: "item_21247",
    "Last Name": "Svenningsen",
    "First Name": "Bill Liberty",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215466: {
    id: "item_33657",
    "Last Name": "Ng",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215569: {
    id: "item_8610",
    "Last Name": "Coulson",
    "First Name": "Allan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215720: {
    id: "item_6016",
    "Last Name": "Spiewak",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215767: {
    id: "item_8607",
    "Last Name": "Taylor",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215775: {
    id: "item_32011",
    "Last Name": "Ferguson",
    "First Name": "Elyse",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215849: {
    id: "item_32010",
    "Last Name": "Grant",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215883: {
    id: "item_8606",
    "Last Name": "YU",
    "First Name": "HSIANG-LU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37215934: {
    id: "item_21243",
    "Last Name": "Betancourt",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37216027: {
    id: "item_32162",
    "Last Name": "Jagonos",
    "First Name": "Jona Lei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37216075: {
    id: "item_6009",
    "Last Name": "Ortega",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37216099: {
    id: "item_8605",
    "Last Name": "Erskine",
    "First Name": "Kerrie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37216103: {
    id: "item_6010",
    "Last Name": "Andriani",
    "First Name": "Adelaide",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37216503: {
    id: "item_8820",
    "Last Name": "Alvarez Brito",
    "First Name": "Malena Julieta",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37216638: {
    id: "item_6549",
    "Last Name": "Hoffman",
    "First Name": "Logan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37216664: {
    id: "item_32006",
    "Last Name": "Wright",
    "First Name": "Brett",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37216746: {
    id: "item_8601",
    "Last Name": "Van Komen",
    "First Name": "Alexa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37216800: {
    id: "item_32217",
    "Last Name": "Diaz",
    "First Name": "Yoselyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217135: {
    id: "item_21234",
    "Last Name": "Jakupi",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217144: {
    id: "item_5995",
    "Last Name": "Ravagnin",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217169: {
    id: "item_8598",
    "Last Name": "Redes",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217172: {
    id: "item_6548",
    "Last Name": "Chen",
    "First Name": "Jingjia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217259: {
    id: "item_8597",
    "Last Name": "Coumont",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217485: {
    id: "item_5993",
    "Last Name": "Caballero Chong",
    "First Name": "Luis Carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217498: {
    id: "item_33644",
    "Last Name": "Inocencio",
    "First Name": "Wilfredo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217708: {
    id: "item_33641",
    "Last Name": "Farber",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217729: {
    id: "item_5987",
    "Last Name": "mas faba",
    "First Name": "ferran",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217810: {
    id: "item_8591",
    "Last Name": "Woodroffe",
    "First Name": "Tatum",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217841: {
    id: "item_32001",
    "Last Name": "Pandey",
    "First Name": "Shruti",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217851: {
    id: "item_5985",
    "Last Name": "Raphael",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217860: {
    id: "item_33637",
    "Last Name": "Davies",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217869: {
    id: "item_33639",
    "Last Name": "Bird",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217923: {
    id: "item_33635",
    "Last Name": "Villacis",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37217929: {
    id: "item_5984",
    "Last Name": "Armstrong",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218002: {
    id: "item_33633",
    "Last Name": "The",
    "First Name": "Lani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218078: {
    id: "item_5980",
    "Last Name": "Sanchez",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218175: {
    id: "item_8589",
    "Last Name": "Fitzgerald",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218196: {
    id: "item_31998",
    "Last Name": "Rowe",
    "First Name": "Esme",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218216: {
    id: "item_5974",
    "Last Name": "Hua",
    "First Name": "Hong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218244: {
    id: "item_21225",
    "Last Name": "Acimov",
    "First Name": "Dragan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218268: {
    id: "item_21223",
    "Last Name": "Plakias",
    "First Name": "Evan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218270: {
    id: "item_21224",
    "Last Name": "Healey",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218272: {
    id: "item_33629",
    "Last Name": "Madden",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218394: {
    id: "item_21222",
    "Last Name": "Botica",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218530: {
    id: "item_8583",
    "Last Name": "Wetthasinghe",
    "First Name": "Kasun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218534: {
    id: "item_21220",
    "Last Name": "Day",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218541: {
    id: "item_31993",
    "Last Name": "Silawan",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218646: {
    id: "item_21218",
    "Last Name": "Tromp",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218847: {
    id: "item_31991",
    "Last Name": "Sam",
    "First Name": "Tsui Ling",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37218897: {
    id: "item_33920",
    "Last Name": "Slack",
    "First Name": "Marjorie (Tracy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219087: {
    id: "item_5958",
    "Last Name": "Taurins",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219111: {
    id: "item_5957",
    "Last Name": "Seaman",
    "First Name": "Briohny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219169: {
    id: "item_5953",
    "Last Name": "Masterson",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219526: {
    id: "item_5946",
    "Last Name": "Galvao-nunes",
    "First Name": "Gabriella",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219534: {
    id: "item_8570",
    "Last Name": "Brown",
    "First Name": "Alison",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219584: {
    id: "item_33613",
    "Last Name": "Bassett",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219653: {
    id: "item_21211",
    "Last Name": "Marchesan",
    "First Name": "Denis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219691: {
    id: "item_8569",
    "Last Name": "Doeleman",
    "First Name": "Emile",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219702: {
    id: "item_8568",
    "Last Name": "Simpson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219725: {
    id: "item_21210",
    "Last Name": "Limao",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219776: {
    id: "item_5938",
    "Last Name": "McCafferty",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219920: {
    id: "item_5933",
    "Last Name": "Vu",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219965: {
    id: "item_33610",
    "Last Name": "Lum",
    "First Name": "Avram",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37219991: {
    id: "item_8565",
    "Last Name": "Warren",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220116: {
    id: "item_8564",
    "Last Name": "Orynska-Grzybek",
    "First Name": "Aleksandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220170: {
    id: "item_5931",
    "Last Name": "McAreavey",
    "First Name": "Johnny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220191: {
    id: "item_33607",
    "Last Name": "De Guzman",
    "First Name": "Joyce Anne Pearl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220235: {
    id: "item_32216",
    "Last Name": "Yong Soon",
    "First Name": "Pang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220382: {
    id: "item_5929",
    "Last Name": "Harris",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220406: {
    id: "item_5928",
    "Last Name": "Jones",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220438: {
    id: "item_5927",
    "Last Name": "Thompson",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220547: {
    id: "item_21204",
    "Last Name": "Power",
    "First Name": "Aisling",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220597: {
    id: "item_5922",
    "Last Name": "McGregor",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220669: {
    id: "item_21201",
    "Last Name": "Cassidy",
    "First Name": "Kaitlin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220677: {
    id: "item_8556",
    "Last Name": "Blake",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220748: {
    id: "item_19348",
    "Last Name": "Radko",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220799: {
    id: "item_5916",
    "Last Name": "Morson",
    "First Name": "Greg",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220808: {
    id: "item_8554",
    "Last Name": "Nam",
    "First Name": "Dong He",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220878: {
    id: "item_33596",
    "Last Name": "Briggs",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220896: {
    id: "item_6547",
    "Last Name": "Hopla",
    "First Name": "Daryl",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220964: {
    id: "item_33595",
    "Last Name": "Williams",
    "First Name": "Robin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37220980: {
    id: "item_5913",
    "Last Name": "klaeser",
    "First Name": "katharina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221028: {
    id: "item_31975",
    "Last Name": "Harris",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221051: {
    id: "item_33594",
    "Last Name": "Taira",
    "First Name": "Mihoko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221055: {
    id: "item_33592",
    "Last Name": "Hampton",
    "First Name": "Scott",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221070: {
    id: "item_5911",
    "Last Name": "Jeffery",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221113: {
    id: "item_31972",
    "Last Name": "Watts",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221119: {
    id: "item_21198",
    "Last Name": "Currie",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221147: {
    id: "item_31971",
    "Last Name": "Ramos",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221228: {
    id: "item_31969",
    "Last Name": "Khattri",
    "First Name": "Mrigesh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221271: {
    id: "item_8862",
    "Last Name": "Griffiths",
    "First Name": "Owain",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221300: {
    id: "item_8546",
    "Last Name": "Doeing",
    "First Name": "Diana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221334: {
    id: "item_5901",
    "Last Name": "Kelly",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221452: {
    id: "item_5899",
    "Last Name": "Maluto",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221464: {
    id: "item_8544",
    "Last Name": "Kneen",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221686: {
    id: "item_5897",
    "Last Name": "Kenny",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221795: {
    id: "item_8861",
    "Last Name": "Mendes",
    "First Name": "Abimar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37221916: {
    id: "item_5895",
    "Last Name": "Werner",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222086: {
    id: "item_5890",
    "Last Name": "Loza",
    "First Name": "Winston",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222094: {
    id: "item_5889",
    "Last Name": "Lim",
    "First Name": "Minhyuck",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222348: {
    id: "item_33581",
    "Last Name": "Williams",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222389: {
    id: "item_5883",
    "Last Name": "CHçVEZ FALCONI",
    "First Name": "ROBERT",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222392: {
    id: "item_8538",
    "Last Name": "Paccagnan",
    "First Name": "Mario",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222445: {
    id: "item_33580",
    "Last Name": "Urban",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222470: {
    id: "item_5880",
    "Last Name": "Phillips",
    "First Name": "Jakob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222532: {
    id: "item_32215",
    "Last Name": "Mellon",
    "First Name": "Holly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222540: {
    id: "item_5879",
    "Last Name": "Martin",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222546: {
    id: "item_31958",
    "Last Name": "Tran",
    "First Name": "Hong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222868: {
    id: "item_32161",
    "Last Name": "Chang",
    "First Name": "Tein chin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37222962: {
    id: "item_8530",
    "Last Name": "James",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223046: {
    id: "item_21183",
    "Last Name": "KIM",
    "First Name": "SIWON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223055: {
    id: "item_31954",
    "Last Name": "Bate",
    "First Name": "Marina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223141: {
    id: "item_5871",
    "Last Name": "Percival",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223147: {
    id: "item_5869",
    "Last Name": "Karmanto",
    "First Name": "Karmanto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223157: {
    id: "item_8529",
    "Last Name": "Pembroke",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223207: {
    id: "item_31952",
    "Last Name": "Lay",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223280: {
    id: "item_5864",
    "Last Name": "Tran",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223304: {
    id: "item_8525",
    "Last Name": "Ackerman",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223420: {
    id: "item_31950",
    "Last Name": "Choi",
    "First Name": "Joonmyung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223471: {
    id: "item_33570",
    "Last Name": "Morgan",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223494: {
    id: "item_5858",
    "Last Name": "Mcgiffen",
    "First Name": "Brett",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223571: {
    id: "item_33569",
    "Last Name": "Dague",
    "First Name": "Meghan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223667: {
    id: "item_5857",
    "Last Name": "Van't Hooft",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223674: {
    id: "item_8524",
    "Last Name": "Sanchez",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223697: {
    id: "item_33567",
    "Last Name": "Pablo",
    "First Name": "Roxy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223708: {
    id: "item_5855",
    "Last Name": "Morrison",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223802: {
    id: "item_33566",
    "Last Name": "Sorgiovanni",
    "First Name": "Jenae",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223947: {
    id: "item_5852",
    "Last Name": "Dela Cruz",
    "First Name": "Jeff",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37223986: {
    id: "item_31942",
    "Last Name": "Samuel",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224093: {
    id: "item_8521",
    "Last Name": "Cotterill",
    "First Name": "Fraser",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224094: {
    id: "item_31941",
    "Last Name": "Torres",
    "First Name": "Sendi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224108: {
    id: "item_8519",
    "Last Name": "Kim",
    "First Name": "Soyeon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224180: {
    id: "item_8860",
    "Last Name": "Reynoso",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224303: {
    id: "item_5844",
    "Last Name": "Hulston",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224334: {
    id: "item_21178",
    "Last Name": "Pepe",
    "First Name": "Fabiola",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224467: {
    id: "item_21177",
    "Last Name": "Chiw",
    "First Name": "Ser Sze",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224540: {
    id: "item_21175",
    "Last Name": "Shuai",
    "First Name": "Hou",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224565: {
    id: "item_5843",
    "Last Name": "Goad",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224602: {
    id: "item_5841",
    "Last Name": "Wang",
    "First Name": "ShihShen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224718: {
    id: "item_33561",
    "Last Name": "Munro",
    "First Name": "Tony",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224796: {
    id: "item_8515",
    "Last Name": "Marenda",
    "First Name": "Mery",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224827: {
    id: "item_5840",
    "Last Name": "Woosnam",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37224930: {
    id: "item_21172",
    "Last Name": "Colpo",
    "First Name": "Mary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225022: {
    id: "item_5838",
    "Last Name": "Berrisford-Thompson",
    "First Name": "Jemima",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225029: {
    id: "item_5837",
    "Last Name": "Ruiz Rodriguez",
    "First Name": "Stefany",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225123: {
    id: "item_5835",
    "Last Name": "Chan",
    "First Name": "Siu Wah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225126: {
    id: "item_21171",
    "Last Name": "Diprose",
    "First Name": "Miranda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225169: {
    id: "item_5833",
    "Last Name": "O' Rourke",
    "First Name": "Niall",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225176: {
    id: "item_21170",
    "Last Name": "Riley",
    "First Name": "Cat",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225208: {
    id: "item_33560",
    "Last Name": "Yumul",
    "First Name": "Sherylyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225209: {
    id: "item_33115",
    "Last Name": "Dunford",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225256: {
    id: "item_31932",
    "Last Name": "Patten",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225287: {
    id: "item_8512",
    "Last Name": "Roberts Thomson",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225307: {
    id: "item_5830",
    "Last Name": "Martinez Godinez",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225349: {
    id: "item_21169",
    "Last Name": "Tersigni",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225350: {
    id: "item_8511",
    "Last Name": "Martinez del Camino",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225379: {
    id: "item_21168",
    "Last Name": "Chen",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225675: {
    id: "item_8508",
    "Last Name": "Daly",
    "First Name": "Ceara",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225822: {
    id: "item_5823",
    "Last Name": "LUK",
    "First Name": "YUN FAT",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225831: {
    id: "item_33556",
    "Last Name": "Cao",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37225855: {
    id: "item_31926",
    "Last Name": "Foundas",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37226005: {
    id: "item_19347",
    "Last Name": "Hsu",
    "First Name": "Han Wei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37226455: {
    id: "item_31924",
    "Last Name": "Goodwin",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37226540: {
    id: "item_8502",
    "Last Name": "Koch",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37226588: {
    id: "item_21391",
    "Last Name": "Singh",
    "First Name": "Ved",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37226703: {
    id: "item_32214",
    "Last Name": "Hill",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37226737: {
    id: "item_33554",
    "Last Name": "ACEITUNO",
    "First Name": "RAFAEL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37226809: {
    id: "item_31920",
    "Last Name": "Randolph",
    "First Name": "Devin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37226898: {
    id: "item_6546",
    "Last Name": "Lossner",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37226981: {
    id: "item_6545",
    "Last Name": "Allwardt",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227197: {
    id: "item_33549",
    "Last Name": "Miles",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227304: {
    id: "item_21161",
    "Last Name": "Tat",
    "First Name": "Justin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227471: {
    id: "item_6544",
    "Last Name": "Andrade",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227483: {
    id: "item_8859",
    "Last Name": "Delgado",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227581: {
    id: "item_33116",
    "Last Name": "Mangunay",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227633: {
    id: "item_8495",
    "Last Name": "Walker",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227735: {
    id: "item_21158",
    "Last Name": "Klein",
    "First Name": "Conor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227756: {
    id: "item_8819",
    "Last Name": "Arora",
    "First Name": "Jyoti",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227792: {
    id: "item_8494",
    "Last Name": "Midyat",
    "First Name": "Levent",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227812: {
    id: "item_33543",
    "Last Name": "Codia",
    "First Name": "Joy Edilen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227903: {
    id: "item_8492",
    "Last Name": "Hilliar",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227909: {
    id: "item_19346",
    "Last Name": "Salinas",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227931: {
    id: "item_33541",
    "Last Name": "Conroy",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227955: {
    id: "item_31911",
    "Last Name": "Moredo",
    "First Name": "Celine Anne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37227984: {
    id: "item_21156",
    "Last Name": "Curran",
    "First Name": "Brady",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228062: {
    id: "item_8490",
    "Last Name": "DE LEON GUILLEN",
    "First Name": "GORETTI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228155: {
    id: "item_31910",
    "Last Name": "Kelly",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228157: {
    id: "item_33537",
    "Last Name": "Baik",
    "First Name": "Jeeho",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228234: {
    id: "item_31909",
    "Last Name": "YE",
    "First Name": "QILIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228238: {
    id: "item_19345",
    "Last Name": "Pichardo",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228376: {
    id: "item_31905",
    "Last Name": "Weygang",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228845: {
    id: "item_33534",
    "Last Name": "Luu",
    "First Name": "Long",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228853: {
    id: "item_31902",
    "Last Name": "XU",
    "First Name": "ZHANXIANG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228898: {
    id: "item_8483",
    "Last Name": "Ming",
    "First Name": "Liang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228915: {
    id: "item_33533",
    "Last Name": "Wilkinson",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37228974: {
    id: "item_33531",
    "Last Name": "Arnott",
    "First Name": "Leanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37229001: {
    id: "item_31900",
    "Last Name": "Wang",
    "First Name": "Jing",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37229124: {
    id: "item_33528",
    "Last Name": "Bin Shamsuddin",
    "First Name": "Sazwan Reezal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37229278: {
    id: "item_8474",
    "Last Name": "Shvets",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37229990: {
    id: "item_33525",
    "Last Name": "Migraso",
    "First Name": "Lenille Jean Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37230073: {
    id: "item_31894",
    "Last Name": "Huynh",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37230381: {
    id: "item_6543",
    "Last Name": "Ji",
    "First Name": "Junsu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37230613: {
    id: "item_33523",
    "Last Name": "Kuo",
    "First Name": "Hsiang-Li",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37230783: {
    id: "item_33117",
    "Last Name": "Cotterill",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37230897: {
    id: "item_31893",
    "Last Name": "Bautista",
    "First Name": "Marlito",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37230987: {
    id: "item_33521",
    "Last Name": "Fisher",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231047: {
    id: "item_33520",
    "Last Name": "Hays",
    "First Name": "Imogen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231184: {
    id: "item_33518",
    "Last Name": "Curtis",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231254: {
    id: "item_8468",
    "Last Name": "Nunez",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231358: {
    id: "item_8466",
    "Last Name": "TIAN",
    "First Name": "weifeng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231400: {
    id: "item_8465",
    "Last Name": "Seymour",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231678: {
    id: "item_8459",
    "Last Name": "Fonseca",
    "First Name": "Marcela",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231739: {
    id: "item_31889",
    "Last Name": "Yang",
    "First Name": "Li",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231759: {
    id: "item_21142",
    "Last Name": "Cui",
    "First Name": "Jichun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231933: {
    id: "item_21141",
    "Last Name": "Stuart",
    "First Name": "Teagan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37231980: {
    id: "item_21140",
    "Last Name": "Harrington",
    "First Name": "Sala",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232009: {
    id: "item_33510",
    "Last Name": "Subramanian",
    "First Name": "Nachiappan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232018: {
    id: "item_18585",
    "Last Name": "Humphries",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232050: {
    id: "item_33509",
    "Last Name": "Gallagher",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232151: {
    id: "item_31885",
    "Last Name": "Basalamah",
    "First Name": "Irfan Nasir",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232159: {
    id: "item_5819",
    "Last Name": "Bermudez",
    "First Name": "Bryle Timothy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232250: {
    id: "item_21139",
    "Last Name": "Yang",
    "First Name": "Chihlin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232313: {
    id: "item_21137",
    "Last Name": "Babayev",
    "First Name": "Dmytro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232317: {
    id: "item_31884",
    "Last Name": "Rinawati",
    "First Name": "Sinta",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232417: {
    id: "item_31883",
    "Last Name": "Price",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232457: {
    id: "item_33503",
    "Last Name": "Tozkoparan",
    "First Name": "Irem",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232467: {
    id: "item_21136",
    "Last Name": "Wu",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232470: {
    id: "item_31881",
    "Last Name": "Heslop",
    "First Name": "Vivienne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232592: {
    id: "item_21134",
    "Last Name": "Capel",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232593: {
    id: "item_33502",
    "Last Name": "PAN",
    "First Name": "JIALE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232603: {
    id: "item_21133",
    "Last Name": "Dong",
    "First Name": "Xiaoyi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232620: {
    id: "item_33919",
    "Last Name": "Capper",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232645: {
    id: "item_33501",
    "Last Name": "Witak",
    "First Name": "Kai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232652: {
    id: "item_33500",
    "Last Name": "Pereira",
    "First Name": "Shah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232663: {
    id: "item_21132",
    "Last Name": "Zavrsnik",
    "First Name": "Alenka",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232690: {
    id: "item_31876",
    "Last Name": "Suleiman",
    "First Name": "Hedi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232738: {
    id: "item_21130",
    "Last Name": "Anwar",
    "First Name": "Mohamed",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232844: {
    id: "item_33499",
    "Last Name": "Tenggara",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37232890: {
    id: "item_31873",
    "Last Name": "WONG",
    "First Name": "PING CHUEN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233189: {
    id: "item_31869",
    "Last Name": "Patrasio",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233219: {
    id: "item_33496",
    "Last Name": "YAN",
    "First Name": "LI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233227: {
    id: "item_8443",
    "Last Name": "Elliott",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233267: {
    id: "item_31867",
    "Last Name": "Casubha",
    "First Name": "Roma Adnexa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233294: {
    id: "item_31866",
    "Last Name": "Shukla",
    "First Name": "Harshit",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233419: {
    id: "item_32213",
    "Last Name": "Wang",
    "First Name": "Xulu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233425: {
    id: "item_8440",
    "Last Name": "Sawley",
    "First Name": "Charlton",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233536: {
    id: "item_32212",
    "Last Name": "Burns",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233568: {
    id: "item_33492",
    "Last Name": "Ford",
    "First Name": "Desmond",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233689: {
    id: "item_31862",
    "Last Name": "Buttigieg",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233726: {
    id: "item_33489",
    "Last Name": "Nadeem",
    "First Name": "Shahwaiz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37233956: {
    id: "item_8433",
    "Last Name": "McCarthy",
    "First Name": "Glenn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234013: {
    id: "item_32211",
    "Last Name": "Bennett",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234034: {
    id: "item_31855",
    "Last Name": "Lin",
    "First Name": "Tzu-Ting",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234054: {
    id: "item_21121",
    "Last Name": "Tor",
    "First Name": "Sidney",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234066: {
    id: "item_21120",
    "Last Name": "Niblock",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234134: {
    id: "item_21118",
    "Last Name": "Xiu",
    "First Name": "Chengjun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234245: {
    id: "item_33485",
    "Last Name": "StoDomingo",
    "First Name": "Gerard",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234259: {
    id: "item_33483",
    "Last Name": "Jarman",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234282: {
    id: "item_8858",
    "Last Name": "TABATA",
    "First Name": "YOSUKE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234329: {
    id: "item_8427",
    "Last Name": "Bragg",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234393: {
    id: "item_8425",
    "Last Name": "Watts",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234600: {
    id: "item_8423",
    "Last Name": "Malloy",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234671: {
    id: "item_31845",
    "Last Name": "Bright",
    "First Name": "Marvia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234672: {
    id: "item_33477",
    "Last Name": "Downey",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234702: {
    id: "item_8419",
    "Last Name": "Nevard",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234829: {
    id: "item_33474",
    "Last Name": "Chin",
    "First Name": "Jin Chuan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234867: {
    id: "item_32210",
    "Last Name": "Versal",
    "First Name": "Farid",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37234987: {
    id: "item_31839",
    "Last Name": "Zhao",
    "First Name": "Lin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235010: {
    id: "item_8417",
    "Last Name": "Madry",
    "First Name": "Radoslaw",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235016: {
    id: "item_8416",
    "Last Name": "Lau",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235057: {
    id: "item_8415",
    "Last Name": "McAnally",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235107: {
    id: "item_19344",
    "Last Name": "Murray",
    "First Name": "Antoinette",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235369: {
    id: "item_31836",
    "Last Name": "PANG",
    "First Name": "LIENG KONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235396: {
    id: "item_21110",
    "Last Name": "Williams",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235450: {
    id: "item_19343",
    "Last Name": "Farag",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235456: {
    id: "item_8411",
    "Last Name": "Coleman",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235734: {
    id: "item_8410",
    "Last Name": "KATO",
    "First Name": "MOMOKO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235928: {
    id: "item_31830",
    "Last Name": "Sanders",
    "First Name": "Frances",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37235981: {
    id: "item_33868",
    "Last Name": "Burke",
    "First Name": "KATONYA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37236192: {
    id: "item_8409",
    "Last Name": "Clark",
    "First Name": "Derek",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37236194: {
    id: "item_8407",
    "Last Name": "Chiu",
    "First Name": "Yi Han",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37236242: {
    id: "item_8405",
    "Last Name": "Hajnal",
    "First Name": "Laszlo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37236322: {
    id: "item_8402",
    "Last Name": "Waters",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37236407: {
    id: "item_21106",
    "Last Name": "Griffin",
    "First Name": "Eamonn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37236422: {
    id: "item_33464",
    "Last Name": "Suan Nguyen",
    "First Name": "Am",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37236506: {
    id: "item_31827",
    "Last Name": "CHEUNG",
    "First Name": "MEI HO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37237035: {
    id: "item_8401",
    "Last Name": "Nirmolo",
    "First Name": "Windono Suryo Pujo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37237069: {
    id: "item_8400",
    "Last Name": "Au",
    "First Name": "Chun Kit",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37237104: {
    id: "item_31822",
    "Last Name": "Kalip",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37239128: {
    id: "item_8818",
    "Last Name": "WENYI",
    "First Name": "HU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37239522: {
    id: "item_21098",
    "Last Name": "JELLA",
    "First Name": "ROHINI Kumar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37239776: {
    id: "item_8395",
    "Last Name": "Massaro",
    "First Name": "Rocco",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37239918: {
    id: "item_31818",
    "Last Name": "Colwill",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37240160: {
    id: "item_21095",
    "Last Name": "Khalilov",
    "First Name": "Nodir",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37240569: {
    id: "item_33459",
    "Last Name": "Menzel",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37241158: {
    id: "item_21091",
    "Last Name": "Chan",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37241254: {
    id: "item_8857",
    "Last Name": "Pasarin",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37241335: {
    id: "item_8389",
    "Last Name": "Blaauw",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37241411: {
    id: "item_8390",
    "Last Name": "Kelley",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37242052: {
    id: "item_21088",
    "Last Name": "Carluccio",
    "First Name": "Judy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37242463: {
    id: "item_33456",
    "Last Name": "Biagi",
    "First Name": "Briana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37242702: {
    id: "item_8386",
    "Last Name": "Lee",
    "First Name": "Megan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37242817: {
    id: "item_8385",
    "Last Name": "Cheng",
    "First Name": "Cassidy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37242827: {
    id: "item_8383",
    "Last Name": "Buchholz",
    "First Name": "Barry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37243046: {
    id: "item_31813",
    "Last Name": "Manen",
    "First Name": "Bernardin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37243372: {
    id: "item_8381",
    "Last Name": "Fitz",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37243724: {
    id: "item_33454",
    "Last Name": "Irving",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37243773: {
    id: "item_5816",
    "Last Name": "Honey-Hember",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37243805: {
    id: "item_8379",
    "Last Name": "Roxburgh",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37243987: {
    id: "item_33451",
    "Last Name": "Mackey",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37244046: {
    id: "item_33450",
    "Last Name": "Legge",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37244699: {
    id: "item_31806",
    "Last Name": "Heggie",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37244760: {
    id: "item_33447",
    "Last Name": "Diputado",
    "First Name": "Mitchell Royce",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37244787: {
    id: "item_8373",
    "Last Name": "Rose",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37244886: {
    id: "item_8372",
    "Last Name": "Smith",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37244932: {
    id: "item_6542",
    "Last Name": "Chang",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37245777: {
    id: "item_8368",
    "Last Name": "Patrick",
    "First Name": "Narelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37245853: {
    id: "item_21079",
    "Last Name": "Eckermann",
    "First Name": "Charleen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37245934: {
    id: "item_8367",
    "Last Name": "Mahoney",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37245941: {
    id: "item_8366",
    "Last Name": "Hackett",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37246186: {
    id: "item_19342",
    "Last Name": "Awotwi",
    "First Name": "Sidney",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37246291: {
    id: "item_8362",
    "Last Name": "Meek",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37246484: {
    id: "item_8361",
    "Last Name": "Hewis",
    "First Name": "Johnathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37246732: {
    id: "item_8358",
    "Last Name": "Inocencio",
    "First Name": "Ishmael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37246826: {
    id: "item_33918",
    "Last Name": "TAKANO",
    "First Name": "JUNICHI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247197: {
    id: "item_31796",
    "Last Name": "Gadd",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247235: {
    id: "item_31795",
    "Last Name": "Daly",
    "First Name": "Eimear",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247308: {
    id: "item_33435",
    "Last Name": "Tran",
    "First Name": "Annie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247377: {
    id: "item_8353",
    "Last Name": "Ethangatta",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247417: {
    id: "item_31794",
    "Last Name": "Rawal",
    "First Name": "Bhupendra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247448: {
    id: "item_33434",
    "Last Name": "Masiero",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247450: {
    id: "item_31793",
    "Last Name": "Southern",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247456: {
    id: "item_6541",
    "Last Name": "Tsai",
    "First Name": "Pei Chun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247471: {
    id: "item_19341",
    "Last Name": "Gurung",
    "First Name": "Jatin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247576: {
    id: "item_33432",
    "Last Name": "Soosay",
    "First Name": "Claudine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247708: {
    id: "item_33431",
    "Last Name": "Romero",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247891: {
    id: "item_19340",
    "Last Name": "Galiza",
    "First Name": "Jayson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37247897: {
    id: "item_33429",
    "Last Name": "Kardha",
    "First Name": "Nyoman Bayu Arthayoga",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37248157: {
    id: "item_8344",
    "Last Name": "Kerrison",
    "First Name": "Macenzie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37248810: {
    id: "item_31786",
    "Last Name": "Ibnu",
    "First Name": "Pegy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37251258: {
    id: "item_31782",
    "Last Name": "Sterling",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37251366: {
    id: "item_8340",
    "Last Name": "Kwiat",
    "First Name": "Eitan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37251416: {
    id: "item_6540",
    "Last Name": "Seibel",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37251592: {
    id: "item_8339",
    "Last Name": "jing",
    "First Name": "xin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37251701: {
    id: "item_21071",
    "Last Name": "Khrisna",
    "First Name": "Noor Soeseno D",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37251860: {
    id: "item_21070",
    "Last Name": "Connor",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37251943: {
    id: "item_8338",
    "Last Name": "MABUCHI",
    "First Name": "CHIHARU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252145: {
    id: "item_33419",
    "Last Name": "Le",
    "First Name": "Tran",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252350: {
    id: "item_8335",
    "Last Name": "Narbay",
    "First Name": "Ien Shen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252400: {
    id: "item_21068",
    "Last Name": "Long",
    "First Name": "Georgi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252427: {
    id: "item_8334",
    "Last Name": "Davidson",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252463: {
    id: "item_31776",
    "Last Name": "Asenjo Rueda",
    "First Name": "Luis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252474: {
    id: "item_6539",
    "Last Name": "xiao",
    "First Name": "min",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252598: {
    id: "item_31775",
    "Last Name": "WANG",
    "First Name": "Yuce",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252614: {
    id: "item_8856",
    "Last Name": "Liner",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252641: {
    id: "item_20748",
    "Last Name": "Hillery",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37252966: {
    id: "item_31774",
    "Last Name": "Espinosa",
    "First Name": "Ingrid",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37253082: {
    id: "item_33411",
    "Last Name": "Rachman",
    "First Name": "Rizky Arief",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37253116: {
    id: "item_33410",
    "Last Name": "CHIU",
    "First Name": "YUNG-SHIOU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37253202: {
    id: "item_33409",
    "Last Name": "Simanjuntak",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37253277: {
    id: "item_8328",
    "Last Name": "Winterflood",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37253421: {
    id: "item_19339",
    "Last Name": "Tisserand",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37253538: {
    id: "item_21064",
    "Last Name": "Himrich",
    "First Name": "Poksil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37253675: {
    id: "item_21063",
    "Last Name": "Stewart",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37253690: {
    id: "item_8325",
    "Last Name": "Kholif Alventa",
    "First Name": "Edo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37253836: {
    id: "item_8323",
    "Last Name": "Superbi",
    "First Name": "Simone",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37254081: {
    id: "item_33406",
    "Last Name": "Hein",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37254108: {
    id: "item_33405",
    "Last Name": "Golilat",
    "First Name": "Mia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37254472: {
    id: "item_20749",
    "Last Name": "Bernard",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37254717: {
    id: "item_33401",
    "Last Name": "Halaba",
    "First Name": "Shelley Jan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37254791: {
    id: "item_21061",
    "Last Name": "Carrero Aguilar",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37254834: {
    id: "item_33400",
    "Last Name": "Santos",
    "First Name": "Madonna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37254986: {
    id: "item_8319",
    "Last Name": "Shek",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37255146: {
    id: "item_8318",
    "Last Name": "Maher",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37255147: {
    id: "item_8316",
    "Last Name": "Soggiu",
    "First Name": "Luigi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37255287: {
    id: "item_31763",
    "Last Name": "Burbridge",
    "First Name": "Cathy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37255567: {
    id: "item_31762",
    "Last Name": "Chan",
    "First Name": "Oi Kwan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37255736: {
    id: "item_31760",
    "Last Name": "Cole",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37255985: {
    id: "item_31758",
    "Last Name": "Resthy",
    "First Name": "Cherylia Fita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37256182: {
    id: "item_8310",
    "Last Name": "Woolhouse",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37256282: {
    id: "item_8311",
    "Last Name": "Moir",
    "First Name": "Jordyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37256373: {
    id: "item_32209",
    "Last Name": "Ngo",
    "First Name": "Vinarith",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37256378: {
    id: "item_31756",
    "Last Name": "Tomlinson",
    "First Name": "Jan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37256414: {
    id: "item_33395",
    "Last Name": "Lee",
    "First Name": "Yee Man Ivy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37256550: {
    id: "item_21051",
    "Last Name": "Yip",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37256583: {
    id: "item_33394",
    "Last Name": "Weir",
    "First Name": "Riley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37256584: {
    id: "item_33393",
    "Last Name": "Angkico",
    "First Name": "Earl lorenz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37256698: {
    id: "item_31754",
    "Last Name": "Efendy",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257173: {
    id: "item_7985",
    "Last Name": "Kim",
    "First Name": "Semin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257215: {
    id: "item_33392",
    "Last Name": "Barnes",
    "First Name": "Esther",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257289: {
    id: "item_5812",
    "Last Name": "Omerovic",
    "First Name": "Sifet",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257303: {
    id: "item_33389",
    "Last Name": "Barnes",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257497: {
    id: "item_31748",
    "Last Name": "Young",
    "First Name": "Aimee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257507: {
    id: "item_19338",
    "Last Name": "Chiang",
    "First Name": "Wei-Jen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257620: {
    id: "item_20750",
    "Last Name": "Hendrie",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257770: {
    id: "item_33385",
    "Last Name": "Mustac",
    "First Name": "Courtney",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257855: {
    id: "item_33383",
    "Last Name": "Chen",
    "First Name": "Che yuan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257944: {
    id: "item_33382",
    "Last Name": "Janson",
    "First Name": "Adrianne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37257983: {
    id: "item_8299",
    "Last Name": "Saleh",
    "First Name": "Khalid",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37258180: {
    id: "item_8297",
    "Last Name": "Parsons",
    "First Name": "Elliot",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37258310: {
    id: "item_6481",
    "Last Name": "KIM",
    "First Name": "JUNHEE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37258497: {
    id: "item_8293",
    "Last Name": "Skupniewska",
    "First Name": "Ewa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37258530: {
    id: "item_8292",
    "Last Name": "Martin",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37258807: {
    id: "item_31739",
    "Last Name": "Lassen",
    "First Name": "Mikael Schmidt",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37258864: {
    id: "item_33374",
    "Last Name": "De Jesus",
    "First Name": "Rizalyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37259069: {
    id: "item_8289",
    "Last Name": "du Toit",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37259080: {
    id: "item_33372",
    "Last Name": "jo",
    "First Name": "ahyoung adele",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37259400: {
    id: "item_31737",
    "Last Name": "Godoy",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37259445: {
    id: "item_31736",
    "Last Name": "Petkovic",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37259868: {
    id: "item_33369",
    "Last Name": "Ichsan",
    "First Name": "Nila Pratiwi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37260074: {
    id: "item_33367",
    "Last Name": "Miller",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37260323: {
    id: "item_31730",
    "Last Name": "Kusumaningrum",
    "First Name": "Candra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37260456: {
    id: "item_8279",
    "Last Name": "Kiyotaki",
    "First Name": "Taiki",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37260775: {
    id: "item_31729",
    "Last Name": "Pristyawat",
    "First Name": "Ani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37260923: {
    id: "item_8277",
    "Last Name": "Man",
    "First Name": "Cheuk Ho",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37261049: {
    id: "item_33364",
    "Last Name": "Nofrimurti",
    "First Name": "Maulana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37261544: {
    id: "item_33360",
    "Last Name": "Shah",
    "First Name": "Hardik",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37261852: {
    id: "item_33357",
    "Last Name": "Ellysa",
    "First Name": "Rahajeng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37266452: {
    id: "item_21038",
    "Last Name": "Herrera",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37267151: {
    id: "item_31725",
    "Last Name": "Nzuzo",
    "First Name": "Azukile",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37267378: {
    id: "item_33356",
    "Last Name": "Buensuceso",
    "First Name": "Bel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37275388: {
    id: "item_21037",
    "Last Name": "Tou",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37275407: {
    id: "item_31721",
    "Last Name": "Fadamitan",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37275458: {
    id: "item_8272",
    "Last Name": "Gardiner",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37285008: {
    id: "item_32160",
    "Last Name": "Vijil",
    "First Name": "Carrie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37287708: {
    id: "item_31715",
    "Last Name": "Juzva",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37288129: {
    id: "item_31713",
    "Last Name": "Phoenix",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37288723: {
    id: "item_8266",
    "Last Name": "Awad",
    "First Name": "Ahmad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37288899: {
    id: "item_19337",
    "Last Name": "McKnight",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37289008: {
    id: "item_31709",
    "Last Name": "Lee",
    "First Name": "Novik",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37289089: {
    id: "item_31706",
    "Last Name": "Diehl",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37289423: {
    id: "item_8262",
    "Last Name": "Aceves Cevallos",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37289523: {
    id: "item_33351",
    "Last Name": "Verdugo",
    "First Name": "Ahtziry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37289837: {
    id: "item_21027",
    "Last Name": "Hoffman",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37289974: {
    id: "item_8261",
    "Last Name": "Newsom",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37290099: {
    id: "item_19336",
    "Last Name": "King",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37290311: {
    id: "item_8260",
    "Last Name": "Lerma",
    "First Name": "Edna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37290471: {
    id: "item_19335",
    "Last Name": "Betancourt",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37290649: {
    id: "item_8258",
    "Last Name": "Lee",
    "First Name": "Taylor Rebecca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37290845: {
    id: "item_8257",
    "Last Name": "Randall",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37291031: {
    id: "item_31698",
    "Last Name": "Wood",
    "First Name": "Monyka",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37291195: {
    id: "item_8255",
    "Last Name": "Ayala",
    "First Name": "Ahtziri",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37291197: {
    id: "item_21022",
    "Last Name": "Denetro Fragoso",
    "First Name": "Jose de Jesus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37291533: {
    id: "item_21021",
    "Last Name": "Angel Tobon",
    "First Name": "Juan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37291679: {
    id: "item_8855",
    "Last Name": "Zillekens",
    "First Name": "Maximilian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37291716: {
    id: "item_21020",
    "Last Name": "Knight",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37291878: {
    id: "item_31694",
    "Last Name": "De Stefano",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292021: {
    id: "item_21019",
    "Last Name": "McCosh",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292071: {
    id: "item_32208",
    "Last Name": "Oakley",
    "First Name": "Allison",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292102: {
    id: "item_8251",
    "Last Name": "Nash",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292107: {
    id: "item_8817",
    "Last Name": "Scharen",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292135: {
    id: "item_21018",
    "Last Name": "Horman",
    "First Name": "Stafford",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292339: {
    id: "item_8854",
    "Last Name": "Kitara",
    "First Name": "Shigeo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292622: {
    id: "item_31688",
    "Last Name": "Ellis",
    "First Name": "Madelaine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292675: {
    id: "item_6538",
    "Last Name": "Andreas",
    "First Name": "Scorpicanrus Tumpal",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292740: {
    id: "item_6537",
    "Last Name": "Faes-Scott",
    "First Name": "Colleen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292768: {
    id: "item_33339",
    "Last Name": "Gurung",
    "First Name": "Prunella",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292775: {
    id: "item_21013",
    "Last Name": "Browning",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37292859: {
    id: "item_21011",
    "Last Name": "Hill",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37293397: {
    id: "item_8246",
    "Last Name": "Devianto",
    "First Name": "Titto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37293425: {
    id: "item_21007",
    "Last Name": "Snook",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37293643: {
    id: "item_31687",
    "Last Name": "Masiiwa",
    "First Name": "Zviko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37294107: {
    id: "item_31681",
    "Last Name": "Soslow",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37294383: {
    id: "item_33917",
    "Last Name": "KIim",
    "First Name": "Taeoh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37294541: {
    id: "item_31680",
    "Last Name": "Rosete",
    "First Name": "Neil Raymond",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37294566: {
    id: "item_6536",
    "Last Name": "BING REN",
    "First Name": "TAI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295074: {
    id: "item_19219",
    "Last Name": "RYU",
    "First Name": "SEUNGLYOL",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295090: {
    id: "item_8232",
    "Last Name": "Murtado",
    "First Name": "Sugi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295453: {
    id: "item_31678",
    "Last Name": "Faridhan",
    "First Name": "Adnan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295497: {
    id: "item_19334",
    "Last Name": "Tiartanaya",
    "First Name": "Bianda Mayfiani",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295546: {
    id: "item_21004",
    "Last Name": "McGee",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295647: {
    id: "item_33323",
    "Last Name": "Chew",
    "First Name": "Kong Sim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295706: {
    id: "item_8229",
    "Last Name": "Shi",
    "First Name": "Liang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295887: {
    id: "item_33118",
    "Last Name": "Bizoev",
    "First Name": "Boyan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295933: {
    id: "item_33322",
    "Last Name": "Rindner",
    "First Name": "Jesse",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37295958: {
    id: "item_21003",
    "Last Name": "Morata",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37296045: {
    id: "item_33321",
    "Last Name": "Seda-Fernandez",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37296258: {
    id: "item_21390",
    "Last Name": "Lo",
    "First Name": "WENHUA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37296444: {
    id: "item_31675",
    "Last Name": "Boyles",
    "First Name": "Mary Jo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37296486: {
    id: "item_8223",
    "Last Name": "Neofitou",
    "First Name": "Spiro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37296530: {
    id: "item_8224",
    "Last Name": "Willoughby",
    "First Name": "Taryn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37296587: {
    id: "item_31674",
    "Last Name": "Ramos",
    "First Name": "Coraima",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37296785: {
    id: "item_31673",
    "Last Name": "Lagombra",
    "First Name": "Rosa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37296937: {
    id: "item_8218",
    "Last Name": "Ramirez",
    "First Name": "Jesus Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37297181: {
    id: "item_8214",
    "Last Name": "OÕConnor",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37297193: {
    id: "item_31670",
    "Last Name": "Gan",
    "First Name": "Ming Hung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37297343: {
    id: "item_20999",
    "Last Name": "Hayden",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37297528: {
    id: "item_31667",
    "Last Name": "Cheong",
    "First Name": "I Teng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37297544: {
    id: "item_31668",
    "Last Name": "Chan",
    "First Name": "Bonnie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37297594: {
    id: "item_8212",
    "Last Name": "Smith",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37297826: {
    id: "item_20997",
    "Last Name": "Davidson",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37297991: {
    id: "item_33314",
    "Last Name": "Masiga",
    "First Name": "Lailah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37298094: {
    id: "item_33313",
    "Last Name": "Miratana",
    "First Name": "Mel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37298095: {
    id: "item_31666",
    "Last Name": "PAN",
    "First Name": "CHIA-MING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37298207: {
    id: "item_31664",
    "Last Name": "Arnold",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37298285: {
    id: "item_21389",
    "Last Name": "Kosasih",
    "First Name": "Tamika",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37298744: {
    id: "item_8206",
    "Last Name": "Castor",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37298757: {
    id: "item_33312",
    "Last Name": "Daymiel",
    "First Name": "Mariluz Germaine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37299169: {
    id: "item_33308",
    "Last Name": "Chang",
    "First Name": "Yenchung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37299277: {
    id: "item_19333",
    "Last Name": "Wong",
    "First Name": "Simon K",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37299454: {
    id: "item_31658",
    "Last Name": "Woodley",
    "First Name": "Yoke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37299464: {
    id: "item_31657",
    "Last Name": "Jotikasthira",
    "First Name": "Thipchanok",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37299736: {
    id: "item_33305",
    "Last Name": "Matos",
    "First Name": "Rita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37299794: {
    id: "item_8199",
    "Last Name": "Ryan",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37299838: {
    id: "item_20988",
    "Last Name": "Knopp",
    "First Name": "Sibyl",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37299910: {
    id: "item_8200",
    "Last Name": "Edmondson",
    "First Name": "Schare",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37300139: {
    id: "item_8198",
    "Last Name": "Allen",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37300215: {
    id: "item_20984",
    "Last Name": "PHAM ANH",
    "First Name": "TOI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37300259: {
    id: "item_8196",
    "Last Name": "Lim",
    "First Name": "Khai Dee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37300379: {
    id: "item_20981",
    "Last Name": "Vanegas",
    "First Name": "Camila",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37300417: {
    id: "item_33301",
    "Last Name": "Lappan",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37300474: {
    id: "item_20979",
    "Last Name": "Fitzgerald",
    "First Name": "Amelia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37300762: {
    id: "item_8192",
    "Last Name": "Johansen",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37301120: {
    id: "item_33295",
    "Last Name": "Lindley",
    "First Name": "Jed",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37301141: {
    id: "item_32207",
    "Last Name": "Sitanggang",
    "First Name": "Nova Meylina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37301158: {
    id: "item_31647",
    "Last Name": "Thomas",
    "First Name": "Kaz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37301319: {
    id: "item_31646",
    "Last Name": "irawan",
    "First Name": "Willy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37301329: {
    id: "item_8191",
    "Last Name": "willebrands",
    "First Name": "cheyne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37301673: {
    id: "item_8189",
    "Last Name": "Son",
    "First Name": "Jeongseup",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37301761: {
    id: "item_20970",
    "Last Name": "Carlson",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37301767: {
    id: "item_19332",
    "Last Name": "Fairns",
    "First Name": "Brent",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37301806: {
    id: "item_20969",
    "Last Name": "Teter",
    "First Name": "Ramona",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302117: {
    id: "item_8183",
    "Last Name": "Kennedy",
    "First Name": "Calvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302182: {
    id: "item_8181",
    "Last Name": "Thatcher",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302187: {
    id: "item_8853",
    "Last Name": "Halim",
    "First Name": "Sylvia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302228: {
    id: "item_20965",
    "Last Name": "Li",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302274: {
    id: "item_20964",
    "Last Name": "Oh",
    "First Name": "Junsung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302383: {
    id: "item_33287",
    "Last Name": "Dekker-Price",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302453: {
    id: "item_8176",
    "Last Name": "Watson",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302481: {
    id: "item_8175",
    "Last Name": "Shea",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302536: {
    id: "item_20954",
    "Last Name": "Szuminska",
    "First Name": "Irena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302538: {
    id: "item_33916",
    "Last Name": "Teh",
    "First Name": "Mooi Choo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302545: {
    id: "item_20953",
    "Last Name": "Simjee",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302563: {
    id: "item_33284",
    "Last Name": "Gung",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302591: {
    id: "item_8173",
    "Last Name": "Colli",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302604: {
    id: "item_20952",
    "Last Name": "Chirnside",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302625: {
    id: "item_8171",
    "Last Name": "Butler",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302638: {
    id: "item_5804",
    "Last Name": "WIGGLESWORTH",
    "First Name": "Rod",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302643: {
    id: "item_6535",
    "Last Name": "Favaloro",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302758: {
    id: "item_31633",
    "Last Name": "Pratomo",
    "First Name": "Tommy Djoko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302768: {
    id: "item_31634",
    "Last Name": "Harrison",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302907: {
    id: "item_20948",
    "Last Name": "Weng",
    "First Name": "Yu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37302980: {
    id: "item_19331",
    "Last Name": "JING",
    "First Name": "BOJIE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303031: {
    id: "item_31632",
    "Last Name": "Dolling",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303118: {
    id: "item_8162",
    "Last Name": "Lovegrove",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303178: {
    id: "item_8161",
    "Last Name": "Cheras",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303210: {
    id: "item_33277",
    "Last Name": "Luong",
    "First Name": "Yen Anh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303245: {
    id: "item_5803",
    "Last Name": "Saito",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303258: {
    id: "item_31631",
    "Last Name": "Keats",
    "First Name": "Kirily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303297: {
    id: "item_8159",
    "Last Name": "Robertson",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303372: {
    id: "item_20942",
    "Last Name": "Scholar",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303472: {
    id: "item_31628",
    "Last Name": "De Canha",
    "First Name": "Daniella",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303486: {
    id: "item_20939",
    "Last Name": "Boyd",
    "First Name": "Malcolm",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303512: {
    id: "item_20938",
    "Last Name": "Crawford",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303610: {
    id: "item_31625",
    "Last Name": "Siu",
    "First Name": "Winnie Wing San",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303632: {
    id: "item_33271",
    "Last Name": "Brustmeyer-Brown",
    "First Name": "Kechia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303738: {
    id: "item_31623",
    "Last Name": "Pandya",
    "First Name": "Hiral",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303895: {
    id: "item_33867",
    "Last Name": "Rupf",
    "First Name": "Elena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37303948: {
    id: "item_33265",
    "Last Name": "Brotonel",
    "First Name": "Girlie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37304074: {
    id: "item_33263",
    "Last Name": "Limu",
    "First Name": "Ebit",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37304235: {
    id: "item_20936",
    "Last Name": "Bruce",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37304336: {
    id: "item_8147",
    "Last Name": "Salazar Rom‡n",
    "First Name": "Mar’a AngŽlica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37304408: {
    id: "item_31619",
    "Last Name": "Brine",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37304908: {
    id: "item_8145",
    "Last Name": "Folliard",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37305013: {
    id: "item_20933",
    "Last Name": "Kemp",
    "First Name": "Ash",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37305021: {
    id: "item_8144",
    "Last Name": "Myers",
    "First Name": "Zach",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37306604: {
    id: "item_31614",
    "Last Name": "Yip",
    "First Name": "Sau Lan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37306909: {
    id: "item_8816",
    "Last Name": "Stephan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37313149: {
    id: "item_31613",
    "Last Name": "Guerrero Castro",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37333287: {
    id: "item_20928",
    "Last Name": "Mok",
    "First Name": "Joey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37334622: {
    id: "item_33915",
    "Last Name": "Torregrossa",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37344554: {
    id: "item_20926",
    "Last Name": "Lim",
    "First Name": "Kah Keng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37344631: {
    id: "item_20924",
    "Last Name": "Goh",
    "First Name": "Teng Yin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37349316: {
    id: "item_8137",
    "Last Name": "Costa",
    "First Name": "Octavio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37365336: {
    id: "item_20918",
    "Last Name": "Laurendet",
    "First Name": "Johnno",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37365546: {
    id: "item_8133",
    "Last Name": "Westheimer",
    "First Name": "Danny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37365772: {
    id: "item_31605",
    "Last Name": "mitchell",
    "First Name": "Huyen Ngoc",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37365811: {
    id: "item_20915",
    "Last Name": "Friedman",
    "First Name": "Kaitlyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37365937: {
    id: "item_20914",
    "Last Name": "Chinas",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37366415: {
    id: "item_8815",
    "Last Name": "Tahanian",
    "First Name": "Armen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37366847: {
    id: "item_32206",
    "Last Name": "Rathi",
    "First Name": "Komal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37366851: {
    id: "item_21388",
    "Last Name": "Manuel",
    "First Name": "Carolyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37366964: {
    id: "item_20912",
    "Last Name": "RAMOS",
    "First Name": "ALFONSO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37367175: {
    id: "item_20909",
    "Last Name": "Dalmia",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37367266: {
    id: "item_20908",
    "Last Name": "Bartley",
    "First Name": "Annabel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37367814: {
    id: "item_20906",
    "Last Name": "Webb",
    "First Name": "Vivienne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37368210: {
    id: "item_8126",
    "Last Name": "Rubin",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37368261: {
    id: "item_20904",
    "Last Name": "Stevens",
    "First Name": "Jacquelyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37368270: {
    id: "item_20903",
    "Last Name": "Kumagai",
    "First Name": "Kazukiyo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37368814: {
    id: "item_32159",
    "Last Name": "Capers",
    "First Name": "Tremica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37368951: {
    id: "item_6534",
    "Last Name": "Nigro",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37369066: {
    id: "item_31591",
    "Last Name": "Tasker",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37369300: {
    id: "item_31588",
    "Last Name": "Dudek",
    "First Name": "Lakshmi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37369337: {
    id: "item_8120",
    "Last Name": "McKinley",
    "First Name": "Carla",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37369491: {
    id: "item_8119",
    "Last Name": "Homburg",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37369657: {
    id: "item_8117",
    "Last Name": "Wylie",
    "First Name": "Craig",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37369925: {
    id: "item_8116",
    "Last Name": "Panther",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37370323: {
    id: "item_8852",
    "Last Name": "Gomez",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37370610: {
    id: "item_20889",
    "Last Name": "Jonah",
    "First Name": "Syntyche",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37370751: {
    id: "item_33232",
    "Last Name": "Wijaya",
    "First Name": "Yuananto Tri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37371008: {
    id: "item_19218",
    "Last Name": "Bono",
    "First Name": "Daisy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37371915: {
    id: "item_8106",
    "Last Name": "Watson",
    "First Name": "Emmeline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37371920: {
    id: "item_8105",
    "Last Name": "KURAI",
    "First Name": "SHOTA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37371997: {
    id: "item_8104",
    "Last Name": "Wash",
    "First Name": "Zak",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37372080: {
    id: "item_33228",
    "Last Name": "Gievers Davies",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37372150: {
    id: "item_20881",
    "Last Name": "Delaney",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37372186: {
    id: "item_20880",
    "Last Name": "Holmes",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37372266: {
    id: "item_20879",
    "Last Name": "Yu",
    "First Name": "Tianjiao",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37372282: {
    id: "item_31581",
    "Last Name": "Brown",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37372922: {
    id: "item_20876",
    "Last Name": "FIL",
    "First Name": "EUGENE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37373217: {
    id: "item_20875",
    "Last Name": "Hill",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37373568: {
    id: "item_20873",
    "Last Name": "Reidy",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37373594: {
    id: "item_20872",
    "Last Name": "Dobroskok",
    "First Name": "Vladyslav",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37373648: {
    id: "item_32205",
    "Last Name": "Farrell",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37373709: {
    id: "item_31572",
    "Last Name": "Fu",
    "First Name": "Limin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37374006: {
    id: "item_31570",
    "Last Name": "wherry",
    "First Name": "melina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37374426: {
    id: "item_32204",
    "Last Name": "Septian",
    "First Name": "Angga",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37374450: {
    id: "item_20869",
    "Last Name": "Barns",
    "First Name": "Jacquie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37374772: {
    id: "item_8097",
    "Last Name": "Lansel",
    "First Name": "Miranda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37374779: {
    id: "item_20867",
    "Last Name": "Bassa",
    "First Name": "Husain",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37374928: {
    id: "item_33215",
    "Last Name": "Kim",
    "First Name": "Suryeon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37374984: {
    id: "item_33213",
    "Last Name": "Victor",
    "First Name": "Victor",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375126: {
    id: "item_8092",
    "Last Name": "Delahunty",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375155: {
    id: "item_20865",
    "Last Name": "Baker",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375270: {
    id: "item_31566",
    "Last Name": "Escribano",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375329: {
    id: "item_20864",
    "Last Name": "OÕDonohue",
    "First Name": "Ieuan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375342: {
    id: "item_8090",
    "Last Name": "Chisholm",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375373: {
    id: "item_33210",
    "Last Name": "Hsu",
    "First Name": "Marlene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375531: {
    id: "item_8089",
    "Last Name": "Ruckriegel",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375559: {
    id: "item_33208",
    "Last Name": "Mah",
    "First Name": "Suh Wei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375693: {
    id: "item_5794",
    "Last Name": "Sutanto",
    "First Name": "Edo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375728: {
    id: "item_31561",
    "Last Name": "FOLEY",
    "First Name": "PAMELA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375735: {
    id: "item_31562",
    "Last Name": "Lee",
    "First Name": "Narelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375887: {
    id: "item_5793",
    "Last Name": "Yip",
    "First Name": "Hiu Tung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375900: {
    id: "item_31556",
    "Last Name": "Cowan",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37375911: {
    id: "item_20859",
    "Last Name": "Hewitt",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376154: {
    id: "item_20858",
    "Last Name": "Martin",
    "First Name": "Jade",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376249: {
    id: "item_8081",
    "Last Name": "Alai",
    "First Name": "Reza",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376389: {
    id: "item_8077",
    "Last Name": "Yanzon",
    "First Name": "Arnel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376416: {
    id: "item_20857",
    "Last Name": "Mulhearn",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376446: {
    id: "item_20856",
    "Last Name": "Jansen",
    "First Name": "Kym",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376569: {
    id: "item_20855",
    "Last Name": "Bone",
    "First Name": "Shaan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376705: {
    id: "item_20851",
    "Last Name": "Ahmad Safaruddin",
    "First Name": "Ahmad Dzulhilmi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376707: {
    id: "item_8074",
    "Last Name": "Prideaux",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376865: {
    id: "item_33197",
    "Last Name": "Yoo",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376882: {
    id: "item_8073",
    "Last Name": "Homan",
    "First Name": "Damien",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37376920: {
    id: "item_8072",
    "Last Name": "Lane",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37377062: {
    id: "item_20849",
    "Last Name": "Narasimhan",
    "First Name": "Toni",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37377139: {
    id: "item_8068",
    "Last Name": "Li",
    "First Name": "Mingshun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37377176: {
    id: "item_31552",
    "Last Name": "Macaskill",
    "First Name": "Megs",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37377425: {
    id: "item_31550",
    "Last Name": "Carr",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37377663: {
    id: "item_8067",
    "Last Name": "Latorre",
    "First Name": "Rocco",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37377915: {
    id: "item_31549",
    "Last Name": "Hackett",
    "First Name": "Yvonne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37377958: {
    id: "item_33191",
    "Last Name": "Sitompul",
    "First Name": "Christsania",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37377985: {
    id: "item_31548",
    "Last Name": "Schwenck",
    "First Name": "Daryl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37378579: {
    id: "item_31545",
    "Last Name": "Macconnell",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37378622: {
    id: "item_31543",
    "Last Name": "Dudek",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37378740: {
    id: "item_20843",
    "Last Name": "PLANA NADAL",
    "First Name": "JOAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37378746: {
    id: "item_33189",
    "Last Name": "ROSADI",
    "First Name": "HASAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37379131: {
    id: "item_31542",
    "Last Name": "Rizkianto",
    "First Name": "Rahmat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37379702: {
    id: "item_33186",
    "Last Name": "Chen",
    "First Name": "Shi Ya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37379830: {
    id: "item_20839",
    "Last Name": "Wybranczyk",
    "First Name": "Katarzyna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37383983: {
    id: "item_20837",
    "Last Name": "Goodman",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37384404: {
    id: "item_33181",
    "Last Name": "Liddell",
    "First Name": "Naomi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37384653: {
    id: "item_8057",
    "Last Name": "Geor-Lai",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37384690: {
    id: "item_33914",
    "Last Name": "CHEN",
    "First Name": "YAO SEN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37385447: {
    id: "item_20836",
    "Last Name": "Khoo",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37385450: {
    id: "item_31540",
    "Last Name": "Goings",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37385512: {
    id: "item_20835",
    "Last Name": "Hall",
    "First Name": "johanna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37385585: {
    id: "item_8055",
    "Last Name": "Ojea R Campos",
    "First Name": "Thiago",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37385785: {
    id: "item_8053",
    "Last Name": "Jopillo",
    "First Name": "Angelo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37385808: {
    id: "item_5791",
    "Last Name": "Staniforth",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37386344: {
    id: "item_31537",
    "Last Name": "Brooks",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37386355: {
    id: "item_33178",
    "Last Name": "Vine",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37386598: {
    id: "item_20826",
    "Last Name": "FERDOUS",
    "First Name": "FARDIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37386674: {
    id: "item_20825",
    "Last Name": "YANG",
    "First Name": "JAEGY",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37386916: {
    id: "item_31535",
    "Last Name": "Pitt",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37387061: {
    id: "item_33913",
    "Last Name": "Traynor",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37387157: {
    id: "item_31533",
    "Last Name": "Lkhagvajargal",
    "First Name": "Tsetsen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37387306: {
    id: "item_8045",
    "Last Name": "Mayr",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37387369: {
    id: "item_33175",
    "Last Name": "Valerio",
    "First Name": "Iris",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37387965: {
    id: "item_33174",
    "Last Name": "Wang",
    "First Name": "Yichin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37388206: {
    id: "item_19330",
    "Last Name": "Viviani",
    "First Name": "Priscila",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37388384: {
    id: "item_8041",
    "Last Name": "Hayes",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37388507: {
    id: "item_20817",
    "Last Name": "Elliott",
    "First Name": "Ashlee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37388618: {
    id: "item_20816",
    "Last Name": "Boock",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37388645: {
    id: "item_31529",
    "Last Name": "Abuzaher",
    "First Name": "Omar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37388859: {
    id: "item_20814",
    "Last Name": "Tensuan",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37388893: {
    id: "item_20813",
    "Last Name": "KIM",
    "First Name": "SUNGDONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37389202: {
    id: "item_20808",
    "Last Name": "Vallely",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37389377: {
    id: "item_31527",
    "Last Name": "Tonnet",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37389654: {
    id: "item_31525",
    "Last Name": "Peltier",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37390237: {
    id: "item_33165",
    "Last Name": "Kumar",
    "First Name": "Asha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37390505: {
    id: "item_33164",
    "Last Name": "Sakashita",
    "First Name": "Tsukasa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37390752: {
    id: "item_33161",
    "Last Name": "Ismael",
    "First Name": "Albert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37390843: {
    id: "item_20804",
    "Last Name": "Zeng",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37391089: {
    id: "item_20802",
    "Last Name": "CHEN",
    "First Name": "DONGMEI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37391103: {
    id: "item_33912",
    "Last Name": "CHEN",
    "First Name": "CHIHCHING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37391763: {
    id: "item_31518",
    "Last Name": "Istadi",
    "First Name": "Bambang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37391829: {
    id: "item_8030",
    "Last Name": "Juers",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37392280: {
    id: "item_31517",
    "Last Name": "Darby",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37392469: {
    id: "item_31516",
    "Last Name": "Villanueva",
    "First Name": "Annie Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37392682: {
    id: "item_20751",
    "Last Name": "McKinnon",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37392704: {
    id: "item_20792",
    "Last Name": "Cho",
    "First Name": "Hyunryung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37392719: {
    id: "item_19329",
    "Last Name": "Tan",
    "First Name": "Yi Ping",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37392795: {
    id: "item_6480",
    "Last Name": "Podszun",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37392847: {
    id: "item_33155",
    "Last Name": "Rosich",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37392923: {
    id: "item_31513",
    "Last Name": "Sapkota",
    "First Name": "Bhim N (Sagar)",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37392945: {
    id: "item_8028",
    "Last Name": "Jimenez Fernandez",
    "First Name": "Jose Carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393175: {
    id: "item_20788",
    "Last Name": "Bui",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393200: {
    id: "item_31509",
    "Last Name": "Thawilwang",
    "First Name": "Sukanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393413: {
    id: "item_32203",
    "Last Name": "Perez",
    "First Name": "Satrina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393622: {
    id: "item_20783",
    "Last Name": "Colligan",
    "First Name": "Bob",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393675: {
    id: "item_20782",
    "Last Name": "Kerslake",
    "First Name": "Nerilee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393691: {
    id: "item_33150",
    "Last Name": "Chen",
    "First Name": "Zoey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393751: {
    id: "item_33149",
    "Last Name": "Lehrbaum",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393868: {
    id: "item_8022",
    "Last Name": "Gillingham",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393906: {
    id: "item_31502",
    "Last Name": "McKenzie",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37393994: {
    id: "item_20778",
    "Last Name": "Perry",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37394001: {
    id: "item_31500",
    "Last Name": "Boswell",
    "First Name": "Clarke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37394097: {
    id: "item_20776",
    "Last Name": "Brown",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37394101: {
    id: "item_33147",
    "Last Name": "Downing",
    "First Name": "Kay",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37394446: {
    id: "item_20774",
    "Last Name": "McLeod",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37394457: {
    id: "item_20773",
    "Last Name": "Magalska",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37394471: {
    id: "item_8013",
    "Last Name": "Magalski",
    "First Name": "Danel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37394596: {
    id: "item_6479",
    "Last Name": "Yeo",
    "First Name": "Colin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37394907: {
    id: "item_33142",
    "Last Name": "Payne",
    "First Name": "Ashleigh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37395023: {
    id: "item_31493",
    "Last Name": "Piao",
    "First Name": "Yushi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37395091: {
    id: "item_8006",
    "Last Name": "Hobbs",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37395242: {
    id: "item_31491",
    "Last Name": "Elisawati",
    "First Name": "Maulina Ruth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37395634: {
    id: "item_6533",
    "Last Name": "Yu",
    "First Name": "Songtao",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37395687: {
    id: "item_33866",
    "Last Name": "Lin",
    "First Name": "Shuhuan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37396105: {
    id: "item_20768",
    "Last Name": "Law",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37396272: {
    id: "item_19328",
    "Last Name": "Brechner",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37396465: {
    id: "item_20766",
    "Last Name": "Jacques",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37396542: {
    id: "item_33137",
    "Last Name": "Chen",
    "First Name": "Matthew Haaw Minn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37396687: {
    id: "item_20765",
    "Last Name": "Frenken",
    "First Name": "Joost",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37396768: {
    id: "item_20764",
    "Last Name": "cao",
    "First Name": "zheng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37396941: {
    id: "item_8002",
    "Last Name": "Good",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37397102: {
    id: "item_33911",
    "Last Name": "Ng Tiong Hong",
    "First Name": "Leonard",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37397119: {
    id: "item_20763",
    "Last Name": "Ward",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37397204: {
    id: "item_33136",
    "Last Name": "Phanjan",
    "First Name": "Wannarat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37397642: {
    id: "item_8851",
    "Last Name": "Tang",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37397854: {
    id: "item_19327",
    "Last Name": "Rainboth",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37399129: {
    id: "item_33131",
    "Last Name": "Thomson",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37400511: {
    id: "item_7997",
    "Last Name": "LIOU",
    "First Name": "CHYUAN JANG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37400870: {
    id: "item_7996",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37401386: {
    id: "item_7995",
    "Last Name": "Bohrer",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37402333: {
    id: "item_7994",
    "Last Name": "Najera",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37402393: {
    id: "item_7992",
    "Last Name": "DelPozo",
    "First Name": "Maricruz",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37404296: {
    id: "item_33122",
    "Last Name": "Martinez",
    "First Name": "Mica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37404311: {
    id: "item_7988",
    "Last Name": "Ellingsen",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37404478: {
    id: "item_20752",
    "Last Name": "Hall",
    "First Name": "Zane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37404758: {
    id: "item_8718",
    "Last Name": "Ivanova",
    "First Name": "Valentina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37404985: {
    id: "item_18884",
    "Last Name": "Campbell",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405007: {
    id: "item_18883",
    "Last Name": "Cefalu",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405051: {
    id: "item_33751",
    "Last Name": "Huang",
    "First Name": "Chenyuan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405089: {
    id: "item_18880",
    "Last Name": "Mcgurn",
    "First Name": "Niall",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405119: {
    id: "item_6261",
    "Last Name": "Holloway",
    "First Name": "Erin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405235: {
    id: "item_18878",
    "Last Name": "Alexander",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405254: {
    id: "item_33750",
    "Last Name": "Fernandez",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405261: {
    id: "item_18876",
    "Last Name": "Browne",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405316: {
    id: "item_32100",
    "Last Name": "Bird",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405362: {
    id: "item_18875",
    "Last Name": "Kimpton",
    "First Name": "Callum",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405387: {
    id: "item_18873",
    "Last Name": "Puig La Calle",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405441: {
    id: "item_32099",
    "Last Name": "morgan",
    "First Name": "natalie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405455: {
    id: "item_33749",
    "Last Name": "Sarong",
    "First Name": "Kiwi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405487: {
    id: "item_6256",
    "Last Name": "Ronald",
    "First Name": "Sheldon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405553: {
    id: "item_8717",
    "Last Name": "meza",
    "First Name": "julieth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405572: {
    id: "item_33747",
    "Last Name": "Dalmolin",
    "First Name": "Joe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405680: {
    id: "item_33746",
    "Last Name": "Furry",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405691: {
    id: "item_21319",
    "Last Name": "MacDonald",
    "First Name": "Lesley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405698: {
    id: "item_8716",
    "Last Name": "Montford",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405752: {
    id: "item_18866",
    "Last Name": "Williams",
    "First Name": "Liz",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405754: {
    id: "item_18864",
    "Last Name": "Bishop",
    "First Name": "Conrad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37405994: {
    id: "item_21317",
    "Last Name": "Wray",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406212: {
    id: "item_18855",
    "Last Name": "Thorley",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406282: {
    id: "item_33745",
    "Last Name": "Eastough",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406289: {
    id: "item_18857",
    "Last Name": "Nicholls",
    "First Name": "Helaena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406379: {
    id: "item_6249",
    "Last Name": "Lefebvre",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406404: {
    id: "item_18854",
    "Last Name": "Gafen",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406409: {
    id: "item_18851",
    "Last Name": "Sacre",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406513: {
    id: "item_33743",
    "Last Name": "Le Mond",
    "First Name": "Wynona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406532: {
    id: "item_8713",
    "Last Name": "Smitheram",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406883: {
    id: "item_6245",
    "Last Name": "Gruslin",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37406893: {
    id: "item_32202",
    "Last Name": "Boake",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37407309: {
    id: "item_6242",
    "Last Name": "Allocca",
    "First Name": "Sebastiano",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37407488: {
    id: "item_18844",
    "Last Name": "Lee",
    "First Name": "Warren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37407591: {
    id: "item_6241",
    "Last Name": "KIM",
    "First Name": "YOUNGA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37407613: {
    id: "item_33739",
    "Last Name": "Kuan",
    "First Name": "Hung-Jen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37407756: {
    id: "item_6240",
    "Last Name": "Lee",
    "First Name": "Myungsoo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408063: {
    id: "item_33738",
    "Last Name": "Nortje",
    "First Name": "Jaco",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408131: {
    id: "item_6235",
    "Last Name": "Cooke",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408338: {
    id: "item_32096",
    "Last Name": "Gopalakrishnan",
    "First Name": "Chandravadhana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408379: {
    id: "item_18838",
    "Last Name": "Tindill",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408401: {
    id: "item_21312",
    "Last Name": "Hetherton",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408405: {
    id: "item_18837",
    "Last Name": "Cankorel",
    "First Name": "Irfan Turgut",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408543: {
    id: "item_6232",
    "Last Name": "Audley",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408556: {
    id: "item_32201",
    "Last Name": "Cheung",
    "First Name": "Sau Yi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408590: {
    id: "item_18835",
    "Last Name": "Carstens",
    "First Name": "Dion",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408602: {
    id: "item_8707",
    "Last Name": "Blucher",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408651: {
    id: "item_33734",
    "Last Name": "Webb",
    "First Name": "Paige",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408843: {
    id: "item_6532",
    "Last Name": "Tobin",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37408899: {
    id: "item_6230",
    "Last Name": "So",
    "First Name": "Edwina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37409224: {
    id: "item_6478",
    "Last Name": "McLaughlin",
    "First Name": "Jade",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37409269: {
    id: "item_33733",
    "Last Name": "Wong",
    "First Name": "Yuen Hing",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37409295: {
    id: "item_32200",
    "Last Name": "Sun",
    "First Name": "Yu-ju",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37409387: {
    id: "item_32094",
    "Last Name": "Hui",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410110: {
    id: "item_18826",
    "Last Name": "Luu",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410235: {
    id: "item_32091",
    "Last Name": "Akbari",
    "First Name": "Amadea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410246: {
    id: "item_8703",
    "Last Name": "Wolfe",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410276: {
    id: "item_33732",
    "Last Name": "Szabo",
    "First Name": "Jenna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410421: {
    id: "item_32090",
    "Last Name": "Whackett",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410482: {
    id: "item_18823",
    "Last Name": "Lapina",
    "First Name": "Geovani 2",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410492: {
    id: "item_18822",
    "Last Name": "li",
    "First Name": "zhiyuan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410534: {
    id: "item_6225",
    "Last Name": "Ilott",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410687: {
    id: "item_18820",
    "Last Name": "bendickson",
    "First Name": "heather",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410690: {
    id: "item_6224",
    "Last Name": "Paez",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410846: {
    id: "item_21309",
    "Last Name": "Michelsen",
    "First Name": "Gabrielle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37410962: {
    id: "item_21308",
    "Last Name": "Watkins",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37411207: {
    id: "item_21307",
    "Last Name": "Pfanstiel",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37411551: {
    id: "item_32088",
    "Last Name": "Ho",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37411611: {
    id: "item_32087",
    "Last Name": "Bishop",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37411917: {
    id: "item_8698",
    "Last Name": "Singer",
    "First Name": "Pia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37411941: {
    id: "item_32086",
    "Last Name": "YI",
    "First Name": "MEIXIA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37412622: {
    id: "item_8697",
    "Last Name": "Cai",
    "First Name": "Yunxia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37412762: {
    id: "item_18815",
    "Last Name": "Petersen",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37413952: {
    id: "item_18812",
    "Last Name": "Russell",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37414020: {
    id: "item_6215",
    "Last Name": "Kriedemann",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37414266: {
    id: "item_33730",
    "Last Name": "Kriedemann",
    "First Name": "Lynn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37414543: {
    id: "item_18803",
    "Last Name": "Hill",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37414623: {
    id: "item_8691",
    "Last Name": "Chen",
    "First Name": "Clarke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37414741: {
    id: "item_6210",
    "Last Name": "Smith",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37414934: {
    id: "item_18801",
    "Last Name": "Tiller",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37414990: {
    id: "item_32082",
    "Last Name": "TAYLOR",
    "First Name": "justin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415017: {
    id: "item_18800",
    "Last Name": "Thorpe",
    "First Name": "Kaitlin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415216: {
    id: "item_32081",
    "Last Name": "Chunchuwar",
    "First Name": "Siddhika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415327: {
    id: "item_18797",
    "Last Name": "Luo",
    "First Name": "YI RU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415345: {
    id: "item_18795",
    "Last Name": "Ariza Vega",
    "First Name": "Carlos Arturo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415563: {
    id: "item_8687",
    "Last Name": "Lawson",
    "First Name": "Janna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415707: {
    id: "item_32079",
    "Last Name": "Cabrera",
    "First Name": "Jessa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415759: {
    id: "item_32199",
    "Last Name": "Tin",
    "First Name": "chee Sin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415861: {
    id: "item_6202",
    "Last Name": "Arndt",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415939: {
    id: "item_18788",
    "Last Name": "Ramadhan",
    "First Name": "Archam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37415956: {
    id: "item_21301",
    "Last Name": "Ch'ng",
    "First Name": "Renee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416068: {
    id: "item_32076",
    "Last Name": "Kamil",
    "First Name": "Ernald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416168: {
    id: "item_18786",
    "Last Name": "McConnell",
    "First Name": "Bryony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416184: {
    id: "item_18783",
    "Last Name": "Xu",
    "First Name": "Yingchao",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416362: {
    id: "item_18781",
    "Last Name": "Wongkar",
    "First Name": "Ricky",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416382: {
    id: "item_6197",
    "Last Name": "Westcott",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416414: {
    id: "item_6196",
    "Last Name": "Schwerbrock",
    "First Name": "Emilia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416503: {
    id: "item_18778",
    "Last Name": "Wilson",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416675: {
    id: "item_6194",
    "Last Name": "Atkinson",
    "First Name": "Geoff",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416694: {
    id: "item_6193",
    "Last Name": "Higa",
    "First Name": "Ritsuko",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416701: {
    id: "item_21296",
    "Last Name": "Hodgekiss",
    "First Name": "Bec",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416712: {
    id: "item_21295",
    "Last Name": "Vidovich",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416782: {
    id: "item_21294",
    "Last Name": "Morris",
    "First Name": "Mick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416881: {
    id: "item_33722",
    "Last Name": "Schwarzenbach",
    "First Name": "Claire",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416888: {
    id: "item_33721",
    "Last Name": "Graham",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416914: {
    id: "item_32072",
    "Last Name": "Sposato",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416920: {
    id: "item_6189",
    "Last Name": "OÕKane",
    "First Name": "Colm",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416956: {
    id: "item_6188",
    "Last Name": "Lindsay",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416966: {
    id: "item_6187",
    "Last Name": "Romero",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416984: {
    id: "item_18771",
    "Last Name": "McCarthy",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37416993: {
    id: "item_18770",
    "Last Name": "Ball",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417003: {
    id: "item_6184",
    "Last Name": "Pascoe",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417019: {
    id: "item_33720",
    "Last Name": "Kelly",
    "First Name": "Debra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417056: {
    id: "item_32071",
    "Last Name": "Spowart",
    "First Name": "Yvonne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417075: {
    id: "item_18768",
    "Last Name": "Yang",
    "First Name": "Chinan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417077: {
    id: "item_6182",
    "Last Name": "Kaukenova",
    "First Name": "Botakoz",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417113: {
    id: "item_18767",
    "Last Name": "Witcombe",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417182: {
    id: "item_6531",
    "Last Name": "ZHAKANOV",
    "First Name": "TALGAT",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417202: {
    id: "item_21293",
    "Last Name": "Williams",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417234: {
    id: "item_33717",
    "Last Name": "Storey",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417274: {
    id: "item_18763",
    "Last Name": "Chanthadavong",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417292: {
    id: "item_6179",
    "Last Name": "Gatt",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417373: {
    id: "item_18760",
    "Last Name": "Schyman",
    "First Name": "Claire",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417460: {
    id: "item_8677",
    "Last Name": "Meller",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417477: {
    id: "item_18758",
    "Last Name": "Carey",
    "First Name": "Blair",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417546: {
    id: "item_18755",
    "Last Name": "Rudge",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417626: {
    id: "item_32070",
    "Last Name": "Pramana",
    "First Name": "Irene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417675: {
    id: "item_8674",
    "Last Name": "Yun",
    "First Name": "Seongbaek",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417706: {
    id: "item_18752",
    "Last Name": "Jones",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417775: {
    id: "item_33712",
    "Last Name": "FUNG",
    "First Name": "OI HA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417781: {
    id: "item_18751",
    "Last Name": "Coombs",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417805: {
    id: "item_6171",
    "Last Name": "Jones",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417848: {
    id: "item_33910",
    "Last Name": "Eather",
    "First Name": "Bernadette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417906: {
    id: "item_18749",
    "Last Name": "Jacob",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417964: {
    id: "item_18748",
    "Last Name": "Collins",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417986: {
    id: "item_18745",
    "Last Name": "Fasana",
    "First Name": "Stefano",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37417998: {
    id: "item_6530",
    "Last Name": "Tang",
    "First Name": "Tian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37418000: {
    id: "item_18747",
    "Last Name": "Wang",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37418005: {
    id: "item_6169",
    "Last Name": "Daley",
    "First Name": "Corey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37418012: {
    id: "item_18746",
    "Last Name": "Kendall",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37418053: {
    id: "item_18744",
    "Last Name": "Derrig",
    "First Name": "Charli",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37418107: {
    id: "item_18739",
    "Last Name": "Kang",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37418454: {
    id: "item_6166",
    "Last Name": "Reynish",
    "First Name": "Stafford",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37418547: {
    id: "item_6165",
    "Last Name": "Donaire",
    "First Name": "Nick Jed",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37418582: {
    id: "item_33709",
    "Last Name": "Gold",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37418745: {
    id: "item_8850",
    "Last Name": "Wesnofske",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37419150: {
    id: "item_21289",
    "Last Name": "Naylor",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37419223: {
    id: "item_18733",
    "Last Name": "Nelis",
    "First Name": "Jacques",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37419415: {
    id: "item_18732",
    "Last Name": "Elengoe",
    "First Name": "Tevanraj",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37419584: {
    id: "item_18730",
    "Last Name": "CHU",
    "First Name": "Yiyi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37426525: {
    id: "item_18728",
    "Last Name": "Poon",
    "First Name": "Wing Hang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37435061: {
    id: "item_18726",
    "Last Name": "Shaffrey",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37435182: {
    id: "item_18725",
    "Last Name": "Pugh",
    "First Name": "January",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37440247: {
    id: "item_6159",
    "Last Name": "Bowen",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37444262: {
    id: "item_33706",
    "Last Name": "McDonald",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37457376: {
    id: "item_19326",
    "Last Name": "Bowker",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37463730: {
    id: "item_19325",
    "Last Name": "Cunningham",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37470287: {
    id: "item_6156",
    "Last Name": "GUARDIA",
    "First Name": "POL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37470323: {
    id: "item_6155",
    "Last Name": "Francis",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37472294: {
    id: "item_21369",
    "Last Name": "Waldron",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37478269: {
    id: "item_8667",
    "Last Name": "Dyer",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37479821: {
    id: "item_32059",
    "Last Name": "Koroye",
    "First Name": "Lara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37480436: {
    id: "item_18717",
    "Last Name": "Mckensey",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37480601: {
    id: "item_6150",
    "Last Name": "Andersen",
    "First Name": "Kira",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37481029: {
    id: "item_33909",
    "Last Name": "Bexultan",
    "First Name": "Malika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37481060: {
    id: "item_6147",
    "Last Name": "Nguyen",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37481322: {
    id: "item_18713",
    "Last Name": "Horsfield",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37481406: {
    id: "item_6144",
    "Last Name": "Patel",
    "First Name": "Om",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37481459: {
    id: "item_21287",
    "Last Name": "Dupuis",
    "First Name": "Elise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37481729: {
    id: "item_6142",
    "Last Name": "Gilberton",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37482342: {
    id: "item_21283",
    "Last Name": "Belyavskiy",
    "First Name": "Maxim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37482580: {
    id: "item_33703",
    "Last Name": "Jain",
    "First Name": "Priya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37482706: {
    id: "item_21282",
    "Last Name": "JUNGJOO",
    "First Name": "LEE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37482756: {
    id: "item_19324",
    "Last Name": "Farquhar",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37482794: {
    id: "item_6477",
    "Last Name": "Qiu",
    "First Name": "Annie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37482878: {
    id: "item_21281",
    "Last Name": "Agostini",
    "First Name": "Alberto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37483033: {
    id: "item_6133",
    "Last Name": "Ma",
    "First Name": "King Chin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37483115: {
    id: "item_8665",
    "Last Name": "Smeeckaert",
    "First Name": "Aline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37483611: {
    id: "item_6131",
    "Last Name": "Miskiewicz",
    "First Name": "Josiah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37483696: {
    id: "item_32055",
    "Last Name": "Brandon",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37483738: {
    id: "item_18703",
    "Last Name": "Tureaud",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37483793: {
    id: "item_18704",
    "Last Name": "Hogg",
    "First Name": "Megan Elinor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37483820: {
    id: "item_6130",
    "Last Name": "Joel",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37483853: {
    id: "item_18700",
    "Last Name": "Mena Garzon",
    "First Name": "Montserrat",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37483916: {
    id: "item_18698",
    "Last Name": "Jackson",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37484117: {
    id: "item_18695",
    "Last Name": "Crawford",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37485069: {
    id: "item_8663",
    "Last Name": "Rossignol",
    "First Name": "Aodren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37485213: {
    id: "item_18689",
    "Last Name": "Stewart",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37485323: {
    id: "item_8662",
    "Last Name": "Broderick",
    "First Name": "Christina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37485378: {
    id: "item_33695",
    "Last Name": "IWATA",
    "First Name": "YUTAKA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486057: {
    id: "item_18685",
    "Last Name": "Claparols",
    "First Name": "Jose Jaime",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486207: {
    id: "item_18684",
    "Last Name": "Martin-Hughes",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486309: {
    id: "item_8659",
    "Last Name": "kim",
    "First Name": "dahmyoung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486369: {
    id: "item_6119",
    "Last Name": "Marks",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486511: {
    id: "item_6529",
    "Last Name": "Lam",
    "First Name": "Chewey BK",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486601: {
    id: "item_33693",
    "Last Name": "chantativakorn",
    "First Name": "patcharapong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486682: {
    id: "item_6115",
    "Last Name": "Ben",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486779: {
    id: "item_8658",
    "Last Name": "HEUNG SEOP",
    "First Name": "KIM",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486820: {
    id: "item_18681",
    "Last Name": "Burke",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486856: {
    id: "item_21277",
    "Last Name": "Wilson",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486885: {
    id: "item_19323",
    "Last Name": "YU",
    "First Name": "HYEONI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486935: {
    id: "item_18677",
    "Last Name": "Wiltshire",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37486940: {
    id: "item_32046",
    "Last Name": "McGowan",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487125: {
    id: "item_18676",
    "Last Name": "Thanombooncharoen",
    "First Name": "Disorn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487131: {
    id: "item_33691",
    "Last Name": "Cochrane",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487186: {
    id: "item_18675",
    "Last Name": "Jones",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487372: {
    id: "item_18674",
    "Last Name": "Panget",
    "First Name": "Jovian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487403: {
    id: "item_32198",
    "Last Name": "Ferencek",
    "First Name": "Radmila",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487520: {
    id: "item_19322",
    "Last Name": "Bow",
    "First Name": "Kimberlee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487687: {
    id: "item_32043",
    "Last Name": "Sanchez",
    "First Name": "Alma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487706: {
    id: "item_6109",
    "Last Name": "Smith",
    "First Name": "Russell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487788: {
    id: "item_18670",
    "Last Name": "ZHANG",
    "First Name": "HaiBin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487817: {
    id: "item_33908",
    "Last Name": "ANG",
    "First Name": "ROSALIND",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487838: {
    id: "item_6108",
    "Last Name": "French",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487968: {
    id: "item_32042",
    "Last Name": "Huang",
    "First Name": "Hsien-Li",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37487988: {
    id: "item_8655",
    "Last Name": "Morice",
    "First Name": "Maxime",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37488280: {
    id: "item_18669",
    "Last Name": "Robertson",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37488316: {
    id: "item_6105",
    "Last Name": "Ho",
    "First Name": "Johnathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37488442: {
    id: "item_18667",
    "Last Name": "Normington-dickens",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37488676: {
    id: "item_18664",
    "Last Name": "Castro",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37488868: {
    id: "item_6101",
    "Last Name": "Hanlon",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489088: {
    id: "item_6100",
    "Last Name": "Trottman",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489132: {
    id: "item_8654",
    "Last Name": "Yeon",
    "First Name": "Lynn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489144: {
    id: "item_6098",
    "Last Name": "VAN HERREWEGHE",
    "First Name": "STEVEN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489184: {
    id: "item_6097",
    "Last Name": "Wood",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489376: {
    id: "item_21273",
    "Last Name": "Swansen",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489558: {
    id: "item_18660",
    "Last Name": "Ruellan",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489619: {
    id: "item_18658",
    "Last Name": "Soleimani",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489639: {
    id: "item_18657",
    "Last Name": "Anjani",
    "First Name": "Abelia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489770: {
    id: "item_18656",
    "Last Name": "Brocal",
    "First Name": "Willem",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489800: {
    id: "item_6528",
    "Last Name": "Gilo",
    "First Name": "Yu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489806: {
    id: "item_19321",
    "Last Name": "McLeod",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489817: {
    id: "item_18655",
    "Last Name": "Duggan",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489875: {
    id: "item_32036",
    "Last Name": "Ward",
    "First Name": "Deb",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37489915: {
    id: "item_6094",
    "Last Name": "Di Salvo",
    "First Name": "Alice",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490030: {
    id: "item_18651",
    "Last Name": "Smith",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490047: {
    id: "item_6092",
    "Last Name": "Donnellan",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490068: {
    id: "item_6091",
    "Last Name": "AGUILASOCHO GONZçLEZ",
    "First Name": "JONATHAN RIKIEL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490146: {
    id: "item_19320",
    "Last Name": "Webb",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490184: {
    id: "item_18647",
    "Last Name": "Yan",
    "First Name": "Sun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490221: {
    id: "item_21272",
    "Last Name": "Retherford",
    "First Name": "Marah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490286: {
    id: "item_33685",
    "Last Name": "Go",
    "First Name": "Aldric Mathew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490398: {
    id: "item_21271",
    "Last Name": "Zhou",
    "First Name": "Harry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490417: {
    id: "item_6089",
    "Last Name": "Hatherley",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490425: {
    id: "item_8645",
    "Last Name": "Ayuya",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490550: {
    id: "item_32034",
    "Last Name": "Roongrut",
    "First Name": "Satit",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490675: {
    id: "item_8643",
    "Last Name": "Li",
    "First Name": "Huafu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490682: {
    id: "item_21269",
    "Last Name": "Riordan",
    "First Name": "Jenni",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490770: {
    id: "item_8642",
    "Last Name": "O'Shaughnessy",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490825: {
    id: "item_8641",
    "Last Name": "KIM",
    "First Name": "MINJUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490908: {
    id: "item_18642",
    "Last Name": "De Bono",
    "First Name": "Eden",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490949: {
    id: "item_18640",
    "Last Name": "Allen",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490953: {
    id: "item_6082",
    "Last Name": "Nieradk",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37490985: {
    id: "item_6081",
    "Last Name": "Hoban",
    "First Name": "Darragh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491031: {
    id: "item_21268",
    "Last Name": "Peil",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491032: {
    id: "item_18637",
    "Last Name": "Serbo",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491088: {
    id: "item_18635",
    "Last Name": "Alexander",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491095: {
    id: "item_32030",
    "Last Name": "zhang",
    "First Name": "Tao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491110: {
    id: "item_33681",
    "Last Name": "Wilton",
    "First Name": "Linda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491148: {
    id: "item_8639",
    "Last Name": "Richards",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491169: {
    id: "item_18630",
    "Last Name": "Heinz",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491398: {
    id: "item_6075",
    "Last Name": "Ouarda",
    "First Name": "Dalal",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491437: {
    id: "item_18625",
    "Last Name": "TO",
    "First Name": "RAY",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491465: {
    id: "item_18624",
    "Last Name": "Cox",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491516: {
    id: "item_18621",
    "Last Name": "ACU„A",
    "First Name": "FABIOLA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491562: {
    id: "item_18618",
    "Last Name": "Lundy",
    "First Name": "Francis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491572: {
    id: "item_19217",
    "Last Name": "Byles",
    "First Name": "Marnie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491612: {
    id: "item_18616",
    "Last Name": "Nohreiter",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491635: {
    id: "item_21265",
    "Last Name": "O'Connell",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491665: {
    id: "item_32027",
    "Last Name": "Newton",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491670: {
    id: "item_18615",
    "Last Name": "Stephenson",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491801: {
    id: "item_18612",
    "Last Name": "Hyett",
    "First Name": "Cindy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491811: {
    id: "item_21264",
    "Last Name": "stewart",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491905: {
    id: "item_8637",
    "Last Name": "Fjellhaug",
    "First Name": "Kristian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491913: {
    id: "item_18610",
    "Last Name": "Meldrum",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37491998: {
    id: "item_6067",
    "Last Name": "cao",
    "First Name": "shimin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37492015: {
    id: "item_6065",
    "Last Name": "Sullivan",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37492027: {
    id: "item_33677",
    "Last Name": "Pacheco",
    "First Name": "Francheska",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37492486: {
    id: "item_18607",
    "Last Name": "Saiah",
    "First Name": "Noah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37492609: {
    id: "item_21260",
    "Last Name": "Twycross",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37492740: {
    id: "item_18604",
    "Last Name": "Yoo",
    "First Name": "Jea Seung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37493241: {
    id: "item_32024",
    "Last Name": "Perol",
    "First Name": "Frances",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37493732: {
    id: "item_33675",
    "Last Name": "Recht",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37494185: {
    id: "item_19319",
    "Last Name": "LI",
    "First Name": "SHUFEN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37495106: {
    id: "item_18599",
    "Last Name": "Mc Grath",
    "First Name": "Roisin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37495392: {
    id: "item_18596",
    "Last Name": "MARTêN HERNANDEZ",
    "First Name": "JUAN PABLO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37495468: {
    id: "item_18595",
    "Last Name": "Grijalva Osorio",
    "First Name": "Estuardo Rene",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37495497: {
    id: "item_32023",
    "Last Name": "Navin",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37495621: {
    id: "item_8849",
    "Last Name": "Duchene",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37495783: {
    id: "item_18593",
    "Last Name": "Chen",
    "First Name": "Ying Jian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37495794: {
    id: "item_32022",
    "Last Name": "Hamer",
    "First Name": "Pirko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37496156: {
    id: "item_18590",
    "Last Name": "Nash",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37496272: {
    id: "item_18589",
    "Last Name": "Ayerdi",
    "First Name": "Mikel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37496342: {
    id: "item_6052",
    "Last Name": "McDonnell",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37496504: {
    id: "item_6050",
    "Last Name": "Foster",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37496857: {
    id: "item_33672",
    "Last Name": "Taplin",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37498011: {
    id: "item_33671",
    "Last Name": "Thedieck",
    "First Name": "Ann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37508454: {
    id: "item_6044",
    "Last Name": "Jackson",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37509098: {
    id: "item_33907",
    "Last Name": "FUNG",
    "First Name": "Kit Man",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37509513: {
    id: "item_6043",
    "Last Name": "Guimaraes Tavares da Silva",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37509999: {
    id: "item_32019",
    "Last Name": "Chattopadhyay",
    "First Name": "Sushmita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37510068: {
    id: "item_33668",
    "Last Name": "Chew",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37510247: {
    id: "item_33666",
    "Last Name": "Hosken",
    "First Name": "Laynee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37510272: {
    id: "item_6039",
    "Last Name": "Kemp",
    "First Name": "Imogen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37510756: {
    id: "item_32017",
    "Last Name": "Melendez",
    "First Name": "Nora",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37512477: {
    id: "item_6037",
    "Last Name": "Johnstone",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37512623: {
    id: "item_21253",
    "Last Name": "Tur",
    "First Name": "Bulgan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37512872: {
    id: "item_33664",
    "Last Name": "Bisht",
    "First Name": "Apoorva",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37513836: {
    id: "item_8625",
    "Last Name": "Mackie",
    "First Name": "Heather",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37514203: {
    id: "item_33661",
    "Last Name": "Scott",
    "First Name": "Kendal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37514345: {
    id: "item_21250",
    "Last Name": "Hermannsson",
    "First Name": "Gudjon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37514667: {
    id: "item_8622",
    "Last Name": "Cadas",
    "First Name": "Sebastien",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37514898: {
    id: "item_6030",
    "Last Name": "Dugger",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37514969: {
    id: "item_32014",
    "Last Name": "Rees",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37515281: {
    id: "item_6028",
    "Last Name": "galeb",
    "First Name": "alen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37515353: {
    id: "item_21249",
    "Last Name": "Curran",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37515396: {
    id: "item_6026",
    "Last Name": "Yang",
    "First Name": "XIAOJUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37515558: {
    id: "item_8615",
    "Last Name": "Latorre",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37515586: {
    id: "item_32012",
    "Last Name": "YANG",
    "First Name": "KUN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37515670: {
    id: "item_6021",
    "Last Name": "Lu",
    "First Name": "Daqian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37515789: {
    id: "item_8612",
    "Last Name": "Xun",
    "First Name": "Deng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37515915: {
    id: "item_21246",
    "Last Name": "martinez",
    "First Name": "Karla",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37515938: {
    id: "item_33656",
    "Last Name": "Wong",
    "First Name": "Jonathan Keng Yew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37516091: {
    id: "item_6019",
    "Last Name": "Rezende",
    "First Name": "Pedro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37516301: {
    id: "item_6017",
    "Last Name": "Accetta",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37516463: {
    id: "item_6015",
    "Last Name": "Chen",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37516772: {
    id: "item_6527",
    "Last Name": "MacKellar",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37516849: {
    id: "item_6012",
    "Last Name": "McAuley",
    "First Name": "Conor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37517095: {
    id: "item_6011",
    "Last Name": "Zhong",
    "First Name": "Yuchen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518157: {
    id: "item_21238",
    "Last Name": "KIM",
    "First Name": "WOOCHAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518220: {
    id: "item_8603",
    "Last Name": "You",
    "First Name": "Ailing",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518268: {
    id: "item_32008",
    "Last Name": "Ching",
    "First Name": "Cherie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518331: {
    id: "item_6008",
    "Last Name": "Vassiliou",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518345: {
    id: "item_19318",
    "Last Name": "YE",
    "First Name": "KAIDING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518424: {
    id: "item_6007",
    "Last Name": "Nguyen",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518571: {
    id: "item_6006",
    "Last Name": "Cornish",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518734: {
    id: "item_6005",
    "Last Name": "Jiang",
    "First Name": "Mingwen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518794: {
    id: "item_32007",
    "Last Name": "Ocampo",
    "First Name": "Carlos Napoleon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518816: {
    id: "item_6004",
    "Last Name": "ham",
    "First Name": "sangwook",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518840: {
    id: "item_21237",
    "Last Name": "Yeung",
    "First Name": "Hiu Kwan Clara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518872: {
    id: "item_6003",
    "Last Name": "Merrick",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37518953: {
    id: "item_6002",
    "Last Name": "Perrett",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37519227: {
    id: "item_33906",
    "Last Name": "Shin",
    "First Name": "Jiwon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37519263: {
    id: "item_32004",
    "Last Name": "Paul",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37519464: {
    id: "item_21236",
    "Last Name": "Whatmore",
    "First Name": "Rosa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37519582: {
    id: "item_5997",
    "Last Name": "Gao",
    "First Name": "Bing",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37519607: {
    id: "item_33648",
    "Last Name": "Hewitt",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37519707: {
    id: "item_33647",
    "Last Name": "Dewi",
    "First Name": "Upik Mahna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37519866: {
    id: "item_33645",
    "Last Name": "Tolentino",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37519923: {
    id: "item_8596",
    "Last Name": "Bower",
    "First Name": "Louise",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37519991: {
    id: "item_21231",
    "Last Name": "Giles",
    "First Name": "Roxanne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37520399: {
    id: "item_5992",
    "Last Name": "Leong",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37520556: {
    id: "item_21229",
    "Last Name": "Simpson",
    "First Name": "Penelope",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37520604: {
    id: "item_5989",
    "Last Name": "De Lusignan",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37520671: {
    id: "item_8592",
    "Last Name": "Papathanasiou",
    "First Name": "Petros",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37520972: {
    id: "item_8590",
    "Last Name": "Williams",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37521531: {
    id: "item_5981",
    "Last Name": "Hastings",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37522079: {
    id: "item_5979",
    "Last Name": "Banta",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37522089: {
    id: "item_32000",
    "Last Name": "Reyes",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37522949: {
    id: "item_31999",
    "Last Name": "Davis",
    "First Name": "Rustin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37523051: {
    id: "item_8587",
    "Last Name": "Yang",
    "First Name": "Shouying",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37523087: {
    id: "item_5975",
    "Last Name": "Halloran",
    "First Name": "Kaitlin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37523643: {
    id: "item_8586",
    "Last Name": "Mukanyima",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37531492: {
    id: "item_19317",
    "Last Name": "Wang",
    "First Name": "Rujin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37533296: {
    id: "item_33628",
    "Last Name": "Soto",
    "First Name": "Judith",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37539979: {
    id: "item_33627",
    "Last Name": "Boppert",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37545533: {
    id: "item_5972",
    "Last Name": "Hart",
    "First Name": "Nadia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37547594: {
    id: "item_31996",
    "Last Name": "Armendariz",
    "First Name": "Raquel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37547986: {
    id: "item_33625",
    "Last Name": "Liehr",
    "First Name": "Jonna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37548899: {
    id: "item_31995",
    "Last Name": "Thomson",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37550382: {
    id: "item_31994",
    "Last Name": "Durbin",
    "First Name": "Dave",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37552699: {
    id: "item_8580",
    "Last Name": "Guery",
    "First Name": "Joan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37556964: {
    id: "item_21219",
    "Last Name": "Cordero",
    "First Name": "Oscar Armando",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37557230: {
    id: "item_33623",
    "Last Name": "Omolon",
    "First Name": "Abegail",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37557927: {
    id: "item_5965",
    "Last Name": "Ackroyd",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37557972: {
    id: "item_33622",
    "Last Name": "Riley",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37558002: {
    id: "item_5964",
    "Last Name": "Daelemans",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37558225: {
    id: "item_31990",
    "Last Name": "Fernandez-Ruiz",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37558417: {
    id: "item_5962",
    "Last Name": "Ha",
    "First Name": "Tyler",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37558598: {
    id: "item_8576",
    "Last Name": "Skaliotis",
    "First Name": "Leon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37558734: {
    id: "item_5960",
    "Last Name": "Li",
    "First Name": "Ho Leung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37558892: {
    id: "item_5955",
    "Last Name": "Street",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37560404: {
    id: "item_33619",
    "Last Name": "Zulkifli Poh",
    "First Name": "Anna Norliza",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37560422: {
    id: "item_33618",
    "Last Name": "Belonguel",
    "First Name": "Aaron Christian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37560589: {
    id: "item_5952",
    "Last Name": "Gowland",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37561050: {
    id: "item_8571",
    "Last Name": "Clay",
    "First Name": "Saul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37561500: {
    id: "item_31987",
    "Last Name": "Osada",
    "First Name": "Kokoro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37561675: {
    id: "item_21213",
    "Last Name": "Taylor",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37561879: {
    id: "item_5947",
    "Last Name": "Kwong",
    "First Name": "Felix",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37562422: {
    id: "item_5945",
    "Last Name": "Smith",
    "First Name": "Shauna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37562472: {
    id: "item_5943",
    "Last Name": "Randall",
    "First Name": "Troy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37562544: {
    id: "item_5941",
    "Last Name": "Ruohan",
    "First Name": "Shang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37563431: {
    id: "item_5939",
    "Last Name": "Saneevong Na Ayuthaya",
    "First Name": "Peerada",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37565203: {
    id: "item_8567",
    "Last Name": "Li",
    "First Name": "Yanrong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37565334: {
    id: "item_6526",
    "Last Name": "Flores",
    "First Name": "Monica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37565492: {
    id: "item_5937",
    "Last Name": "Huang",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37565496: {
    id: "item_5936",
    "Last Name": "Kelly",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37566174: {
    id: "item_21208",
    "Last Name": "Schedler",
    "First Name": "Anika",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37566546: {
    id: "item_5932",
    "Last Name": "Hay",
    "First Name": "Christel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37566563: {
    id: "item_31984",
    "Last Name": "Fitzpatrick",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37566630: {
    id: "item_19316",
    "Last Name": "Stevens",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37566672: {
    id: "item_8563",
    "Last Name": "lusaya",
    "First Name": "Erlo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37566684: {
    id: "item_31983",
    "Last Name": "Lim",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567045: {
    id: "item_31981",
    "Last Name": "CHUNG",
    "First Name": "jinmyeong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567080: {
    id: "item_5926",
    "Last Name": "HSIAO",
    "First Name": "YU CHENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567232: {
    id: "item_8557",
    "Last Name": "Berichel",
    "First Name": "Lise",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567290: {
    id: "item_33603",
    "Last Name": "Varney",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567315: {
    id: "item_33604",
    "Last Name": "Noon",
    "First Name": "Bronwyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567319: {
    id: "item_33602",
    "Last Name": "Hopton",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567322: {
    id: "item_33601",
    "Last Name": "Moloney",
    "First Name": "Marife",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567349: {
    id: "item_5923",
    "Last Name": "Ashley",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567418: {
    id: "item_5919",
    "Last Name": "Lau",
    "First Name": "Ka Ming",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567493: {
    id: "item_5918",
    "Last Name": "TAKEUCHI",
    "First Name": "KENJI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567572: {
    id: "item_33599",
    "Last Name": "Imanotai",
    "First Name": "Vananthon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37567966: {
    id: "item_33598",
    "Last Name": "Cankova-Unwin",
    "First Name": "Bogdana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37568041: {
    id: "item_31979",
    "Last Name": "Chiou",
    "First Name": "Crisander",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37568116: {
    id: "item_31978",
    "Last Name": "Thia",
    "First Name": "Cheryl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37568396: {
    id: "item_5914",
    "Last Name": "Harknett",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37568698: {
    id: "item_32197",
    "Last Name": "Liu",
    "First Name": "Jianbang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37568716: {
    id: "item_8551",
    "Last Name": "KAO",
    "First Name": "SHUN-YI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37568910: {
    id: "item_33593",
    "Last Name": "Bontsi",
    "First Name": "Fortune",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37568945: {
    id: "item_19315",
    "Last Name": "Mandetta",
    "First Name": "Antonietta",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37568991: {
    id: "item_31973",
    "Last Name": "Chung",
    "First Name": "Chihyu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37570384: {
    id: "item_33905",
    "Last Name": "Kawano",
    "First Name": "Mariko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37574272: {
    id: "item_5908",
    "Last Name": "DouŽ",
    "First Name": "SŽbastien",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37578416: {
    id: "item_8548",
    "Last Name": "Yew",
    "First Name": "Yuen chun richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37578442: {
    id: "item_6476",
    "Last Name": "Mbugua",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37587949: {
    id: "item_8547",
    "Last Name": "Kumar",
    "First Name": "Pratyush",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37596340: {
    id: "item_31970",
    "Last Name": "Flores",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37598986: {
    id: "item_5905",
    "Last Name": "Endsley",
    "First Name": "Daren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37600704: {
    id: "item_8848",
    "Last Name": "Guerrero",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37610331: {
    id: "item_19314",
    "Last Name": "O'Keefe",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37618973: {
    id: "item_8545",
    "Last Name": "Usandizaga Carulla",
    "First Name": "Claudi Artur",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37620627: {
    id: "item_21195",
    "Last Name": "Scharpf",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37623012: {
    id: "item_31968",
    "Last Name": "Bai Reddy",
    "First Name": "Santosh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37631464: {
    id: "item_33590",
    "Last Name": "Duncan",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37632651: {
    id: "item_21193",
    "Last Name": "Samko",
    "First Name": "Kiki",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37632667: {
    id: "item_21192",
    "Last Name": "Rocha Trevizani",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37632745: {
    id: "item_21191",
    "Last Name": "Hunting",
    "First Name": "Todd",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37632900: {
    id: "item_8541",
    "Last Name": "Sitch",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37632922: {
    id: "item_5898",
    "Last Name": "Ishikawa",
    "First Name": "Mariko",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37633049: {
    id: "item_33586",
    "Last Name": "Newell",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37633692: {
    id: "item_8847",
    "Last Name": "Nelson",
    "First Name": "Karin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37635986: {
    id: "item_33904",
    "Last Name": "Glover",
    "First Name": "Silvia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37636430: {
    id: "item_31967",
    "Last Name": "GIL",
    "First Name": "PAULO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37645447: {
    id: "item_5894",
    "Last Name": "Falzarano",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37645464: {
    id: "item_5892",
    "Last Name": "Pandey",
    "First Name": "Jagdish",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37645524: {
    id: "item_31964",
    "Last Name": "Golusin",
    "First Name": "Ally",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37645705: {
    id: "item_31962",
    "Last Name": "Guzman",
    "First Name": "Chee Anne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37645729: {
    id: "item_21189",
    "Last Name": "Sham",
    "First Name": "Kamcheung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37646727: {
    id: "item_5884",
    "Last Name": "Nguyen",
    "First Name": "Trung Thanh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37646920: {
    id: "item_5882",
    "Last Name": "Knight",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37646977: {
    id: "item_31960",
    "Last Name": "Farrell",
    "First Name": "Odile",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37647543: {
    id: "item_33578",
    "Last Name": "Dennett",
    "First Name": "Mali",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37648368: {
    id: "item_5877",
    "Last Name": "Tu",
    "First Name": "Chin-Wen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37648507: {
    id: "item_31957",
    "Last Name": "Chearon",
    "First Name": "Farahana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37648647: {
    id: "item_8535",
    "Last Name": "Moss",
    "First Name": "Broderick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37649640: {
    id: "item_5876",
    "Last Name": "Connolly",
    "First Name": "Helen Marie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37649690: {
    id: "item_31955",
    "Last Name": "Velasquez",
    "First Name": "Shara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37649796: {
    id: "item_21185",
    "Last Name": "Johnson",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37649807: {
    id: "item_8532",
    "Last Name": "Low",
    "First Name": "Yiin Chern",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650044: {
    id: "item_21184",
    "Last Name": "Ng",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650054: {
    id: "item_5874",
    "Last Name": "Na Nakhon",
    "First Name": "Kittanon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650175: {
    id: "item_5873",
    "Last Name": "Melville",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650203: {
    id: "item_5872",
    "Last Name": "Siddiqui",
    "First Name": "Quazi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650430: {
    id: "item_5868",
    "Last Name": "Khan",
    "First Name": "Mustafa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650580: {
    id: "item_8526",
    "Last Name": "Crinis",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650581: {
    id: "item_33574",
    "Last Name": "Fadhli",
    "First Name": "Hafizna Arsyil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650727: {
    id: "item_5863",
    "Last Name": "Bungate",
    "First Name": "Neil",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650767: {
    id: "item_33572",
    "Last Name": "Dairo",
    "First Name": "Seliat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650782: {
    id: "item_19313",
    "Last Name": "Tessa",
    "First Name": "Tessa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650822: {
    id: "item_5861",
    "Last Name": "Norvill",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650920: {
    id: "item_21180",
    "Last Name": "Sands",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37650955: {
    id: "item_21179",
    "Last Name": "Anderson",
    "First Name": "Michael Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37651074: {
    id: "item_5860",
    "Last Name": "Murphy",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37651131: {
    id: "item_5859",
    "Last Name": "Juan",
    "First Name": "Khairo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37651433: {
    id: "item_19312",
    "Last Name": "Kirwan",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37651749: {
    id: "item_31947",
    "Last Name": "Suwito",
    "First Name": "Rizki Dwi Oktora",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37651842: {
    id: "item_31946",
    "Last Name": "Morris",
    "First Name": "Tia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37651969: {
    id: "item_5853",
    "Last Name": "Ngan",
    "First Name": "Tsz Cheung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37651973: {
    id: "item_5854",
    "Last Name": "Rowlands",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652050: {
    id: "item_5851",
    "Last Name": "tomeldan",
    "First Name": "ervin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652077: {
    id: "item_33565",
    "Last Name": "Prasetyo",
    "First Name": "Budi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652103: {
    id: "item_5849",
    "Last Name": "Doyle",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652135: {
    id: "item_5848",
    "Last Name": "Smith",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652345: {
    id: "item_21176",
    "Last Name": "Kapitza",
    "First Name": "Nat",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652414: {
    id: "item_8814",
    "Last Name": "YAO",
    "First Name": "PENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652485: {
    id: "item_33564",
    "Last Name": "Calangan",
    "First Name": "Ma. Liza Agnes",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652558: {
    id: "item_33563",
    "Last Name": "Matbagan",
    "First Name": "Genivive",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652606: {
    id: "item_31938",
    "Last Name": "Torres Montoya",
    "First Name": "Katheleen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652638: {
    id: "item_33562",
    "Last Name": "Kelly",
    "First Name": "Bronwyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652644: {
    id: "item_8518",
    "Last Name": "Klein",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652836: {
    id: "item_8517",
    "Last Name": "Sklavounos",
    "First Name": "Sotiris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652839: {
    id: "item_8516",
    "Last Name": "lin",
    "First Name": "chiayuan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37652918: {
    id: "item_5839",
    "Last Name": "Junk",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37653092: {
    id: "item_33903",
    "Last Name": "Tarwidi Sukemi",
    "First Name": "Prihadiyanto",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37653871: {
    id: "item_8846",
    "Last Name": "moon",
    "First Name": "seongeun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37654544: {
    id: "item_5832",
    "Last Name": "Dale",
    "First Name": "Harold",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37660983: {
    id: "item_33559",
    "Last Name": "Aer",
    "First Name": "Irma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37664979: {
    id: "item_33558",
    "Last Name": "SON",
    "First Name": "YI YO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37665551: {
    id: "item_5829",
    "Last Name": "Fisher",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37686720: {
    id: "item_21166",
    "Last Name": "Humphrey",
    "First Name": "Renata",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37691925: {
    id: "item_31930",
    "Last Name": "Agudo",
    "First Name": "Reynald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37695134: {
    id: "item_31928",
    "Last Name": "Kirchhoff",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37696993: {
    id: "item_5824",
    "Last Name": "Teng",
    "First Name": "Wanming",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37697322: {
    id: "item_31927",
    "Last Name": "Wu",
    "First Name": "YEN CHIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37698160: {
    id: "item_8507",
    "Last Name": "Liu",
    "First Name": "Hang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37699085: {
    id: "item_21165",
    "Last Name": "Serrao",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37699307: {
    id: "item_8505",
    "Last Name": "mugodzeri",
    "First Name": "Daisy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37700448: {
    id: "item_8503",
    "Last Name": "Hendabadi",
    "First Name": "Sahar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37700498: {
    id: "item_31925",
    "Last Name": "Byrne",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37700713: {
    id: "item_21164",
    "Last Name": "Clarke",
    "First Name": "Shelby",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37700821: {
    id: "item_31923",
    "Last Name": "Baxter",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37700985: {
    id: "item_8501",
    "Last Name": "Moctezuma",
    "First Name": "Monica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37701645: {
    id: "item_31922",
    "Last Name": "Kwenda",
    "First Name": "Esinath",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37701814: {
    id: "item_31921",
    "Last Name": "Cuthbert",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37702100: {
    id: "item_19311",
    "Last Name": "Aprianto",
    "First Name": "Fadly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37702122: {
    id: "item_8500",
    "Last Name": "Ghersi",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37702466: {
    id: "item_33551",
    "Last Name": "Mohamad Zain",
    "First Name": "Faizal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37702481: {
    id: "item_31919",
    "Last Name": "Reynolds",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37702619: {
    id: "item_19310",
    "Last Name": "OConnor",
    "First Name": "Sacha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37702759: {
    id: "item_19309",
    "Last Name": "Murphy",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37703349: {
    id: "item_33119",
    "Last Name": "Wong",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37704028: {
    id: "item_31914",
    "Last Name": "samosir",
    "First Name": "fanny eileen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37704045: {
    id: "item_33546",
    "Last Name": "posmasari",
    "First Name": "indria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37704775: {
    id: "item_8493",
    "Last Name": "Lomas",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37705171: {
    id: "item_33540",
    "Last Name": "Walker",
    "First Name": "Ashlinn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37705248: {
    id: "item_19216",
    "Last Name": "Sudi",
    "First Name": "Simin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37705800: {
    id: "item_21153",
    "Last Name": "Webb",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37705845: {
    id: "item_33536",
    "Last Name": "Kortekaas",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37706247: {
    id: "item_31903",
    "Last Name": "Yasmin",
    "First Name": "Fawjia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37706362: {
    id: "item_33535",
    "Last Name": "Gampfer",
    "First Name": "Laila",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37706661: {
    id: "item_19308",
    "Last Name": "Liu",
    "First Name": "Zhefan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37707448: {
    id: "item_8482",
    "Last Name": "Yu",
    "First Name": "Yeung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37707680: {
    id: "item_21150",
    "Last Name": "Sosa",
    "First Name": "Judith",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37707794: {
    id: "item_33530",
    "Last Name": "napitupulu",
    "First Name": "elfrida",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37708052: {
    id: "item_6475",
    "Last Name": "Ferrer",
    "First Name": "Nialah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37708457: {
    id: "item_19307",
    "Last Name": "WOO",
    "First Name": "SEUNGSIK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37708936: {
    id: "item_6525",
    "Last Name": "Osman",
    "First Name": "Tariq",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37709043: {
    id: "item_8845",
    "Last Name": "Umarov",
    "First Name": "Maxim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37709389: {
    id: "item_33529",
    "Last Name": "Selvaraj",
    "First Name": "Senthilkumar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37710349: {
    id: "item_31897",
    "Last Name": "Stevens",
    "First Name": "Doug",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37710990: {
    id: "item_21148",
    "Last Name": "Janis",
    "First Name": "Mercedes",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37711060: {
    id: "item_8477",
    "Last Name": "Hurry",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37711281: {
    id: "item_31895",
    "Last Name": "Keating",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37713682: {
    id: "item_31892",
    "Last Name": "Brule",
    "First Name": "Monique",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37714037: {
    id: "item_21145",
    "Last Name": "Dieste franca",
    "First Name": "Leire",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37714540: {
    id: "item_33517",
    "Last Name": "LIM",
    "First Name": "TECK LEE PHILIP",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37714864: {
    id: "item_33515",
    "Last Name": "Ng",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37715118: {
    id: "item_8464",
    "Last Name": "Wood",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37715393: {
    id: "item_8462",
    "Last Name": "Canepa Calderon",
    "First Name": "Itzel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37715411: {
    id: "item_8460",
    "Last Name": "Pirozhkov",
    "First Name": "Fedor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37715504: {
    id: "item_33514",
    "Last Name": "Soriano",
    "First Name": "Verrell Victor",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37715921: {
    id: "item_6524",
    "Last Name": "Ischia",
    "First Name": "Liesl",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37715958: {
    id: "item_8457",
    "Last Name": "Ponce",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37716312: {
    id: "item_31887",
    "Last Name": "Jones",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37716463: {
    id: "item_33508",
    "Last Name": "Liu",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37716516: {
    id: "item_8456",
    "Last Name": "Whitcroft",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37716587: {
    id: "item_33506",
    "Last Name": "Rodd",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37717051: {
    id: "item_31882",
    "Last Name": "Nur Aini",
    "First Name": "Rini",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37717087: {
    id: "item_21135",
    "Last Name": "Qiu",
    "First Name": "Xiaochuan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37717190: {
    id: "item_31878",
    "Last Name": "Hong",
    "First Name": "Sunghun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37717427: {
    id: "item_19306",
    "Last Name": "Tran",
    "First Name": "Arron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37717499: {
    id: "item_19305",
    "Last Name": "Tay",
    "First Name": "Keni",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37717576: {
    id: "item_31875",
    "Last Name": "Raguine",
    "First Name": "Yelsha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37717634: {
    id: "item_21131",
    "Last Name": "martin",
    "First Name": "erica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37717696: {
    id: "item_8449",
    "Last Name": "Biundo",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37718224: {
    id: "item_21387",
    "Last Name": "Ridwan",
    "First Name": "Masud",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37718451: {
    id: "item_19304",
    "Last Name": "KIM",
    "First Name": "SEUNG SIK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37718639: {
    id: "item_33498",
    "Last Name": "Fung",
    "First Name": "Wing Chung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37719375: {
    id: "item_31872",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37719465: {
    id: "item_31871",
    "Last Name": "Fleming",
    "First Name": "Jayne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37719632: {
    id: "item_32196",
    "Last Name": "CHU",
    "First Name": "KUAN LIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37722853: {
    id: "item_21126",
    "Last Name": "Aschinasi",
    "First Name": "Serge",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37723302: {
    id: "item_33494",
    "Last Name": "Morris",
    "First Name": "Evan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37723454: {
    id: "item_33493",
    "Last Name": "Orpen",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37724282: {
    id: "item_33491",
    "Last Name": "Piyasantisook",
    "First Name": "Burintorn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37725152: {
    id: "item_8435",
    "Last Name": "Bishop",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37726230: {
    id: "item_8434",
    "Last Name": "Chulalucksiriboon_",
    "First Name": "Patnarin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37726708: {
    id: "item_21123",
    "Last Name": "Palomino",
    "First Name": "Daniel Mauricio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37726906: {
    id: "item_31858",
    "Last Name": "Stocker",
    "First Name": "Raelene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37726971: {
    id: "item_31857",
    "Last Name": "CAPUCHINO",
    "First Name": "RUDOLPH VALENTIN SERAFIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37727637: {
    id: "item_31854",
    "Last Name": "Clyde",
    "First Name": "Kristol",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37728059: {
    id: "item_21117",
    "Last Name": "Dennehy",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37728102: {
    id: "item_8431",
    "Last Name": "Kucharski",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37728219: {
    id: "item_33484",
    "Last Name": "Wu",
    "First Name": "Yi-Chieh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37728337: {
    id: "item_33482",
    "Last Name": "Badrish",
    "First Name": "Arnav",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37728764: {
    id: "item_21114",
    "Last Name": "Lawson",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37728801: {
    id: "item_33480",
    "Last Name": "Maharjan",
    "First Name": "Somy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37728896: {
    id: "item_31848",
    "Last Name": "WANG",
    "First Name": "CHIUN-YI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37729035: {
    id: "item_33479",
    "Last Name": "Tempongko",
    "First Name": "Pia Karla",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37729108: {
    id: "item_8420",
    "Last Name": "Saffarini",
    "First Name": "Rayeq",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37729283: {
    id: "item_31844",
    "Last Name": "Lu",
    "First Name": "Wylene Chelsea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37729318: {
    id: "item_31842",
    "Last Name": "Lu",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37729378: {
    id: "item_33475",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37729927: {
    id: "item_8418",
    "Last Name": "Araiza Soto",
    "First Name": "Gonzalo Abraham",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37732611: {
    id: "item_8813",
    "Last Name": "Cordini",
    "First Name": "Clerio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37733455: {
    id: "item_33471",
    "Last Name": "Kaur",
    "First Name": "Harvinder",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37733675: {
    id: "item_33469",
    "Last Name": "Chlonta",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37733810: {
    id: "item_8412",
    "Last Name": "Foster",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37734125: {
    id: "item_31834",
    "Last Name": "Bascetta",
    "First Name": "Paola",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37735005: {
    id: "item_31832",
    "Last Name": "Nazzaro",
    "First Name": "Demelene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37735338: {
    id: "item_31829",
    "Last Name": "Daughters",
    "First Name": "Kathy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37736326: {
    id: "item_21107",
    "Last Name": "Park",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37736490: {
    id: "item_8844",
    "Last Name": "CHIA",
    "First Name": "YANG JIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37738234: {
    id: "item_19303",
    "Last Name": "Mok",
    "First Name": "Ka Kin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37739376: {
    id: "item_31821",
    "Last Name": "Enerio",
    "First Name": "Heart De",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37739515: {
    id: "item_6523",
    "Last Name": "Velasco",
    "First Name": "Samantha Lorraine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37739651: {
    id: "item_8398",
    "Last Name": "Klug",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37739803: {
    id: "item_33461",
    "Last Name": "Cheesman-Dutton",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37740014: {
    id: "item_31819",
    "Last Name": "Ng",
    "First Name": "Peng Kwee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37740036: {
    id: "item_8394",
    "Last Name": "McAleese",
    "First Name": "Declan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37740171: {
    id: "item_31817",
    "Last Name": "YANG",
    "First Name": "KUO-LIANG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37740173: {
    id: "item_21094",
    "Last Name": "Raihan Bin Saipul",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37740300: {
    id: "item_31815",
    "Last Name": "Love",
    "First Name": "Desiree",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37740642: {
    id: "item_21092",
    "Last Name": "Harvey",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37740667: {
    id: "item_21090",
    "Last Name": "Johnstone",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37741339: {
    id: "item_8384",
    "Last Name": "Sheppard",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37741395: {
    id: "item_8382",
    "Last Name": "Sorensen",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37741469: {
    id: "item_8843",
    "Last Name": "Dean",
    "First Name": "Melody",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37741519: {
    id: "item_33455",
    "Last Name": "CHANG",
    "First Name": "HSIN-CHING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37741551: {
    id: "item_31809",
    "Last Name": "Vongchaisit",
    "First Name": "Lertchai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37741831: {
    id: "item_33453",
    "Last Name": "Su",
    "First Name": "Myat Noe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37741951: {
    id: "item_8378",
    "Last Name": "Sasaki",
    "First Name": "Toshiyuki",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37741979: {
    id: "item_8377",
    "Last Name": "Lai",
    "First Name": "Yuhao",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37742110: {
    id: "item_21086",
    "Last Name": "HUANG",
    "First Name": "PANG-HSUAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37742679: {
    id: "item_8375",
    "Last Name": "Liu",
    "First Name": "YU CHUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37743472: {
    id: "item_31807",
    "Last Name": "Duque",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37744468: {
    id: "item_31804",
    "Last Name": "Gelles",
    "First Name": "Lyly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37745242: {
    id: "item_8370",
    "Last Name": "Crocker",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37745723: {
    id: "item_33902",
    "Last Name": "Baker",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37746099: {
    id: "item_21080",
    "Last Name": "Schiedel",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37746251: {
    id: "item_31803",
    "Last Name": "Kuang",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37746506: {
    id: "item_33444",
    "Last Name": "Lin",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37746986: {
    id: "item_21078",
    "Last Name": "Koh",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37746988: {
    id: "item_5815",
    "Last Name": "TANG",
    "First Name": "WEN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37747438: {
    id: "item_8363",
    "Last Name": "SMALL",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37748036: {
    id: "item_31800",
    "Last Name": "Amin",
    "First Name": "Shivani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37748170: {
    id: "item_31799",
    "Last Name": "Tionko",
    "First Name": "Efrain",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37748270: {
    id: "item_31798",
    "Last Name": "Parkes",
    "First Name": "Nette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37748295: {
    id: "item_5814",
    "Last Name": "SOTO",
    "First Name": "CARLOS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37748707: {
    id: "item_33439",
    "Last Name": "Tan",
    "First Name": "Sok Fei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37748909: {
    id: "item_6522",
    "Last Name": "Ferguson",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37748961: {
    id: "item_8357",
    "Last Name": "Limburg",
    "First Name": "Dave",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37748977: {
    id: "item_8356",
    "Last Name": "Nicholls",
    "First Name": "Kate",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37749207: {
    id: "item_33437",
    "Last Name": "Heyvaerts",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37749360: {
    id: "item_33436",
    "Last Name": "Gandhi",
    "First Name": "Norin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37749716: {
    id: "item_31792",
    "Last Name": "Callen",
    "First Name": "Maddie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37749769: {
    id: "item_33433",
    "Last Name": "Yu",
    "First Name": "Ming Qi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37749859: {
    id: "item_8349",
    "Last Name": "Gundry",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37750473: {
    id: "item_33430",
    "Last Name": "Kanokkeekarin",
    "First Name": "Kattalee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37750510: {
    id: "item_32195",
    "Last Name": "TAKANI",
    "First Name": "HIROOKI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37750632: {
    id: "item_21075",
    "Last Name": "Jang",
    "First Name": "Aronne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37750722: {
    id: "item_8346",
    "Last Name": "Khong",
    "First Name": "Jing Chao",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37750835: {
    id: "item_32194",
    "Last Name": "Nobleza",
    "First Name": "Tatiana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37751121: {
    id: "item_33428",
    "Last Name": "Misa",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37751404: {
    id: "item_31789",
    "Last Name": "Chen",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37751781: {
    id: "item_8343",
    "Last Name": "Depalo",
    "First Name": "Anna Claudia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37753498: {
    id: "item_31787",
    "Last Name": "Savage",
    "First Name": "Storm",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37754032: {
    id: "item_32193",
    "Last Name": "Luu",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37755976: {
    id: "item_31781",
    "Last Name": "Forneloza",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37756216: {
    id: "item_31780",
    "Last Name": "Hadinata",
    "First Name": "Clinton",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37756380: {
    id: "item_33423",
    "Last Name": "Ciepla",
    "First Name": "Iwona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37756391: {
    id: "item_33421",
    "Last Name": "Lee",
    "First Name": "Soo Kee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37756392: {
    id: "item_31779",
    "Last Name": "Wang",
    "First Name": "Haoyu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37756490: {
    id: "item_33901",
    "Last Name": "Binte Mohamed Othman",
    "First Name": "Hani Hazirah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37756577: {
    id: "item_31778",
    "Last Name": "WANG",
    "First Name": "CHAO YU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37756915: {
    id: "item_32192",
    "Last Name": "Holcomb",
    "First Name": "Irene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37757107: {
    id: "item_31777",
    "Last Name": "Koranne",
    "First Name": "Prasad",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37757137: {
    id: "item_21067",
    "Last Name": "Snook",
    "First Name": "Mackenzie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37757230: {
    id: "item_8333",
    "Last Name": "Frost",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37757351: {
    id: "item_32191",
    "Last Name": "Tai",
    "First Name": "Chi-An",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37757397: {
    id: "item_33417",
    "Last Name": "Wong",
    "First Name": "Chung Yee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37760507: {
    id: "item_33414",
    "Last Name": "Khatib",
    "First Name": "Rahaf",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37760509: {
    id: "item_19302",
    "Last Name": "Bietola",
    "First Name": "Marc",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37762914: {
    id: "item_33412",
    "Last Name": "Wright",
    "First Name": "Jennie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37774603: {
    id: "item_31772",
    "Last Name": "Agarwal",
    "First Name": "Ankit",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37775185: {
    id: "item_33407",
    "Last Name": "LANCASTER",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37775465: {
    id: "item_21062",
    "Last Name": "Sollich",
    "First Name": "Eduard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37775474: {
    id: "item_32190",
    "Last Name": "Chan",
    "First Name": "Allen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37775583: {
    id: "item_31771",
    "Last Name": "KIM",
    "First Name": "HYUNGGU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37775765: {
    id: "item_32189",
    "Last Name": "Ong",
    "First Name": "Katrina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37775868: {
    id: "item_33402",
    "Last Name": "Quinn",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37775990: {
    id: "item_8321",
    "Last Name": "Pham",
    "First Name": "Minh Tan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37776116: {
    id: "item_31769",
    "Last Name": "_",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37776167: {
    id: "item_6521",
    "Last Name": "nilyanimit",
    "First Name": "pornjarim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37776305: {
    id: "item_21058",
    "Last Name": "Tang",
    "First Name": "Wai Shan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37776555: {
    id: "item_8320",
    "Last Name": "ZHONG",
    "First Name": "Wensheng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37778519: {
    id: "item_31765",
    "Last Name": "Montesdeoca",
    "First Name": "Jomary",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37779009: {
    id: "item_8317",
    "Last Name": "Walsh",
    "First Name": "Eileen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37780160: {
    id: "item_19215",
    "Last Name": "Bowen",
    "First Name": "Kathy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37782535: {
    id: "item_21368",
    "Last Name": "Fannon",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37782613: {
    id: "item_21054",
    "Last Name": "James",
    "First Name": "Neve",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37782640: {
    id: "item_33399",
    "Last Name": "Heng",
    "First Name": "Iin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37782801: {
    id: "item_8312",
    "Last Name": "Martin",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37784105: {
    id: "item_8308",
    "Last Name": "Davy",
    "First Name": "Calum",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37784303: {
    id: "item_8307",
    "Last Name": "Keating",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37784397: {
    id: "item_31752",
    "Last Name": "Perez Matos",
    "First Name": "Rossy Evelyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37784572: {
    id: "item_8306",
    "Last Name": "Abbey",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37784585: {
    id: "item_31750",
    "Last Name": "Hoffrage",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37784732: {
    id: "item_8842",
    "Last Name": "Elkinton",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37785248: {
    id: "item_8304",
    "Last Name": "WOO",
    "First Name": "JIMIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37785553: {
    id: "item_33390",
    "Last Name": "Bhatti",
    "First Name": "Hamza",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37785652: {
    id: "item_33388",
    "Last Name": "Wong",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37786041: {
    id: "item_19301",
    "Last Name": "SIANONA",
    "First Name": "SIANONA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37786434: {
    id: "item_31747",
    "Last Name": "Petalber",
    "First Name": "Bernadette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37787041: {
    id: "item_33384",
    "Last Name": "Landgraf",
    "First Name": "Austin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37787122: {
    id: "item_21047",
    "Last Name": "Andersen",
    "First Name": "Skye",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37787154: {
    id: "item_21386",
    "Last Name": "WU",
    "First Name": "YING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37787280: {
    id: "item_31746",
    "Last Name": "Heggie",
    "First Name": "Anita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37787744: {
    id: "item_33380",
    "Last Name": "Tan",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37788023: {
    id: "item_8295",
    "Last Name": "Schultz",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37788033: {
    id: "item_33379",
    "Last Name": "Keating",
    "First Name": "Siany",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37788089: {
    id: "item_33377",
    "Last Name": "Knight",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37788426: {
    id: "item_33376",
    "Last Name": "Tiongco",
    "First Name": "Gene Gerald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37789222: {
    id: "item_31744",
    "Last Name": "Vien",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37789333: {
    id: "item_8291",
    "Last Name": "YUNG",
    "First Name": "Heung Wing",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37789391: {
    id: "item_31743",
    "Last Name": "Ruhl",
    "First Name": "Diane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37789600: {
    id: "item_31738",
    "Last Name": "Ng",
    "First Name": "Cheuk him Leo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37789747: {
    id: "item_5811",
    "Last Name": "Clelland",
    "First Name": "Kadee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37790087: {
    id: "item_19300",
    "Last Name": "Pertiwi",
    "First Name": "Dina Bakti",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37790156: {
    id: "item_33371",
    "Last Name": "Pearce",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37790159: {
    id: "item_31735",
    "Last Name": "Linsangan",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37790265: {
    id: "item_31734",
    "Last Name": "Gregory",
    "First Name": "Brent",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37790463: {
    id: "item_8282",
    "Last Name": "Raynor",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37790599: {
    id: "item_21041",
    "Last Name": "Wang",
    "First Name": "Zhipeng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37790640: {
    id: "item_33366",
    "Last Name": "Louis",
    "First Name": "Mario",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37790671: {
    id: "item_8280",
    "Last Name": "McDonald",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37790680: {
    id: "item_8278",
    "Last Name": "Wooderson",
    "First Name": "Darcey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37791045: {
    id: "item_8841",
    "Last Name": "Orozco",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37792525: {
    id: "item_33361",
    "Last Name": "Hakim",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37800018: {
    id: "item_31726",
    "Last Name": "Cannon",
    "First Name": "Debby",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37806416: {
    id: "item_33359",
    "Last Name": "Fesdianti",
    "First Name": "Whenes",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37806466: {
    id: "item_33358",
    "Last Name": "Pathak",
    "First Name": "Pankaj",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37838677: {
    id: "item_33355",
    "Last Name": "Goh",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839367: {
    id: "item_8273",
    "Last Name": "Butler",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839442: {
    id: "item_21036",
    "Last Name": "Cassidy",
    "First Name": "Lily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839446: {
    id: "item_8271",
    "Last Name": "McCord",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839462: {
    id: "item_31719",
    "Last Name": "McLachlan",
    "First Name": "Antonia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839487: {
    id: "item_8268",
    "Last Name": "Quealy",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839509: {
    id: "item_31716",
    "Last Name": "King",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839720: {
    id: "item_33353",
    "Last Name": "Kidd",
    "First Name": "Peta",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839727: {
    id: "item_31712",
    "Last Name": "Gabitan",
    "First Name": "Marcel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839729: {
    id: "item_33354",
    "Last Name": "Garbo",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839731: {
    id: "item_21034",
    "Last Name": "Bravo",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839817: {
    id: "item_19214",
    "Last Name": "Choe",
    "First Name": "Terri",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37839985: {
    id: "item_31707",
    "Last Name": "Williamson",
    "First Name": "Guy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840016: {
    id: "item_21032",
    "Last Name": "Sivasubramanian",
    "First Name": "Abi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840030: {
    id: "item_21030",
    "Last Name": "Giurastante",
    "First Name": "Nunzio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840036: {
    id: "item_31705",
    "Last Name": "Christopher",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840082: {
    id: "item_21029",
    "Last Name": "Price",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840276: {
    id: "item_21028",
    "Last Name": "Hubbard",
    "First Name": "Koren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840430: {
    id: "item_21024",
    "Last Name": "Jenkins",
    "First Name": "Britteny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840455: {
    id: "item_21385",
    "Last Name": "Zurkammer",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840553: {
    id: "item_31700",
    "Last Name": "Carroll",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840608: {
    id: "item_33344",
    "Last Name": "Klein",
    "First Name": "Maren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840752: {
    id: "item_33343",
    "Last Name": "Cooray",
    "First Name": "Shavinka",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37840893: {
    id: "item_31695",
    "Last Name": "Brennan",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841043: {
    id: "item_8254",
    "Last Name": "Amond",
    "First Name": "Dale",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841101: {
    id: "item_8253",
    "Last Name": "Weber",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841174: {
    id: "item_31693",
    "Last Name": "Barrand-Lee",
    "First Name": "Elsa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841367: {
    id: "item_21016",
    "Last Name": "Rivero",
    "First Name": "Reanne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841498: {
    id: "item_8249",
    "Last Name": "Simpson",
    "First Name": "Annabelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841613: {
    id: "item_33337",
    "Last Name": "Treen",
    "First Name": "Noelene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841756: {
    id: "item_21384",
    "Last Name": "Lopez-Hope",
    "First Name": "Marli",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841794: {
    id: "item_8245",
    "Last Name": "Briceno",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841899: {
    id: "item_5808",
    "Last Name": "Karaman",
    "First Name": "Alia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841937: {
    id: "item_8247",
    "Last Name": "Drayton",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37841971: {
    id: "item_21009",
    "Last Name": "Shaw",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842122: {
    id: "item_8242",
    "Last Name": "Gordon",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842218: {
    id: "item_8240",
    "Last Name": "Smith",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842245: {
    id: "item_33333",
    "Last Name": "Tan",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842247: {
    id: "item_33334",
    "Last Name": "OÕHalloran",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842252: {
    id: "item_33332",
    "Last Name": "Catindig",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842592: {
    id: "item_33329",
    "Last Name": "Caldwell",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842607: {
    id: "item_8236",
    "Last Name": "Sullivan",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842674: {
    id: "item_8235",
    "Last Name": "Walter",
    "First Name": "Leo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842811: {
    id: "item_33328",
    "Last Name": "Bintoro",
    "First Name": "Kelik",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37842971: {
    id: "item_8233",
    "Last Name": "McNamara",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37843259: {
    id: "item_21005",
    "Last Name": "Soubrier",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37843304: {
    id: "item_19213",
    "Last Name": "Shaffrey",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37844196: {
    id: "item_33319",
    "Last Name": "Gaston",
    "First Name": "Tania",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37844215: {
    id: "item_8221",
    "Last Name": "franklin",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37844389: {
    id: "item_8220",
    "Last Name": "Marulanda",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37844414: {
    id: "item_8219",
    "Last Name": "McDonald",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37844632: {
    id: "item_8217",
    "Last Name": "La",
    "First Name": "Dongjin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37844667: {
    id: "item_8215",
    "Last Name": "Flordeliz",
    "First Name": "Janelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37844715: {
    id: "item_31669",
    "Last Name": "monaghan",
    "First Name": "alexander",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37844801: {
    id: "item_20998",
    "Last Name": "Paice",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37844901: {
    id: "item_33316",
    "Last Name": "Maddern",
    "First Name": "Noel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37845112: {
    id: "item_33315",
    "Last Name": "Huang",
    "First Name": "Xuwei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37845219: {
    id: "item_31665",
    "Last Name": "Yahaya",
    "First Name": "Ayob",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37845521: {
    id: "item_31661",
    "Last Name": "Foutanu",
    "First Name": "Vaova'i",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37845822: {
    id: "item_33311",
    "Last Name": "Cheng",
    "First Name": "Yuen Yee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37845839: {
    id: "item_20991",
    "Last Name": "Birmingham",
    "First Name": "Renee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37846088: {
    id: "item_31659",
    "Last Name": "Shrestha",
    "First Name": "Kabir",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37846195: {
    id: "item_20989",
    "Last Name": "Frank",
    "First Name": "Jayde",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37846848: {
    id: "item_31654",
    "Last Name": "Lee Lee",
    "First Name": "Tan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37846953: {
    id: "item_33304",
    "Last Name": "Kennewell",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847080: {
    id: "item_8197",
    "Last Name": "Dobson",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847113: {
    id: "item_20983",
    "Last Name": "MURAKAMI",
    "First Name": "NAOYA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847209: {
    id: "item_6520",
    "Last Name": "Thompson",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847253: {
    id: "item_8193",
    "Last Name": "Fimeri",
    "First Name": "Jasmin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847290: {
    id: "item_32188",
    "Last Name": "Amog",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847357: {
    id: "item_20980",
    "Last Name": "Panossian",
    "First Name": "Ani",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847514: {
    id: "item_20978",
    "Last Name": "Ng",
    "First Name": "Sophia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847543: {
    id: "item_33299",
    "Last Name": "Lowe",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847620: {
    id: "item_20976",
    "Last Name": "Weldon",
    "First Name": "Daryl",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847627: {
    id: "item_33297",
    "Last Name": "Elson",
    "First Name": "Lynda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37847650: {
    id: "item_19299",
    "Last Name": "Popham",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37848279: {
    id: "item_20972",
    "Last Name": "Macho",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37848292: {
    id: "item_8190",
    "Last Name": "Barrie",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37848579: {
    id: "item_8187",
    "Last Name": "Catal‡n Alarcon",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37848831: {
    id: "item_20967",
    "Last Name": "Admaja",
    "First Name": "Handoyo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37848962: {
    id: "item_20963",
    "Last Name": "WU",
    "First Name": "CHUN CHENG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849018: {
    id: "item_20961",
    "Last Name": "Villaflor",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849030: {
    id: "item_20960",
    "Last Name": "Stock",
    "First Name": "Sina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849063: {
    id: "item_33288",
    "Last Name": "Palasigue",
    "First Name": "Rowell",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849066: {
    id: "item_20958",
    "Last Name": "Morison",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849106: {
    id: "item_33286",
    "Last Name": "Porter",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849199: {
    id: "item_8178",
    "Last Name": "Miller",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849204: {
    id: "item_33285",
    "Last Name": "Josfira",
    "First Name": "Josfira",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849335: {
    id: "item_8174",
    "Last Name": "miller",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849397: {
    id: "item_33282",
    "Last Name": "Damrow",
    "First Name": "Lizzy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849454: {
    id: "item_32187",
    "Last Name": "Behal",
    "First Name": "Manan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849516: {
    id: "item_8170",
    "Last Name": "Phelan",
    "First Name": "Liam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849656: {
    id: "item_33279",
    "Last Name": "Tanioka",
    "First Name": "Kanami",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849768: {
    id: "item_20950",
    "Last Name": "CANESCHI",
    "First Name": "EROS",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37849973: {
    id: "item_8168",
    "Last Name": "Katugampola",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37850010: {
    id: "item_8167",
    "Last Name": "Tse",
    "First Name": "Ling nga sally",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37850113: {
    id: "item_8166",
    "Last Name": "Choi",
    "First Name": "Sau Tai Catherine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37851833: {
    id: "item_6519",
    "Last Name": "douglas",
    "First Name": "katherine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37851895: {
    id: "item_33865",
    "Last Name": "Austin",
    "First Name": "Lily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37853407: {
    id: "item_8156",
    "Last Name": "Fernandez",
    "First Name": "Vicente",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37853442: {
    id: "item_32186",
    "Last Name": "Cayanong",
    "First Name": "Mary Magdalene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37853614: {
    id: "item_33275",
    "Last Name": "Olivier",
    "First Name": "Ilhaam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37853739: {
    id: "item_8154",
    "Last Name": "Lin",
    "First Name": "Yue",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37854273: {
    id: "item_31626",
    "Last Name": "Avdijaj",
    "First Name": "Blendina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37854372: {
    id: "item_19298",
    "Last Name": "Lee",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37854788: {
    id: "item_33267",
    "Last Name": "Murray",
    "First Name": "Meagan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37854911: {
    id: "item_33266",
    "Last Name": "Fuller",
    "First Name": "Jay",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37854924: {
    id: "item_8148",
    "Last Name": "Petrie",
    "First Name": "Drew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37855235: {
    id: "item_20935",
    "Last Name": "Ivastanin",
    "First Name": "Nevena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37855516: {
    id: "item_8812",
    "Last Name": "Thornton",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37856037: {
    id: "item_31616",
    "Last Name": "Pal",
    "First Name": "Jatinder",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37856096: {
    id: "item_20931",
    "Last Name": "Fox-Allan",
    "First Name": "Rufus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37856241: {
    id: "item_33257",
    "Last Name": "YOUNG CHEE CHEONG",
    "First Name": "PATRICK",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37856633: {
    id: "item_31612",
    "Last Name": "Asad",
    "First Name": "Azhana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37856821: {
    id: "item_31610",
    "Last Name": "Joffe",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37856958: {
    id: "item_33255",
    "Last Name": "Harris",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857021: {
    id: "item_20925",
    "Last Name": "Faust",
    "First Name": "Leopold",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857025: {
    id: "item_20927",
    "Last Name": "Chakrabarty",
    "First Name": "Devam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857075: {
    id: "item_8140",
    "Last Name": "Kappeyne",
    "First Name": "Allison",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857120: {
    id: "item_31609",
    "Last Name": "Dixon",
    "First Name": "Elle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857169: {
    id: "item_20923",
    "Last Name": "Dixon",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857190: {
    id: "item_8139",
    "Last Name": "Lee",
    "First Name": "Johnston",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857224: {
    id: "item_20921",
    "Last Name": "Cury Neto",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857462: {
    id: "item_31607",
    "Last Name": "Lua",
    "First Name": "Marc Joshua",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857523: {
    id: "item_8134",
    "Last Name": "Beckett",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857531: {
    id: "item_20919",
    "Last Name": "Chau",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857576: {
    id: "item_20917",
    "Last Name": "Mai",
    "First Name": "Thu Le",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857589: {
    id: "item_33900",
    "Last Name": "Bleckmann",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37857996: {
    id: "item_19297",
    "Last Name": "Molnar",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37858061: {
    id: "item_33249",
    "Last Name": "Andreacchio",
    "First Name": "Carlo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37858066: {
    id: "item_33248",
    "Last Name": "Goodwin",
    "First Name": "Stacey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37858083: {
    id: "item_33247",
    "Last Name": "Goodwin",
    "First Name": "Carley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37858133: {
    id: "item_5800",
    "Last Name": "LEE",
    "First Name": "SHIUBIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37858942: {
    id: "item_20907",
    "Last Name": "Hosking",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37859099: {
    id: "item_33244",
    "Last Name": "Walters",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37859144: {
    id: "item_19296",
    "Last Name": "TANG",
    "First Name": "GUICHENG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37859145: {
    id: "item_33243",
    "Last Name": "O'Reilly",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37859330: {
    id: "item_8125",
    "Last Name": "Wong",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37859534: {
    id: "item_20902",
    "Last Name": "Wingate",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37859645: {
    id: "item_33242",
    "Last Name": "Janitz",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37859679: {
    id: "item_20901",
    "Last Name": "Dulevski",
    "First Name": "Alannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37859792: {
    id: "item_31595",
    "Last Name": "Cheng",
    "First Name": "Linus",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37860050: {
    id: "item_20898",
    "Last Name": "Stockham",
    "First Name": "Jessie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37860090: {
    id: "item_33241",
    "Last Name": "Grange",
    "First Name": "Christiopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37860189: {
    id: "item_33240",
    "Last Name": "Petrovski",
    "First Name": "Vesna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37860733: {
    id: "item_33237",
    "Last Name": "Shetty",
    "First Name": "Sanjana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37861336: {
    id: "item_8112",
    "Last Name": "Amderson-Carter",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37861373: {
    id: "item_31586",
    "Last Name": "Shibu",
    "First Name": "Vimal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37861731: {
    id: "item_8110",
    "Last Name": "Brooks",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37861792: {
    id: "item_8109",
    "Last Name": "Walter",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37861917: {
    id: "item_5797",
    "Last Name": "Keska",
    "First Name": "Anna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862264: {
    id: "item_8107",
    "Last Name": "Oman",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862315: {
    id: "item_20884",
    "Last Name": "Gavin",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862405: {
    id: "item_20885",
    "Last Name": "Briscoe",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862451: {
    id: "item_20882",
    "Last Name": "Graham",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862542: {
    id: "item_8103",
    "Last Name": "De Riter",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862557: {
    id: "item_33226",
    "Last Name": "Lion",
    "First Name": "Linda Darlene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862566: {
    id: "item_31583",
    "Last Name": "Peters",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862772: {
    id: "item_31580",
    "Last Name": "Hennings",
    "First Name": "Judith",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862884: {
    id: "item_31578",
    "Last Name": "Buckley",
    "First Name": "Anika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862905: {
    id: "item_20878",
    "Last Name": "O'Kane",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37862994: {
    id: "item_20877",
    "Last Name": "Chew",
    "First Name": "Seth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37863246: {
    id: "item_31573",
    "Last Name": "Ryu",
    "First Name": "Pureun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37863420: {
    id: "item_31571",
    "Last Name": "Park",
    "First Name": "Chonggil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37863726: {
    id: "item_8098",
    "Last Name": "Fenwick",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37863742: {
    id: "item_33219",
    "Last Name": "Lewis",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37863775: {
    id: "item_31568",
    "Last Name": "Brticevich",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37864020: {
    id: "item_33216",
    "Last Name": "Liu",
    "First Name": "Yu-Chia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37864067: {
    id: "item_33214",
    "Last Name": "Yen",
    "First Name": "Hsuan-Yu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37864372: {
    id: "item_31564",
    "Last Name": "Woo",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37864392: {
    id: "item_33209",
    "Last Name": "Antoniol",
    "First Name": "Aurelie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37864429: {
    id: "item_8088",
    "Last Name": "winterton",
    "First Name": "olivia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37864699: {
    id: "item_31560",
    "Last Name": "Appelgren",
    "First Name": "Tereanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37864816: {
    id: "item_8084",
    "Last Name": "Rossi",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37865031: {
    id: "item_33205",
    "Last Name": "Juan",
    "First Name": "Cierra Care",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37865359: {
    id: "item_31554",
    "Last Name": "Garcia",
    "First Name": "Flo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37865392: {
    id: "item_33201",
    "Last Name": "Srithong",
    "First Name": "Jomkwan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37865519: {
    id: "item_19295",
    "Last Name": "Ma",
    "First Name": "Stanley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37865814: {
    id: "item_20854",
    "Last Name": "Giurastante",
    "First Name": "Kerryn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37865847: {
    id: "item_33199",
    "Last Name": "Thongthew",
    "First Name": "Paewalin Pakkanaphong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866013: {
    id: "item_33198",
    "Last Name": "Rice",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866322: {
    id: "item_20848",
    "Last Name": "Chan",
    "First Name": "Man Kwong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866326: {
    id: "item_8071",
    "Last Name": "CHOU",
    "First Name": "WAN LING",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866352: {
    id: "item_6474",
    "Last Name": "WU",
    "First Name": "YONG ZHAO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866365: {
    id: "item_20847",
    "Last Name": "Tengco",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866477: {
    id: "item_31551",
    "Last Name": "Levitzke",
    "First Name": "Gus",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866546: {
    id: "item_33195",
    "Last Name": "Jin",
    "First Name": "Yanting",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866744: {
    id: "item_8840",
    "Last Name": "Jaquez",
    "First Name": "Angelica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866771: {
    id: "item_33194",
    "Last Name": "Gelwicks",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37866854: {
    id: "item_19294",
    "Last Name": "Kim",
    "First Name": "Seongjune",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37867376: {
    id: "item_8839",
    "Last Name": "Kuo",
    "First Name": "Chun Yi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37867400: {
    id: "item_31547",
    "Last Name": "McAuley",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37867633: {
    id: "item_33190",
    "Last Name": "Stampa",
    "First Name": "Ewa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37867657: {
    id: "item_8066",
    "Last Name": "Lin",
    "First Name": "Yu Wen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37867966: {
    id: "item_6473",
    "Last Name": "Laowiwatwong",
    "First Name": "Kongkij",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37868062: {
    id: "item_20844",
    "Last Name": "Rini",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37868116: {
    id: "item_31544",
    "Last Name": "Rich",
    "First Name": "Trisha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37868151: {
    id: "item_20842",
    "Last Name": "Clarke",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37869005: {
    id: "item_8063",
    "Last Name": "Zakrzewicz",
    "First Name": "Marcin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37869751: {
    id: "item_33899",
    "Last Name": "Gurovich",
    "First Name": "Yamila",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37870431: {
    id: "item_33185",
    "Last Name": "Gomez",
    "First Name": "Luz Elena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37870620: {
    id: "item_33184",
    "Last Name": "Walsh",
    "First Name": "Maryann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37870660: {
    id: "item_8062",
    "Last Name": "Antignani",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37870671: {
    id: "item_8060",
    "Last Name": "Cameron",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37870701: {
    id: "item_33182",
    "Last Name": "Bernardo",
    "First Name": "Pietro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37870961: {
    id: "item_5792",
    "Last Name": "Tan",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37871613: {
    id: "item_8056",
    "Last Name": "O'Brien",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37871885: {
    id: "item_19293",
    "Last Name": "Lee",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37871906: {
    id: "item_33180",
    "Last Name": "Natour",
    "First Name": "Hana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37872135: {
    id: "item_6518",
    "Last Name": "Derevyanko",
    "First Name": "Oksana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37872231: {
    id: "item_33179",
    "Last Name": "Wood",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37872477: {
    id: "item_31538",
    "Last Name": "Rodda",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37872519: {
    id: "item_8051",
    "Last Name": "Sy Peng",
    "First Name": "Queenie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37872542: {
    id: "item_20830",
    "Last Name": "Morrow",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37872637: {
    id: "item_20829",
    "Last Name": "Hale",
    "First Name": "Declan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37872907: {
    id: "item_20827",
    "Last Name": "Allan-Pearce",
    "First Name": "Rory",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37872982: {
    id: "item_8047",
    "Last Name": "Harper",
    "First Name": "Baron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37873030: {
    id: "item_33177",
    "Last Name": "PANTOJA",
    "First Name": "VIBERLYN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37873056: {
    id: "item_21383",
    "Last Name": "Jendrek",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37873058: {
    id: "item_31536",
    "Last Name": "Whealing",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37873242: {
    id: "item_8046",
    "Last Name": "van Adelsberg",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37873381: {
    id: "item_33176",
    "Last Name": "Jin",
    "First Name": "Shuting",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37873699: {
    id: "item_31531",
    "Last Name": "Stewart",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37874010: {
    id: "item_20820",
    "Last Name": "Hannah",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37874296: {
    id: "item_8040",
    "Last Name": "Koplan",
    "First Name": "Ali",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37874799: {
    id: "item_33172",
    "Last Name": "Terry",
    "First Name": "Tamsyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37874862: {
    id: "item_33898",
    "Last Name": "Tabili",
    "First Name": "Tom",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37875091: {
    id: "item_33171",
    "Last Name": "Murphy",
    "First Name": "Tenysha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37875181: {
    id: "item_8838",
    "Last Name": "Cora Decunto",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37875253: {
    id: "item_20810",
    "Last Name": "Walker",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37875479: {
    id: "item_33170",
    "Last Name": "So",
    "First Name": "Chun Wing",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37875490: {
    id: "item_31528",
    "Last Name": "Jimenez",
    "First Name": "Francia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37875562: {
    id: "item_20806",
    "Last Name": "Jennings",
    "First Name": "Liza",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37875722: {
    id: "item_31526",
    "Last Name": "Nazari",
    "First Name": "Suhil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37876146: {
    id: "item_31524",
    "Last Name": "Bond",
    "First Name": "Lorraine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37876168: {
    id: "item_32185",
    "Last Name": "Przybyciel",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37876604: {
    id: "item_33167",
    "Last Name": "Williams",
    "First Name": "Lily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37877700: {
    id: "item_31522",
    "Last Name": "Barbera-Felter",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37877786: {
    id: "item_33159",
    "Last Name": "Au Yeung",
    "First Name": "Pik Man",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37878021: {
    id: "item_31520",
    "Last Name": "Tuntitaveevorakul",
    "First Name": "Surat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37878562: {
    id: "item_20800",
    "Last Name": "Leung",
    "First Name": "Lilian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37878847: {
    id: "item_20797",
    "Last Name": "McCabe",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37879349: {
    id: "item_33897",
    "Last Name": "Yulhardi",
    "First Name": "Falah Fakhriyah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37879465: {
    id: "item_20794",
    "Last Name": "Theodoris",
    "First Name": "Marina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37880026: {
    id: "item_31515",
    "Last Name": "Chen",
    "First Name": "Ya Wei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37880033: {
    id: "item_31514",
    "Last Name": "Wong",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37880130: {
    id: "item_33154",
    "Last Name": "LAWLER",
    "First Name": "MICHAEL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37880697: {
    id: "item_8026",
    "Last Name": "Phillips",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37880704: {
    id: "item_31508",
    "Last Name": "Lambert",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37880749: {
    id: "item_6517",
    "Last Name": "WONG",
    "First Name": "Wing ho",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881138: {
    id: "item_8023",
    "Last Name": "van der Genugten",
    "First Name": "Renate",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881390: {
    id: "item_20784",
    "Last Name": "Ashton",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881486: {
    id: "item_5788",
    "Last Name": "Borrillo",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881539: {
    id: "item_20780",
    "Last Name": "Fassot",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881613: {
    id: "item_31506",
    "Last Name": "Pratama",
    "First Name": "Ardiya Bimaputra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881737: {
    id: "item_8021",
    "Last Name": "Ahmed",
    "First Name": "Khoula",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881764: {
    id: "item_8020",
    "Last Name": "Hirayama",
    "First Name": "Akari",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881765: {
    id: "item_31503",
    "Last Name": "Tan",
    "First Name": "Jinng Hwee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881872: {
    id: "item_20779",
    "Last Name": "James",
    "First Name": "Abigail Jesse",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37881922: {
    id: "item_31501",
    "Last Name": "Toscano Grijalba",
    "First Name": "Anthony Emilio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37882275: {
    id: "item_33146",
    "Last Name": "Lauman",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37882336: {
    id: "item_31499",
    "Last Name": "JEONG",
    "First Name": "MIHEE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37882347: {
    id: "item_20775",
    "Last Name": "Brydges",
    "First Name": "Neil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37882554: {
    id: "item_33144",
    "Last Name": "Yang",
    "First Name": "Hung-Chiang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37882617: {
    id: "item_31497",
    "Last Name": "Oh",
    "First Name": "Wan Qian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37882645: {
    id: "item_20772",
    "Last Name": "Choi",
    "First Name": "Hiu Tung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37882677: {
    id: "item_8011",
    "Last Name": "Howard",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37882998: {
    id: "item_6516",
    "Last Name": "Jordan",
    "First Name": "Dale",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883070: {
    id: "item_31494",
    "Last Name": "Cook",
    "First Name": "Pam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883191: {
    id: "item_33140",
    "Last Name": "CONSUELO",
    "First Name": "ANA MARIA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883234: {
    id: "item_33139",
    "Last Name": "Ho",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883315: {
    id: "item_20769",
    "Last Name": "Comafay",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883351: {
    id: "item_8005",
    "Last Name": "Haeusler",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883353: {
    id: "item_33138",
    "Last Name": "Thorburn",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883431: {
    id: "item_20767",
    "Last Name": "Hogben",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883600: {
    id: "item_33134",
    "Last Name": "Basyal",
    "First Name": "Laxman",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883628: {
    id: "item_7999",
    "Last Name": "garcia ciruelos",
    "First Name": "joan maties",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883658: {
    id: "item_32184",
    "Last Name": "Renard",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883715: {
    id: "item_33133",
    "Last Name": "Wind",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883737: {
    id: "item_33132",
    "Last Name": "Mao",
    "First Name": "Yuxiao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883809: {
    id: "item_33130",
    "Last Name": "Yonezawa",
    "First Name": "Itsumi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883903: {
    id: "item_19292",
    "Last Name": "Ji Ji",
    "First Name": "Chia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37883969: {
    id: "item_33127",
    "Last Name": "Ho",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884020: {
    id: "item_33126",
    "Last Name": "Uraichuen",
    "First Name": "Chinapa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884112: {
    id: "item_31484",
    "Last Name": "Chen",
    "First Name": "Lei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884183: {
    id: "item_31483",
    "Last Name": "Setiawati",
    "First Name": "Novi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884209: {
    id: "item_31482",
    "Last Name": "Thompson",
    "First Name": "Ingrid",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884229: {
    id: "item_31481",
    "Last Name": "Widodo",
    "First Name": "Wahyu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884280: {
    id: "item_7989",
    "Last Name": "Gnanasambandapillai",
    "First Name": "Vikkitharan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884380: {
    id: "item_33124",
    "Last Name": "Ng",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884413: {
    id: "item_33121",
    "Last Name": "Vesper",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884418: {
    id: "item_20753",
    "Last Name": "Campbell",
    "First Name": "Bronwen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884447: {
    id: "item_31478",
    "Last Name": "Lennon",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  37884500: {
    id: "item_7986",
    "Last Name": "Szymanski",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38210777: {
    id: "item_18901",
    "Last Name": "Jebulan",
    "First Name": "Katlyn Kaye",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211147: {
    id: "item_18902",
    "Last Name": "Wilson",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211552: {
    id: "item_18903",
    "Last Name": "Rogers",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211567: {
    id: "item_18907",
    "Last Name": "Parker",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211573: {
    id: "item_18909",
    "Last Name": "Ward",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211580: {
    id: "item_18904",
    "Last Name": "Snell",
    "First Name": "Olive",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211586: {
    id: "item_8724",
    "Last Name": "Anderson",
    "First Name": "Levi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211590: {
    id: "item_6276",
    "Last Name": "Ferrier",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211596: {
    id: "item_32103",
    "Last Name": "General",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211604: {
    id: "item_8725",
    "Last Name": "Bragg",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211605: {
    id: "item_6277",
    "Last Name": "Butler",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211607: {
    id: "item_18908",
    "Last Name": "Dowie",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211612: {
    id: "item_6282",
    "Last Name": "Fagot",
    "First Name": "Pierre-Loup",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211615: {
    id: "item_8726",
    "Last Name": "Gale",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211616: {
    id: "item_18906",
    "Last Name": "Piper",
    "First Name": "Noah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211617: {
    id: "item_18905",
    "Last Name": "Harrison",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211620: {
    id: "item_8727",
    "Last Name": "Wong",
    "First Name": "Sheng Wei",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211627: {
    id: "item_6278",
    "Last Name": "Jenkins",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211632: {
    id: "item_32104",
    "Last Name": "House",
    "First Name": "Natalie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211638: {
    id: "item_6279",
    "Last Name": "Caruso",
    "First Name": "Chanel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211656: {
    id: "item_8728",
    "Last Name": "Kelly",
    "First Name": "Brigid",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211657: {
    id: "item_6281",
    "Last Name": "Finnigan",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211670: {
    id: "item_6286",
    "Last Name": "Tabifranca",
    "First Name": "Karl",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211672: {
    id: "item_18911",
    "Last Name": "Naseby",
    "First Name": "Abby",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211673: {
    id: "item_8729",
    "Last Name": "Sharma",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211679: {
    id: "item_6280",
    "Last Name": "Hyslop",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211685: {
    id: "item_18910",
    "Last Name": "Anders",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211687: {
    id: "item_32105",
    "Last Name": "Metusela",
    "First Name": "Elenoa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211688: {
    id: "item_33754",
    "Last Name": "Cooper",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211696: {
    id: "item_33755",
    "Last Name": "Sinclair",
    "First Name": "Jane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211702: {
    id: "item_21325",
    "Last Name": "Dorman",
    "First Name": "Leticia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211706: {
    id: "item_32106",
    "Last Name": "Makepeace Smith",
    "First Name": "Alice",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211710: {
    id: "item_18920",
    "Last Name": "Pich",
    "First Name": "Eileen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211716: {
    id: "item_8731",
    "Last Name": "Anderson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211718: {
    id: "item_18913",
    "Last Name": "Reeves",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211729: {
    id: "item_21326",
    "Last Name": "Monahan",
    "First Name": "Eire",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211734: {
    id: "item_6285",
    "Last Name": "Auld",
    "First Name": "Reyne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211741: {
    id: "item_8730",
    "Last Name": "Mobbs",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211743: {
    id: "item_6284",
    "Last Name": "Pattinson-Green",
    "First Name": "Tobias",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211744: {
    id: "item_6283",
    "Last Name": "Thompson",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211745: {
    id: "item_18912",
    "Last Name": "Nalen",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211752: {
    id: "item_18917",
    "Last Name": "Dunlay",
    "First Name": "Juliette",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211758: {
    id: "item_6287",
    "Last Name": "Kennedy",
    "First Name": "Louisa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211760: {
    id: "item_18914",
    "Last Name": "Carroll",
    "First Name": "Harriet",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211761: {
    id: "item_32107",
    "Last Name": "Giles",
    "First Name": "Brenda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211765: {
    id: "item_18915",
    "Last Name": "Boymal",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211770: {
    id: "item_33761",
    "Last Name": "Lee",
    "First Name": "Augustine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211779: {
    id: "item_18918",
    "Last Name": "Mairs",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211785: {
    id: "item_21327",
    "Last Name": "Popperwell",
    "First Name": "Jenna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211791: {
    id: "item_18916",
    "Last Name": "Franzone",
    "First Name": "Rob",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211798: {
    id: "item_33756",
    "Last Name": "Viena",
    "First Name": "Merian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211803: {
    id: "item_33757",
    "Last Name": "Wilson",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211807: {
    id: "item_21329",
    "Last Name": "Saraisuwan",
    "First Name": "Krist",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211808: {
    id: "item_18919",
    "Last Name": "Binion",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211810: {
    id: "item_18921",
    "Last Name": "Balog",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211815: {
    id: "item_8732",
    "Last Name": "Le",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211823: {
    id: "item_6289",
    "Last Name": "Hosking",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211824: {
    id: "item_6293",
    "Last Name": "Sharvin",
    "First Name": "Alan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211825: {
    id: "item_8733",
    "Last Name": "Nguyen",
    "First Name": "Linda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211834: {
    id: "item_18923",
    "Last Name": "Burke",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211837: {
    id: "item_21328",
    "Last Name": "Roe Banks",
    "First Name": "Jye",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211842: {
    id: "item_18922",
    "Last Name": "Tahir",
    "First Name": "Arsalan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211845: {
    id: "item_21330",
    "Last Name": "lim",
    "First Name": "jongsu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211849: {
    id: "item_6290",
    "Last Name": "Nicholls",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211851: {
    id: "item_21331",
    "Last Name": "Prendergast",
    "First Name": "Clare",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211855: {
    id: "item_18926",
    "Last Name": "Alessio",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211856: {
    id: "item_18933",
    "Last Name": "David",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211858: {
    id: "item_8734",
    "Last Name": "Johnston",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211864: {
    id: "item_18927",
    "Last Name": "Lee",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211865: {
    id: "item_18929",
    "Last Name": "Salvatucci",
    "First Name": "Ruben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211876: {
    id: "item_6288",
    "Last Name": "Gann",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211882: {
    id: "item_18925",
    "Last Name": "Baumgarten",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211883: {
    id: "item_18924",
    "Last Name": "Diacek",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211891: {
    id: "item_32108",
    "Last Name": "Maiden",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211892: {
    id: "item_6295",
    "Last Name": "McManus",
    "First Name": "Connor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211894: {
    id: "item_18928",
    "Last Name": "Akkartal",
    "First Name": "Esin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211897: {
    id: "item_18931",
    "Last Name": "Clark",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211901: {
    id: "item_18932",
    "Last Name": "Sajche",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211908: {
    id: "item_6292",
    "Last Name": "White",
    "First Name": "Harvey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211918: {
    id: "item_18930",
    "Last Name": "Burdett",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211925: {
    id: "item_33763",
    "Last Name": "Putorak",
    "First Name": "Reece",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211926: {
    id: "item_18941",
    "Last Name": "Nurahman",
    "First Name": "Dikkk",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211928: {
    id: "item_18934",
    "Last Name": "Cudia",
    "First Name": "Kim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211932: {
    id: "item_18935",
    "Last Name": "Daligdig",
    "First Name": "Merbs",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211936: {
    id: "item_32109",
    "Last Name": "Sekar",
    "First Name": "Hari prasaath",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211937: {
    id: "item_6303",
    "Last Name": "Soar",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211939: {
    id: "item_21332",
    "Last Name": "Casey",
    "First Name": "Isabella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211944: {
    id: "item_18940",
    "Last Name": "Griffin",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211945: {
    id: "item_33759",
    "Last Name": "Fierro",
    "First Name": "Arturo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211946: {
    id: "item_6291",
    "Last Name": "Green",
    "First Name": "Gemma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211948: {
    id: "item_18937",
    "Last Name": "LIN",
    "First Name": "CHE YU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211960: {
    id: "item_18936",
    "Last Name": "Mason",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211967: {
    id: "item_18938",
    "Last Name": "Huang",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211970: {
    id: "item_33760",
    "Last Name": "Rizal",
    "First Name": "Donna Rose",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211971: {
    id: "item_33758",
    "Last Name": "Trinca",
    "First Name": "Melanie Anne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211974: {
    id: "item_8735",
    "Last Name": "Carey",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211982: {
    id: "item_18943",
    "Last Name": "Crakanthorp",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211987: {
    id: "item_18942",
    "Last Name": "Smith",
    "First Name": "Cj",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38211998: {
    id: "item_21333",
    "Last Name": "Wicks",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212000: {
    id: "item_18939",
    "Last Name": "Carroll",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212007: {
    id: "item_33762",
    "Last Name": "Bryant",
    "First Name": "Anselle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212011: {
    id: "item_21335",
    "Last Name": "Zhou",
    "First Name": "Jinhong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212012: {
    id: "item_6294",
    "Last Name": "Grosch",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212025: {
    id: "item_21334",
    "Last Name": "Hillman",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212026: {
    id: "item_6300",
    "Last Name": "Schupina",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212029: {
    id: "item_6299",
    "Last Name": "Holland",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212030: {
    id: "item_32110",
    "Last Name": "Barry",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212033: {
    id: "item_6304",
    "Last Name": "Bowker",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212034: {
    id: "item_6296",
    "Last Name": "Gittins",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212043: {
    id: "item_18944",
    "Last Name": "Farrell",
    "First Name": "Jarrett",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212054: {
    id: "item_18946",
    "Last Name": "OÕDonohue",
    "First Name": "Kara Jayde",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212057: {
    id: "item_6297",
    "Last Name": "Wang",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212064: {
    id: "item_6298",
    "Last Name": "Woo",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212067: {
    id: "item_6301",
    "Last Name": "Rajah",
    "First Name": "Logan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212068: {
    id: "item_18948",
    "Last Name": "Rezende Junior",
    "First Name": "Sergio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212074: {
    id: "item_21337",
    "Last Name": "Vollans",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212076: {
    id: "item_6302",
    "Last Name": "Bookallil",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212081: {
    id: "item_6305",
    "Last Name": "Roger",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212087: {
    id: "item_18945",
    "Last Name": "PENNINGTON",
    "First Name": "JAKOB",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212091: {
    id: "item_18947",
    "Last Name": "Mesoga",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212098: {
    id: "item_8741",
    "Last Name": "Zhang",
    "First Name": "Yudong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212100: {
    id: "item_21336",
    "Last Name": "Wood",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212109: {
    id: "item_6309",
    "Last Name": "Howarth",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212110: {
    id: "item_32111",
    "Last Name": "Yuen",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212112: {
    id: "item_18952",
    "Last Name": "HU",
    "First Name": "Panfeng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212114: {
    id: "item_6312",
    "Last Name": "Wajzer",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212118: {
    id: "item_6308",
    "Last Name": "Alcantara",
    "First Name": "Wolfgang Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212121: {
    id: "item_6306",
    "Last Name": "OÕBryan",
    "First Name": "Erin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212122: {
    id: "item_32112",
    "Last Name": "Chapman",
    "First Name": "Lynda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212124: {
    id: "item_33764",
    "Last Name": "Tagarino",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212128: {
    id: "item_6307",
    "Last Name": "neira",
    "First Name": "christian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212135: {
    id: "item_6315",
    "Last Name": "Papageorgiou",
    "First Name": "Johnny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212137: {
    id: "item_21338",
    "Last Name": "Heggs",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212142: {
    id: "item_18950",
    "Last Name": "Montenegro",
    "First Name": "Barone",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212152: {
    id: "item_6314",
    "Last Name": "Fenby",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212153: {
    id: "item_6313",
    "Last Name": "Sexton",
    "First Name": "Eimear",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212159: {
    id: "item_6310",
    "Last Name": "QIAN",
    "First Name": "YIHAOJIE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212164: {
    id: "item_18949",
    "Last Name": "Mc Govern",
    "First Name": "Kesley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212167: {
    id: "item_6311",
    "Last Name": "Thorpe",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212171: {
    id: "item_33765",
    "Last Name": "Khoo",
    "First Name": "Jasmine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212173: {
    id: "item_32114",
    "Last Name": "Astria",
    "First Name": "Riendy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212174: {
    id: "item_32113",
    "Last Name": "HILLSTEAD",
    "First Name": "RYAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212177: {
    id: "item_18951",
    "Last Name": "Turvill",
    "First Name": "Alana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212195: {
    id: "item_21339",
    "Last Name": "Tiberio",
    "First Name": "Acelyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212203: {
    id: "item_18954",
    "Last Name": "Hallam",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212215: {
    id: "item_6316",
    "Last Name": "YANG",
    "First Name": "SZU YU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212217: {
    id: "item_18953",
    "Last Name": "Brotchie",
    "First Name": "Eleanore",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212224: {
    id: "item_6317",
    "Last Name": "Ibrahim",
    "First Name": "Abdufatah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212225: {
    id: "item_8736",
    "Last Name": "Partridge",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212233: {
    id: "item_6318",
    "Last Name": "McCormick",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212247: {
    id: "item_18957",
    "Last Name": "Camacho Jara",
    "First Name": "Yael Adrian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212262: {
    id: "item_6319",
    "Last Name": "Van Schaik",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212279: {
    id: "item_33766",
    "Last Name": "MacLaughlin",
    "First Name": "Sinead",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212282: {
    id: "item_8737",
    "Last Name": "Veitch",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212285: {
    id: "item_18955",
    "Last Name": "Davis",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212293: {
    id: "item_18961",
    "Last Name": "Varapodio",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212304: {
    id: "item_18964",
    "Last Name": "Nockles",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212307: {
    id: "item_18956",
    "Last Name": "Veal",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212309: {
    id: "item_21340",
    "Last Name": "Casson",
    "First Name": "Giulia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212310: {
    id: "item_18960",
    "Last Name": "Spaulding",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212323: {
    id: "item_33767",
    "Last Name": "Tran Minh Thanh",
    "First Name": "Thao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212324: {
    id: "item_18962",
    "Last Name": "Guerron",
    "First Name": "Ana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212344: {
    id: "item_8738",
    "Last Name": "Barringer",
    "First Name": "Dane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212346: {
    id: "item_18959",
    "Last Name": "Hill",
    "First Name": "Shahida",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212366: {
    id: "item_18958",
    "Last Name": "Such",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212368: {
    id: "item_6320",
    "Last Name": "Hepburn",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212370: {
    id: "item_33768",
    "Last Name": "McCormack",
    "First Name": "Sasha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212376: {
    id: "item_32116",
    "Last Name": "Widjaja",
    "First Name": "Airin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212383: {
    id: "item_18968",
    "Last Name": "Gesite",
    "First Name": "Emy Anne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212384: {
    id: "item_8739",
    "Last Name": "Siems",
    "First Name": "Henry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212387: {
    id: "item_8740",
    "Last Name": "Yasay",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212393: {
    id: "item_6321",
    "Last Name": "Broun",
    "First Name": "Ellary",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212394: {
    id: "item_33769",
    "Last Name": "Choo",
    "First Name": "Yin Fatt",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212398: {
    id: "item_32115",
    "Last Name": "Tsai",
    "First Name": "Pei Ru",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212411: {
    id: "item_18963",
    "Last Name": "Zhang",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212413: {
    id: "item_18970",
    "Last Name": "Chan",
    "First Name": "Sidney",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212415: {
    id: "item_6322",
    "Last Name": "De Visser",
    "First Name": "Todd",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212416: {
    id: "item_18967",
    "Last Name": "Lee",
    "First Name": "Vivian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212421: {
    id: "item_18966",
    "Last Name": "Verrel",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212423: {
    id: "item_18965",
    "Last Name": "Ovung",
    "First Name": "Ron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212434: {
    id: "item_33771",
    "Last Name": "Mabunda",
    "First Name": "Thembi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212436: {
    id: "item_33772",
    "Last Name": "Liu",
    "First Name": "Ruijun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212448: {
    id: "item_6326",
    "Last Name": "Guzman",
    "First Name": "Arnold",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212480: {
    id: "item_18973",
    "Last Name": "Cruz Torres",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212481: {
    id: "item_18969",
    "Last Name": "Davidson",
    "First Name": "Jared",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212488: {
    id: "item_32117",
    "Last Name": "Douglas",
    "First Name": "Josephine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212492: {
    id: "item_18971",
    "Last Name": "Sng",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212497: {
    id: "item_33770",
    "Last Name": "Dunphy",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212517: {
    id: "item_32118",
    "Last Name": "McKenzie",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212531: {
    id: "item_18974",
    "Last Name": "Kime",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212536: {
    id: "item_21341",
    "Last Name": "Day",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212545: {
    id: "item_18972",
    "Last Name": "Conway",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212554: {
    id: "item_6323",
    "Last Name": "Hogan",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212564: {
    id: "item_6324",
    "Last Name": "Bannon",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212584: {
    id: "item_8742",
    "Last Name": "Zanatta",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212586: {
    id: "item_6325",
    "Last Name": "Dao",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212587: {
    id: "item_21342",
    "Last Name": "Warwick",
    "First Name": "Abbey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212608: {
    id: "item_18975",
    "Last Name": "Peake",
    "First Name": "Miriam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212614: {
    id: "item_18976",
    "Last Name": "Gung",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212632: {
    id: "item_6327",
    "Last Name": "Habib",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212633: {
    id: "item_18977",
    "Last Name": "Nguyen",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212647: {
    id: "item_6328",
    "Last Name": "toma",
    "First Name": "keini",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212675: {
    id: "item_33773",
    "Last Name": "Layco",
    "First Name": "Marites",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212677: {
    id: "item_18978",
    "Last Name": "Bueso",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212694: {
    id: "item_18982",
    "Last Name": "Delaney",
    "First Name": "genevieve86@hotmail.co.uk",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212707: {
    id: "item_18979",
    "Last Name": "Crisafi",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212709: {
    id: "item_18981",
    "Last Name": "Mesa Parra",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212719: {
    id: "item_6332",
    "Last Name": "Boyle",
    "First Name": "Ebony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212740: {
    id: "item_33774",
    "Last Name": "Quijano",
    "First Name": "Omar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212744: {
    id: "item_18980",
    "Last Name": "Palaypayon",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212746: {
    id: "item_6329",
    "Last Name": "Robinson",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212753: {
    id: "item_6330",
    "Last Name": "Lin",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212761: {
    id: "item_33775",
    "Last Name": "Yao",
    "First Name": "Tung-Yun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212777: {
    id: "item_6331",
    "Last Name": "Banks",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212788: {
    id: "item_32119",
    "Last Name": "MILLAR",
    "First Name": "NICOLE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212790: {
    id: "item_6335",
    "Last Name": "Trenowden",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212793: {
    id: "item_18997",
    "Last Name": "Hargreaves",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212797: {
    id: "item_8743",
    "Last Name": "Fraser",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212801: {
    id: "item_18984",
    "Last Name": "Stone",
    "First Name": "Braydon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212809: {
    id: "item_18983",
    "Last Name": "Lewis",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212816: {
    id: "item_18985",
    "Last Name": "Baranoff",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212820: {
    id: "item_21343",
    "Last Name": "Lee",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212837: {
    id: "item_18987",
    "Last Name": "Timmins",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212855: {
    id: "item_18986",
    "Last Name": "Cheung",
    "First Name": "Kin Hing Kevin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38212940: {
    id: "item_6333",
    "Last Name": "Mackenzie",
    "First Name": "Katie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213022: {
    id: "item_6334",
    "Last Name": "Loades",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213034: {
    id: "item_6336",
    "Last Name": "Tirado Mancilla",
    "First Name": "Alfonso",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213051: {
    id: "item_8745",
    "Last Name": "PRATHEEPNAMPAPHON",
    "First Name": "KAMON",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213056: {
    id: "item_18989",
    "Last Name": "Mcadam",
    "First Name": "Kira",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213057: {
    id: "item_8744",
    "Last Name": "Ngoo",
    "First Name": "Hui Le",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213058: {
    id: "item_33776",
    "Last Name": "Davies",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213062: {
    id: "item_18988",
    "Last Name": "Delgado Cuenca",
    "First Name": "Angie Vanessa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213069: {
    id: "item_33777",
    "Last Name": "kim",
    "First Name": "dahye",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213087: {
    id: "item_18990",
    "Last Name": "Freeman",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213092: {
    id: "item_8748",
    "Last Name": "Edgar",
    "First Name": "Ash",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213100: {
    id: "item_33778",
    "Last Name": "Manaclay",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213109: {
    id: "item_18991",
    "Last Name": "Meadows",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213116: {
    id: "item_8747",
    "Last Name": "Pacheco",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213118: {
    id: "item_8746",
    "Last Name": "Santos",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213151: {
    id: "item_18992",
    "Last Name": "McArdle",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213152: {
    id: "item_32120",
    "Last Name": "Osborne",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213153: {
    id: "item_33780",
    "Last Name": "Cassidy",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213164: {
    id: "item_32121",
    "Last Name": "Ding",
    "First Name": "Duo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213167: {
    id: "item_18994",
    "Last Name": "Kho",
    "First Name": "Jangelo Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213168: {
    id: "item_6337",
    "Last Name": "Male",
    "First Name": "Evan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213171: {
    id: "item_6340",
    "Last Name": "Barr",
    "First Name": "Shane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213174: {
    id: "item_6338",
    "Last Name": "Puspitasari",
    "First Name": "Dea",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213183: {
    id: "item_18993",
    "Last Name": "Thuemala",
    "First Name": "Tawadchai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213210: {
    id: "item_6341",
    "Last Name": "Rooney",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213229: {
    id: "item_33779",
    "Last Name": "cortez",
    "First Name": "jason",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213244: {
    id: "item_33781",
    "Last Name": "Bristow",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213274: {
    id: "item_6350",
    "Last Name": "zhang",
    "First Name": "yifan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213291: {
    id: "item_18995",
    "Last Name": "Chung",
    "First Name": "Hea Eun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213292: {
    id: "item_33782",
    "Last Name": "Liao",
    "First Name": "Qingting",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213295: {
    id: "item_6339",
    "Last Name": "Cash",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213312: {
    id: "item_32126",
    "Last Name": "Crequer",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213327: {
    id: "item_18996",
    "Last Name": "Ngo",
    "First Name": "Jefferson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213341: {
    id: "item_18998",
    "Last Name": "Cheffirs",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213515: {
    id: "item_18999",
    "Last Name": "Chang",
    "First Name": "Taison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213529: {
    id: "item_19000",
    "Last Name": "Wu",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213531: {
    id: "item_33783",
    "Last Name": "Schneider",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213543: {
    id: "item_8749",
    "Last Name": "Emmerig",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213546: {
    id: "item_32123",
    "Last Name": "FRASER",
    "First Name": "DANIELLE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213556: {
    id: "item_19001",
    "Last Name": "Saffioti",
    "First Name": "Emiliana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213561: {
    id: "item_19002",
    "Last Name": "Ang",
    "First Name": "Kin Hoe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213569: {
    id: "item_32124",
    "Last Name": "Poke",
    "First Name": "Nada",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213576: {
    id: "item_19004",
    "Last Name": "Molloy",
    "First Name": "Eanna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213577: {
    id: "item_6342",
    "Last Name": "Gordon",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213585: {
    id: "item_21344",
    "Last Name": "Chow",
    "First Name": "Kai Hau",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213590: {
    id: "item_32122",
    "Last Name": "Tranquilino",
    "First Name": "John Robert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213591: {
    id: "item_6343",
    "Last Name": "Weston",
    "First Name": "Sharn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213593: {
    id: "item_19003",
    "Last Name": "Houghton",
    "First Name": "Archer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213595: {
    id: "item_33784",
    "Last Name": "Oliver",
    "First Name": "Fria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213600: {
    id: "item_19015",
    "Last Name": "Sudharma",
    "First Name": "SETIAWAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213613: {
    id: "item_19006",
    "Last Name": "Hassell",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213625: {
    id: "item_19005",
    "Last Name": "Clapton",
    "First Name": "Felicity",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213644: {
    id: "item_19007",
    "Last Name": "Bao",
    "First Name": "Mingqiu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213652: {
    id: "item_6344",
    "Last Name": "Lucas",
    "First Name": "Steve",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213660: {
    id: "item_19008",
    "Last Name": "De Paz",
    "First Name": "Patroys",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213664: {
    id: "item_19009",
    "Last Name": "Stepatschuk",
    "First Name": "Amber",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213666: {
    id: "item_6345",
    "Last Name": "Abrera",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213715: {
    id: "item_33785",
    "Last Name": "Refuerzo",
    "First Name": "Tisha Felliz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213716: {
    id: "item_19011",
    "Last Name": "Smith",
    "First Name": "Tyra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213720: {
    id: "item_19010",
    "Last Name": "Burgess",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213724: {
    id: "item_32125",
    "Last Name": "Aguilar",
    "First Name": "Homero",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213780: {
    id: "item_19012",
    "Last Name": "Khan",
    "First Name": "Qasim Ali",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213796: {
    id: "item_6346",
    "Last Name": "Johnson",
    "First Name": "Tane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213808: {
    id: "item_19013",
    "Last Name": "Cruden",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213830: {
    id: "item_19014",
    "Last Name": "Leeson",
    "First Name": "MacAlister",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213853: {
    id: "item_32127",
    "Last Name": "MacBean",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213854: {
    id: "item_6347",
    "Last Name": "Vautin",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213861: {
    id: "item_6348",
    "Last Name": "Bimarivo",
    "First Name": "Simond",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213878: {
    id: "item_19016",
    "Last Name": "Bell",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213882: {
    id: "item_8750",
    "Last Name": "Galpin",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213904: {
    id: "item_6349",
    "Last Name": "Manning",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213937: {
    id: "item_33787",
    "Last Name": "Correa",
    "First Name": "Marianna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213942: {
    id: "item_33786",
    "Last Name": "Tan",
    "First Name": "Poh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213954: {
    id: "item_19017",
    "Last Name": "Balandra",
    "First Name": "Rabbin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213958: {
    id: "item_19020",
    "Last Name": "Cherny",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213962: {
    id: "item_19019",
    "Last Name": "Heim",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213984: {
    id: "item_19018",
    "Last Name": "White",
    "First Name": "Alfred",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38213990: {
    id: "item_6351",
    "Last Name": "Dino",
    "First Name": "Armand",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214073: {
    id: "item_8751",
    "Last Name": "Wulff",
    "First Name": "Helmut",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214096: {
    id: "item_6352",
    "Last Name": "Morgan",
    "First Name": "Sally",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214136: {
    id: "item_19021",
    "Last Name": "Webb",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214142: {
    id: "item_19024",
    "Last Name": "Malta",
    "First Name": "Tatiana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214156: {
    id: "item_19022",
    "Last Name": "Buenaflor",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214162: {
    id: "item_8752",
    "Last Name": "Mackay",
    "First Name": "Callan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214193: {
    id: "item_19028",
    "Last Name": "Perez",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214223: {
    id: "item_19023",
    "Last Name": "Halbert",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214230: {
    id: "item_19027",
    "Last Name": "Button",
    "First Name": "Annabelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214232: {
    id: "item_8753",
    "Last Name": "Gallagher",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214245: {
    id: "item_8754",
    "Last Name": "Mawn",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214276: {
    id: "item_19025",
    "Last Name": "Lechminka",
    "First Name": "Alana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214280: {
    id: "item_19026",
    "Last Name": "Messer",
    "First Name": "Katie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214285: {
    id: "item_19029",
    "Last Name": "San Jose",
    "First Name": "Argell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214287: {
    id: "item_21346",
    "Last Name": "Aparo",
    "First Name": "Bridgette",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214290: {
    id: "item_21345",
    "Last Name": "Bonafont",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214291: {
    id: "item_6353",
    "Last Name": "Eveans",
    "First Name": "Lucinda Grace",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214333: {
    id: "item_19030",
    "Last Name": "Katte",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214337: {
    id: "item_32129",
    "Last Name": "Miller",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214351: {
    id: "item_32128",
    "Last Name": "Dolman",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214355: {
    id: "item_32130",
    "Last Name": "Chairunnisa",
    "First Name": "Salwa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214370: {
    id: "item_19031",
    "Last Name": "Khoo",
    "First Name": "Aleney",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214377: {
    id: "item_6356",
    "Last Name": "Williams",
    "First Name": "Guy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214380: {
    id: "item_19032",
    "Last Name": "Tanzil",
    "First Name": "Sanny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214386: {
    id: "item_8755",
    "Last Name": "Rondon Lopez",
    "First Name": "Cristian Camilo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214391: {
    id: "item_6354",
    "Last Name": "Steckoll",
    "First Name": "Ricci",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214421: {
    id: "item_19033",
    "Last Name": "OÕSullivan",
    "First Name": "Shayne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214424: {
    id: "item_19035",
    "Last Name": "Webster",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214434: {
    id: "item_32131",
    "Last Name": "Walter",
    "First Name": "Josh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214436: {
    id: "item_19034",
    "Last Name": "McClelland",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214448: {
    id: "item_19036",
    "Last Name": "Gutte",
    "First Name": "Phulchand",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214452: {
    id: "item_33788",
    "Last Name": "nicol",
    "First Name": "jonathan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214465: {
    id: "item_33789",
    "Last Name": "Newell",
    "First Name": "Blake",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214469: {
    id: "item_32132",
    "Last Name": "Jones",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214472: {
    id: "item_21347",
    "Last Name": "Ledon",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214483: {
    id: "item_6355",
    "Last Name": "Toohey",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214533: {
    id: "item_33791",
    "Last Name": "Lin",
    "First Name": "Chuang-Hwa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214586: {
    id: "item_6357",
    "Last Name": "Johnson",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214588: {
    id: "item_33790",
    "Last Name": "Young",
    "First Name": "Yoko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214592: {
    id: "item_19038",
    "Last Name": "Isnuriantin",
    "First Name": "Isnuriantin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214593: {
    id: "item_19037",
    "Last Name": "Kapdi",
    "First Name": "Aneesa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214600: {
    id: "item_6359",
    "Last Name": "Silisilon",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214606: {
    id: "item_19040",
    "Last Name": "Lumanog",
    "First Name": "Juanita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214636: {
    id: "item_6360",
    "Last Name": "Ballarin",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214644: {
    id: "item_6358",
    "Last Name": "Mangiapane",
    "First Name": "Damion",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214688: {
    id: "item_19039",
    "Last Name": "Parsons",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214693: {
    id: "item_19042",
    "Last Name": "Williams",
    "First Name": "Bailey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214696: {
    id: "item_19041",
    "Last Name": "Barac",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214714: {
    id: "item_8756",
    "Last Name": "Iorio",
    "First Name": "Yineska",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214774: {
    id: "item_19043",
    "Last Name": "Cotter",
    "First Name": "Jordie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214779: {
    id: "item_6361",
    "Last Name": "Ruge",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214806: {
    id: "item_19045",
    "Last Name": "Maude",
    "First Name": "Jill",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214823: {
    id: "item_19044",
    "Last Name": "Marchett",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214825: {
    id: "item_6362",
    "Last Name": "Woon",
    "First Name": "Thian Main",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214847: {
    id: "item_19046",
    "Last Name": "Ramage",
    "First Name": "Ailsa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214852: {
    id: "item_19047",
    "Last Name": "Nguyen",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214863: {
    id: "item_19048",
    "Last Name": "Leng",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214880: {
    id: "item_19049",
    "Last Name": "Creaven",
    "First Name": "Marcella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214884: {
    id: "item_32133",
    "Last Name": "kim",
    "First Name": "seulgi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214944: {
    id: "item_6363",
    "Last Name": "Peniche",
    "First Name": "Lorena",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214958: {
    id: "item_33792",
    "Last Name": "Lee",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214985: {
    id: "item_32134",
    "Last Name": "Rose",
    "First Name": "Bronwyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38214987: {
    id: "item_19050",
    "Last Name": "Abuova",
    "First Name": "Kamilya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215000: {
    id: "item_6364",
    "Last Name": "Eitel",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215003: {
    id: "item_21349",
    "Last Name": "Bernstein",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215009: {
    id: "item_32136",
    "Last Name": "Ellis",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215014: {
    id: "item_32138",
    "Last Name": "Menhart",
    "First Name": "Nikolett",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215021: {
    id: "item_32135",
    "Last Name": "SAMSON",
    "First Name": "MICHELLEANN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215036: {
    id: "item_32137",
    "Last Name": "White",
    "First Name": "Emilie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215044: {
    id: "item_21348",
    "Last Name": "Young",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215100: {
    id: "item_19051",
    "Last Name": "BARKER",
    "First Name": "JAYMEN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215111: {
    id: "item_33793",
    "Last Name": "Psyhogios",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215125: {
    id: "item_6365",
    "Last Name": "Sokol",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215172: {
    id: "item_19052",
    "Last Name": "Slater",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215188: {
    id: "item_33794",
    "Last Name": "Mortero",
    "First Name": "Czarina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215209: {
    id: "item_6366",
    "Last Name": "Woodgate",
    "First Name": "Fred",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215214: {
    id: "item_19053",
    "Last Name": "O'Brien",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215218: {
    id: "item_33795",
    "Last Name": "Leung",
    "First Name": "Gary",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215219: {
    id: "item_6368",
    "Last Name": "Morris",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215221: {
    id: "item_19055",
    "Last Name": "Cullen",
    "First Name": "Elise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215230: {
    id: "item_19054",
    "Last Name": "Haggerty",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215233: {
    id: "item_19056",
    "Last Name": "Dougan",
    "First Name": "Ross",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215248: {
    id: "item_6367",
    "Last Name": "Satterthwaite",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215284: {
    id: "item_19057",
    "Last Name": "Porto",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215306: {
    id: "item_19058",
    "Last Name": "De Paz",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215307: {
    id: "item_6369",
    "Last Name": "Brady",
    "First Name": "Mckenzie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215313: {
    id: "item_6373",
    "Last Name": "CHUO",
    "First Name": "King Juin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215318: {
    id: "item_33796",
    "Last Name": "Balanzario",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215389: {
    id: "item_8757",
    "Last Name": "Orr",
    "First Name": "Bronwyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215434: {
    id: "item_6370",
    "Last Name": "Owen",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215453: {
    id: "item_6371",
    "Last Name": "Phoamus",
    "First Name": "Albert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215468: {
    id: "item_19059",
    "Last Name": "Yamada",
    "First Name": "Hiroshi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215506: {
    id: "item_19060",
    "Last Name": "Allen",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215531: {
    id: "item_19061",
    "Last Name": "Olmeda",
    "First Name": "Mariana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215563: {
    id: "item_19063",
    "Last Name": "nandidarbha",
    "First Name": "phongsira",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215571: {
    id: "item_6372",
    "Last Name": "Pernet",
    "First Name": "Florian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215597: {
    id: "item_19062",
    "Last Name": "Chin",
    "First Name": "Miew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215620: {
    id: "item_33797",
    "Last Name": "Tantono",
    "First Name": "Evan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215648: {
    id: "item_19064",
    "Last Name": "Mackevicius",
    "First Name": "Eva",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215679: {
    id: "item_21350",
    "Last Name": "Hernandez",
    "First Name": "Emiliano",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215721: {
    id: "item_19065",
    "Last Name": "Kerr",
    "First Name": "Liana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215733: {
    id: "item_19066",
    "Last Name": "Everett",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215734: {
    id: "item_8758",
    "Last Name": "Hugo",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215742: {
    id: "item_32139",
    "Last Name": "Tresnasari",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215768: {
    id: "item_8759",
    "Last Name": "Grennan",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215782: {
    id: "item_6374",
    "Last Name": "Iesalnieks",
    "First Name": "Augusts",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215800: {
    id: "item_21351",
    "Last Name": "Burrows",
    "First Name": "Crofton",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215821: {
    id: "item_19067",
    "Last Name": "Griffin",
    "First Name": "Nicci",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215879: {
    id: "item_32140",
    "Last Name": "Cross",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215882: {
    id: "item_6375",
    "Last Name": "Vink",
    "First Name": "Louise",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215908: {
    id: "item_8760",
    "Last Name": "Vigil",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215940: {
    id: "item_33798",
    "Last Name": "Wibowo",
    "First Name": "Dhanny Christian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215957: {
    id: "item_6376",
    "Last Name": "Leong",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215959: {
    id: "item_6377",
    "Last Name": "Wright",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215970: {
    id: "item_19068",
    "Last Name": "Duke",
    "First Name": "Shirlee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215987: {
    id: "item_32141",
    "Last Name": "Mullan",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215988: {
    id: "item_19069",
    "Last Name": "Cohen",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38215989: {
    id: "item_33799",
    "Last Name": "Dibben",
    "First Name": "Ailsa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216005: {
    id: "item_6378",
    "Last Name": "Tran",
    "First Name": "Graham",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216184: {
    id: "item_33800",
    "Last Name": "Dimanarig",
    "First Name": "Shane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216202: {
    id: "item_19070",
    "Last Name": "Kulkarni",
    "First Name": "Vallabh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216224: {
    id: "item_19072",
    "Last Name": "Wang",
    "First Name": "Sheng hsiung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216225: {
    id: "item_19071",
    "Last Name": "Garrett",
    "First Name": "Tausha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216253: {
    id: "item_32142",
    "Last Name": "Ye",
    "First Name": "Tingyu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216258: {
    id: "item_8761",
    "Last Name": "Ward",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216308: {
    id: "item_6379",
    "Last Name": "Bird",
    "First Name": "Maisie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216399: {
    id: "item_6380",
    "Last Name": "Smith",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216406: {
    id: "item_19073",
    "Last Name": "Heffernan",
    "First Name": "Laurence",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216424: {
    id: "item_19074",
    "Last Name": "Preston",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216450: {
    id: "item_32143",
    "Last Name": "Fegcan",
    "First Name": "Nicole Agdisel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216456: {
    id: "item_19075",
    "Last Name": "O' Doherty",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216469: {
    id: "item_8762",
    "Last Name": "Chase",
    "First Name": "Mica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216484: {
    id: "item_8763",
    "Last Name": "Ahmad",
    "First Name": "Saiful Iswadi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216510: {
    id: "item_6381",
    "Last Name": "Catalano",
    "First Name": "Fedele",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216539: {
    id: "item_19076",
    "Last Name": "Petrovski",
    "First Name": "Alek",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216657: {
    id: "item_19077",
    "Last Name": "Axton",
    "First Name": "Megan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216675: {
    id: "item_19078",
    "Last Name": "BOONDEEKUN",
    "First Name": "KIMHAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216700: {
    id: "item_19079",
    "Last Name": "Huang",
    "First Name": "Ya Yi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216732: {
    id: "item_6382",
    "Last Name": "LIN",
    "First Name": "YI XING",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216841: {
    id: "item_21352",
    "Last Name": "Revell",
    "First Name": "Grace",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216919: {
    id: "item_33801",
    "Last Name": "Zaki",
    "First Name": "Mohammad Faza Ghani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216944: {
    id: "item_19080",
    "Last Name": "Calisto Ovalle",
    "First Name": "Macarena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38216961: {
    id: "item_8764",
    "Last Name": "John",
    "First Name": "Joshin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217001: {
    id: "item_19084",
    "Last Name": "Putra",
    "First Name": "Elga Fadhila",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217016: {
    id: "item_19081",
    "Last Name": "Kang",
    "First Name": "Che-Wei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217110: {
    id: "item_6383",
    "Last Name": "Farinazzo",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217133: {
    id: "item_19082",
    "Last Name": "S.",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217136: {
    id: "item_8765",
    "Last Name": "Delorme",
    "First Name": "Lucile",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217169: {
    id: "item_6384",
    "Last Name": "Correa Bernardo",
    "First Name": "Bruno",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217219: {
    id: "item_6385",
    "Last Name": "Su",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217328: {
    id: "item_19083",
    "Last Name": "Lambert",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217513: {
    id: "item_6388",
    "Last Name": "Dilley",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217522: {
    id: "item_19085",
    "Last Name": "Widjaja",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217538: {
    id: "item_6387",
    "Last Name": "hunt",
    "First Name": "emmalie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217553: {
    id: "item_6386",
    "Last Name": "Kajornrungsilp",
    "First Name": "Attasith",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217599: {
    id: "item_8766",
    "Last Name": "CHEN",
    "First Name": "PEI JUNG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217602: {
    id: "item_19087",
    "Last Name": "HSU",
    "First Name": "CHUNG EN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217622: {
    id: "item_19086",
    "Last Name": "Lawrence",
    "First Name": "Nick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217671: {
    id: "item_19088",
    "Last Name": "Locke",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217698: {
    id: "item_6389",
    "Last Name": "ANDERSON",
    "First Name": "EMILY",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217700: {
    id: "item_19089",
    "Last Name": "Godding",
    "First Name": "Lily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217769: {
    id: "item_32144",
    "Last Name": "Ramsay",
    "First Name": "Eliza",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217780: {
    id: "item_33802",
    "Last Name": "Cova",
    "First Name": "Engels",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217867: {
    id: "item_6390",
    "Last Name": "Sargent",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217912: {
    id: "item_8767",
    "Last Name": "Ghosh",
    "First Name": "Debabrata",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38217958: {
    id: "item_6391",
    "Last Name": "Hee",
    "First Name": "Chew Peng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218114: {
    id: "item_19090",
    "Last Name": "laurent",
    "First Name": "jeffry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218165: {
    id: "item_21353",
    "Last Name": "Quiambao",
    "First Name": "Paul Allyson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218172: {
    id: "item_19091",
    "Last Name": "lucarelli",
    "First Name": "madison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218188: {
    id: "item_19092",
    "Last Name": "O'Meara",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218206: {
    id: "item_33803",
    "Last Name": "ko",
    "First Name": "hyejin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218320: {
    id: "item_19093",
    "Last Name": "Weichselbaum",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218418: {
    id: "item_19094",
    "Last Name": "Tran",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218449: {
    id: "item_8768",
    "Last Name": "Dewi",
    "First Name": "Cindy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218484: {
    id: "item_19095",
    "Last Name": "Abrahams",
    "First Name": "Taj",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218517: {
    id: "item_19096",
    "Last Name": "Wiltshire",
    "First Name": "Madison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218519: {
    id: "item_19098",
    "Last Name": "Browell",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218535: {
    id: "item_6392",
    "Last Name": "Lee",
    "First Name": "Jisung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218621: {
    id: "item_19097",
    "Last Name": "Deighton",
    "First Name": "Sheyteika",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218727: {
    id: "item_6393",
    "Last Name": "Chin",
    "First Name": "Vivien",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218740: {
    id: "item_19100",
    "Last Name": "Waters",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218762: {
    id: "item_19099",
    "Last Name": "Ashton",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218901: {
    id: "item_32145",
    "Last Name": "Chick",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38218942: {
    id: "item_19101",
    "Last Name": "Kutliakova",
    "First Name": "Jana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219011: {
    id: "item_6394",
    "Last Name": "Fadil",
    "First Name": "Hadif",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219056: {
    id: "item_33804",
    "Last Name": "KAFFROWI",
    "First Name": "MUHADI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219137: {
    id: "item_6395",
    "Last Name": "Shickle",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219225: {
    id: "item_19102",
    "Last Name": "SALVI",
    "First Name": "KRANTI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219394: {
    id: "item_33805",
    "Last Name": "Sozio",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219447: {
    id: "item_19103",
    "Last Name": "Cromie",
    "First Name": "Ella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219460: {
    id: "item_6396",
    "Last Name": "King Cheng",
    "First Name": "Choy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219494: {
    id: "item_19104",
    "Last Name": "Yung",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219536: {
    id: "item_19105",
    "Last Name": "OÕBrien",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219550: {
    id: "item_19106",
    "Last Name": "Hunter",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219577: {
    id: "item_19109",
    "Last Name": "Handayani",
    "First Name": "Esty",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219665: {
    id: "item_33806",
    "Last Name": "Hazeldine Nardone",
    "First Name": "Julia Moana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219686: {
    id: "item_19107",
    "Last Name": "Rojas",
    "First Name": "Guillermo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219714: {
    id: "item_33807",
    "Last Name": "Tran",
    "First Name": "Vinson",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219727: {
    id: "item_8769",
    "Last Name": "Walker",
    "First Name": "Harriet",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219771: {
    id: "item_32146",
    "Last Name": "Gustiananda",
    "First Name": "Winda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219783: {
    id: "item_19108",
    "Last Name": "Januar",
    "First Name": "Budiyanto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219809: {
    id: "item_33808",
    "Last Name": "PUN",
    "First Name": "KAM CHUN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219874: {
    id: "item_33809",
    "Last Name": "Graham",
    "First Name": "Maddie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38219957: {
    id: "item_6397",
    "Last Name": "CHIU",
    "First Name": "KEHENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220040: {
    id: "item_33810",
    "Last Name": "Moore",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220123: {
    id: "item_8771",
    "Last Name": "Rinkin",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220156: {
    id: "item_8770",
    "Last Name": "Nairn",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220221: {
    id: "item_19110",
    "Last Name": "Chanda",
    "First Name": "Mithun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220239: {
    id: "item_33811",
    "Last Name": "Canecchia",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220261: {
    id: "item_8772",
    "Last Name": "Geerlings",
    "First Name": "Sonia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220269: {
    id: "item_19111",
    "Last Name": "O'Shannassy",
    "First Name": "Blake",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220298: {
    id: "item_19112",
    "Last Name": "Olsen",
    "First Name": "Mardi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220358: {
    id: "item_32147",
    "Last Name": "Phillips",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220377: {
    id: "item_33812",
    "Last Name": "Jones",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220401: {
    id: "item_33813",
    "Last Name": "Firdaus",
    "First Name": "Salsabil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220520: {
    id: "item_33814",
    "Last Name": "Dutkovich",
    "First Name": "Shamirah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220548: {
    id: "item_19113",
    "Last Name": "Whitford",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220569: {
    id: "item_19114",
    "Last Name": "Kownacki",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220577: {
    id: "item_19116",
    "Last Name": "Rijs",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220581: {
    id: "item_19115",
    "Last Name": "Rijs",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220619: {
    id: "item_6398",
    "Last Name": "Huynh",
    "First Name": "Terry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220631: {
    id: "item_33815",
    "Last Name": "McCormack",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220648: {
    id: "item_33816",
    "Last Name": "Marsden",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220656: {
    id: "item_19117",
    "Last Name": "Smith",
    "First Name": "Heather",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220658: {
    id: "item_6399",
    "Last Name": "Tabarez",
    "First Name": "Juan David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220680: {
    id: "item_19118",
    "Last Name": "Lawrence",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220702: {
    id: "item_32148",
    "Last Name": "Agrawal",
    "First Name": "Himanshu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220733: {
    id: "item_33817",
    "Last Name": "Chan",
    "First Name": "Kyna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220738: {
    id: "item_19119",
    "Last Name": "JŠgers",
    "First Name": "Bibi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220739: {
    id: "item_6400",
    "Last Name": "Paez",
    "First Name": "Victor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220753: {
    id: "item_8773",
    "Last Name": "Hunt",
    "First Name": "Greg",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220817: {
    id: "item_6401",
    "Last Name": "Grove",
    "First Name": "Finn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220867: {
    id: "item_6402",
    "Last Name": "Preston",
    "First Name": "Heath",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220889: {
    id: "item_19120",
    "Last Name": "Blunsdon",
    "First Name": "Jade",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220894: {
    id: "item_6403",
    "Last Name": "Bidanel",
    "First Name": "Ewen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220945: {
    id: "item_32149",
    "Last Name": "Chung",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220960: {
    id: "item_8774",
    "Last Name": "Markovski",
    "First Name": "Lou",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38220997: {
    id: "item_33818",
    "Last Name": "Thakur",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221010: {
    id: "item_8775",
    "Last Name": "Wharerau",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221034: {
    id: "item_6404",
    "Last Name": "Tan",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221084: {
    id: "item_8776",
    "Last Name": "Paulin",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221098: {
    id: "item_8777",
    "Last Name": "Lopez",
    "First Name": "Raymond John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221124: {
    id: "item_6405",
    "Last Name": "Duckworth",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221131: {
    id: "item_33819",
    "Last Name": "Pagotto",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221151: {
    id: "item_32152",
    "Last Name": "Rodriguez",
    "First Name": "Juan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221162: {
    id: "item_19121",
    "Last Name": "Tadjibaeva",
    "First Name": "Aynur",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221243: {
    id: "item_32151",
    "Last Name": "Silalahi",
    "First Name": "Doyan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221264: {
    id: "item_33820",
    "Last Name": "Nguyen",
    "First Name": "Le Thy Thao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221286: {
    id: "item_32150",
    "Last Name": "Fan",
    "First Name": "Ting Xuan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221387: {
    id: "item_19122",
    "Last Name": "Webb",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221414: {
    id: "item_19123",
    "Last Name": "Sanchez Barrero",
    "First Name": "Camilo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221424: {
    id: "item_19124",
    "Last Name": "Villanueva Valdez",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221437: {
    id: "item_6406",
    "Last Name": "Sheahan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221457: {
    id: "item_8778",
    "Last Name": "Selmes",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221472: {
    id: "item_19125",
    "Last Name": "Cheong Phey Denn",
    "First Name": "Peyton",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221497: {
    id: "item_19126",
    "Last Name": "Nuiphet",
    "First Name": "Anucha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221589: {
    id: "item_8779",
    "Last Name": "Martin",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221670: {
    id: "item_6408",
    "Last Name": "Bezett",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221679: {
    id: "item_6407",
    "Last Name": "Morev",
    "First Name": "Oleg",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221703: {
    id: "item_8780",
    "Last Name": "Gietman",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221754: {
    id: "item_33821",
    "Last Name": "Eveleigh",
    "First Name": "Casey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221803: {
    id: "item_19127",
    "Last Name": "KIM",
    "First Name": "YUNJIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221804: {
    id: "item_21354",
    "Last Name": "Sevilla",
    "First Name": "Yuliana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221808: {
    id: "item_8781",
    "Last Name": "Freeman",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221810: {
    id: "item_8782",
    "Last Name": "Hilcke",
    "First Name": "Zaine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221836: {
    id: "item_6409",
    "Last Name": "Caine",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221855: {
    id: "item_8783",
    "Last Name": "Zahr",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221860: {
    id: "item_33822",
    "Last Name": "Yakin",
    "First Name": "Mochamad Muldan Nurul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221871: {
    id: "item_6410",
    "Last Name": "Khunnen",
    "First Name": "Songrit",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221890: {
    id: "item_21355",
    "Last Name": "Shim",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221919: {
    id: "item_19128",
    "Last Name": "Yu",
    "First Name": "Yalin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38221976: {
    id: "item_32153",
    "Last Name": "Bonnette",
    "First Name": "Taryn Ann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222001: {
    id: "item_19129",
    "Last Name": "Elliott",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222028: {
    id: "item_8784",
    "Last Name": "Critchlow",
    "First Name": "Maddie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222087: {
    id: "item_19131",
    "Last Name": "Edmondson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222126: {
    id: "item_19130",
    "Last Name": "Orsman",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222152: {
    id: "item_19132",
    "Last Name": "Lee",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222154: {
    id: "item_33823",
    "Last Name": "Kusuma",
    "First Name": "Made Adhiguna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222178: {
    id: "item_8785",
    "Last Name": "Walker",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222181: {
    id: "item_19133",
    "Last Name": "Mantilla Gamarra",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222193: {
    id: "item_6411",
    "Last Name": "Callaghan",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222262: {
    id: "item_19134",
    "Last Name": "Dennis",
    "First Name": "Mary-Kate",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222289: {
    id: "item_19135",
    "Last Name": "Taylor",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222311: {
    id: "item_19137",
    "Last Name": "Clarete",
    "First Name": "Ernie Darwin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222321: {
    id: "item_33824",
    "Last Name": "Kutumbale",
    "First Name": "Leena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222326: {
    id: "item_19136",
    "Last Name": "ternent",
    "First Name": "geena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222365: {
    id: "item_19138",
    "Last Name": "Dulebenets",
    "First Name": "Nataliya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222379: {
    id: "item_6412",
    "Last Name": "Elmy",
    "First Name": "Kaine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222433: {
    id: "item_19139",
    "Last Name": "Hoyle",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222438: {
    id: "item_21356",
    "Last Name": "Prichard",
    "First Name": "Lexi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222445: {
    id: "item_33825",
    "Last Name": "Wheatley",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222473: {
    id: "item_33826",
    "Last Name": "Alejo",
    "First Name": "Johanna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222482: {
    id: "item_19140",
    "Last Name": "MORENO",
    "First Name": "RUBY ROSE FAITH",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222488: {
    id: "item_21357",
    "Last Name": "Pain",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222490: {
    id: "item_8786",
    "Last Name": "Grocke",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222495: {
    id: "item_8787",
    "Last Name": "Jones",
    "First Name": "Bethan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222501: {
    id: "item_6413",
    "Last Name": "Edwards",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222505: {
    id: "item_6414",
    "Last Name": "Cooper",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222507: {
    id: "item_21358",
    "Last Name": "Hurst",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222571: {
    id: "item_19141",
    "Last Name": "Browne",
    "First Name": "Aoife",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222641: {
    id: "item_6416",
    "Last Name": "Hsia",
    "First Name": "Shuo-Lin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222649: {
    id: "item_6415",
    "Last Name": "Tamayo",
    "First Name": "Juan pablo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222660: {
    id: "item_8788",
    "Last Name": "Khomiakova",
    "First Name": "Daria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222666: {
    id: "item_6417",
    "Last Name": "Colangelo",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222685: {
    id: "item_19142",
    "Last Name": "Anderson",
    "First Name": "Alessia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222702: {
    id: "item_19143",
    "Last Name": "Bentley",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222719: {
    id: "item_6418",
    "Last Name": "Wotherspoon",
    "First Name": "Mia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222781: {
    id: "item_19144",
    "Last Name": "Crawford",
    "First Name": "Darian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222822: {
    id: "item_19145",
    "Last Name": "Hussey",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222829: {
    id: "item_6419",
    "Last Name": "Sinclair",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222838: {
    id: "item_8789",
    "Last Name": "Chu",
    "First Name": "Po Yin Candy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222841: {
    id: "item_33827",
    "Last Name": "Farrer",
    "First Name": "Andy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222941: {
    id: "item_33828",
    "Last Name": "Chapman",
    "First Name": "Melinda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222972: {
    id: "item_32154",
    "Last Name": "Tang",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38222977: {
    id: "item_6420",
    "Last Name": "Royston",
    "First Name": "Toby",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223006: {
    id: "item_6421",
    "Last Name": "Bowden",
    "First Name": "Katelyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223019: {
    id: "item_19146",
    "Last Name": "Mistry",
    "First Name": "Kiran",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223085: {
    id: "item_33829",
    "Last Name": "O'Dwyer",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223104: {
    id: "item_6422",
    "Last Name": "Moors",
    "First Name": "Auben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223133: {
    id: "item_19147",
    "Last Name": "Browne",
    "First Name": "Lochlan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223165: {
    id: "item_19148",
    "Last Name": "Almeida",
    "First Name": "Inny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223173: {
    id: "item_6423",
    "Last Name": "Erlangga",
    "First Name": "Andi Muhammad Resa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223215: {
    id: "item_32155",
    "Last Name": "Tarakanova",
    "First Name": "Olga",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223230: {
    id: "item_19149",
    "Last Name": "Knopf",
    "First Name": "Kisani",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223243: {
    id: "item_8790",
    "Last Name": "Lam",
    "First Name": "Pui Long",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223284: {
    id: "item_8791",
    "Last Name": "Jenkins",
    "First Name": "Darryl",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223297: {
    id: "item_33830",
    "Last Name": "Pledge",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223307: {
    id: "item_19150",
    "Last Name": "Hennessy",
    "First Name": "Bronagh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223320: {
    id: "item_6424",
    "Last Name": "Lace",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223323: {
    id: "item_19151",
    "Last Name": "Baird",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223445: {
    id: "item_19152",
    "Last Name": "Hunhemluan",
    "First Name": "Suchada",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223462: {
    id: "item_33831",
    "Last Name": "Jones",
    "First Name": "Sherridan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223575: {
    id: "item_6425",
    "Last Name": "Faris",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223606: {
    id: "item_6426",
    "Last Name": "Chan",
    "First Name": "Henny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223643: {
    id: "item_6427",
    "Last Name": "McWhinney",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223648: {
    id: "item_6428",
    "Last Name": "Crowe",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223656: {
    id: "item_8792",
    "Last Name": "Keutzer",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223700: {
    id: "item_21359",
    "Last Name": "Harbar",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223712: {
    id: "item_33832",
    "Last Name": "Trisnayanti",
    "First Name": "Ni Putu Oka Mei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223738: {
    id: "item_33833",
    "Last Name": "EDELBAY",
    "First Name": "SANIYA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223765: {
    id: "item_6429",
    "Last Name": "Wilkes",
    "First Name": "Evan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223778: {
    id: "item_33834",
    "Last Name": "Timor",
    "First Name": "Aliffianti Bhara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223784: {
    id: "item_19153",
    "Last Name": "Wilkinson",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223831: {
    id: "item_19155",
    "Last Name": "Lagnada",
    "First Name": "Allen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223833: {
    id: "item_19154",
    "Last Name": "Herrera",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223969: {
    id: "item_6430",
    "Last Name": "Jakubiak",
    "First Name": "Zuzanna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223972: {
    id: "item_33835",
    "Last Name": "Worden",
    "First Name": "Rose",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223973: {
    id: "item_19156",
    "Last Name": "Leonaviciute",
    "First Name": "Brigita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223975: {
    id: "item_8793",
    "Last Name": "Green",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38223979: {
    id: "item_19157",
    "Last Name": "Markham",
    "First Name": "Rhona",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224029: {
    id: "item_19158",
    "Last Name": "Quane",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224061: {
    id: "item_8794",
    "Last Name": "Fedorina",
    "First Name": "Maria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224063: {
    id: "item_19159",
    "Last Name": "Harris",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224098: {
    id: "item_19160",
    "Last Name": "Shah",
    "First Name": "Deep",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224150: {
    id: "item_19161",
    "Last Name": "Coughlan",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224290: {
    id: "item_33836",
    "Last Name": "Omolon",
    "First Name": "Benedict Benz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224461: {
    id: "item_6431",
    "Last Name": "Lopez",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224469: {
    id: "item_21360",
    "Last Name": "Whittaker",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224495: {
    id: "item_6432",
    "Last Name": "Daza",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224506: {
    id: "item_19163",
    "Last Name": "Orlandi",
    "First Name": "JosŽ",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224511: {
    id: "item_19162",
    "Last Name": "Hernandez",
    "First Name": "Jenifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224648: {
    id: "item_19164",
    "Last Name": "Crocombe",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224652: {
    id: "item_21361",
    "Last Name": "Klein",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224697: {
    id: "item_6435",
    "Last Name": "Vieira Rodrigues",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224700: {
    id: "item_6433",
    "Last Name": "PARK",
    "First Name": "HANRIM",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224722: {
    id: "item_19165",
    "Last Name": "Gurung",
    "First Name": "Indra Bahadur",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224751: {
    id: "item_6434",
    "Last Name": "Benn",
    "First Name": "Aaidan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224805: {
    id: "item_19166",
    "Last Name": "Osborne",
    "First Name": "Jayde",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224823: {
    id: "item_33837",
    "Last Name": "Millan",
    "First Name": "Mark Francis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224916: {
    id: "item_32156",
    "Last Name": "LAW",
    "First Name": "WAI LUN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224924: {
    id: "item_21362",
    "Last Name": "Schawaller",
    "First Name": "Theo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38224987: {
    id: "item_6436",
    "Last Name": "Boubakir",
    "First Name": "Yasmine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225034: {
    id: "item_6437",
    "Last Name": "Phofu",
    "First Name": "Thabang Tony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225122: {
    id: "item_8795",
    "Last Name": "Wibowo",
    "First Name": "Jeffry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225222: {
    id: "item_19167",
    "Last Name": "Hall",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225236: {
    id: "item_21363",
    "Last Name": "Baptista",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225256: {
    id: "item_19168",
    "Last Name": "Toth",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225330: {
    id: "item_6438",
    "Last Name": "Nguyen",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225506: {
    id: "item_8796",
    "Last Name": "Tutill",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225584: {
    id: "item_6439",
    "Last Name": "Fung",
    "First Name": "Ching Cheung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225671: {
    id: "item_6440",
    "Last Name": "Chemakina",
    "First Name": "Anastasiia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225703: {
    id: "item_6441",
    "Last Name": "Katus",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38225955: {
    id: "item_19169",
    "Last Name": "Duncan",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38226004: {
    id: "item_19170",
    "Last Name": "MARCHESI",
    "First Name": "ARTURO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38226102: {
    id: "item_6442",
    "Last Name": "Putri",
    "First Name": "Aldila Ayudya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38226356: {
    id: "item_8797",
    "Last Name": "Sinagra",
    "First Name": "Maria Paola",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38226537: {
    id: "item_8798",
    "Last Name": "Gandara",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38226597: {
    id: "item_21364",
    "Last Name": "Coetzee",
    "First Name": "Bridget Jean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38226854: {
    id: "item_6443",
    "Last Name": "Limon villarreal",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38227069: {
    id: "item_33838",
    "Last Name": "Trivedi",
    "First Name": "Vidisha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38227092: {
    id: "item_19171",
    "Last Name": "Kastner",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38227289: {
    id: "item_6444",
    "Last Name": "Luna",
    "First Name": "Mariana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38227301: {
    id: "item_33839",
    "Last Name": "Jabal",
    "First Name": "Evan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38227635: {
    id: "item_6445",
    "Last Name": "Ceja Tamayo",
    "First Name": "Cesar Rafael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38228177: {
    id: "item_33840",
    "Last Name": "Olivia",
    "First Name": "Fenny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38228247: {
    id: "item_6446",
    "Last Name": "Park",
    "First Name": "Sangyoon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38228849: {
    id: "item_19172",
    "Last Name": "Santos",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38229428: {
    id: "item_19173",
    "Last Name": "Wilkinson",
    "First Name": "Maxine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38229774: {
    id: "item_19174",
    "Last Name": "Acosta Mora",
    "First Name": "Esteban Efrain",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38230075: {
    id: "item_19175",
    "Last Name": "Sabrina",
    "First Name": "Adinda Olivia Ryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38230962: {
    id: "item_19176",
    "Last Name": "Charrault",
    "First Name": "Arthur",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38231242: {
    id: "item_19177",
    "Last Name": "Badayos",
    "First Name": "Aiken Rey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38232130: {
    id: "item_33841",
    "Last Name": "Quarrell",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38232632: {
    id: "item_21365",
    "Last Name": "Ramos",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38233371: {
    id: "item_6448",
    "Last Name": "CORONADO",
    "First Name": "CƒSAR",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38233397: {
    id: "item_6447",
    "Last Name": "Kildea",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38233507: {
    id: "item_8799",
    "Last Name": "Williams",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38233588: {
    id: "item_19178",
    "Last Name": "dias",
    "First Name": "shenan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38234003: {
    id: "item_19179",
    "Last Name": "pique",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38234007: {
    id: "item_19180",
    "Last Name": "Oliveira Soens",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38234206: {
    id: "item_6449",
    "Last Name": "g mesquita",
    "First Name": "armando",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38234678: {
    id: "item_19181",
    "Last Name": "Sullivan",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38234939: {
    id: "item_19182",
    "Last Name": "Mooney",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38235009: {
    id: "item_19183",
    "Last Name": "Wagner",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38235098: {
    id: "item_6450",
    "Last Name": "Drummond",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38235122: {
    id: "item_6451",
    "Last Name": "Cabida",
    "First Name": "Rockie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38235976: {
    id: "item_6452",
    "Last Name": "Faria",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38236766: {
    id: "item_33842",
    "Last Name": "Soler",
    "First Name": "Francesca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38242323: {
    id: "item_19184",
    "Last Name": "Bradshaw",
    "First Name": "Phillip",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38243510: {
    id: "item_6453",
    "Last Name": "Sun",
    "First Name": "Chia-Hung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38243542: {
    id: "item_19185",
    "Last Name": "Burke",
    "First Name": "Waldo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38243837: {
    id: "item_19186",
    "Last Name": "Rukundu",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38248382: {
    id: "item_6454",
    "Last Name": "Barizo",
    "First Name": "Kimi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38248585: {
    id: "item_33843",
    "Last Name": "Hart",
    "First Name": "Martyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38248784: {
    id: "item_33844",
    "Last Name": "Patron",
    "First Name": "Khryss",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38248956: {
    id: "item_33845",
    "Last Name": "Suryanto",
    "First Name": "Aji",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38248987: {
    id: "item_19187",
    "Last Name": "Ramos",
    "First Name": "Leah Angela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38249438: {
    id: "item_6455",
    "Last Name": "Georgiadis",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38249476: {
    id: "item_8800",
    "Last Name": "howatson",
    "First Name": "jasmine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38249502: {
    id: "item_19188",
    "Last Name": "Paoli",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38249568: {
    id: "item_33847",
    "Last Name": "Cha",
    "First Name": "Yonghun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38249571: {
    id: "item_33846",
    "Last Name": "Jack",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38249580: {
    id: "item_8801",
    "Last Name": "Fielding",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38249835: {
    id: "item_19189",
    "Last Name": "duangdeethaweesap",
    "First Name": "chatthawut",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38250216: {
    id: "item_33848",
    "Last Name": "Taylor",
    "First Name": "Alexis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38250317: {
    id: "item_19190",
    "Last Name": "Lewis",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38250375: {
    id: "item_6456",
    "Last Name": "Spencer",
    "First Name": "Hayden",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38250448: {
    id: "item_19191",
    "Last Name": "Zhai",
    "First Name": "Waine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38250458: {
    id: "item_19192",
    "Last Name": "Fan",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38250715: {
    id: "item_8802",
    "Last Name": "Kaye",
    "First Name": "Hamish",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38250749: {
    id: "item_8803",
    "Last Name": "Jorge",
    "First Name": "Tania",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38250985: {
    id: "item_19193",
    "Last Name": "Zheng",
    "First Name": "Hao",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38251050: {
    id: "item_6457",
    "Last Name": "Archer",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38251055: {
    id: "item_8804",
    "Last Name": "Charlier",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38251683: {
    id: "item_33849",
    "Last Name": "Sandel",
    "First Name": "Mharjorie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38251790: {
    id: "item_6459",
    "Last Name": "Kipps",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38251870: {
    id: "item_6458",
    "Last Name": "Thompson",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38252002: {
    id: "item_6460",
    "Last Name": "Lee",
    "First Name": "Kia Liang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38252535: {
    id: "item_33850",
    "Last Name": "Godfrey",
    "First Name": "Ainsley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38252537: {
    id: "item_33851",
    "Last Name": "Man Tein",
    "First Name": "Tang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38252543: {
    id: "item_19194",
    "Last Name": "Le Dain",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38252765: {
    id: "item_33852",
    "Last Name": "Bamba",
    "First Name": "Maria Ni–afe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38252823: {
    id: "item_33853",
    "Last Name": "Trimarwanti",
    "First Name": "Rinny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38253331: {
    id: "item_33854",
    "Last Name": "Valentin",
    "First Name": "Samuel J",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38253333: {
    id: "item_6461",
    "Last Name": "Nicholls",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38253407: {
    id: "item_32157",
    "Last Name": "Figueroa",
    "First Name": "Diana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38253415: {
    id: "item_6462",
    "Last Name": "Kay",
    "First Name": "Noah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38253459: {
    id: "item_8805",
    "Last Name": "Swain",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38253483: {
    id: "item_8806",
    "Last Name": "Frost",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38254162: {
    id: "item_33855",
    "Last Name": "Oldham",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38254445: {
    id: "item_19195",
    "Last Name": "McGinn",
    "First Name": "Ciaran",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38254477: {
    id: "item_19196",
    "Last Name": "Cummins",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38254809: {
    id: "item_6463",
    "Last Name": "Mildrum",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38255007: {
    id: "item_6464",
    "Last Name": "Farrow",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38255306: {
    id: "item_33856",
    "Last Name": "Briggs",
    "First Name": "Shelby",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38255376: {
    id: "item_33857",
    "Last Name": "Armstrong",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38255963: {
    id: "item_8807",
    "Last Name": "orsini",
    "First Name": "Filippo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38256431: {
    id: "item_6465",
    "Last Name": "Featherstone",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38256773: {
    id: "item_19197",
    "Last Name": "Sinclair",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38256836: {
    id: "item_8808",
    "Last Name": "Dam",
    "First Name": "Tomas Norman",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38257081: {
    id: "item_19198",
    "Last Name": "Rosas",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38257090: {
    id: "item_19199",
    "Last Name": "Healy",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38257229: {
    id: "item_19200",
    "Last Name": "Dale",
    "First Name": "Eugenie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38257288: {
    id: "item_19201",
    "Last Name": "Jung",
    "First Name": "Heejeong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38257535: {
    id: "item_6466",
    "Last Name": "Pring",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38257756: {
    id: "item_33858",
    "Last Name": "Tangaraja",
    "First Name": "Darlene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38257806: {
    id: "item_19202",
    "Last Name": "Puerto",
    "First Name": "Fircie Grace gastardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38257955: {
    id: "item_6467",
    "Last Name": "Bihari",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38257971: {
    id: "item_21366",
    "Last Name": "Lipari",
    "First Name": "Marco",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38258044: {
    id: "item_19204",
    "Last Name": "Imlati",
    "First Name": "Imlati",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38258085: {
    id: "item_19203",
    "Last Name": "Gill",
    "First Name": "Russell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38258330: {
    id: "item_33859",
    "Last Name": "Takavarasha",
    "First Name": "Tabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38258356: {
    id: "item_19205",
    "Last Name": "Simpson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38258474: {
    id: "item_19206",
    "Last Name": "Allen",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38258519: {
    id: "item_6468",
    "Last Name": "Mitchell",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38258599: {
    id: "item_19207",
    "Last Name": "CHAE",
    "First Name": "Ohyoung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38258913: {
    id: "item_19208",
    "Last Name": "Jones",
    "First Name": "Tom",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38258951: {
    id: "item_6469",
    "Last Name": "ATCHESON",
    "First Name": "DONALD",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38259033: {
    id: "item_33860",
    "Last Name": "Huang",
    "First Name": "Pei-Ru",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38259140: {
    id: "item_6470",
    "Last Name": "Turner",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38259236: {
    id: "item_19209",
    "Last Name": "colinot",
    "First Name": "julien",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38259247: {
    id: "item_32158",
    "Last Name": "Sitorus",
    "First Name": "Ardjuna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38259401: {
    id: "item_33861",
    "Last Name": "Azhar",
    "First Name": "Nurul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38259644: {
    id: "item_33862",
    "Last Name": "Smithers",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38259645: {
    id: "item_21367",
    "Last Name": "Janah",
    "First Name": "Abdul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38259669: {
    id: "item_8809",
    "Last Name": "Chiu",
    "First Name": "Will",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38259957: {
    id: "item_19210",
    "Last Name": "Jiang",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38260207: {
    id: "item_33863",
    "Last Name": "Chong",
    "First Name": "Chin Man",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38261880: {
    id: "item_6471",
    "Last Name": "Toussaint",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38263300: {
    id: "item_8810",
    "Last Name": "li",
    "First Name": "Xiao",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38265345: {
    id: "item_19211",
    "Last Name": "Das",
    "First Name": "Nikunja",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38265517: {
    id: "item_8811",
    "Last Name": "Bright-Mortey",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38266285: {
    id: "item_33864",
    "Last Name": "Marshall",
    "First Name": "Luke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38266310: {
    id: "item_19212",
    "Last Name": "Lumsden",
    "First Name": "Ally",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38266360: {
    id: "item_6472",
    "Last Name": "Woodburn",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38269008: {
    id: "item_21373",
    "Last Name": "Newell",
    "First Name": "Marshall",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38269345: {
    id: "item_33875",
    "Last Name": "Morrison",
    "First Name": "Adele",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38270090: {
    id: "item_19230",
    "Last Name": "Snee",
    "First Name": "Evie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38270886: {
    id: "item_19231",
    "Last Name": "LAI",
    "First Name": "HSIN JOU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38273661: {
    id: "item_19232",
    "Last Name": "Ng",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38281671: {
    id: "item_6488",
    "Last Name": "Mitrovski",
    "First Name": "Goce",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38282078: {
    id: "item_19233",
    "Last Name": "Pineda",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38284238: {
    id: "item_33876",
    "Last Name": "van der Loos",
    "First Name": "Rosemary",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38285307: {
    id: "item_6489",
    "Last Name": "Choli",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38289349: {
    id: "item_21374",
    "Last Name": "Stuart",
    "First Name": "Jermaine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38294059: {
    id: "item_19234",
    "Last Name": "Alcazar",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38294271: {
    id: "item_6490",
    "Last Name": "blessing",
    "First Name": "oisin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38294629: {
    id: "item_19235",
    "Last Name": "Khamphengphet",
    "First Name": "Pat",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38295582: {
    id: "item_33877",
    "Last Name": "Adiao",
    "First Name": "Meg",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38296024: {
    id: "item_19236",
    "Last Name": "Levy",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38296108: {
    id: "item_6491",
    "Last Name": "Nguyen",
    "First Name": "Nga",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38296288: {
    id: "item_19237",
    "Last Name": "hutchings",
    "First Name": "marissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38296367: {
    id: "item_19238",
    "Last Name": "Brogan",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38296429: {
    id: "item_19239",
    "Last Name": "Leiva",
    "First Name": "Lucia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38296862: {
    id: "item_33878",
    "Last Name": "Laface",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38296908: {
    id: "item_6492",
    "Last Name": "Hoyos",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38298095: {
    id: "item_19240",
    "Last Name": "Webb",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38298152: {
    id: "item_32165",
    "Last Name": "Basha",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38299129: {
    id: "item_32166",
    "Last Name": "Falah",
    "First Name": "Yogi Mohamad",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38299758: {
    id: "item_32167",
    "Last Name": "NASUTION",
    "First Name": "Viga",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38300209: {
    id: "item_32168",
    "Last Name": "DWI KURNIAWAN",
    "First Name": "TEDDY",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38300641: {
    id: "item_19241",
    "Last Name": "Slattery",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38300664: {
    id: "item_32169",
    "Last Name": "Puzanova",
    "First Name": "Ekaterina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38300910: {
    id: "item_6493",
    "Last Name": "Coma",
    "First Name": "Laia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38300985: {
    id: "item_6494",
    "Last Name": "Tams",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38301247: {
    id: "item_21375",
    "Last Name": "Fearon",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38301798: {
    id: "item_32170",
    "Last Name": "Baker",
    "First Name": "Rawiri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38301834: {
    id: "item_6495",
    "Last Name": "TRACEY-SHAW",
    "First Name": "DEVLIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38301940: {
    id: "item_32171",
    "Last Name": "Fischer",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38301977: {
    id: "item_19242",
    "Last Name": "Acosta Figueroa",
    "First Name": "Esteban",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302408: {
    id: "item_21376",
    "Last Name": "Pleasants",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302418: {
    id: "item_19243",
    "Last Name": "Peethamparam",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302438: {
    id: "item_6496",
    "Last Name": "Leary",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302475: {
    id: "item_8829",
    "Last Name": "Webb",
    "First Name": "Danni",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302486: {
    id: "item_19245",
    "Last Name": "Batelaan",
    "First Name": "Stella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302500: {
    id: "item_19244",
    "Last Name": "Norris",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302513: {
    id: "item_19246",
    "Last Name": "Dunlay",
    "First Name": "Jak",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302551: {
    id: "item_19247",
    "Last Name": "Williams",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302568: {
    id: "item_33879",
    "Last Name": "Swift",
    "First Name": "Lily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302578: {
    id: "item_19248",
    "Last Name": "Tuipulotu",
    "First Name": "Lota",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302583: {
    id: "item_19249",
    "Last Name": "slattery",
    "First Name": "elouise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302608: {
    id: "item_19250",
    "Last Name": "Encio",
    "First Name": "Larry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302801: {
    id: "item_6497",
    "Last Name": "Chang",
    "First Name": "Chong liang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302859: {
    id: "item_19251",
    "Last Name": "Hansen",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302901: {
    id: "item_6498",
    "Last Name": "Haddrell",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302921: {
    id: "item_21377",
    "Last Name": "Gummakonda",
    "First Name": "Vinay Rama Reddy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38302949: {
    id: "item_33880",
    "Last Name": "Carthew",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303030: {
    id: "item_33881",
    "Last Name": "Farquhar",
    "First Name": "Susie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303058: {
    id: "item_33882",
    "Last Name": "Halim-Bender",
    "First Name": "Sari",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303110: {
    id: "item_21378",
    "Last Name": "Wachira",
    "First Name": "Amos",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303129: {
    id: "item_19252",
    "Last Name": "Fletcher",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303259: {
    id: "item_21379",
    "Last Name": "Giles",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303325: {
    id: "item_19253",
    "Last Name": "Batchelor",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303369: {
    id: "item_32172",
    "Last Name": "ung",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303380: {
    id: "item_6499",
    "Last Name": "Moncrieff",
    "First Name": "Kelvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303401: {
    id: "item_6500",
    "Last Name": "Lorigan",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303497: {
    id: "item_33883",
    "Last Name": "Sweeney Fawcett",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303504: {
    id: "item_19254",
    "Last Name": "Zanatta",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303570: {
    id: "item_19255",
    "Last Name": "Aman",
    "First Name": "Md Amanul Haque",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303722: {
    id: "item_19256",
    "Last Name": "Randall",
    "First Name": "Kristy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303740: {
    id: "item_33884",
    "Last Name": "Dumdum",
    "First Name": "Marjorie Gizelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303762: {
    id: "item_6501",
    "Last Name": "Robertson",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303825: {
    id: "item_19257",
    "Last Name": "Galagedara",
    "First Name": "Neraj",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303848: {
    id: "item_21380",
    "Last Name": "Mahon Helguero",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303925: {
    id: "item_6502",
    "Last Name": "SHAYO",
    "First Name": "PERFECT",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303952: {
    id: "item_21381",
    "Last Name": "Kovacs",
    "First Name": "Eszter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303984: {
    id: "item_19258",
    "Last Name": "Papalkar",
    "First Name": "Kale",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38303999: {
    id: "item_33885",
    "Last Name": "Kannike",
    "First Name": "Yewande",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304009: {
    id: "item_33886",
    "Last Name": "Cannon",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304044: {
    id: "item_19259",
    "Last Name": "OSUAGWU",
    "First Name": "STANLEY",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304056: {
    id: "item_19260",
    "Last Name": "Perkins",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304062: {
    id: "item_19261",
    "Last Name": "Evans",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304107: {
    id: "item_33887",
    "Last Name": "Ralph",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304160: {
    id: "item_19262",
    "Last Name": "Gallardo",
    "First Name": "Gene Carlo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304191: {
    id: "item_8830",
    "Last Name": "Alaimo",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304243: {
    id: "item_19263",
    "Last Name": "Sauturaga",
    "First Name": "Zac",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304565: {
    id: "item_32173",
    "Last Name": "Yoshihara",
    "First Name": "Kurumi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304680: {
    id: "item_19264",
    "Last Name": "Rolnik",
    "First Name": "Remigiusz",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304705: {
    id: "item_6503",
    "Last Name": "Rheinberger",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304720: {
    id: "item_6504",
    "Last Name": "Brown",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304822: {
    id: "item_19265",
    "Last Name": "Gonzales",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304885: {
    id: "item_19266",
    "Last Name": "Azzahra",
    "First Name": "Asihta Aulia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304950: {
    id: "item_33888",
    "Last Name": "de Guzman",
    "First Name": "Patricia Marebella",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38304974: {
    id: "item_33889",
    "Last Name": "Ekasari",
    "First Name": "Rita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38305240: {
    id: "item_19267",
    "Last Name": "Than",
    "First Name": "Nam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38305309: {
    id: "item_8831",
    "Last Name": "LAI LING",
    "First Name": "YEONG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38305375: {
    id: "item_33890",
    "Last Name": "Setiawan",
    "First Name": "Kurnia Kautsar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38305449: {
    id: "item_21382",
    "Last Name": "Amirova",
    "First Name": "Dayana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38305515: {
    id: "item_8832",
    "Last Name": "Woods",
    "First Name": "Ashley Elizabeth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38305536: {
    id: "item_19268",
    "Last Name": "Newbold",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38305538: {
    id: "item_33891",
    "Last Name": "Guleng",
    "First Name": "Jowena Zhen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38305813: {
    id: "item_33892",
    "Last Name": "Dumaran",
    "First Name": "Nedi Jessa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38305816: {
    id: "item_8833",
    "Last Name": "Zennaro",
    "First Name": "Hariette",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38306122: {
    id: "item_19269",
    "Last Name": "Gupta",
    "First Name": "Saksham",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38306247: {
    id: "item_19270",
    "Last Name": "Salem",
    "First Name": "Ailin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38306387: {
    id: "item_19271",
    "Last Name": "Butler",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38306516: {
    id: "item_33893",
    "Last Name": "Wibowo",
    "First Name": "Arie Satryo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38306714: {
    id: "item_32174",
    "Last Name": "Venkatesan",
    "First Name": "Vasi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38307297: {
    id: "item_32175",
    "Last Name": "Pg Md JaÕafar",
    "First Name": "Pg Aeddie Masjaffrie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38307441: {
    id: "item_6505",
    "Last Name": "PƒREZ DE LA ROSA",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38308313: {
    id: "item_6506",
    "Last Name": "Duisenbina",
    "First Name": "Togzhan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38308736: {
    id: "item_19272",
    "Last Name": "Moore",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38311224: {
    id: "item_6507",
    "Last Name": "Boda - Toth",
    "First Name": "Rolf",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38311829: {
    id: "item_19273",
    "Last Name": "Re",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38312222: {
    id: "item_19274",
    "Last Name": "Aljasmi",
    "First Name": "Adel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38314267: {
    id: "item_19275",
    "Last Name": "Zeng",
    "First Name": "Yunfeng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38314325: {
    id: "item_8834",
    "Last Name": "Davey",
    "First Name": "Brad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38314469: {
    id: "item_19276",
    "Last Name": "Tran",
    "First Name": "Henley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38320388: {
    id: "item_6508",
    "Last Name": "Malakhouskaya",
    "First Name": "Tatsiana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38324113: {
    id: "item_19277",
    "Last Name": "NATALI",
    "First Name": "CESAR",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38324201: {
    id: "item_32176",
    "Last Name": "Ortega",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38326518: {
    id: "item_32177",
    "Last Name": "Johnston",
    "First Name": "Cooper",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38326693: {
    id: "item_19278",
    "Last Name": "Robertson",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38327576: {
    id: "item_6509",
    "Last Name": "Wood",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38333928: {
    id: "item_19279",
    "Last Name": "James",
    "First Name": "Warwick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38337611: {
    id: "item_19280",
    "Last Name": "Donald",
    "First Name": "Charlene",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38337938: {
    id: "item_19281",
    "Last Name": "Bennett",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38338007: {
    id: "item_32178",
    "Last Name": "joanhan",
    "First Name": "andri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38338019: {
    id: "item_19282",
    "Last Name": "Daniels",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38338132: {
    id: "item_32179",
    "Last Name": "Rosy",
    "First Name": "Arif",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38338778: {
    id: "item_19283",
    "Last Name": "Klemke",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38339152: {
    id: "item_6510",
    "Last Name": "Mailing",
    "First Name": "Trent",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38339365: {
    id: "item_19284",
    "Last Name": "Noya",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38339728: {
    id: "item_32181",
    "Last Name": "Samar",
    "First Name": "Raul CZ Intan II",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38339730: {
    id: "item_19285",
    "Last Name": "Clements",
    "First Name": "Marlo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38339795: {
    id: "item_33894",
    "Last Name": "Mullins",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38339834: {
    id: "item_19286",
    "Last Name": "Caton",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38339871: {
    id: "item_32180",
    "Last Name": "Williams",
    "First Name": "Sonya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38340039: {
    id: "item_33895",
    "Last Name": "Buca-Salvador",
    "First Name": "Gladys",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38340265: {
    id: "item_19287",
    "Last Name": "Gumbo",
    "First Name": "Humphrey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38340319: {
    id: "item_6511",
    "Last Name": "Faulder",
    "First Name": "Seb",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38340330: {
    id: "item_6512",
    "Last Name": "Billings",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38340452: {
    id: "item_19288",
    "Last Name": "Setio",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38340592: {
    id: "item_8835",
    "Last Name": "Lampe",
    "First Name": "Owen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38340607: {
    id: "item_19289",
    "Last Name": "Morris",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38340765: {
    id: "item_32182",
    "Last Name": "esteban marin",
    "First Name": "ana maria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38340983: {
    id: "item_19290",
    "Last Name": "Bishop",
    "First Name": "Jonathon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38341169: {
    id: "item_6513",
    "Last Name": "Lewis",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38354352: {
    id: "item_6514",
    "Last Name": "Salazar",
    "First Name": "Braulio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38354427: {
    id: "item_33896",
    "Last Name": "Rahmanita",
    "First Name": "Hany",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38356636: {
    id: "item_6515",
    "Last Name": "AHMED",
    "First Name": "Hussain",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38402394: {
    id: "item_19291",
    "Last Name": "Morris",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38437693: {
    id: "item_8836",
    "Last Name": "Hepworth",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38459682: {
    id: "item_8837",
    "Last Name": "DUNKLEY",
    "First Name": "ROBERT",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38462880: {
    id: "item_32183",
    "Last Name": "BALISACAN",
    "First Name": "ARSENIO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38524143: {
    id: "item_19391",
    "Last Name": "Choo",
    "First Name": "Jian Won",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38528889: {
    id: "item_32242",
    "Last Name": "Lewis",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38528913: {
    id: "item_19392",
    "Last Name": "Tahir",
    "First Name": "Ima Aziz Widiasagita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38531111: {
    id: "item_19393",
    "Last Name": "O'Connor",
    "First Name": "Fletcher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38531468: {
    id: "item_19394",
    "Last Name": "Davies",
    "First Name": "Blair",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38531724: {
    id: "item_19395",
    "Last Name": "Alam",
    "First Name": "Azlan Shah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532096: {
    id: "item_6576",
    "Last Name": "Ford",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532187: {
    id: "item_19396",
    "Last Name": "Haynes",
    "First Name": "Darren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532353: {
    id: "item_19398",
    "Last Name": "Alexander",
    "First Name": "Jody-Ann",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532366: {
    id: "item_19397",
    "Last Name": "Ong",
    "First Name": "Leonard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532386: {
    id: "item_32243",
    "Last Name": "Mananov",
    "First Name": "Kirstie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532394: {
    id: "item_33941",
    "Last Name": "Baker",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532425: {
    id: "item_33942",
    "Last Name": "Lancaster",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532591: {
    id: "item_32244",
    "Last Name": "Osico",
    "First Name": "Michelle Ann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532684: {
    id: "item_6577",
    "Last Name": "Cluett",
    "First Name": "Dan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38532965: {
    id: "item_33943",
    "Last Name": "Tellei",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38533005: {
    id: "item_19399",
    "Last Name": "Chaplyhina",
    "First Name": "Yelyzaveta",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38533529: {
    id: "item_6578",
    "Last Name": "Stevenson",
    "First Name": "Zac",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38533603: {
    id: "item_19400",
    "Last Name": "Jose da Silva",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38533677: {
    id: "item_6579",
    "Last Name": "Brydon",
    "First Name": "Aida",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38533709: {
    id: "item_19401",
    "Last Name": "Dannock-Price",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38533862: {
    id: "item_32245",
    "Last Name": "Benedict",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38533958: {
    id: "item_32246",
    "Last Name": "Quach",
    "First Name": "Thanh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38534142: {
    id: "item_21403",
    "Last Name": "Denyer",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38534149: {
    id: "item_6580",
    "Last Name": "Alescio",
    "First Name": "Giuseppe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38534233: {
    id: "item_6581",
    "Last Name": "almutairi",
    "First Name": "mohammed",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38534479: {
    id: "item_19402",
    "Last Name": "Edwards-Smith",
    "First Name": "Holly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38534711: {
    id: "item_19403",
    "Last Name": "Lambourne",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38534840: {
    id: "item_33944",
    "Last Name": "Reyes",
    "First Name": "Maria Christina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38534842: {
    id: "item_19404",
    "Last Name": "Ingate",
    "First Name": "Amy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38535368: {
    id: "item_19405",
    "Last Name": "Lee",
    "First Name": "Duk",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38535715: {
    id: "item_6582",
    "Last Name": "Dinning",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38536144: {
    id: "item_6583",
    "Last Name": "Powell",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38536808: {
    id: "item_33945",
    "Last Name": "Carolina",
    "First Name": "Annisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38537015: {
    id: "item_33946",
    "Last Name": "ZHOU",
    "First Name": "JINGYI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38537375: {
    id: "item_19406",
    "Last Name": "George",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38537413: {
    id: "item_32247",
    "Last Name": "Yee",
    "First Name": "Sean Jiun Fa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38537551: {
    id: "item_32248",
    "Last Name": "KANG XI",
    "First Name": "WANG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38537586: {
    id: "item_33947",
    "Last Name": "Polii",
    "First Name": "Stefanus Dolfi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38537630: {
    id: "item_19407",
    "Last Name": "Smalley",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38537634: {
    id: "item_8884",
    "Last Name": "Moody",
    "First Name": "Tyson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38537946: {
    id: "item_8885",
    "Last Name": "Sorilla",
    "First Name": "Eunice Leigh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38538259: {
    id: "item_8886",
    "Last Name": "Hogg",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38538417: {
    id: "item_19408",
    "Last Name": "Richards",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38538467: {
    id: "item_8887",
    "Last Name": "Shou",
    "First Name": "Marlon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38538494: {
    id: "item_19409",
    "Last Name": "Messmer",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38538533: {
    id: "item_33948",
    "Last Name": "Gerber",
    "First Name": "Lelaina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38538676: {
    id: "item_33949",
    "Last Name": "Afriliani",
    "First Name": "Vera",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38539091: {
    id: "item_21404",
    "Last Name": "Orcullo",
    "First Name": "Hanna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38539477: {
    id: "item_33950",
    "Last Name": "Shinzawa",
    "First Name": "Nanami",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38539518: {
    id: "item_32249",
    "Last Name": "Au",
    "First Name": "Ka Ting",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38541012: {
    id: "item_32250",
    "Last Name": "Hern‡ndez",
    "First Name": "Diego",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38541230: {
    id: "item_19410",
    "Last Name": "Espinosa de los Monteros Hernandez",
    "First Name": "Rocio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38542249: {
    id: "item_19411",
    "Last Name": "TAN",
    "First Name": "KAI THERN ADRIAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38542935: {
    id: "item_8888",
    "Last Name": "Hernandez",
    "First Name": "Lenin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38547164: {
    id: "item_6584",
    "Last Name": "Savelev",
    "First Name": "Gleb",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38547362: {
    id: "item_33951",
    "Last Name": "Mandy",
    "First Name": "Madeleine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38551498: {
    id: "item_6585",
    "Last Name": "Bennett",
    "First Name": "Ella",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38552348: {
    id: "item_6586",
    "Last Name": "Lepiz",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38552619: {
    id: "item_6587",
    "Last Name": "Pilkington",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38553843: {
    id: "item_19412",
    "Last Name": "Alejandrino",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38554008: {
    id: "item_33952",
    "Last Name": "Bliss",
    "First Name": "Ebony",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38557703: {
    id: "item_19413",
    "Last Name": "Scherer",
    "First Name": "Charline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38558403: {
    id: "item_19414",
    "Last Name": "Boke",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38562804: {
    id: "item_19415",
    "Last Name": "Atasan",
    "First Name": "Demwel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38564991: {
    id: "item_6588",
    "Last Name": "Chun",
    "First Name": "Jiang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38565537: {
    id: "item_6589",
    "Last Name": "Sim",
    "First Name": "Diane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38588509: {
    id: "item_19416",
    "Last Name": "Kennnelly",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38591437: {
    id: "item_19417",
    "Last Name": "Aspell",
    "First Name": "Erinn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38592547: {
    id: "item_6590",
    "Last Name": "Beddome",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38595538: {
    id: "item_21405",
    "Last Name": "sheridan",
    "First Name": "max",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38596539: {
    id: "item_19418",
    "Last Name": "Kim",
    "First Name": "Bogeon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38610334: {
    id: "item_32251",
    "Last Name": "Giotta",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38617489: {
    id: "item_19419",
    "Last Name": "McGrath",
    "First Name": "Orla",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38632987: {
    id: "item_19420",
    "Last Name": "Davies",
    "First Name": "Paige",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38649246: {
    id: "item_19421",
    "Last Name": "Kobayashi",
    "First Name": "Hideaki",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38653807: {
    id: "item_33953",
    "Last Name": "Mccallum",
    "First Name": "Georgina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38658141: {
    id: "item_8889",
    "Last Name": "Howard",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38658557: {
    id: "item_19422",
    "Last Name": "van der Jagt",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38658942: {
    id: "item_6591",
    "Last Name": "Squires",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38659301: {
    id: "item_19423",
    "Last Name": "Poppleton",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38660615: {
    id: "item_6592",
    "Last Name": "Henriquez Falconi",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38661927: {
    id: "item_33954",
    "Last Name": "Metiam",
    "First Name": "Monserrat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38662075: {
    id: "item_19424",
    "Last Name": "OÕDonohue",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38662160: {
    id: "item_6593",
    "Last Name": "KWON",
    "First Name": "YOUNGJAE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38662945: {
    id: "item_33955",
    "Last Name": "LIU",
    "First Name": "Yufan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38663611: {
    id: "item_33956",
    "Last Name": "Klein",
    "First Name": "Lillian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38677742: {
    id: "item_19425",
    "Last Name": "Sarvida",
    "First Name": "Owie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38679708: {
    id: "item_6594",
    "Last Name": "Fickel",
    "First Name": "Corey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38680392: {
    id: "item_32252",
    "Last Name": "Thompson",
    "First Name": "Darby",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38680483: {
    id: "item_6595",
    "Last Name": "Beljanski",
    "First Name": "Vladimir",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38680491: {
    id: "item_19426",
    "Last Name": "WAHYUDI",
    "First Name": "ROBBY RAKHMAD",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38681200: {
    id: "item_33957",
    "Last Name": "Kaewsaard",
    "First Name": "Naichanok",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38681305: {
    id: "item_33958",
    "Last Name": "Udtohan",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  38798206: {
    id: "item_33959",
    "Last Name": "Garrett",
    "First Name": "Keir",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39072907: {
    id: "item_32253",
    "Last Name": "McGuiness",
    "First Name": "Mitch",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39072938: {
    id: "item_19427",
    "Last Name": "Sivam Raja",
    "First Name": "Vik",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39073450: {
    id: "item_19428",
    "Last Name": "Maskrey",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39073754: {
    id: "item_8890",
    "Last Name": "Bunyan",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39074338: {
    id: "item_19429",
    "Last Name": "Clough",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39074381: {
    id: "item_6596",
    "Last Name": "Yip",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39074809: {
    id: "item_19430",
    "Last Name": "Aouad",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39079098: {
    id: "item_32254",
    "Last Name": "Poole",
    "First Name": "Whitney",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39096052: {
    id: "item_8891",
    "Last Name": "Gunn",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39096482: {
    id: "item_19431",
    "Last Name": "Peou",
    "First Name": "Thida",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39096882: {
    id: "item_6597",
    "Last Name": "Lutz",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39119082: {
    id: "item_8892",
    "Last Name": "Frigo",
    "First Name": "Kendra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39122577: {
    id: "item_19432",
    "Last Name": "Barden",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39124548: {
    id: "item_32255",
    "Last Name": "Jackson",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39125049: {
    id: "item_8893",
    "Last Name": "Bailey",
    "First Name": "Harry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39125258: {
    id: "item_32256",
    "Last Name": "Jones",
    "First Name": "Ashton",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39125300: {
    id: "item_32257",
    "Last Name": "Pereira",
    "First Name": "Anastasia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39131700: {
    id: "item_32258",
    "Last Name": "Pizanias",
    "First Name": "Contessa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39132558: {
    id: "item_8894",
    "Last Name": "Zhang",
    "First Name": "Elisabeth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39132612: {
    id: "item_19433",
    "Last Name": "Lundy",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39138622: {
    id: "item_21406",
    "Last Name": "Heaney",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39139149: {
    id: "item_19434",
    "Last Name": "McDermott",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39153110: {
    id: "item_19435",
    "Last Name": "Gregory",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39164319: {
    id: "item_32259",
    "Last Name": "Or",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39165145: {
    id: "item_19436",
    "Last Name": "Sugianto",
    "First Name": "Tiffanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39178546: {
    id: "item_19437",
    "Last Name": "Jarcho",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39196103: {
    id: "item_19438",
    "Last Name": "Nguyen",
    "First Name": "Aidan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39199057: {
    id: "item_32260",
    "Last Name": "Masselos",
    "First Name": "Mieke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39223312: {
    id: "item_32261",
    "Last Name": "Dewald",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39248188: {
    id: "item_32262",
    "Last Name": "Heaslip",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39249512: {
    id: "item_6598",
    "Last Name": "Wilson",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39256325: {
    id: "item_33960",
    "Last Name": "Ramos",
    "First Name": "Rachel Mae",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39258268: {
    id: "item_21407",
    "Last Name": "Fok",
    "First Name": "Shun Cheong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39268529: {
    id: "item_19439",
    "Last Name": "Gaucin",
    "First Name": "Ricardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39292002: {
    id: "item_6599",
    "Last Name": "Strickland",
    "First Name": "Jen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39292911: {
    id: "item_8895",
    "Last Name": "Greig",
    "First Name": "Callum",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39313320: {
    id: "item_32263",
    "Last Name": "Armstrong",
    "First Name": "Kelsey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39332931: {
    id: "item_33961",
    "Last Name": "Landsbergen",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39344105: {
    id: "item_19440",
    "Last Name": "Richards",
    "First Name": "Milton",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39350388: {
    id: "item_6600",
    "Last Name": "OReilly",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39353065: {
    id: "item_32264",
    "Last Name": "Hartman",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39359792: {
    id: "item_32265",
    "Last Name": "McDowell",
    "First Name": "Leilani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39365236: {
    id: "item_19441",
    "Last Name": "McCabe",
    "First Name": "Allan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39399566: {
    id: "item_19442",
    "Last Name": "Bickerton",
    "First Name": "Andy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39402470: {
    id: "item_19443",
    "Last Name": "Ivers",
    "First Name": "Garth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39415950: {
    id: "item_6601",
    "Last Name": "Hussaini",
    "First Name": "Syed",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39481441: {
    id: "item_21408",
    "Last Name": "Suyono",
    "First Name": "Fransisca Samantha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39482915: {
    id: "item_6602",
    "Last Name": "Langbein",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39482984: {
    id: "item_19444",
    "Last Name": "Stark",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39483052: {
    id: "item_19445",
    "Last Name": "Adams",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39484200: {
    id: "item_6603",
    "Last Name": "Burt",
    "First Name": "Elle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39485120: {
    id: "item_33962",
    "Last Name": "Murdock",
    "First Name": "Cheyanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39487581: {
    id: "item_19446",
    "Last Name": "Saffre",
    "First Name": "Beatrice",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39488479: {
    id: "item_33963",
    "Last Name": "Williams",
    "First Name": "Rosemary",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39489839: {
    id: "item_19447",
    "Last Name": "Li",
    "First Name": "Zhi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39489849: {
    id: "item_6604",
    "Last Name": "Hennig",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39492847: {
    id: "item_19448",
    "Last Name": "Voronov",
    "First Name": "Aleksei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39493824: {
    id: "item_32266",
    "Last Name": "Lowery",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39515858: {
    id: "item_8896",
    "Last Name": "Hayes",
    "First Name": "Fina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39525618: {
    id: "item_19449",
    "Last Name": "Mahon",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39588191: {
    id: "item_6605",
    "Last Name": "Keogh",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39598933: {
    id: "item_32267",
    "Last Name": "Kennedy",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39601502: {
    id: "item_8897",
    "Last Name": "Boston",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39608346: {
    id: "item_19450",
    "Last Name": "Beard",
    "First Name": "Kari",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39619041: {
    id: "item_32268",
    "Last Name": "Mahfouz",
    "First Name": "Nehmat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39661512: {
    id: "item_8898",
    "Last Name": "Samson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39667658: {
    id: "item_6606",
    "Last Name": "Parrott",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39667902: {
    id: "item_8899",
    "Last Name": "Singh",
    "First Name": "Baljinder",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39670649: {
    id: "item_33964",
    "Last Name": "Gill",
    "First Name": "Parminder",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39671511: {
    id: "item_33965",
    "Last Name": "Singh",
    "First Name": "Lakvinder",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39671834: {
    id: "item_19451",
    "Last Name": "Durrant",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39672250: {
    id: "item_33966",
    "Last Name": "Flora",
    "First Name": "Jaswinder Kaur",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39672390: {
    id: "item_32269",
    "Last Name": "Sira",
    "First Name": "Hardev singh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39675022: {
    id: "item_6607",
    "Last Name": "Hussain",
    "First Name": "Shaid",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39675245: {
    id: "item_32270",
    "Last Name": "KAUR",
    "First Name": "NARINDER",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39676351: {
    id: "item_21409",
    "Last Name": "Singh",
    "First Name": "Manjit",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39678124: {
    id: "item_33967",
    "Last Name": "Jobanputra",
    "First Name": "Sandy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39688667: {
    id: "item_6608",
    "Last Name": "Chapagain",
    "First Name": "Ansil",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39689226: {
    id: "item_8900",
    "Last Name": "Corrompido",
    "First Name": "Irina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39689846: {
    id: "item_19452",
    "Last Name": "GURUNG",
    "First Name": "Iman",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39690380: {
    id: "item_6609",
    "Last Name": "Budhathoki",
    "First Name": "Ramesh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39692080: {
    id: "item_33968",
    "Last Name": "Sahotay",
    "First Name": "Harjinder",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39692201: {
    id: "item_33969",
    "Last Name": "LOTAY",
    "First Name": "NIRMAL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39712200: {
    id: "item_6610",
    "Last Name": "Khan",
    "First Name": "Semeena",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39719996: {
    id: "item_8901",
    "Last Name": "Bississo",
    "First Name": "Lena",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39721954: {
    id: "item_6611",
    "Last Name": "Abusharif",
    "First Name": "Lama",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39725154: {
    id: "item_6612",
    "Last Name": "Abdullah",
    "First Name": "Ruba",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39729027: {
    id: "item_6613",
    "Last Name": "Ben Slama",
    "First Name": "Akram",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39731844: {
    id: "item_8902",
    "Last Name": "Athar",
    "First Name": "Talal",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39736265: {
    id: "item_19453",
    "Last Name": "Ali",
    "First Name": "Hamad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39753144: {
    id: "item_6614",
    "Last Name": "Abdullah",
    "First Name": "Zain",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39775486: {
    id: "item_32271",
    "Last Name": "MELENDEZ",
    "First Name": "YOLANDA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39775714: {
    id: "item_19454",
    "Last Name": "Perry",
    "First Name": "Liza",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39778359: {
    id: "item_6615",
    "Last Name": "Mahmood",
    "First Name": "Rashad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39786034: {
    id: "item_6616",
    "Last Name": "Siddiqui",
    "First Name": "Muhammad Yawar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39789635: {
    id: "item_6617",
    "Last Name": "Yawar",
    "First Name": "Nida",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39792324: {
    id: "item_33970",
    "Last Name": "Rosmarin",
    "First Name": "Jake",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39796277: {
    id: "item_6618",
    "Last Name": "Abukaram",
    "First Name": "NoorAlexandria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39799156: {
    id: "item_32272",
    "Last Name": "Lee",
    "First Name": "Jaeung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39801219: {
    id: "item_6619",
    "Last Name": "Ellingsen",
    "First Name": "Catharine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39807025: {
    id: "item_32273",
    "Last Name": "Feinberg",
    "First Name": "Ndidi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39809554: {
    id: "item_33971",
    "Last Name": "Chang",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39814323: {
    id: "item_33972",
    "Last Name": "Hossain",
    "First Name": "Naushin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39823072: {
    id: "item_21410",
    "Last Name": "Severino",
    "First Name": "Jas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39836006: {
    id: "item_19455",
    "Last Name": "Shanahan",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39860703: {
    id: "item_33973",
    "Last Name": "Baviskar",
    "First Name": "Chaitali",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39886524: {
    id: "item_8903",
    "Last Name": "Moody",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39887078: {
    id: "item_8904",
    "Last Name": "Lea",
    "First Name": "Justine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39921381: {
    id: "item_32274",
    "Last Name": "Dafnis",
    "First Name": "Suzi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39922555: {
    id: "item_19456",
    "Last Name": "Jackson",
    "First Name": "Mike",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39923035: {
    id: "item_6620",
    "Last Name": "Beck",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39970842: {
    id: "item_33974",
    "Last Name": "Severs",
    "First Name": "Alison",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39973415: {
    id: "item_6621",
    "Last Name": "Arellano",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39973853: {
    id: "item_33975",
    "Last Name": "PRIAMBODO",
    "First Name": "NINO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39973909: {
    id: "item_19457",
    "Last Name": "Yap",
    "First Name": "Timothy Bryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39980989: {
    id: "item_6622",
    "Last Name": "Reckler",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  39981011: {
    id: "item_19458",
    "Last Name": "Lyons",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40001047: {
    id: "item_6623",
    "Last Name": "Weinberger",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40002028: {
    id: "item_19459",
    "Last Name": "Varadarajan",
    "First Name": "Anand",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40002855: {
    id: "item_19460",
    "Last Name": "Dichupa",
    "First Name": "Mary Emerald",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40004847: {
    id: "item_21411",
    "Last Name": "Rased",
    "First Name": "Yama",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40007093: {
    id: "item_32275",
    "Last Name": "Laanani",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40010556: {
    id: "item_33976",
    "Last Name": "Bhana",
    "First Name": "Jameel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40023577: {
    id: "item_6624",
    "Last Name": "De Almeida Carneiro Giongo",
    "First Name": "Thais",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40049636: {
    id: "item_32276",
    "Last Name": "Cummins",
    "First Name": "Sean",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40063954: {
    id: "item_32277",
    "Last Name": "Young",
    "First Name": "Keith",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40104061: {
    id: "item_8905",
    "Last Name": "kashif",
    "First Name": "furqan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40106197: {
    id: "item_32278",
    "Last Name": "Ansari",
    "First Name": "Mir Sadeq",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40106523: {
    id: "item_21412",
    "Last Name": "Peiris",
    "First Name": "Keshan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40122426: {
    id: "item_19461",
    "Last Name": "Barnett",
    "First Name": "Liliana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40123113: {
    id: "item_33977",
    "Last Name": "Alhassan",
    "First Name": "Aya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40123211: {
    id: "item_33978",
    "Last Name": "Kassem",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40127400: {
    id: "item_19462",
    "Last Name": "Shown",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40149022: {
    id: "item_32279",
    "Last Name": "Takkoush",
    "First Name": "Suha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40164503: {
    id: "item_21413",
    "Last Name": "Donlan",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40165258: {
    id: "item_6625",
    "Last Name": "Steude",
    "First Name": "Maik",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40165635: {
    id: "item_19463",
    "Last Name": "Dominguez",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40165639: {
    id: "item_19464",
    "Last Name": "Schuster",
    "First Name": "Eric",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40179282: {
    id: "item_8906",
    "Last Name": "Park",
    "First Name": "Jungkyu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40197897: {
    id: "item_33979",
    "Last Name": "Mijares",
    "First Name": "Paula",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40203284: {
    id: "item_19465",
    "Last Name": "Anderson",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40205814: {
    id: "item_6626",
    "Last Name": "Natale",
    "First Name": "Alessandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40206642: {
    id: "item_33980",
    "Last Name": "Murtha",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40206978: {
    id: "item_33981",
    "Last Name": "Pilcher",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40207415: {
    id: "item_33982",
    "Last Name": "Waddell",
    "First Name": "Harrison",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40219599: {
    id: "item_6627",
    "Last Name": "Hempstead",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40260190: {
    id: "item_32280",
    "Last Name": "Suarez",
    "First Name": "Noelia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40328740: {
    id: "item_32281",
    "Last Name": "Cotton",
    "First Name": "DeLorean",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40334720: {
    id: "item_6628",
    "Last Name": "X",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40372962: {
    id: "item_19466",
    "Last Name": "Boston",
    "First Name": "Greg",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40405148: {
    id: "item_8907",
    "Last Name": "Brown",
    "First Name": "Nigel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40455643: {
    id: "item_32282",
    "Last Name": "Hassan",
    "First Name": "Rowah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40460262: {
    id: "item_19467",
    "Last Name": "Schoenewald",
    "First Name": "Stan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40460873: {
    id: "item_33983",
    "Last Name": "Schneider",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40461246: {
    id: "item_21414",
    "Last Name": "Scheetz",
    "First Name": "Kimberlee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40491627: {
    id: "item_19468",
    "Last Name": "McShane",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40569933: {
    id: "item_19469",
    "Last Name": "Burrows",
    "First Name": "Marianne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40596975: {
    id: "item_19470",
    "Last Name": "Oldfield",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40617380: {
    id: "item_33984",
    "Last Name": "Caron",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40641905: {
    id: "item_33985",
    "Last Name": "Rodd",
    "First Name": "Sallie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40642840: {
    id: "item_6629",
    "Last Name": "Hamilton",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40643344: {
    id: "item_21415",
    "Last Name": "Zhang",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40646262: {
    id: "item_6630",
    "Last Name": "Skilling",
    "First Name": "Moray",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40723608: {
    id: "item_6631",
    "Last Name": "Masterton",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40731293: {
    id: "item_33986",
    "Last Name": "Broadhead",
    "First Name": "Klarissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40736832: {
    id: "item_19471",
    "Last Name": "Rosier",
    "First Name": "Titus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40743478: {
    id: "item_33987",
    "Last Name": "Mai",
    "First Name": "Stellar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40744670: {
    id: "item_8908",
    "Last Name": "YAN",
    "First Name": "ZHANG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40745407: {
    id: "item_6632",
    "Last Name": "Meakin",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40802139: {
    id: "item_19472",
    "Last Name": "Magnuson",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40832805: {
    id: "item_32283",
    "Last Name": "Bradley",
    "First Name": "Larry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40885953: {
    id: "item_6633",
    "Last Name": "Grewal",
    "First Name": "Kimmi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40905168: {
    id: "item_19473",
    "Last Name": "Chareonwongsak",
    "First Name": "Anajuk",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40909507: {
    id: "item_19474",
    "Last Name": "Thomas",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40909826: {
    id: "item_6634",
    "Last Name": "Comerford",
    "First Name": "Kim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40911841: {
    id: "item_6635",
    "Last Name": "Henderson",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40911996: {
    id: "item_6636",
    "Last Name": "Robson",
    "First Name": "Jack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40912888: {
    id: "item_8909",
    "Last Name": "Cusack",
    "First Name": "Mairead",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40913296: {
    id: "item_6637",
    "Last Name": "Rymer",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40914973: {
    id: "item_8910",
    "Last Name": "Howard",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40915458: {
    id: "item_19475",
    "Last Name": "Tully",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40916082: {
    id: "item_19476",
    "Last Name": "Angus",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40917641: {
    id: "item_19477",
    "Last Name": "Napper",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40922726: {
    id: "item_6638",
    "Last Name": "Escalante",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40923301: {
    id: "item_21416",
    "Last Name": "Stout",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40923446: {
    id: "item_8911",
    "Last Name": "McLaughlin",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40924193: {
    id: "item_32284",
    "Last Name": "Lee",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40952644: {
    id: "item_6639",
    "Last Name": "Richardson",
    "First Name": "Vici",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40952975: {
    id: "item_32285",
    "Last Name": "Coombes",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40953833: {
    id: "item_6640",
    "Last Name": "Bourke",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40954324: {
    id: "item_19478",
    "Last Name": "Mulder",
    "First Name": "Janet",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40954538: {
    id: "item_32286",
    "Last Name": "Anglade",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40954911: {
    id: "item_33988",
    "Last Name": "Liong",
    "First Name": "Ivy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40956303: {
    id: "item_6641",
    "Last Name": "Papa",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40958348: {
    id: "item_19479",
    "Last Name": "Gilhooley",
    "First Name": "Sinead",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40958360: {
    id: "item_32287",
    "Last Name": "Yang",
    "First Name": "Jian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40958386: {
    id: "item_19480",
    "Last Name": "Wang",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  40958739: {
    id: "item_6642",
    "Last Name": "Halpin",
    "First Name": "Steph",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41000105: {
    id: "item_6643",
    "Last Name": "Estrada Pardo",
    "First Name": "Hugo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41002981: {
    id: "item_6644",
    "Last Name": "Meadowcroft",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41004434: {
    id: "item_6645",
    "Last Name": "Webster",
    "First Name": "Hollie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41010738: {
    id: "item_32288",
    "Last Name": "CHANG",
    "First Name": "ZHE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41050077: {
    id: "item_33989",
    "Last Name": "Tiernan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41051335: {
    id: "item_32289",
    "Last Name": "Chamnankool",
    "First Name": "Vorawit",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41053044: {
    id: "item_32290",
    "Last Name": "Allen",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41069186: {
    id: "item_19481",
    "Last Name": "Maier",
    "First Name": "Francisca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41084015: {
    id: "item_8912",
    "Last Name": "Mueller",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41084090: {
    id: "item_8913",
    "Last Name": "Reyes",
    "First Name": "MAURICIO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41084958: {
    id: "item_32291",
    "Last Name": "DRAYTON",
    "First Name": "SASHA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41085477: {
    id: "item_21417",
    "Last Name": "Diprose",
    "First Name": "Julian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41089160: {
    id: "item_6646",
    "Last Name": "Lewis",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41094056: {
    id: "item_32292",
    "Last Name": "Williams Lewis",
    "First Name": "Michele",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41104362: {
    id: "item_32293",
    "Last Name": "Callister",
    "First Name": "Euan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41106771: {
    id: "item_8914",
    "Last Name": "Wood",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41115834: {
    id: "item_19482",
    "Last Name": "Dodaro",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41132619: {
    id: "item_19483",
    "Last Name": "Kaul",
    "First Name": "Neelam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41134312: {
    id: "item_21418",
    "Last Name": "Quintrell",
    "First Name": "Laura Lawshe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41142171: {
    id: "item_32294",
    "Last Name": "Turner",
    "First Name": "Irapaul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41154645: {
    id: "item_19484",
    "Last Name": "Thiel",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41154686: {
    id: "item_6647",
    "Last Name": "Blankenship",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41154796: {
    id: "item_21419",
    "Last Name": "Khim",
    "First Name": "Sary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41159979: {
    id: "item_32295",
    "Last Name": "Caban",
    "First Name": "Freddy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41161314: {
    id: "item_33990",
    "Last Name": "Garcia",
    "First Name": "Pamela Jubaira",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41162248: {
    id: "item_33991",
    "Last Name": "Pathmanandavel",
    "First Name": "Aarthi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41167116: {
    id: "item_19485",
    "Last Name": "Wright",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41167553: {
    id: "item_19486",
    "Last Name": "Williams",
    "First Name": "Austin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41167675: {
    id: "item_19487",
    "Last Name": "Helmrich",
    "First Name": "Loren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41172384: {
    id: "item_8915",
    "Last Name": "Whiting",
    "First Name": "Darryl",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41172985: {
    id: "item_19488",
    "Last Name": "Kennedy",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41175882: {
    id: "item_19489",
    "Last Name": "Batson",
    "First Name": "Junior",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41177784: {
    id: "item_6648",
    "Last Name": "Mortimer",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41204072: {
    id: "item_32296",
    "Last Name": "Tudor",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41204511: {
    id: "item_19490",
    "Last Name": "Robinson",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41205653: {
    id: "item_33992",
    "Last Name": "Limkin",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41208677: {
    id: "item_32297",
    "Last Name": "Cabral",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41210471: {
    id: "item_21420",
    "Last Name": "McCarthy",
    "First Name": "Fionnuala",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41215194: {
    id: "item_8916",
    "Last Name": "Stepanets",
    "First Name": "Olga",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41217256: {
    id: "item_6649",
    "Last Name": "Handt",
    "First Name": "Larry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41239275: {
    id: "item_19491",
    "Last Name": "Sherman",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41258346: {
    id: "item_33993",
    "Last Name": "Perez",
    "First Name": "Sabrina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41258909: {
    id: "item_19492",
    "Last Name": "Hu",
    "First Name": "Peiling",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41261641: {
    id: "item_19493",
    "Last Name": "Carter",
    "First Name": "Clive",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41264715: {
    id: "item_32298",
    "Last Name": "Urbina",
    "First Name": "Arlin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41314346: {
    id: "item_8917",
    "Last Name": "Restrepo Giraldo",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41316113: {
    id: "item_33994",
    "Last Name": "Blessing",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41324388: {
    id: "item_32299",
    "Last Name": "Trance",
    "First Name": "Mario",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41336661: {
    id: "item_32300",
    "Last Name": "Senney",
    "First Name": "Wally",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41368350: {
    id: "item_6650",
    "Last Name": "Hannell",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41411723: {
    id: "item_19494",
    "Last Name": "Jones",
    "First Name": "Sean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41427423: {
    id: "item_19495",
    "Last Name": "Dennis",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41435265: {
    id: "item_32301",
    "Last Name": "Turner",
    "First Name": "Mechell",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41472307: {
    id: "item_21421",
    "Last Name": "Adeva",
    "First Name": "Jamila",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41472673: {
    id: "item_19496",
    "Last Name": "Hardie",
    "First Name": "Tia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41473945: {
    id: "item_8918",
    "Last Name": "Landers",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41495343: {
    id: "item_19497",
    "Last Name": "Scanlan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41504998: {
    id: "item_6651",
    "Last Name": "Beh",
    "First Name": "Chyr Khai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41508063: {
    id: "item_6652",
    "Last Name": "Tile",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41510288: {
    id: "item_19498",
    "Last Name": "McDonald",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41510337: {
    id: "item_33995",
    "Last Name": "Bangcong",
    "First Name": "Malou Joy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41510347: {
    id: "item_32302",
    "Last Name": "Chong",
    "First Name": "Matias",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41510703: {
    id: "item_6653",
    "Last Name": "Schweizer",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41511713: {
    id: "item_19499",
    "Last Name": "La Delfa",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41512473: {
    id: "item_33996",
    "Last Name": "Luk",
    "First Name": "Test",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41513804: {
    id: "item_21422",
    "Last Name": "Callister",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41515183: {
    id: "item_33997",
    "Last Name": "Sherrington",
    "First Name": "Cathie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41515196: {
    id: "item_8919",
    "Last Name": "Sikorski",
    "First Name": "Szymon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41515535: {
    id: "item_33998",
    "Last Name": "Thessman",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41517051: {
    id: "item_19500",
    "Last Name": "Carragher",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41521557: {
    id: "item_19501",
    "Last Name": "Sullivan",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41540446: {
    id: "item_19502",
    "Last Name": "Syddall",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41540498: {
    id: "item_19503",
    "Last Name": "Feeney",
    "First Name": "Joan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41560357: {
    id: "item_19504",
    "Last Name": "Land",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41585896: {
    id: "item_19505",
    "Last Name": "Spence",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41606520: {
    id: "item_19506",
    "Last Name": "Stephens",
    "First Name": "Ginger",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41633943: {
    id: "item_21423",
    "Last Name": "Miller",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41636312: {
    id: "item_32303",
    "Last Name": "Lambert",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41638936: {
    id: "item_8920",
    "Last Name": "Tervit",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41642342: {
    id: "item_33999",
    "Last Name": "Kirk",
    "First Name": "Schlise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41642788: {
    id: "item_21424",
    "Last Name": "Motley",
    "First Name": "Takisha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41645653: {
    id: "item_19507",
    "Last Name": "Corigliano",
    "First Name": "Frank",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41647160: {
    id: "item_19508",
    "Last Name": "Ramirez",
    "First Name": "Dani",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41647781: {
    id: "item_32304",
    "Last Name": "Gibson",
    "First Name": "Casey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41648826: {
    id: "item_8921",
    "Last Name": "Wong",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41669430: {
    id: "item_21425",
    "Last Name": "Stevens",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41675253: {
    id: "item_6654",
    "Last Name": "Cliffe",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41676415: {
    id: "item_19509",
    "Last Name": "Jenness",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41679949: {
    id: "item_19510",
    "Last Name": "Butel",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41684001: {
    id: "item_6655",
    "Last Name": "Coker",
    "First Name": "Sammy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41687620: {
    id: "item_34000",
    "Last Name": "Breckon",
    "First Name": "Shelley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41688476: {
    id: "item_6656",
    "Last Name": "Hooper",
    "First Name": "Trevor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41688953: {
    id: "item_34001",
    "Last Name": "Sto Domingo",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41695291: {
    id: "item_19511",
    "Last Name": "Al-Sadiq",
    "First Name": "Nargis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41695357: {
    id: "item_19512",
    "Last Name": "Vakani",
    "First Name": "Bijay",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41720556: {
    id: "item_34002",
    "Last Name": "Murtagh",
    "First Name": "Annmarie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41726470: {
    id: "item_19513",
    "Last Name": "Kells",
    "First Name": "Christine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41726925: {
    id: "item_34003",
    "Last Name": "Cote-Saunders",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41733525: {
    id: "item_19514",
    "Last Name": "Cox",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41739501: {
    id: "item_21426",
    "Last Name": "Sterling",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41756640: {
    id: "item_19515",
    "Last Name": "Gagawanan",
    "First Name": "Rizian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41758995: {
    id: "item_21427",
    "Last Name": "Boccara",
    "First Name": "Eddy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41787342: {
    id: "item_32305",
    "Last Name": "Newton",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41787921: {
    id: "item_21428",
    "Last Name": "Hall",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41788011: {
    id: "item_32306",
    "Last Name": "Simonetti",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41788752: {
    id: "item_34004",
    "Last Name": "Williams",
    "First Name": "Theresa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41791305: {
    id: "item_32307",
    "Last Name": "Benton",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41793382: {
    id: "item_19516",
    "Last Name": "McLister",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41797105: {
    id: "item_34005",
    "Last Name": "Vincent",
    "First Name": "Robins",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41797714: {
    id: "item_19517",
    "Last Name": "PASINDU",
    "First Name": "DON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41797980: {
    id: "item_19518",
    "Last Name": "Lam",
    "First Name": "Edison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41798038: {
    id: "item_6657",
    "Last Name": "Dooley",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41798349: {
    id: "item_19519",
    "Last Name": "Falkiner",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41798750: {
    id: "item_19520",
    "Last Name": "Murphy",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41799560: {
    id: "item_21429",
    "Last Name": "Burgess",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41800960: {
    id: "item_32308",
    "Last Name": "Adams",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41801008: {
    id: "item_32309",
    "Last Name": "King",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41802009: {
    id: "item_32310",
    "Last Name": "Renton",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41803501: {
    id: "item_34006",
    "Last Name": "BUTEAU",
    "First Name": "DAVID",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41804935: {
    id: "item_34007",
    "Last Name": "Romero",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41807568: {
    id: "item_34008",
    "Last Name": "Holloman-Taylor",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41812444: {
    id: "item_32311",
    "Last Name": "Malakie",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41819500: {
    id: "item_34009",
    "Last Name": "Wilson",
    "First Name": "Zelia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41841244: {
    id: "item_19521",
    "Last Name": "McDuffie-Stanziani",
    "First Name": "Andretti",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41848786: {
    id: "item_19522",
    "Last Name": "Garrity",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41861095: {
    id: "item_19523",
    "Last Name": "Batchelor",
    "First Name": "Brett",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41863819: {
    id: "item_21430",
    "Last Name": "Hattersley",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41869250: {
    id: "item_34010",
    "Last Name": "Hemstreet",
    "First Name": "Troy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41869534: {
    id: "item_32312",
    "Last Name": "Brooks",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41869929: {
    id: "item_34011",
    "Last Name": "Mixon",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41870965: {
    id: "item_19524",
    "Last Name": "Bayram",
    "First Name": "Will",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41872507: {
    id: "item_19525",
    "Last Name": "Macrina",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41881455: {
    id: "item_34012",
    "Last Name": "Ehrlich",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41883122: {
    id: "item_32313",
    "Last Name": "Monaghan",
    "First Name": "Ashleah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41883231: {
    id: "item_19526",
    "Last Name": "Kubal",
    "First Name": "Collin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41885951: {
    id: "item_8922",
    "Last Name": "Morton",
    "First Name": "Kristi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41888141: {
    id: "item_6658",
    "Last Name": "Clippingdale",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41888933: {
    id: "item_34013",
    "Last Name": "TEST",
    "First Name": "TEST",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41889815: {
    id: "item_19527",
    "Last Name": "Smith",
    "First Name": "Darryl",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41890197: {
    id: "item_21431",
    "Last Name": "McGann",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41890574: {
    id: "item_19528",
    "Last Name": "Read",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41890723: {
    id: "item_19529",
    "Last Name": "Thomas",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41918625: {
    id: "item_6659",
    "Last Name": "Limbrey",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41926938: {
    id: "item_32314",
    "Last Name": "Glynn",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41950405: {
    id: "item_34014",
    "Last Name": "Collazo Lefranc",
    "First Name": "Zelma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41953365: {
    id: "item_6660",
    "Last Name": "Martinez",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41953753: {
    id: "item_32315",
    "Last Name": "Schwartz",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41965904: {
    id: "item_34015",
    "Last Name": "Wax",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41967481: {
    id: "item_8923",
    "Last Name": "Siejka",
    "First Name": "Dylan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41973556: {
    id: "item_21432",
    "Last Name": "Matthews",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41975272: {
    id: "item_34016",
    "Last Name": "Nicholson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41976351: {
    id: "item_8924",
    "Last Name": "Hodes",
    "First Name": "Evan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41977763: {
    id: "item_8925",
    "Last Name": "Dimitrov",
    "First Name": "Denislav",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41980186: {
    id: "item_6661",
    "Last Name": "Porras Suarez",
    "First Name": "Jorge Edilberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41988246: {
    id: "item_8926",
    "Last Name": "Latyshenko",
    "First Name": "Constantine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41992598: {
    id: "item_34017",
    "Last Name": "LIAO",
    "First Name": "YUNER",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41993344: {
    id: "item_32316",
    "Last Name": "Santos",
    "First Name": "Francis Oliver",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41995343: {
    id: "item_19530",
    "Last Name": "Pico",
    "First Name": "Karl Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41995553: {
    id: "item_34018",
    "Last Name": "Kelly",
    "First Name": "Eilis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  41999830: {
    id: "item_19531",
    "Last Name": "Bellamy",
    "First Name": "Ashton",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42001288: {
    id: "item_8927",
    "Last Name": "Asprec",
    "First Name": "Lawrence",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42003551: {
    id: "item_19532",
    "Last Name": "Giang",
    "First Name": "Albert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42043057: {
    id: "item_19533",
    "Last Name": "Cook",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42043496: {
    id: "item_19534",
    "Last Name": "Fox",
    "First Name": "Brindley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42049642: {
    id: "item_19535",
    "Last Name": "Reynolds",
    "First Name": "Rian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42049884: {
    id: "item_19536",
    "Last Name": "Luquin",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42051040: {
    id: "item_32317",
    "Last Name": "Donaldson",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42054628: {
    id: "item_8928",
    "Last Name": "Cheung",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42060125: {
    id: "item_19537",
    "Last Name": "Sebbouh",
    "First Name": "Elies",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42073043: {
    id: "item_19538",
    "Last Name": "Webber",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42077900: {
    id: "item_6662",
    "Last Name": "Foster",
    "First Name": "Mathew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42080135: {
    id: "item_21433",
    "Last Name": "Carter",
    "First Name": "Siv Eing",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42083967: {
    id: "item_6663",
    "Last Name": "Seconi",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42087949: {
    id: "item_8929",
    "Last Name": "Forsyth",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42093161: {
    id: "item_6664",
    "Last Name": "Delea",
    "First Name": "Colin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42128744: {
    id: "item_6665",
    "Last Name": "Lucas",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42129347: {
    id: "item_6666",
    "Last Name": "Del Vecchio",
    "First Name": "Silvio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42130246: {
    id: "item_8930",
    "Last Name": "morrison",
    "First Name": "kirstie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42131267: {
    id: "item_32318",
    "Last Name": "McNaughton",
    "First Name": "Conagh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42135652: {
    id: "item_32319",
    "Last Name": "Wu",
    "First Name": "Qilong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42140244: {
    id: "item_19539",
    "Last Name": "Nicholson",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42145770: {
    id: "item_32320",
    "Last Name": "Gardi",
    "First Name": "Badruun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42145930: {
    id: "item_34019",
    "Last Name": "Porter",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42151043: {
    id: "item_6667",
    "Last Name": "Mart’nez-Mu–iz",
    "First Name": "AndrŽs",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42156917: {
    id: "item_32321",
    "Last Name": "Coates",
    "First Name": "Sarah Jane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42158526: {
    id: "item_19540",
    "Last Name": "Lam",
    "First Name": "Andrea Mei Yan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42161980: {
    id: "item_6668",
    "Last Name": "Perrett",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42163003: {
    id: "item_21434",
    "Last Name": "Schepers",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42167105: {
    id: "item_34020",
    "Last Name": "FU",
    "First Name": "YANN-LIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42181514: {
    id: "item_21436",
    "Last Name": "Lees",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42181515: {
    id: "item_21435",
    "Last Name": "Hides",
    "First Name": "Hanna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42181517: {
    id: "item_6669",
    "Last Name": "Carroll",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42181522: {
    id: "item_6670",
    "Last Name": "Fisher",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42181523: {
    id: "item_19541",
    "Last Name": "Downing",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42181527: {
    id: "item_6671",
    "Last Name": "Leroux",
    "First Name": "Jean-Etienne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42181528: {
    id: "item_6672",
    "Last Name": "Soler Ramos",
    "First Name": "Jose Antonio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42181531: {
    id: "item_6673",
    "Last Name": "Cameron",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42182518: {
    id: "item_6674",
    "Last Name": "Sundaraj",
    "First Name": "Keran",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42182834: {
    id: "item_32322",
    "Last Name": "Smith",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42183705: {
    id: "item_34021",
    "Last Name": "Balak",
    "First Name": "Renu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42186615: {
    id: "item_32323",
    "Last Name": "Chirambo",
    "First Name": "Themba",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42190503: {
    id: "item_34022",
    "Last Name": "dos Santos",
    "First Name": "Domitilia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42191441: {
    id: "item_32324",
    "Last Name": "Kordestani",
    "First Name": "Said",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42203394: {
    id: "item_34023",
    "Last Name": "Mendoza",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42207412: {
    id: "item_6675",
    "Last Name": "Valencia Arroyo",
    "First Name": "Braulio Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42208401: {
    id: "item_8931",
    "Last Name": "Sodo",
    "First Name": "Jessica Kate",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42212301: {
    id: "item_8932",
    "Last Name": "Sinclair",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42213205: {
    id: "item_19542",
    "Last Name": "Taggart",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42214194: {
    id: "item_19543",
    "Last Name": "Nair",
    "First Name": "Vignesh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42228745: {
    id: "item_6676",
    "Last Name": "Young",
    "First Name": "Gina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42237694: {
    id: "item_19544",
    "Last Name": "Goli",
    "First Name": "Srinath",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42248596: {
    id: "item_32325",
    "Last Name": "Rudis",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42250987: {
    id: "item_21437",
    "Last Name": "Swanson",
    "First Name": "Brad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42259953: {
    id: "item_19545",
    "Last Name": "Wilde",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42260287: {
    id: "item_6677",
    "Last Name": "Noyce",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42274475: {
    id: "item_8933",
    "Last Name": "macomber",
    "First Name": "Brittney",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42275949: {
    id: "item_19546",
    "Last Name": "Warren",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42276090: {
    id: "item_32326",
    "Last Name": "Rynn",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42276653: {
    id: "item_6678",
    "Last Name": "Donkin",
    "First Name": "Matilda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42283197: {
    id: "item_6679",
    "Last Name": "Wallis",
    "First Name": "Hugh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42284356: {
    id: "item_19547",
    "Last Name": "BAIDENGAN",
    "First Name": "JOSHUA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42285798: {
    id: "item_8934",
    "Last Name": "Moger",
    "First Name": "Levi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42285927: {
    id: "item_19548",
    "Last Name": "Hipgrave",
    "First Name": "Keegan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42289022: {
    id: "item_19549",
    "Last Name": "Rajasekharan",
    "First Name": "Sachin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42303379: {
    id: "item_6680",
    "Last Name": "Ashley",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42303461: {
    id: "item_19550",
    "Last Name": "Shapiro",
    "First Name": "Kayla",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42308186: {
    id: "item_19551",
    "Last Name": "Driver",
    "First Name": "Glen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42312209: {
    id: "item_19552",
    "Last Name": "Platt",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42312926: {
    id: "item_6681",
    "Last Name": "Pepl",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42322730: {
    id: "item_6682",
    "Last Name": "Lei",
    "First Name": "Austin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42322942: {
    id: "item_19553",
    "Last Name": "Min",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42324020: {
    id: "item_19554",
    "Last Name": "George",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42334219: {
    id: "item_32327",
    "Last Name": "Saunders",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42339533: {
    id: "item_34024",
    "Last Name": "Field",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42340630: {
    id: "item_34025",
    "Last Name": "SUN",
    "First Name": "JINLEI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42342285: {
    id: "item_19555",
    "Last Name": "Walker",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42342929: {
    id: "item_34026",
    "Last Name": "Townsend",
    "First Name": "Tamika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42343134: {
    id: "item_34027",
    "Last Name": "NezBegay Volker",
    "First Name": "Verna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42343399: {
    id: "item_32328",
    "Last Name": "Moreton Stewart",
    "First Name": "Nakia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42343545: {
    id: "item_34028",
    "Last Name": "Martin",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42343669: {
    id: "item_32329",
    "Last Name": "Weber",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42343753: {
    id: "item_32330",
    "Last Name": "Weir",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42344256: {
    id: "item_32331",
    "Last Name": "Perera",
    "First Name": "Oswin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42349452: {
    id: "item_19556",
    "Last Name": "Sutherland",
    "First Name": "Isla",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42350213: {
    id: "item_19557",
    "Last Name": "Barbosa Passos",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42355032: {
    id: "item_32332",
    "Last Name": "Guffey",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42373813: {
    id: "item_6683",
    "Last Name": "mjahed",
    "First Name": "khalid",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42375120: {
    id: "item_6684",
    "Last Name": "Fattah",
    "First Name": "Belhoucine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42375652: {
    id: "item_6685",
    "Last Name": "HADDAD",
    "First Name": "FOUAD",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42376740: {
    id: "item_6686",
    "Last Name": "dkhissy",
    "First Name": "mouhssine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42396586: {
    id: "item_19558",
    "Last Name": "Walker",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42397710: {
    id: "item_19559",
    "Last Name": "Zandona",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42400919: {
    id: "item_6687",
    "Last Name": "Yamaguchi",
    "First Name": "Kayo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42401651: {
    id: "item_19560",
    "Last Name": "Thorn",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42418169: {
    id: "item_6688",
    "Last Name": "Medina",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42418453: {
    id: "item_8935",
    "Last Name": "Boyd",
    "First Name": "Randy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42425244: {
    id: "item_6689",
    "Last Name": "Choi",
    "First Name": "Joonho",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42430439: {
    id: "item_6690",
    "Last Name": "OÕBrien",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42433082: {
    id: "item_19561",
    "Last Name": "Chua",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42434630: {
    id: "item_21438",
    "Last Name": "Lim",
    "First Name": "Manuel jr",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42435029: {
    id: "item_19562",
    "Last Name": "Lui",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42435880: {
    id: "item_6691",
    "Last Name": "O'Shea",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42438112: {
    id: "item_8936",
    "Last Name": "Preece",
    "First Name": "Sian-Marie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42438643: {
    id: "item_8937",
    "Last Name": "Castlehow",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42438774: {
    id: "item_19563",
    "Last Name": "Shaw",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42438879: {
    id: "item_19564",
    "Last Name": "CHUAH",
    "First Name": "GAIK BEE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42438881: {
    id: "item_34029",
    "Last Name": "Jambal",
    "First Name": "Ulziie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439031: {
    id: "item_32333",
    "Last Name": "Susanto",
    "First Name": "Budiyanto",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439032: {
    id: "item_32334",
    "Last Name": "DAI",
    "First Name": "GUOYAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439128: {
    id: "item_6692",
    "Last Name": "Johnson",
    "First Name": "Johnson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439149: {
    id: "item_32335",
    "Last Name": "Ng",
    "First Name": "Yu Chiu Beverly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439233: {
    id: "item_19565",
    "Last Name": "Peri",
    "First Name": "Srinivas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439390: {
    id: "item_8938",
    "Last Name": "Ng",
    "First Name": "Wai Yen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439403: {
    id: "item_34030",
    "Last Name": "Lim",
    "First Name": "Alan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439611: {
    id: "item_8939",
    "Last Name": "Setiabudy",
    "First Name": "Marta",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439616: {
    id: "item_32336",
    "Last Name": "Soon",
    "First Name": "Bin Foo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439733: {
    id: "item_6693",
    "Last Name": "Fan",
    "First Name": "Po Kam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439791: {
    id: "item_34031",
    "Last Name": "Wardhana",
    "First Name": "Arief Kusuma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439810: {
    id: "item_8940",
    "Last Name": "Suardja",
    "First Name": "Iqbal Ardylies",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439886: {
    id: "item_8941",
    "Last Name": "Puspaningrum",
    "First Name": "Dwi Marytha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42439929: {
    id: "item_34032",
    "Last Name": "Neo",
    "First Name": "Katrina, Ya Fong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42440040: {
    id: "item_32337",
    "Last Name": "Suprapto",
    "First Name": "Andari",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42440343: {
    id: "item_6694",
    "Last Name": "yu",
    "First Name": "fangdi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42440395: {
    id: "item_8942",
    "Last Name": "Kaswiyanto",
    "First Name": "Fredo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42440410: {
    id: "item_34033",
    "Last Name": "David",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42440613: {
    id: "item_8943",
    "Last Name": "Mahuli",
    "First Name": "Kiran",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42441777: {
    id: "item_6695",
    "Last Name": "Gaizar sidik",
    "First Name": "Reiza",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42442772: {
    id: "item_6696",
    "Last Name": "Siburian",
    "First Name": "Rentina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42443140: {
    id: "item_19566",
    "Last Name": "Margamuljana",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42443828: {
    id: "item_34034",
    "Last Name": "EE",
    "First Name": "Hock Chye",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42443968: {
    id: "item_34035",
    "Last Name": "Chua",
    "First Name": "Raymund",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42444593: {
    id: "item_34036",
    "Last Name": "Abraham",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42444756: {
    id: "item_6697",
    "Last Name": "Sucipto",
    "First Name": "Abdul Azis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42446298: {
    id: "item_8944",
    "Last Name": "Kerdphol",
    "First Name": "Pakpong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42447579: {
    id: "item_19567",
    "Last Name": "Sriphon",
    "First Name": "Phornrak",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42448906: {
    id: "item_6698",
    "Last Name": "Rinchokechai",
    "First Name": "Winyoo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42455904: {
    id: "item_32338",
    "Last Name": "Namuangchan",
    "First Name": "Yotdanai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42456959: {
    id: "item_6699",
    "Last Name": "Weeramethachai",
    "First Name": "Deephrom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42458466: {
    id: "item_34037",
    "Last Name": "Chan",
    "First Name": "Lai Kheng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42459410: {
    id: "item_19568",
    "Last Name": "Wu",
    "First Name": "Ya-hui",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42459523: {
    id: "item_19569",
    "Last Name": "Aguilar Ceballos",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42461654: {
    id: "item_19570",
    "Last Name": "Lawn",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42461870: {
    id: "item_19571",
    "Last Name": "Yoshikawa",
    "First Name": "Xiaosu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42462365: {
    id: "item_32339",
    "Last Name": "Kanpai",
    "First Name": "Nopphawan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42463081: {
    id: "item_34038",
    "Last Name": "sudiarta",
    "First Name": "i wayan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42463263: {
    id: "item_34039",
    "Last Name": "virmayanti",
    "First Name": "putu indah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42463456: {
    id: "item_19572",
    "Last Name": "Hall",
    "First Name": "Celeste",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42465690: {
    id: "item_6700",
    "Last Name": "Tower",
    "First Name": "Jared",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42465766: {
    id: "item_21439",
    "Last Name": "Wong",
    "First Name": "Ping Huong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42466123: {
    id: "item_8945",
    "Last Name": "Masitoh",
    "First Name": "Siti",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42466468: {
    id: "item_34040",
    "Last Name": "Jangid",
    "First Name": "Mitaram",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42466633: {
    id: "item_32340",
    "Last Name": "Sapiie",
    "First Name": "Benyamin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42466774: {
    id: "item_19573",
    "Last Name": "Freeman",
    "First Name": "Jason",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42467823: {
    id: "item_6701",
    "Last Name": "Arias Gonzalez",
    "First Name": "Vicente Antonio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42468457: {
    id: "item_19574",
    "Last Name": "Cuan",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42481223: {
    id: "item_19575",
    "Last Name": "Anyamaneecharoen",
    "First Name": "Tamolwan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42483514: {
    id: "item_6702",
    "Last Name": "Hansen",
    "First Name": "Alice",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42485186: {
    id: "item_19576",
    "Last Name": "Anzueto",
    "First Name": "Diego",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42485426: {
    id: "item_8946",
    "Last Name": "Lim",
    "First Name": "Mui Hong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42485618: {
    id: "item_19577",
    "Last Name": "Nguyen",
    "First Name": "Duy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42485795: {
    id: "item_34041",
    "Last Name": "Yu",
    "First Name": "Lai Chong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42486252: {
    id: "item_6703",
    "Last Name": "Sumuweng",
    "First Name": "Aldi Ronaldo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42486475: {
    id: "item_6704",
    "Last Name": "Darma",
    "First Name": "Wendyanto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42487185: {
    id: "item_8947",
    "Last Name": "Nurbaiti",
    "First Name": "Lia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42488474: {
    id: "item_6705",
    "Last Name": "Lee",
    "First Name": "Junghyuk",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42489305: {
    id: "item_32341",
    "Last Name": "Soriano",
    "First Name": "Lourdes",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42490268: {
    id: "item_6706",
    "Last Name": "Ng",
    "First Name": "Noviati",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42490674: {
    id: "item_6707",
    "Last Name": "Triyo Raharjo",
    "First Name": "Rahmat",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42491096: {
    id: "item_6708",
    "Last Name": "Widjajanto",
    "First Name": "Andre",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42491107: {
    id: "item_19578",
    "Last Name": "tianusa",
    "First Name": "walton",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42492596: {
    id: "item_8948",
    "Last Name": "Iskandar",
    "First Name": "Chitrayani Sandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42493161: {
    id: "item_6709",
    "Last Name": "Rustamiaji",
    "First Name": "Tomi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42495764: {
    id: "item_19579",
    "Last Name": "Lee",
    "First Name": "Yen Fee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42496247: {
    id: "item_32342",
    "Last Name": "Rompis",
    "First Name": "Andreas Moritz Egon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42496922: {
    id: "item_34042",
    "Last Name": "Laosirichon",
    "First Name": "Wannasiri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42497369: {
    id: "item_34043",
    "Last Name": "Wijitkhunakorn",
    "First Name": "Sunantha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42499559: {
    id: "item_6710",
    "Last Name": "raworth",
    "First Name": "sophie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42502279: {
    id: "item_6711",
    "Last Name": "Poon",
    "First Name": "Jonny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42507841: {
    id: "item_32343",
    "Last Name": "Peng",
    "First Name": "Ngiap Luan Luke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42512283: {
    id: "item_19580",
    "Last Name": "Wilkie",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42512370: {
    id: "item_8949",
    "Last Name": "Goyen",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42512677: {
    id: "item_6712",
    "Last Name": "Sahroni",
    "First Name": "Irsyad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42512981: {
    id: "item_19581",
    "Last Name": "Mohamed",
    "First Name": "Huwayda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42513327: {
    id: "item_6713",
    "Last Name": "Saba",
    "First Name": "Ash",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42513587: {
    id: "item_32344",
    "Last Name": "Hoang",
    "First Name": "Chi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42513780: {
    id: "item_32345",
    "Last Name": "Indra",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42516651: {
    id: "item_19582",
    "Last Name": "Chandra",
    "First Name": "Yenny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42517261: {
    id: "item_32346",
    "Last Name": "Abu Zaharin",
    "First Name": "Siti Hajar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42517316: {
    id: "item_21440",
    "Last Name": "Kumaar",
    "First Name": "Logesh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42517418: {
    id: "item_34044",
    "Last Name": "KUMAR",
    "First Name": "GULSHAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42517602: {
    id: "item_6714",
    "Last Name": "Wang",
    "First Name": "Dongyu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42517711: {
    id: "item_34046",
    "Last Name": "Zainul Bahrin",
    "First Name": "Nur Airin Zairin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42517718: {
    id: "item_34045",
    "Last Name": "Magsalin",
    "First Name": "Chase Hermit",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42517823: {
    id: "item_19583",
    "Last Name": "Hasnan",
    "First Name": "Abdul Rahman",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518158: {
    id: "item_6715",
    "Last Name": "Kurniawan",
    "First Name": "Michelle Audrey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518246: {
    id: "item_34047",
    "Last Name": "Leong",
    "First Name": "Kin Yue",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518264: {
    id: "item_6716",
    "Last Name": "Rizal",
    "First Name": "M",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518292: {
    id: "item_6717",
    "Last Name": "Lim",
    "First Name": "Charles Calvius",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518329: {
    id: "item_6718",
    "Last Name": "Montisano",
    "First Name": "Riana Nusjirwan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518378: {
    id: "item_34048",
    "Last Name": "Williams",
    "First Name": "Kate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518405: {
    id: "item_34049",
    "Last Name": "SALIM",
    "First Name": "AZLAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518488: {
    id: "item_34050",
    "Last Name": "Wong",
    "First Name": "Sue Fern",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518505: {
    id: "item_34051",
    "Last Name": "Hartono",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518670: {
    id: "item_19584",
    "Last Name": "MAMAT RADUAN",
    "First Name": "SITI SHUHAIZAM",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518764: {
    id: "item_6719",
    "Last Name": "SUWEDYATAWON",
    "First Name": "WICHAI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518786: {
    id: "item_6720",
    "Last Name": "SUDIJONO",
    "First Name": "SLAMET",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518825: {
    id: "item_34052",
    "Last Name": "Widjaya tianotak",
    "First Name": "Jussri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42518894: {
    id: "item_6721",
    "Last Name": "Agustina",
    "First Name": "Uli",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42519049: {
    id: "item_19585",
    "Last Name": "CHAUHAN",
    "First Name": "AJAY",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42519070: {
    id: "item_8950",
    "Last Name": "ARITOME",
    "First Name": "SEIICHI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42519193: {
    id: "item_34053",
    "Last Name": "Trabanpreuk",
    "First Name": "Benjawan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42519496: {
    id: "item_32347",
    "Last Name": "Binte Mohamed",
    "First Name": "Salawati",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42519532: {
    id: "item_19586",
    "Last Name": "LAU",
    "First Name": "KOK XING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42519731: {
    id: "item_34054",
    "Last Name": "Bin Mohamed Zainal Abidin",
    "First Name": "Mohamad Ziad",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42520117: {
    id: "item_21441",
    "Last Name": "KURIZAKI",
    "First Name": "TAKASHI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42520430: {
    id: "item_6722",
    "Last Name": "Sani",
    "First Name": "Alya Rohali",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42520530: {
    id: "item_8951",
    "Last Name": "ACHDA",
    "First Name": "IRNAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42520581: {
    id: "item_6723",
    "Last Name": "Gusena",
    "First Name": "Andy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42521248: {
    id: "item_32348",
    "Last Name": "Limpikanjanakowit",
    "First Name": "Supreecha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42521502: {
    id: "item_8952",
    "Last Name": "Tara",
    "First Name": "Anastasia Elektria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42521929: {
    id: "item_34055",
    "Last Name": "Puritaningtyas",
    "First Name": "Ndarumas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42522214: {
    id: "item_6724",
    "Last Name": "Roberts",
    "First Name": "Adele",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42522462: {
    id: "item_32349",
    "Last Name": "Yap",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42522703: {
    id: "item_8953",
    "Last Name": "KUWAZURU",
    "First Name": "KEISUKE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42522827: {
    id: "item_19587",
    "Last Name": "AISYAH",
    "First Name": "ISMI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42523158: {
    id: "item_32350",
    "Last Name": "TAGUCHI",
    "First Name": "SHIMON",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42523276: {
    id: "item_6725",
    "Last Name": "Brauner",
    "First Name": "Roberta",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42523468: {
    id: "item_19588",
    "Last Name": "preechasammakul",
    "First Name": "Somkid",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42523781: {
    id: "item_32351",
    "Last Name": "Khoo",
    "First Name": "Hui Sing",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42524187: {
    id: "item_8954",
    "Last Name": "Karli",
    "First Name": "Jonny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42524598: {
    id: "item_6726",
    "Last Name": "Lai",
    "First Name": "Alie Makmur",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42525002: {
    id: "item_6727",
    "Last Name": "Cheng",
    "First Name": "Andrew Heng Jin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42525445: {
    id: "item_32352",
    "Last Name": "bayu putra",
    "First Name": "muhammad",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42526457: {
    id: "item_34056",
    "Last Name": "BIE KONG",
    "First Name": "BONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42526754: {
    id: "item_34057",
    "Last Name": "Sarkorntrakoon",
    "First Name": "Chonticha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42526956: {
    id: "item_8955",
    "Last Name": "Mohd Azmi",
    "First Name": "Muhd Izzat",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42527074: {
    id: "item_19589",
    "Last Name": "Kok",
    "First Name": "Yan Keong David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42528262: {
    id: "item_21442",
    "Last Name": "Moessner",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42528702: {
    id: "item_6728",
    "Last Name": "MacArthur",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42530432: {
    id: "item_8956",
    "Last Name": "Mildschuh",
    "First Name": "Stephan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42530583: {
    id: "item_34058",
    "Last Name": "Gates",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42531917: {
    id: "item_6729",
    "Last Name": "Alves Camargo Bley",
    "First Name": "Tatiana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42534216: {
    id: "item_8957",
    "Last Name": "Bauer",
    "First Name": "Franz",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42535553: {
    id: "item_32353",
    "Last Name": "Millar",
    "First Name": "Garth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42535714: {
    id: "item_8958",
    "Last Name": "Gazarkiewicz",
    "First Name": "Paula",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42535874: {
    id: "item_19590",
    "Last Name": "Metz",
    "First Name": "Meagan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42536021: {
    id: "item_8959",
    "Last Name": "Sigala",
    "First Name": "April",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42536023: {
    id: "item_6730",
    "Last Name": "Stroie",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42536062: {
    id: "item_32354",
    "Last Name": "Perry",
    "First Name": "Erica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42536103: {
    id: "item_32355",
    "Last Name": "Millar",
    "First Name": "Helena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42536152: {
    id: "item_6731",
    "Last Name": "Montgomery",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42536349: {
    id: "item_19591",
    "Last Name": "Mendes",
    "First Name": "Aldo Luiz",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42536533: {
    id: "item_6732",
    "Last Name": "Thangarasu",
    "First Name": "Dhanabalan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42536664: {
    id: "item_21443",
    "Last Name": "Swift",
    "First Name": "Lori",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42537057: {
    id: "item_6733",
    "Last Name": "Cambridge",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42537267: {
    id: "item_6734",
    "Last Name": "Loyd",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42537585: {
    id: "item_34059",
    "Last Name": "Suzuki",
    "First Name": "Staci",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42537715: {
    id: "item_19592",
    "Last Name": "Hanna",
    "First Name": "Carlie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42537826: {
    id: "item_6735",
    "Last Name": "Kelly",
    "First Name": "Ciaran",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42538314: {
    id: "item_8960",
    "Last Name": "Serrato",
    "First Name": "Oscar F",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42538576: {
    id: "item_6736",
    "Last Name": "Bailey",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42538704: {
    id: "item_19593",
    "Last Name": "Jackson",
    "First Name": "Janet Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42539494: {
    id: "item_8961",
    "Last Name": "Xue",
    "First Name": "Mengya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42539993: {
    id: "item_6737",
    "Last Name": "Biccai",
    "First Name": "Stefano",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42541468: {
    id: "item_19594",
    "Last Name": "Nio",
    "First Name": "Kusuma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42542268: {
    id: "item_32356",
    "Last Name": "Cheng",
    "First Name": "Chi Fung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42542784: {
    id: "item_8962",
    "Last Name": "Wong",
    "First Name": "Winnie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42543277: {
    id: "item_19595",
    "Last Name": "KIMURA",
    "First Name": "MIKA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42543407: {
    id: "item_19596",
    "Last Name": "KIMURA",
    "First Name": "HIROKAZU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42543873: {
    id: "item_34060",
    "Last Name": "Azlin",
    "First Name": "Amir",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42544171: {
    id: "item_34061",
    "Last Name": "NEZU",
    "First Name": "TAKAKO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42544194: {
    id: "item_32357",
    "Last Name": "Rujirawanichtep",
    "First Name": "Teelada",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42545001: {
    id: "item_6738",
    "Last Name": "SIREGAR",
    "First Name": "ANGKOLA OGESSARDO SIREGAR",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42545531: {
    id: "item_32358",
    "Last Name": "Trapla",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42546814: {
    id: "item_19597",
    "Last Name": "Dang",
    "First Name": "Lynn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42546904: {
    id: "item_8963",
    "Last Name": "Huff",
    "First Name": "Monica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42547648: {
    id: "item_19598",
    "Last Name": "Colwell",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42547688: {
    id: "item_32359",
    "Last Name": "Kaewpijit",
    "First Name": "Kasidit",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42548786: {
    id: "item_6739",
    "Last Name": "Cahill",
    "First Name": "Phil",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42548968: {
    id: "item_19599",
    "Last Name": "Bajumi",
    "First Name": "Irna Setiawati",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42549101: {
    id: "item_19600",
    "Last Name": "Walsh",
    "First Name": "Owen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42549356: {
    id: "item_6740",
    "Last Name": "Garcia Andres",
    "First Name": "Abel Roberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42549792: {
    id: "item_19601",
    "Last Name": "Bichler",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42550534: {
    id: "item_32360",
    "Last Name": "Wibowo",
    "First Name": "Ellena Patricia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42550639: {
    id: "item_34062",
    "Last Name": "Parks",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42550789: {
    id: "item_6741",
    "Last Name": "Cheng",
    "First Name": "Xu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42551596: {
    id: "item_6742",
    "Last Name": "Caba–es",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552328: {
    id: "item_8964",
    "Last Name": "Jelonek",
    "First Name": "Piotr",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552511: {
    id: "item_32361",
    "Last Name": "QIN",
    "First Name": "YANG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552549: {
    id: "item_8965",
    "Last Name": "Crotti",
    "First Name": "Luca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552605: {
    id: "item_6743",
    "Last Name": "Ko",
    "First Name": "Chiu Kelvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552678: {
    id: "item_19602",
    "Last Name": "Lee",
    "First Name": "Wai Choy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552701: {
    id: "item_6744",
    "Last Name": "YE",
    "First Name": "JINGHAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552769: {
    id: "item_21444",
    "Last Name": "KAM",
    "First Name": "KA IAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552802: {
    id: "item_34063",
    "Last Name": "Tik",
    "First Name": "Chi Yuen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552820: {
    id: "item_8966",
    "Last Name": "LAM",
    "First Name": "KA MING",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552931: {
    id: "item_6745",
    "Last Name": "Iao",
    "First Name": "Un Keong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552952: {
    id: "item_8967",
    "Last Name": "LIN",
    "First Name": "KUEI FENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42552961: {
    id: "item_6746",
    "Last Name": "CHIU",
    "First Name": "SHIHYING",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553083: {
    id: "item_6747",
    "Last Name": "chuang",
    "First Name": "yusheng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553142: {
    id: "item_6748",
    "Last Name": "LU",
    "First Name": "WENCHI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553313: {
    id: "item_6749",
    "Last Name": "Chiammanisakul",
    "First Name": "Picharat",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553338: {
    id: "item_19603",
    "Last Name": "HUANG",
    "First Name": "CHIEN-CHIH",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553361: {
    id: "item_6750",
    "Last Name": "CHUO",
    "First Name": "PEI YEN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553362: {
    id: "item_6751",
    "Last Name": "TSAI",
    "First Name": "FENGYI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553425: {
    id: "item_6752",
    "Last Name": "LIN",
    "First Name": "MEI LING",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553444: {
    id: "item_19604",
    "Last Name": "Yonatan",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553459: {
    id: "item_34064",
    "Last Name": "SHARIZAILA",
    "First Name": "ZAIDI BIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553496: {
    id: "item_6753",
    "Last Name": "LIAO",
    "First Name": "HANYU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553515: {
    id: "item_8968",
    "Last Name": "Kandoly",
    "First Name": "Arvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553543: {
    id: "item_34065",
    "Last Name": "Pawan Teh",
    "First Name": "Farisha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553592: {
    id: "item_6754",
    "Last Name": "Rodber",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553612: {
    id: "item_8969",
    "Last Name": "Horthammarat",
    "First Name": "Chaiwat",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553654: {
    id: "item_19605",
    "Last Name": "BAI",
    "First Name": "HETING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553744: {
    id: "item_32362",
    "Last Name": "Harun",
    "First Name": "Rayandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553751: {
    id: "item_8970",
    "Last Name": "Ricambi",
    "First Name": "Stopira",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553811: {
    id: "item_34066",
    "Last Name": "zhu",
    "First Name": "xiaohui",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553841: {
    id: "item_6755",
    "Last Name": "Jackson-Jones",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553900: {
    id: "item_32363",
    "Last Name": "HASUI",
    "First Name": "YOSHINORI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42553975: {
    id: "item_6756",
    "Last Name": "CHANG",
    "First Name": "TZU PING",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554056: {
    id: "item_32364",
    "Last Name": "TANK",
    "First Name": "SHIHKAI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554146: {
    id: "item_19606",
    "Last Name": "John",
    "First Name": "Henry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554204: {
    id: "item_8971",
    "Last Name": "Wolf",
    "First Name": "Lars",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554428: {
    id: "item_8972",
    "Last Name": "Djohan",
    "First Name": "Jacky",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554523: {
    id: "item_8973",
    "Last Name": "Annas",
    "First Name": "Akhmad Taufiq",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554627: {
    id: "item_19607",
    "Last Name": "Kamolchanokkul",
    "First Name": "Boonlert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554628: {
    id: "item_6757",
    "Last Name": "ZHANG",
    "First Name": "MINHUI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554636: {
    id: "item_8974",
    "Last Name": "Sudiyanto",
    "First Name": "Bambang Tandu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554646: {
    id: "item_34067",
    "Last Name": "Siriwat",
    "First Name": "Parin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554728: {
    id: "item_32365",
    "Last Name": "Cao",
    "First Name": "Yifan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554738: {
    id: "item_8975",
    "Last Name": "Tungadi",
    "First Name": "Thoeng Clinton",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554779: {
    id: "item_34068",
    "Last Name": "YOSHITOMI",
    "First Name": "KAZUHIRO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554961: {
    id: "item_19608",
    "Last Name": "SUGIYAMA",
    "First Name": "TSUTOMU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42554993: {
    id: "item_8976",
    "Last Name": "Gupta",
    "First Name": "Ranjini",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42555097: {
    id: "item_34069",
    "Last Name": "YAKHAM",
    "First Name": "ROTJANA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42555366: {
    id: "item_6758",
    "Last Name": "Marynczak",
    "First Name": "Tomasz",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42556117: {
    id: "item_19609",
    "Last Name": "BRAGA FILHO",
    "First Name": "JOSE EDUARDO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42556452: {
    id: "item_8977",
    "Last Name": "Tungerapan",
    "First Name": "Alfred",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42557321: {
    id: "item_19610",
    "Last Name": "QUEIROZ DE AZEVEDO",
    "First Name": "JOAO ROBERTO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42559612: {
    id: "item_19611",
    "Last Name": "Suyanto",
    "First Name": "Robby",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42562193: {
    id: "item_19612",
    "Last Name": "Costa",
    "First Name": "Cleverson Manoel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42562832: {
    id: "item_19613",
    "Last Name": "Wijaya",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42565801: {
    id: "item_19614",
    "Last Name": "Piboonwattanawong",
    "First Name": "Pichet",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42569723: {
    id: "item_19615",
    "Last Name": "Boosten",
    "First Name": "Ruddi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42572107: {
    id: "item_8978",
    "Last Name": "ANDRADE",
    "First Name": "DALTON",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42572116: {
    id: "item_8979",
    "Last Name": "CHEN",
    "First Name": "HSINHUNG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42572284: {
    id: "item_32366",
    "Last Name": "khoo",
    "First Name": "Edward Ting Lee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42572346: {
    id: "item_6759",
    "Last Name": "wu",
    "First Name": "chihao",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42572438: {
    id: "item_19616",
    "Last Name": "Sampaio",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42578057: {
    id: "item_8980",
    "Last Name": "De Moura",
    "First Name": "Jonas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42581874: {
    id: "item_6760",
    "Last Name": "CHANG",
    "First Name": "SHIH-MENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42588724: {
    id: "item_6761",
    "Last Name": "Luo",
    "First Name": "Jiali",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42589028: {
    id: "item_19617",
    "Last Name": "Kamolchanokkul",
    "First Name": "Ratchaporn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42591785: {
    id: "item_34070",
    "Last Name": "Thongyot",
    "First Name": "Khunakorn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42592050: {
    id: "item_19618",
    "Last Name": "Yanny",
    "First Name": "Shilsi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42592528: {
    id: "item_8981",
    "Last Name": "Peng",
    "First Name": "Yuting",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42593632: {
    id: "item_8982",
    "Last Name": "Bastrash",
    "First Name": "Ive",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42593690: {
    id: "item_21445",
    "Last Name": "Jaco",
    "First Name": "Mart’n",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42593692: {
    id: "item_6762",
    "Last Name": "hong",
    "First Name": "ming jun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42593722: {
    id: "item_32367",
    "Last Name": "Lim",
    "First Name": "Valerie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42593893: {
    id: "item_19619",
    "Last Name": "Irawan",
    "First Name": "Prawindra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42594004: {
    id: "item_6763",
    "Last Name": "FETRIZA",
    "First Name": "FETRIZA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42594516: {
    id: "item_19620",
    "Last Name": "CHAN",
    "First Name": "WENG PUI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42594698: {
    id: "item_6764",
    "Last Name": "Leung",
    "First Name": "Marcus Tsun Kit",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42594740: {
    id: "item_19621",
    "Last Name": "OR",
    "First Name": "KUOK CHENG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42594755: {
    id: "item_19622",
    "Last Name": "Huter",
    "First Name": "Eberhard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42594786: {
    id: "item_6765",
    "Last Name": "Keay",
    "First Name": "Susan Margaret",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42594901: {
    id: "item_19623",
    "Last Name": "Chan",
    "First Name": "Po King",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42594971: {
    id: "item_19624",
    "Last Name": "Hossepian Lima",
    "First Name": "reinaldo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42595675: {
    id: "item_19625",
    "Last Name": "Lam",
    "First Name": "Ching Ho",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42595741: {
    id: "item_32368",
    "Last Name": "Moore",
    "First Name": "Jillian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42595820: {
    id: "item_8983",
    "Last Name": "Gattas",
    "First Name": "Agustin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42595832: {
    id: "item_19626",
    "Last Name": "Delgado",
    "First Name": "Denise Maria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42595961: {
    id: "item_6766",
    "Last Name": "Sinaga",
    "First Name": "Andar Ramona",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42596425: {
    id: "item_6767",
    "Last Name": "De Oliveira",
    "First Name": "Iwahnoer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42596682: {
    id: "item_6768",
    "Last Name": "Gonzalez",
    "First Name": "Hazael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42596836: {
    id: "item_21446",
    "Last Name": "Sollich",
    "First Name": "Lucia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42597494: {
    id: "item_19627",
    "Last Name": "perez",
    "First Name": "braulio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42597824: {
    id: "item_19628",
    "Last Name": "KANAI",
    "First Name": "RYOSHIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42598027: {
    id: "item_8984",
    "Last Name": "Ma",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42598184: {
    id: "item_8985",
    "Last Name": "Preslaski",
    "First Name": "Candice",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42599089: {
    id: "item_19629",
    "Last Name": "Gamez",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42599091: {
    id: "item_8986",
    "Last Name": "Chen",
    "First Name": "En Chia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42599206: {
    id: "item_19630",
    "Last Name": "Laurel",
    "First Name": "Raymund",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42599256: {
    id: "item_8987",
    "Last Name": "Gomes",
    "First Name": "Herivelto F",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42599644: {
    id: "item_21447",
    "Last Name": "medellin perez",
    "First Name": "Jose Luis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42601420: {
    id: "item_6769",
    "Last Name": "SALOM PORTELLA",
    "First Name": "LUIS JOSE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42602067: {
    id: "item_34071",
    "Last Name": "Wong",
    "First Name": "Kit Moon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42602101: {
    id: "item_19631",
    "Last Name": "de Sousa Paes Landim",
    "First Name": "Cristiano",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42602623: {
    id: "item_32369",
    "Last Name": "Phitakraxanti",
    "First Name": "Taj",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42603970: {
    id: "item_19632",
    "Last Name": "IORIS",
    "First Name": "NEILA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42604041: {
    id: "item_6770",
    "Last Name": "ZAOUDI",
    "First Name": "Said",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42605576: {
    id: "item_19633",
    "Last Name": "Santiago Gonz‡lez",
    "First Name": "Freyda H",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42605895: {
    id: "item_6771",
    "Last Name": "Bley",
    "First Name": "Tatiana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42606087: {
    id: "item_32370",
    "Last Name": "YU",
    "First Name": "YAO-CHUNG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42606089: {
    id: "item_32371",
    "Last Name": "HSU",
    "First Name": "PING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42606432: {
    id: "item_32372",
    "Last Name": "Hartnett",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42606754: {
    id: "item_19634",
    "Last Name": "Llamas",
    "First Name": "Beatrice",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42607162: {
    id: "item_6772",
    "Last Name": "Bley Filho",
    "First Name": "Ubirajara",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42607699: {
    id: "item_6773",
    "Last Name": "Rozza",
    "First Name": "Ana Lucia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42609285: {
    id: "item_19635",
    "Last Name": "BELLINATI GARCIA PEREZ",
    "First Name": "FLAVIANO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42610222: {
    id: "item_6774",
    "Last Name": "Ananta",
    "First Name": "Yovita",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42611211: {
    id: "item_19636",
    "Last Name": "CAVALCANTE AMORIM",
    "First Name": "GERALDO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42611321: {
    id: "item_19637",
    "Last Name": "Gois",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42612966: {
    id: "item_19638",
    "Last Name": "HO",
    "First Name": "SUT IM",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42612990: {
    id: "item_34072",
    "Last Name": "Gouveia",
    "First Name": "Roslaine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42613143: {
    id: "item_19639",
    "Last Name": "Tom",
    "First Name": "Johnathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42613474: {
    id: "item_34073",
    "Last Name": "Bailey",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42613620: {
    id: "item_8988",
    "Last Name": "YIN",
    "First Name": "HONGMEI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42613794: {
    id: "item_19640",
    "Last Name": "LEE",
    "First Name": "SHU-CHING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42613869: {
    id: "item_32373",
    "Last Name": "Hong",
    "First Name": "Tin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42614001: {
    id: "item_32374",
    "Last Name": "HE",
    "First Name": "JIANMIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42614087: {
    id: "item_19641",
    "Last Name": "LIN",
    "First Name": "MAO SUNG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42614589: {
    id: "item_34074",
    "Last Name": "YEUNG",
    "First Name": "CHEUK KIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42614797: {
    id: "item_6775",
    "Last Name": "CHEN",
    "First Name": "XINGYU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42615506: {
    id: "item_6776",
    "Last Name": "Xu",
    "First Name": "Liang Gen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42615846: {
    id: "item_21448",
    "Last Name": "Tong",
    "First Name": "Jianqin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42616268: {
    id: "item_19642",
    "Last Name": "Song",
    "First Name": "Mingxuan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42616468: {
    id: "item_32375",
    "Last Name": "PENG",
    "First Name": "ZHENGYU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42616506: {
    id: "item_8989",
    "Last Name": "sanchez moyano",
    "First Name": "angelica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42616561: {
    id: "item_8990",
    "Last Name": "Quek",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42616748: {
    id: "item_34075",
    "Last Name": "Liu",
    "First Name": "Yu-Ching",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42616829: {
    id: "item_8991",
    "Last Name": "Yeung",
    "First Name": "Oi Win",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617099: {
    id: "item_34076",
    "Last Name": "Waiyachai",
    "First Name": "Baifern",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617102: {
    id: "item_34077",
    "Last Name": "Saedan",
    "First Name": "Surat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617255: {
    id: "item_34078",
    "Last Name": "WONGKRAJANG",
    "First Name": "INTIMA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617284: {
    id: "item_6777",
    "Last Name": "Mandawi",
    "First Name": "Nurni Mesya Sintha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617388: {
    id: "item_19643",
    "Last Name": "Pan",
    "First Name": "Yueh Jung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617759: {
    id: "item_34079",
    "Last Name": "widjaja",
    "First Name": "adi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617866: {
    id: "item_19644",
    "Last Name": "KU",
    "First Name": "Chia-tien",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617882: {
    id: "item_34080",
    "Last Name": "fanny",
    "First Name": "dessy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617925: {
    id: "item_19645",
    "Last Name": "Roy",
    "First Name": "Sukanto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42617988: {
    id: "item_6778",
    "Last Name": "Rahmawati",
    "First Name": "Riska",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42618106: {
    id: "item_32376",
    "Last Name": "LI",
    "First Name": "TSZ SHING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42618315: {
    id: "item_19646",
    "Last Name": "Nagal",
    "First Name": "Josephine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42618351: {
    id: "item_8992",
    "Last Name": "Chiu",
    "First Name": "Carey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42618380: {
    id: "item_32377",
    "Last Name": "Chew",
    "First Name": "Bee Lin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42618412: {
    id: "item_19647",
    "Last Name": "HAN",
    "First Name": "YING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42618589: {
    id: "item_34081",
    "Last Name": "Safitri",
    "First Name": "Asti Diar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42618663: {
    id: "item_19648",
    "Last Name": "Satasook",
    "First Name": "Keerati",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42620796: {
    id: "item_19649",
    "Last Name": "shao",
    "First Name": "junwei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42623286: {
    id: "item_21449",
    "Last Name": "Bognar",
    "First Name": "Tamas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631038: {
    id: "item_21450",
    "Last Name": "Rajani",
    "First Name": "Prem",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631144: {
    id: "item_32378",
    "Last Name": "Setiawan",
    "First Name": "Henry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631157: {
    id: "item_19650",
    "Last Name": "Chen",
    "First Name": "Guosheng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631218: {
    id: "item_34082",
    "Last Name": "Wirya",
    "First Name": "Nike kurniasari",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631257: {
    id: "item_19651",
    "Last Name": "HUANG",
    "First Name": "CHI YEH",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631346: {
    id: "item_34083",
    "Last Name": "Pramedi",
    "First Name": "Dudi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631404: {
    id: "item_34084",
    "Last Name": "Yakub",
    "First Name": "Mohd Azhari bin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631425: {
    id: "item_34085",
    "Last Name": "Hidayat",
    "First Name": "Andri Krisna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631469: {
    id: "item_19652",
    "Last Name": "Peel",
    "First Name": "Kate",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631487: {
    id: "item_34086",
    "Last Name": "Basra",
    "First Name": "Ihsan Prima",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631583: {
    id: "item_6779",
    "Last Name": "Hall",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631607: {
    id: "item_34087",
    "Last Name": "Prasadtyo",
    "First Name": "Ken",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631632: {
    id: "item_8993",
    "Last Name": "Chaniago",
    "First Name": "Adryansyah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631676: {
    id: "item_19653",
    "Last Name": "Stephanus",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631743: {
    id: "item_21451",
    "Last Name": "Jacobs-Cooke",
    "First Name": "Karen Lee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631750: {
    id: "item_19654",
    "Last Name": "Simons",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631803: {
    id: "item_34088",
    "Last Name": "Martin",
    "First Name": "Marlena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631825: {
    id: "item_19655",
    "Last Name": "A–o Sais",
    "First Name": "Ernesto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631965: {
    id: "item_19656",
    "Last Name": "YANG",
    "First Name": "HONGBIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42631986: {
    id: "item_21452",
    "Last Name": "Khaleel",
    "First Name": "Abdulla",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42632013: {
    id: "item_6780",
    "Last Name": "CHEN",
    "First Name": "HUI JU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42632073: {
    id: "item_6781",
    "Last Name": "HU",
    "First Name": "MEI-LING",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42632102: {
    id: "item_34089",
    "Last Name": "PEREIRA DA SILVA",
    "First Name": "JOAO CARLOS",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42632136: {
    id: "item_34090",
    "Last Name": "cavalcanti",
    "First Name": "lia penteado",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42632139: {
    id: "item_19657",
    "Last Name": "Ning",
    "First Name": "Shur-Fen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42632268: {
    id: "item_6782",
    "Last Name": "Li",
    "First Name": "Weifeng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42632368: {
    id: "item_19658",
    "Last Name": "Jiang",
    "First Name": "Ting",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42635572: {
    id: "item_19659",
    "Last Name": "LI",
    "First Name": "HSIAO-CHUN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42643682: {
    id: "item_6783",
    "Last Name": "liao",
    "First Name": "qian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42644456: {
    id: "item_19660",
    "Last Name": "xu",
    "First Name": "mingfa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42645278: {
    id: "item_6784",
    "Last Name": "YAO",
    "First Name": "SHI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42645296: {
    id: "item_19661",
    "Last Name": "Alisjahbana",
    "First Name": "Andi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42645309: {
    id: "item_19662",
    "Last Name": "Hungerford",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42645335: {
    id: "item_19663",
    "Last Name": "MA",
    "First Name": "MENGNAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42645541: {
    id: "item_19664",
    "Last Name": "CAO",
    "First Name": "SHUCHAO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42645582: {
    id: "item_6785",
    "Last Name": "HITA RODRIGUEZ",
    "First Name": "LIDIA FERNANDA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42645848: {
    id: "item_8994",
    "Last Name": "Mahna",
    "First Name": "Gokul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42645961: {
    id: "item_34091",
    "Last Name": "Sani",
    "First Name": "Dinda Abdullah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646062: {
    id: "item_32379",
    "Last Name": "LIU",
    "First Name": "WEI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646105: {
    id: "item_6786",
    "Last Name": "JULKA",
    "First Name": "KUNAL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646164: {
    id: "item_8995",
    "Last Name": "WU",
    "First Name": "SHOUQIU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646314: {
    id: "item_19665",
    "Last Name": "Zhou",
    "First Name": "Xin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646328: {
    id: "item_19666",
    "Last Name": "Zhai",
    "First Name": "Wei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646459: {
    id: "item_6787",
    "Last Name": "Zhang",
    "First Name": "Zhiyan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646595: {
    id: "item_19667",
    "Last Name": "Li",
    "First Name": "zhusong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646597: {
    id: "item_19668",
    "Last Name": "Frenky",
    "First Name": "Frenky",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646606: {
    id: "item_19669",
    "Last Name": "LIU",
    "First Name": "YING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646659: {
    id: "item_6788",
    "Last Name": "HERMO MUGICA",
    "First Name": "NEREA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646702: {
    id: "item_19670",
    "Last Name": "Lee",
    "First Name": "Tzu Chin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646736: {
    id: "item_19671",
    "Last Name": "ZHANG",
    "First Name": "XINGQIANG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646765: {
    id: "item_6789",
    "Last Name": "Tieu",
    "First Name": "Xue Yuan Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42646830: {
    id: "item_19672",
    "Last Name": "Qin",
    "First Name": "Jun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647317: {
    id: "item_19673",
    "Last Name": "MADRIDEJOS FERNANDEZ",
    "First Name": "SANTIAGO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647377: {
    id: "item_19674",
    "Last Name": "CHEN",
    "First Name": "QUNCHANG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647405: {
    id: "item_34092",
    "Last Name": "tan",
    "First Name": "Mui Meng Raymond",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647450: {
    id: "item_19675",
    "Last Name": "Agustini",
    "First Name": "Lia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647456: {
    id: "item_8996",
    "Last Name": "Hakim",
    "First Name": "Mirza Aditya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647475: {
    id: "item_34093",
    "Last Name": "Nugroho",
    "First Name": "Yudhistiro Andri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647476: {
    id: "item_6790",
    "Last Name": "YU",
    "First Name": "TAO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647626: {
    id: "item_19676",
    "Last Name": "NIU",
    "First Name": "HAILONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647750: {
    id: "item_19677",
    "Last Name": "MA",
    "First Name": "SHENGZE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42647852: {
    id: "item_6791",
    "Last Name": "HUANG",
    "First Name": "TANGHONG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42648031: {
    id: "item_6792",
    "Last Name": "LYU",
    "First Name": "XINFU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42648074: {
    id: "item_32380",
    "Last Name": "Lee",
    "First Name": "Hooi Gzan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42648921: {
    id: "item_19678",
    "Last Name": "GONZALEZ MURILLO",
    "First Name": "MARIA FERNANDA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42648924: {
    id: "item_19679",
    "Last Name": "TJITRADI",
    "First Name": "ARMAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42649024: {
    id: "item_32381",
    "Last Name": "Bin Mohd Ghazi",
    "First Name": "Azmee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42649485: {
    id: "item_21453",
    "Last Name": "Huang",
    "First Name": "Ailan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42649976: {
    id: "item_34094",
    "Last Name": "Tham",
    "First Name": "Lai Lai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42650011: {
    id: "item_19680",
    "Last Name": "Tantisuwat",
    "First Name": "Anong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42650138: {
    id: "item_34095",
    "Last Name": "Yahaya",
    "First Name": "Youhaniz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42650694: {
    id: "item_32382",
    "Last Name": "Widyaningrum",
    "First Name": "Silvy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42650795: {
    id: "item_19681",
    "Last Name": "ZAINUDDIN",
    "First Name": "ZULFIQAR BIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42651049: {
    id: "item_19682",
    "Last Name": "WONGSAVAT",
    "First Name": "WIWATH",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42651079: {
    id: "item_34096",
    "Last Name": "Viswanathan",
    "First Name": "Sita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42651249: {
    id: "item_8997",
    "Last Name": "Gonzalez Arias",
    "First Name": "Isidro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42651448: {
    id: "item_8998",
    "Last Name": "Palanisamy",
    "First Name": "Karthikeyan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42651464: {
    id: "item_32383",
    "Last Name": "Pai",
    "First Name": "Amol",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42652290: {
    id: "item_21454",
    "Last Name": "Urban",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42653118: {
    id: "item_6793",
    "Last Name": "BERNABE",
    "First Name": "CRISTOBAL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42653820: {
    id: "item_32384",
    "Last Name": "OSORIO GONZALEZ",
    "First Name": "FERNANDO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42654631: {
    id: "item_21455",
    "Last Name": "Preter",
    "First Name": "Serge",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42655069: {
    id: "item_6794",
    "Last Name": "garnett",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42655462: {
    id: "item_19683",
    "Last Name": "MASSAGLI",
    "First Name": "CLAUDIO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42656603: {
    id: "item_6795",
    "Last Name": "Illescas",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42657205: {
    id: "item_32385",
    "Last Name": "VARGAS ESCOBEDO",
    "First Name": "MARIA EUGENIA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42657924: {
    id: "item_19684",
    "Last Name": "Uden",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42659256: {
    id: "item_19685",
    "Last Name": "Andujar Lazaro",
    "First Name": "Francisco Jose",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42660515: {
    id: "item_6796",
    "Last Name": "RAMIREZ PICHARDO",
    "First Name": "DULCE MARIA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42661703: {
    id: "item_34097",
    "Last Name": "RIVERA CASTA„EDA",
    "First Name": "MARCOS",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42662343: {
    id: "item_8999",
    "Last Name": "Rahman",
    "First Name": "Sunmbul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42662731: {
    id: "item_6797",
    "Last Name": "Suvagondha",
    "First Name": "Worawat",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42663206: {
    id: "item_32386",
    "Last Name": "TRAKULTRAIPRUK",
    "First Name": "WATCHAREE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42663818: {
    id: "item_9000",
    "Last Name": "Tan",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42663981: {
    id: "item_32387",
    "Last Name": "Rahadini",
    "First Name": "Ade",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42664349: {
    id: "item_6798",
    "Last Name": "Wan",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42665445: {
    id: "item_6799",
    "Last Name": "Cahyadi",
    "First Name": "Gunawan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42665655: {
    id: "item_34098",
    "Last Name": "effendi",
    "First Name": "wiwin is",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42667453: {
    id: "item_19686",
    "Last Name": "Sanches",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42667626: {
    id: "item_34099",
    "Last Name": "Sulthon",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42667773: {
    id: "item_19687",
    "Last Name": "Lee",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42667837: {
    id: "item_34100",
    "Last Name": "Soyka",
    "First Name": "Sydnie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42668036: {
    id: "item_32388",
    "Last Name": "Isaac",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42668352: {
    id: "item_19688",
    "Last Name": "Rivera",
    "First Name": "Katrina Isabelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42668358: {
    id: "item_34101",
    "Last Name": "Weiler",
    "First Name": "Angelica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42668498: {
    id: "item_34102",
    "Last Name": "Christyanti",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42668500: {
    id: "item_32389",
    "Last Name": "Mandat",
    "First Name": "Liane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42668676: {
    id: "item_19689",
    "Last Name": "CHEN",
    "First Name": "WEI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42668699: {
    id: "item_32390",
    "Last Name": "ASSUNTAJAI",
    "First Name": "BOONRIT",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42668724: {
    id: "item_19690",
    "Last Name": "Eng",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42668754: {
    id: "item_9001",
    "Last Name": "Buddhaboonyaras",
    "First Name": "Thanawatt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42669001: {
    id: "item_34103",
    "Last Name": "Lovering",
    "First Name": "Mackenzie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42669814: {
    id: "item_19691",
    "Last Name": "Lai",
    "First Name": "Lijing",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42670142: {
    id: "item_32391",
    "Last Name": "Samuel",
    "First Name": "Richard Morgan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42670439: {
    id: "item_19692",
    "Last Name": "Zeng",
    "First Name": "Jiming",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42670756: {
    id: "item_19693",
    "Last Name": "Fitzpatrick",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42670806: {
    id: "item_32392",
    "Last Name": "SHIROKANE",
    "First Name": "YOSHIO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42671901: {
    id: "item_34104",
    "Last Name": "Kandiban",
    "First Name": "Puvaneswary",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42672397: {
    id: "item_6800",
    "Last Name": "YANG",
    "First Name": "CHING-AN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42672588: {
    id: "item_32393",
    "Last Name": "Chung",
    "First Name": "Tak Wai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42672701: {
    id: "item_32394",
    "Last Name": "YDIA",
    "First Name": "DEMOSTHENES",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42672993: {
    id: "item_6801",
    "Last Name": "Tansol",
    "First Name": "Christiano",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42673188: {
    id: "item_6802",
    "Last Name": "SHEN",
    "First Name": "PINJU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42673333: {
    id: "item_32395",
    "Last Name": "Wetti",
    "First Name": "Nita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42673386: {
    id: "item_6803",
    "Last Name": "Qiu",
    "First Name": "Dong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42673503: {
    id: "item_32396",
    "Last Name": "NG",
    "First Name": "Ching Hiong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42673591: {
    id: "item_21456",
    "Last Name": "BI",
    "First Name": "XUETAO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42673683: {
    id: "item_6804",
    "Last Name": "Bull",
    "First Name": "Clarke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42673704: {
    id: "item_6805",
    "Last Name": "Kato",
    "First Name": "Yuki",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42673958: {
    id: "item_9002",
    "Last Name": "Tjhang",
    "First Name": "Iwan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674047: {
    id: "item_6806",
    "Last Name": "Anderson",
    "First Name": "Ng David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674114: {
    id: "item_21457",
    "Last Name": "Nen",
    "First Name": "Ho Bui",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674154: {
    id: "item_6807",
    "Last Name": "Kartono",
    "First Name": "Kartono",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674180: {
    id: "item_6808",
    "Last Name": "Lie",
    "First Name": "Sugiarto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674234: {
    id: "item_19694",
    "Last Name": "HUANG",
    "First Name": "CHIN LIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674270: {
    id: "item_34105",
    "Last Name": "Cabral",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674286: {
    id: "item_19695",
    "Last Name": "Gapido",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674304: {
    id: "item_21458",
    "Last Name": "John",
    "First Name": "Sajeev",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674702: {
    id: "item_19696",
    "Last Name": "CHUNG",
    "First Name": "YAO-TANG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674732: {
    id: "item_34106",
    "Last Name": "WU",
    "First Name": "YONGJIE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674756: {
    id: "item_6809",
    "Last Name": "HSIAO",
    "First Name": "SHENG-HSUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674767: {
    id: "item_19697",
    "Last Name": "Musparno",
    "First Name": "Adi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674808: {
    id: "item_32397",
    "Last Name": "Rickard",
    "First Name": "Louise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674812: {
    id: "item_19698",
    "Last Name": "CHEN",
    "First Name": "YU-HSIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674879: {
    id: "item_19699",
    "Last Name": "Mirasari",
    "First Name": "Rita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674931: {
    id: "item_6810",
    "Last Name": "HUANG",
    "First Name": "GUISHENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674966: {
    id: "item_6811",
    "Last Name": "Bagga",
    "First Name": "Ranbir Singh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42674999: {
    id: "item_34107",
    "Last Name": "Serios",
    "First Name": "Vorada",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675011: {
    id: "item_19700",
    "Last Name": "Rezadi",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675025: {
    id: "item_6812",
    "Last Name": "CHEN",
    "First Name": "CHENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675210: {
    id: "item_19701",
    "Last Name": "Giegerich",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675318: {
    id: "item_6813",
    "Last Name": "CHIH HAUR",
    "First Name": "TAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675329: {
    id: "item_19702",
    "Last Name": "IGLESIAS",
    "First Name": "Mariano Oscar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675452: {
    id: "item_32398",
    "Last Name": "Ho",
    "First Name": "Ngai Sum",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675512: {
    id: "item_32399",
    "Last Name": "Tucker",
    "First Name": "Brian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675639: {
    id: "item_6814",
    "Last Name": "ZHU",
    "First Name": "JIACHUAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675751: {
    id: "item_34108",
    "Last Name": "Magno",
    "First Name": "Janice",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675755: {
    id: "item_6815",
    "Last Name": "Patil",
    "First Name": "Hardik",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675811: {
    id: "item_34109",
    "Last Name": "Follett",
    "First Name": "Kendra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675874: {
    id: "item_21459",
    "Last Name": "Khaleequzzaman",
    "First Name": "Tausifuzzaman",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42675932: {
    id: "item_34110",
    "Last Name": "Kalidindi",
    "First Name": "Anuradha Raju",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42676040: {
    id: "item_6816",
    "Last Name": "Khanal",
    "First Name": "Yubaraj",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42676379: {
    id: "item_19703",
    "Last Name": "Kapali",
    "First Name": "Aravind",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42676806: {
    id: "item_19704",
    "Last Name": "Marques Junior",
    "First Name": "Nailor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42677575: {
    id: "item_19705",
    "Last Name": "Maranan",
    "First Name": "Danisel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42679539: {
    id: "item_6817",
    "Last Name": "ZHAO",
    "First Name": "ZHIWEI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42682539: {
    id: "item_32400",
    "Last Name": "CHEN",
    "First Name": "TING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42683317: {
    id: "item_34111",
    "Last Name": "JUAN",
    "First Name": "HEE KIANG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42684757: {
    id: "item_34112",
    "Last Name": "Pai",
    "First Name": "Nutan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42684950: {
    id: "item_19706",
    "Last Name": "Mathur",
    "First Name": "Ambrish",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42685609: {
    id: "item_6818",
    "Last Name": "Hwang",
    "First Name": "Shin Young",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42685934: {
    id: "item_34113",
    "Last Name": "Mun Wai",
    "First Name": "Wong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42687091: {
    id: "item_34114",
    "Last Name": "Philipose",
    "First Name": "Thoppil Reba",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42687272: {
    id: "item_6819",
    "Last Name": "Chaudhary",
    "First Name": "Sonukumar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42687392: {
    id: "item_21460",
    "Last Name": "Barni",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42687627: {
    id: "item_6820",
    "Last Name": "Ricketts",
    "First Name": "Colin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42688314: {
    id: "item_19707",
    "Last Name": "gajulapalle",
    "First Name": "Vish",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42690807: {
    id: "item_32401",
    "Last Name": "RAMOS",
    "First Name": "JOSE JESUS PASCUAL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42691085: {
    id: "item_32402",
    "Last Name": "Andini",
    "First Name": "Dina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42691808: {
    id: "item_19708",
    "Last Name": "Arenas",
    "First Name": "Cecilia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42692299: {
    id: "item_6821",
    "Last Name": "Pavia Merin",
    "First Name": "Jesus Amor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42692639: {
    id: "item_32403",
    "Last Name": "SQUIZZATO",
    "First Name": "ONIVALDO JOSE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42693974: {
    id: "item_9003",
    "Last Name": "DINIZ",
    "First Name": "JOSE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42694075: {
    id: "item_32404",
    "Last Name": "Yau",
    "First Name": "Marie Jane",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42694151: {
    id: "item_6822",
    "Last Name": "Knitter",
    "First Name": "Konrad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42694329: {
    id: "item_34115",
    "Last Name": "DOMINGUEZ",
    "First Name": "JOHN APRIL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42694493: {
    id: "item_6823",
    "Last Name": "Van den bosch",
    "First Name": "Cornelis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42694953: {
    id: "item_19709",
    "Last Name": "Geyman",
    "First Name": "Ella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42694959: {
    id: "item_32405",
    "Last Name": "Ray",
    "First Name": "Nirjhar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42696150: {
    id: "item_34116",
    "Last Name": "Burusphat",
    "First Name": "Chantavudh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42696646: {
    id: "item_9004",
    "Last Name": "ROBALINO",
    "First Name": "CLAUDIA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42696884: {
    id: "item_19711",
    "Last Name": "Rex",
    "First Name": "Valentin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42696886: {
    id: "item_19710",
    "Last Name": "Hoefer",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42696969: {
    id: "item_19712",
    "Last Name": "PIMENTEL",
    "First Name": "PAULO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42698413: {
    id: "item_6824",
    "Last Name": "STEFANO",
    "First Name": "RENE ALBERTO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42698701: {
    id: "item_21461",
    "Last Name": "Rimari",
    "First Name": "Ernesto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42698714: {
    id: "item_21462",
    "Last Name": "Cardenas Pinzon",
    "First Name": "Clara Ines",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42698820: {
    id: "item_19713",
    "Last Name": "MATEOS",
    "First Name": "JESUS",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42698962: {
    id: "item_19714",
    "Last Name": "Weng",
    "First Name": "Naidong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42699158: {
    id: "item_34117",
    "Last Name": "Weng",
    "First Name": "Helen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42699455: {
    id: "item_6825",
    "Last Name": "Zalewski",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42699751: {
    id: "item_34118",
    "Last Name": "Jantarang",
    "First Name": "Sittiporn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42701006: {
    id: "item_9005",
    "Last Name": "Safyanovskiy",
    "First Name": "Vlad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42701399: {
    id: "item_21463",
    "Last Name": "hoffmann coldibelli",
    "First Name": "eliana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42701586: {
    id: "item_21464",
    "Last Name": "COLDIBELLI",
    "First Name": "ADAUTO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42701782: {
    id: "item_9006",
    "Last Name": "Loiacono",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42703477: {
    id: "item_34119",
    "Last Name": "Groth",
    "First Name": "Stevin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42703508: {
    id: "item_32406",
    "Last Name": "MOHAMMED ILYAS",
    "First Name": "MOHAMMED IBRAHIM",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42703691: {
    id: "item_19715",
    "Last Name": "Zalewski",
    "First Name": "Meg",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42704892: {
    id: "item_9007",
    "Last Name": "Rusli",
    "First Name": "Harimurty",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42705171: {
    id: "item_34120",
    "Last Name": "Barr",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42705267: {
    id: "item_34121",
    "Last Name": "Deleon",
    "First Name": "Ingrid",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42706291: {
    id: "item_34122",
    "Last Name": "PASION",
    "First Name": "RONALD",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42706536: {
    id: "item_34123",
    "Last Name": "Tinio",
    "First Name": "Albert Raymund",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42706568: {
    id: "item_34124",
    "Last Name": "Hampton",
    "First Name": "Sonia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42707132: {
    id: "item_19716",
    "Last Name": "LIAO",
    "First Name": "CHIH-SHENG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42707269: {
    id: "item_19717",
    "Last Name": "LIN",
    "First Name": "FEN-LAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42708028: {
    id: "item_19718",
    "Last Name": "Anggreini",
    "First Name": "Risa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42708327: {
    id: "item_34125",
    "Last Name": "SAWA",
    "First Name": "AKINOBU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42708585: {
    id: "item_6826",
    "Last Name": "Legge",
    "First Name": "Logan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42708842: {
    id: "item_6827",
    "Last Name": "Sugui",
    "First Name": "Joni",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42708913: {
    id: "item_6828",
    "Last Name": "Soedarjo",
    "First Name": "Rino",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709342: {
    id: "item_34126",
    "Last Name": "Briggs",
    "First Name": "Sally",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709347: {
    id: "item_19719",
    "Last Name": "Huang",
    "First Name": "Xueming",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709462: {
    id: "item_34127",
    "Last Name": "Aves",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709609: {
    id: "item_32407",
    "Last Name": "Lee",
    "First Name": "Vicky",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709610: {
    id: "item_19720",
    "Last Name": "WONG",
    "First Name": "NING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709612: {
    id: "item_9008",
    "Last Name": "Finn",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709788: {
    id: "item_6829",
    "Last Name": "Opperman",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709820: {
    id: "item_19721",
    "Last Name": "WENG",
    "First Name": "WEI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709962: {
    id: "item_34128",
    "Last Name": "LIU",
    "First Name": "PO-YI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42709973: {
    id: "item_6830",
    "Last Name": "HUANG",
    "First Name": "TZUYUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42710092: {
    id: "item_6831",
    "Last Name": "Mehrotra",
    "First Name": "Shyamji",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42710116: {
    id: "item_34129",
    "Last Name": "Loh",
    "First Name": "Choo Kiong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42710174: {
    id: "item_19722",
    "Last Name": "Garcia",
    "First Name": "Regner",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42710242: {
    id: "item_19723",
    "Last Name": "NARGOLWALA",
    "First Name": "ADIL SHIAVAX",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42710616: {
    id: "item_19724",
    "Last Name": "VASQUEZ",
    "First Name": "ALBERT",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42710675: {
    id: "item_19725",
    "Last Name": "VASQUEZ",
    "First Name": "JEFFREY",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42710818: {
    id: "item_19726",
    "Last Name": "Lorenz",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42710909: {
    id: "item_6832",
    "Last Name": "Bagga",
    "First Name": "Jasmit Singh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42710968: {
    id: "item_6833",
    "Last Name": "Pardede",
    "First Name": "Giffy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42711069: {
    id: "item_6834",
    "Last Name": "zhang",
    "First Name": "shijie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42712381: {
    id: "item_6835",
    "Last Name": "Seto LP",
    "First Name": "Christina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42712594: {
    id: "item_9009",
    "Last Name": "Maharjan",
    "First Name": "Ramkrishna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42713182: {
    id: "item_19727",
    "Last Name": "Sitohang",
    "First Name": "Benny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42713342: {
    id: "item_6836",
    "Last Name": "Gomes da Silva",
    "First Name": "Americo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42713432: {
    id: "item_32408",
    "Last Name": "Que",
    "First Name": "Mark Anthony",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42713564: {
    id: "item_19728",
    "Last Name": "Sweetzer",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42715804: {
    id: "item_19729",
    "Last Name": "Yang",
    "First Name": "Yuqing",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42716723: {
    id: "item_19730",
    "Last Name": "PERMTHONGIN",
    "First Name": "PAPAWARIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42716873: {
    id: "item_32409",
    "Last Name": "Sykes",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42717561: {
    id: "item_6837",
    "Last Name": "Kuppusamy",
    "First Name": "Vijayakumar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42718109: {
    id: "item_34130",
    "Last Name": "Howard",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42718282: {
    id: "item_19731",
    "Last Name": "xiongchao",
    "First Name": "chen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42718378: {
    id: "item_32410",
    "Last Name": "Scordellis",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42718466: {
    id: "item_34131",
    "Last Name": "CHUNG",
    "First Name": "MEI TING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42718823: {
    id: "item_19732",
    "Last Name": "DeKeuster",
    "First Name": "Sara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42718825: {
    id: "item_19733",
    "Last Name": "Zhu",
    "First Name": "Ling",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42720195: {
    id: "item_6838",
    "Last Name": "Burnett",
    "First Name": "Taryn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42720313: {
    id: "item_6839",
    "Last Name": "Herludianto",
    "First Name": "Putri Astuti",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42720424: {
    id: "item_32411",
    "Last Name": "Larson",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42720636: {
    id: "item_19734",
    "Last Name": "Silva",
    "First Name": "Luis Bernardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42720641: {
    id: "item_19735",
    "Last Name": "Szacun-shimizu",
    "First Name": "Katarzyna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42721015: {
    id: "item_6840",
    "Last Name": "PERISSE",
    "First Name": "FRANCOIS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42722451: {
    id: "item_6841",
    "Last Name": "Mercer",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42722721: {
    id: "item_34132",
    "Last Name": "Chan",
    "First Name": "Leona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42722885: {
    id: "item_32412",
    "Last Name": "Wu",
    "First Name": "Binky",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42723814: {
    id: "item_32413",
    "Last Name": "Rosero",
    "First Name": "Natalia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42724462: {
    id: "item_19736",
    "Last Name": "Lam",
    "First Name": "Iris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42725177: {
    id: "item_34133",
    "Last Name": "Vivas-Esteban",
    "First Name": "Cindy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42725680: {
    id: "item_34134",
    "Last Name": "Beck",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42726082: {
    id: "item_32414",
    "Last Name": "Chesney",
    "First Name": "Cara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42726449: {
    id: "item_21465",
    "Last Name": "Johnson",
    "First Name": "Kyla Paige",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42726579: {
    id: "item_34135",
    "Last Name": "Smith",
    "First Name": "Reginald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42727023: {
    id: "item_6842",
    "Last Name": "Vazquez",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42727062: {
    id: "item_9010",
    "Last Name": "Toor",
    "First Name": "Nirmal",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42727135: {
    id: "item_19737",
    "Last Name": "Clark",
    "First Name": "Holly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42727459: {
    id: "item_32415",
    "Last Name": "Christie",
    "First Name": "EVANGELINE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42727618: {
    id: "item_32416",
    "Last Name": "SQUEFF",
    "First Name": "KARINE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42727889: {
    id: "item_6843",
    "Last Name": "GOULART LANES",
    "First Name": "JULIO CESAR",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42729044: {
    id: "item_34136",
    "Last Name": "INOUE",
    "First Name": "MIKIO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42729069: {
    id: "item_32417",
    "Last Name": "Chavez",
    "First Name": "Juan Lorenzo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42729300: {
    id: "item_32418",
    "Last Name": "Samaniego",
    "First Name": "Corinna Elise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42729429: {
    id: "item_6844",
    "Last Name": "arroxinho",
    "First Name": "gustavo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42729438: {
    id: "item_19738",
    "Last Name": "Knopp",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42730161: {
    id: "item_21466",
    "Last Name": "GARCIA TAMAYO",
    "First Name": "MONICA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42732977: {
    id: "item_6845",
    "Last Name": "Yau",
    "First Name": "Yeuk yu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42733244: {
    id: "item_21467",
    "Last Name": "Bing",
    "First Name": "Zhaoxia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42733316: {
    id: "item_6846",
    "Last Name": "Dave",
    "First Name": "Subodh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42733541: {
    id: "item_32419",
    "Last Name": "CHEN",
    "First Name": "WENQING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42733646: {
    id: "item_32420",
    "Last Name": "Gao",
    "First Name": "Chao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42734318: {
    id: "item_9011",
    "Last Name": "Roach",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42734583: {
    id: "item_19739",
    "Last Name": "Wong",
    "First Name": "Jean Wah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42734687: {
    id: "item_19740",
    "Last Name": "Evuru",
    "First Name": "Krishna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42735378: {
    id: "item_32421",
    "Last Name": "Atmoko",
    "First Name": "Indri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42735877: {
    id: "item_34137",
    "Last Name": "Wang",
    "First Name": "Lingmei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736214: {
    id: "item_19741",
    "Last Name": "Widjono",
    "First Name": "William Augustto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736220: {
    id: "item_34138",
    "Last Name": "Yu",
    "First Name": "Xuejun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736318: {
    id: "item_9012",
    "Last Name": "ren",
    "First Name": "siguo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736351: {
    id: "item_19742",
    "Last Name": "ZHAO",
    "First Name": "DONGDONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736365: {
    id: "item_32422",
    "Last Name": "NAGARAJAN",
    "First Name": "SRIKANTH",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736422: {
    id: "item_6847",
    "Last Name": "ZHU",
    "First Name": "YINGWEN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736578: {
    id: "item_19743",
    "Last Name": "SU",
    "First Name": "NENG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736598: {
    id: "item_34139",
    "Last Name": "XIAO",
    "First Name": "HONGWEI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736620: {
    id: "item_19744",
    "Last Name": "Lu",
    "First Name": "Chun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736758: {
    id: "item_6848",
    "Last Name": "LIN",
    "First Name": "JING",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42736839: {
    id: "item_6849",
    "Last Name": "ZHANG",
    "First Name": "JILIANG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737030: {
    id: "item_19745",
    "Last Name": "Ying",
    "First Name": "Ye",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737090: {
    id: "item_21468",
    "Last Name": "Gladstone",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737324: {
    id: "item_6850",
    "Last Name": "Lee",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737405: {
    id: "item_34140",
    "Last Name": "Zulfian",
    "First Name": "Zulfian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737427: {
    id: "item_9013",
    "Last Name": "sun",
    "First Name": "yuanyuan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737429: {
    id: "item_34141",
    "Last Name": "Damm",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737465: {
    id: "item_19746",
    "Last Name": "Setio",
    "First Name": "Andry Yanwar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737466: {
    id: "item_34142",
    "Last Name": "Hagestedt Ferreira",
    "First Name": "Andre",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737518: {
    id: "item_19747",
    "Last Name": "KONNO",
    "First Name": "MASAKAZU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42737637: {
    id: "item_21469",
    "Last Name": "den Hartog",
    "First Name": "willem",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42738573: {
    id: "item_6851",
    "Last Name": "HUIXIA",
    "First Name": "SUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42738617: {
    id: "item_32423",
    "Last Name": "Harrison",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42739112: {
    id: "item_6852",
    "Last Name": "Tong",
    "First Name": "Anh Geoffrey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42740111: {
    id: "item_34143",
    "Last Name": "Liang",
    "First Name": "Jiayu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42740574: {
    id: "item_19748",
    "Last Name": "Boodoo",
    "First Name": "Annie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42741043: {
    id: "item_21470",
    "Last Name": "Firth",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42741086: {
    id: "item_34144",
    "Last Name": "Chen",
    "First Name": "Chunwen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42741250: {
    id: "item_6853",
    "Last Name": "Nakamura",
    "First Name": "Cesar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42741801: {
    id: "item_6854",
    "Last Name": "Zhang",
    "First Name": "Haiying",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42741890: {
    id: "item_6855",
    "Last Name": "Lei",
    "First Name": "Qiao",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42742487: {
    id: "item_6856",
    "Last Name": "Lo",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42743674: {
    id: "item_6857",
    "Last Name": "Wu",
    "First Name": "Yi-hsin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42744609: {
    id: "item_34145",
    "Last Name": "Aranda",
    "First Name": "Gabrielle Andrea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42745535: {
    id: "item_19749",
    "Last Name": "Gray",
    "First Name": "Louisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42746749: {
    id: "item_19750",
    "Last Name": "Kethu",
    "First Name": "Sripathi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42746883: {
    id: "item_6858",
    "Last Name": "Sousa",
    "First Name": "Jairo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42746886: {
    id: "item_6859",
    "Last Name": "PEREIRA DA SILVA FILHO",
    "First Name": "MILTON",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42747597: {
    id: "item_34146",
    "Last Name": "CHAN",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42748171: {
    id: "item_19751",
    "Last Name": "TRINCHERO",
    "First Name": "PAUL",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42748330: {
    id: "item_19752",
    "Last Name": "Bruemmerstaedt",
    "First Name": "Marlies",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42748425: {
    id: "item_19753",
    "Last Name": "Bruemmerstaedt",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42748692: {
    id: "item_32424",
    "Last Name": "MacNabb",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42750550: {
    id: "item_34147",
    "Last Name": "Elemrani",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42750785: {
    id: "item_6860",
    "Last Name": "O'Sullivan",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42752582: {
    id: "item_34148",
    "Last Name": "Dennehy",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42754023: {
    id: "item_6861",
    "Last Name": "Ranadireksa",
    "First Name": "Ardha Candra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42754404: {
    id: "item_9014",
    "Last Name": "Foo",
    "First Name": "Chek Wun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42754431: {
    id: "item_19754",
    "Last Name": "Yap",
    "First Name": "Lye Yee Jasmine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42755322: {
    id: "item_19755",
    "Last Name": "Boon",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42755372: {
    id: "item_19756",
    "Last Name": "Guss",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42755374: {
    id: "item_19757",
    "Last Name": "FOULI",
    "First Name": "YMENE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42755636: {
    id: "item_19758",
    "Last Name": "Liu",
    "First Name": "Bonan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42755686: {
    id: "item_19759",
    "Last Name": "Xu",
    "First Name": "Chenyan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42756660: {
    id: "item_34149",
    "Last Name": "PRAWIRA",
    "First Name": "SATRIA YUDA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42756893: {
    id: "item_19760",
    "Last Name": "Wei",
    "First Name": "Fang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42757098: {
    id: "item_32425",
    "Last Name": "Toh",
    "First Name": "Yan Ling",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42757099: {
    id: "item_34150",
    "Last Name": "wong",
    "First Name": "andres",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42757580: {
    id: "item_32426",
    "Last Name": "Magmanlac",
    "First Name": "Alphonse Regin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42757860: {
    id: "item_6862",
    "Last Name": "INOUE",
    "First Name": "KIYOKO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42757918: {
    id: "item_6863",
    "Last Name": "Demeulenaere",
    "First Name": "Wouter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42757943: {
    id: "item_19761",
    "Last Name": "Beltran",
    "First Name": "Andres",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42757944: {
    id: "item_6864",
    "Last Name": "CHEN",
    "First Name": "SHAO-HONG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758006: {
    id: "item_19762",
    "Last Name": "TANG",
    "First Name": "FANG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758118: {
    id: "item_6865",
    "Last Name": "CHIU",
    "First Name": "AI-LUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758272: {
    id: "item_19763",
    "Last Name": "Savage",
    "First Name": "Paula",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758306: {
    id: "item_32427",
    "Last Name": "Littlejohn",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758446: {
    id: "item_19764",
    "Last Name": "CHEN",
    "First Name": "YU-HUI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758498: {
    id: "item_6866",
    "Last Name": "LIU",
    "First Name": "YA-LEI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758543: {
    id: "item_19765",
    "Last Name": "TSAI",
    "First Name": "YAO-TE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758588: {
    id: "item_6867",
    "Last Name": "CHEN",
    "First Name": "HUNG-JU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758643: {
    id: "item_6868",
    "Last Name": "NEE",
    "First Name": "CHENG-HSIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758772: {
    id: "item_19766",
    "Last Name": "Treb_e",
    "First Name": "Lidija",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758775: {
    id: "item_6869",
    "Last Name": "PENG",
    "First Name": "CHAO-CHI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758813: {
    id: "item_21471",
    "Last Name": "Chinhamo",
    "First Name": "Jeremiah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758962: {
    id: "item_19767",
    "Last Name": "Corey",
    "First Name": "Lee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42758967: {
    id: "item_6870",
    "Last Name": "SHYY",
    "First Name": "WEN-CHING",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759183: {
    id: "item_6871",
    "Last Name": "LO",
    "First Name": "CHUN-CHIH",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759254: {
    id: "item_19768",
    "Last Name": "HUANG",
    "First Name": "SHIH-YU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759387: {
    id: "item_6872",
    "Last Name": "LIN",
    "First Name": "YEN-CHUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759514: {
    id: "item_19769",
    "Last Name": "LIN",
    "First Name": "BING-LONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759647: {
    id: "item_32428",
    "Last Name": "WU",
    "First Name": "FANG-CHI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759719: {
    id: "item_32429",
    "Last Name": "TSENG",
    "First Name": "FU-SHENG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759809: {
    id: "item_19770",
    "Last Name": "Low",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759847: {
    id: "item_19771",
    "Last Name": "Tan",
    "First Name": "Kok Seong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759864: {
    id: "item_21472",
    "Last Name": "CHO",
    "First Name": "CHIOU-JI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42759996: {
    id: "item_19772",
    "Last Name": "CHEN",
    "First Name": "PING-JUI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42760027: {
    id: "item_21473",
    "Last Name": "Hamer",
    "First Name": "Ana Alicia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42760083: {
    id: "item_21474",
    "Last Name": "WANG",
    "First Name": "HUI-CHUN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42760270: {
    id: "item_34151",
    "Last Name": "Takakura",
    "First Name": "Takashi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42760480: {
    id: "item_32430",
    "Last Name": "Menell",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42760945: {
    id: "item_6873",
    "Last Name": "Rumapea",
    "First Name": "Virgilius",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42761006: {
    id: "item_34152",
    "Last Name": "JUGUILON",
    "First Name": "NORMAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42762843: {
    id: "item_19773",
    "Last Name": "Lutfi",
    "First Name": "Mohamad syahril",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42763748: {
    id: "item_21475",
    "Last Name": "SORIA",
    "First Name": "MAICA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42764375: {
    id: "item_6874",
    "Last Name": "Al-kuwari",
    "First Name": "Khalid",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42764383: {
    id: "item_6875",
    "Last Name": "Alkuwari",
    "First Name": "Khalifa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42766220: {
    id: "item_34153",
    "Last Name": "Dandele-MacNabb",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42766257: {
    id: "item_6876",
    "Last Name": "Eshuys",
    "First Name": "Katie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42770163: {
    id: "item_32431",
    "Last Name": "Biggs",
    "First Name": "Lorraine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42771555: {
    id: "item_32432",
    "Last Name": "Firmani",
    "First Name": "Megan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42772897: {
    id: "item_34154",
    "Last Name": "singh",
    "First Name": "harjot",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42773006: {
    id: "item_21476",
    "Last Name": "Nolin",
    "First Name": "Nathalie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42773767: {
    id: "item_32433",
    "Last Name": "MA",
    "First Name": "JIANGONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42774227: {
    id: "item_9015",
    "Last Name": "WENZHI",
    "First Name": "ZHANG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42775192: {
    id: "item_34155",
    "Last Name": "Budiman",
    "First Name": "Bayu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42775230: {
    id: "item_6877",
    "Last Name": "Jiang",
    "First Name": "wei",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42775965: {
    id: "item_19774",
    "Last Name": "Flanery",
    "First Name": "Ray",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42776053: {
    id: "item_19775",
    "Last Name": "CHEN",
    "First Name": "YUNG CHOU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42776429: {
    id: "item_34156",
    "Last Name": "Wang",
    "First Name": "Miao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42777010: {
    id: "item_6878",
    "Last Name": "Jie",
    "First Name": "Zhang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42777325: {
    id: "item_19776",
    "Last Name": "SHILONG",
    "First Name": "LOU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42777847: {
    id: "item_34157",
    "Last Name": "Cabuyao",
    "First Name": "Florian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42778157: {
    id: "item_32434",
    "Last Name": "miao",
    "First Name": "xi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42778619: {
    id: "item_19777",
    "Last Name": "FUJITA",
    "First Name": "MADOKA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42778687: {
    id: "item_19778",
    "Last Name": "GABOR",
    "First Name": "MAJA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42778721: {
    id: "item_6879",
    "Last Name": "Femc",
    "First Name": "Marko",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42779104: {
    id: "item_19779",
    "Last Name": "Rafael",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42779264: {
    id: "item_32435",
    "Last Name": "Gardnier",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42780003: {
    id: "item_19780",
    "Last Name": "Weizhi",
    "First Name": "Chen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42780263: {
    id: "item_6880",
    "Last Name": "Qu",
    "First Name": "Jianyun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42780326: {
    id: "item_19781",
    "Last Name": "YANG",
    "First Name": "CHUNRONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42780786: {
    id: "item_19782",
    "Last Name": "Dempster",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42781473: {
    id: "item_6881",
    "Last Name": "Ros",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42781478: {
    id: "item_21477",
    "Last Name": "Simson",
    "First Name": "Maddy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42781748: {
    id: "item_19783",
    "Last Name": "van Breemen",
    "First Name": "Michiel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42781777: {
    id: "item_32436",
    "Last Name": "Fitrianti",
    "First Name": "Zahra Putri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42781791: {
    id: "item_6882",
    "Last Name": "Parker",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42781880: {
    id: "item_34158",
    "Last Name": "Mitchell",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42781901: {
    id: "item_21478",
    "Last Name": "De Hart",
    "First Name": "Arthur Theodorus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42782628: {
    id: "item_6883",
    "Last Name": "Chau",
    "First Name": "Jose Antonio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42782632: {
    id: "item_32437",
    "Last Name": "prieto perez",
    "First Name": "jose eduardo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42782907: {
    id: "item_19784",
    "Last Name": "Vidovic",
    "First Name": "Dragan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42782930: {
    id: "item_32438",
    "Last Name": "Kamat",
    "First Name": "Shripad",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42782952: {
    id: "item_19785",
    "Last Name": "Chavan",
    "First Name": "Subodh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42782966: {
    id: "item_19786",
    "Last Name": "Yu",
    "First Name": "Hai Tao",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42783909: {
    id: "item_19787",
    "Last Name": "van der Pijl",
    "First Name": "Petrus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42784994: {
    id: "item_32439",
    "Last Name": "Padua",
    "First Name": "Shawn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42785091: {
    id: "item_9016",
    "Last Name": "VALANT",
    "First Name": "FRANCI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42786470: {
    id: "item_6884",
    "Last Name": "Jain",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42786710: {
    id: "item_19788",
    "Last Name": "Jain",
    "First Name": "Pooja",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42786782: {
    id: "item_9017",
    "Last Name": "bendeck",
    "First Name": "maria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42786952: {
    id: "item_34159",
    "Last Name": "Gladych",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42786990: {
    id: "item_6885",
    "Last Name": "De Sa Moreira",
    "First Name": "Rosa Maria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42788700: {
    id: "item_6886",
    "Last Name": "Voorham",
    "First Name": "Stefan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42788828: {
    id: "item_9018",
    "Last Name": "PERCIC",
    "First Name": "ERVIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42789464: {
    id: "item_34160",
    "Last Name": "Stanley",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42789819: {
    id: "item_21479",
    "Last Name": "Kalkhoven",
    "First Name": "Thijs",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42790550: {
    id: "item_34161",
    "Last Name": "Greene",
    "First Name": "Aisha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42790757: {
    id: "item_6887",
    "Last Name": "CHEN",
    "First Name": "CHUNHAI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42791674: {
    id: "item_21480",
    "Last Name": "Harvill",
    "First Name": "Steve",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42792472: {
    id: "item_19789",
    "Last Name": "Marin",
    "First Name": "Fagaras",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42793014: {
    id: "item_6888",
    "Last Name": "Targowski",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42793537: {
    id: "item_32440",
    "Last Name": "CHEN",
    "First Name": "Xu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42795727: {
    id: "item_32441",
    "Last Name": "Ruland",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42796457: {
    id: "item_6889",
    "Last Name": "Imperatore",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42796873: {
    id: "item_32442",
    "Last Name": "Sands",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42796948: {
    id: "item_32443",
    "Last Name": "Turocey",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42798141: {
    id: "item_32444",
    "Last Name": "Santos",
    "First Name": "Maritza",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42798285: {
    id: "item_19790",
    "Last Name": "Vidal",
    "First Name": "Afife",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42798696: {
    id: "item_19791",
    "Last Name": "Midderhoff",
    "First Name": "Ni6",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42798843: {
    id: "item_34162",
    "Last Name": "Onibala",
    "First Name": "Bobby",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42798879: {
    id: "item_6890",
    "Last Name": "Pereira",
    "First Name": "Tony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42799061: {
    id: "item_19792",
    "Last Name": "Pasia",
    "First Name": "Jefferson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42799081: {
    id: "item_34163",
    "Last Name": "Guerrero",
    "First Name": "Analiza",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42799520: {
    id: "item_19793",
    "Last Name": "Pasia",
    "First Name": "France Marie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42799811: {
    id: "item_34164",
    "Last Name": "Cortez",
    "First Name": "Eliel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42800348: {
    id: "item_6891",
    "Last Name": "ZHANG",
    "First Name": "CHUI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42800578: {
    id: "item_21481",
    "Last Name": "Standish",
    "First Name": "Constance",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42801084: {
    id: "item_34165",
    "Last Name": "Wong",
    "First Name": "Su-Yen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42802472: {
    id: "item_21482",
    "Last Name": "Ferreira Morillo",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42802855: {
    id: "item_9019",
    "Last Name": "Verweij",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42802891: {
    id: "item_6892",
    "Last Name": "LI",
    "First Name": "JIANYUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42803440: {
    id: "item_19794",
    "Last Name": "Wotherspoon",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42804047: {
    id: "item_32445",
    "Last Name": "Yandell",
    "First Name": "Sue",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42804274: {
    id: "item_6893",
    "Last Name": "zhang",
    "First Name": "fan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42804330: {
    id: "item_6894",
    "Last Name": "Elamparo",
    "First Name": "Estrella",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42804466: {
    id: "item_32446",
    "Last Name": "Ireland",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42804864: {
    id: "item_34166",
    "Last Name": "Watanabe",
    "First Name": "Noriko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42805207: {
    id: "item_21483",
    "Last Name": "SHAO",
    "First Name": "YUWEI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42805488: {
    id: "item_32447",
    "Last Name": "Vermeire",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42805581: {
    id: "item_6895",
    "Last Name": "SAN ROMAN SANCHEZ",
    "First Name": "JOSE MARIA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42806412: {
    id: "item_34167",
    "Last Name": "Farrington",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42806453: {
    id: "item_32448",
    "Last Name": "Sykes",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42806562: {
    id: "item_19795",
    "Last Name": "Trethewie",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42806565: {
    id: "item_19796",
    "Last Name": "Dekeghel",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42806605: {
    id: "item_34168",
    "Last Name": "Dunford",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42806868: {
    id: "item_32449",
    "Last Name": "Lindsay",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42806984: {
    id: "item_6896",
    "Last Name": "Chew",
    "First Name": "Poh Wai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807035: {
    id: "item_6897",
    "Last Name": "ONG",
    "First Name": "Ai Shuang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807037: {
    id: "item_32450",
    "Last Name": "Suessenbach",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807045: {
    id: "item_9020",
    "Last Name": "Molepe",
    "First Name": "Collin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807055: {
    id: "item_9021",
    "Last Name": "Szabados",
    "First Name": "Zsuzsanna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807101: {
    id: "item_19797",
    "Last Name": "VILLAREJO",
    "First Name": "JORGE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807226: {
    id: "item_19798",
    "Last Name": "Querijero",
    "First Name": "Roger Francis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807230: {
    id: "item_32451",
    "Last Name": "Phala",
    "First Name": "Dwinki",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807284: {
    id: "item_32452",
    "Last Name": "Tamme",
    "First Name": "Petra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807389: {
    id: "item_21484",
    "Last Name": "Kling",
    "First Name": "Lewis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42807444: {
    id: "item_19799",
    "Last Name": "Melani",
    "First Name": "Vivi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42808591: {
    id: "item_21485",
    "Last Name": "Khawam Chakar",
    "First Name": "Georges",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42808697: {
    id: "item_9022",
    "Last Name": "Aker",
    "First Name": "Ferry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42808908: {
    id: "item_6898",
    "Last Name": "Schele",
    "First Name": "Torsten",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42809189: {
    id: "item_32454",
    "Last Name": "Hakim",
    "First Name": "Fenny Oktavia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42809191: {
    id: "item_32453",
    "Last Name": "Wilenski",
    "First Name": "Simone",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42810074: {
    id: "item_19800",
    "Last Name": "Sands",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42810875: {
    id: "item_9023",
    "Last Name": "Fabian Sofyan",
    "First Name": "Rian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42811481: {
    id: "item_32455",
    "Last Name": "Utnehmer",
    "First Name": "Silke Christina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42812336: {
    id: "item_6899",
    "Last Name": "Haynes",
    "First Name": "Maria Amparo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42813800: {
    id: "item_6900",
    "Last Name": "PRIORI",
    "First Name": "MARCO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42814501: {
    id: "item_19801",
    "Last Name": "Oery",
    "First Name": "Christina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42815272: {
    id: "item_34169",
    "Last Name": "Cameron",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42815426: {
    id: "item_19802",
    "Last Name": "Starr",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42815703: {
    id: "item_19803",
    "Last Name": "Pesce",
    "First Name": "Claudio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42815796: {
    id: "item_6901",
    "Last Name": "Malizia",
    "First Name": "Federico",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42816775: {
    id: "item_21486",
    "Last Name": "Coco",
    "First Name": "Marcela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42817871: {
    id: "item_6902",
    "Last Name": "Klein",
    "First Name": "Anita",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42827155: {
    id: "item_19804",
    "Last Name": "ORNELAS MARQUEZ",
    "First Name": "JORGE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42827304: {
    id: "item_6903",
    "Last Name": "Ropers",
    "First Name": "Dieter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42827756: {
    id: "item_6904",
    "Last Name": "Amin",
    "First Name": "Ismail",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42829085: {
    id: "item_32456",
    "Last Name": "Manenti",
    "First Name": "Paolo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42829546: {
    id: "item_6905",
    "Last Name": "Stubbs",
    "First Name": "Juliette",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42830366: {
    id: "item_6906",
    "Last Name": "Cahyadi",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42830407: {
    id: "item_19805",
    "Last Name": "Goncalves",
    "First Name": "Luiz Gustavo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42830637: {
    id: "item_19806",
    "Last Name": "Baulde",
    "First Name": "Mar’a Laura Ceferina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42830769: {
    id: "item_19807",
    "Last Name": "Aguilar",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42831871: {
    id: "item_19808",
    "Last Name": "McArthur",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42832083: {
    id: "item_6907",
    "Last Name": "haichin",
    "First Name": "enrique guillermo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42832239: {
    id: "item_21487",
    "Last Name": "LOPEZ",
    "First Name": "BRIDGET",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42832327: {
    id: "item_32457",
    "Last Name": "Myers",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42832955: {
    id: "item_34170",
    "Last Name": "Huang",
    "First Name": "Darius",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42833181: {
    id: "item_9024",
    "Last Name": "TAN",
    "First Name": "SER AIK",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42833235: {
    id: "item_6908",
    "Last Name": "Pang",
    "First Name": "Chun Hai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42833322: {
    id: "item_32458",
    "Last Name": "Chan",
    "First Name": "Maria Rhodora",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42833467: {
    id: "item_9025",
    "Last Name": "Tan",
    "First Name": "Tzu Yih",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42833597: {
    id: "item_32459",
    "Last Name": "Benesiewicz",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42833628: {
    id: "item_32460",
    "Last Name": "Moreno cota",
    "First Name": "Jose manuel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42833936: {
    id: "item_6909",
    "Last Name": "aramwatanun",
    "First Name": "rerkrooj",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42833996: {
    id: "item_19809",
    "Last Name": "Wang",
    "First Name": "He",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42834110: {
    id: "item_32461",
    "Last Name": "Jeong",
    "First Name": "Won Bok",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42834277: {
    id: "item_32462",
    "Last Name": "Chin",
    "First Name": "Wen Jye",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42834351: {
    id: "item_6910",
    "Last Name": "De Pedro",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42834465: {
    id: "item_21488",
    "Last Name": "Russo",
    "First Name": "Mariela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42834866: {
    id: "item_32463",
    "Last Name": "Thiruman",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42834948: {
    id: "item_6911",
    "Last Name": "Khoo",
    "First Name": "Xin Hui",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42835070: {
    id: "item_19810",
    "Last Name": "Sosa",
    "First Name": "Dianisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42835379: {
    id: "item_6912",
    "Last Name": "Bailey",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42835460: {
    id: "item_19811",
    "Last Name": "Vea",
    "First Name": "Stacy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42835483: {
    id: "item_19812",
    "Last Name": "Thezine",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42835638: {
    id: "item_19813",
    "Last Name": "Bailey",
    "First Name": "Vesna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836184: {
    id: "item_34171",
    "Last Name": "Phorojanawanich",
    "First Name": "Nichalee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836195: {
    id: "item_19814",
    "Last Name": "WANG",
    "First Name": "CHUN HUI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836218: {
    id: "item_21489",
    "Last Name": "Hull",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836252: {
    id: "item_9026",
    "Last Name": "Cerna",
    "First Name": "Gabrielle Marcelo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836367: {
    id: "item_9027",
    "Last Name": "Limbaco",
    "First Name": "Angeline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836500: {
    id: "item_21490",
    "Last Name": "Rarantika",
    "First Name": "Vivi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836501: {
    id: "item_32464",
    "Last Name": "Lim",
    "First Name": "Marissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836542: {
    id: "item_32465",
    "Last Name": "Camacho",
    "First Name": "Manolito",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836583: {
    id: "item_19815",
    "Last Name": "Tao",
    "First Name": "Xinran",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42836872: {
    id: "item_34172",
    "Last Name": "Susanto",
    "First Name": "Susanto",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837088: {
    id: "item_9028",
    "Last Name": "Zheng",
    "First Name": "Jelene",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837157: {
    id: "item_34173",
    "Last Name": "Estera",
    "First Name": "Cecile Margaret",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837172: {
    id: "item_6913",
    "Last Name": "Chang",
    "First Name": "Chao Chi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837212: {
    id: "item_19816",
    "Last Name": "Cole",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837371: {
    id: "item_9029",
    "Last Name": "Tsan",
    "First Name": "Yi Jung",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837517: {
    id: "item_6914",
    "Last Name": "Wang",
    "First Name": "Wei Kai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837544: {
    id: "item_19817",
    "Last Name": "Goh",
    "First Name": "Joe Shuen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837634: {
    id: "item_34174",
    "Last Name": "Putra Supriadi",
    "First Name": "Ekky",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837640: {
    id: "item_34175",
    "Last Name": "Ramadanti",
    "First Name": "Aprilya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837706: {
    id: "item_19818",
    "Last Name": "TANG",
    "First Name": "WAI TONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837728: {
    id: "item_6915",
    "Last Name": "Lunprom",
    "First Name": "Anchana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837827: {
    id: "item_6916",
    "Last Name": "chaowakul",
    "First Name": "pitupong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42837949: {
    id: "item_21491",
    "Last Name": "Njoo",
    "First Name": "Fey Lieng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838146: {
    id: "item_19819",
    "Last Name": "JEONG",
    "First Name": "INSOOK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838215: {
    id: "item_9030",
    "Last Name": "LAM",
    "First Name": "CHIN TAT",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838335: {
    id: "item_32466",
    "Last Name": "Liang",
    "First Name": "Wen Chang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838387: {
    id: "item_32467",
    "Last Name": "Tiong",
    "First Name": "Immaculate",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838408: {
    id: "item_34176",
    "Last Name": "Gonzalez",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838424: {
    id: "item_9031",
    "Last Name": "Papanikolaou",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838581: {
    id: "item_34177",
    "Last Name": "Ursales",
    "First Name": "Anna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838677: {
    id: "item_19820",
    "Last Name": "Goh",
    "First Name": "Aziel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838819: {
    id: "item_34178",
    "Last Name": "Mendoza",
    "First Name": "Beatrice",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838902: {
    id: "item_19821",
    "Last Name": "Tolhurst",
    "First Name": "Jay",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838952: {
    id: "item_32468",
    "Last Name": "SULISTYONO",
    "First Name": "AGUS",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42838961: {
    id: "item_19822",
    "Last Name": "Scott",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839001: {
    id: "item_32469",
    "Last Name": "CAYANONG",
    "First Name": "KIRBY LUKE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839019: {
    id: "item_19823",
    "Last Name": "Brown",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839057: {
    id: "item_6917",
    "Last Name": "Srikong",
    "First Name": "Jirawat",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839075: {
    id: "item_34179",
    "Last Name": "Zhang",
    "First Name": "Jack",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839294: {
    id: "item_9032",
    "Last Name": "Pinto",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839578: {
    id: "item_34180",
    "Last Name": "DARGANTES",
    "First Name": "BRENT NIKO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839691: {
    id: "item_34181",
    "Last Name": "Iftikhar",
    "First Name": "Yusra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839731: {
    id: "item_19824",
    "Last Name": "Sardin",
    "First Name": "Wilma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839764: {
    id: "item_19825",
    "Last Name": "MOON",
    "First Name": "GUNCHEOL",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839809: {
    id: "item_34182",
    "Last Name": "Kurniawan",
    "First Name": "Budi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42839812: {
    id: "item_9033",
    "Last Name": "Becker",
    "First Name": "Frank Andreas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840009: {
    id: "item_6918",
    "Last Name": "Milo",
    "First Name": "Jens Christian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840094: {
    id: "item_34183",
    "Last Name": "Dannerfjord",
    "First Name": "Stina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840208: {
    id: "item_21492",
    "Last Name": "Chew",
    "First Name": "Wee Seong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840296: {
    id: "item_34184",
    "Last Name": "Lee",
    "First Name": "Pui See Fiona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840525: {
    id: "item_6919",
    "Last Name": "Corr",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840539: {
    id: "item_34185",
    "Last Name": "Aquino",
    "First Name": "Marianne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840590: {
    id: "item_34186",
    "Last Name": "Huang",
    "First Name": "Liyana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840723: {
    id: "item_19826",
    "Last Name": "Mehta",
    "First Name": "Rubin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840888: {
    id: "item_6920",
    "Last Name": "Ezhovkin",
    "First Name": "Nikita",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42840963: {
    id: "item_32470",
    "Last Name": "KWONG HOI",
    "First Name": "MAK",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42841281: {
    id: "item_6921",
    "Last Name": "Vasista",
    "First Name": "Harish",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42841342: {
    id: "item_34187",
    "Last Name": "Kwun",
    "First Name": "Lee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42841733: {
    id: "item_19827",
    "Last Name": "Holmberg",
    "First Name": "Lars-Bertil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42841861: {
    id: "item_19828",
    "Last Name": "Pael",
    "First Name": "Himanshu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42841864: {
    id: "item_19829",
    "Last Name": "Shelvia",
    "First Name": "Katarina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42842168: {
    id: "item_32471",
    "Last Name": "Quang",
    "First Name": "Elaine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42842197: {
    id: "item_32472",
    "Last Name": "Sadek",
    "First Name": "Aletha Maria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42842248: {
    id: "item_6922",
    "Last Name": "Lagers",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42842334: {
    id: "item_34188",
    "Last Name": "ASAMI",
    "First Name": "MARIKO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42842539: {
    id: "item_19830",
    "Last Name": "Martinez",
    "First Name": "Arnie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42842771: {
    id: "item_34189",
    "Last Name": "Flaherty",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42843115: {
    id: "item_34190",
    "Last Name": "STEFFAN",
    "First Name": "ODINO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42843397: {
    id: "item_19831",
    "Last Name": "Ehrlickman",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42843466: {
    id: "item_19832",
    "Last Name": "watanabe",
    "First Name": "fumi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42843557: {
    id: "item_21493",
    "Last Name": "de Medeiros",
    "First Name": "Luciana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42843604: {
    id: "item_6923",
    "Last Name": "Lee",
    "First Name": "Kit Yee Evelyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42843725: {
    id: "item_19833",
    "Last Name": "Chiu",
    "First Name": "Janet",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42844892: {
    id: "item_34191",
    "Last Name": "Quidilla",
    "First Name": "Lino",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42844973: {
    id: "item_19834",
    "Last Name": "Conseil",
    "First Name": "Laurent",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42845228: {
    id: "item_9034",
    "Last Name": "Cable",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42845276: {
    id: "item_6924",
    "Last Name": "Guimaraes",
    "First Name": "Rildo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42845411: {
    id: "item_34192",
    "Last Name": "Evans",
    "First Name": "Nigel Stephen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42845568: {
    id: "item_34193",
    "Last Name": "Sordyl",
    "First Name": "Tori",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42845959: {
    id: "item_6925",
    "Last Name": "Setiawan",
    "First Name": "Gilbert Wendy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42845979: {
    id: "item_32473",
    "Last Name": "Kuderski-Fischer",
    "First Name": "Simone",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42846490: {
    id: "item_6926",
    "Last Name": "Wright",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42847370: {
    id: "item_32474",
    "Last Name": "ARIBOWO",
    "First Name": "MOHAMAD",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42847487: {
    id: "item_34194",
    "Last Name": "Zavatti",
    "First Name": "Ivanromeo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42847567: {
    id: "item_6927",
    "Last Name": "Lui",
    "First Name": "Ho Tong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42847649: {
    id: "item_34195",
    "Last Name": "Fell",
    "First Name": "Denys",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42847761: {
    id: "item_32475",
    "Last Name": "Chin",
    "First Name": "Bernard",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42847819: {
    id: "item_19835",
    "Last Name": "Leung",
    "First Name": "Jimmy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42848531: {
    id: "item_32476",
    "Last Name": "HUANG",
    "First Name": "CHUN CHIH",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42848658: {
    id: "item_6928",
    "Last Name": "Panganiban",
    "First Name": "Christie Rea",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42848659: {
    id: "item_32477",
    "Last Name": "Flatt Franklin",
    "First Name": "Collette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42849313: {
    id: "item_19836",
    "Last Name": "Gimenez Sanchez",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42849351: {
    id: "item_32478",
    "Last Name": "Castro",
    "First Name": "Ma luisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42849693: {
    id: "item_9035",
    "Last Name": "Tejero",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42850964: {
    id: "item_34196",
    "Last Name": "Petri",
    "First Name": "Guenter Alfred",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42851656: {
    id: "item_6929",
    "Last Name": "Wiecher",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42851749: {
    id: "item_19837",
    "Last Name": "GimŽnez Monedero",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42852136: {
    id: "item_6930",
    "Last Name": "Haertel",
    "First Name": "Franz",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42852229: {
    id: "item_9036",
    "Last Name": "Hubmann",
    "First Name": "Christof Johannes",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42853002: {
    id: "item_19838",
    "Last Name": "Chana",
    "First Name": "Viresh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42853261: {
    id: "item_19839",
    "Last Name": "Capelin",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42853356: {
    id: "item_6931",
    "Last Name": "Glover",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42853474: {
    id: "item_9037",
    "Last Name": "Pula",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42856180: {
    id: "item_19840",
    "Last Name": "Ali",
    "First Name": "Chimedragchaa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42860305: {
    id: "item_21494",
    "Last Name": "Meyer",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42860509: {
    id: "item_19841",
    "Last Name": "Langsdorf",
    "First Name": "Griffin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42860892: {
    id: "item_32479",
    "Last Name": "Jensen",
    "First Name": "Gitte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42862533: {
    id: "item_9038",
    "Last Name": "RODRIGUEZ BARAJAS",
    "First Name": "PEDRO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42864270: {
    id: "item_21495",
    "Last Name": "Miranda",
    "First Name": "Nelson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42864932: {
    id: "item_6932",
    "Last Name": "Sandgaard",
    "First Name": "Matilde",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42864994: {
    id: "item_6934",
    "Last Name": "Bongelli",
    "First Name": "Saverio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42864996: {
    id: "item_6933",
    "Last Name": "Tacconi",
    "First Name": "Jenny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42868587: {
    id: "item_32480",
    "Last Name": "Ostrowski",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42872112: {
    id: "item_6935",
    "Last Name": "Mbhele",
    "First Name": "Bukelani",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42872284: {
    id: "item_6936",
    "Last Name": "Bharadwaj",
    "First Name": "Aditya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42875538: {
    id: "item_32481",
    "Last Name": "Salas",
    "First Name": "Gwendolyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42875799: {
    id: "item_6937",
    "Last Name": "Presswood",
    "First Name": "Melody",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42875848: {
    id: "item_6938",
    "Last Name": "Ponduri",
    "First Name": "Srinivas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42875912: {
    id: "item_9039",
    "Last Name": "Brett",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42876584: {
    id: "item_34197",
    "Last Name": "Mendoza",
    "First Name": "San Sharmaine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42876758: {
    id: "item_32482",
    "Last Name": "icaranom",
    "First Name": "ian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42876827: {
    id: "item_19842",
    "Last Name": "Denis",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877013: {
    id: "item_19843",
    "Last Name": "Chan",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877054: {
    id: "item_6939",
    "Last Name": "Laumann",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877071: {
    id: "item_32483",
    "Last Name": "Crawford",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877213: {
    id: "item_6940",
    "Last Name": "Kucharska",
    "First Name": "Malgorzata",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877217: {
    id: "item_19844",
    "Last Name": "Carberry",
    "First Name": "Samantha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877277: {
    id: "item_32484",
    "Last Name": "Tran",
    "First Name": "Julian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877338: {
    id: "item_19845",
    "Last Name": "Nelson",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877408: {
    id: "item_19846",
    "Last Name": "Brown",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877439: {
    id: "item_6941",
    "Last Name": "Buisman",
    "First Name": "Nick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877471: {
    id: "item_6942",
    "Last Name": "Sandoval",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877563: {
    id: "item_19847",
    "Last Name": "Heraux",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877629: {
    id: "item_6943",
    "Last Name": "Leyden",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877642: {
    id: "item_19848",
    "Last Name": "Harrell",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877865: {
    id: "item_19849",
    "Last Name": "Loschin",
    "First Name": "Tina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42877902: {
    id: "item_19850",
    "Last Name": "Taruli",
    "First Name": "Lidwina Elisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42878087: {
    id: "item_6944",
    "Last Name": "Decatur",
    "First Name": "Alimaa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42878205: {
    id: "item_34198",
    "Last Name": "TJIOE",
    "First Name": "DOLY",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42879158: {
    id: "item_6945",
    "Last Name": "Wrigley",
    "First Name": "Shannon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42879295: {
    id: "item_32485",
    "Last Name": "bendeck",
    "First Name": "stephanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42880698: {
    id: "item_34199",
    "Last Name": "Tineo",
    "First Name": "Marleni Josefina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42882114: {
    id: "item_19851",
    "Last Name": "Fleming",
    "First Name": "Liam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42882223: {
    id: "item_34200",
    "Last Name": "Chang",
    "First Name": "Danni",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42882275: {
    id: "item_21496",
    "Last Name": "Zanath",
    "First Name": "Kathy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42882625: {
    id: "item_6946",
    "Last Name": "Ransang",
    "First Name": "Ferdinand Charly",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42883395: {
    id: "item_19852",
    "Last Name": "Piggott",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42883961: {
    id: "item_19853",
    "Last Name": "GUERRERO",
    "First Name": "ULISES",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42884163: {
    id: "item_32486",
    "Last Name": "LILO",
    "First Name": "LINE SIA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42884356: {
    id: "item_19854",
    "Last Name": "KIM",
    "First Name": "YONG GON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42884465: {
    id: "item_19855",
    "Last Name": "PARK",
    "First Name": "ALVIN SUNG KYU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42884619: {
    id: "item_19856",
    "Last Name": null,
    "First Name": "JONG PILL",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42884803: {
    id: "item_19857",
    "Last Name": "YANG",
    "First Name": "HYUNG SOON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42885697: {
    id: "item_19858",
    "Last Name": "Dai",
    "First Name": "Huilin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42885968: {
    id: "item_19859",
    "Last Name": "Alsadi",
    "First Name": "Maha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42885981: {
    id: "item_21497",
    "Last Name": "Hasnie",
    "First Name": "Hasan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42886081: {
    id: "item_19860",
    "Last Name": "KIM",
    "First Name": "MINKI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42886213: {
    id: "item_19861",
    "Last Name": "LEE",
    "First Name": "MIKYUNG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42886248: {
    id: "item_19862",
    "Last Name": "MYUNG",
    "First Name": "SANGMIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42886254: {
    id: "item_32487",
    "Last Name": "Tong",
    "First Name": "Wan Wai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42886360: {
    id: "item_6947",
    "Last Name": "Muljadi",
    "First Name": "Beny",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42886504: {
    id: "item_9040",
    "Last Name": "Oeyono",
    "First Name": "Januar Tjiptadi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42886808: {
    id: "item_32488",
    "Last Name": "Yim",
    "First Name": "Charlie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42886938: {
    id: "item_6948",
    "Last Name": "RESTREPO GAVIRIA",
    "First Name": "FRANCISCO ALEJANDRO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42886994: {
    id: "item_19863",
    "Last Name": "Kooij",
    "First Name": "Jeroen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42887046: {
    id: "item_34201",
    "Last Name": "TIERRO",
    "First Name": "ANNBEL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42887112: {
    id: "item_34202",
    "Last Name": "Tierro",
    "First Name": "Martin Angelo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42887120: {
    id: "item_19864",
    "Last Name": "pangestu",
    "First Name": "yandri",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42887700: {
    id: "item_6949",
    "Last Name": "Wan",
    "First Name": "Hin Pong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42887781: {
    id: "item_19865",
    "Last Name": "Jayadi",
    "First Name": "Weta",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42888075: {
    id: "item_19866",
    "Last Name": "Suharto",
    "First Name": "Pauline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42888230: {
    id: "item_32489",
    "Last Name": "Lai",
    "First Name": "George",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42888292: {
    id: "item_34203",
    "Last Name": "Caroli",
    "First Name": "MariaGrazia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42888701: {
    id: "item_9041",
    "Last Name": "Limbu",
    "First Name": "Kajiman",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42889026: {
    id: "item_34204",
    "Last Name": "sarah saus",
    "First Name": "puti",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42889159: {
    id: "item_19867",
    "Last Name": "Umar",
    "First Name": "Edwin Ardiansyah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42889219: {
    id: "item_19868",
    "Last Name": "Tan",
    "First Name": "Chrystabelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42889465: {
    id: "item_32490",
    "Last Name": "Tjandraliem",
    "First Name": "Herlina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42889588: {
    id: "item_32491",
    "Last Name": "Citro",
    "First Name": "Widayati siswanto",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42889637: {
    id: "item_6950",
    "Last Name": "Bourne",
    "First Name": "Frederick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42889843: {
    id: "item_19869",
    "Last Name": "Binnie",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42890820: {
    id: "item_21498",
    "Last Name": "Raven",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42890912: {
    id: "item_6951",
    "Last Name": "Leonhardt",
    "First Name": "Christian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42890990: {
    id: "item_32492",
    "Last Name": "MAYUMI",
    "First Name": "WATANABE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42891027: {
    id: "item_6952",
    "Last Name": "Leonhardt",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42891061: {
    id: "item_19870",
    "Last Name": "SEKASON",
    "First Name": "FARHAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42891401: {
    id: "item_32493",
    "Last Name": "Enjapuri",
    "First Name": "Jayaprakash",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42891833: {
    id: "item_32494",
    "Last Name": "Juliachs",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42891943: {
    id: "item_32495",
    "Last Name": "Nek Hassan",
    "First Name": "Nek Zainab",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42891991: {
    id: "item_19871",
    "Last Name": "LASAGA",
    "First Name": "ANDRES",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892003: {
    id: "item_34205",
    "Last Name": "Raman",
    "First Name": "Krithika",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892074: {
    id: "item_19872",
    "Last Name": "Suisa",
    "First Name": "Varandy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892290: {
    id: "item_6953",
    "Last Name": "Bawono",
    "First Name": "Angela Myrna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892309: {
    id: "item_9042",
    "Last Name": "Trotti",
    "First Name": "Matteo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892319: {
    id: "item_32496",
    "Last Name": "SULISTIYOWATI",
    "First Name": "HENY",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892527: {
    id: "item_6954",
    "Last Name": "Kurniawan",
    "First Name": "Selvy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892617: {
    id: "item_6955",
    "Last Name": "Hardjono",
    "First Name": "Christabella",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892637: {
    id: "item_32497",
    "Last Name": "SUSANTO",
    "First Name": "AGUS",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892773: {
    id: "item_34206",
    "Last Name": "Duque",
    "First Name": "Althea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892817: {
    id: "item_32498",
    "Last Name": "Dithupe",
    "First Name": "Mmabakwena Exelsior Joyce",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42892962: {
    id: "item_21499",
    "Last Name": "Luengaroonroj",
    "First Name": "Natee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42893364: {
    id: "item_19873",
    "Last Name": "Montgomery",
    "First Name": "Suzanne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42893372: {
    id: "item_6956",
    "Last Name": "pasqual",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42893482: {
    id: "item_34207",
    "Last Name": "Haryani",
    "First Name": "Yani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42893488: {
    id: "item_21500",
    "Last Name": "Chaiyosburana",
    "First Name": "Worawat",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42893542: {
    id: "item_21501",
    "Last Name": "Varma",
    "First Name": "Kartik",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42894457: {
    id: "item_6957",
    "Last Name": "Barba",
    "First Name": "Uro_",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42894497: {
    id: "item_19874",
    "Last Name": "Orozco",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42895136: {
    id: "item_34208",
    "Last Name": "Vincensius",
    "First Name": "Kartika Juwono",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42895154: {
    id: "item_34209",
    "Last Name": "Meray",
    "First Name": "Veronica Agustina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42896078: {
    id: "item_19875",
    "Last Name": "Wegesin",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42896193: {
    id: "item_32499",
    "Last Name": "Mazariegos",
    "First Name": "Jose",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42897704: {
    id: "item_19876",
    "Last Name": "Cosalan",
    "First Name": "Claudine Marianne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42899531: {
    id: "item_19877",
    "Last Name": "Castro",
    "First Name": "Luis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42902480: {
    id: "item_34210",
    "Last Name": "SIU",
    "First Name": "CHING YU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42902907: {
    id: "item_6958",
    "Last Name": "GARCIA UMANA",
    "First Name": "JOSE MIGUEL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42906247: {
    id: "item_32500",
    "Last Name": "HUANG",
    "First Name": "SHIH-CHUAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42906784: {
    id: "item_9043",
    "Last Name": "Araya Navarro",
    "First Name": "Juan Carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42907547: {
    id: "item_21502",
    "Last Name": "Mu–oz Villalobos",
    "First Name": "Mar’a Esther",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42908175: {
    id: "item_32501",
    "Last Name": "LEE",
    "First Name": "MEI-CHEN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42908979: {
    id: "item_21503",
    "Last Name": "Patrick",
    "First Name": "Jen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42912738: {
    id: "item_32502",
    "Last Name": "Sibeko",
    "First Name": "Morapedi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42912816: {
    id: "item_6959",
    "Last Name": "RODRêGUEZ",
    "First Name": "ROBERTO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42913864: {
    id: "item_34211",
    "Last Name": "Evers",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42913924: {
    id: "item_34212",
    "Last Name": "Leveille",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42916657: {
    id: "item_32503",
    "Last Name": "Dindarti",
    "First Name": "Yulia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42923530: {
    id: "item_21504",
    "Last Name": "van Mol",
    "First Name": "Martina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42927192: {
    id: "item_19878",
    "Last Name": "Delfino",
    "First Name": "Valerio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42935184: {
    id: "item_9044",
    "Last Name": "Castro Vargas",
    "First Name": "Andrea Patricia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42935778: {
    id: "item_6960",
    "Last Name": "Paraschiv",
    "First Name": "Georgiana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42935786: {
    id: "item_6961",
    "Last Name": "Spijker",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42935802: {
    id: "item_19879",
    "Last Name": "McDonald",
    "First Name": "Dionne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42936049: {
    id: "item_6962",
    "Last Name": "Gaggianesi",
    "First Name": "Stefano",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42936590: {
    id: "item_19880",
    "Last Name": "Guillarte",
    "First Name": "Gaudencio III",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42937096: {
    id: "item_9045",
    "Last Name": "MORANTES",
    "First Name": "KAREN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42939623: {
    id: "item_19881",
    "Last Name": "Haigh",
    "First Name": "Chris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42941237: {
    id: "item_32504",
    "Last Name": "Kurnia",
    "First Name": "Denny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42941291: {
    id: "item_19882",
    "Last Name": "Avila",
    "First Name": "Diana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42941908: {
    id: "item_32505",
    "Last Name": "Villablanca de Mendoza",
    "First Name": "Joanne Marie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42942153: {
    id: "item_6963",
    "Last Name": "Mah",
    "First Name": "Harvey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42942935: {
    id: "item_32506",
    "Last Name": "BELLO SAUCEDO",
    "First Name": "JUDITH",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42943082: {
    id: "item_6964",
    "Last Name": "Sok",
    "First Name": "Heng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42943196: {
    id: "item_34213",
    "Last Name": "KAMBAYASHI",
    "First Name": "TOMOAKI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42943216: {
    id: "item_19883",
    "Last Name": "Hernandez Villegas",
    "First Name": "Osbaldo Germain",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42943616: {
    id: "item_34214",
    "Last Name": "KANG",
    "First Name": "HWEE SIAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42944876: {
    id: "item_34215",
    "Last Name": "Harry",
    "First Name": "Harry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42945144: {
    id: "item_34216",
    "Last Name": "Sahara",
    "First Name": "Nur",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42947120: {
    id: "item_9046",
    "Last Name": "Eryawan",
    "First Name": "Bayu Iman",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42947369: {
    id: "item_6965",
    "Last Name": "Karthik Anand",
    "First Name": "Deepti",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42947575: {
    id: "item_19884",
    "Last Name": "LEE",
    "First Name": "MYUNGKOOK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42947579: {
    id: "item_19885",
    "Last Name": "Zou",
    "First Name": "Hongwei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42947601: {
    id: "item_6966",
    "Last Name": "Moeller",
    "First Name": "Anders Vilhelm",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42947705: {
    id: "item_19886",
    "Last Name": "LEE",
    "First Name": "INSOOK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42947722: {
    id: "item_9047",
    "Last Name": "Heryanto",
    "First Name": "Herlina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42948353: {
    id: "item_34217",
    "Last Name": "Supadhiloke",
    "First Name": "Lertad",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42948865: {
    id: "item_6967",
    "Last Name": "Bolton",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42948876: {
    id: "item_6968",
    "Last Name": "Yang",
    "First Name": "Fei",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42949311: {
    id: "item_32507",
    "Last Name": "Heemskerk",
    "First Name": "Johanna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42949464: {
    id: "item_34218",
    "Last Name": "PERRONE",
    "First Name": "RAFFAELE LINO DOMENICO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42949502: {
    id: "item_34219",
    "Last Name": "EJALU",
    "First Name": "SHEILA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42949586: {
    id: "item_32508",
    "Last Name": "COGLIATI",
    "First Name": "MARCO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42949599: {
    id: "item_9048",
    "Last Name": "Profeta",
    "First Name": "Pierino",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42949678: {
    id: "item_21505",
    "Last Name": "PILIU",
    "First Name": "ANGELA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42949735: {
    id: "item_19887",
    "Last Name": "van Dyk",
    "First Name": "Yulandi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42949919: {
    id: "item_32509",
    "Last Name": "Chandra",
    "First Name": "Riyanto",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42949992: {
    id: "item_6969",
    "Last Name": "Patroni",
    "First Name": "Gabriele",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42950051: {
    id: "item_6970",
    "Last Name": "Dionisio",
    "First Name": "Raymond Kenneth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42950358: {
    id: "item_21506",
    "Last Name": "De Bernochi",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42950362: {
    id: "item_19888",
    "Last Name": "Avinash",
    "First Name": "Priyamvada",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42950793: {
    id: "item_19889",
    "Last Name": "Ca–igral Ortiz",
    "First Name": "Maria Aranzazu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42950907: {
    id: "item_19890",
    "Last Name": "Ca–igral Ferrando",
    "First Name": "Guillermo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42951473: {
    id: "item_32510",
    "Last Name": "Cadorin",
    "First Name": "Edi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42952102: {
    id: "item_19891",
    "Last Name": "zhu",
    "First Name": "jing",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42952721: {
    id: "item_6971",
    "Last Name": "Rodriguez Raviolo",
    "First Name": "Alejandro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42952987: {
    id: "item_19892",
    "Last Name": "Niedermeier",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42953110: {
    id: "item_19893",
    "Last Name": "Bernstein",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42953160: {
    id: "item_9049",
    "Last Name": "Giordano",
    "First Name": "ALESSANDRO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42953210: {
    id: "item_19894",
    "Last Name": "Myers-Bernstein",
    "First Name": "Audrey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42953486: {
    id: "item_34220",
    "Last Name": "Gutierrez Ferreras",
    "First Name": "Luis Fernando",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42954425: {
    id: "item_32511",
    "Last Name": "Wu",
    "First Name": "Man Wai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42954684: {
    id: "item_6972",
    "Last Name": "Dšlz",
    "First Name": "Harald",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42955027: {
    id: "item_19895",
    "Last Name": "Alejandro",
    "First Name": "Lolleth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42955308: {
    id: "item_6973",
    "Last Name": "Hoffmann",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42955443: {
    id: "item_19896",
    "Last Name": "Silvio",
    "First Name": "Elzbeth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42955681: {
    id: "item_19897",
    "Last Name": "REINARES TEN",
    "First Name": "MARIA DE LOS REYES",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42955890: {
    id: "item_6974",
    "Last Name": "PANAGIOTOPOULOS",
    "First Name": "GEORGIOS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42956191: {
    id: "item_19898",
    "Last Name": "Alvarez Villar",
    "First Name": "Carmen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42956250: {
    id: "item_34221",
    "Last Name": "Palombi",
    "First Name": "Debora",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42956438: {
    id: "item_32512",
    "Last Name": "Spindler",
    "First Name": "Kester",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42956441: {
    id: "item_19899",
    "Last Name": "fernandez rojano",
    "First Name": "miguel angel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42956471: {
    id: "item_19900",
    "Last Name": "Suherman",
    "First Name": "Kasman",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42957430: {
    id: "item_19901",
    "Last Name": "TORNARI",
    "First Name": "PAOLO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42957629: {
    id: "item_34222",
    "Last Name": "KWOK",
    "First Name": "Ying Tung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42957955: {
    id: "item_6975",
    "Last Name": "HO",
    "First Name": "WUN TSZ TIMUS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42958061: {
    id: "item_6976",
    "Last Name": "Ringbaek",
    "First Name": "Jens",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42958162: {
    id: "item_34223",
    "Last Name": "Axelrod",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42958812: {
    id: "item_6977",
    "Last Name": "TONG",
    "First Name": "LAI CHUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42961367: {
    id: "item_19902",
    "Last Name": "Maleika",
    "First Name": "Ringo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42962631: {
    id: "item_32513",
    "Last Name": "MOLINA",
    "First Name": "LILIANA MARGARITA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42962994: {
    id: "item_34224",
    "Last Name": "Rickard",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42965276: {
    id: "item_19903",
    "Last Name": "Baxamusa",
    "First Name": "Riaz",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42966164: {
    id: "item_34225",
    "Last Name": "Gaston",
    "First Name": "Erica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42970631: {
    id: "item_34226",
    "Last Name": "Putranto",
    "First Name": "Andi Tri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42970983: {
    id: "item_19904",
    "Last Name": "Fung",
    "First Name": "Wah Tim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42971241: {
    id: "item_34227",
    "Last Name": "Suen",
    "First Name": "Lan Lan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42971377: {
    id: "item_34228",
    "Last Name": "Yuningsih",
    "First Name": "Nanik",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42971812: {
    id: "item_34229",
    "Last Name": "Kattiwong",
    "First Name": "Piyachat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42972512: {
    id: "item_21507",
    "Last Name": "Soverini",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42972773: {
    id: "item_6978",
    "Last Name": "MacMillan",
    "First Name": "Josephine",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42973215: {
    id: "item_6979",
    "Last Name": "Vassard",
    "First Name": "Morten",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42973265: {
    id: "item_34230",
    "Last Name": "Cahyati",
    "First Name": "Desi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42973365: {
    id: "item_32514",
    "Last Name": "Tettamanti",
    "First Name": "Mauro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42973481: {
    id: "item_6980",
    "Last Name": "Ross",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42973818: {
    id: "item_34231",
    "Last Name": "Utami Dewi",
    "First Name": "Irina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42974058: {
    id: "item_9050",
    "Last Name": "mariani",
    "First Name": "mauro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42974444: {
    id: "item_34232",
    "Last Name": "YEE",
    "First Name": "KIM WING RAYMOND",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42974481: {
    id: "item_9051",
    "Last Name": "Hšhl",
    "First Name": "Laura Maria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42974703: {
    id: "item_32515",
    "Last Name": "Chong",
    "First Name": "Kwan Yee Queenie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42975205: {
    id: "item_9052",
    "Last Name": "De Pinto",
    "First Name": "Giuseppe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42975562: {
    id: "item_32516",
    "Last Name": "Wangchucherdkul",
    "First Name": "Ekaluck",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42976013: {
    id: "item_21508",
    "Last Name": "Metzner",
    "First Name": "Ingrid",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42976032: {
    id: "item_6981",
    "Last Name": "Biffi",
    "First Name": "Domenico",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42976252: {
    id: "item_34233",
    "Last Name": "Colombo",
    "First Name": "Enrica Domenica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42976564: {
    id: "item_19905",
    "Last Name": "Keshishian",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42977656: {
    id: "item_19906",
    "Last Name": "TSANG",
    "First Name": "PUI HA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42977807: {
    id: "item_34234",
    "Last Name": "Kromoto",
    "First Name": "Felicia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42977948: {
    id: "item_19907",
    "Last Name": "CHEN",
    "First Name": "DONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42978639: {
    id: "item_32517",
    "Last Name": "Alves",
    "First Name": "Maria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42978794: {
    id: "item_32518",
    "Last Name": "LO",
    "First Name": "YUET MI BRENDA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42979321: {
    id: "item_34235",
    "Last Name": "Thurmond",
    "First Name": "Shavon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42980079: {
    id: "item_21509",
    "Last Name": "Visicchio",
    "First Name": "Angelo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42981789: {
    id: "item_6982",
    "Last Name": "Cinesi",
    "First Name": "Pietro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42984349: {
    id: "item_34236",
    "Last Name": "Smithers",
    "First Name": "Julia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42984779: {
    id: "item_6983",
    "Last Name": "Manchanda",
    "First Name": "Rajinder",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42986893: {
    id: "item_34237",
    "Last Name": "KURIHARA",
    "First Name": "NAOKI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42987177: {
    id: "item_34238",
    "Last Name": "KURIHARA",
    "First Name": "KYOKO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42987415: {
    id: "item_34239",
    "Last Name": "Ng",
    "First Name": "Huey Chun Peggy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42989586: {
    id: "item_32519",
    "Last Name": "LAI",
    "First Name": "CHING KEUNG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42990767: {
    id: "item_32520",
    "Last Name": "KONGYINGYONG",
    "First Name": "PIBUL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42991538: {
    id: "item_32521",
    "Last Name": "Telfer",
    "First Name": "Simon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42991622: {
    id: "item_32522",
    "Last Name": "Watling",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42991822: {
    id: "item_19908",
    "Last Name": "Moy",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42992912: {
    id: "item_6984",
    "Last Name": "Mladenovic",
    "First Name": "Dragan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42993362: {
    id: "item_34240",
    "Last Name": "Pothipala",
    "First Name": "Su-unchana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42993718: {
    id: "item_32523",
    "Last Name": "Tummalapalli",
    "First Name": "Sunita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42994748: {
    id: "item_32524",
    "Last Name": "WONG",
    "First Name": "CHI KEONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42994800: {
    id: "item_6985",
    "Last Name": "Dantas",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42995383: {
    id: "item_34241",
    "Last Name": "kaller",
    "First Name": "matias daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42995432: {
    id: "item_19909",
    "Last Name": "Birgisson",
    "First Name": "Erlendur Birgisson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42995444: {
    id: "item_19910",
    "Last Name": "Rothenborg",
    "First Name": "J—runn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42995687: {
    id: "item_21510",
    "Last Name": "Hasler",
    "First Name": "Felix Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42996198: {
    id: "item_19911",
    "Last Name": "Chung",
    "First Name": "(Moon Sup) Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42996885: {
    id: "item_6986",
    "Last Name": "Satwiko",
    "First Name": "Sat Sidharta Putrama",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42997006: {
    id: "item_34242",
    "Last Name": "Chunchuwar",
    "First Name": "Ashwini",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42997441: {
    id: "item_34243",
    "Last Name": "Abd Hadi",
    "First Name": "Haslina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  42999718: {
    id: "item_6987",
    "Last Name": "ESTEBAN DEL VALLE",
    "First Name": "JUAN REGINO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43000433: {
    id: "item_6988",
    "Last Name": "BUSTILLO GUTIERREZ",
    "First Name": "MARCO ANTONIO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43000652: {
    id: "item_6989",
    "Last Name": "Scarcella",
    "First Name": "Giovanni",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43000771: {
    id: "item_19912",
    "Last Name": "MCKAY",
    "First Name": "TAMECKA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43005505: {
    id: "item_19913",
    "Last Name": "Zoia",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43006406: {
    id: "item_32525",
    "Last Name": "Edwards",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43007137: {
    id: "item_6990",
    "Last Name": "Montano",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43007188: {
    id: "item_19914",
    "Last Name": "Claparols",
    "First Name": "Juan miguel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43007369: {
    id: "item_6991",
    "Last Name": "Connolly",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43007911: {
    id: "item_19915",
    "Last Name": "Marrow",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43008015: {
    id: "item_19916",
    "Last Name": "Evangelista",
    "First Name": "Hector",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43008442: {
    id: "item_34244",
    "Last Name": "Saeed",
    "First Name": "Omar",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43008504: {
    id: "item_6992",
    "Last Name": "MORINAKA",
    "First Name": "RYO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43008691: {
    id: "item_32526",
    "Last Name": "Larra–aga",
    "First Name": "Valentina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43008712: {
    id: "item_19917",
    "Last Name": "VERGARA IBARRA",
    "First Name": "BENIGNO G.",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43008786: {
    id: "item_34245",
    "Last Name": "FONSECA BLANCARTE",
    "First Name": "GABRIELA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43009207: {
    id: "item_19918",
    "Last Name": "JAVIER SUAREZ",
    "First Name": "CHRISTIAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43009319: {
    id: "item_34246",
    "Last Name": "Lee",
    "First Name": "Man Shan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43010070: {
    id: "item_6993",
    "Last Name": "Ancira Torres",
    "First Name": "Maria Alejandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43010322: {
    id: "item_34247",
    "Last Name": "liu",
    "First Name": "Jiangtao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43010609: {
    id: "item_19919",
    "Last Name": "MEZA ZEPEDA",
    "First Name": "Antonio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43010611: {
    id: "item_34248",
    "Last Name": "Xia",
    "First Name": "Jun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43010790: {
    id: "item_19920",
    "Last Name": "LEE",
    "First Name": "YIU TUNG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43010932: {
    id: "item_9053",
    "Last Name": "YIM",
    "First Name": "FAI DICKY",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43012059: {
    id: "item_32527",
    "Last Name": "KURNIADY",
    "First Name": "KURNIADY",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013141: {
    id: "item_19921",
    "Last Name": "Mandagie",
    "First Name": "Philip",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013164: {
    id: "item_19922",
    "Last Name": "HUI",
    "First Name": "SIU KEE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013195: {
    id: "item_19923",
    "Last Name": "Meiliana",
    "First Name": "Meiliana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013211: {
    id: "item_19924",
    "Last Name": "HARUMAN",
    "First Name": "REZA SUWITRA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013219: {
    id: "item_19925",
    "Last Name": "phie",
    "First Name": "joko phitoyo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013371: {
    id: "item_32528",
    "Last Name": "Pangilinan",
    "First Name": "Rolando Jr.",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013534: {
    id: "item_9054",
    "Last Name": "Luthfi",
    "First Name": "Andi Praja Wira Yudha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013584: {
    id: "item_19926",
    "Last Name": "Simon",
    "First Name": "Analyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013641: {
    id: "item_19927",
    "Last Name": "Kambey",
    "First Name": "Monica merel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013782: {
    id: "item_19928",
    "Last Name": "Shao",
    "First Name": "Chunyu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013814: {
    id: "item_19929",
    "Last Name": "Eraku",
    "First Name": "Olis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013871: {
    id: "item_34249",
    "Last Name": "LAI",
    "First Name": "Sheung mei",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43013978: {
    id: "item_19930",
    "Last Name": "Dearing",
    "First Name": "Jackson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014102: {
    id: "item_19931",
    "Last Name": "Ansell",
    "First Name": "Warren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014181: {
    id: "item_6994",
    "Last Name": "Balunan",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014221: {
    id: "item_34250",
    "Last Name": "Orbegoso",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014247: {
    id: "item_9055",
    "Last Name": "Ferdinan",
    "First Name": "Ferdinan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014274: {
    id: "item_19932",
    "Last Name": "Arsal",
    "First Name": "Donny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014281: {
    id: "item_32529",
    "Last Name": "Carse",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014339: {
    id: "item_6995",
    "Last Name": "dsilva",
    "First Name": "lemmie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014458: {
    id: "item_19933",
    "Last Name": "akhir putra",
    "First Name": "Dafnil",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014586: {
    id: "item_34251",
    "Last Name": "Carse",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014878: {
    id: "item_19934",
    "Last Name": "SUWITO",
    "First Name": "IRWAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43014933: {
    id: "item_19935",
    "Last Name": "TJIOE",
    "First Name": "ANGIE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43015498: {
    id: "item_34252",
    "Last Name": "Yu",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43015611: {
    id: "item_6996",
    "Last Name": "MARTINEZ DE SALAZAR SEPULVEDA",
    "First Name": "MARIA AUXILIADORA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43015635: {
    id: "item_6997",
    "Last Name": "Dumont",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43015855: {
    id: "item_19936",
    "Last Name": "Sutanto",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43015866: {
    id: "item_32530",
    "Last Name": "LOPEZ PAJARES",
    "First Name": "DIEGO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43015876: {
    id: "item_19937",
    "Last Name": "Wahyuningsih",
    "First Name": "Retno",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43015924: {
    id: "item_19938",
    "Last Name": "Anindita",
    "First Name": "Fraya fadiana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43015960: {
    id: "item_6998",
    "Last Name": "Shrestha",
    "First Name": "Rajesh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43015993: {
    id: "item_6999",
    "Last Name": "van den Aker",
    "First Name": "Petrus (Patrick)",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43016086: {
    id: "item_19939",
    "Last Name": "Ananda",
    "First Name": "Pratama",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43016296: {
    id: "item_19940",
    "Last Name": "Friliesta Eliman",
    "First Name": "karin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43016326: {
    id: "item_7000",
    "Last Name": "Mudau",
    "First Name": "Tshinyadzo Meshack",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43016400: {
    id: "item_19941",
    "Last Name": "Sandria",
    "First Name": "Cut Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43016469: {
    id: "item_19942",
    "Last Name": "Go",
    "First Name": "Alex chandra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43016669: {
    id: "item_19943",
    "Last Name": "Jamil",
    "First Name": "Ibnu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43016674: {
    id: "item_7001",
    "Last Name": "Susanto",
    "First Name": "Ali",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43017014: {
    id: "item_19944",
    "Last Name": "Malik",
    "First Name": "Ferdy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43017198: {
    id: "item_19945",
    "Last Name": "Limantono",
    "First Name": "Dinasty",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43017234: {
    id: "item_19946",
    "Last Name": "Rizal",
    "First Name": "Andi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43017308: {
    id: "item_32531",
    "Last Name": "Lin",
    "First Name": "Hsin Te",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43017369: {
    id: "item_7002",
    "Last Name": "SENOPATI SILAM",
    "First Name": "VEBY",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43017558: {
    id: "item_19947",
    "Last Name": "Gombodorj",
    "First Name": "Sugarmaa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43017680: {
    id: "item_7003",
    "Last Name": "Moreau",
    "First Name": "Tristan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43017860: {
    id: "item_7004",
    "Last Name": "van Hunsel",
    "First Name": "Gijs",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43017873: {
    id: "item_19948",
    "Last Name": "Roosdiono",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018007: {
    id: "item_19949",
    "Last Name": "Fibrita",
    "First Name": "Winda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018106: {
    id: "item_7005",
    "Last Name": "Van Hunsel",
    "First Name": "Dirk",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018132: {
    id: "item_32532",
    "Last Name": "Kurniawan",
    "First Name": "Liliani",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018169: {
    id: "item_7006",
    "Last Name": "WUTUH",
    "First Name": "RICHARD",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018197: {
    id: "item_34253",
    "Last Name": "Wiewel",
    "First Name": "Markus",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018315: {
    id: "item_19950",
    "Last Name": "Gita",
    "First Name": "Irza",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018409: {
    id: "item_19951",
    "Last Name": "Suadi",
    "First Name": "Sismawati",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018493: {
    id: "item_19952",
    "Last Name": "Wijaya",
    "First Name": "Sandi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018608: {
    id: "item_19953",
    "Last Name": "Damayanti",
    "First Name": "Dewi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018646: {
    id: "item_32533",
    "Last Name": "Rajan",
    "First Name": "Navina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43018866: {
    id: "item_21511",
    "Last Name": "SUHERLAN",
    "First Name": "AMIR",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43019009: {
    id: "item_19954",
    "Last Name": "Danas",
    "First Name": "Teddy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43019418: {
    id: "item_34254",
    "Last Name": "ALVARADO PINEDO",
    "First Name": "MARCO ANTONIO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43020095: {
    id: "item_19955",
    "Last Name": "Heskett",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43020581: {
    id: "item_32534",
    "Last Name": "Tummalapalli",
    "First Name": "Rao",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43021244: {
    id: "item_7007",
    "Last Name": "Wong",
    "First Name": "Ping",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43021329: {
    id: "item_7008",
    "Last Name": "TENA GOMEZ",
    "First Name": "FRANCISCO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43021562: {
    id: "item_21512",
    "Last Name": "Calderon Purizaca",
    "First Name": "Carlos Antonio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43022546: {
    id: "item_9056",
    "Last Name": "Dratwa",
    "First Name": "Valerie Marie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43022891: {
    id: "item_34255",
    "Last Name": "Dratwa",
    "First Name": "Christoph Josef",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43023771: {
    id: "item_19956",
    "Last Name": "Armenta",
    "First Name": "Humberto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43023894: {
    id: "item_34256",
    "Last Name": "aceves borbolla",
    "First Name": "sergio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43024305: {
    id: "item_19957",
    "Last Name": "Gurung",
    "First Name": "Khop Bahadur",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43024329: {
    id: "item_7009",
    "Last Name": "Scott-Brown",
    "First Name": "Angus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43024397: {
    id: "item_7010",
    "Last Name": "Chen",
    "First Name": "Jingjing",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43025143: {
    id: "item_32535",
    "Last Name": "Almeida",
    "First Name": "Salvador",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43025528: {
    id: "item_19958",
    "Last Name": "Baldwin",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43025644: {
    id: "item_19959",
    "Last Name": "Astuti",
    "First Name": "Yulia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43025764: {
    id: "item_19960",
    "Last Name": "Liddell",
    "First Name": "Brin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43027561: {
    id: "item_7011",
    "Last Name": "Martinez Cruz",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43027842: {
    id: "item_7012",
    "Last Name": "Kasuganti",
    "First Name": "Harish",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43028030: {
    id: "item_7013",
    "Last Name": "Adderley",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43028344: {
    id: "item_32536",
    "Last Name": "Riding",
    "First Name": "Melanie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43028595: {
    id: "item_7014",
    "Last Name": "Setiawan",
    "First Name": "Sony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43028736: {
    id: "item_7015",
    "Last Name": "Troncoso",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43028770: {
    id: "item_19961",
    "Last Name": "MARTINAULY",
    "First Name": "Bertha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43029077: {
    id: "item_21513",
    "Last Name": "CHI",
    "First Name": "MYUNG-HOON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43029615: {
    id: "item_32537",
    "Last Name": "Gonzales",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43029645: {
    id: "item_19962",
    "Last Name": "Hatmanti",
    "First Name": "Gendis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43030172: {
    id: "item_19963",
    "Last Name": "Dumadi",
    "First Name": "Hastin Aristya Bakti",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43030546: {
    id: "item_19964",
    "Last Name": "Gavilondo",
    "First Name": "Eileen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43031040: {
    id: "item_7016",
    "Last Name": "CHUANG",
    "First Name": "YU-YU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43031967: {
    id: "item_19965",
    "Last Name": "Li",
    "First Name": "pengzhi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43032146: {
    id: "item_19966",
    "Last Name": "Natassia",
    "First Name": "Yolanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43032308: {
    id: "item_19967",
    "Last Name": "THERESIA",
    "First Name": "DONNA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43032777: {
    id: "item_19968",
    "Last Name": "LAMBOK PAHOTAN NAPITUPULU",
    "First Name": "NIXON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43033284: {
    id: "item_21514",
    "Last Name": "Renyda",
    "First Name": "Difa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43033361: {
    id: "item_19969",
    "Last Name": "Sari",
    "First Name": "Nadian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43033408: {
    id: "item_9057",
    "Last Name": "Bundy",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43033750: {
    id: "item_19971",
    "Last Name": "Fadli",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43033751: {
    id: "item_19970",
    "Last Name": "Marischa",
    "First Name": "Sylvia Yanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43034053: {
    id: "item_32538",
    "Last Name": "CHEN",
    "First Name": "YI-JU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43034066: {
    id: "item_19972",
    "Last Name": "FRANSISCA",
    "First Name": "HANA MARIA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43034070: {
    id: "item_7017",
    "Last Name": "Chaudhary",
    "First Name": "Rahul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43034227: {
    id: "item_19973",
    "Last Name": "bijaksana",
    "First Name": "patria arif",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43034271: {
    id: "item_19974",
    "Last Name": "ZULFIKAR",
    "First Name": "ANDI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43034607: {
    id: "item_19975",
    "Last Name": "Suwandono",
    "First Name": "Maya Ekakristiani",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43034656: {
    id: "item_32539",
    "Last Name": "Squier",
    "First Name": "Martin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43034803: {
    id: "item_7018",
    "Last Name": "Antoni",
    "First Name": "Oriola",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43034904: {
    id: "item_19976",
    "Last Name": "Toar",
    "First Name": "Astrid",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035063: {
    id: "item_19977",
    "Last Name": "Sari",
    "First Name": "Diah Fita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035276: {
    id: "item_32540",
    "Last Name": "YU",
    "First Name": "WAN-YI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035421: {
    id: "item_19978",
    "Last Name": "Sandhi",
    "First Name": "Agung Fitra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035484: {
    id: "item_7019",
    "Last Name": "O'Sullivan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035551: {
    id: "item_7020",
    "Last Name": "Lam",
    "First Name": "Kai Seng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035590: {
    id: "item_34257",
    "Last Name": "HSU",
    "First Name": "CHUN-TSE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035733: {
    id: "item_19979",
    "Last Name": "YANG",
    "First Name": "BAOJIA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035766: {
    id: "item_34258",
    "Last Name": "TAO",
    "First Name": "PING-LIEN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035798: {
    id: "item_32541",
    "Last Name": "Khorana",
    "First Name": "Rajan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035877: {
    id: "item_19980",
    "Last Name": "IM",
    "First Name": "DU JIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035913: {
    id: "item_19981",
    "Last Name": "Gutierrez Sanchez",
    "First Name": "Antonio Gutierrez Sanchez",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43035996: {
    id: "item_9058",
    "Last Name": "_",
    "First Name": "Abdulrahman",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43036242: {
    id: "item_7021",
    "Last Name": "Reyes",
    "First Name": "Juan Paolo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43036394: {
    id: "item_7022",
    "Last Name": "LEFEVRE",
    "First Name": "STEPHANE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43036433: {
    id: "item_7023",
    "Last Name": "Christopher",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43036491: {
    id: "item_9059",
    "Last Name": "Koesmantoro",
    "First Name": "Henny Purnama",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43036536: {
    id: "item_19982",
    "Last Name": "Andwina",
    "First Name": "Theophilia Chris",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43036631: {
    id: "item_19983",
    "Last Name": "Alamro",
    "First Name": "Sultan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43036784: {
    id: "item_7024",
    "Last Name": "Yusuf",
    "First Name": "Abdul Rachman Virga Maulidhany",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43037007: {
    id: "item_19984",
    "Last Name": "Uggerh¿j",
    "First Name": "Jesper",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43037417: {
    id: "item_7025",
    "Last Name": "Stadler",
    "First Name": "Marcel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43037693: {
    id: "item_7026",
    "Last Name": "van Eijkelenburg",
    "First Name": "Svenia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43037709: {
    id: "item_32542",
    "Last Name": "SICA",
    "First Name": "ADEMIR ALBERTO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43037744: {
    id: "item_7027",
    "Last Name": "McDougall",
    "First Name": "Lachlan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038115: {
    id: "item_21515",
    "Last Name": "Hendry",
    "First Name": "Hendry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038243: {
    id: "item_21516",
    "Last Name": "Ponlu",
    "First Name": "Tola",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038300: {
    id: "item_19985",
    "Last Name": "Boccia",
    "First Name": "Annunziata",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038333: {
    id: "item_19986",
    "Last Name": "LOPEZ ALONSO",
    "First Name": "FRANCISCO CARLOS",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038418: {
    id: "item_19987",
    "Last Name": "Filart",
    "First Name": "Igor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038422: {
    id: "item_32543",
    "Last Name": "Cui",
    "First Name": "Yuan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038430: {
    id: "item_34259",
    "Last Name": "YANG",
    "First Name": "YEN CHI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038489: {
    id: "item_19988",
    "Last Name": "DEL BARRIO VILLETA",
    "First Name": "FRANCISCO JAVIER",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038597: {
    id: "item_7028",
    "Last Name": "naser",
    "First Name": "fuad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038804: {
    id: "item_21517",
    "Last Name": "Nepomneschi",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038836: {
    id: "item_19989",
    "Last Name": "DIAZ BENITEZ",
    "First Name": "FRANCISCO JAVIER",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038910: {
    id: "item_7029",
    "Last Name": "MONIER",
    "First Name": "Michel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038983: {
    id: "item_19990",
    "Last Name": "COFRADE PARTY",
    "First Name": "SERGE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43038990: {
    id: "item_7030",
    "Last Name": "CHEN",
    "First Name": "CHIH-WEI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43039050: {
    id: "item_19991",
    "Last Name": "RAUDALES BANEGAS",
    "First Name": "EDUAR JAVIER",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43039353: {
    id: "item_19992",
    "Last Name": "SANCHEZ CENDRA",
    "First Name": "CRISTINA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43039380: {
    id: "item_32544",
    "Last Name": "Ming",
    "First Name": "Fabian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43040192: {
    id: "item_19993",
    "Last Name": "Purnomo",
    "First Name": "Andiko Ardi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43040486: {
    id: "item_7031",
    "Last Name": "Bell",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43040560: {
    id: "item_19994",
    "Last Name": "Lim",
    "First Name": "Him Boon Julie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43040799: {
    id: "item_19995",
    "Last Name": "Soedjoko",
    "First Name": "Rizki Lovanto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43041240: {
    id: "item_19996",
    "Last Name": "Hutapea",
    "First Name": "Novia Irma Grecia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43041485: {
    id: "item_7032",
    "Last Name": "PYE",
    "First Name": "Guillaume",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43041963: {
    id: "item_21518",
    "Last Name": "Byland",
    "First Name": "Kevin Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43042238: {
    id: "item_7033",
    "Last Name": "SALADO SANTIAGO",
    "First Name": "FRANCISCO JAVIER",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43043100: {
    id: "item_32545",
    "Last Name": "CHANG",
    "First Name": "SHENG-HSIEN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43043462: {
    id: "item_21519",
    "Last Name": "Mulrooney",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43043476: {
    id: "item_19997",
    "Last Name": "Garnaud",
    "First Name": "Sylvain",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43044542: {
    id: "item_7034",
    "Last Name": "Schmidt",
    "First Name": "Pauline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43045078: {
    id: "item_9060",
    "Last Name": "Tonoli",
    "First Name": "Elisiane",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43046209: {
    id: "item_19998",
    "Last Name": "LE GUEN",
    "First Name": "HERVE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43046412: {
    id: "item_19999",
    "Last Name": "Zigterman",
    "First Name": "Wieger",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43046455: {
    id: "item_32546",
    "Last Name": "VILLANUEVA ARANDA",
    "First Name": "CARMEN LAURA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43046614: {
    id: "item_20000",
    "Last Name": "Pineiro",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43046795: {
    id: "item_32547",
    "Last Name": "OSSIO RODRIGUEZ",
    "First Name": "FRANCISCO JAVIER",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43047018: {
    id: "item_32548",
    "Last Name": "Armenta",
    "First Name": "Fernanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43047136: {
    id: "item_9061",
    "Last Name": "Blogg",
    "First Name": "Hokkie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048188: {
    id: "item_9062",
    "Last Name": "MASSARD",
    "First Name": "EMMANUELLE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048201: {
    id: "item_9063",
    "Last Name": "Cook",
    "First Name": "Antwaun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048210: {
    id: "item_34260",
    "Last Name": "Cuesta Koury",
    "First Name": "Rafael Jose",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048299: {
    id: "item_21520",
    "Last Name": "HART",
    "First Name": "JULIE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048362: {
    id: "item_32549",
    "Last Name": "Jackson",
    "First Name": "CYERIA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048482: {
    id: "item_20001",
    "Last Name": "Paganelli",
    "First Name": "Maria Pia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048501: {
    id: "item_7035",
    "Last Name": "Resendez",
    "First Name": "Maximiliano",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048511: {
    id: "item_9064",
    "Last Name": "Appiagyei",
    "First Name": "Cleopatra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048516: {
    id: "item_20002",
    "Last Name": "Yoo",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048521: {
    id: "item_34261",
    "Last Name": "Wcislo",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048531: {
    id: "item_7036",
    "Last Name": "Laboy",
    "First Name": "Alfredo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048534: {
    id: "item_32550",
    "Last Name": "Stamm",
    "First Name": "Ronald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048597: {
    id: "item_7037",
    "Last Name": "Williams",
    "First Name": "Larry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048626: {
    id: "item_20003",
    "Last Name": "Unny",
    "First Name": "Sujatha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048634: {
    id: "item_20004",
    "Last Name": "Kaufman",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048636: {
    id: "item_9065",
    "Last Name": "Abbott",
    "First Name": "Diana",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048732: {
    id: "item_34262",
    "Last Name": "Price",
    "First Name": "Leesa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048868: {
    id: "item_7038",
    "Last Name": "Fowler",
    "First Name": "Howard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048872: {
    id: "item_7039",
    "Last Name": "Resendez",
    "First Name": "Javier",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048898: {
    id: "item_20005",
    "Last Name": "Sundack",
    "First Name": "Tracie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048944: {
    id: "item_7040",
    "Last Name": "Jones",
    "First Name": "Todd",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43048996: {
    id: "item_21521",
    "Last Name": "Adams",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43049041: {
    id: "item_20006",
    "Last Name": "Munoz",
    "First Name": "Lydia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43049071: {
    id: "item_32551",
    "Last Name": "Hernan",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43049157: {
    id: "item_32552",
    "Last Name": "Varner",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43049179: {
    id: "item_32553",
    "Last Name": "Neaves",
    "First Name": "Warren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43049213: {
    id: "item_20007",
    "Last Name": "Saat",
    "First Name": "Deborah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43049605: {
    id: "item_20008",
    "Last Name": "Merene",
    "First Name": "Jan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43049713: {
    id: "item_21522",
    "Last Name": "Morad",
    "First Name": "Ahmed",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43049837: {
    id: "item_34263",
    "Last Name": "Childress",
    "First Name": "ED",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43050060: {
    id: "item_20009",
    "Last Name": "Gonzalez",
    "First Name": "Lilia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43050096: {
    id: "item_34264",
    "Last Name": "Brill",
    "First Name": "Susan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43050103: {
    id: "item_32554",
    "Last Name": "Gerth",
    "First Name": "Danete",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43050250: {
    id: "item_7041",
    "Last Name": "Musso",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43050299: {
    id: "item_32555",
    "Last Name": "Abenir",
    "First Name": "Cynthia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43050334: {
    id: "item_9066",
    "Last Name": "SHAWBER",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43050521: {
    id: "item_9067",
    "Last Name": "Tanski",
    "First Name": "Michele Ann",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43050771: {
    id: "item_9068",
    "Last Name": "Di Lisio",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43050836: {
    id: "item_7042",
    "Last Name": "Hunt",
    "First Name": "Glen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051013: {
    id: "item_7043",
    "Last Name": "Marks",
    "First Name": "Khemika",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051326: {
    id: "item_20010",
    "Last Name": "Ng",
    "First Name": "Eric Kokman",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051352: {
    id: "item_21523",
    "Last Name": "Kane",
    "First Name": "Brodie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051408: {
    id: "item_32556",
    "Last Name": "Boyle",
    "First Name": "Terry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051492: {
    id: "item_32557",
    "Last Name": "Shapiro",
    "First Name": "Alla",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051541: {
    id: "item_20011",
    "Last Name": "Cosola",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051633: {
    id: "item_20012",
    "Last Name": "Xu",
    "First Name": "Jing",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051755: {
    id: "item_34265",
    "Last Name": "Lancaster",
    "First Name": "Shenita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051841: {
    id: "item_21524",
    "Last Name": "Nash",
    "First Name": "Tammy Gail",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43051869: {
    id: "item_32558",
    "Last Name": "Nazzarett",
    "First Name": "Sergel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43052086: {
    id: "item_21525",
    "Last Name": "Laqua",
    "First Name": "Travis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43052308: {
    id: "item_32559",
    "Last Name": "Ringwood",
    "First Name": "Sherry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43053152: {
    id: "item_7044",
    "Last Name": "LEE",
    "First Name": "JAE YEONG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43053219: {
    id: "item_20013",
    "Last Name": "Ling",
    "First Name": "Kwan kit",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43053252: {
    id: "item_32560",
    "Last Name": "Heunisch",
    "First Name": "Carol",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43053366: {
    id: "item_20014",
    "Last Name": "HO",
    "First Name": "CHUI KWAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43053417: {
    id: "item_32561",
    "Last Name": "Inouye",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43053431: {
    id: "item_7045",
    "Last Name": "Shaw",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43053881: {
    id: "item_32562",
    "Last Name": "Flournoy",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43053963: {
    id: "item_7046",
    "Last Name": "Knuteson",
    "First Name": "Candice",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43054268: {
    id: "item_7047",
    "Last Name": "Bennett",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43054275: {
    id: "item_34266",
    "Last Name": "On Ni Annie",
    "First Name": "Li",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43054301: {
    id: "item_32563",
    "Last Name": "Franklin",
    "First Name": "Gary Neil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43054321: {
    id: "item_21526",
    "Last Name": "Lambert",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43054582: {
    id: "item_34267",
    "Last Name": "Brown",
    "First Name": "Geoffrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43054607: {
    id: "item_20015",
    "Last Name": "Roesner",
    "First Name": "Crystal",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43054792: {
    id: "item_20016",
    "Last Name": "Yee",
    "First Name": "Helen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43055501: {
    id: "item_34268",
    "Last Name": "JOHNSON",
    "First Name": "ERIC",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43055875: {
    id: "item_32564",
    "Last Name": "Valencia",
    "First Name": "Julio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43056034: {
    id: "item_20017",
    "Last Name": "Hutagalung",
    "First Name": "Ridhania",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43056250: {
    id: "item_21527",
    "Last Name": "MA",
    "First Name": "WANLI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43056488: {
    id: "item_34269",
    "Last Name": "Bosch",
    "First Name": "Ana Marie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43057144: {
    id: "item_7048",
    "Last Name": "Massey",
    "First Name": "Jake",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43057264: {
    id: "item_9069",
    "Last Name": "Foor",
    "First Name": "Brandon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43057475: {
    id: "item_34270",
    "Last Name": "Yao",
    "First Name": "Maria Cristina A.",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43057653: {
    id: "item_34271",
    "Last Name": "CARIASO",
    "First Name": "MELANIE GRACE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43057717: {
    id: "item_20018",
    "Last Name": "Akhmetov",
    "First Name": "Bagdat",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43057977: {
    id: "item_20019",
    "Last Name": "Chendra",
    "First Name": "Senny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43058196: {
    id: "item_9070",
    "Last Name": "Klass",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43058206: {
    id: "item_20020",
    "Last Name": "Anwar",
    "First Name": "Ratna Nurlaela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43058617: {
    id: "item_32565",
    "Last Name": "Bhula",
    "First Name": "Nandkumar Dullabh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43058702: {
    id: "item_21528",
    "Last Name": "Chen",
    "First Name": "Xiuzhen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43058862: {
    id: "item_7049",
    "Last Name": "Soon",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059019: {
    id: "item_7050",
    "Last Name": "Harkness",
    "First Name": "Blake",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059024: {
    id: "item_9071",
    "Last Name": "Tilaro",
    "First Name": "Salvatore",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059228: {
    id: "item_32566",
    "Last Name": "CREN",
    "First Name": "OLINDO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059237: {
    id: "item_9072",
    "Last Name": "Ho",
    "First Name": "Jianbang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059243: {
    id: "item_20021",
    "Last Name": "Schena",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059325: {
    id: "item_32567",
    "Last Name": "HE",
    "First Name": "LIANFANG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059413: {
    id: "item_7051",
    "Last Name": "Forte",
    "First Name": "Aden",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059566: {
    id: "item_34272",
    "Last Name": "BEDENDO",
    "First Name": "CAMILLA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059647: {
    id: "item_7052",
    "Last Name": "Dinh",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059649: {
    id: "item_7053",
    "Last Name": "PATA FRANCO",
    "First Name": "JESUS ANTONIO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059851: {
    id: "item_7054",
    "Last Name": "Ruzik",
    "First Name": "Andrej",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43059896: {
    id: "item_20022",
    "Last Name": "CHUNG",
    "First Name": "SANG MO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060021: {
    id: "item_9073",
    "Last Name": "Verkhoturov",
    "First Name": "Alexey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060084: {
    id: "item_20023",
    "Last Name": "SABANDO PEREZ",
    "First Name": "JUAN MANUEL",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060104: {
    id: "item_20024",
    "Last Name": "Price",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060142: {
    id: "item_32568",
    "Last Name": "Kurlekar",
    "First Name": "Utkrant",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060159: {
    id: "item_20025",
    "Last Name": "Righetti",
    "First Name": "Elisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060351: {
    id: "item_20026",
    "Last Name": "Tarigan",
    "First Name": "Yaninta Evavalona",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060397: {
    id: "item_7055",
    "Last Name": "Llano Miranda",
    "First Name": "Luis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060442: {
    id: "item_7056",
    "Last Name": "Chin Yat",
    "First Name": "Chan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060572: {
    id: "item_34273",
    "Last Name": "Bui",
    "First Name": "Minh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060603: {
    id: "item_7057",
    "Last Name": "Wong",
    "First Name": "Darren",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060634: {
    id: "item_7058",
    "Last Name": "Jardine",
    "First Name": "Bret",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060644: {
    id: "item_7059",
    "Last Name": "Slaughter",
    "First Name": "Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060720: {
    id: "item_20027",
    "Last Name": "Pequeno",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060766: {
    id: "item_34274",
    "Last Name": "VAN ROOY",
    "First Name": "PIETER",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43060792: {
    id: "item_20028",
    "Last Name": "LEOPOLD",
    "First Name": "PERDANA DANIEL",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43061069: {
    id: "item_20029",
    "Last Name": "Yupiratu",
    "First Name": "Christy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43061176: {
    id: "item_20030",
    "Last Name": "Permana",
    "First Name": "Dendi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43061181: {
    id: "item_20031",
    "Last Name": "Rabbani",
    "First Name": "Alif Nadhif",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43061499: {
    id: "item_32569",
    "Last Name": "BEZNOS",
    "First Name": "LESLEY",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43061555: {
    id: "item_9074",
    "Last Name": "Martin-Dichosa",
    "First Name": "Michele Ann",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43061630: {
    id: "item_20032",
    "Last Name": "Indriani",
    "First Name": "Ira",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43061919: {
    id: "item_32570",
    "Last Name": "Keung",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43062079: {
    id: "item_32571",
    "Last Name": "Chang",
    "First Name": "Li Chieh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43062125: {
    id: "item_32572",
    "Last Name": "Wallace",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43062281: {
    id: "item_20033",
    "Last Name": "QUATREMER",
    "First Name": "JOELLE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43062962: {
    id: "item_20034",
    "Last Name": "LEDUC",
    "First Name": "Jean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43063337: {
    id: "item_20035",
    "Last Name": "Payne",
    "First Name": "Vicki",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43063446: {
    id: "item_32573",
    "Last Name": "Suhr",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43063463: {
    id: "item_20036",
    "Last Name": "FOURMONT",
    "First Name": "CLAUDE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43063739: {
    id: "item_20037",
    "Last Name": "Bramantyo",
    "First Name": "Eko Agung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43064063: {
    id: "item_20038",
    "Last Name": "McKinnon",
    "First Name": "Sandee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43064365: {
    id: "item_32574",
    "Last Name": "Eustace",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43064479: {
    id: "item_20039",
    "Last Name": "Thierstein",
    "First Name": "Mathias",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43064593: {
    id: "item_7060",
    "Last Name": "Rigaux",
    "First Name": "Yves",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43064709: {
    id: "item_34275",
    "Last Name": "Cabrera",
    "First Name": "Ma. Bernadette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43064759: {
    id: "item_20040",
    "Last Name": "Florio",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43064987: {
    id: "item_32575",
    "Last Name": "TAN",
    "First Name": "NANCY",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43065029: {
    id: "item_32576",
    "Last Name": "Owens",
    "First Name": "Cassie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43065276: {
    id: "item_32577",
    "Last Name": "Roberts",
    "First Name": "Bridget",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43065443: {
    id: "item_32578",
    "Last Name": "James",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43065449: {
    id: "item_20041",
    "Last Name": "Mallasani",
    "First Name": "Venkataramana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43065495: {
    id: "item_20042",
    "Last Name": "Nascimento",
    "First Name": "Elisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43065529: {
    id: "item_20043",
    "Last Name": "Collins-Lindner",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43065698: {
    id: "item_34276",
    "Last Name": "ANCIRA ARECHIGA",
    "First Name": "MARIO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43065967: {
    id: "item_21529",
    "Last Name": "Ozog",
    "First Name": "Cathy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43066068: {
    id: "item_7061",
    "Last Name": "Hicks",
    "First Name": "William",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43066157: {
    id: "item_34277",
    "Last Name": "Rogers",
    "First Name": "Bonita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43066326: {
    id: "item_20044",
    "Last Name": "ahuja",
    "First Name": "jorge",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43066629: {
    id: "item_34278",
    "Last Name": "Luke",
    "First Name": "Twyla A",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43066900: {
    id: "item_32579",
    "Last Name": "Tollinchi Negron",
    "First Name": "Maridaly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43067043: {
    id: "item_9075",
    "Last Name": "Currier",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43067047: {
    id: "item_9076",
    "Last Name": "Carter",
    "First Name": "Jill",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43067173: {
    id: "item_34279",
    "Last Name": "Wheatley",
    "First Name": "Sacha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43067315: {
    id: "item_34280",
    "Last Name": "Price",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43067443: {
    id: "item_7062",
    "Last Name": "JANAS",
    "First Name": "JEREMY",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43067593: {
    id: "item_21530",
    "Last Name": "Harris",
    "First Name": "Harjaben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43067880: {
    id: "item_20045",
    "Last Name": "Rebeix",
    "First Name": "Jean-Philippe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43068002: {
    id: "item_7063",
    "Last Name": "GRANIER",
    "First Name": "FRANCOIS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43068216: {
    id: "item_7064",
    "Last Name": "Saiz Navarro ep Reymondier",
    "First Name": "Lina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43068500: {
    id: "item_34281",
    "Last Name": "Hart",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43068661: {
    id: "item_34282",
    "Last Name": "Lafeber",
    "First Name": "Cornelis Hendrikus",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43068841: {
    id: "item_32580",
    "Last Name": "Duarte Ambriz",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43068898: {
    id: "item_34283",
    "Last Name": "Miranda",
    "First Name": "Gail Kramer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43069034: {
    id: "item_20046",
    "Last Name": "Elvira Martin",
    "First Name": "Jean Claude",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43069039: {
    id: "item_32581",
    "Last Name": "Schuttert",
    "First Name": "Jan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43069171: {
    id: "item_34284",
    "Last Name": "Taylor",
    "First Name": "Barbara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43069283: {
    id: "item_34285",
    "Last Name": "Birk",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43069411: {
    id: "item_7065",
    "Last Name": "Pratt",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43069468: {
    id: "item_32582",
    "Last Name": "Liles",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43069758: {
    id: "item_34286",
    "Last Name": "Nahar",
    "First Name": "Sobrun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43070050: {
    id: "item_21531",
    "Last Name": "Maag",
    "First Name": "Roland",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43070331: {
    id: "item_20047",
    "Last Name": "Hanby",
    "First Name": "Brooke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43070754: {
    id: "item_7066",
    "Last Name": "BEDIER",
    "First Name": "Clement",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43071028: {
    id: "item_21532",
    "Last Name": "Loving",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43071055: {
    id: "item_20048",
    "Last Name": "Tan",
    "First Name": "Seng-Lai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43071280: {
    id: "item_20049",
    "Last Name": "Gerhart",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43071290: {
    id: "item_32583",
    "Last Name": "Anthony",
    "First Name": "Priya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43071439: {
    id: "item_7067",
    "Last Name": "Ramirez Ortega",
    "First Name": "Marta",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43071489: {
    id: "item_20050",
    "Last Name": "Kjaersgaard",
    "First Name": "Palle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43071970: {
    id: "item_7068",
    "Last Name": "Gutierrez",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43072123: {
    id: "item_7069",
    "Last Name": "Gibson",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43072175: {
    id: "item_20051",
    "Last Name": "Lawless",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43073302: {
    id: "item_21533",
    "Last Name": "Garza",
    "First Name": "Raquel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43073384: {
    id: "item_20052",
    "Last Name": "Kj¾rsgaard",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43073829: {
    id: "item_7070",
    "Last Name": "Pintarich",
    "First Name": "Jason",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43073906: {
    id: "item_32584",
    "Last Name": "DeVita",
    "First Name": "Juliana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43074065: {
    id: "item_20053",
    "Last Name": "Hipolito",
    "First Name": "Ronaldo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43074197: {
    id: "item_20054",
    "Last Name": "Chavez",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43074900: {
    id: "item_34287",
    "Last Name": "Perry",
    "First Name": "Diana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43074925: {
    id: "item_34288",
    "Last Name": "Raney",
    "First Name": "Karen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43075499: {
    id: "item_32585",
    "Last Name": "Beynon",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43075541: {
    id: "item_20055",
    "Last Name": "ilic",
    "First Name": "stojan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43075905: {
    id: "item_9077",
    "Last Name": "Martinez Rivera",
    "First Name": "Jose",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43076102: {
    id: "item_7071",
    "Last Name": "Evans",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43077279: {
    id: "item_20056",
    "Last Name": "Sosa",
    "First Name": "Wendy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43078081: {
    id: "item_20057",
    "Last Name": "Thakur",
    "First Name": "Shantanu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43078364: {
    id: "item_20058",
    "Last Name": "Jones",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43078709: {
    id: "item_9078",
    "Last Name": "Perez",
    "First Name": "Erika",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43078747: {
    id: "item_34289",
    "Last Name": "Seah",
    "First Name": "Wee Shaun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43080558: {
    id: "item_34290",
    "Last Name": "Davidson",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43080739: {
    id: "item_7072",
    "Last Name": "Berkowitz",
    "First Name": "Pamela",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43080823: {
    id: "item_34291",
    "Last Name": "Hettinger",
    "First Name": "Meredith",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43081180: {
    id: "item_32586",
    "Last Name": "Lagomarsino",
    "First Name": "Erin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43081350: {
    id: "item_20059",
    "Last Name": "Mihura",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43081849: {
    id: "item_20060",
    "Last Name": "Grossi-Roffi",
    "First Name": "Guillermo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43081882: {
    id: "item_20061",
    "Last Name": "PARK",
    "First Name": "JEONGHO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43081894: {
    id: "item_7073",
    "Last Name": "ILHAM",
    "First Name": "ARHAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43081935: {
    id: "item_32587",
    "Last Name": "Prasad",
    "First Name": "Swati",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43081998: {
    id: "item_20062",
    "Last Name": "Grossi",
    "First Name": "Camille",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43082292: {
    id: "item_21534",
    "Last Name": "Anthes",
    "First Name": "Tegan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43082441: {
    id: "item_32588",
    "Last Name": "PARK",
    "First Name": "YUNSUK",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43082680: {
    id: "item_20063",
    "Last Name": "KIM",
    "First Name": "MIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43082745: {
    id: "item_21535",
    "Last Name": "Gaddis",
    "First Name": "Byron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43082771: {
    id: "item_20064",
    "Last Name": "Tsang",
    "First Name": "Rick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43082796: {
    id: "item_7074",
    "Last Name": "Morriss",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43082820: {
    id: "item_9079",
    "Last Name": "Merkel",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43082828: {
    id: "item_20065",
    "Last Name": "Nivet",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43082919: {
    id: "item_20066",
    "Last Name": "KIM",
    "First Name": "WONSEOB",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43083032: {
    id: "item_21536",
    "Last Name": "HONG",
    "First Name": "SEOKJA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43083093: {
    id: "item_21537",
    "Last Name": "KIM",
    "First Name": "JAEHONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43083591: {
    id: "item_32589",
    "Last Name": "Voyce",
    "First Name": "Hinewai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43083612: {
    id: "item_7075",
    "Last Name": "PARK",
    "First Name": "JIHYE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43083714: {
    id: "item_32590",
    "Last Name": "LAU",
    "First Name": "CHI WAI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43083728: {
    id: "item_7076",
    "Last Name": "Tratt",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43083775: {
    id: "item_7077",
    "Last Name": "GIM",
    "First Name": "TAEHUI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43083963: {
    id: "item_20067",
    "Last Name": "CHANG",
    "First Name": "DAIWON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43084065: {
    id: "item_20068",
    "Last Name": "JUNG",
    "First Name": "JIYEON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43084287: {
    id: "item_20069",
    "Last Name": "Stevenson",
    "First Name": "Chanterelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43084360: {
    id: "item_7078",
    "Last Name": "fnini",
    "First Name": "salah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43084559: {
    id: "item_20070",
    "Last Name": "Mills",
    "First Name": "John",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43084736: {
    id: "item_20071",
    "Last Name": "Sipahutar",
    "First Name": "Akbar Febriandree",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43084950: {
    id: "item_32591",
    "Last Name": "SZE-TO",
    "First Name": "SAI CHUN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43086198: {
    id: "item_20072",
    "Last Name": "Santos de Quevedo Palacios",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43086351: {
    id: "item_20073",
    "Last Name": "Tiartanaya",
    "First Name": "Annetya Hapsari",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43086742: {
    id: "item_7079",
    "Last Name": "Hughes",
    "First Name": "Travis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43086848: {
    id: "item_20074",
    "Last Name": "Falloway",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43086935: {
    id: "item_32592",
    "Last Name": "HUANG",
    "First Name": "WEN-CHUNG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43087038: {
    id: "item_34292",
    "Last Name": "Shih",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43087344: {
    id: "item_7080",
    "Last Name": "Ramoutar",
    "First Name": "Rajhen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43087947: {
    id: "item_20075",
    "Last Name": "Nielsen",
    "First Name": "Per",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43088333: {
    id: "item_20076",
    "Last Name": "Nourallah Laraqui",
    "First Name": "Zine Elabidine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43088359: {
    id: "item_32593",
    "Last Name": "Kim",
    "First Name": "Irene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43088421: {
    id: "item_20077",
    "Last Name": "Ohsako",
    "First Name": "Yoichiro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43090875: {
    id: "item_32594",
    "Last Name": "VANLUE",
    "First Name": "JULIE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43092200: {
    id: "item_34293",
    "Last Name": "Vendette",
    "First Name": "Francois",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43092807: {
    id: "item_20078",
    "Last Name": "Pardos",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43093042: {
    id: "item_9080",
    "Last Name": "Navarrete",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43093803: {
    id: "item_7081",
    "Last Name": "Spadavecchia",
    "First Name": "Mario",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43094145: {
    id: "item_21538",
    "Last Name": "TOME'",
    "First Name": "MANUELA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43094294: {
    id: "item_7082",
    "Last Name": "Guerriero",
    "First Name": "Jacopo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43094467: {
    id: "item_7083",
    "Last Name": "Cancedda",
    "First Name": "Silvia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43094898: {
    id: "item_21539",
    "Last Name": "Riancho",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43094950: {
    id: "item_34294",
    "Last Name": "Mancini",
    "First Name": "Gabriele",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43094966: {
    id: "item_20079",
    "Last Name": "BASCHIERI",
    "First Name": "CRISTIANA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43095480: {
    id: "item_7084",
    "Last Name": "bonfadini",
    "First Name": "davide",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43095565: {
    id: "item_20080",
    "Last Name": "Donna",
    "First Name": "Power",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43095604: {
    id: "item_20081",
    "Last Name": "Davis",
    "First Name": "Merry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43095729: {
    id: "item_7085",
    "Last Name": "RAMEIL",
    "First Name": "JEAN CHRISTOPHE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43095853: {
    id: "item_7086",
    "Last Name": "polesel",
    "First Name": "andrea",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43096817: {
    id: "item_34295",
    "Last Name": "Thukral",
    "First Name": "Pimolrat",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43096935: {
    id: "item_9081",
    "Last Name": "Larkins",
    "First Name": "Gantuya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43098160: {
    id: "item_32595",
    "Last Name": "Konnick",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43098722: {
    id: "item_21540",
    "Last Name": "King",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43098723: {
    id: "item_21541",
    "Last Name": "Defendini",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43098822: {
    id: "item_7087",
    "Last Name": "Cole",
    "First Name": "Danae",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43098921: {
    id: "item_32596",
    "Last Name": "Cole",
    "First Name": "Adam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43100562: {
    id: "item_34296",
    "Last Name": "McKee",
    "First Name": "Connie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43100771: {
    id: "item_34297",
    "Last Name": "Shaheed",
    "First Name": "Nena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43100862: {
    id: "item_32597",
    "Last Name": "Shabir",
    "First Name": "Henna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43100950: {
    id: "item_34298",
    "Last Name": "Wcislo",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43101905: {
    id: "item_20082",
    "Last Name": "SUGANYA SELVAKUMARI JAYARAJAN",
    "First Name": "ANITA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43102172: {
    id: "item_20083",
    "Last Name": "Jannaccio",
    "First Name": "Bruce",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43102618: {
    id: "item_34299",
    "Last Name": "Khaliq",
    "First Name": "Jihan Qonitatillah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43102630: {
    id: "item_9082",
    "Last Name": "Skokos",
    "First Name": "Callie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43104064: {
    id: "item_32598",
    "Last Name": "Lawson",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43104611: {
    id: "item_20084",
    "Last Name": "Habib",
    "First Name": "Ali",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43104663: {
    id: "item_7088",
    "Last Name": "Pantuvanich",
    "First Name": "Jiratha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43104783: {
    id: "item_32599",
    "Last Name": "Yob",
    "First Name": "Steven",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43104931: {
    id: "item_7089",
    "Last Name": "Budsingkorn",
    "First Name": "Janjira",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43105010: {
    id: "item_7090",
    "Last Name": "JITTASONTHI",
    "First Name": "PRASAI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43105109: {
    id: "item_32600",
    "Last Name": "Bradford",
    "First Name": "Kylie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43105268: {
    id: "item_7091",
    "Last Name": "VANICHKOBCHINDA",
    "First Name": "GHLOD",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43105520: {
    id: "item_7092",
    "Last Name": "SENAVEENIN",
    "First Name": "PATINYA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43105606: {
    id: "item_7093",
    "Last Name": "GALVEZ",
    "First Name": "JORGE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43105785: {
    id: "item_7094",
    "Last Name": "Peerachotiwatra",
    "First Name": "Peerapong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43105920: {
    id: "item_7095",
    "Last Name": "CHAROENVAI",
    "First Name": "PUNNATORN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43106471: {
    id: "item_32601",
    "Last Name": "Mays",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43107260: {
    id: "item_32602",
    "Last Name": "Kiemel",
    "First Name": "Ann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43107370: {
    id: "item_32603",
    "Last Name": "Turner",
    "First Name": "Brigid",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43108528: {
    id: "item_20085",
    "Last Name": "Waldie",
    "First Name": "Doug",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43108814: {
    id: "item_21542",
    "Last Name": "IGLESIAS RAGGIO",
    "First Name": "SEBASTIAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43108871: {
    id: "item_20086",
    "Last Name": "Marder",
    "First Name": "Alice",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43110161: {
    id: "item_7096",
    "Last Name": "Bozin",
    "First Name": "Josh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43111052: {
    id: "item_7097",
    "Last Name": "Guo",
    "First Name": "Renli",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43111231: {
    id: "item_7098",
    "Last Name": "Song",
    "First Name": "Chuanfeng",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43111608: {
    id: "item_7099",
    "Last Name": "Mata Mayrand",
    "First Name": "Bruno",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43111940: {
    id: "item_20087",
    "Last Name": "Wright",
    "First Name": "Lloyd",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43112177: {
    id: "item_32604",
    "Last Name": "Colen",
    "First Name": "Kerryn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43112188: {
    id: "item_32605",
    "Last Name": "Magni",
    "First Name": "Fabio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43112216: {
    id: "item_32606",
    "Last Name": "LAPENA",
    "First Name": "ELMER",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43112364: {
    id: "item_7100",
    "Last Name": "HERYANTO",
    "First Name": "RAKA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43112406: {
    id: "item_9083",
    "Last Name": "Novitasari",
    "First Name": "Debby Ayu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43112544: {
    id: "item_34300",
    "Last Name": "Chang",
    "First Name": "Fang-Ju",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43112844: {
    id: "item_20088",
    "Last Name": "Alluri",
    "First Name": "Raju",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43112845: {
    id: "item_21543",
    "Last Name": "Boer",
    "First Name": "Novarinta",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43113005: {
    id: "item_20089",
    "Last Name": "Chaudhary",
    "First Name": "Nitin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43113469: {
    id: "item_21544",
    "Last Name": "Condon",
    "First Name": "Kathleen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43114274: {
    id: "item_7101",
    "Last Name": "Faubel",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43114325: {
    id: "item_20090",
    "Last Name": "Albisetti",
    "First Name": "Simone Ugo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43114542: {
    id: "item_20091",
    "Last Name": "Quinonez",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43114840: {
    id: "item_7102",
    "Last Name": "Liang",
    "First Name": "Benedict",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43114939: {
    id: "item_7103",
    "Last Name": "AMEGLIO",
    "First Name": "STEFANO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43115017: {
    id: "item_20092",
    "Last Name": "Cheong",
    "First Name": "Wei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43115417: {
    id: "item_7104",
    "Last Name": "Slaviero",
    "First Name": "Felipe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43116027: {
    id: "item_7105",
    "Last Name": "Pellerin",
    "First Name": "Christophe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43116194: {
    id: "item_21545",
    "Last Name": "KOBA",
    "First Name": "MITSUO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43116874: {
    id: "item_7106",
    "Last Name": "Satadar",
    "First Name": "Mario",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43117313: {
    id: "item_32607",
    "Last Name": "CHANG",
    "First Name": "HSIAO YUN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43117786: {
    id: "item_32608",
    "Last Name": "HSIA",
    "First Name": "CHIH-CHIANG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43118070: {
    id: "item_32609",
    "Last Name": "HSIA",
    "First Name": "CHEN-YEH",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43118163: {
    id: "item_20093",
    "Last Name": "Madrigal",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43119028: {
    id: "item_32610",
    "Last Name": "Montgomery",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43120212: {
    id: "item_7107",
    "Last Name": "MERLO",
    "First Name": "LUISELLA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43126337: {
    id: "item_32611",
    "Last Name": "Moore",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43126770: {
    id: "item_32612",
    "Last Name": "Aitro",
    "First Name": "Michelle Lee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43127671: {
    id: "item_20094",
    "Last Name": "Zayani",
    "First Name": "Rachid",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43128595: {
    id: "item_34301",
    "Last Name": "Hauser",
    "First Name": "Tina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43129152: {
    id: "item_20095",
    "Last Name": "Wiseman",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43129429: {
    id: "item_20096",
    "Last Name": "Torres-Reyes",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43130248: {
    id: "item_32613",
    "Last Name": "Alvarez",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43130840: {
    id: "item_34302",
    "Last Name": "Dial",
    "First Name": "Janet",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43132265: {
    id: "item_20097",
    "Last Name": "Dignelli",
    "First Name": "Ramon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43132447: {
    id: "item_20098",
    "Last Name": "Zhang",
    "First Name": "Lilin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43133760: {
    id: "item_20099",
    "Last Name": "Guerrero",
    "First Name": "Denise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43134606: {
    id: "item_20100",
    "Last Name": "Olivares Alvarez",
    "First Name": "Sheila Yssel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43135992: {
    id: "item_20101",
    "Last Name": "Penner",
    "First Name": "Joyce Davida",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43136653: {
    id: "item_7108",
    "Last Name": "Suchan",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43136711: {
    id: "item_20102",
    "Last Name": "Modolo",
    "First Name": "Ellen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43137872: {
    id: "item_7109",
    "Last Name": "Sako",
    "First Name": "Liza",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43138947: {
    id: "item_7110",
    "Last Name": "Huang",
    "First Name": "Kerry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43139204: {
    id: "item_7111",
    "Last Name": "Gibson",
    "First Name": "Dean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43139524: {
    id: "item_32614",
    "Last Name": "Chan",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43139899: {
    id: "item_7112",
    "Last Name": "Rameil",
    "First Name": "Alexia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43140232: {
    id: "item_20103",
    "Last Name": "Suharno",
    "First Name": "Muhammad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43140368: {
    id: "item_20104",
    "Last Name": "Baran",
    "First Name": "Vance",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43140526: {
    id: "item_7113",
    "Last Name": "Schmid",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43140656: {
    id: "item_32615",
    "Last Name": "Aronson",
    "First Name": "Gil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43140666: {
    id: "item_32616",
    "Last Name": "Cadena-Perez",
    "First Name": "Alejandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43140758: {
    id: "item_32617",
    "Last Name": "Merk",
    "First Name": "Christian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43141565: {
    id: "item_9084",
    "Last Name": "Hocking",
    "First Name": "Anna Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43141570: {
    id: "item_7114",
    "Last Name": "Ardianto",
    "First Name": "Edoardus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43142212: {
    id: "item_20105",
    "Last Name": "Sandri",
    "First Name": "Prima Hapsari",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43142493: {
    id: "item_32618",
    "Last Name": "Gunawan",
    "First Name": "Yoreen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43142572: {
    id: "item_21546",
    "Last Name": "BIROT",
    "First Name": "JEAN-LUC",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43142608: {
    id: "item_20106",
    "Last Name": "Usman",
    "First Name": "Adella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43143496: {
    id: "item_20107",
    "Last Name": "Darmaputra",
    "First Name": "Adi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43143719: {
    id: "item_34303",
    "Last Name": "Aceves",
    "First Name": "Ana Paula",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43143731: {
    id: "item_7115",
    "Last Name": "Harsono",
    "First Name": "Sudi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43144012: {
    id: "item_34304",
    "Last Name": "Yoo",
    "First Name": "Sang Bong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43144312: {
    id: "item_34305",
    "Last Name": "Chin",
    "First Name": "James",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43144983: {
    id: "item_20108",
    "Last Name": "Wijaya",
    "First Name": "Baryadi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43147864: {
    id: "item_32619",
    "Last Name": "Domenge",
    "First Name": "Laurent",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43148193: {
    id: "item_32620",
    "Last Name": "Gomez Negron",
    "First Name": "Myrna Angelie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43149737: {
    id: "item_34306",
    "Last Name": "Cunanan",
    "First Name": "Maria Emilia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43150005: {
    id: "item_32621",
    "Last Name": "Cunanan",
    "First Name": "Francis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43151223: {
    id: "item_7116",
    "Last Name": "Ly",
    "First Name": "Kheang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43152196: {
    id: "item_7117",
    "Last Name": "Mananta",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43152855: {
    id: "item_7118",
    "Last Name": "Bird",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43153350: {
    id: "item_20109",
    "Last Name": "Habsharie",
    "First Name": "Retno",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43153402: {
    id: "item_20110",
    "Last Name": "Nugroho",
    "First Name": "Ary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43153749: {
    id: "item_7119",
    "Last Name": "HE",
    "First Name": "XIANGYU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43154691: {
    id: "item_32622",
    "Last Name": "Perrottet",
    "First Name": "Aurore",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43154743: {
    id: "item_32623",
    "Last Name": "Plewtong",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43154799: {
    id: "item_32624",
    "Last Name": "Plewtong",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43155615: {
    id: "item_20111",
    "Last Name": "Dunn",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43156469: {
    id: "item_20112",
    "Last Name": "Sorensen",
    "First Name": "Don",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43156479: {
    id: "item_9085",
    "Last Name": "Borner",
    "First Name": "Benoit",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43156871: {
    id: "item_21547",
    "Last Name": "Lutz",
    "First Name": "Manuela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43157079: {
    id: "item_7120",
    "Last Name": "Kunz",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43157176: {
    id: "item_7121",
    "Last Name": "Zhou",
    "First Name": "Qing",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43159987: {
    id: "item_32625",
    "Last Name": "Lahiff",
    "First Name": "Oonagh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43160004: {
    id: "item_32626",
    "Last Name": "Moran",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43160041: {
    id: "item_7122",
    "Last Name": "Petermans",
    "First Name": "Wim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43160690: {
    id: "item_32627",
    "Last Name": "Muench",
    "First Name": "Martina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43160879: {
    id: "item_20113",
    "Last Name": "Shimamoto",
    "First Name": "Darlene",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43160955: {
    id: "item_34307",
    "Last Name": "PŽralta",
    "First Name": "ValŽrie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43162049: {
    id: "item_34308",
    "Last Name": "TSAI",
    "First Name": "TING LIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43162156: {
    id: "item_21548",
    "Last Name": "Crowell",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43163068: {
    id: "item_20114",
    "Last Name": "Cambier",
    "First Name": "Philippe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43163796: {
    id: "item_7123",
    "Last Name": "adorni",
    "First Name": "elisa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43164512: {
    id: "item_20115",
    "Last Name": "Houbaer",
    "First Name": "Robert Frank",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43164996: {
    id: "item_32628",
    "Last Name": "MENG",
    "First Name": "JUN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43165362: {
    id: "item_20116",
    "Last Name": "Pea",
    "First Name": "Davide",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43165366: {
    id: "item_34309",
    "Last Name": "LIU",
    "First Name": "HUA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43165909: {
    id: "item_34310",
    "Last Name": "Amadori",
    "First Name": "Irene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43166204: {
    id: "item_34311",
    "Last Name": "McIntosh",
    "First Name": "Jocelyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43167454: {
    id: "item_7124",
    "Last Name": "Rodrigue",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43167590: {
    id: "item_20117",
    "Last Name": "Bowling",
    "First Name": "Russell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43167929: {
    id: "item_7125",
    "Last Name": "Harto",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43170024: {
    id: "item_21549",
    "Last Name": "Frazer",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43170372: {
    id: "item_7126",
    "Last Name": "TANG",
    "First Name": "Thierry",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43170429: {
    id: "item_20118",
    "Last Name": "Moreno Urbina",
    "First Name": "Alfredo Alejandro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43171395: {
    id: "item_34312",
    "Last Name": "Vinning",
    "First Name": "Dawn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43173238: {
    id: "item_21550",
    "Last Name": "Ojimba",
    "First Name": "Erisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43174750: {
    id: "item_21551",
    "Last Name": "DEPPELER",
    "First Name": "PETER",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43175013: {
    id: "item_7127",
    "Last Name": "Robinson",
    "First Name": "Max",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43175279: {
    id: "item_20119",
    "Last Name": "ZHANG",
    "First Name": "BAO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43175353: {
    id: "item_21552",
    "Last Name": "Ferrara",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43175693: {
    id: "item_7128",
    "Last Name": "Lin",
    "First Name": "Ying",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43176892: {
    id: "item_20120",
    "Last Name": "Arlan Sahari",
    "First Name": "Leza",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43176970: {
    id: "item_9086",
    "Last Name": "Yahya",
    "First Name": "Hery",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43177167: {
    id: "item_34313",
    "Last Name": "Siregar",
    "First Name": "Margarettha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43177954: {
    id: "item_7129",
    "Last Name": "Strathern",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43178070: {
    id: "item_7130",
    "Last Name": "KOIKE",
    "First Name": "SHOICHIRO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43178133: {
    id: "item_32629",
    "Last Name": "Howell",
    "First Name": "Brittany",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43178641: {
    id: "item_20121",
    "Last Name": "Bjorneng",
    "First Name": "Geir Jarle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43178652: {
    id: "item_20122",
    "Last Name": "FERNANDEZ GARCIA",
    "First Name": "LUIS",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43178681: {
    id: "item_9087",
    "Last Name": "Wing Suen Alice",
    "First Name": "Lee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43178805: {
    id: "item_34314",
    "Last Name": "Chuang",
    "First Name": "Kuei-hsiang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43179020: {
    id: "item_9088",
    "Last Name": "Choi Sin",
    "First Name": "Tsang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43179035: {
    id: "item_34315",
    "Last Name": "Meng",
    "First Name": "Ya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43179526: {
    id: "item_34316",
    "Last Name": "Abraham",
    "First Name": "Lambert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43179621: {
    id: "item_20123",
    "Last Name": "Wilson",
    "First Name": "Zanda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43180003: {
    id: "item_9089",
    "Last Name": "Lu",
    "First Name": "Hongbo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43180124: {
    id: "item_20124",
    "Last Name": "Turrina",
    "First Name": "Maria Luisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43180364: {
    id: "item_9090",
    "Last Name": "SANTRUCEK",
    "First Name": "JAROMIR",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43180467: {
    id: "item_32630",
    "Last Name": "Dougherty",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43180933: {
    id: "item_34317",
    "Last Name": "Bang",
    "First Name": "Jade",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43181004: {
    id: "item_34318",
    "Last Name": "Khlaiophas",
    "First Name": "Nophawan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43181020: {
    id: "item_20125",
    "Last Name": "Koska",
    "First Name": "Henrik",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43181114: {
    id: "item_34319",
    "Last Name": "Khlaiophas",
    "First Name": "Yutthakarn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43181135: {
    id: "item_9091",
    "Last Name": "BLAT",
    "First Name": "DANIIL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43181261: {
    id: "item_34320",
    "Last Name": "OTAKE",
    "First Name": "RIKA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43181455: {
    id: "item_20126",
    "Last Name": "OTAKE",
    "First Name": "CHIE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43182028: {
    id: "item_7131",
    "Last Name": "CHUANG",
    "First Name": "TING-JUI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43182407: {
    id: "item_7132",
    "Last Name": "Fassi",
    "First Name": "Mohsen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43182816: {
    id: "item_32631",
    "Last Name": "Di Sante",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43184262: {
    id: "item_9093",
    "Last Name": "Tjokrorahardjo",
    "First Name": "Jeslyne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43184310: {
    id: "item_9092",
    "Last Name": "Cannon",
    "First Name": "Sean",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43184358: {
    id: "item_7133",
    "Last Name": "Bilgin",
    "First Name": "Orcun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43184672: {
    id: "item_21553",
    "Last Name": "Bertram",
    "First Name": "April Dawn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43185144: {
    id: "item_9094",
    "Last Name": "Stellan",
    "First Name": "Anne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43185807: {
    id: "item_20127",
    "Last Name": "Parilov",
    "First Name": "Dmitrii",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43185883: {
    id: "item_34321",
    "Last Name": "Pagano",
    "First Name": "Loris",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43186647: {
    id: "item_20128",
    "Last Name": "Marin Rodriguez",
    "First Name": "Joaquin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43187366: {
    id: "item_21554",
    "Last Name": "Bringemeier",
    "First Name": "Karlene",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43187556: {
    id: "item_20129",
    "Last Name": "Fernandez Garcia",
    "First Name": "Monica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43187850: {
    id: "item_20130",
    "Last Name": "Kociubinska",
    "First Name": "Ilona",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43187906: {
    id: "item_7134",
    "Last Name": "Sanschagrin",
    "First Name": "Chad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43189202: {
    id: "item_34322",
    "Last Name": "Hauser",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43189204: {
    id: "item_7135",
    "Last Name": "Mormile",
    "First Name": "Lucio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43189290: {
    id: "item_9095",
    "Last Name": "Capezzuto",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43189378: {
    id: "item_20131",
    "Last Name": "Bansal",
    "First Name": "Reena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43189926: {
    id: "item_20132",
    "Last Name": "Vorhees",
    "First Name": "Scotty",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43190038: {
    id: "item_32632",
    "Last Name": "Pilloud",
    "First Name": "Etienne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43190182: {
    id: "item_20133",
    "Last Name": "KONSTANTINIDIS",
    "First Name": "IOANNIS",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43190235: {
    id: "item_7136",
    "Last Name": "MENA GONZALEZ",
    "First Name": "LUIS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43190996: {
    id: "item_7137",
    "Last Name": "PAPADIMITRIOU",
    "First Name": "ARISTOFANIS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43193449: {
    id: "item_21555",
    "Last Name": "Mahe Tapa",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43193949: {
    id: "item_7138",
    "Last Name": "van Loon",
    "First Name": "Robertus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43194094: {
    id: "item_20134",
    "Last Name": "GARCIA SILVA",
    "First Name": "HUGO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43195419: {
    id: "item_32633",
    "Last Name": "Rosa",
    "First Name": "Sara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43195681: {
    id: "item_34323",
    "Last Name": "Sanders-Hurst",
    "First Name": "Erica D.",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43195810: {
    id: "item_9096",
    "Last Name": "Gebauer",
    "First Name": "Jonas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43196112: {
    id: "item_7139",
    "Last Name": "Hendricks",
    "First Name": "Missy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43196518: {
    id: "item_32634",
    "Last Name": "Tadytin",
    "First Name": "Angel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43196964: {
    id: "item_7140",
    "Last Name": "Chatterjee",
    "First Name": "Projit",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43198409: {
    id: "item_20135",
    "Last Name": "Efendi",
    "First Name": "Yento",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43198494: {
    id: "item_32635",
    "Last Name": "Ruvalcaba",
    "First Name": "Angelica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43198813: {
    id: "item_34324",
    "Last Name": "Hasegawa",
    "First Name": "Wataru",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43199080: {
    id: "item_7141",
    "Last Name": "Elizondo-Jimenez",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43199618: {
    id: "item_32636",
    "Last Name": "Ingham",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43199654: {
    id: "item_32637",
    "Last Name": "Buitrago",
    "First Name": "Felix",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43201014: {
    id: "item_34325",
    "Last Name": "Ross",
    "First Name": "Catherine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43201534: {
    id: "item_7142",
    "Last Name": "Karagiannis",
    "First Name": "Georgios",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43201804: {
    id: "item_34326",
    "Last Name": "Garcia Garcia",
    "First Name": "Yaiza",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43201837: {
    id: "item_34327",
    "Last Name": "Chenlo Caldelas",
    "First Name": "Brais",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43202349: {
    id: "item_7143",
    "Last Name": "Yee",
    "First Name": "Allison",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43202605: {
    id: "item_21556",
    "Last Name": "CHU",
    "First Name": "CHIH-YANG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43202842: {
    id: "item_7144",
    "Last Name": "ISMAIL",
    "First Name": "IZUAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43202924: {
    id: "item_7145",
    "Last Name": "Huang",
    "First Name": "Ji",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43203210: {
    id: "item_34328",
    "Last Name": "Manuel",
    "First Name": "Cindy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43203431: {
    id: "item_20136",
    "Last Name": "KAWAI",
    "First Name": "TAKAO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43203512: {
    id: "item_20137",
    "Last Name": "Schlereth",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43203602: {
    id: "item_7146",
    "Last Name": "Guo",
    "First Name": "Ruey-Shan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43203891: {
    id: "item_32638",
    "Last Name": "Ajulo",
    "First Name": "Inemami",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43204060: {
    id: "item_20138",
    "Last Name": "Mulazzani",
    "First Name": "Massimo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43204061: {
    id: "item_20139",
    "Last Name": "MULAZZANI",
    "First Name": "FEDERICO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43204211: {
    id: "item_20140",
    "Last Name": "Lodal Mogensen",
    "First Name": "Jane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43204260: {
    id: "item_32639",
    "Last Name": "Young",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43204445: {
    id: "item_20141",
    "Last Name": "HOU",
    "First Name": "Yanfeng",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43204795: {
    id: "item_21557",
    "Last Name": "Edgren",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43204889: {
    id: "item_32640",
    "Last Name": "Lim",
    "First Name": "Ka Ling",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43204952: {
    id: "item_9097",
    "Last Name": "Carandang",
    "First Name": "Eriberto Jr.",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43205103: {
    id: "item_32641",
    "Last Name": "Cugmas",
    "First Name": "Alfonz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43205132: {
    id: "item_7147",
    "Last Name": "Kristoffersen",
    "First Name": "Rita",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43205512: {
    id: "item_20142",
    "Last Name": "Burns",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43205948: {
    id: "item_7148",
    "Last Name": "von Rosen",
    "First Name": "JŸrgen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43205977: {
    id: "item_21558",
    "Last Name": "Stav¿",
    "First Name": "Norunn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43206021: {
    id: "item_7149",
    "Last Name": "Dorofeev",
    "First Name": "Igor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43206332: {
    id: "item_20143",
    "Last Name": "Morris",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43206397: {
    id: "item_7150",
    "Last Name": "STROMSTEN",
    "First Name": "ULF",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43206703: {
    id: "item_7151",
    "Last Name": "Soler Martin",
    "First Name": "Jose Antonio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43207042: {
    id: "item_20144",
    "Last Name": "Lawson-Smith",
    "First Name": "Pia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43207910: {
    id: "item_20145",
    "Last Name": "Bultema",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43208648: {
    id: "item_9098",
    "Last Name": "Chra•bi",
    "First Name": "Malik",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43208828: {
    id: "item_34329",
    "Last Name": "Jones",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43209169: {
    id: "item_7152",
    "Last Name": "Pena",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43209433: {
    id: "item_7153",
    "Last Name": "Soler",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43209519: {
    id: "item_20146",
    "Last Name": "Romero",
    "First Name": "Marjorie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43209683: {
    id: "item_34330",
    "Last Name": "Lau",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43210040: {
    id: "item_32642",
    "Last Name": "Eguimendia Churruca",
    "First Name": "Jesus Maria",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43210083: {
    id: "item_7154",
    "Last Name": "çNGEL çVILA",
    "First Name": "JUAN MANUEL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43210336: {
    id: "item_34331",
    "Last Name": "Ockleberry",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43210338: {
    id: "item_20147",
    "Last Name": "Bastidas",
    "First Name": "Nicol‡s",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43210865: {
    id: "item_9099",
    "Last Name": "Ascarrunz Aramayo",
    "First Name": "Douglas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43210867: {
    id: "item_20148",
    "Last Name": "Casbas huerta",
    "First Name": "Carmelo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43210898: {
    id: "item_7155",
    "Last Name": "Bolo–a",
    "First Name": "JosŽ Antonio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43210961: {
    id: "item_20149",
    "Last Name": "Ng",
    "First Name": "Chi Hang",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43211363: {
    id: "item_7156",
    "Last Name": "NJOROGE",
    "First Name": "PAUL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43211739: {
    id: "item_34332",
    "Last Name": "Garcia",
    "First Name": "Cecille Marie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43211926: {
    id: "item_20150",
    "Last Name": "Santa",
    "First Name": "Adriana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43213005: {
    id: "item_7157",
    "Last Name": "Doblado Sierra",
    "First Name": "Oswaldo Fabricio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43213095: {
    id: "item_20151",
    "Last Name": "Tapia Julca",
    "First Name": "Elias Teodoro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43217359: {
    id: "item_34333",
    "Last Name": "Ahlberg",
    "First Name": "Jeanette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43221156: {
    id: "item_7158",
    "Last Name": "RUIZ SANTOLAYA",
    "First Name": "JULIAN ANTONIO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43221294: {
    id: "item_20152",
    "Last Name": "Carranza Escalante",
    "First Name": "Jorge Luis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43221390: {
    id: "item_32643",
    "Last Name": "Olmeda",
    "First Name": "Julian Matias",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43221455: {
    id: "item_7159",
    "Last Name": "Ogalde Gomez",
    "First Name": "Mauricio Alejandro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43222247: {
    id: "item_21559",
    "Last Name": "MIGHELLA",
    "First Name": "JUAN DOMINGO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43222252: {
    id: "item_20153",
    "Last Name": "Davis",
    "First Name": "Susan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43222424: {
    id: "item_7160",
    "Last Name": "Veloza",
    "First Name": "Raul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43222956: {
    id: "item_32644",
    "Last Name": "Casey",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43222968: {
    id: "item_34334",
    "Last Name": "Kruger",
    "First Name": "Magnus",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43223182: {
    id: "item_32645",
    "Last Name": "Strand",
    "First Name": "Teres",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43223289: {
    id: "item_32646",
    "Last Name": "Merner",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43223505: {
    id: "item_7161",
    "Last Name": "Clark",
    "First Name": "Clayton",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43224336: {
    id: "item_34335",
    "Last Name": "Wallace",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43224618: {
    id: "item_20154",
    "Last Name": "ORTEGA ISAZA",
    "First Name": "JORGE ALBERTO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43225620: {
    id: "item_20155",
    "Last Name": "Slibar",
    "First Name": "Emina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43225713: {
    id: "item_20156",
    "Last Name": "Nielsen",
    "First Name": "Britt",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43226906: {
    id: "item_9100",
    "Last Name": "Pratt",
    "First Name": "Chelsea",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43227194: {
    id: "item_21560",
    "Last Name": "Millar",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43227457: {
    id: "item_34336",
    "Last Name": "Farrell",
    "First Name": "Candice",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43227478: {
    id: "item_34337",
    "Last Name": "Wu",
    "First Name": "Salina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43227493: {
    id: "item_20158",
    "Last Name": "Bastidas",
    "First Name": "Daniela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43227504: {
    id: "item_20157",
    "Last Name": "FIERRO",
    "First Name": "MARIA VALERIA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43227533: {
    id: "item_20159",
    "Last Name": "Bastidas",
    "First Name": "Francisco",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43227847: {
    id: "item_7162",
    "Last Name": "TORRELLAS JOVANI",
    "First Name": "JORDI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43228970: {
    id: "item_34338",
    "Last Name": "Cardona Pineda",
    "First Name": "Maria Sthefany",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43230203: {
    id: "item_21561",
    "Last Name": "Kolesnikova",
    "First Name": "Raisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43230591: {
    id: "item_32647",
    "Last Name": "Young",
    "First Name": "Renee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43230972: {
    id: "item_20160",
    "Last Name": "Toledo-Garcia",
    "First Name": "Aixa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43231166: {
    id: "item_34339",
    "Last Name": "Lopez-Vazquez",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43231721: {
    id: "item_34340",
    "Last Name": "LEWIS",
    "First Name": "ZENITH",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43232331: {
    id: "item_7163",
    "Last Name": "Gates",
    "First Name": "Dirk",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43233969: {
    id: "item_20161",
    "Last Name": "Fahey",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43234143: {
    id: "item_34341",
    "Last Name": "SANCHEZ ALVAREZ",
    "First Name": "JACQUELINE ROCIO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43234568: {
    id: "item_20162",
    "Last Name": "KIM",
    "First Name": "YOUNGSHIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43234648: {
    id: "item_34342",
    "Last Name": "Castillo",
    "First Name": "Jakyrist",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43234847: {
    id: "item_20163",
    "Last Name": "HONG",
    "First Name": "KYUNGHO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43235069: {
    id: "item_34343",
    "Last Name": "NEIS",
    "First Name": "THALIA THEA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43235239: {
    id: "item_7164",
    "Last Name": "Brady",
    "First Name": "Joel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43237062: {
    id: "item_21562",
    "Last Name": "chiou",
    "First Name": "yuhjen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43237614: {
    id: "item_34344",
    "Last Name": "LIU",
    "First Name": "YINGHUA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43237752: {
    id: "item_7165",
    "Last Name": "Torres",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43237877: {
    id: "item_32648",
    "Last Name": "FONG",
    "First Name": "SIO KUN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43238258: {
    id: "item_32649",
    "Last Name": "He",
    "First Name": "Xiaojing",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43238587: {
    id: "item_7166",
    "Last Name": "Gashkova",
    "First Name": "Olga",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43238965: {
    id: "item_7167",
    "Last Name": "Bacon",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43239017: {
    id: "item_7168",
    "Last Name": "Matija_evi_",
    "First Name": "Sr_an",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43240465: {
    id: "item_20164",
    "Last Name": "CHEN",
    "First Name": "CHUN FEI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43240649: {
    id: "item_7169",
    "Last Name": "ZHANG",
    "First Name": "NAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43241428: {
    id: "item_7170",
    "Last Name": "Marusic",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43241916: {
    id: "item_34345",
    "Last Name": "Maltry",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43242141: {
    id: "item_32650",
    "Last Name": "Strand",
    "First Name": "Inga-Lill",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43242662: {
    id: "item_20165",
    "Last Name": "Flšgel",
    "First Name": "Oliver",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43243314: {
    id: "item_32651",
    "Last Name": "Wallace",
    "First Name": "Scarlett",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43243454: {
    id: "item_32652",
    "Last Name": "Navarro",
    "First Name": "Evelyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43243813: {
    id: "item_9101",
    "Last Name": "Clements",
    "First Name": "Tim",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43243916: {
    id: "item_21563",
    "Last Name": "Layton",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43244496: {
    id: "item_9102",
    "Last Name": "Andrew",
    "First Name": "Mairead",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43244875: {
    id: "item_21564",
    "Last Name": "Vincent",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43245494: {
    id: "item_34346",
    "Last Name": "Ventura",
    "First Name": "Nancy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43245521: {
    id: "item_20166",
    "Last Name": "Collins",
    "First Name": "Stanley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43248028: {
    id: "item_7171",
    "Last Name": "Castro Albornoz",
    "First Name": "Juan Pablo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43249211: {
    id: "item_32653",
    "Last Name": "ISHIKAWA",
    "First Name": "TSUBASA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43249522: {
    id: "item_34347",
    "Last Name": "Sellars",
    "First Name": "Mary Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43249662: {
    id: "item_7172",
    "Last Name": "Bejar",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43249718: {
    id: "item_34348",
    "Last Name": "Leiza",
    "First Name": "Laura",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43249976: {
    id: "item_7173",
    "Last Name": "Pizer",
    "First Name": "Emma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43251073: {
    id: "item_20167",
    "Last Name": "Gavrea",
    "First Name": "Veronica",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43251440: {
    id: "item_34349",
    "Last Name": "Rom‡n Toro",
    "First Name": "Carlos Armando",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43251613: {
    id: "item_34350",
    "Last Name": "Sandoval PŽrez",
    "First Name": "Javier Hern‡n",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43252034: {
    id: "item_34351",
    "Last Name": "Fannon",
    "First Name": "Eileen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43252062: {
    id: "item_7174",
    "Last Name": "Wang",
    "First Name": "Xiaojie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43252464: {
    id: "item_32654",
    "Last Name": "LARA GARCIA",
    "First Name": "NELSON RAFAEL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43252506: {
    id: "item_34352",
    "Last Name": "Wiholm Zander",
    "First Name": "Anette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43252510: {
    id: "item_34353",
    "Last Name": "Kim",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43252679: {
    id: "item_32655",
    "Last Name": "OVIEDO COLORADO",
    "First Name": "DEISY JOSEFINA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43252724: {
    id: "item_20168",
    "Last Name": "Mai Phan Huu",
    "First Name": "Quyen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43252984: {
    id: "item_20169",
    "Last Name": "CALVINO",
    "First Name": "PABLO ALBERTO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43253107: {
    id: "item_20170",
    "Last Name": "Rivero",
    "First Name": "Alfredo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43253341: {
    id: "item_9103",
    "Last Name": "Bertotto",
    "First Name": "Marina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43253981: {
    id: "item_20171",
    "Last Name": "Calabria Amaral",
    "First Name": "Angela Giovanna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43254439: {
    id: "item_7175",
    "Last Name": "Gauvin",
    "First Name": "Marco",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43254441: {
    id: "item_9104",
    "Last Name": "Rossi",
    "First Name": "Diego Fernando",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43254605: {
    id: "item_7176",
    "Last Name": "Rocha",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43254896: {
    id: "item_34354",
    "Last Name": "Chintamaneni",
    "First Name": "Kinnera",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43255494: {
    id: "item_20172",
    "Last Name": "Harrer",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43256130: {
    id: "item_32656",
    "Last Name": "Madrid",
    "First Name": "Imelda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43256685: {
    id: "item_7177",
    "Last Name": "Wolf",
    "First Name": "Steven",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43256993: {
    id: "item_21565",
    "Last Name": "Stefanski",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257004: {
    id: "item_32657",
    "Last Name": "McLain",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257071: {
    id: "item_32659",
    "Last Name": "Monaco",
    "First Name": "Danilo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257073: {
    id: "item_32658",
    "Last Name": "ORTIZ ROSARIO",
    "First Name": "JAIME L",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257139: {
    id: "item_21566",
    "Last Name": "Rohadi",
    "First Name": "Mas Alimin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257413: {
    id: "item_21567",
    "Last Name": "Rossi",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257434: {
    id: "item_20173",
    "Last Name": "Martinez",
    "First Name": "Michelle Lorraine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257473: {
    id: "item_34355",
    "Last Name": "Willey",
    "First Name": "Angel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257576: {
    id: "item_20174",
    "Last Name": "Nelson",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257589: {
    id: "item_32660",
    "Last Name": "Mastrocola",
    "First Name": "Filippo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43257765: {
    id: "item_21568",
    "Last Name": "Williams",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43258043: {
    id: "item_20175",
    "Last Name": "Harding",
    "First Name": "Peter Wes",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43258159: {
    id: "item_32661",
    "Last Name": "Hicks",
    "First Name": "Angela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43258558: {
    id: "item_7178",
    "Last Name": "Grubel",
    "First Name": "Angelika",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43258663: {
    id: "item_34356",
    "Last Name": "Botha",
    "First Name": "Henry",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43258722: {
    id: "item_9105",
    "Last Name": "De Leon",
    "First Name": "Anne",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43258764: {
    id: "item_20176",
    "Last Name": "King",
    "First Name": "Tynisha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43258888: {
    id: "item_21569",
    "Last Name": "Sullivan",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43259333: {
    id: "item_20177",
    "Last Name": "Kaufman",
    "First Name": "Patricia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43259834: {
    id: "item_9106",
    "Last Name": "C™te",
    "First Name": "Pierre",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43260329: {
    id: "item_20178",
    "Last Name": "Ackerley",
    "First Name": "Freddie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43260486: {
    id: "item_20179",
    "Last Name": "SON",
    "First Name": "YONG GON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43260586: {
    id: "item_20180",
    "Last Name": "Andrew",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43260945: {
    id: "item_7179",
    "Last Name": "SHIN",
    "First Name": "KANGWOO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43261474: {
    id: "item_7180",
    "Last Name": "DeCarli",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43261635: {
    id: "item_20181",
    "Last Name": "Andrew",
    "First Name": "Sylvie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43261891: {
    id: "item_21570",
    "Last Name": "Rasanayagam",
    "First Name": "Mehalai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43262579: {
    id: "item_20182",
    "Last Name": "Snipes",
    "First Name": "Davon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43262820: {
    id: "item_34357",
    "Last Name": "Zulkarnaen",
    "First Name": "Karin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43263349: {
    id: "item_21571",
    "Last Name": "Karg",
    "First Name": "Karol",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43264570: {
    id: "item_34358",
    "Last Name": "Trainor",
    "First Name": "Heather",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43265290: {
    id: "item_21572",
    "Last Name": "Ezell",
    "First Name": "Sherry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43265405: {
    id: "item_7181",
    "Last Name": "Palmer",
    "First Name": "Lindsey",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43265717: {
    id: "item_7182",
    "Last Name": "Harvey",
    "First Name": "Dom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43265739: {
    id: "item_20183",
    "Last Name": "Metz",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43265889: {
    id: "item_20184",
    "Last Name": "Kaufman",
    "First Name": "Patrik",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43266184: {
    id: "item_34359",
    "Last Name": "Arce",
    "First Name": "Luis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43266988: {
    id: "item_32662",
    "Last Name": "Sullivan",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43266999: {
    id: "item_20185",
    "Last Name": "FENG",
    "First Name": "XINRU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43267168: {
    id: "item_32663",
    "Last Name": "Dotson",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43267202: {
    id: "item_34360",
    "Last Name": "Suzuki",
    "First Name": "Sakula",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43268678: {
    id: "item_21573",
    "Last Name": "Kim",
    "First Name": "Sujin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43268774: {
    id: "item_7183",
    "Last Name": "Porlier",
    "First Name": "Pierre-Paul",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43268916: {
    id: "item_34361",
    "Last Name": "KIMURA",
    "First Name": "TETSURO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43269139: {
    id: "item_7184",
    "Last Name": "CHANG",
    "First Name": "LI WEI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270069: {
    id: "item_20186",
    "Last Name": "KIM",
    "First Name": "HAESIG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270087: {
    id: "item_7185",
    "Last Name": "YU",
    "First Name": "YEONGHYE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270110: {
    id: "item_7186",
    "Last Name": "SON",
    "First Name": "HOKYOUNG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270130: {
    id: "item_7187",
    "Last Name": "KIM",
    "First Name": "HEUNGSEOP",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270162: {
    id: "item_7188",
    "Last Name": "KIM",
    "First Name": "JAE MAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270179: {
    id: "item_20187",
    "Last Name": "CHO",
    "First Name": "NAM SOO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270195: {
    id: "item_7189",
    "Last Name": "PARK",
    "First Name": "KWANGYUL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270228: {
    id: "item_20188",
    "Last Name": "CHANG",
    "First Name": "YOUNG MI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270253: {
    id: "item_20189",
    "Last Name": "CHO",
    "First Name": "TAIHEE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270272: {
    id: "item_7190",
    "Last Name": "KIM",
    "First Name": "JONGCHAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270294: {
    id: "item_20190",
    "Last Name": "HWANG",
    "First Name": "KYUNG MI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270345: {
    id: "item_20191",
    "Last Name": "SEO",
    "First Name": "SANG CHEON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270365: {
    id: "item_34362",
    "Last Name": "YOON",
    "First Name": "SEONGDEOK",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270389: {
    id: "item_20192",
    "Last Name": "KANG",
    "First Name": "JANG SOO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270680: {
    id: "item_20193",
    "Last Name": "LEE",
    "First Name": "JAE HO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270750: {
    id: "item_20194",
    "Last Name": "LEE",
    "First Name": "YOUNGME",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270863: {
    id: "item_20195",
    "Last Name": "PARK",
    "First Name": "JUNG IN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270883: {
    id: "item_7191",
    "Last Name": "KIM",
    "First Name": "SUNGMAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43270980: {
    id: "item_7192",
    "Last Name": "KOO",
    "First Name": "BONYONG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43271175: {
    id: "item_34363",
    "Last Name": "RICHARDSON",
    "First Name": "Kristy Maree",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43271685: {
    id: "item_32664",
    "Last Name": "Skar Westerlind",
    "First Name": "Kristina Anna Gullvi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43272196: {
    id: "item_32665",
    "Last Name": "Westerlind",
    "First Name": "Rolf Lennart",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43273745: {
    id: "item_7193",
    "Last Name": "Lamy Medina",
    "First Name": "Jen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43274308: {
    id: "item_34364",
    "Last Name": "Andersson",
    "First Name": "Anna Marie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43274573: {
    id: "item_7194",
    "Last Name": "Walker",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43274588: {
    id: "item_34365",
    "Last Name": "Murphy",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43274785: {
    id: "item_7195",
    "Last Name": "Garrido",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43274941: {
    id: "item_7196",
    "Last Name": "Hewett",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43274974: {
    id: "item_7197",
    "Last Name": "Perrior",
    "First Name": "Alexandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275061: {
    id: "item_32666",
    "Last Name": "Vahlsing",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275080: {
    id: "item_34366",
    "Last Name": "LINDLEY-GILL",
    "First Name": "Tonya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275282: {
    id: "item_34367",
    "Last Name": "Tobin-Murphy",
    "First Name": "Mary Louise",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275422: {
    id: "item_21574",
    "Last Name": "Baillargeon",
    "First Name": "Louis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275434: {
    id: "item_9107",
    "Last Name": "Fairless",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275623: {
    id: "item_20196",
    "Last Name": "SON",
    "First Name": "DAEHYUN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275817: {
    id: "item_20197",
    "Last Name": "LEE",
    "First Name": "EUISHIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275835: {
    id: "item_20198",
    "Last Name": "Hsu",
    "First Name": "Tak Lai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275850: {
    id: "item_20199",
    "Last Name": "SvendgŒrd",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43275982: {
    id: "item_20200",
    "Last Name": "CHOI",
    "First Name": "MIRA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43276104: {
    id: "item_20201",
    "Last Name": "LEE",
    "First Name": "JONG KEUN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43276213: {
    id: "item_34368",
    "Last Name": "Dogan",
    "First Name": "Keith",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43276240: {
    id: "item_20202",
    "Last Name": "KIM",
    "First Name": "YEONJA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43276398: {
    id: "item_20203",
    "Last Name": "HAN",
    "First Name": "MANKYU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43276516: {
    id: "item_20204",
    "Last Name": "CHO",
    "First Name": "DALSOON",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43276565: {
    id: "item_9108",
    "Last Name": "Novotny",
    "First Name": "Michal",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43276674: {
    id: "item_20205",
    "Last Name": "JUNG",
    "First Name": "JIN YOUNG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43277130: {
    id: "item_20206",
    "Last Name": "Quane",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43277523: {
    id: "item_20207",
    "Last Name": "Lee",
    "First Name": "May Bo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43278006: {
    id: "item_7198",
    "Last Name": "NAM",
    "First Name": "HYOKWOO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43278019: {
    id: "item_9109",
    "Last Name": "Nijnens",
    "First Name": "Margriet",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43278202: {
    id: "item_20208",
    "Last Name": "Khoo",
    "First Name": "Hwee Lian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43278227: {
    id: "item_34369",
    "Last Name": "Bourassa",
    "First Name": "Pierre",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43278781: {
    id: "item_9110",
    "Last Name": "Kastelijns",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43278849: {
    id: "item_20209",
    "Last Name": "Zarth",
    "First Name": "Bettina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43278875: {
    id: "item_32667",
    "Last Name": "Redjouani",
    "First Name": "Yasmina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43279047: {
    id: "item_20210",
    "Last Name": "Mayorga",
    "First Name": "Xochitl",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43279227: {
    id: "item_20211",
    "Last Name": "Zarth",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43279448: {
    id: "item_34370",
    "Last Name": "Gordon",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43279484: {
    id: "item_34371",
    "Last Name": "English",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43279620: {
    id: "item_20212",
    "Last Name": "Daniel",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43279711: {
    id: "item_20213",
    "Last Name": "Carmody",
    "First Name": "Stevie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43279792: {
    id: "item_21575",
    "Last Name": "Espina",
    "First Name": "Annabella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43279814: {
    id: "item_32668",
    "Last Name": "Fratesi",
    "First Name": "Kati",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43279843: {
    id: "item_32669",
    "Last Name": "Eichele",
    "First Name": "Reanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43280367: {
    id: "item_7199",
    "Last Name": "Kahf",
    "First Name": "Markus",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43280648: {
    id: "item_9111",
    "Last Name": "Weil",
    "First Name": "Leon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43280827: {
    id: "item_32670",
    "Last Name": "Bullock",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43281028: {
    id: "item_34372",
    "Last Name": "Antang",
    "First Name": "Cyd",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43281430: {
    id: "item_32671",
    "Last Name": "Coleman",
    "First Name": "Mamie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43281534: {
    id: "item_20214",
    "Last Name": "Darden",
    "First Name": "Ethan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43281587: {
    id: "item_20215",
    "Last Name": "Vercoski",
    "First Name": "Michele",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43282844: {
    id: "item_21576",
    "Last Name": "Cai",
    "First Name": "Shawn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43282868: {
    id: "item_21577",
    "Last Name": "Jonsson",
    "First Name": "Bogi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43283423: {
    id: "item_7200",
    "Last Name": "Betancur",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43283497: {
    id: "item_7201",
    "Last Name": "Mashayek",
    "First Name": "Farzad",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43283592: {
    id: "item_34373",
    "Last Name": "Lindqvist",
    "First Name": "Peder",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43283722: {
    id: "item_32672",
    "Last Name": "Lam",
    "First Name": "Giang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43283770: {
    id: "item_34374",
    "Last Name": "Hedren",
    "First Name": "Jaana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43283926: {
    id: "item_9112",
    "Last Name": "Chamiga",
    "First Name": "Slawomira",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43284457: {
    id: "item_34375",
    "Last Name": "Glover",
    "First Name": "Lyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43284983: {
    id: "item_32673",
    "Last Name": "Greenman",
    "First Name": "Sandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43285073: {
    id: "item_20216",
    "Last Name": "Mostoles",
    "First Name": "Mark Deo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43287662: {
    id: "item_20217",
    "Last Name": "McAlpine",
    "First Name": "Alastair",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43288606: {
    id: "item_7202",
    "Last Name": "Nunez",
    "First Name": "Roberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43289301: {
    id: "item_9113",
    "Last Name": "Mosbauer",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43289385: {
    id: "item_7203",
    "Last Name": "Kipps",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43289436: {
    id: "item_21578",
    "Last Name": "PENG",
    "First Name": "PIN CHUN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43290704: {
    id: "item_7204",
    "Last Name": "Eshuis",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43290730: {
    id: "item_9114",
    "Last Name": "Chan",
    "First Name": "Wai Fun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43291449: {
    id: "item_32674",
    "Last Name": "De Castro",
    "First Name": "Ma Francesca Abigail Guinto",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43291694: {
    id: "item_34376",
    "Last Name": "SHENG",
    "First Name": "SHENG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43291890: {
    id: "item_7205",
    "Last Name": "YUAN",
    "First Name": "XIAOLIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43292375: {
    id: "item_34377",
    "Last Name": "Rutledge",
    "First Name": "Estelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43292413: {
    id: "item_20218",
    "Last Name": "WANG",
    "First Name": "SUSAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43293175: {
    id: "item_34378",
    "Last Name": "Fadlan",
    "First Name": "Said Ridho",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43293786: {
    id: "item_32675",
    "Last Name": "Ross",
    "First Name": "Russell",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43294075: {
    id: "item_32676",
    "Last Name": "Hamzah",
    "First Name": "Hanim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43294100: {
    id: "item_34379",
    "Last Name": "Sutanto",
    "First Name": "Anne Patricia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43294377: {
    id: "item_7206",
    "Last Name": "Thomas",
    "First Name": "Sam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43294395: {
    id: "item_20219",
    "Last Name": "Tartes",
    "First Name": "Tiina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43295371: {
    id: "item_7207",
    "Last Name": "SRISAWAT",
    "First Name": "ORAPIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43295748: {
    id: "item_32677",
    "Last Name": "NOMA",
    "First Name": "KATSUAKI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43296153: {
    id: "item_32678",
    "Last Name": "CHONG",
    "First Name": "SOO MEE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43296229: {
    id: "item_34380",
    "Last Name": "ROBINSON",
    "First Name": "TRISTAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43296443: {
    id: "item_34381",
    "Last Name": "Bastian",
    "First Name": "Johan Bukhari",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43296760: {
    id: "item_32679",
    "Last Name": "Markstedt",
    "First Name": "Karin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43297163: {
    id: "item_20220",
    "Last Name": "Ohsako",
    "First Name": "Yoichiro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43297674: {
    id: "item_21579",
    "Last Name": "Pham-Dang",
    "First Name": "My-Lan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43297771: {
    id: "item_7208",
    "Last Name": "Benoit",
    "First Name": "Eric",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43298088: {
    id: "item_7209",
    "Last Name": "Cameron",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43298177: {
    id: "item_20221",
    "Last Name": "Nielsen",
    "First Name": "Clint",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43298803: {
    id: "item_34382",
    "Last Name": "SEBASTIAN",
    "First Name": "MA VENERACION SEDRIKA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43298882: {
    id: "item_34383",
    "Last Name": "SEBASTIAN",
    "First Name": "PATRICK",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43299801: {
    id: "item_7210",
    "Last Name": "Brunet",
    "First Name": "Julie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43300253: {
    id: "item_7211",
    "Last Name": "De Medio",
    "First Name": "Juan Facundo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43300395: {
    id: "item_32680",
    "Last Name": "Rovea",
    "First Name": "Silvina Rita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43300543: {
    id: "item_21580",
    "Last Name": "Nijs",
    "First Name": "Bert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43300591: {
    id: "item_32681",
    "Last Name": "Chennavajjala",
    "First Name": "Srinivas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43300668: {
    id: "item_32682",
    "Last Name": "Powell",
    "First Name": "Frederick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43301915: {
    id: "item_32683",
    "Last Name": "Montes",
    "First Name": "Juan Manuel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43302533: {
    id: "item_7212",
    "Last Name": "Macdonald",
    "First Name": "Robert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43303709: {
    id: "item_20222",
    "Last Name": "Van De Vijver",
    "First Name": "Ella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43304847: {
    id: "item_7213",
    "Last Name": "Fornari",
    "First Name": "Guido",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43305745: {
    id: "item_20223",
    "Last Name": "Reekmans",
    "First Name": "Bart",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43306010: {
    id: "item_7214",
    "Last Name": "Badea",
    "First Name": "Virgiliu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43307121: {
    id: "item_20224",
    "Last Name": "Villa Larroudet",
    "First Name": "Santiago",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43307431: {
    id: "item_9115",
    "Last Name": "Paz Gasta–aga",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43307729: {
    id: "item_20225",
    "Last Name": "Prieto Duclos",
    "First Name": "Maria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43307966: {
    id: "item_32684",
    "Last Name": "Ortiz Martinez",
    "First Name": "Jaime Anibal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43308379: {
    id: "item_32685",
    "Last Name": "Flores Pavon",
    "First Name": "Aline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43308472: {
    id: "item_9116",
    "Last Name": "Pina",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43310644: {
    id: "item_32686",
    "Last Name": "Marklund",
    "First Name": "Jens",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43311095: {
    id: "item_7215",
    "Last Name": "Hammarstrom",
    "First Name": "Kristina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43311271: {
    id: "item_32687",
    "Last Name": "Anderson",
    "First Name": "Karl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43311425: {
    id: "item_32688",
    "Last Name": "Jahan",
    "First Name": "Rehana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43312636: {
    id: "item_20226",
    "Last Name": "Valerio Francisco",
    "First Name": "Elsa Maria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43313671: {
    id: "item_20227",
    "Last Name": "GARCIA ALVAREZ",
    "First Name": "HEIDI CAROLINA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43313679: {
    id: "item_20228",
    "Last Name": "Cossio De Robles",
    "First Name": "Julio Cesar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43314227: {
    id: "item_9117",
    "Last Name": "Bouzo",
    "First Name": "Dario",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43314789: {
    id: "item_9118",
    "Last Name": "Kohatsu",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43317761: {
    id: "item_20229",
    "Last Name": "HUANG",
    "First Name": "YUMING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43318496: {
    id: "item_20230",
    "Last Name": "Bassaly",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43318587: {
    id: "item_32689",
    "Last Name": "Kiefer",
    "First Name": "Grace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43320155: {
    id: "item_34384",
    "Last Name": "Bostroem",
    "First Name": "Emil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43321283: {
    id: "item_7216",
    "Last Name": "GARCIA SUAREZ",
    "First Name": "JUAN JOSE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43322040: {
    id: "item_34385",
    "Last Name": "Johansen",
    "First Name": "Edvard",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43322931: {
    id: "item_20231",
    "Last Name": "S_omska",
    "First Name": "Monika",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43323473: {
    id: "item_32690",
    "Last Name": "Vermeulen Buis",
    "First Name": "Elvira",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43326061: {
    id: "item_32691",
    "Last Name": "MacMillan",
    "First Name": "Yvonne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43328213: {
    id: "item_7217",
    "Last Name": "filali",
    "First Name": "salwa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43328237: {
    id: "item_34386",
    "Last Name": "Eriksson",
    "First Name": "Lena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43329311: {
    id: "item_20232",
    "Last Name": "Van De Vijver",
    "First Name": "Tomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43329517: {
    id: "item_20233",
    "Last Name": "Carbone",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43330989: {
    id: "item_7218",
    "Last Name": "Gimenez Nabia",
    "First Name": "Joaquin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43331587: {
    id: "item_32692",
    "Last Name": "Georgiev",
    "First Name": "Georgi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43334919: {
    id: "item_20234",
    "Last Name": "Sanchez",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43335899: {
    id: "item_20235",
    "Last Name": "Cruz",
    "First Name": "Justin Micah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43348697: {
    id: "item_20236",
    "Last Name": "STOPNEVICH",
    "First Name": "SERGEY",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43351178: {
    id: "item_32693",
    "Last Name": "Questiaux",
    "First Name": "Jean-Francois",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43351373: {
    id: "item_34387",
    "Last Name": "Malysse",
    "First Name": "Geert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43352255: {
    id: "item_32694",
    "Last Name": "LARASWATI",
    "First Name": "WIDYA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43352723: {
    id: "item_9119",
    "Last Name": "Escribano Braojos",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43356100: {
    id: "item_20237",
    "Last Name": "LaForgia",
    "First Name": "Denise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43359106: {
    id: "item_9120",
    "Last Name": "SUGICH SILVA",
    "First Name": "JOSE ANDRES",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43360135: {
    id: "item_34388",
    "Last Name": "Eriksson",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43360344: {
    id: "item_21581",
    "Last Name": "Johansson",
    "First Name": "Ingela Anette",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43360585: {
    id: "item_20238",
    "Last Name": "Enderby",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43360960: {
    id: "item_32695",
    "Last Name": "Bibiano",
    "First Name": "Ram—n",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43362965: {
    id: "item_34389",
    "Last Name": "Barta",
    "First Name": "Hilary",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43362976: {
    id: "item_34390",
    "Last Name": "Heffernan",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43366202: {
    id: "item_7219",
    "Last Name": "Swindells",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43367718: {
    id: "item_7220",
    "Last Name": "YEH",
    "First Name": "CHENGYUAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43368187: {
    id: "item_7221",
    "Last Name": "TSAO",
    "First Name": "CHIHCHENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43368599: {
    id: "item_7222",
    "Last Name": "Cruz",
    "First Name": "Jan Rasto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43370131: {
    id: "item_21582",
    "Last Name": "McCosh",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43370329: {
    id: "item_34391",
    "Last Name": "Arambewala",
    "First Name": "Saminda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43370542: {
    id: "item_21583",
    "Last Name": "Kuo",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43370544: {
    id: "item_34392",
    "Last Name": "Furphy",
    "First Name": "Jean",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43370777: {
    id: "item_20239",
    "Last Name": "May",
    "First Name": "Mary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43371281: {
    id: "item_34393",
    "Last Name": "Drieberg",
    "First Name": "Bianca",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43371520: {
    id: "item_20240",
    "Last Name": "Etherington",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43371600: {
    id: "item_20241",
    "Last Name": "Etherington",
    "First Name": "Lisa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43371984: {
    id: "item_32696",
    "Last Name": "napier",
    "First Name": "karen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43372909: {
    id: "item_20242",
    "Last Name": "PARK",
    "First Name": "YU JIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43373060: {
    id: "item_20243",
    "Last Name": "Klein",
    "First Name": "Alex",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43373076: {
    id: "item_34394",
    "Last Name": "Sutikno",
    "First Name": "Melatti",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43373454: {
    id: "item_32697",
    "Last Name": "Harahap",
    "First Name": "Amir machmud",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43373824: {
    id: "item_32698",
    "Last Name": "MANO",
    "First Name": "AKI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43373869: {
    id: "item_20244",
    "Last Name": "Hewitt-Scott",
    "First Name": "Natasha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43373923: {
    id: "item_34395",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43374047: {
    id: "item_7223",
    "Last Name": "Popelianski",
    "First Name": "Nathaniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43374256: {
    id: "item_20245",
    "Last Name": "Heng",
    "First Name": "Chris jeffery",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43374488: {
    id: "item_20246",
    "Last Name": "UEJI",
    "First Name": "YUMA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43374592: {
    id: "item_7224",
    "Last Name": "Reidy",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43374598: {
    id: "item_34396",
    "Last Name": "Hochschild",
    "First Name": "Julio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43374807: {
    id: "item_32699",
    "Last Name": "SHIBUYA",
    "First Name": "YASUSHI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43374889: {
    id: "item_20247",
    "Last Name": "Koch",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43374939: {
    id: "item_7225",
    "Last Name": "Taillier",
    "First Name": "Frederic",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43374989: {
    id: "item_20248",
    "Last Name": "Nuebel",
    "First Name": "Andreas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43375022: {
    id: "item_9121",
    "Last Name": "Baer",
    "First Name": "Sven",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43375047: {
    id: "item_20249",
    "Last Name": "Curran",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43375397: {
    id: "item_20250",
    "Last Name": "Jullien",
    "First Name": "Joerg",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43375561: {
    id: "item_20251",
    "Last Name": "Reid",
    "First Name": "Stephen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43375732: {
    id: "item_7226",
    "Last Name": "Sokac",
    "First Name": "Berislav",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43376059: {
    id: "item_7227",
    "Last Name": "Haberda",
    "First Name": "Erwin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43376193: {
    id: "item_20252",
    "Last Name": "Bier",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43376310: {
    id: "item_20253",
    "Last Name": "Nguyen",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43376330: {
    id: "item_20254",
    "Last Name": "Egger",
    "First Name": "Andre",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43378067: {
    id: "item_32700",
    "Last Name": "Nuebel",
    "First Name": "Anja",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43379329: {
    id: "item_32701",
    "Last Name": "Tomlinson",
    "First Name": "Ann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43379383: {
    id: "item_20255",
    "Last Name": "DILLAY",
    "First Name": "EMMANUEL",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43381015: {
    id: "item_9122",
    "Last Name": "Chamiga",
    "First Name": "Andrzej",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43382174: {
    id: "item_34397",
    "Last Name": "Simon",
    "First Name": "Ute",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43382195: {
    id: "item_20256",
    "Last Name": "da Silva Moura",
    "First Name": "Jose Alberto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43382656: {
    id: "item_7228",
    "Last Name": "Schuller",
    "First Name": "Gerhard Kurt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43382704: {
    id: "item_9123",
    "Last Name": "ACHIM",
    "First Name": "Irina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43382998: {
    id: "item_7229",
    "Last Name": "Nordahl",
    "First Name": "Ingulf",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43383025: {
    id: "item_7230",
    "Last Name": "Eslava",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43383651: {
    id: "item_21584",
    "Last Name": "Eckert",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43383654: {
    id: "item_7231",
    "Last Name": "Weckbecker-Yagob",
    "First Name": "Katharina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43383673: {
    id: "item_34398",
    "Last Name": "LUM",
    "First Name": "VANHORNE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43383977: {
    id: "item_34399",
    "Last Name": "Dedow",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43384132: {
    id: "item_34400",
    "Last Name": "Dedow",
    "First Name": "Eike",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43387328: {
    id: "item_34401",
    "Last Name": "D_bkowski",
    "First Name": "Arkadiusz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43387431: {
    id: "item_7232",
    "Last Name": "Staniszewska",
    "First Name": "Magdalena",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43387881: {
    id: "item_7233",
    "Last Name": "jingbiao",
    "First Name": "shan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43388384: {
    id: "item_7234",
    "Last Name": "Kochanowska",
    "First Name": "Magdalena",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43388531: {
    id: "item_20257",
    "Last Name": "Belusica",
    "First Name": "Luca Dumitru",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43389779: {
    id: "item_9124",
    "Last Name": "Rok",
    "First Name": "Dariusz",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43397149: {
    id: "item_7235",
    "Last Name": "FERNANDEZ GIL",
    "First Name": "JUAN RAMON",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43398275: {
    id: "item_20258",
    "Last Name": "FUKUSHIMA",
    "First Name": "WAKANA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43405243: {
    id: "item_32702",
    "Last Name": "KIMIKO",
    "First Name": "SHIRAI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43409314: {
    id: "item_20259",
    "Last Name": "Balroop",
    "First Name": "Ron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43429331: {
    id: "item_32703",
    "Last Name": "Grose",
    "First Name": "Lindy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43429891: {
    id: "item_20260",
    "Last Name": "Bylsma",
    "First Name": "Dan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43430581: {
    id: "item_20261",
    "Last Name": "Sudweeks",
    "First Name": "Morgan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43430862: {
    id: "item_20262",
    "Last Name": "Motmans",
    "First Name": "Alicia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43431110: {
    id: "item_32704",
    "Last Name": "Bowman",
    "First Name": "Tiombe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43431183: {
    id: "item_20263",
    "Last Name": "Granata",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43431676: {
    id: "item_9125",
    "Last Name": "HUANG",
    "First Name": "CHI-CHENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43431911: {
    id: "item_34402",
    "Last Name": "__",
    "First Name": "__",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43432219: {
    id: "item_32705",
    "Last Name": "Chen",
    "First Name": "Hsiang Ling",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43432597: {
    id: "item_20264",
    "Last Name": "Stanton",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43433057: {
    id: "item_21585",
    "Last Name": "Montoya",
    "First Name": "Lucas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43433107: {
    id: "item_9126",
    "Last Name": "Risch",
    "First Name": "Sebastian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43433238: {
    id: "item_20265",
    "Last Name": "Bhalla",
    "First Name": "Gurmeet",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43433678: {
    id: "item_34403",
    "Last Name": "Trabinger",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43433812: {
    id: "item_7236",
    "Last Name": "Tamura",
    "First Name": "Masayoshi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43434237: {
    id: "item_34404",
    "Last Name": "Islam",
    "First Name": "Mysha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43434720: {
    id: "item_7237",
    "Last Name": "Segura",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43434823: {
    id: "item_7238",
    "Last Name": "Amills Beltran",
    "First Name": "Ester",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43434885: {
    id: "item_20266",
    "Last Name": "Mezynski",
    "First Name": "Przemyslaw",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43434894: {
    id: "item_20267",
    "Last Name": "RAHARJA",
    "First Name": "TONO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43434966: {
    id: "item_7239",
    "Last Name": "Verde",
    "First Name": "Eduardo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43435082: {
    id: "item_7240",
    "Last Name": "Heimer",
    "First Name": "Marlene",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43435122: {
    id: "item_7241",
    "Last Name": "Take",
    "First Name": "Naoki",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43435200: {
    id: "item_9127",
    "Last Name": "Pollach",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43435247: {
    id: "item_20268",
    "Last Name": "Markovic",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43435433: {
    id: "item_32706",
    "Last Name": "PI„A SALOMO",
    "First Name": "ORIOL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43435653: {
    id: "item_7242",
    "Last Name": "LEONE",
    "First Name": "FRANCESCO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43435697: {
    id: "item_7243",
    "Last Name": "Lo",
    "First Name": "Chi Man",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43436130: {
    id: "item_20269",
    "Last Name": "McClusky",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43436805: {
    id: "item_32707",
    "Last Name": "Kataria",
    "First Name": "Kunal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43437060: {
    id: "item_21586",
    "Last Name": "Sved Dures",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43437360: {
    id: "item_20270",
    "Last Name": "Manucci",
    "First Name": "Filippo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43437412: {
    id: "item_20271",
    "Last Name": "D'Alvano",
    "First Name": "Michele",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43437440: {
    id: "item_7244",
    "Last Name": "Mandil",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43437464: {
    id: "item_7245",
    "Last Name": "Sacco",
    "First Name": "Angelo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43437561: {
    id: "item_32708",
    "Last Name": "LIVRAGHI",
    "First Name": "ANGELO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43437675: {
    id: "item_20272",
    "Last Name": "Alam",
    "First Name": "Shafiq",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43437734: {
    id: "item_34405",
    "Last Name": "Hare",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43437795: {
    id: "item_7246",
    "Last Name": "Valluzzi",
    "First Name": "Filippo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43438496: {
    id: "item_20273",
    "Last Name": "Sedda",
    "First Name": "Wladimiro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43438620: {
    id: "item_7248",
    "Last Name": "Vestberg",
    "First Name": "Per",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43438627: {
    id: "item_7247",
    "Last Name": "Eriksrud",
    "First Name": "Cecilie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43438782: {
    id: "item_20274",
    "Last Name": "Bj¿rneng",
    "First Name": "Isabella San Miguel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43438812: {
    id: "item_34406",
    "Last Name": "Realini",
    "First Name": "Pietro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43439335: {
    id: "item_34407",
    "Last Name": "Patel",
    "First Name": "Aysha Mohamed Rafik",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43439484: {
    id: "item_7249",
    "Last Name": "OMORI",
    "First Name": "EIICHIRO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43439880: {
    id: "item_34408",
    "Last Name": "Canning",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43440146: {
    id: "item_20275",
    "Last Name": "Dias pereira",
    "First Name": "Silvio Leonardo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43440190: {
    id: "item_21587",
    "Last Name": "Kane",
    "First Name": "Geraldine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43440214: {
    id: "item_21588",
    "Last Name": "Bunawan",
    "First Name": "Edwin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43440257: {
    id: "item_32709",
    "Last Name": "Sellgren",
    "First Name": "Karin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43440575: {
    id: "item_7250",
    "Last Name": "GIURI",
    "First Name": "GAETANO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43440916: {
    id: "item_34409",
    "Last Name": "Kaczor",
    "First Name": "Abigail",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43441075: {
    id: "item_32710",
    "Last Name": "juaristi sesma",
    "First Name": "luis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43441701: {
    id: "item_32711",
    "Last Name": "Gomez",
    "First Name": "Eva",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43442235: {
    id: "item_7251",
    "Last Name": "Giavazzoli",
    "First Name": "Fabio",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43442376: {
    id: "item_7252",
    "Last Name": "Loevold",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43442382: {
    id: "item_32712",
    "Last Name": "NŠslund",
    "First Name": "Annette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43442498: {
    id: "item_7253",
    "Last Name": "LOMBARDI",
    "First Name": "Francesco",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43442681: {
    id: "item_32713",
    "Last Name": "Mannion",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43443087: {
    id: "item_20276",
    "Last Name": "PATINO",
    "First Name": "CARLOS",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43443487: {
    id: "item_7254",
    "Last Name": "Brown",
    "First Name": "Michael Warrender",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43443559: {
    id: "item_21589",
    "Last Name": "Perego",
    "First Name": "Elena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43443857: {
    id: "item_20277",
    "Last Name": "Gurianov",
    "First Name": "Konstantin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43444546: {
    id: "item_32714",
    "Last Name": "Marmor",
    "First Name": "Seth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43444604: {
    id: "item_20278",
    "Last Name": "Le",
    "First Name": "Shirley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43444805: {
    id: "item_34410",
    "Last Name": "Harris",
    "First Name": "Gina Martine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43445883: {
    id: "item_7255",
    "Last Name": "AZORIN ORTU„O",
    "First Name": "LUIS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43446053: {
    id: "item_20279",
    "Last Name": "Ion",
    "First Name": "Diana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43448327: {
    id: "item_34411",
    "Last Name": "PETTINAROLI",
    "First Name": "ALESSANDRO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43448923: {
    id: "item_7256",
    "Last Name": "MIZUNO",
    "First Name": "LAURO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43449024: {
    id: "item_7257",
    "Last Name": "Furukita Mizuno",
    "First Name": "Edna Harue",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43449222: {
    id: "item_32715",
    "Last Name": "CARLINI",
    "First Name": "MORENA MARILISA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43452937: {
    id: "item_34412",
    "Last Name": "Richardson",
    "First Name": "Donald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43469853: {
    id: "item_34413",
    "Last Name": "Greel",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43477282: {
    id: "item_7258",
    "Last Name": "OHASHI",
    "First Name": "TAKASHI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43482831: {
    id: "item_20280",
    "Last Name": "Van Beers",
    "First Name": "Winnie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43482832: {
    id: "item_20281",
    "Last Name": "VAN BEERS",
    "First Name": "MARK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43483496: {
    id: "item_34414",
    "Last Name": "DANILLA HERRERA",
    "First Name": "MOHAMED DIDAKE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43483955: {
    id: "item_20282",
    "Last Name": "Barnes",
    "First Name": "Edward",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43484126: {
    id: "item_7259",
    "Last Name": "MORALES SALGADO",
    "First Name": "VICTORIA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43484676: {
    id: "item_34415",
    "Last Name": "Febriyanti",
    "First Name": "Ghittha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43484802: {
    id: "item_9128",
    "Last Name": "Rao",
    "First Name": "Eravanan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43484914: {
    id: "item_34416",
    "Last Name": "Mahisa",
    "First Name": "Orizanov",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43487187: {
    id: "item_20283",
    "Last Name": "Supsinwiwat",
    "First Name": "R-titaya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43489450: {
    id: "item_20284",
    "Last Name": "McGrath",
    "First Name": "Lilly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43489622: {
    id: "item_32716",
    "Last Name": "Parmenter",
    "First Name": "Craig",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490049: {
    id: "item_20285",
    "Last Name": "Elias",
    "First Name": "Emmanuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490325: {
    id: "item_20286",
    "Last Name": "BOULANGER",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490644: {
    id: "item_32717",
    "Last Name": "CHOI",
    "First Name": "MIKYUNG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490683: {
    id: "item_32718",
    "Last Name": "massini",
    "First Name": "fulvio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490762: {
    id: "item_7260",
    "Last Name": "Vasilenko",
    "First Name": "Daria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490767: {
    id: "item_32719",
    "Last Name": "ROLLE",
    "First Name": "Muriel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490778: {
    id: "item_21590",
    "Last Name": "Peter",
    "First Name": "Samuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490782: {
    id: "item_7261",
    "Last Name": "Catena",
    "First Name": "Alessandro",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490814: {
    id: "item_34417",
    "Last Name": "Philips",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490885: {
    id: "item_20287",
    "Last Name": "Meaney",
    "First Name": "Colm",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490986: {
    id: "item_34418",
    "Last Name": "Arthur",
    "First Name": "Sylvia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43490997: {
    id: "item_7262",
    "Last Name": "DUFEAL",
    "First Name": "Jean-Luc",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43491196: {
    id: "item_20288",
    "Last Name": "RAYMOND",
    "First Name": "CHRISTIAN SERGE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43491273: {
    id: "item_21591",
    "Last Name": "Giacomini",
    "First Name": "Luca",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43491563: {
    id: "item_7263",
    "Last Name": "Yehezkiel",
    "First Name": "Alvin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43491605: {
    id: "item_34419",
    "Last Name": "Madsen",
    "First Name": "Finn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43491716: {
    id: "item_21592",
    "Last Name": "BRAQUET",
    "First Name": "MICHEL FREDDY G",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43492285: {
    id: "item_21593",
    "Last Name": "So",
    "First Name": "Wai Yin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43492317: {
    id: "item_21594",
    "Last Name": "Edmunds",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43492695: {
    id: "item_32720",
    "Last Name": "Seidlova",
    "First Name": "Eva",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43492831: {
    id: "item_7264",
    "Last Name": "Passer˜",
    "First Name": "Patrizia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43493117: {
    id: "item_7265",
    "Last Name": "GARCIA LOPEZ",
    "First Name": "LUIS ANGEL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43493244: {
    id: "item_7266",
    "Last Name": "Kim",
    "First Name": "Yuliya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43493313: {
    id: "item_7267",
    "Last Name": "Kim",
    "First Name": "Yevgeniy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43494394: {
    id: "item_21595",
    "Last Name": "Kerzner",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43494581: {
    id: "item_21596",
    "Last Name": "D'AVOLIO",
    "First Name": "PIETRO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43494991: {
    id: "item_32721",
    "Last Name": "TRAN",
    "First Name": "Mary Chau",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43497199: {
    id: "item_32722",
    "Last Name": "GONZçLEZ PEDROZA",
    "First Name": "ALLAN BARUSH",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43497741: {
    id: "item_21597",
    "Last Name": "Carlson",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43498454: {
    id: "item_7268",
    "Last Name": "Girard",
    "First Name": "Luc",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43499429: {
    id: "item_9129",
    "Last Name": "Darden",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43499537: {
    id: "item_21598",
    "Last Name": "Hein",
    "First Name": "Mar’a Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43499602: {
    id: "item_21599",
    "Last Name": "Swanson",
    "First Name": "Craig",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43499947: {
    id: "item_21600",
    "Last Name": "Boasso",
    "First Name": "Rebecca Carlotta",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43500737: {
    id: "item_21601",
    "Last Name": "Carias",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43500830: {
    id: "item_7269",
    "Last Name": "Sullivan",
    "First Name": "Dann",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43501030: {
    id: "item_34420",
    "Last Name": "Malet",
    "First Name": "Michel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43501132: {
    id: "item_7270",
    "Last Name": "Rahman",
    "First Name": "Huma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43501338: {
    id: "item_21602",
    "Last Name": "Carias",
    "First Name": "Luis Alfredo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43501443: {
    id: "item_21603",
    "Last Name": "Reddy",
    "First Name": "Kamireddy Prema",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43501844: {
    id: "item_21604",
    "Last Name": "Carias",
    "First Name": "Rodrigo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43501948: {
    id: "item_34421",
    "Last Name": "Hennessy",
    "First Name": "Dillan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43502780: {
    id: "item_34422",
    "Last Name": "Hoang",
    "First Name": "Vinh Phu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43503095: {
    id: "item_21605",
    "Last Name": "Villa",
    "First Name": "Giuditta Cristina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43503247: {
    id: "item_21606",
    "Last Name": "Siess",
    "First Name": "Margarete",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43503248: {
    id: "item_21607",
    "Last Name": "Siess",
    "First Name": "Johannes",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43503570: {
    id: "item_21608",
    "Last Name": "Lo",
    "First Name": "Maggie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43503634: {
    id: "item_7271",
    "Last Name": "Selvi",
    "First Name": "Yuksel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43503685: {
    id: "item_7272",
    "Last Name": "Goulding",
    "First Name": "Finbarr",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43503861: {
    id: "item_32723",
    "Last Name": "Sparrow",
    "First Name": "Julie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43505261: {
    id: "item_32724",
    "Last Name": "Savage",
    "First Name": "Tamara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43505302: {
    id: "item_9130",
    "Last Name": "FORONDA",
    "First Name": "NANCY ALEJANDRA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43507870: {
    id: "item_7273",
    "Last Name": "COLIN",
    "First Name": "Stephanie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43507981: {
    id: "item_21609",
    "Last Name": "Nass",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43508720: {
    id: "item_7274",
    "Last Name": "HUSAIN",
    "First Name": "ABDULLA",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43508961: {
    id: "item_21610",
    "Last Name": "Forselius",
    "First Name": "Anders",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43509902: {
    id: "item_21611",
    "Last Name": "Stoyles",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43510288: {
    id: "item_21612",
    "Last Name": "Riscou",
    "First Name": "Ioan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43511305: {
    id: "item_21613",
    "Last Name": "Gemmell",
    "First Name": "Martin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43511351: {
    id: "item_21614",
    "Last Name": "Silva",
    "First Name": "Kristen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43511385: {
    id: "item_32725",
    "Last Name": "Garlapati",
    "First Name": "Bhasker",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43511671: {
    id: "item_32726",
    "Last Name": "Sterling",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43513734: {
    id: "item_21615",
    "Last Name": "Castillo",
    "First Name": "Raul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43514188: {
    id: "item_21616",
    "Last Name": "Wolf",
    "First Name": "Jacquelyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43514377: {
    id: "item_32727",
    "Last Name": "Jen",
    "First Name": "Tobey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43516359: {
    id: "item_32728",
    "Last Name": "VILLAFUERTE",
    "First Name": "LORI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43517941: {
    id: "item_21617",
    "Last Name": "carriedo",
    "First Name": "cesar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43517965: {
    id: "item_21618",
    "Last Name": "Reddy",
    "First Name": "Tashen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43518706: {
    id: "item_21619",
    "Last Name": "LIU",
    "First Name": "JIANZHONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43520040: {
    id: "item_7275",
    "Last Name": "Ding",
    "First Name": "Rongfang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43520233: {
    id: "item_32729",
    "Last Name": "Thompson",
    "First Name": "Teresa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43520312: {
    id: "item_34423",
    "Last Name": "Connon-McDonald",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43520976: {
    id: "item_34424",
    "Last Name": "Wirahadikusumah Tanubrata",
    "First Name": "Ignasius",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43521036: {
    id: "item_7276",
    "Last Name": "Milgate",
    "First Name": "Hunter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43521419: {
    id: "item_21620",
    "Last Name": "LEVENTI TZIOULIOU",
    "First Name": "NIKI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43521692: {
    id: "item_21621",
    "Last Name": "Lee",
    "First Name": "Jaewi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43522904: {
    id: "item_34425",
    "Last Name": "Warner",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43522950: {
    id: "item_32730",
    "Last Name": "Tanaka",
    "First Name": "Toshihiko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43522993: {
    id: "item_21622",
    "Last Name": "Kane",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43523274: {
    id: "item_7277",
    "Last Name": "Jackson",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43523424: {
    id: "item_21623",
    "Last Name": "Chae",
    "First Name": "Scott Sung-Ho",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43523620: {
    id: "item_34426",
    "Last Name": "Burton",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43524027: {
    id: "item_32731",
    "Last Name": "doly",
    "First Name": "doly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43524053: {
    id: "item_7278",
    "Last Name": "Russell",
    "First Name": "Ben",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43524720: {
    id: "item_34427",
    "Last Name": "Gusmanova",
    "First Name": "Liliana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43525562: {
    id: "item_21624",
    "Last Name": "Mc Eachern",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43525570: {
    id: "item_34428",
    "Last Name": "Cooke",
    "First Name": "Chloe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43525846: {
    id: "item_7279",
    "Last Name": "Yan",
    "First Name": "Zhu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43526067: {
    id: "item_7280",
    "Last Name": "Dreno",
    "First Name": "Titouan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43526683: {
    id: "item_7281",
    "Last Name": "Maletz",
    "First Name": "Hans-Christoph Walter Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43527381: {
    id: "item_21625",
    "Last Name": "Gaeta",
    "First Name": "Julia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43528078: {
    id: "item_32732",
    "Last Name": "Yuen",
    "First Name": "Man Kwong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43528097: {
    id: "item_7282",
    "Last Name": "Sachdev",
    "First Name": "Savannah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43528390: {
    id: "item_7283",
    "Last Name": "Brodnicki",
    "First Name": "Ralf",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43528699: {
    id: "item_34429",
    "Last Name": "Macleod",
    "First Name": "Donald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43528724: {
    id: "item_7284",
    "Last Name": "ming",
    "First Name": "jiang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43528850: {
    id: "item_7285",
    "Last Name": "Barreiros Dias Duque",
    "First Name": "Rui Manuel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43528925: {
    id: "item_7286",
    "Last Name": "Khimji",
    "First Name": "Imran",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43529137: {
    id: "item_34430",
    "Last Name": "George",
    "First Name": "Cheryl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43529181: {
    id: "item_21626",
    "Last Name": "Hogancamp",
    "First Name": "Brent",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43530024: {
    id: "item_34431",
    "Last Name": "Sim",
    "First Name": "Li-shern",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43530504: {
    id: "item_21627",
    "Last Name": "Brachmann",
    "First Name": "Michaela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43530747: {
    id: "item_21628",
    "Last Name": "Petersen",
    "First Name": "Jan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43530972: {
    id: "item_21629",
    "Last Name": "devloo",
    "First Name": "celine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43531050: {
    id: "item_9131",
    "Last Name": "Devloo",
    "First Name": "cedric",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43531139: {
    id: "item_34432",
    "Last Name": "oconnell",
    "First Name": "Justin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43532240: {
    id: "item_7287",
    "Last Name": "Rocco",
    "First Name": "Luca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43533033: {
    id: "item_9132",
    "Last Name": "JIMENEZ CANDELA",
    "First Name": "SANTIAGO RAFAEL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43533355: {
    id: "item_34433",
    "Last Name": "Morritt",
    "First Name": "Beverley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43534029: {
    id: "item_32733",
    "Last Name": "Schmid",
    "First Name": "Alina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43534419: {
    id: "item_21630",
    "Last Name": "Winters",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43534563: {
    id: "item_32734",
    "Last Name": "Schmid",
    "First Name": "Sonja Michaela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43535552: {
    id: "item_21631",
    "Last Name": "Cook Jr",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43535555: {
    id: "item_9133",
    "Last Name": "Brazzo",
    "First Name": "Renee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43535587: {
    id: "item_34434",
    "Last Name": "Burke",
    "First Name": "Rayna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43535651: {
    id: "item_9134",
    "Last Name": "Hoang",
    "First Name": "Thuong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43535768: {
    id: "item_21632",
    "Last Name": "Hague",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43535956: {
    id: "item_9135",
    "Last Name": "Brinker",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43536053: {
    id: "item_21633",
    "Last Name": "Ramsey",
    "First Name": "Mandy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43536202: {
    id: "item_21634",
    "Last Name": "Howard",
    "First Name": "Rafael Santillan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43536257: {
    id: "item_21635",
    "Last Name": "Riddle",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43536309: {
    id: "item_7288",
    "Last Name": "Goldstein",
    "First Name": "Brianna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43536816: {
    id: "item_34435",
    "Last Name": "Sana",
    "First Name": "Marilou",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43537012: {
    id: "item_21636",
    "Last Name": "Williams",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43537896: {
    id: "item_9136",
    "Last Name": "Albert",
    "First Name": "Mark",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43538030: {
    id: "item_32735",
    "Last Name": "Rouai",
    "First Name": "Sadok",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43538409: {
    id: "item_21637",
    "Last Name": "Kdouh",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43540084: {
    id: "item_21638",
    "Last Name": "Prowse",
    "First Name": "Karen",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43540266: {
    id: "item_7289",
    "Last Name": "Williams",
    "First Name": "Tom",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43542147: {
    id: "item_34436",
    "Last Name": "Sryantoro Wakeling",
    "First Name": "Ratri",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43543061: {
    id: "item_34437",
    "Last Name": "Gavriliadis",
    "First Name": "Fiona",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43543177: {
    id: "item_21639",
    "Last Name": "Thurecht",
    "First Name": "Norman",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43543330: {
    id: "item_7290",
    "Last Name": "Reitz",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43543667: {
    id: "item_7291",
    "Last Name": "Kigen",
    "First Name": "Hilda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43543848: {
    id: "item_9137",
    "Last Name": "Sweetapple",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43544409: {
    id: "item_34438",
    "Last Name": "OIKAWA",
    "First Name": "TOMOKO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43544410: {
    id: "item_34439",
    "Last Name": "Nicholas",
    "First Name": "Claudine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43544595: {
    id: "item_21640",
    "Last Name": "Uzair",
    "First Name": "Anum",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43544791: {
    id: "item_32736",
    "Last Name": "Tho",
    "First Name": "Yeong Wah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43545003: {
    id: "item_7292",
    "Last Name": "Clohisey",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43545405: {
    id: "item_9138",
    "Last Name": "Leaney",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43545507: {
    id: "item_7293",
    "Last Name": "PLAISANT",
    "First Name": "CHRISTOPHE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43546367: {
    id: "item_7294",
    "Last Name": "Fitzgerald",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43546396: {
    id: "item_34440",
    "Last Name": "Clancy",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43546612: {
    id: "item_7295",
    "Last Name": "Chan",
    "First Name": "Yui Chit Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43546909: {
    id: "item_34441",
    "Last Name": "Chinnareddy",
    "First Name": "Babitha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43547068: {
    id: "item_32737",
    "Last Name": "Erickson",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43547086: {
    id: "item_7296",
    "Last Name": "Karabassova",
    "First Name": "Alma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43547217: {
    id: "item_21641",
    "Last Name": "Beyer",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43547253: {
    id: "item_32738",
    "Last Name": "HANAI",
    "First Name": "HIDEKI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43547272: {
    id: "item_21642",
    "Last Name": "Beyer",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43547277: {
    id: "item_7297",
    "Last Name": "David",
    "First Name": "Florina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43548679: {
    id: "item_32739",
    "Last Name": "HANAI",
    "First Name": "HARUMI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43550344: {
    id: "item_34442",
    "Last Name": "QUINZ",
    "First Name": "ROBERTA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43551236: {
    id: "item_21644",
    "Last Name": "Ras",
    "First Name": "Wilfred",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43551243: {
    id: "item_21643",
    "Last Name": "Volpacchio",
    "First Name": "Florindo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43551884: {
    id: "item_32740",
    "Last Name": "Ward",
    "First Name": "Donna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43551893: {
    id: "item_32741",
    "Last Name": "Devoto",
    "First Name": "Monica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43552103: {
    id: "item_32742",
    "Last Name": "Cancela",
    "First Name": "Gerardo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43552209: {
    id: "item_32743",
    "Last Name": "O dwyer kelly",
    "First Name": "Zoe",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43552456: {
    id: "item_7298",
    "Last Name": "Wang",
    "First Name": "Xiaoyu",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43552689: {
    id: "item_32744",
    "Last Name": "Wilson",
    "First Name": "Aleisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43553764: {
    id: "item_32745",
    "Last Name": "Lochmann",
    "First Name": "Marika Jacqueline",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43554213: {
    id: "item_21645",
    "Last Name": "Nesbitt",
    "First Name": "Clive",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43554276: {
    id: "item_21646",
    "Last Name": "Rieutort-Louis",
    "First Name": "Warren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43554660: {
    id: "item_7299",
    "Last Name": "Fumich",
    "First Name": "Frank",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43556553: {
    id: "item_32746",
    "Last Name": "Albon",
    "First Name": "Lorraine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43556617: {
    id: "item_34443",
    "Last Name": "Ravines",
    "First Name": "Luz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43556753: {
    id: "item_21647",
    "Last Name": "Duffy",
    "First Name": "Nichola",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43558053: {
    id: "item_21648",
    "Last Name": "Holford",
    "First Name": "Nora",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43558368: {
    id: "item_21649",
    "Last Name": "Fang",
    "First Name": "Wei",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43558748: {
    id: "item_7300",
    "Last Name": "Nakich",
    "First Name": "Erik",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43558884: {
    id: "item_21650",
    "Last Name": "Cassidy",
    "First Name": "Sydney",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43559513: {
    id: "item_21651",
    "Last Name": "Goldberg",
    "First Name": "Guillermina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43560487: {
    id: "item_7301",
    "Last Name": "Villavicencio",
    "First Name": "Luis Alberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43561145: {
    id: "item_7302",
    "Last Name": "Carvajal",
    "First Name": "Carolina",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43561279: {
    id: "item_7303",
    "Last Name": "SARABIA",
    "First Name": "GILDARDO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43561557: {
    id: "item_34444",
    "Last Name": "Cunningham",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43561681: {
    id: "item_21652",
    "Last Name": "maria leticia",
    "First Name": "maria leticia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43561790: {
    id: "item_32747",
    "Last Name": "Krishnan",
    "First Name": "Reena",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43562675: {
    id: "item_32748",
    "Last Name": "Leblond",
    "First Name": "Liam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43562843: {
    id: "item_21653",
    "Last Name": "Lopez Crozet",
    "First Name": "Alejo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43563546: {
    id: "item_34445",
    "Last Name": "Hughes",
    "First Name": "Tracey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43564222: {
    id: "item_21654",
    "Last Name": "Lulic",
    "First Name": "Mario",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43565598: {
    id: "item_32749",
    "Last Name": "Lee",
    "First Name": "Kyungsook",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43566169: {
    id: "item_21655",
    "Last Name": "Altenburg",
    "First Name": "Chong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43566576: {
    id: "item_34446",
    "Last Name": "Ablay",
    "First Name": "Joni",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43566624: {
    id: "item_21656",
    "Last Name": "OConnell",
    "First Name": "Sally",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43567313: {
    id: "item_7304",
    "Last Name": "Schreiber",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43567384: {
    id: "item_7305",
    "Last Name": "Scrase",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43567399: {
    id: "item_7306",
    "Last Name": "Foo",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43569133: {
    id: "item_21657",
    "Last Name": "Berge",
    "First Name": "Lutz",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43569598: {
    id: "item_21658",
    "Last Name": "Cook",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43569620: {
    id: "item_21659",
    "Last Name": "Berge",
    "First Name": "Martina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43569825: {
    id: "item_7307",
    "Last Name": "Jones",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43571129: {
    id: "item_21660",
    "Last Name": "Scott",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43571255: {
    id: "item_21661",
    "Last Name": "Lightbody",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43572653: {
    id: "item_9139",
    "Last Name": "Brown",
    "First Name": "Brandon Allen",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43574089: {
    id: "item_32750",
    "Last Name": "Ramalingam",
    "First Name": "Nagendran",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43576434: {
    id: "item_34447",
    "Last Name": "MALET",
    "First Name": "Nicolas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43576764: {
    id: "item_34448",
    "Last Name": "Diaz",
    "First Name": "Annie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43577803: {
    id: "item_21662",
    "Last Name": "Vazquez Villasanti",
    "First Name": "Federico Miguel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43577919: {
    id: "item_32751",
    "Last Name": "Mast",
    "First Name": "Robert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43578601: {
    id: "item_9140",
    "Last Name": "Wilson",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43578843: {
    id: "item_32752",
    "Last Name": "Ganjekar",
    "First Name": "Naman",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43579999: {
    id: "item_32753",
    "Last Name": "Clark",
    "First Name": "Justine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43580214: {
    id: "item_34449",
    "Last Name": "KEIICHI",
    "First Name": "NAGATA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43581294: {
    id: "item_32754",
    "Last Name": "Wrigley",
    "First Name": "Kousha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43582756: {
    id: "item_7308",
    "Last Name": "McCourt",
    "First Name": "Derrick",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43583172: {
    id: "item_7309",
    "Last Name": "slaoui",
    "First Name": "mehdi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43583395: {
    id: "item_7310",
    "Last Name": "Jacobsen",
    "First Name": "Peter Holst",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43584034: {
    id: "item_21663",
    "Last Name": "Smith",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43584556: {
    id: "item_9141",
    "Last Name": "Geyer",
    "First Name": "Adam",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43584764: {
    id: "item_21664",
    "Last Name": "Campbell",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43586083: {
    id: "item_34450",
    "Last Name": "CHOUNAN",
    "First Name": "YASUKA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43586132: {
    id: "item_21665",
    "Last Name": "sonne",
    "First Name": "Jeppe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43586154: {
    id: "item_34451",
    "Last Name": "Fukasawa",
    "First Name": "Yuji",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43586723: {
    id: "item_7311",
    "Last Name": "Adcock",
    "First Name": "Simon",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43589833: {
    id: "item_21666",
    "Last Name": "Schuely",
    "First Name": "Christoph",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43590450: {
    id: "item_7312",
    "Last Name": "MARANGOS",
    "First Name": "LEONIDAS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43590924: {
    id: "item_21667",
    "Last Name": "Kasarla",
    "First Name": "Ram",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43591191: {
    id: "item_21668",
    "Last Name": "Koletsios",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43591869: {
    id: "item_21669",
    "Last Name": "Roeders",
    "First Name": "ingo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43596109: {
    id: "item_21670",
    "Last Name": "QUIROGA MIRELES",
    "First Name": "CARLOS ALBERTO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43596821: {
    id: "item_34452",
    "Last Name": "Yu",
    "First Name": "Chun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43596898: {
    id: "item_7313",
    "Last Name": "Braun",
    "First Name": "Raymond",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43598151: {
    id: "item_21671",
    "Last Name": "Miyama",
    "First Name": "Seiji",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43598722: {
    id: "item_21672",
    "Last Name": "Milton",
    "First Name": "Angela",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43599100: {
    id: "item_7314",
    "Last Name": "Chan",
    "First Name": "Siu-Ho",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43599125: {
    id: "item_21673",
    "Last Name": "Ward",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43599210: {
    id: "item_21674",
    "Last Name": "Atkinson",
    "First Name": "Steven",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43599272: {
    id: "item_9142",
    "Last Name": "Myer",
    "First Name": "Melissa",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43599909: {
    id: "item_21675",
    "Last Name": "Rigby",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43599964: {
    id: "item_21676",
    "Last Name": "ranson",
    "First Name": "lee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43600100: {
    id: "item_34453",
    "Last Name": "Cooke",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43600164: {
    id: "item_21677",
    "Last Name": "Intwala",
    "First Name": "Kalpeshkumar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43600292: {
    id: "item_21678",
    "Last Name": "Graydon",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43600398: {
    id: "item_32755",
    "Last Name": "Liang",
    "First Name": "Feng",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43600506: {
    id: "item_32756",
    "Last Name": "Papanicolaou",
    "First Name": "Marcus",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43600991: {
    id: "item_34454",
    "Last Name": "Kondo",
    "First Name": "Kazuya",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43601126: {
    id: "item_32757",
    "Last Name": "Yderberg",
    "First Name": "Patrik",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43601493: {
    id: "item_32758",
    "Last Name": "Powell",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43601638: {
    id: "item_32759",
    "Last Name": "Kane",
    "First Name": "Tammi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43601649: {
    id: "item_21679",
    "Last Name": "Sonne",
    "First Name": "Carl-Rasmus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43601918: {
    id: "item_21680",
    "Last Name": "COELHO",
    "First Name": "Cristina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43602514: {
    id: "item_32760",
    "Last Name": "Tan",
    "First Name": "Mona Lisa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43602528: {
    id: "item_21681",
    "Last Name": "Dias dos Santos",
    "First Name": "Matheus",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43603649: {
    id: "item_21682",
    "Last Name": "figueiredo",
    "First Name": "chiovonne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43603721: {
    id: "item_21683",
    "Last Name": "figueiredo",
    "First Name": "armando SA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43604703: {
    id: "item_21684",
    "Last Name": "Rodriguez Duarte",
    "First Name": "Fernando Javier",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43605175: {
    id: "item_32761",
    "Last Name": "Petakova",
    "First Name": "Samanta",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43605298: {
    id: "item_32762",
    "Last Name": "Hopen",
    "First Name": "Harald",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43605432: {
    id: "item_21685",
    "Last Name": "Ranson",
    "First Name": "Alana",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43605983: {
    id: "item_32763",
    "Last Name": "weilmann",
    "First Name": "marcelo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43606055: {
    id: "item_7315",
    "Last Name": "MUJICAZALAMEA",
    "First Name": "ANDRES MAURICIO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43606779: {
    id: "item_7316",
    "Last Name": "Harris",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43607160: {
    id: "item_21686",
    "Last Name": "Alb",
    "First Name": "Venecia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43607382: {
    id: "item_32764",
    "Last Name": "Frohlich",
    "First Name": "Gabriela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43608320: {
    id: "item_21687",
    "Last Name": "AYALLA PRAZERES",
    "First Name": "JOSE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43608457: {
    id: "item_21688",
    "Last Name": "Da Silva",
    "First Name": "cibele",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43611474: {
    id: "item_32765",
    "Last Name": "Tempton",
    "First Name": "Marie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43612241: {
    id: "item_32766",
    "Last Name": "Fisk",
    "First Name": "Nicolene",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43612306: {
    id: "item_7317",
    "Last Name": "Chaney",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43612608: {
    id: "item_34455",
    "Last Name": "Tomlinson",
    "First Name": "Gavin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43613200: {
    id: "item_32767",
    "Last Name": "Character",
    "First Name": "Janice",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43614121: {
    id: "item_21689",
    "Last Name": "Pedrozo Silvero",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43614250: {
    id: "item_34456",
    "Last Name": "WOISIN",
    "First Name": "MARGARET",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43614703: {
    id: "item_21690",
    "Last Name": "Brown",
    "First Name": "Anissa",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43615720: {
    id: "item_34457",
    "Last Name": "CUBILLA VILLALBA",
    "First Name": "HADA SUSANA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43617220: {
    id: "item_21691",
    "Last Name": "Lee",
    "First Name": "Bethany",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43618156: {
    id: "item_9143",
    "Last Name": "Meyers",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43618341: {
    id: "item_21692",
    "Last Name": "Grainger",
    "First Name": "Kirsty",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43619439: {
    id: "item_32768",
    "Last Name": "Hepburn",
    "First Name": "Damali",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43619505: {
    id: "item_21693",
    "Last Name": "Taylor",
    "First Name": "Kenny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43619674: {
    id: "item_21694",
    "Last Name": "Osborne",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43621149: {
    id: "item_34458",
    "Last Name": "kim",
    "First Name": "hongwoo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43621581: {
    id: "item_7318",
    "Last Name": "mohendroo",
    "First Name": "munish",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43621639: {
    id: "item_21695",
    "Last Name": "Rinaudo",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43622449: {
    id: "item_7319",
    "Last Name": "Luna Alamilla",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43622826: {
    id: "item_21696",
    "Last Name": "Oliver",
    "First Name": "Alison",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43622886: {
    id: "item_32769",
    "Last Name": "shigejima",
    "First Name": "kenji",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43623149: {
    id: "item_34459",
    "Last Name": "Rae",
    "First Name": "Erica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43623981: {
    id: "item_21697",
    "Last Name": "Blasczak",
    "First Name": "Kynan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624028: {
    id: "item_21698",
    "Last Name": "Forde",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624155: {
    id: "item_21699",
    "Last Name": "KIM",
    "First Name": "SUK HYUNG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624347: {
    id: "item_34460",
    "Last Name": "WOO",
    "First Name": "SUNGEUN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624440: {
    id: "item_34461",
    "Last Name": "SEOL",
    "First Name": "SEONGYONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624520: {
    id: "item_21700",
    "Last Name": "KIM",
    "First Name": "ANDREW NOHRIP",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624551: {
    id: "item_21701",
    "Last Name": "Watson",
    "First Name": "Robert",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624562: {
    id: "item_7320",
    "Last Name": "Bastide",
    "First Name": "Hugo J",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624596: {
    id: "item_21702",
    "Last Name": "HU",
    "First Name": "QINGWEI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624606: {
    id: "item_21703",
    "Last Name": "BYUN",
    "First Name": "JONG SEH",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624650: {
    id: "item_21704",
    "Last Name": "Sumners",
    "First Name": "Zayne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624843: {
    id: "item_21705",
    "Last Name": "KWON",
    "First Name": "DONG WOOK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43624902: {
    id: "item_7321",
    "Last Name": "Patel",
    "First Name": "Alpesh",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43625121: {
    id: "item_34462",
    "Last Name": "Raquedan",
    "First Name": "Pia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43625938: {
    id: "item_21706",
    "Last Name": "Abid",
    "First Name": "Salman",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43626074: {
    id: "item_34463",
    "Last Name": "Garc’a-Cordero Gallego",
    "First Name": "çngel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43626638: {
    id: "item_21707",
    "Last Name": "Boylan",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43626752: {
    id: "item_21708",
    "Last Name": "Ishida",
    "First Name": "Hisanaga",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43626948: {
    id: "item_21709",
    "Last Name": "Stevens",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43627135: {
    id: "item_20289",
    "Last Name": "McConnell",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43629672: {
    id: "item_34464",
    "Last Name": "Ramos Schulze",
    "First Name": "Raul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43630935: {
    id: "item_34465",
    "Last Name": "Horn",
    "First Name": "Heidi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43634145: {
    id: "item_9144",
    "Last Name": "Diniz Morgado",
    "First Name": "Carla Alexandra",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43635596: {
    id: "item_9145",
    "Last Name": "Poulton",
    "First Name": "Gary",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43637785: {
    id: "item_21710",
    "Last Name": "Xenos",
    "First Name": "Austin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43639257: {
    id: "item_34466",
    "Last Name": "Rondario",
    "First Name": "Michelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43639528: {
    id: "item_34467",
    "Last Name": "Rondario",
    "First Name": "Michael Ian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43641445: {
    id: "item_34468",
    "Last Name": "Bragas - Millan",
    "First Name": "Rushelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43642135: {
    id: "item_21711",
    "Last Name": "Arroyo",
    "First Name": "Lidia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43643150: {
    id: "item_34469",
    "Last Name": "URATA",
    "First Name": "YOSHIKO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43643843: {
    id: "item_21712",
    "Last Name": "Thurecht",
    "First Name": "Katherine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43644161: {
    id: "item_32770",
    "Last Name": "Ayers",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43644889: {
    id: "item_32771",
    "Last Name": "Camilleri",
    "First Name": "Joanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43644892: {
    id: "item_21713",
    "Last Name": "Tumilty",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43644909: {
    id: "item_7322",
    "Last Name": "Mossig",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43645155: {
    id: "item_21714",
    "Last Name": "Garc’a-Cordero Gallego",
    "First Name": "Jacobo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43645251: {
    id: "item_21715",
    "Last Name": "Harriman",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43645407: {
    id: "item_21716",
    "Last Name": "Sanders",
    "First Name": "Johannes",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43645546: {
    id: "item_9146",
    "Last Name": "Colquhoun",
    "First Name": "Campbell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43645823: {
    id: "item_7323",
    "Last Name": "Holden",
    "First Name": "Gareth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43646016: {
    id: "item_9147",
    "Last Name": "Francis",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43646076: {
    id: "item_9148",
    "Last Name": "Carlie",
    "First Name": "Carlie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43646223: {
    id: "item_34470",
    "Last Name": "Gloria",
    "First Name": "Ma. Rosanna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43646338: {
    id: "item_34471",
    "Last Name": "Benson",
    "First Name": "Amie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43646402: {
    id: "item_32772",
    "Last Name": "Enomoto",
    "First Name": "Goji",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43646489: {
    id: "item_34472",
    "Last Name": "Hillman",
    "First Name": "Peita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43646578: {
    id: "item_9149",
    "Last Name": "Sacca",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43647009: {
    id: "item_34473",
    "Last Name": "Santa Teresa",
    "First Name": "Jc",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43647499: {
    id: "item_32773",
    "Last Name": "Shirilele",
    "First Name": "Ignatius Clement",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43647966: {
    id: "item_32774",
    "Last Name": "NOGUCHI",
    "First Name": "MIDORI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43648088: {
    id: "item_32775",
    "Last Name": "DIXON",
    "First Name": "GARY",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43648540: {
    id: "item_32776",
    "Last Name": "Wada",
    "First Name": "Sachie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43648574: {
    id: "item_21717",
    "Last Name": "HAMADA",
    "First Name": "AYUMI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43649079: {
    id: "item_32777",
    "Last Name": "Aiba",
    "First Name": "Yuki",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43649332: {
    id: "item_32778",
    "Last Name": "NOGUCHI",
    "First Name": "MASAHIRO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43649368: {
    id: "item_7324",
    "Last Name": "Bradbury",
    "First Name": "James",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43650498: {
    id: "item_34474",
    "Last Name": "Mecking",
    "First Name": "Bettina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43650872: {
    id: "item_21718",
    "Last Name": "Vetere",
    "First Name": "Rhonda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43651676: {
    id: "item_7325",
    "Last Name": "Ford",
    "First Name": "Darran",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43652234: {
    id: "item_34475",
    "Last Name": "Les",
    "First Name": "Char",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43653095: {
    id: "item_34476",
    "Last Name": "Petersen",
    "First Name": "Bec",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43654443: {
    id: "item_20290",
    "Last Name": "Arcieri",
    "First Name": "Massimiliano",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43656444: {
    id: "item_21719",
    "Last Name": "Garlinska",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43656874: {
    id: "item_34477",
    "Last Name": "Meyer",
    "First Name": "Roslyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43657490: {
    id: "item_34478",
    "Last Name": "Corcoran",
    "First Name": "Timothy M",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43658048: {
    id: "item_21720",
    "Last Name": "Ah Kong",
    "First Name": "Tracy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43658289: {
    id: "item_20291",
    "Last Name": "Eagles",
    "First Name": "Ruth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43658377: {
    id: "item_32779",
    "Last Name": "Martin",
    "First Name": "Neil",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43658474: {
    id: "item_32780",
    "Last Name": "Co",
    "First Name": "Dan Gilbert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43659271: {
    id: "item_21721",
    "Last Name": "Stevens",
    "First Name": "Tony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43659867: {
    id: "item_21722",
    "Last Name": "WU",
    "First Name": "LIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43662372: {
    id: "item_21723",
    "Last Name": "Pilares",
    "First Name": "Richie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43663292: {
    id: "item_34479",
    "Last Name": "Drury",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43663401: {
    id: "item_34480",
    "Last Name": "Kelly",
    "First Name": "Kim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43663493: {
    id: "item_21724",
    "Last Name": "Stobbs",
    "First Name": "India",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43663650: {
    id: "item_7326",
    "Last Name": "CHOO",
    "First Name": "HYUN SOO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43663735: {
    id: "item_34481",
    "Last Name": "TAYLOR",
    "First Name": "LELANIA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43663816: {
    id: "item_9150",
    "Last Name": "Smith",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43664070: {
    id: "item_21725",
    "Last Name": "KIM",
    "First Name": "TAEK SOO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43664094: {
    id: "item_21726",
    "Last Name": "Joo",
    "First Name": "Bang Ok",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43664112: {
    id: "item_21727",
    "Last Name": "Oh",
    "First Name": "Dongkeun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43664130: {
    id: "item_21728",
    "Last Name": "Lee",
    "First Name": "Daesung",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43664156: {
    id: "item_34482",
    "Last Name": "Grashuis",
    "First Name": "Carmel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43664175: {
    id: "item_34483",
    "Last Name": "Alkhub",
    "First Name": "Mohammed",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43664243: {
    id: "item_20292",
    "Last Name": "Addicott",
    "First Name": "Paul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43664478: {
    id: "item_20293",
    "Last Name": "Raimondi",
    "First Name": "Michele",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43664556: {
    id: "item_34484",
    "Last Name": "Ward",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43669175: {
    id: "item_34485",
    "Last Name": "xiao",
    "First Name": "ziye",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43670216: {
    id: "item_21729",
    "Last Name": "Clarke",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43671016: {
    id: "item_34486",
    "Last Name": "White",
    "First Name": "Cassandra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43673222: {
    id: "item_32781",
    "Last Name": "Farragher",
    "First Name": "Rachel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43674666: {
    id: "item_21730",
    "Last Name": "Mooney",
    "First Name": "Chad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43675645: {
    id: "item_21731",
    "Last Name": "Luba_",
    "First Name": "Anna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43676273: {
    id: "item_32782",
    "Last Name": "Twiggs",
    "First Name": "Chris",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43677365: {
    id: "item_34487",
    "Last Name": "Perri",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43677913: {
    id: "item_21732",
    "Last Name": "Salazar",
    "First Name": "Pablo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43679067: {
    id: "item_32783",
    "Last Name": "Huang",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43679110: {
    id: "item_21733",
    "Last Name": "Huang",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43679410: {
    id: "item_34488",
    "Last Name": "Flores",
    "First Name": "Yolanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43679841: {
    id: "item_34489",
    "Last Name": "KAPARELIS",
    "First Name": "JOHN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43680375: {
    id: "item_32784",
    "Last Name": "Brevard",
    "First Name": "Veronica",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43681069: {
    id: "item_34490",
    "Last Name": "Ernst",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43682857: {
    id: "item_21734",
    "Last Name": "Ryan",
    "First Name": "William",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43683347: {
    id: "item_32785",
    "Last Name": "Twiggs",
    "First Name": "Diana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43683546: {
    id: "item_7327",
    "Last Name": "Beas",
    "First Name": "Isai",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43683913: {
    id: "item_34491",
    "Last Name": "Giancola",
    "First Name": "Vicky",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43684562: {
    id: "item_7328",
    "Last Name": "McIntyre Aguirre",
    "First Name": "Amber",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43685776: {
    id: "item_9151",
    "Last Name": "Pritchard",
    "First Name": "Ken",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43685825: {
    id: "item_34492",
    "Last Name": "ABRAJANO",
    "First Name": "JOANNE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43686124: {
    id: "item_32786",
    "Last Name": "Surya",
    "First Name": "Ivan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43686165: {
    id: "item_21735",
    "Last Name": "Firdaus",
    "First Name": "Mokhamad",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43686259: {
    id: "item_34493",
    "Last Name": "Geromboux",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43686313: {
    id: "item_21736",
    "Last Name": "Alatorre Estrada",
    "First Name": "Federico",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43686892: {
    id: "item_9152",
    "Last Name": "Soriano Martinez",
    "First Name": "Jorge Nestor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43687153: {
    id: "item_21737",
    "Last Name": "McMahon",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43687197: {
    id: "item_34494",
    "Last Name": "Straetemans",
    "First Name": "Alexandro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43687976: {
    id: "item_9153",
    "Last Name": "Furst",
    "First Name": "Andrea",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43688064: {
    id: "item_32787",
    "Last Name": "Syafaat",
    "First Name": "Hidranto",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43688232: {
    id: "item_21738",
    "Last Name": "Meecham",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43688511: {
    id: "item_21739",
    "Last Name": "Molyneux",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43688797: {
    id: "item_32788",
    "Last Name": "Kalnina Laksa",
    "First Name": "Daiga",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43691065: {
    id: "item_7329",
    "Last Name": "Tejeiro",
    "First Name": "Marcos",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43692216: {
    id: "item_32789",
    "Last Name": "ISHIDA",
    "First Name": "YASUHIRO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43692758: {
    id: "item_21740",
    "Last Name": "Zhu",
    "First Name": "He",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43694141: {
    id: "item_21741",
    "Last Name": "Rodr’guez Santos",
    "First Name": "Jaime",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43695044: {
    id: "item_7330",
    "Last Name": "Jackson",
    "First Name": "Rebecca",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43696357: {
    id: "item_21742",
    "Last Name": "Nava",
    "First Name": "Carlota",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43696521: {
    id: "item_7331",
    "Last Name": "BEDEKAR",
    "First Name": "MAHESH",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43697094: {
    id: "item_7332",
    "Last Name": "Wijaya",
    "First Name": "Wilson",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43698141: {
    id: "item_34495",
    "Last Name": "Gonzalez",
    "First Name": "Andres",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43699949: {
    id: "item_21743",
    "Last Name": "Doolan",
    "First Name": "Kristine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43701358: {
    id: "item_9154",
    "Last Name": "LOZANO",
    "First Name": "MARCO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43702549: {
    id: "item_7333",
    "Last Name": "FERRO",
    "First Name": "ROBERTO CARLOS",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43703254: {
    id: "item_21744",
    "Last Name": "Kim",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43705893: {
    id: "item_7334",
    "Last Name": "Arias Rodriguez",
    "First Name": "Fernando",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43705987: {
    id: "item_34496",
    "Last Name": "OKAMURA",
    "First Name": "TOSHIKO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43708623: {
    id: "item_21745",
    "Last Name": "Krochmal",
    "First Name": "Riley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43709792: {
    id: "item_32790",
    "Last Name": "Yonkman",
    "First Name": "Aaron",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43710850: {
    id: "item_9155",
    "Last Name": "Aryaguna",
    "First Name": "Ananda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43711535: {
    id: "item_21746",
    "Last Name": "W—jcik",
    "First Name": "Jaros_aw",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43712252: {
    id: "item_21747",
    "Last Name": "Siem Velarde",
    "First Name": "Soraya Yasmin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43712297: {
    id: "item_34497",
    "Last Name": "TORII",
    "First Name": "KUMI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43712366: {
    id: "item_21748",
    "Last Name": "WîJCIK",
    "First Name": "ELIZA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43713225: {
    id: "item_21749",
    "Last Name": "Miki",
    "First Name": "Tomomi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43713384: {
    id: "item_32791",
    "Last Name": "Schaefer",
    "First Name": "Elisabeth Inge",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43714017: {
    id: "item_21750",
    "Last Name": "Cornelius",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43714569: {
    id: "item_34498",
    "Last Name": "Davis",
    "First Name": "Kiley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43714574: {
    id: "item_34499",
    "Last Name": "Yoshida",
    "First Name": "Takako",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43715762: {
    id: "item_32792",
    "Last Name": "Taut",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43717591: {
    id: "item_7335",
    "Last Name": "HAFFERTY",
    "First Name": "WILLIAM",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43717594: {
    id: "item_9156",
    "Last Name": "Ulrich",
    "First Name": "Dirk",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43720758: {
    id: "item_32793",
    "Last Name": "Buchleither",
    "First Name": "Detlef",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43723239: {
    id: "item_21751",
    "Last Name": "Hoagland",
    "First Name": "Rachael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43724489: {
    id: "item_32794",
    "Last Name": "Itagaki",
    "First Name": "Shintaro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43725307: {
    id: "item_32795",
    "Last Name": "Haynes",
    "First Name": "Emma",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43727244: {
    id: "item_32796",
    "Last Name": "Gillmore",
    "First Name": "Janelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43728612: {
    id: "item_21752",
    "Last Name": "Watanabe",
    "First Name": "Mai",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43731020: {
    id: "item_21753",
    "Last Name": "Shalabi",
    "First Name": "Akram",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43731556: {
    id: "item_34500",
    "Last Name": "Santa Teresa",
    "First Name": "Jeanette",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43732264: {
    id: "item_34501",
    "Last Name": "Sullivan",
    "First Name": "Richard",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43732707: {
    id: "item_34502",
    "Last Name": "Zhang",
    "First Name": "Danyang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43736105: {
    id: "item_21754",
    "Last Name": "Wadle",
    "First Name": "Sabine Ursula",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43736884: {
    id: "item_32797",
    "Last Name": "Rosado",
    "First Name": "Edward",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43736947: {
    id: "item_21755",
    "Last Name": "Fernandez Maquieira",
    "First Name": "Arturo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43736967: {
    id: "item_32798",
    "Last Name": "Cruz",
    "First Name": "Silvana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43740313: {
    id: "item_21756",
    "Last Name": "Medina",
    "First Name": "Miguel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43741767: {
    id: "item_7336",
    "Last Name": "Rushford",
    "First Name": "Chris",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43743330: {
    id: "item_7337",
    "Last Name": "Kashima",
    "First Name": "Chohachi",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43743569: {
    id: "item_21757",
    "Last Name": "Bay",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43744121: {
    id: "item_34503",
    "Last Name": "FUJII",
    "First Name": "NOBUYOSHI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43747352: {
    id: "item_7338",
    "Last Name": "Jenkins",
    "First Name": "Amber",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43749141: {
    id: "item_34504",
    "Last Name": "Busutel",
    "First Name": "Kym",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43749452: {
    id: "item_34505",
    "Last Name": "Buhayo",
    "First Name": "Elizabeth",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43750497: {
    id: "item_32799",
    "Last Name": "Furlong",
    "First Name": "Gafyn",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43750518: {
    id: "item_21758",
    "Last Name": "Seto",
    "First Name": "Cary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43750705: {
    id: "item_32800",
    "Last Name": "Floris",
    "First Name": "Peter",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43750810: {
    id: "item_32801",
    "Last Name": "Lersakrussamee",
    "First Name": "Naruemon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43752121: {
    id: "item_34506",
    "Last Name": "Shaw",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43752301: {
    id: "item_21759",
    "Last Name": "WALAC",
    "First Name": "JACEK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43752531: {
    id: "item_21760",
    "Last Name": "von Arx",
    "First Name": "Meret Ann",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43752865: {
    id: "item_32802",
    "Last Name": "YOSHIDA",
    "First Name": "KAORI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43753650: {
    id: "item_21761",
    "Last Name": "McGovern",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43754533: {
    id: "item_34507",
    "Last Name": "Mullins-May",
    "First Name": "Maureen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43755176: {
    id: "item_7339",
    "Last Name": "Bliss",
    "First Name": "Laura",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43755470: {
    id: "item_7340",
    "Last Name": "Szewczyk",
    "First Name": "Artur",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43755655: {
    id: "item_7341",
    "Last Name": "Sparks",
    "First Name": "John",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43755672: {
    id: "item_21762",
    "Last Name": "Im",
    "First Name": "Eunice",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43755754: {
    id: "item_21763",
    "Last Name": "Im",
    "First Name": "Ted",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43755927: {
    id: "item_32803",
    "Last Name": "Kadkol",
    "First Name": "Anand",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43756058: {
    id: "item_7342",
    "Last Name": "MERLO",
    "First Name": "MICHEL",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43758098: {
    id: "item_34508",
    "Last Name": "Alvarenga",
    "First Name": "Ondina L",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43758429: {
    id: "item_32804",
    "Last Name": "Steel",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43762300: {
    id: "item_7343",
    "Last Name": "Jansonius",
    "First Name": "Jennifer",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43767714: {
    id: "item_34509",
    "Last Name": "Wong",
    "First Name": "Li Tein",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43767977: {
    id: "item_21764",
    "Last Name": "Dalley",
    "First Name": "Maxwell",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43768383: {
    id: "item_21765",
    "Last Name": "MacDiarmid",
    "First Name": "Georgie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43768772: {
    id: "item_21766",
    "Last Name": "Hernandez",
    "First Name": "Joyce",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43769160: {
    id: "item_34510",
    "Last Name": "Tagarino",
    "First Name": "Elmer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43769603: {
    id: "item_34511",
    "Last Name": "Fuller",
    "First Name": "Sasha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43770065: {
    id: "item_34512",
    "Last Name": "Tanlu",
    "First Name": "Louie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43770777: {
    id: "item_21767",
    "Last Name": "LU",
    "First Name": "LU",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43771088: {
    id: "item_34513",
    "Last Name": "Buhayo",
    "First Name": "Sharon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43771114: {
    id: "item_7344",
    "Last Name": "Como",
    "First Name": "Mario",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43771702: {
    id: "item_32805",
    "Last Name": "Choi",
    "First Name": "Sanghyun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43771727: {
    id: "item_21768",
    "Last Name": "Guntoro",
    "First Name": "Rusli",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43772196: {
    id: "item_7345",
    "Last Name": "Ortega",
    "First Name": "Adolfo",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43773494: {
    id: "item_7346",
    "Last Name": "Cooper",
    "First Name": "Kathryn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43773546: {
    id: "item_7347",
    "Last Name": "McKinstry",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43773573: {
    id: "item_32806",
    "Last Name": "Goolsby",
    "First Name": "Brandy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43774389: {
    id: "item_21769",
    "Last Name": "KIM",
    "First Name": "KYOUNGMI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43774666: {
    id: "item_7348",
    "Last Name": "KIM",
    "First Name": "KYUNGSU",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43774684: {
    id: "item_7349",
    "Last Name": "IEONG",
    "First Name": "SOI LONG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43774709: {
    id: "item_9157",
    "Last Name": "LEE",
    "First Name": "YOONSEOK",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43774771: {
    id: "item_34514",
    "Last Name": "LAM",
    "First Name": "MEI KENG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43774812: {
    id: "item_7350",
    "Last Name": "Polumysnyi",
    "First Name": "Sergii",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43774824: {
    id: "item_21770",
    "Last Name": "French",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43774853: {
    id: "item_9158",
    "Last Name": "Rachman",
    "First Name": "Andy Rifandy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43774952: {
    id: "item_34515",
    "Last Name": "Llado",
    "First Name": "Ana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43775052: {
    id: "item_21771",
    "Last Name": "Cadacio",
    "First Name": "Aldrick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43775569: {
    id: "item_7351",
    "Last Name": "Plotnikova",
    "First Name": "Anastasiya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43775603: {
    id: "item_34516",
    "Last Name": "Simjaya",
    "First Name": "Alwi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43776175: {
    id: "item_34517",
    "Last Name": "Pearson",
    "First Name": "Mike",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43776830: {
    id: "item_32807",
    "Last Name": "Carvil",
    "First Name": "Philip",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43777400: {
    id: "item_32808",
    "Last Name": "Cheam",
    "First Name": "Tze Hui",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43778540: {
    id: "item_32809",
    "Last Name": "Young",
    "First Name": "Johnny",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43779500: {
    id: "item_21772",
    "Last Name": "Vohra",
    "First Name": "Ranu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43781065: {
    id: "item_7352",
    "Last Name": "Polanco",
    "First Name": "Agustin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43781417: {
    id: "item_9159",
    "Last Name": "Jimenez Arechar",
    "First Name": "Rafael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43781667: {
    id: "item_7353",
    "Last Name": "Lai",
    "First Name": "Suk Yee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43782249: {
    id: "item_34518",
    "Last Name": "Gorenberg",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43782533: {
    id: "item_32810",
    "Last Name": "Sheldon",
    "First Name": "Agnes",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43782872: {
    id: "item_21773",
    "Last Name": "Gold",
    "First Name": "Hadassah Esther",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43783494: {
    id: "item_21774",
    "Last Name": "PARCON",
    "First Name": "PHILLIP",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43783747: {
    id: "item_21775",
    "Last Name": "LEVY",
    "First Name": "RINA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43784616: {
    id: "item_21776",
    "Last Name": "GADAMSKA-KABATA",
    "First Name": "Paulina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43784621: {
    id: "item_21777",
    "Last Name": "KHEDIS",
    "First Name": "MEHDI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43784815: {
    id: "item_21778",
    "Last Name": "li",
    "First Name": "jennifer",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43785244: {
    id: "item_21779",
    "Last Name": "Bryant",
    "First Name": "Leonie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43785601: {
    id: "item_32811",
    "Last Name": "Gerber",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43787187: {
    id: "item_32812",
    "Last Name": "Forester",
    "First Name": "Manulang Rentohay",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43787200: {
    id: "item_34519",
    "Last Name": "Li",
    "First Name": "Gengu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43788092: {
    id: "item_7354",
    "Last Name": "Rougas",
    "First Name": "Megan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43788278: {
    id: "item_32813",
    "Last Name": "George",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43788963: {
    id: "item_32814",
    "Last Name": "Austin",
    "First Name": "Towalame",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43789606: {
    id: "item_21780",
    "Last Name": "Wieblitz",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43791098: {
    id: "item_7355",
    "Last Name": "Vereb",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43791767: {
    id: "item_7356",
    "Last Name": "Makonnen",
    "First Name": "Salome",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43794781: {
    id: "item_21781",
    "Last Name": "Siangsomboon",
    "First Name": "Naphat",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43794960: {
    id: "item_21782",
    "Last Name": "Stavropoulos",
    "First Name": "Jade",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43795155: {
    id: "item_21783",
    "Last Name": "Kheder",
    "First Name": "Yousra",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43795411: {
    id: "item_21784",
    "Last Name": "Park",
    "First Name": "Nuno",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43795673: {
    id: "item_7357",
    "Last Name": "PARK",
    "First Name": "DAEKEUN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43795782: {
    id: "item_7358",
    "Last Name": "KIM",
    "First Name": "HYEONKI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43796022: {
    id: "item_21785",
    "Last Name": "KIM",
    "First Name": "SUNHYO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43796247: {
    id: "item_21786",
    "Last Name": "YIN",
    "First Name": "ZHIQING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43796252: {
    id: "item_34520",
    "Last Name": "Thomas-Kircher",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43796666: {
    id: "item_34521",
    "Last Name": "Zimner",
    "First Name": "Isaac",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43796692: {
    id: "item_21787",
    "Last Name": "Bezer",
    "First Name": "Cameron",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43796737: {
    id: "item_21788",
    "Last Name": "Ibanez",
    "First Name": "Bruno",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43796805: {
    id: "item_34522",
    "Last Name": "SARUTHIRATHANAWORAKUN",
    "First Name": "RATHAPON",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43797078: {
    id: "item_7359",
    "Last Name": "Weimer",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43797139: {
    id: "item_34523",
    "Last Name": "Langley",
    "First Name": "Maxine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43797195: {
    id: "item_21789",
    "Last Name": "Weimer",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43797292: {
    id: "item_34524",
    "Last Name": "Charoenpiriyanont",
    "First Name": "Atiphu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43797700: {
    id: "item_34525",
    "Last Name": "Chutiteerakeart",
    "First Name": "Jirunthanin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43799438: {
    id: "item_32815",
    "Last Name": "YIU",
    "First Name": "LI YING CARROLL",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43800318: {
    id: "item_21790",
    "Last Name": "YAO",
    "First Name": "ZHENHUA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43800672: {
    id: "item_32816",
    "Last Name": "Kaminski",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43801616: {
    id: "item_21791",
    "Last Name": "Solodkin",
    "First Name": "Anatoliy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43802934: {
    id: "item_34526",
    "Last Name": "Tantisuwat",
    "First Name": "Rachot",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43803699: {
    id: "item_34527",
    "Last Name": "Lander-Kapavik",
    "First Name": "Candace",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43803865: {
    id: "item_34528",
    "Last Name": "Kapavik",
    "First Name": "William",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43804453: {
    id: "item_9160",
    "Last Name": "Wangatau",
    "First Name": "Charisma",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43804681: {
    id: "item_7360",
    "Last Name": "Raviv",
    "First Name": "Mirit",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43806734: {
    id: "item_21792",
    "Last Name": "Cueto Medina",
    "First Name": "Ascencion Humberto",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43807527: {
    id: "item_21793",
    "Last Name": "Clarke",
    "First Name": "Jake",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43809404: {
    id: "item_34529",
    "Last Name": "Joaquin Rosso",
    "First Name": "Paola",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43809758: {
    id: "item_21794",
    "Last Name": "Reyna",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43810150: {
    id: "item_32817",
    "Last Name": "Spann",
    "First Name": "Tara",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43812017: {
    id: "item_21795",
    "Last Name": "Charlton-Jones",
    "First Name": "Alasdair",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43812643: {
    id: "item_34530",
    "Last Name": "YŽvenes",
    "First Name": "Claudia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43813273: {
    id: "item_21796",
    "Last Name": "Lee",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43814317: {
    id: "item_21797",
    "Last Name": "PARK",
    "First Name": "TAEHEE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43814821: {
    id: "item_9161",
    "Last Name": "CHOI",
    "First Name": "DAEYOUNG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43815145: {
    id: "item_32818",
    "Last Name": "YEUNG",
    "First Name": "JEAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43815389: {
    id: "item_32819",
    "Last Name": "HO",
    "First Name": "YI CHIA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43815442: {
    id: "item_21798",
    "Last Name": "Gil",
    "First Name": "Manuel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43815635: {
    id: "item_34531",
    "Last Name": "Adam-Terem",
    "First Name": "Rosemary C",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43816025: {
    id: "item_21799",
    "Last Name": "TONG",
    "First Name": "LIN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43816150: {
    id: "item_21800",
    "Last Name": "ZHANG",
    "First Name": "TAO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43816579: {
    id: "item_21801",
    "Last Name": "CUI",
    "First Name": "YING",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43817117: {
    id: "item_21802",
    "Last Name": "LIU",
    "First Name": "XIAO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43817671: {
    id: "item_32820",
    "Last Name": "LU",
    "First Name": "RUI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43817938: {
    id: "item_32821",
    "Last Name": "WANG",
    "First Name": "PENGYU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43818067: {
    id: "item_21803",
    "Last Name": "HAO",
    "First Name": "QIAN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43818269: {
    id: "item_9162",
    "Last Name": "Zarhin",
    "First Name": "Rami",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43818319: {
    id: "item_34532",
    "Last Name": "sun",
    "First Name": "yanjun",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43818403: {
    id: "item_34533",
    "Last Name": "ZHU",
    "First Name": "JING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43818405: {
    id: "item_21804",
    "Last Name": "WANG",
    "First Name": "QI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43818534: {
    id: "item_32822",
    "Last Name": "Wong",
    "First Name": "Wai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43818558: {
    id: "item_21805",
    "Last Name": "Cao",
    "First Name": "ZHENLEI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43818612: {
    id: "item_21806",
    "Last Name": "ZHUANG",
    "First Name": "YINGRUI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43818778: {
    id: "item_7361",
    "Last Name": "HONG",
    "First Name": "ZHONG XIANG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43819102: {
    id: "item_9163",
    "Last Name": "Ameyaw",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43819299: {
    id: "item_21807",
    "Last Name": "Karta",
    "First Name": "Pranata Adiwijaya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43820277: {
    id: "item_32823",
    "Last Name": "Clark",
    "First Name": "Tammy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43820304: {
    id: "item_21808",
    "Last Name": "Kamate",
    "First Name": "Ousmane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43820504: {
    id: "item_7362",
    "Last Name": "Maaliki",
    "First Name": "Mounir",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43822665: {
    id: "item_34534",
    "Last Name": "Cortes",
    "First Name": "Claribel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43826822: {
    id: "item_9164",
    "Last Name": "Usher",
    "First Name": "Tanya",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43830232: {
    id: "item_21809",
    "Last Name": "Chiu",
    "First Name": "Lori",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43832200: {
    id: "item_21810",
    "Last Name": "Pring",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43833171: {
    id: "item_21811",
    "Last Name": "DOUROS",
    "First Name": "JENNA LOUISE",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43835369: {
    id: "item_32824",
    "Last Name": "KIM",
    "First Name": "DOKYEONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43835589: {
    id: "item_32825",
    "Last Name": "SIM",
    "First Name": "YUNJI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43836231: {
    id: "item_32826",
    "Last Name": "KANG",
    "First Name": "JIHYE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43836294: {
    id: "item_32827",
    "Last Name": "CHAN",
    "First Name": "Jeremy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43836671: {
    id: "item_32828",
    "Last Name": "watanabe",
    "First Name": "haruki",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43836883: {
    id: "item_34535",
    "Last Name": "Routt",
    "First Name": "Antonia M.",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43837548: {
    id: "item_21812",
    "Last Name": "suter",
    "First Name": "christine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43839319: {
    id: "item_9165",
    "Last Name": "Ishii",
    "First Name": "Kenji",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43839342: {
    id: "item_32829",
    "Last Name": "Nagamori",
    "First Name": "Hajimu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43839348: {
    id: "item_21813",
    "Last Name": "Vignani",
    "First Name": "Ottavia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43839361: {
    id: "item_21814",
    "Last Name": "Nagamori",
    "First Name": "Taro",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43839437: {
    id: "item_32830",
    "Last Name": "Miyakawa",
    "First Name": "Atsuko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43839466: {
    id: "item_7363",
    "Last Name": "Jamaluddin",
    "First Name": "Nurul Ili",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43839469: {
    id: "item_7364",
    "Last Name": "Yamada",
    "First Name": "Shinji",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43839533: {
    id: "item_7365",
    "Last Name": "Zanul Abdin",
    "First Name": "Mohd Azmir",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43840079: {
    id: "item_32831",
    "Last Name": "McCowen",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43840386: {
    id: "item_21815",
    "Last Name": "Rasmussen",
    "First Name": "Johanna Simona",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43840986: {
    id: "item_7366",
    "Last Name": "Appo",
    "First Name": "Dudley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43841787: {
    id: "item_21816",
    "Last Name": "Quarmby",
    "First Name": "Shaun",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43842120: {
    id: "item_9166",
    "Last Name": "Fraser",
    "First Name": "Emily",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43844088: {
    id: "item_21817",
    "Last Name": "Yu",
    "First Name": "Chang-Hong",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43844456: {
    id: "item_34536",
    "Last Name": "Rose",
    "First Name": "Carla",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43844674: {
    id: "item_21818",
    "Last Name": "Chezum",
    "First Name": "Rick",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43845035: {
    id: "item_7367",
    "Last Name": "Holloway",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43845736: {
    id: "item_34537",
    "Last Name": "Maharani",
    "First Name": "Megah Ayu",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43850029: {
    id: "item_21819",
    "Last Name": "Meskers",
    "First Name": "Isabel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43850763: {
    id: "item_7368",
    "Last Name": "Paulson",
    "First Name": "Ashley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43851066: {
    id: "item_21820",
    "Last Name": "Luo",
    "First Name": "Dexuan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43851464: {
    id: "item_34538",
    "Last Name": "Jackson",
    "First Name": "Patti",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43851933: {
    id: "item_21821",
    "Last Name": "Clarke",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43852768: {
    id: "item_21822",
    "Last Name": "Mitchell",
    "First Name": "Valencia Renee",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43854995: {
    id: "item_21823",
    "Last Name": "Ho",
    "First Name": "Cherry",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43856469: {
    id: "item_32832",
    "Last Name": "NAOHARU",
    "First Name": "NAKAYAMA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43859235: {
    id: "item_32833",
    "Last Name": "Yip",
    "First Name": "Wai Hung Jason",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43862695: {
    id: "item_7369",
    "Last Name": "Sanjuan",
    "First Name": "Juan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43867909: {
    id: "item_9167",
    "Last Name": "MARRA",
    "First Name": "GUILLERMO OMAR",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43869830: {
    id: "item_21824",
    "Last Name": "Whybird",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43871643: {
    id: "item_7370",
    "Last Name": "Villars",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43880160: {
    id: "item_32834",
    "Last Name": "Lu",
    "First Name": "Xiao Ling",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43880251: {
    id: "item_32835",
    "Last Name": "Lam",
    "First Name": "Larissa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43880338: {
    id: "item_32836",
    "Last Name": "Li",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43881511: {
    id: "item_7371",
    "Last Name": "watson",
    "First Name": "bradyn",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43881714: {
    id: "item_21825",
    "Last Name": "Pullan",
    "First Name": "Scott",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43882383: {
    id: "item_20294",
    "Last Name": "Irwin",
    "First Name": "Brendan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43882623: {
    id: "item_7372",
    "Last Name": "Gordon",
    "First Name": "Grant",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43882668: {
    id: "item_21826",
    "Last Name": "Lillis",
    "First Name": "Moe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43882681: {
    id: "item_7373",
    "Last Name": "Xie",
    "First Name": "TIAN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43882907: {
    id: "item_7374",
    "Last Name": "KUBOTA",
    "First Name": "YUJI",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43883500: {
    id: "item_21827",
    "Last Name": "Fofie Jr",
    "First Name": "Charles",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43884293: {
    id: "item_21828",
    "Last Name": "Males",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43884470: {
    id: "item_21829",
    "Last Name": "WU",
    "First Name": "HUAIYONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43886877: {
    id: "item_21830",
    "Last Name": "Whiteley",
    "First Name": "Olly",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43887019: {
    id: "item_21831",
    "Last Name": "ZHANG",
    "First Name": "HUIJUN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43887062: {
    id: "item_7375",
    "Last Name": "zhang",
    "First Name": "qiang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43887458: {
    id: "item_9168",
    "Last Name": "Clark",
    "First Name": "Kimberly Chanelle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43887485: {
    id: "item_9169",
    "Last Name": "Underwood",
    "First Name": "Steven Tyler",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43887839: {
    id: "item_21832",
    "Last Name": "Skinner",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43888267: {
    id: "item_9170",
    "Last Name": "Doecke",
    "First Name": "Jenna",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43888478: {
    id: "item_32837",
    "Last Name": "Chokalingam",
    "First Name": "Lushan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43889048: {
    id: "item_7376",
    "Last Name": "Kruczynski",
    "First Name": "Wojciech",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43889739: {
    id: "item_21833",
    "Last Name": "Santos",
    "First Name": "Angel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43890241: {
    id: "item_34539",
    "Last Name": "LI",
    "First Name": "XIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43890526: {
    id: "item_34540",
    "Last Name": "Bund",
    "First Name": "Jody",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43893632: {
    id: "item_7377",
    "Last Name": "Yip",
    "First Name": "Shing Yan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43895668: {
    id: "item_32838",
    "Last Name": "McMillan",
    "First Name": "Gregory",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43898504: {
    id: "item_34541",
    "Last Name": "Anderson",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43898573: {
    id: "item_21834",
    "Last Name": "AHUJA",
    "First Name": "ARACELI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43898665: {
    id: "item_21835",
    "Last Name": "AHUJA",
    "First Name": "RICARDO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43898979: {
    id: "item_21836",
    "Last Name": "SANDOVAL",
    "First Name": "MA DE LOURDES",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43899379: {
    id: "item_32839",
    "Last Name": "BARTELME",
    "First Name": "DELMA TORRES",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43899593: {
    id: "item_9171",
    "Last Name": "KUZMA",
    "First Name": "MATEUSZ",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43901029: {
    id: "item_7378",
    "Last Name": "Mai",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43901641: {
    id: "item_21837",
    "Last Name": "HINOJOSA",
    "First Name": "SALVADOR",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43902206: {
    id: "item_21838",
    "Last Name": "Howell",
    "First Name": "Wayne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43902477: {
    id: "item_21839",
    "Last Name": "McDowell",
    "First Name": "Graham",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43902777: {
    id: "item_21840",
    "Last Name": "NOH",
    "First Name": "JAI HO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43902930: {
    id: "item_32840",
    "Last Name": "Salter",
    "First Name": "Katie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43904225: {
    id: "item_21841",
    "Last Name": "Elerick",
    "First Name": "Riley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43904468: {
    id: "item_7379",
    "Last Name": "Pulling",
    "First Name": "Denise",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43904896: {
    id: "item_21842",
    "Last Name": "Jackson",
    "First Name": "Josh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43905858: {
    id: "item_21843",
    "Last Name": "LAU",
    "First Name": "HIU POK",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43906511: {
    id: "item_21844",
    "Last Name": "Chau",
    "First Name": "Henson",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43906636: {
    id: "item_34542",
    "Last Name": "Black",
    "First Name": "Amy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43906643: {
    id: "item_32841",
    "Last Name": "Hardi",
    "First Name": "Maulana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43906677: {
    id: "item_34543",
    "Last Name": "Angelina",
    "First Name": "Christina",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43908145: {
    id: "item_34544",
    "Last Name": "Ferguson",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43908594: {
    id: "item_7380",
    "Last Name": "Sokolov",
    "First Name": "Nikolay",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43909036: {
    id: "item_32842",
    "Last Name": "Kohli",
    "First Name": "Bhawana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43909052: {
    id: "item_21845",
    "Last Name": "Sehta",
    "First Name": "Sandeep",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43909794: {
    id: "item_21846",
    "Last Name": "Satria",
    "First Name": "Eka",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43911611: {
    id: "item_34545",
    "Last Name": "Mcilvenna",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43915095: {
    id: "item_21847",
    "Last Name": "Satria",
    "First Name": "Andika Aufar",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43915284: {
    id: "item_21848",
    "Last Name": "Bodenstein",
    "First Name": "Ulf",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43915475: {
    id: "item_32843",
    "Last Name": "GARCES",
    "First Name": "MARIA",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43915725: {
    id: "item_34546",
    "Last Name": "Norton",
    "First Name": "Hannah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43915899: {
    id: "item_21849",
    "Last Name": "PASILLAS",
    "First Name": "MARIA FERNANDA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43917408: {
    id: "item_34547",
    "Last Name": "Bullock",
    "First Name": "Bryan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43918754: {
    id: "item_32844",
    "Last Name": "Martinez",
    "First Name": "Vanessa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43921313: {
    id: "item_21850",
    "Last Name": "Byrne",
    "First Name": "Tess",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43921420: {
    id: "item_21851",
    "Last Name": "Caliman",
    "First Name": "Adrian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43923501: {
    id: "item_34548",
    "Last Name": "Menor",
    "First Name": "Salvador",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43924398: {
    id: "item_21852",
    "Last Name": "Murray",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43924670: {
    id: "item_34549",
    "Last Name": "Lam",
    "First Name": "Huy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43925569: {
    id: "item_7381",
    "Last Name": "LIU",
    "First Name": "SEN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43926079: {
    id: "item_9172",
    "Last Name": "Davis",
    "First Name": "Kimberley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43926247: {
    id: "item_21853",
    "Last Name": "YANG",
    "First Name": "MEIHUA",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43927140: {
    id: "item_21854",
    "Last Name": "ZHANG",
    "First Name": "LONG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43927337: {
    id: "item_7382",
    "Last Name": "ZHANG",
    "First Name": "GUOFENG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43927712: {
    id: "item_34550",
    "Last Name": "ASHIMURA",
    "First Name": "TOMOHIDE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43927718: {
    id: "item_7383",
    "Last Name": "ROMAN",
    "First Name": "IVO",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43927912: {
    id: "item_7384",
    "Last Name": "De Reu",
    "First Name": "Marc",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43928124: {
    id: "item_21855",
    "Last Name": "Gittany",
    "First Name": "Max",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43928458: {
    id: "item_34551",
    "Last Name": "Obernauer",
    "First Name": "Maria Jana",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43928737: {
    id: "item_21856",
    "Last Name": "McDonald",
    "First Name": "Mary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43928846: {
    id: "item_21857",
    "Last Name": "Xiu",
    "First Name": "Yue",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43929448: {
    id: "item_21858",
    "Last Name": "Adams",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43929742: {
    id: "item_32845",
    "Last Name": "Adams",
    "First Name": "Cian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43930771: {
    id: "item_32846",
    "Last Name": "Gaekel",
    "First Name": "Kay",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43932414: {
    id: "item_7385",
    "Last Name": "Bane",
    "First Name": "Ginger",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43934301: {
    id: "item_21859",
    "Last Name": "Peanpanit",
    "First Name": "Parinda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43935232: {
    id: "item_32847",
    "Last Name": "Patel",
    "First Name": "Gopalkrushna (Alias Gopal",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43936035: {
    id: "item_32848",
    "Last Name": "Lowery",
    "First Name": "Steve",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43936630: {
    id: "item_32849",
    "Last Name": "Dassonville",
    "First Name": "Leigh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43938321: {
    id: "item_32850",
    "Last Name": "Íispuu",
    "First Name": "Merike",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43938369: {
    id: "item_32851",
    "Last Name": "Khurmi",
    "First Name": "Jasvinder",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43938979: {
    id: "item_34552",
    "Last Name": "Elumelu",
    "First Name": "Awele",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43939975: {
    id: "item_34553",
    "Last Name": "Troncoso",
    "First Name": "Gonzalo Enrique",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43943644: {
    id: "item_34554",
    "Last Name": "HUNG",
    "First Name": "WEIPIN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43944024: {
    id: "item_7386",
    "Last Name": "Snow",
    "First Name": "Carla",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43944134: {
    id: "item_7387",
    "Last Name": "Yan",
    "First Name": "Bei",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43944626: {
    id: "item_32852",
    "Last Name": "LIANG",
    "First Name": "BING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43944746: {
    id: "item_32853",
    "Last Name": "Ramirez",
    "First Name": "Rosybel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43945685: {
    id: "item_21860",
    "Last Name": "Gillanders",
    "First Name": "Toby",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43946169: {
    id: "item_21861",
    "Last Name": "Llaver",
    "First Name": "Oscar Gustavo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43946451: {
    id: "item_21862",
    "Last Name": "Torres Rodrigues",
    "First Name": "Marcella",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43946495: {
    id: "item_21863",
    "Last Name": "TORRES MORERA",
    "First Name": "MARIA ANGELES",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43946526: {
    id: "item_34555",
    "Last Name": "Ferrier",
    "First Name": "Tim",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43946666: {
    id: "item_34556",
    "Last Name": "Ramotowska",
    "First Name": "Kamila",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43946698: {
    id: "item_34557",
    "Last Name": "WANG",
    "First Name": "BOYAN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43947191: {
    id: "item_21864",
    "Last Name": "Bartlett",
    "First Name": "Dean",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43947543: {
    id: "item_34558",
    "Last Name": "Sath",
    "First Name": "Victor",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43947819: {
    id: "item_32854",
    "Last Name": "Suskin",
    "First Name": "Dan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43948112: {
    id: "item_21865",
    "Last Name": "VAUTIER",
    "First Name": "RUDY",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43948164: {
    id: "item_21866",
    "Last Name": "Caillot",
    "First Name": "Florent",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43949446: {
    id: "item_7388",
    "Last Name": "RATAJ",
    "First Name": "ADAM",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43949684: {
    id: "item_21867",
    "Last Name": "Yi",
    "First Name": "Lynette",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43951209: {
    id: "item_34559",
    "Last Name": "Torres Martinez",
    "First Name": "Alex",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43951433: {
    id: "item_7389",
    "Last Name": "Holgado Galan",
    "First Name": "Raquel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43951595: {
    id: "item_32855",
    "Last Name": "Vazquez",
    "First Name": "Ariel Alejandro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43952612: {
    id: "item_34560",
    "Last Name": "Gallego",
    "First Name": "Adela",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43953911: {
    id: "item_34561",
    "Last Name": "Varsa",
    "First Name": "Lailo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43954774: {
    id: "item_7390",
    "Last Name": "SAIZ ZAMORANO",
    "First Name": "LUIS AGUSTIN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43955179: {
    id: "item_21868",
    "Last Name": "Nallamothu",
    "First Name": "Vishnu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43955526: {
    id: "item_7391",
    "Last Name": "Reyes",
    "First Name": "Diego",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43955637: {
    id: "item_34562",
    "Last Name": "Samet",
    "First Name": "Miriam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43956642: {
    id: "item_21869",
    "Last Name": "Traynor",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43959399: {
    id: "item_21870",
    "Last Name": "Jozwik",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43960075: {
    id: "item_7392",
    "Last Name": "Leckie-Harbord",
    "First Name": "Clare",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43960765: {
    id: "item_32856",
    "Last Name": "Forward",
    "First Name": "Paul",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43963524: {
    id: "item_32857",
    "Last Name": "LU",
    "First Name": "MINGLIU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43963656: {
    id: "item_21871",
    "Last Name": "YU",
    "First Name": "SIQI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43965583: {
    id: "item_32858",
    "Last Name": "McHugh",
    "First Name": "Lindsey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43965702: {
    id: "item_7393",
    "Last Name": "Bamford",
    "First Name": "Ian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43965717: {
    id: "item_32859",
    "Last Name": "Lineham",
    "First Name": "Sam",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43966458: {
    id: "item_9173",
    "Last Name": "gilbertson",
    "First Name": "gilbert",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43966533: {
    id: "item_7394",
    "Last Name": "CHEN",
    "First Name": "YINGJIE",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43967315: {
    id: "item_21872",
    "Last Name": "Harper",
    "First Name": "Nadine",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43967387: {
    id: "item_21873",
    "Last Name": "Verbruggen",
    "First Name": "Stefan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43968063: {
    id: "item_32860",
    "Last Name": "ZAJ_C",
    "First Name": "PIOTR",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43968116: {
    id: "item_7395",
    "Last Name": "Nieves",
    "First Name": "Gabriel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43968752: {
    id: "item_34563",
    "Last Name": "Khan",
    "First Name": "Kalsum",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43970546: {
    id: "item_32861",
    "Last Name": "Atiga",
    "First Name": "Memrose",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43970705: {
    id: "item_32862",
    "Last Name": "Atiga",
    "First Name": "Rolando",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43971822: {
    id: "item_21874",
    "Last Name": "Miranda",
    "First Name": "Carmelita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43973239: {
    id: "item_21875",
    "Last Name": "Halsey",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43973873: {
    id: "item_21876",
    "Last Name": "Yeboah",
    "First Name": "Abena",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43974214: {
    id: "item_21877",
    "Last Name": "Depot",
    "First Name": "Erin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43975508: {
    id: "item_7396",
    "Last Name": "Lukas",
    "First Name": "Jessica",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43975961: {
    id: "item_7397",
    "Last Name": "Loaiza Montero",
    "First Name": "Carlos Alberto",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43977964: {
    id: "item_34564",
    "Last Name": "Dumaluan",
    "First Name": "Theodore",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43980985: {
    id: "item_21878",
    "Last Name": "FONT-RIVERA",
    "First Name": "YOANYD",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43981204: {
    id: "item_21879",
    "Last Name": "GONZALEZ-RIVERA",
    "First Name": "MIGUEL",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43984294: {
    id: "item_21880",
    "Last Name": "Barnhart",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43985249: {
    id: "item_34565",
    "Last Name": "cai",
    "First Name": "ouxiang",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43988840: {
    id: "item_21881",
    "Last Name": "Owen",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  43991293: {
    id: "item_32863",
    "Last Name": "Chen",
    "First Name": "Tan Jacky",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44002752: {
    id: "item_21882",
    "Last Name": "Dahiya",
    "First Name": "Abhi",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44003524: {
    id: "item_21883",
    "Last Name": "Phelan",
    "First Name": "Troy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44015730: {
    id: "item_34566",
    "Last Name": "Stewart",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44017687: {
    id: "item_7398",
    "Last Name": "Stone",
    "First Name": "Claire",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44018873: {
    id: "item_21884",
    "Last Name": "LIU",
    "First Name": "XUEHUI",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44020387: {
    id: "item_7399",
    "Last Name": "Ly",
    "First Name": "Justin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44020593: {
    id: "item_21885",
    "Last Name": "Guerra",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44020687: {
    id: "item_32864",
    "Last Name": "Ward",
    "First Name": "Roger",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44022734: {
    id: "item_21886",
    "Last Name": "Hidayah",
    "First Name": "Mardiyati Nurul",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44023626: {
    id: "item_7400",
    "Last Name": "Atkinson",
    "First Name": "Nikhil",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44023720: {
    id: "item_21887",
    "Last Name": "Blixt",
    "First Name": "Evie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44024360: {
    id: "item_21888",
    "Last Name": "Dixon",
    "First Name": "Joe",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44025177: {
    id: "item_21889",
    "Last Name": "Alvim",
    "First Name": "Carolina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44025272: {
    id: "item_34567",
    "Last Name": "Thomas",
    "First Name": "Carey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44026196: {
    id: "item_7401",
    "Last Name": "Corbett",
    "First Name": "Peter",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44026423: {
    id: "item_34568",
    "Last Name": "Edwards",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44026789: {
    id: "item_34569",
    "Last Name": "Serrano",
    "First Name": "Milagros",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44028639: {
    id: "item_34570",
    "Last Name": "Briones",
    "First Name": "Dante",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44031040: {
    id: "item_21890",
    "Last Name": "Miller",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44031643: {
    id: "item_21891",
    "Last Name": "Amormino",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44032008: {
    id: "item_7402",
    "Last Name": "Konstantopoulos",
    "First Name": "Yianni",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44032105: {
    id: "item_32865",
    "Last Name": "Flores",
    "First Name": "Joanna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44032232: {
    id: "item_32866",
    "Last Name": "Flores",
    "First Name": "Emilio Tagalog",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44033043: {
    id: "item_32867",
    "Last Name": "Sundaram",
    "First Name": "Shan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44034768: {
    id: "item_7403",
    "Last Name": "TATARCZAK",
    "First Name": "NORBERT",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44034877: {
    id: "item_21892",
    "Last Name": "Tatarczak",
    "First Name": "Bartosz",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44035992: {
    id: "item_9174",
    "Last Name": "Almajed",
    "First Name": "Anwar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44039709: {
    id: "item_7404",
    "Last Name": "Egorova",
    "First Name": "Olga",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44040443: {
    id: "item_34571",
    "Last Name": "Dela Cruz",
    "First Name": "Elmer",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44042222: {
    id: "item_32868",
    "Last Name": "Jones",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44042431: {
    id: "item_34572",
    "Last Name": "Yang",
    "First Name": "Hungjen",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44043131: {
    id: "item_7405",
    "Last Name": "Taylor",
    "First Name": "Scott",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44043782: {
    id: "item_21893",
    "Last Name": "Mistry",
    "First Name": "Chetan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44043878: {
    id: "item_32869",
    "Last Name": "Sachdev",
    "First Name": "Veerachai",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44043942: {
    id: "item_7406",
    "Last Name": "Chang",
    "First Name": "Caroline",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44044770: {
    id: "item_21894",
    "Last Name": "Chapman",
    "First Name": "Kieley",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44045183: {
    id: "item_9175",
    "Last Name": "CHU",
    "First Name": "HWANJONG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44045680: {
    id: "item_9176",
    "Last Name": "Choi",
    "First Name": "Seunguk",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44047181: {
    id: "item_7407",
    "Last Name": "Ge",
    "First Name": "Junrong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44050221: {
    id: "item_32870",
    "Last Name": "Brown",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44050844: {
    id: "item_21895",
    "Last Name": "Parsons",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44051071: {
    id: "item_34573",
    "Last Name": "chavarria",
    "First Name": "uriel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44051541: {
    id: "item_34574",
    "Last Name": "Hoang",
    "First Name": "Vy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44051927: {
    id: "item_21896",
    "Last Name": "Kumar",
    "First Name": "Kevin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44052252: {
    id: "item_32871",
    "Last Name": "HSHIEH",
    "First Name": "HUI JYE",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44052520: {
    id: "item_34575",
    "Last Name": "Badenhorst",
    "First Name": "Philna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44052590: {
    id: "item_21897",
    "Last Name": "Free",
    "First Name": "Heather",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44053021: {
    id: "item_21898",
    "Last Name": "Rafter",
    "First Name": "Niamh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44053610: {
    id: "item_21899",
    "Last Name": "Aenugu",
    "First Name": "Jaipal Reddy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44054363: {
    id: "item_21900",
    "Last Name": "Setiadi",
    "First Name": "Adrian Teguh",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44055544: {
    id: "item_32872",
    "Last Name": "Anderson",
    "First Name": "Leah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44056106: {
    id: "item_32873",
    "Last Name": "Fucci",
    "First Name": "Rosa",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44056376: {
    id: "item_21901",
    "Last Name": "Guarina",
    "First Name": "Rebs",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44056743: {
    id: "item_9177",
    "Last Name": "Unitt",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44058791: {
    id: "item_32874",
    "Last Name": "Byers",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44063281: {
    id: "item_9178",
    "Last Name": "Mcshane",
    "First Name": "Dessie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44067138: {
    id: "item_7408",
    "Last Name": "Navin",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44069144: {
    id: "item_32875",
    "Last Name": "Figueroa",
    "First Name": "Olga",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44072726: {
    id: "item_7409",
    "Last Name": "Pedras",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44075202: {
    id: "item_32876",
    "Last Name": "Chu",
    "First Name": "Kwai Wan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44075621: {
    id: "item_21902",
    "Last Name": "Florence-Rieniets",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44076411: {
    id: "item_21903",
    "Last Name": "Agarwal",
    "First Name": "vineet",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44076979: {
    id: "item_21904",
    "Last Name": "Esposito",
    "First Name": "Amber",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44077021: {
    id: "item_9179",
    "Last Name": "Belfiore",
    "First Name": "Antonio Luciano",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44077092: {
    id: "item_9180",
    "Last Name": "Ippolito",
    "First Name": "Brigitte",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44078458: {
    id: "item_21905",
    "Last Name": "Cofield",
    "First Name": "Tonita",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44085304: {
    id: "item_34576",
    "Last Name": "Lewis",
    "First Name": "Chrylann",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44086826: {
    id: "item_34577",
    "Last Name": "Kreps",
    "First Name": "Sandy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44087194: {
    id: "item_21906",
    "Last Name": "Pfeffer",
    "First Name": "Maria Ignacia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44087420: {
    id: "item_7410",
    "Last Name": "RILEY",
    "First Name": "STEVEN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44090286: {
    id: "item_21907",
    "Last Name": "Gnan",
    "First Name": "Eugene",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44090909: {
    id: "item_34578",
    "Last Name": "Cormican",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44094331: {
    id: "item_21908",
    "Last Name": "Flores",
    "First Name": "Brian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44094603: {
    id: "item_32877",
    "Last Name": "Salvaggio",
    "First Name": "Leon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44097106: {
    id: "item_7411",
    "Last Name": "Pine",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44097376: {
    id: "item_21909",
    "Last Name": "Liemiyah",
    "First Name": "Rikha",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44097578: {
    id: "item_7412",
    "Last Name": "Ybarra",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44097611: {
    id: "item_21910",
    "Last Name": "Naidu",
    "First Name": "Selvaraj",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44097696: {
    id: "item_21911",
    "Last Name": "LI",
    "First Name": "Carol",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44099670: {
    id: "item_21912",
    "Last Name": "Fairs",
    "First Name": "Emily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44100426: {
    id: "item_9181",
    "Last Name": "Argyrou",
    "First Name": "Adonis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44100498: {
    id: "item_9182",
    "Last Name": "Christodoulou",
    "First Name": "Omiros",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44101661: {
    id: "item_21913",
    "Last Name": "Navarrete",
    "First Name": "Mason",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44103355: {
    id: "item_34579",
    "Last Name": "Lee",
    "First Name": "Jorge",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44106276: {
    id: "item_7413",
    "Last Name": "Hermann",
    "First Name": "Maik",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44107586: {
    id: "item_7414",
    "Last Name": "Elliott",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44114287: {
    id: "item_32878",
    "Last Name": "Howell",
    "First Name": "Rhian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44114419: {
    id: "item_32879",
    "Last Name": "Verzosa",
    "First Name": "Samuel Jr",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44115175: {
    id: "item_34580",
    "Last Name": "Castro",
    "First Name": "Salvador Antonio",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44115837: {
    id: "item_7415",
    "Last Name": "Rae",
    "First Name": "Stuart",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44115927: {
    id: "item_21914",
    "Last Name": "Huelgas",
    "First Name": "Nikko Bryan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44116377: {
    id: "item_21915",
    "Last Name": "GARCIA LOPEZ7",
    "First Name": "ELIZABETH",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44118659: {
    id: "item_21916",
    "Last Name": "Brouns",
    "First Name": "Jens",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44120999: {
    id: "item_21917",
    "Last Name": "Lucero",
    "First Name": "Silvia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44121111: {
    id: "item_32880",
    "Last Name": "Mercado",
    "First Name": "Carlos",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44122419: {
    id: "item_34581",
    "Last Name": "Boorse",
    "First Name": "Kristin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44122554: {
    id: "item_32881",
    "Last Name": "Eastwood",
    "First Name": "Jemima",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44123826: {
    id: "item_34582",
    "Last Name": "Totterdell",
    "First Name": "Judy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44125739: {
    id: "item_21918",
    "Last Name": "Comafay",
    "First Name": "Kniles",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44126372: {
    id: "item_21919",
    "Last Name": "SAMBOGO",
    "First Name": "RACHMAN DITTO",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44129774: {
    id: "item_9183",
    "Last Name": "Holt",
    "First Name": "Marcy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44133463: {
    id: "item_9184",
    "Last Name": "ODonnell",
    "First Name": "Amy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44136233: {
    id: "item_7416",
    "Last Name": "Scott",
    "First Name": "Luke",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44138300: {
    id: "item_21920",
    "Last Name": "Azc‡rate",
    "First Name": "Ariel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44143954: {
    id: "item_21921",
    "Last Name": "Bowler",
    "First Name": "Brendon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44144265: {
    id: "item_34583",
    "Last Name": "Low",
    "First Name": "Ruby",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44156646: {
    id: "item_21922",
    "Last Name": "Hasegawa",
    "First Name": "Lindsay",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44171741: {
    id: "item_21923",
    "Last Name": "Cochrane",
    "First Name": "Laura",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44183514: {
    id: "item_21924",
    "Last Name": "Hoffman",
    "First Name": "Tiffany",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44183523: {
    id: "item_7417",
    "Last Name": "Menendez",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44194742: {
    id: "item_7418",
    "Last Name": "Hussain",
    "First Name": "Thanbir",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44205301: {
    id: "item_21925",
    "Last Name": "Marino",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44210756: {
    id: "item_34584",
    "Last Name": "LIU",
    "First Name": "BOMING",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44212852: {
    id: "item_32882",
    "Last Name": "Felix",
    "First Name": "Alexander II",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44214347: {
    id: "item_21926",
    "Last Name": "Tucker",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44214964: {
    id: "item_7419",
    "Last Name": "Tops",
    "First Name": "Jolie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44215808: {
    id: "item_21927",
    "Last Name": "O'Malley",
    "First Name": "Matt",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44217018: {
    id: "item_21928",
    "Last Name": "Meeks",
    "First Name": "Erika",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44218830: {
    id: "item_34585",
    "Last Name": "Polotan",
    "First Name": "Jourdan Andrew",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44218876: {
    id: "item_32883",
    "Last Name": "Stinton",
    "First Name": "Joseph",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44220016: {
    id: "item_21929",
    "Last Name": "Scholz",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44221544: {
    id: "item_32884",
    "Last Name": "Brandon",
    "First Name": "Deanne",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44223496: {
    id: "item_21930",
    "Last Name": "Lazarowich",
    "First Name": "Richard",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44272419: {
    id: "item_32885",
    "Last Name": "Esquibel",
    "First Name": "Pearl",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44276184: {
    id: "item_34586",
    "Last Name": "Backus",
    "First Name": "Leslie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44276782: {
    id: "item_7420",
    "Last Name": "van Wijnen",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44277114: {
    id: "item_20295",
    "Last Name": "Bartolo",
    "First Name": "Ed",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44277174: {
    id: "item_21931",
    "Last Name": "Liew",
    "First Name": "Yi Xing",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44277824: {
    id: "item_21932",
    "Last Name": "Arroyo Jimenez",
    "First Name": "Jose",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44279006: {
    id: "item_34587",
    "Last Name": "Oktanira",
    "First Name": "Fera",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44279098: {
    id: "item_32886",
    "Last Name": "Pascua",
    "First Name": "Marian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44279630: {
    id: "item_21933",
    "Last Name": "Phillips",
    "First Name": "Emma",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44279747: {
    id: "item_34588",
    "Last Name": "jung",
    "First Name": "DONGYOON",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44279765: {
    id: "item_9185",
    "Last Name": "SIWU",
    "First Name": "DANNY",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44280463: {
    id: "item_34589",
    "Last Name": "Parameswaran",
    "First Name": "Shathusan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44281843: {
    id: "item_21934",
    "Last Name": "Douch",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44282748: {
    id: "item_34590",
    "Last Name": "Chan",
    "First Name": "Tak Kwong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44292670: {
    id: "item_21935",
    "Last Name": "Steenstra",
    "First Name": "Sydnie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44313310: {
    id: "item_32887",
    "Last Name": "Eimbrodt",
    "First Name": "Jason",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44318817: {
    id: "item_34591",
    "Last Name": "Brightwell",
    "First Name": "Frank",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44341078: {
    id: "item_7421",
    "Last Name": "Dimond",
    "First Name": "Martin",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44343685: {
    id: "item_21936",
    "Last Name": "Elms",
    "First Name": "James",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44345723: {
    id: "item_32888",
    "Last Name": "Masahashi",
    "First Name": "Rintaro",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44345849: {
    id: "item_34592",
    "Last Name": "Marcos-Eligio",
    "First Name": "Estrellita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44345899: {
    id: "item_32889",
    "Last Name": "MASUMOTO",
    "First Name": "YOKO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44345929: {
    id: "item_34593",
    "Last Name": "Widjiasto",
    "First Name": "Condrodjoko",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44346664: {
    id: "item_7422",
    "Last Name": "KIM",
    "First Name": "SA UN",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44346738: {
    id: "item_32890",
    "Last Name": "Kim",
    "First Name": "Jae Ung",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44347046: {
    id: "item_32891",
    "Last Name": "Blore",
    "First Name": "Michael",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44347246: {
    id: "item_21937",
    "Last Name": "Nunez",
    "First Name": "Danny",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44347363: {
    id: "item_7423",
    "Last Name": "Marchon",
    "First Name": "Charles",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44348829: {
    id: "item_21938",
    "Last Name": "Millward",
    "First Name": "Alanna",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44394802: {
    id: "item_34594",
    "Last Name": "Parsons",
    "First Name": "Sierra",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44397073: {
    id: "item_32892",
    "Last Name": "Murphy",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44398854: {
    id: "item_21939",
    "Last Name": "Cash",
    "First Name": "Jacklyn",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44399138: {
    id: "item_7424",
    "Last Name": "tak",
    "First Name": "seongyeong",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44401046: {
    id: "item_9186",
    "Last Name": "Ellis",
    "First Name": "Leonard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44406837: {
    id: "item_34595",
    "Last Name": "Cho",
    "First Name": "Jaeki",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44411438: {
    id: "item_21940",
    "Last Name": "KANG",
    "First Name": "MINJUNG",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44415031: {
    id: "item_34596",
    "Last Name": "Walji",
    "First Name": "Ali",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44421454: {
    id: "item_34597",
    "Last Name": "Mason",
    "First Name": "Mckensey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44431587: {
    id: "item_7425",
    "Last Name": "Johnston",
    "First Name": "Brydee",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44431607: {
    id: "item_32893",
    "Last Name": "Knight",
    "First Name": "Jamie",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44431689: {
    id: "item_7426",
    "Last Name": "Hamilton",
    "First Name": "David",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44431755: {
    id: "item_32894",
    "Last Name": "Chand",
    "First Name": "Avakash",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44432225: {
    id: "item_7427",
    "Last Name": "Henderson",
    "First Name": "Tabitha",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44432262: {
    id: "item_7428",
    "Last Name": "Robinson",
    "First Name": "Mitchell",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44433910: {
    id: "item_21941",
    "Last Name": "Waterhouse",
    "First Name": "Jess",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44434811: {
    id: "item_7429",
    "Last Name": "Gregory",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44435242: {
    id: "item_7430",
    "Last Name": "Martin",
    "First Name": "Jay",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44436452: {
    id: "item_21942",
    "Last Name": "Dobson",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44437281: {
    id: "item_34598",
    "Last Name": "Yong",
    "First Name": "Kelly Tau Len",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44437350: {
    id: "item_32895",
    "Last Name": "Pannell",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44437666: {
    id: "item_32896",
    "Last Name": "Meuchner",
    "First Name": "Meghan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44437951: {
    id: "item_21943",
    "Last Name": "Drewery",
    "First Name": "Kiara",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44441325: {
    id: "item_34599",
    "Last Name": "Esmeralda",
    "First Name": "Emira",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44442505: {
    id: "item_34600",
    "Last Name": "Rappa",
    "First Name": "Frank",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44442961: {
    id: "item_7431",
    "Last Name": "Sinema",
    "First Name": "Kyrsten",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44443046: {
    id: "item_32897",
    "Last Name": "Korenfeld Federman",
    "First Name": "David",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44443771: {
    id: "item_32898",
    "Last Name": "Fedorova",
    "First Name": "Inna",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44443963: {
    id: "item_34601",
    "Last Name": "Jackson",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44449154: {
    id: "item_21944",
    "Last Name": "Howley",
    "First Name": "Jonah",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44453457: {
    id: "item_7432",
    "Last Name": "Ahearn",
    "First Name": "Enja",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44455402: {
    id: "item_21945",
    "Last Name": "Dubrich",
    "First Name": "Adam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44457719: {
    id: "item_7433",
    "Last Name": "Dolbel",
    "First Name": "Bradley",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44458806: {
    id: "item_34602",
    "Last Name": "CHUA",
    "First Name": "BAYANI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44459066: {
    id: "item_34603",
    "Last Name": "ZULETA",
    "First Name": "RAYNOR",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44459143: {
    id: "item_21946",
    "Last Name": "Rodriguez",
    "First Name": "Gericah May",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44459375: {
    id: "item_21947",
    "Last Name": "Ong",
    "First Name": "Chloe Jane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44460158: {
    id: "item_32899",
    "Last Name": "Noviyanto",
    "First Name": "Nugroho",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44460180: {
    id: "item_21948",
    "Last Name": "Bunyamin",
    "First Name": "Cisyelya",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44460562: {
    id: "item_32900",
    "Last Name": "Faranial",
    "First Name": "Jeffrey",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44461843: {
    id: "item_21949",
    "Last Name": "Raspevin",
    "First Name": "Konstantin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44463723: {
    id: "item_21950",
    "Last Name": "Spensley",
    "First Name": "Ellie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44471234: {
    id: "item_21951",
    "Last Name": "Sakhiyev",
    "First Name": "Zhandos",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44472844: {
    id: "item_21952",
    "Last Name": "Galindo Rodriguez",
    "First Name": "Ignacio",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44472862: {
    id: "item_21953",
    "Last Name": "Lonergan",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44474514: {
    id: "item_32901",
    "Last Name": "Gachango",
    "First Name": "Esther",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44476736: {
    id: "item_21954",
    "Last Name": "Alexandra",
    "First Name": "Corinne",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44480864: {
    id: "item_21955",
    "Last Name": "Curtis",
    "First Name": "Annabelle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44481025: {
    id: "item_20296",
    "Last Name": "Reid",
    "First Name": "Andrew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute F",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44483953: {
    id: "item_7434",
    "Last Name": "Curtis",
    "First Name": "Dilan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44484271: {
    id: "item_7435",
    "Last Name": "McDowell",
    "First Name": "Jacob",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44485837: {
    id: "item_21956",
    "Last Name": "Jaravata",
    "First Name": "Deo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44486327: {
    id: "item_21957",
    "Last Name": "Coburn",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44486649: {
    id: "item_21958",
    "Last Name": "O'Grady",
    "First Name": "Shane",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44486764: {
    id: "item_21959",
    "Last Name": "Klemke",
    "First Name": "Joel",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44487292: {
    id: "item_21960",
    "Last Name": "Wright",
    "First Name": "Jordan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44487929: {
    id: "item_21961",
    "Last Name": "Pye",
    "First Name": "Michael",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44493750: {
    id: "item_21962",
    "Last Name": "Silva",
    "First Name": "Jacqueline",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44493805: {
    id: "item_9187",
    "Last Name": "Turgumbayev",
    "First Name": "Samat",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44494986: {
    id: "item_32902",
    "Last Name": "DiGirolomo",
    "First Name": "Marco",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44495175: {
    id: "item_7436",
    "Last Name": "Sato",
    "First Name": "Masaru",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44495614: {
    id: "item_21963",
    "Last Name": "Hernandez",
    "First Name": "Christian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44500408: {
    id: "item_32903",
    "Last Name": "Vaivode",
    "First Name": "Kristine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44503688: {
    id: "item_9188",
    "Last Name": "Bi",
    "First Name": "Xiang",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44504103: {
    id: "item_34604",
    "Last Name": "Ferdiansyah",
    "First Name": "Irfan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44504270: {
    id: "item_7437",
    "Last Name": "Prasatya",
    "First Name": "Dedy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44506672: {
    id: "item_7438",
    "Last Name": "Watson",
    "First Name": "Shelby",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44509675: {
    id: "item_7439",
    "Last Name": "Boudakin",
    "First Name": "Ella",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44510106: {
    id: "item_32904",
    "Last Name": "Rojas Urzua",
    "First Name": "Javiera",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44511491: {
    id: "item_34605",
    "Last Name": "Pangeni",
    "First Name": "Yogesh",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44511606: {
    id: "item_32905",
    "Last Name": "yatco",
    "First Name": "hayward",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44512503: {
    id: "item_7440",
    "Last Name": "van Ruiten",
    "First Name": "Johannes",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44513140: {
    id: "item_21964",
    "Last Name": "Patel",
    "First Name": "Vidur",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44514415: {
    id: "item_7441",
    "Last Name": "Soto",
    "First Name": "Eddie",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44514586: {
    id: "item_34606",
    "Last Name": "Romero",
    "First Name": "Leticia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44517110: {
    id: "item_21965",
    "Last Name": "Apanco",
    "First Name": "Theo",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44518477: {
    id: "item_21966",
    "Last Name": "Tan",
    "First Name": "Jarin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44518793: {
    id: "item_21967",
    "Last Name": "Parisi",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44519241: {
    id: "item_34607",
    "Last Name": "Braden Koulaouzos",
    "First Name": "Margaret",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44526193: {
    id: "item_34608",
    "Last Name": "LeValley",
    "First Name": "Joshua",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44527522: {
    id: "item_34609",
    "Last Name": "Wells",
    "First Name": "Roger",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44537625: {
    id: "item_9189",
    "Last Name": "Gaff",
    "First Name": "Richard",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44541425: {
    id: "item_34610",
    "Last Name": "Riordan",
    "First Name": "Kimberly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44543830: {
    id: "item_21968",
    "Last Name": "Most",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44544983: {
    id: "item_34611",
    "Last Name": "Brinkman",
    "First Name": "Mary Jo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44549450: {
    id: "item_21969",
    "Last Name": "Mc Donnell",
    "First Name": "Conor",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44552496: {
    id: "item_32906",
    "Last Name": "Wright",
    "First Name": "Kemi",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44565298: {
    id: "item_7442",
    "Last Name": "Vollmer",
    "First Name": "Dennis",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44575215: {
    id: "item_7443",
    "Last Name": "Begley",
    "First Name": "George",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44575438: {
    id: "item_21970",
    "Last Name": "Barbara",
    "First Name": "Anthony",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44579010: {
    id: "item_32907",
    "Last Name": "RŸb",
    "First Name": "Joel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44580557: {
    id: "item_21971",
    "Last Name": "Munro",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44581445: {
    id: "item_21972",
    "Last Name": "Gonzalez",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44582840: {
    id: "item_21973",
    "Last Name": "Ryan",
    "First Name": "Peter",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44616332: {
    id: "item_32908",
    "Last Name": "Gladsburner",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44618793: {
    id: "item_34612",
    "Last Name": "Kristofic",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44619491: {
    id: "item_34613",
    "Last Name": "mahoney",
    "First Name": "kyle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44619601: {
    id: "item_7444",
    "Last Name": "Winkler",
    "First Name": "Daniel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44622144: {
    id: "item_7445",
    "Last Name": "Simet",
    "First Name": "Dorian",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44623010: {
    id: "item_32909",
    "Last Name": "De Conti",
    "First Name": "Domenico",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44623704: {
    id: "item_32910",
    "Last Name": "Deol",
    "First Name": "Bhavjot",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44624556: {
    id: "item_7446",
    "Last Name": "Wright",
    "First Name": "Matt",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44629751: {
    id: "item_9190",
    "Last Name": "Larson",
    "First Name": "Nicole",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44640813: {
    id: "item_7447",
    "Last Name": "Bruce",
    "First Name": "Edward",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44642898: {
    id: "item_7448",
    "Last Name": "Mirizio",
    "First Name": "Joe",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44645441: {
    id: "item_34614",
    "Last Name": "Friedmann",
    "First Name": "Eleanor",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44648477: {
    id: "item_21974",
    "Last Name": "Peters",
    "First Name": "Ben",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44649779: {
    id: "item_21975",
    "Last Name": "Thomas",
    "First Name": "George",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44651088: {
    id: "item_32911",
    "Last Name": "Mancini",
    "First Name": "Luciano",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44651173: {
    id: "item_7449",
    "Last Name": "Luya",
    "First Name": "Jerald",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44651424: {
    id: "item_21976",
    "Last Name": "Costley",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44652969: {
    id: "item_21977",
    "Last Name": "SHIH",
    "First Name": "PO AN",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44653928: {
    id: "item_21978",
    "Last Name": "Lin",
    "First Name": "Crystal",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44654227: {
    id: "item_32912",
    "Last Name": "Kim",
    "First Name": "John Jin Han",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44654288: {
    id: "item_32913",
    "Last Name": "Langsworth",
    "First Name": "Mark",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44654300: {
    id: "item_32914",
    "Last Name": "Langsworth",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44655330: {
    id: "item_34615",
    "Last Name": "BAE",
    "First Name": "HUIJEONG",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44655382: {
    id: "item_7450",
    "Last Name": "ji",
    "First Name": "hyeonki",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44655434: {
    id: "item_32915",
    "Last Name": "Yang",
    "First Name": "Yuseong",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44655447: {
    id: "item_7451",
    "Last Name": "SONG",
    "First Name": "MOO KYOUNG",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44656938: {
    id: "item_34616",
    "Last Name": "Kume-Davy",
    "First Name": "Jonathan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44657070: {
    id: "item_34617",
    "Last Name": "Spencer",
    "First Name": "Kelly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44685856: {
    id: "item_32916",
    "Last Name": "O'Rourke",
    "First Name": "Fallon",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44689435: {
    id: "item_21979",
    "Last Name": "Zammit",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44690749: {
    id: "item_21980",
    "Last Name": "Tanti",
    "First Name": "Goutam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44691881: {
    id: "item_32917",
    "Last Name": "Rattanachatukorn",
    "First Name": "Vincent",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44691993: {
    id: "item_32918",
    "Last Name": "Sinn",
    "First Name": "Sindy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44739679: {
    id: "item_7452",
    "Last Name": "Fortune",
    "First Name": "Grant",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44799054: {
    id: "item_34618",
    "Last Name": "Czernek",
    "First Name": "Hayley",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44799642: {
    id: "item_7453",
    "Last Name": "Jimenez",
    "First Name": "Jeziel",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44802293: {
    id: "item_32919",
    "Last Name": "Lizardo",
    "First Name": "Dimas",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44803403: {
    id: "item_32920",
    "Last Name": "Mahony",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44807017: {
    id: "item_7454",
    "Last Name": "Gilkes",
    "First Name": "Nicola",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44807483: {
    id: "item_7455",
    "Last Name": "Smith",
    "First Name": "Alexander",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44807788: {
    id: "item_9191",
    "Last Name": "Constantinou",
    "First Name": "Athena",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44807854: {
    id: "item_32921",
    "Last Name": "Williams",
    "First Name": "Callum",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44808063: {
    id: "item_21981",
    "Last Name": "Ramsay",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44808631: {
    id: "item_32922",
    "Last Name": "Lee",
    "First Name": "Byunghee",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44808906: {
    id: "item_32923",
    "Last Name": "SEOK",
    "First Name": "SEUNGHUN",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44809817: {
    id: "item_34619",
    "Last Name": "King",
    "First Name": "Lauren",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44890367: {
    id: "item_32924",
    "Last Name": "Lourie",
    "First Name": "Patrick",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44900702: {
    id: "item_7456",
    "Last Name": "Pladevall",
    "First Name": "Xavier",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44946781: {
    id: "item_21982",
    "Last Name": "Cartmell",
    "First Name": "Elyse",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44959554: {
    id: "item_7457",
    "Last Name": "Landin",
    "First Name": "Alfred",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44960252: {
    id: "item_32925",
    "Last Name": "Scott",
    "First Name": "Miranda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44961348: {
    id: "item_21983",
    "Last Name": "Wiley",
    "First Name": "Matthew",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44963059: {
    id: "item_34620",
    "Last Name": "O'Sullivan",
    "First Name": "Amber",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44963149: {
    id: "item_21984",
    "Last Name": "Stone",
    "First Name": "Gailina",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44963309: {
    id: "item_21985",
    "Last Name": "Pearson",
    "First Name": "Luke",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44963766: {
    id: "item_21986",
    "Last Name": "Isaacs",
    "First Name": "Annelise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44964352: {
    id: "item_7458",
    "Last Name": "Fulkerson",
    "First Name": "Ryan",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44964420: {
    id: "item_21987",
    "Last Name": "Lund",
    "First Name": "Olivia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44965448: {
    id: "item_21988",
    "Last Name": "Buckley",
    "First Name": "Nathan",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44965569: {
    id: "item_21989",
    "Last Name": "Cornwell",
    "First Name": "Nikki",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44966385: {
    id: "item_21990",
    "Last Name": "Rindfleish",
    "First Name": "Sophie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  44967111: {
    id: "item_32926",
    "Last Name": "Ahmed",
    "First Name": "Raz",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45009920: {
    id: "item_7459",
    "Last Name": "Anderson",
    "First Name": "Michael",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45010977: {
    id: "item_34621",
    "Last Name": "Wenzel",
    "First Name": "John",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45011355: {
    id: "item_21991",
    "Last Name": "Tiburzi",
    "First Name": "Victoria",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45052143: {
    id: "item_21992",
    "Last Name": "Padillo",
    "First Name": "Mark",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45064176: {
    id: "item_32927",
    "Last Name": "Olivera",
    "First Name": "Solange",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45117349: {
    id: "item_34622",
    "Last Name": "hammen",
    "First Name": "gabby",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45118844: {
    id: "item_32928",
    "Last Name": "Drury",
    "First Name": "Ben",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45132282: {
    id: "item_9192",
    "Last Name": "Kirkpatrick",
    "First Name": "Belinda",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45132298: {
    id: "item_7460",
    "Last Name": "Hughes",
    "First Name": "Rhys",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45133464: {
    id: "item_21993",
    "Last Name": "Henderson",
    "First Name": "Nicholas",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45133486: {
    id: "item_21994",
    "Last Name": "Rasbash",
    "First Name": "Tim",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45133904: {
    id: "item_7461",
    "Last Name": "Mortimer",
    "First Name": "Mike",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45134607: {
    id: "item_21995",
    "Last Name": "Turton",
    "First Name": "Lily",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45152877: {
    id: "item_32929",
    "Last Name": "Nikic",
    "First Name": "Christopher",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45172903: {
    id: "item_32930",
    "Last Name": "Bing",
    "First Name": "Timothy",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45204347: {
    id: "item_34623",
    "Last Name": "Borchard",
    "First Name": "Christine",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45206499: {
    id: "item_7462",
    "Last Name": "Wolfstrome",
    "First Name": "Oscar",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45208028: {
    id: "item_21996",
    "Last Name": "Vidal Martins",
    "First Name": "Afonso",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45209353: {
    id: "item_21997",
    "Last Name": "Thorne",
    "First Name": "Jack",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45209458: {
    id: "item_21998",
    "Last Name": "Hanks",
    "First Name": "Rosie",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45209880: {
    id: "item_21999",
    "Last Name": "Drinane",
    "First Name": "Louise",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45210008: {
    id: "item_32931",
    "Last Name": "Gonzalez",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45210373: {
    id: "item_22000",
    "Last Name": "Kinsley",
    "First Name": "Ian",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45211688: {
    id: "item_22001",
    "Last Name": "Conroy",
    "First Name": "Aindriu",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45211828: {
    id: "item_7463",
    "Last Name": "Oloughlan",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45211833: {
    id: "item_22002",
    "Last Name": "Lucas",
    "First Name": "Benjamin",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45212714: {
    id: "item_34624",
    "Last Name": "Speer",
    "First Name": "Amanda",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45213796: {
    id: "item_34625",
    "Last Name": "Jaggard",
    "First Name": "Emily",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45214814: {
    id: "item_32932",
    "Last Name": "Le Grange",
    "First Name": "Keagan",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45215019: {
    id: "item_22003",
    "Last Name": "Silveira",
    "First Name": "Diego",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45215080: {
    id: "item_22004",
    "Last Name": "Zulian",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45215142: {
    id: "item_7464",
    "Last Name": "Switzer",
    "First Name": "Alex",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45218247: {
    id: "item_22005",
    "Last Name": "Marsh",
    "First Name": "Georgia",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45218498: {
    id: "item_34626",
    "Last Name": "Ho",
    "First Name": "Albert",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45219353: {
    id: "item_22006",
    "Last Name": "Mara",
    "First Name": "Simon",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45219498: {
    id: "item_32933",
    "Last Name": "Harvey",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45219868: {
    id: "item_7465",
    "Last Name": "Hill",
    "First Name": "Kaleb",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45219893: {
    id: "item_7466",
    "Last Name": "Guinan",
    "First Name": "Kenneth",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45220276: {
    id: "item_22007",
    "Last Name": "Sciberras",
    "First Name": "Dominic",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45221981: {
    id: "item_22008",
    "Last Name": "Cocker",
    "First Name": "David",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45223430: {
    id: "item_22009",
    "Last Name": "Harper",
    "First Name": "Toby",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45224013: {
    id: "item_34627",
    "Last Name": "Umpleby",
    "First Name": "Carly",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45291365: {
    id: "item_7467",
    "Last Name": "Ryan",
    "First Name": "Kieran",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45292479: {
    id: "item_22010",
    "Last Name": "Hewetson",
    "First Name": "Sam",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45292680: {
    id: "item_7468",
    "Last Name": "Cuthbert",
    "First Name": "Sarah",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45294391: {
    id: "item_7469",
    "Last Name": "McGookin",
    "First Name": "Thomas",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45294459: {
    id: "item_7470",
    "Last Name": "Davies",
    "First Name": "Jye",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45294475: {
    id: "item_34628",
    "Last Name": "Ardiyansyah",
    "First Name": "Gege",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45294728: {
    id: "item_32934",
    "Last Name": "Sleet",
    "First Name": "Richelle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45295326: {
    id: "item_7471",
    "Last Name": "Atkinson",
    "First Name": "Lucy",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45295821: {
    id: "item_34629",
    "Last Name": "WATANABE",
    "First Name": "DAI",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45295905: {
    id: "item_34630",
    "Last Name": "KONO",
    "First Name": "HIROKAZU",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45295970: {
    id: "item_34631",
    "Last Name": "MINE",
    "First Name": "KEITO",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45296820: {
    id: "item_34632",
    "Last Name": "Byers",
    "First Name": "Anita",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45297287: {
    id: "item_32935",
    "Last Name": "Gray",
    "First Name": "Dean",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45297386: {
    id: "item_32936",
    "Last Name": "kizelnik",
    "First Name": "Danielle",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45299231: {
    id: "item_22011",
    "Last Name": "Sharow",
    "First Name": "Kyle",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45299550: {
    id: "item_34633",
    "Last Name": "Aziz",
    "First Name": "Jameelah",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45341596: {
    id: "item_32937",
    "Last Name": "Tasker",
    "First Name": "Letitia",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45342113: {
    id: "item_32938",
    "Last Name": "Cutbush",
    "First Name": "Jo",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45349563: {
    id: "item_22012",
    "Last Name": "Brambila De Souza",
    "First Name": "Guilherme",
    "Marathon Waves": "Start group 2 - Orange Assembly - Entry Chute G",
    assemblyPoint: " Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:55 AM",
    "ENTRY CHUTE TIME": "6:50 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45361915: {
    id: "item_32939",
    "Last Name": "Lee",
    "First Name": "Jie Hua",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45361929: {
    id: "item_32940",
    "Last Name": "Mullings",
    "First Name": "Rodney",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45365417: {
    id: "item_34634",
    "Last Name": "Gonzalez",
    "First Name": "Ayrel",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45381779: {
    id: "item_34635",
    "Last Name": "Riley",
    "First Name": "Alisha",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45381870: {
    id: "item_34636",
    "Last Name": "Riley",
    "First Name": "Zachary",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute G",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45381986: {
    id: "item_32941",
    "Last Name": "Ratliff",
    "First Name": "Charlotte",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45393975: {
    id: "item_32942",
    "Last Name": "McLean",
    "First Name": "Christian",
    "Marathon Waves": "Start group 3 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "6:45 AM",
    "ENTRY CHUTE TIME": "7:25 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
  45404699: {
    id: "item_7472",
    "Last Name": "Barnes",
    "First Name": "Todd",
    "Marathon Waves": "Start group 1 - Orange Assembly - Entry Chute F",
    assemblyPoint: "Orange Assembly",
    startingPoint: "Victoria Cross Station",
    routeStartCoordinates: [-33.8358333, 151.2077778],
    "TRAIN STATION": "North Sydney Station",
    "TRAIN STATION Coordinates": [-33.8402778, 151.2072222],
    assemblyCoordinates: [-33.8325, 151.21],
    assemblyCoordinates_2: null,
    "ARRIVAL Time": "5:00 AM",
    "ENTRY CHUTE TIME": "6:05 AM",
    "Ped Crossing 1": [-33.835, 151.2075],
    "Ped Crossing 2": [-33.8366667, 151.2072222],
    "Ped Crossing 3": [-33.8405556, 151.2083333],
  "Ped Crossing 4": [
    -33.84027777777778,
    151.20805555555556
  ],
    closureTimeStart: "6:30 AM, 7:03 AM, 7:40 AM",
    closureTimeEnd: "7:00 AM, 7:31 AM, 8:10 AM",
  },
};
